/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
// eslint-disable-next-line
/*eslint-disable*/ !(function (t) {
  const e = (t.en = t.en || {});
  e.dictionary = Object.assign(e.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    "Align center": "Align center",
    "Align left": "Align left",
    "Align right": "Align right",
    "Block quote": "Block quote",
    Bold: "Bold",
    "Bulleted List": "Bulleted List",
    Cancel: "Cancel",
    "Cannot upload file:": "Cannot upload file:",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Column: "Column",
    "Could not insert image at the current position.":
      "Could not insert image at the current position.",
    "Could not obtain resized image URL.":
      "Could not obtain resized image URL.",
    "Decrease indent": "Decrease indent",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    Downloadable: "Downloadable",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit link": "Edit link",
    "Editor toolbar": "Editor toolbar",
    "Enter image caption": "Enter image caption",
    "Full size image": "Full size image",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    "Image toolbar": "Image toolbar",
    "image widget": "image widget",
    "Increase indent": "Increase indent",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert image": "Insert image",
    "Insert image or file": "Insert image or file",
    "Insert media": "Insert media",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    "Inserting image failed": "Inserting image failed",
    Italic: "Italic",
    Justify: "Justify",
    "Left aligned image": "Left aligned image",
    Link: "Link",
    "Link URL": "Link URL",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    Next: "Next",
    "Numbered List": "Numbered List",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    Paragraph: "Paragraph",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    Previous: "Previous",
    Redo: "Redo",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich Text Editor, %0",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Select column": "Select column",
    "Select row": "Select row",
    "Selecting resized image failed": "Selecting resized image failed",
    "Show more items": "Show more items",
    "Side image": "Side image",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    "Table toolbar": "Table toolbar",
    "Text alignment": "Text alignment",
    "Text alignment toolbar": "Text alignment toolbar",
    "Text alternative": "Text alternative",
    "The URL must not be empty.": "The URL must not be empty.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Paste the URL into the content to embed faster.":
      "Tip: Paste the URL into the content to embed faster.",
    Undo: "Undo",
    Unlink: "Unlink",
    "Upload failed": "Upload failed",
    "Upload in progress": "Upload in progress",
    "Widget toolbar": "Widget toolbar",
  });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
  (function (t, e) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof exports
      ? (exports.ClassicEditor = e())
      : (t.ClassicEditor = e());
  })(window, function () {
    return (function (t) {
      var e = {};
      function i(n) {
        if (e[n]) return e[n].exports;
        var o = (e[n] = { i: n, l: !1, exports: {} });
        return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
      }
      return (
        (i.m = t),
        (i.c = e),
        (i.d = function (t, e, n) {
          i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
        }),
        (i.r = function (t) {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (i.t = function (t, e) {
          if ((1 & e && (t = i(t)), 8 & e)) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (
            (i.r(n),
            Object.defineProperty(n, "default", { enumerable: !0, value: t }),
            2 & e && "string" != typeof t)
          )
            for (var o in t)
              i.d(
                n,
                o,
                function (e) {
                  return t[e];
                }.bind(null, o)
              );
          return n;
        }),
        (i.n = function (t) {
          var e =
            t && t.__esModule
              ? function () {
                  return t.default;
                }
              : function () {
                  return t;
                };
          return i.d(e, "a", e), e;
        }),
        (i.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (i.p = ""),
        i((i.s = 98))
      );
    })([
      function (t, e, i) {
        "use strict";
        i.d(e, "b", function () {
          return n;
        }),
          i.d(e, "a", function () {
            return o;
          });
        class n extends Error {
          constructor(t, e, i) {
            (t = o(t)),
              i && (t += " " + JSON.stringify(i)),
              super(t),
              (this.name = "CKEditorError"),
              (this.context = e),
              (this.data = i);
          }
          is(t) {
            return "CKEditorError" === t;
          }
          static rethrowUnexpectedError(t, e) {
            if (t.is && t.is("CKEditorError")) throw t;
            const i = new n(t.message, e);
            throw ((i.stack = t.stack), i);
          }
        }
        function o(t) {
          const e = t.match(/^([^:]+):/);
          return e
            ? t +
                ` Read more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-${e[1]}\n`
            : t;
        }
      },
      function (t, e, i) {
        "use strict";
        var n,
          o = function () {
            return (
              void 0 === n &&
                (n = Boolean(
                  window && document && document.all && !window.atob
                )),
              n
            );
          },
          r = (function () {
            var t = {};
            return function (e) {
              if (void 0 === t[e]) {
                var i = document.querySelector(e);
                if (
                  window.HTMLIFrameElement &&
                  i instanceof window.HTMLIFrameElement
                )
                  try {
                    i = i.contentDocument.head;
                  } catch (t) {
                    i = null;
                  }
                t[e] = i;
              }
              return t[e];
            };
          })(),
          s = [];
        function a(t) {
          for (var e = -1, i = 0; i < s.length; i++)
            if (s[i].identifier === t) {
              e = i;
              break;
            }
          return e;
        }
        function l(t, e) {
          for (var i = {}, n = [], o = 0; o < t.length; o++) {
            var r = t[o],
              l = e.base ? r[0] + e.base : r[0],
              c = i[l] || 0,
              d = "".concat(l, " ").concat(c);
            i[l] = c + 1;
            var h = a(d),
              u = { css: r[1], media: r[2], sourceMap: r[3] };
            -1 !== h
              ? (s[h].references++, s[h].updater(u))
              : s.push({ identifier: d, updater: p(u, e), references: 1 }),
              n.push(d);
          }
          return n;
        }
        function c(t) {
          var e = document.createElement("style"),
            n = t.attributes || {};
          if (void 0 === n.nonce) {
            var o = i.nc;
            o && (n.nonce = o);
          }
          if (
            (Object.keys(n).forEach(function (t) {
              e.setAttribute(t, n[t]);
            }),
            "function" == typeof t.insert)
          )
            t.insert(e);
          else {
            var s = r(t.insert || "head");
            if (!s)
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            s.appendChild(e);
          }
          return e;
        }
        var d,
          h =
            ((d = []),
            function (t, e) {
              return (d[t] = e), d.filter(Boolean).join("\n");
            });
        function u(t, e, i, n) {
          var o = i
            ? ""
            : n.media
            ? "@media ".concat(n.media, " {").concat(n.css, "}")
            : n.css;
          if (t.styleSheet) t.styleSheet.cssText = h(e, o);
          else {
            var r = document.createTextNode(o),
              s = t.childNodes;
            s[e] && t.removeChild(s[e]),
              s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
          }
        }
        function m(t, e, i) {
          var n = i.css,
            o = i.media,
            r = i.sourceMap;
          if (
            (o ? t.setAttribute("media", o) : t.removeAttribute("media"),
            r &&
              btoa &&
              (n +=
                "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                  btoa(unescape(encodeURIComponent(JSON.stringify(r)))),
                  " */"
                )),
            t.styleSheet)
          )
            t.styleSheet.cssText = n;
          else {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(n));
          }
        }
        var g = null,
          f = 0;
        function p(t, e) {
          var i, n, o;
          if (e.singleton) {
            var r = f++;
            (i = g || (g = c(e))),
              (n = u.bind(null, i, r, !1)),
              (o = u.bind(null, i, r, !0));
          } else
            (i = c(e)),
              (n = m.bind(null, i, e)),
              (o = function () {
                !(function (t) {
                  if (null === t.parentNode) return !1;
                  t.parentNode.removeChild(t);
                })(i);
              });
          return (
            n(t),
            function (e) {
              if (e) {
                if (
                  e.css === t.css &&
                  e.media === t.media &&
                  e.sourceMap === t.sourceMap
                )
                  return;
                n((t = e));
              } else o();
            }
          );
        }
        t.exports = function (t, e) {
          (e = e || {}).singleton ||
            "boolean" == typeof e.singleton ||
            (e.singleton = o());
          var i = l((t = t || []), e);
          return function (t) {
            if (
              ((t = t || []),
              "[object Array]" === Object.prototype.toString.call(t))
            ) {
              for (var n = 0; n < i.length; n++) {
                var o = a(i[n]);
                s[o].references--;
              }
              for (var r = l(t, e), c = 0; c < i.length; c++) {
                var d = a(i[c]);
                0 === s[d].references && (s[d].updater(), s.splice(d, 1));
              }
              i = r;
            }
          };
        };
      },
      ,
      function (t, e, i) {
        "use strict";
        var n = i(7),
          o = "object" == typeof self && self && self.Object === Object && self,
          r = n.a || o || Function("return this")();
        e.a = r;
      },
      function (t, e, i) {
        "use strict";
        (function (t) {
          var n = i(3),
            o = i(12),
            r =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            s = r && "object" == typeof t && t && !t.nodeType && t,
            a = s && s.exports === r ? n.a.Buffer : void 0,
            l = (a ? a.isBuffer : void 0) || o.a;
          e.a = l;
        }).call(this, i(9)(t));
      },
      function (t, e, i) {
        "use strict";
        (function (t) {
          var n = i(7),
            o =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            r = o && "object" == typeof t && t && !t.nodeType && t,
            s = r && r.exports === o && n.a.process,
            a = (function () {
              try {
                var t = r && r.require && r.require("util").types;
                return t || (s && s.binding && s.binding("util"));
              } catch (t) {}
            })();
          e.a = a;
        }).call(this, i(9)(t));
      },
      function (t, e, i) {
        "use strict";
        (function (t) {
          var e = i(0);
          const n = "object" == typeof window ? window : t;
          if (n.CKEDITOR_VERSION)
            throw new e.b(
              "ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.",
              null
            );
          n.CKEDITOR_VERSION = "19.0.0";
        }).call(this, i(10));
      },
      function (t, e, i) {
        "use strict";
        (function (t) {
          var i = "object" == typeof t && t && t.Object === Object && t;
          e.a = i;
        }).call(this, i(10));
      },
      function (t, e, i) {
        "use strict";
        (function (t) {
          var n = i(3),
            o =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            r = o && "object" == typeof t && t && !t.nodeType && t,
            s = r && r.exports === o ? n.a.Buffer : void 0,
            a = s ? s.allocUnsafe : void 0;
          e.a = function (t, e) {
            if (e) return t.slice();
            var i = t.length,
              n = a ? a(i) : new t.constructor(i);
            return t.copy(n), n;
          };
        }).call(this, i(9)(t));
      },
      function (t, e) {
        t.exports = function (t) {
          if (!t.webpackPolyfill) {
            var e = Object.create(t);
            e.children || (e.children = []),
              Object.defineProperty(e, "loaded", {
                enumerable: !0,
                get: function () {
                  return e.l;
                },
              }),
              Object.defineProperty(e, "id", {
                enumerable: !0,
                get: function () {
                  return e.i;
                },
              }),
              Object.defineProperty(e, "exports", { enumerable: !0 }),
              (e.webpackPolyfill = 1);
          }
          return e;
        };
      },
      function (t, e) {
        var i;
        i = (function () {
          return this;
        })();
        try {
          i = i || new Function("return this")();
        } catch (t) {
          "object" == typeof window && (i = window);
        }
        t.exports = i;
      },
      function (t, e, i) {
        var n = i(1),
          o = i(70);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e, i) {
        "use strict";
        e.a = function () {
          return !1;
        };
      },
      function (t) {
        t.exports = JSON.parse(
          '{"ar":{"latex":"LaTeX","cancel":"إلغاء","accept":"موا�?ق","manual":"الدليل","insert_math":"إدراج صيغة رياضية - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"ca":{"latex":"LaTeX","cancel":"Cancel·lar","accept":"Acceptar","manual":"Manual","insert_math":"Inserir fórmula matemàtica - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"cs":{"latex":"LaTeX","cancel":"Storno","accept":"OK","manual":"Příru�?ka","insert_math":"Vložit matematický vzorec - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"da":{"latex":"LaTeX","cancel":"Annuller","accept":"OK","manual":"Brugervejledning","insert_math":"Indsæt matematisk formel - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"de":{"latex":"LaTeX","cancel":"Abbrechen","accept":"OK","manual":"Handbuch","insert_math":"Mathematische Formel einfügen - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"en":{"latex":"LaTeX","cancel":"Cancel","accept":"OK","manual":"Manual","insert_math":"Insert a math equation - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"es":{"latex":"LaTeX","cancel":"Cancelar","accept":"Aceptar","manual":"Manual","insert_math":"Insertar fórmula matemática - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"et":{"latex":"LaTeX","cancel":"Loobu","accept":"OK","manual":"Käsiraamat","insert_math":"Lisa matemaatiline valem – WIRIS","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"eu":{"latex":"LaTeX","cancel":"Ezeztatu","accept":"Onartu","manual":"Gida","insert_math":"Txertatu matematikako formula - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"fi":{"latex":"LaTeX","cancel":"Peruuta","accept":"OK","manual":"Manual","insert_math":"Liitä matemaattinen kaava - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"fr":{"latex":"LaTeX","cancel":"Annuler","accept":"OK","manual":"Manuel","insert_math":"Insérer une formule mathématique - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"gl":{"latex":"LaTeX","cancel":"Cancelar","accept":"Aceptar","manual":"Manual","insert_math":"Inserir fórmula matemática - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"he":{"latex":"LaTeX","cancel":"ביטול","accept":"�?ישור","manual":"מדריך","insert_math":"הוסף נוסחה מתמטית - MathType","insert_chem":"הוספת כתיבה כימית - ChemType","minimize":"מזערי","maximize":"מרבי","fullscreen":"מסך מל�?","exit_fullscreen":"יצי�?ה ממצב מסך מל�?","close":"סגירה","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"ה�?�? לצ�?ת? שינויי�? �?שר בוצעו ימחקו.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" �?יננה פונקציה","exception_invalid_date_format":"תסדיר ת�?ריך �?ינו תקין : ","exception_casting":"ל�? ניתן להמיר ","exception_casting_to":" ל "},"hr":{"latex":"LaTeX","cancel":"Poništi","accept":"U redu","manual":"Priru�?nik","insert_math":"Umetnite matemati�?ku formulu - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"hu":{"latex":"LaTeX","cancel":"Mégsem","accept":"OK","manual":"Kézikönyv","insert_math":"Matematikai képlet beszúrása - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"it":{"latex":"LaTeX","cancel":"Annulla","accept":"Accetta","manual":"Manuale","insert_math":"Inserisci una formula matematica - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"ja":{"latex":"LaTeX","cancel":"キャンセル","accept":"OK","manual":"マニュアル","insert_math":"数�?を挿入 - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"ko":{"latex":"LaTeX","cancel":"취소","accept":"승�?�","manual":"설명서","insert_math":"수학 공�? 삽입 - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"nl":{"latex":"LaTeX","cancel":"Annuleren","accept":"OK","manual":"Handleiding","insert_math":"Wiskundige formule invoegen - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"no":{"latex":"LaTeX","cancel":"Avbryt","accept":"OK","manual":"Håndbok","insert_math":"Sett inn matematikkformel - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"pl":{"latex":"LaTeX","cancel":"Anuluj","accept":"OK","manual":"Instrukcja","insert_math":"Wstaw formułę matematyczną - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"pt":{"latex":"LaTeX","cancel":"Cancelar","accept":"OK","manual":"Manual","insert_math":"Inserir fórmula matemática - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"pt_br":{"latex":"LaTeX","cancel":"Cancelar","accept":"OK","manual":"Manual","insert_math":"Inserir fórmula matemática - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"ru":{"latex":"LaTeX","cancel":"отмена","accept":"OK","manual":"вручную","insert_math":"В�?тавить математиче�?кую формулу: WIRIS","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"sv":{"latex":"LaTeX","cancel":"Avbryt","accept":"OK","manual":"Bruksanvisning","insert_math":"Infoga matematisk formel - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"tr":{"latex":"LaTeX","cancel":"Vazgeç","accept":"Tamam","manual":"Kılavuz","insert_math":"Matematik formülü ekle - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"zh":{"latex":"LaTeX","cancel":"�?�消","accept":"确定","manual":"手册","insert_math":"�?�入数学公�? - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"el":{"latex":"LaTeX","cancel":"Άκυ�?ο","accept":"ΟΚ","manual":"Χει�?οκίνητα","insert_math":"Εισαγωγή μαθηματικο�? τ�?που - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"":{}}'
        );
      },
      function (t, e, i) {
        var n = i(1),
          o = i(15);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(17);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#969696;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border:#969696;--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#969696;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:10px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:10px;--ck-spacing-large:10px;--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(19);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(21);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(23);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(25);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(27);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(29);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}';
      },
      function (t, e, i) {
        var n = i(1),
          o = i(31);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(33);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(35);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2*var(--ck-switch-button-toggle-spacing))}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(37);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(39);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(41);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck.ck-toolbar>.ck-toolbar__items>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>*,.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(43);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(45);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(47);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(49);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(51);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view>.ck.ck-label{width:100%;text-overflow:ellipsis;overflow:hidden}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(53);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .2s ease-in-out,border .2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(55);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(57);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}';
      },
      function (t, e, i) {
        var n = i(1),
          o = i(59);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(61);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(63);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image>img{display:block;margin:0 auto;max-width:100%;min-width:50px}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(65);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(67);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
      },
      function (t, e, i) {
        var n = i(1),
          o = i(69);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
      },
      function (t, e) {
        t.exports =
          ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(72);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(74);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center,.ck-content .image-style-align-left,.ck-content .image-style-align-right,.ck-content .image-style-side{max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(76);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(78);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(80);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
      },
      function (t, e, i) {
        var n = i(1),
          o = i(82);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(84);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(86);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(88);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-radius:0}.ck-rounded-corners [dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow,[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-left-color:var(--ck-color-split-button-hover-border)}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-right-color:var(--ck-color-split-button-hover-border)}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(90);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}";
      },
      function (t, e, i) {
        var n = i(1),
          o = i(92);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget_selected{outline:unset}';
      },
      function (t, e, i) {
        var n = i(1),
          o = i(94);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}";
      },
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var md5,
          _unused_webpack_default_export = md5;
        !(function () {
          var HxOverrides = function () {};
          (HxOverrides.__name__ = !0),
            (HxOverrides.dateStr = function (t) {
              var e = t.getMonth() + 1,
                i = t.getDate(),
                n = t.getHours(),
                o = t.getMinutes(),
                r = t.getSeconds();
              return (
                t.getFullYear() +
                "-" +
                (e < 10 ? "0" + e : "" + e) +
                "-" +
                (i < 10 ? "0" + i : "" + i) +
                " " +
                (n < 10 ? "0" + n : "" + n) +
                ":" +
                (o < 10 ? "0" + o : "" + o) +
                ":" +
                (r < 10 ? "0" + r : "" + r)
              );
            }),
            (HxOverrides.strDate = function (t) {
              switch (t.length) {
                case 8:
                  var e = t.split(":"),
                    i = new Date();
                  return (
                    i.setTime(0),
                    i.setUTCHours(e[0]),
                    i.setUTCMinutes(e[1]),
                    i.setUTCSeconds(e[2]),
                    i
                  );
                case 10:
                  e = t.split("-");
                  return new Date(e[0], e[1] - 1, e[2], 0, 0, 0);
                case 19:
                  var n = (e = t.split(" "))[0].split("-"),
                    o = e[1].split(":");
                  return new Date(n[0], n[1] - 1, n[2], o[0], o[1], o[2]);
                default:
                  throw "Invalid date format : " + t;
              }
            }),
            (HxOverrides.cca = function (t, e) {
              var i = t.charCodeAt(e);
              if (i == i) return i;
            }),
            (HxOverrides.substr = function (t, e, i) {
              return null != e && 0 != e && null != i && i < 0
                ? ""
                : (null == i && (i = t.length),
                  e < 0
                    ? (e = t.length + e) < 0 && (e = 0)
                    : i < 0 && (i = t.length + i - e),
                  t.substr(e, i));
            }),
            (HxOverrides.remove = function (t, e) {
              for (var i = 0, n = t.length; i < n; ) {
                if (t[i] == e) return t.splice(i, 1), !0;
                i++;
              }
              return !1;
            }),
            (HxOverrides.iter = function (t) {
              return {
                cur: 0,
                arr: t,
                hasNext: function () {
                  return this.cur < this.arr.length;
                },
                next: function () {
                  return this.arr[this.cur++];
                },
              };
            });
          var IntIter = function (t, e) {
            (this.min = t), (this.max = e);
          };
          (IntIter.__name__ = !0),
            (IntIter.prototype = {
              next: function () {
                return this.min++;
              },
              hasNext: function () {
                return this.min < this.max;
              },
              __class__: IntIter,
            });
          var Std = function () {};
          (Std.__name__ = !0),
            (Std.is = function (t, e) {
              return js.Boot.__instanceof(t, e);
            }),
            (Std.string = function (t) {
              return js.Boot.__string_rec(t, "");
            }),
            (Std.int = function (t) {
              return 0 | t;
            }),
            (Std.parseInt = function (t) {
              var e = parseInt(t, 10);
              return (
                0 != e ||
                  (120 != HxOverrides.cca(t, 1) &&
                    88 != HxOverrides.cca(t, 1)) ||
                  (e = parseInt(t)),
                isNaN(e) ? null : e
              );
            }),
            (Std.parseFloat = function (t) {
              return parseFloat(t);
            }),
            (Std.random = function (t) {
              return Math.floor(Math.random() * t);
            });
          var com = com || {};
          com.wiris || (com.wiris = {}),
            com.wiris.js || (com.wiris.js = {}),
            (com.wiris.js.JsPluginTools = function () {
              this.tryReady();
            }),
            (com.wiris.js.JsPluginTools.__name__ = !0),
            (com.wiris.js.JsPluginTools.main = function () {
              var t;
              (t = com.wiris.js.JsPluginTools.getInstance()),
                haxe.Timer.delay($bind(t, t.tryReady), 100);
            }),
            (com.wiris.js.JsPluginTools.getInstance = function () {
              return (
                null == com.wiris.js.JsPluginTools.instance &&
                  (com.wiris.js.JsPluginTools.instance =
                    new com.wiris.js.JsPluginTools()),
                com.wiris.js.JsPluginTools.instance
              );
            }),
            (com.wiris.js.JsPluginTools.bypassEncapsulation = function () {
              null == window.com && (window.com = {}),
                null == window.com.wiris && (window.com.wiris = {}),
                null == window.com.wiris.js && (window.com.wiris.js = {}),
                null == window.com.wiris.js.JsPluginTools &&
                  (window.com.wiris.js.JsPluginTools =
                    com.wiris.js.JsPluginTools.getInstance());
            }),
            (com.wiris.js.JsPluginTools.prototype = {
              md5encode: function (t) {
                return haxe.Md5.encode(t);
              },
              doLoad: function () {
                (this.ready = !0),
                  (com.wiris.js.JsPluginTools.instance = this),
                  com.wiris.js.JsPluginTools.bypassEncapsulation();
              },
              tryReady: function () {
                (this.ready = !1),
                  js.Lib.document.readyState &&
                    (this.doLoad(), (this.ready = !0)),
                  this.ready ||
                    haxe.Timer.delay($bind(this, this.tryReady), 100);
              },
              __class__: com.wiris.js.JsPluginTools,
            });
          var haxe = haxe || {};
          (haxe.Log = function () {}),
            (haxe.Log.__name__ = !0),
            (haxe.Log.trace = function (t, e) {
              js.Boot.__trace(t, e);
            }),
            (haxe.Log.clear = function () {
              js.Boot.__clear_trace();
            }),
            (haxe.Md5 = function () {}),
            (haxe.Md5.__name__ = !0),
            (haxe.Md5.encode = function (t) {
              return new haxe.Md5().doEncode(t);
            }),
            (haxe.Md5.prototype = {
              doEncode: function (t) {
                for (
                  var e = this.str2blks(t),
                    i = 1732584193,
                    n = -271733879,
                    o = -1732584194,
                    r = 271733878,
                    s = 0;
                  s < e.length;

                ) {
                  var a = i,
                    l = n,
                    c = o,
                    d = r;
                  0,
                    (i = this.ff(i, n, o, r, e[s], 7, -680876936)),
                    (r = this.ff(r, i, n, o, e[s + 1], 12, -389564586)),
                    (o = this.ff(o, r, i, n, e[s + 2], 17, 606105819)),
                    (n = this.ff(n, o, r, i, e[s + 3], 22, -1044525330)),
                    (i = this.ff(i, n, o, r, e[s + 4], 7, -176418897)),
                    (r = this.ff(r, i, n, o, e[s + 5], 12, 1200080426)),
                    (o = this.ff(o, r, i, n, e[s + 6], 17, -1473231341)),
                    (n = this.ff(n, o, r, i, e[s + 7], 22, -45705983)),
                    (i = this.ff(i, n, o, r, e[s + 8], 7, 1770035416)),
                    (r = this.ff(r, i, n, o, e[s + 9], 12, -1958414417)),
                    (o = this.ff(o, r, i, n, e[s + 10], 17, -42063)),
                    (n = this.ff(n, o, r, i, e[s + 11], 22, -1990404162)),
                    (i = this.ff(i, n, o, r, e[s + 12], 7, 1804603682)),
                    (r = this.ff(r, i, n, o, e[s + 13], 12, -40341101)),
                    (o = this.ff(o, r, i, n, e[s + 14], 17, -1502002290)),
                    (n = this.ff(n, o, r, i, e[s + 15], 22, 1236535329)),
                    (i = this.gg(i, n, o, r, e[s + 1], 5, -165796510)),
                    (r = this.gg(r, i, n, o, e[s + 6], 9, -1069501632)),
                    (o = this.gg(o, r, i, n, e[s + 11], 14, 643717713)),
                    (n = this.gg(n, o, r, i, e[s], 20, -373897302)),
                    (i = this.gg(i, n, o, r, e[s + 5], 5, -701558691)),
                    (r = this.gg(r, i, n, o, e[s + 10], 9, 38016083)),
                    (o = this.gg(o, r, i, n, e[s + 15], 14, -660478335)),
                    (n = this.gg(n, o, r, i, e[s + 4], 20, -405537848)),
                    (i = this.gg(i, n, o, r, e[s + 9], 5, 568446438)),
                    (r = this.gg(r, i, n, o, e[s + 14], 9, -1019803690)),
                    (o = this.gg(o, r, i, n, e[s + 3], 14, -187363961)),
                    (n = this.gg(n, o, r, i, e[s + 8], 20, 1163531501)),
                    (i = this.gg(i, n, o, r, e[s + 13], 5, -1444681467)),
                    (r = this.gg(r, i, n, o, e[s + 2], 9, -51403784)),
                    (o = this.gg(o, r, i, n, e[s + 7], 14, 1735328473)),
                    (n = this.gg(n, o, r, i, e[s + 12], 20, -1926607734)),
                    (i = this.hh(i, n, o, r, e[s + 5], 4, -378558)),
                    (r = this.hh(r, i, n, o, e[s + 8], 11, -2022574463)),
                    (o = this.hh(o, r, i, n, e[s + 11], 16, 1839030562)),
                    (n = this.hh(n, o, r, i, e[s + 14], 23, -35309556)),
                    (i = this.hh(i, n, o, r, e[s + 1], 4, -1530992060)),
                    (r = this.hh(r, i, n, o, e[s + 4], 11, 1272893353)),
                    (o = this.hh(o, r, i, n, e[s + 7], 16, -155497632)),
                    (n = this.hh(n, o, r, i, e[s + 10], 23, -1094730640)),
                    (i = this.hh(i, n, o, r, e[s + 13], 4, 681279174)),
                    (r = this.hh(r, i, n, o, e[s], 11, -358537222)),
                    (o = this.hh(o, r, i, n, e[s + 3], 16, -722521979)),
                    (n = this.hh(n, o, r, i, e[s + 6], 23, 76029189)),
                    (i = this.hh(i, n, o, r, e[s + 9], 4, -640364487)),
                    (r = this.hh(r, i, n, o, e[s + 12], 11, -421815835)),
                    (o = this.hh(o, r, i, n, e[s + 15], 16, 530742520)),
                    (n = this.hh(n, o, r, i, e[s + 2], 23, -995338651)),
                    (i = this.ii(i, n, o, r, e[s], 6, -198630844)),
                    (r = this.ii(r, i, n, o, e[s + 7], 10, 1126891415)),
                    (o = this.ii(o, r, i, n, e[s + 14], 15, -1416354905)),
                    (n = this.ii(n, o, r, i, e[s + 5], 21, -57434055)),
                    (i = this.ii(i, n, o, r, e[s + 12], 6, 1700485571)),
                    (r = this.ii(r, i, n, o, e[s + 3], 10, -1894986606)),
                    (o = this.ii(o, r, i, n, e[s + 10], 15, -1051523)),
                    (n = this.ii(n, o, r, i, e[s + 1], 21, -2054922799)),
                    (i = this.ii(i, n, o, r, e[s + 8], 6, 1873313359)),
                    (r = this.ii(r, i, n, o, e[s + 15], 10, -30611744)),
                    (o = this.ii(o, r, i, n, e[s + 6], 15, -1560198380)),
                    (n = this.ii(n, o, r, i, e[s + 13], 21, 1309151649)),
                    (i = this.ii(i, n, o, r, e[s + 4], 6, -145523070)),
                    (r = this.ii(r, i, n, o, e[s + 11], 10, -1120210379)),
                    (o = this.ii(o, r, i, n, e[s + 2], 15, 718787259)),
                    (n = this.ii(n, o, r, i, e[s + 9], 21, -343485551)),
                    (i = this.addme(i, a)),
                    (n = this.addme(n, l)),
                    (o = this.addme(o, c)),
                    (r = this.addme(r, d)),
                    (s += 16);
                }
                return (
                  this.rhex(i) + this.rhex(n) + this.rhex(o) + this.rhex(r)
                );
              },
              ii: function (t, e, i, n, o, r, s) {
                return this.cmn(
                  this.bitXOR(i, this.bitOR(e, ~n)),
                  t,
                  e,
                  o,
                  r,
                  s
                );
              },
              hh: function (t, e, i, n, o, r, s) {
                return this.cmn(
                  this.bitXOR(this.bitXOR(e, i), n),
                  t,
                  e,
                  o,
                  r,
                  s
                );
              },
              gg: function (t, e, i, n, o, r, s) {
                return this.cmn(
                  this.bitOR(this.bitAND(e, n), this.bitAND(i, ~n)),
                  t,
                  e,
                  o,
                  r,
                  s
                );
              },
              ff: function (t, e, i, n, o, r, s) {
                return this.cmn(
                  this.bitOR(this.bitAND(e, i), this.bitAND(~e, n)),
                  t,
                  e,
                  o,
                  r,
                  s
                );
              },
              cmn: function (t, e, i, n, o, r) {
                return this.addme(
                  this.rol(this.addme(this.addme(e, t), this.addme(n, r)), o),
                  i
                );
              },
              rol: function (t, e) {
                return (t << e) | (t >>> (32 - e));
              },
              str2blks: function (t) {
                for (
                  var e = 1 + ((t.length + 8) >> 6),
                    i = new Array(),
                    n = 0,
                    o = 16 * e;
                  n < o;

                ) {
                  i[(r = n++)] = 0;
                }
                for (var r = 0; r < t.length; )
                  (i[r >> 2] |=
                    HxOverrides.cca(t, r) << (((8 * t.length + r) % 4) * 8)),
                    r++;
                i[r >> 2] |= 128 << (((8 * t.length + r) % 4) * 8);
                var s = 8 * t.length,
                  a = 16 * e - 2;
                return (
                  (i[a] = 255 & s),
                  (i[a] |= ((s >>> 8) & 255) << 8),
                  (i[a] |= ((s >>> 16) & 255) << 16),
                  (i[a] |= ((s >>> 24) & 255) << 24),
                  i
                );
              },
              rhex: function (t) {
                for (var e = "", i = 0; i < 4; ) {
                  var n = i++;
                  e +=
                    "0123456789abcdef".charAt((t >> (8 * n + 4)) & 15) +
                    "0123456789abcdef".charAt((t >> (8 * n)) & 15);
                }
                return e;
              },
              addme: function (t, e) {
                var i = (65535 & t) + (65535 & e);
                return (
                  (((t >> 16) + (e >> 16) + (i >> 16)) << 16) | (65535 & i)
                );
              },
              bitAND: function (t, e) {
                return (((t >>> 1) & (e >>> 1)) << 1) | (1 & t & e);
              },
              bitXOR: function (t, e) {
                return (((t >>> 1) ^ (e >>> 1)) << 1) | ((1 & t) ^ (1 & e));
              },
              bitOR: function (t, e) {
                return (((t >>> 1) | (e >>> 1)) << 1) | ((1 & t) | (1 & e));
              },
              __class__: haxe.Md5,
            }),
            (haxe.Timer = function (t) {
              var e = this;
              this.id = window.setInterval(function () {
                e.run();
              }, t);
            }),
            (haxe.Timer.__name__ = !0),
            (haxe.Timer.delay = function (t, e) {
              var i = new haxe.Timer(e);
              return (
                (i.run = function () {
                  i.stop(), t();
                }),
                i
              );
            }),
            (haxe.Timer.measure = function (t, e) {
              var i = haxe.Timer.stamp(),
                n = t();
              return haxe.Log.trace(haxe.Timer.stamp() - i + "s", e), n;
            }),
            (haxe.Timer.stamp = function () {
              return new Date().getTime() / 1e3;
            }),
            (haxe.Timer.prototype = {
              run: function () {},
              stop: function () {
                null != this.id &&
                  (window.clearInterval(this.id), (this.id = null));
              },
              __class__: haxe.Timer,
            });
          var js = js || {},
            $_;
          function $bind(t, e) {
            var i = function () {
              return i.method.apply(i.scope, arguments);
            };
            return (i.scope = t), (i.method = e), i;
          }
          (js.Boot = function () {}),
            (js.Boot.__name__ = !0),
            (js.Boot.__unhtml = function (t) {
              return t
                .split("&")
                .join("&amp;")
                .split("<")
                .join("&lt;")
                .split(">")
                .join("&gt;");
            }),
            (js.Boot.__trace = function (t, e) {
              var i,
                n = null != e ? e.fileName + ":" + e.lineNumber + ": " : "";
              (n += js.Boot.__string_rec(t, "")),
                "undefined" != typeof document &&
                null != (i = document.getElementById("haxe:trace"))
                  ? (i.innerHTML += js.Boot.__unhtml(n) + "<br/>")
                  : "undefined" != typeof console &&
                    null != console.log &&
                    console.log(n);
            }),
            (js.Boot.__clear_trace = function () {
              var t = document.getElementById("haxe:trace");
              null != t && (t.innerHTML = "");
            }),
            (js.Boot.isClass = function (t) {
              return t.__name__;
            }),
            (js.Boot.isEnum = function (t) {
              return t.__ename__;
            }),
            (js.Boot.getClass = function (t) {
              return t.__class__;
            }),
            (js.Boot.__string_rec = function (t, e) {
              if (null == t) return "null";
              if (e.length >= 5) return "<...>";
              var i = typeof t;
              switch (
                ("function" == i &&
                  (t.__name__ || t.__ename__) &&
                  (i = "object"),
                i)
              ) {
                case "object":
                  if (t instanceof Array) {
                    if (t.__enum__) {
                      if (2 == t.length) return t[0];
                      var n = t[0] + "(";
                      e += "\t";
                      for (var o = 2, r = t.length; o < r; ) {
                        n +=
                          2 != (s = o++)
                            ? "," + js.Boot.__string_rec(t[s], e)
                            : js.Boot.__string_rec(t[s], e);
                      }
                      return n + ")";
                    }
                    var s,
                      a = t.length;
                    n = "[";
                    e += "\t";
                    for (r = 0; r < a; ) {
                      var l = r++;
                      n += (l > 0 ? "," : "") + js.Boot.__string_rec(t[l], e);
                    }
                    return (n += "]");
                  }
                  var c;
                  try {
                    c = t.toString;
                  } catch (t) {
                    return "???";
                  }
                  if (null != c && c != Object.toString) {
                    var d = t.toString();
                    if ("[object Object]" != d) return d;
                  }
                  var h = null;
                  n = "{\n";
                  e += "\t";
                  var u = null != t.hasOwnProperty;
                  for (var h in t)
                    (u && !t.hasOwnProperty(h)) ||
                      ("prototype" != h &&
                        "__class__" != h &&
                        "__super__" != h &&
                        "__interfaces__" != h &&
                        "__properties__" != h &&
                        (2 != n.length && (n += ", \n"),
                        (n += e + h + " : " + js.Boot.__string_rec(t[h], e))));
                  return (n += "\n" + (e = e.substring(1)) + "}");
                case "function":
                  return "<function>";
                case "string":
                  return t;
                default:
                  return String(t);
              }
            }),
            (js.Boot.__interfLoop = function (t, e) {
              if (null == t) return !1;
              if (t == e) return !0;
              var i = t.__interfaces__;
              if (null != i)
                for (var n = 0, o = i.length; n < o; ) {
                  var r = i[n++];
                  if (r == e || js.Boot.__interfLoop(r, e)) return !0;
                }
              return js.Boot.__interfLoop(t.__super__, e);
            }),
            (js.Boot.__instanceof = function (t, e) {
              try {
                if (t instanceof e) return e != Array || null == t.__enum__;
                if (js.Boot.__interfLoop(t.__class__, e)) return !0;
              } catch (t) {
                if (null == e) return !1;
              }
              switch (e) {
                case Int:
                  return Math.ceil(t % 2147483648) === t;
                case Float:
                  return "number" == typeof t;
                case Bool:
                  return !0 === t || !1 === t;
                case String:
                  return "string" == typeof t;
                case Dynamic:
                  return !0;
                default:
                  return (
                    null != t &&
                    ((e == Class && null != t.__name__) ||
                      (e == Enum && null != t.__ename__) ||
                      t.__enum__ == e)
                  );
              }
            }),
            (js.Boot.__cast = function (t, e) {
              if (js.Boot.__instanceof(t, e)) return t;
              throw "Cannot cast " + Std.string(t) + " to " + Std.string(e);
            }),
            (js.Lib = function () {}),
            (js.Lib.__name__ = !0),
            (js.Lib.debug = function () {}),
            (js.Lib.alert = function (t) {
              alert(js.Boot.__string_rec(t, ""));
            }),
            (js.Lib.eval = function (code) {
              return eval(code);
            }),
            (js.Lib.setErrorHandler = function (t) {
              js.Lib.onerror = t;
            }),
            Array.prototype.indexOf &&
              (HxOverrides.remove = function (t, e) {
                var i = t.indexOf(e);
                return -1 != i && (t.splice(i, 1), !0);
              }),
            (Math.__name__ = ["Math"]),
            (Math.NaN = Number.NaN),
            (Math.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY),
            (Math.POSITIVE_INFINITY = Number.POSITIVE_INFINITY),
            (Math.isFinite = function (t) {
              return isFinite(t);
            }),
            (Math.isNaN = function (t) {
              return isNaN(t);
            }),
            (String.prototype.__class__ = String),
            (String.__name__ = !0),
            (Array.prototype.__class__ = Array),
            (Array.__name__ = !0),
            (Date.prototype.__class__ = Date),
            (Date.__name__ = ["Date"]);
          var Int = { __name__: ["Int"] },
            Dynamic = { __name__: ["Dynamic"] },
            Float = Number;
          Float.__name__ = ["Float"];
          var Bool = Boolean;
          Bool.__ename__ = ["Bool"];
          var Class = { __name__: ["Class"] },
            Enum = {},
            Void = { __ename__: ["Void"] };
          "undefined" != typeof document && (js.Lib.document = document),
            "undefined" != typeof window &&
              ((js.Lib.window = window),
              (js.Lib.window.onerror = function (t, e, i) {
                var n = js.Lib.onerror;
                return null != n && n(t, [e + ":" + i]);
              })),
            com.wiris.js.JsPluginTools.main(),
            delete Array.prototype.__class__;
        })(),
          (function () {
            var HxOverrides = function () {};
            (HxOverrides.__name__ = !0),
              (HxOverrides.dateStr = function (t) {
                var e = t.getMonth() + 1,
                  i = t.getDate(),
                  n = t.getHours(),
                  o = t.getMinutes(),
                  r = t.getSeconds();
                return (
                  t.getFullYear() +
                  "-" +
                  (e < 10 ? "0" + e : "" + e) +
                  "-" +
                  (i < 10 ? "0" + i : "" + i) +
                  " " +
                  (n < 10 ? "0" + n : "" + n) +
                  ":" +
                  (o < 10 ? "0" + o : "" + o) +
                  ":" +
                  (r < 10 ? "0" + r : "" + r)
                );
              }),
              (HxOverrides.strDate = function (t) {
                switch (t.length) {
                  case 8:
                    var e = t.split(":"),
                      i = new Date();
                    return (
                      i.setTime(0),
                      i.setUTCHours(e[0]),
                      i.setUTCMinutes(e[1]),
                      i.setUTCSeconds(e[2]),
                      i
                    );
                  case 10:
                    e = t.split("-");
                    return new Date(e[0], e[1] - 1, e[2], 0, 0, 0);
                  case 19:
                    var n = (e = t.split(" "))[0].split("-"),
                      o = e[1].split(":");
                    return new Date(n[0], n[1] - 1, n[2], o[0], o[1], o[2]);
                  default:
                    throw "Invalid date format : " + t;
                }
              }),
              (HxOverrides.cca = function (t, e) {
                var i = t.charCodeAt(e);
                if (i == i) return i;
              }),
              (HxOverrides.substr = function (t, e, i) {
                return null != e && 0 != e && null != i && i < 0
                  ? ""
                  : (null == i && (i = t.length),
                    e < 0
                      ? (e = t.length + e) < 0 && (e = 0)
                      : i < 0 && (i = t.length + i - e),
                    t.substr(e, i));
              }),
              (HxOverrides.remove = function (t, e) {
                for (var i = 0, n = t.length; i < n; ) {
                  if (t[i] == e) return t.splice(i, 1), !0;
                  i++;
                }
                return !1;
              }),
              (HxOverrides.iter = function (t) {
                return {
                  cur: 0,
                  arr: t,
                  hasNext: function () {
                    return this.cur < this.arr.length;
                  },
                  next: function () {
                    return this.arr[this.cur++];
                  },
                };
              });
            var IntIter = function (t, e) {
              (this.min = t), (this.max = e);
            };
            (IntIter.__name__ = !0),
              (IntIter.prototype = {
                next: function () {
                  return this.min++;
                },
                hasNext: function () {
                  return this.min < this.max;
                },
                __class__: IntIter,
              });
            var Std = function () {};
            (Std.__name__ = !0),
              (Std.is = function (t, e) {
                return js.Boot.__instanceof(t, e);
              }),
              (Std.string = function (t) {
                return js.Boot.__string_rec(t, "");
              }),
              (Std.int = function (t) {
                return 0 | t;
              }),
              (Std.parseInt = function (t) {
                var e = parseInt(t, 10);
                return (
                  0 != e ||
                    (120 != HxOverrides.cca(t, 1) &&
                      88 != HxOverrides.cca(t, 1)) ||
                    (e = parseInt(t)),
                  isNaN(e) ? null : e
                );
              }),
              (Std.parseFloat = function (t) {
                return parseFloat(t);
              }),
              (Std.random = function (t) {
                return Math.floor(Math.random() * t);
              });
            var com = com || {};
            com.wiris || (com.wiris = {}),
              com.wiris.js || (com.wiris.js = {}),
              (com.wiris.js.JsPluginTools = function () {
                this.tryReady();
              }),
              (com.wiris.js.JsPluginTools.__name__ = !0),
              (com.wiris.js.JsPluginTools.main = function () {
                var t;
                (t = com.wiris.js.JsPluginTools.getInstance()),
                  haxe.Timer.delay($bind(t, t.tryReady), 100);
              }),
              (com.wiris.js.JsPluginTools.getInstance = function () {
                return (
                  null == com.wiris.js.JsPluginTools.instance &&
                    (com.wiris.js.JsPluginTools.instance =
                      new com.wiris.js.JsPluginTools()),
                  com.wiris.js.JsPluginTools.instance
                );
              }),
              (com.wiris.js.JsPluginTools.bypassEncapsulation = function () {
                null == window.com && (window.com = {}),
                  null == window.com.wiris && (window.com.wiris = {}),
                  null == window.com.wiris.js && (window.com.wiris.js = {}),
                  null == window.com.wiris.js.JsPluginTools &&
                    (window.com.wiris.js.JsPluginTools =
                      com.wiris.js.JsPluginTools.getInstance());
              }),
              (com.wiris.js.JsPluginTools.prototype = {
                md5encode: function (t) {
                  return haxe.Md5.encode(t);
                },
                doLoad: function () {
                  (this.ready = !0),
                    (com.wiris.js.JsPluginTools.instance = this),
                    com.wiris.js.JsPluginTools.bypassEncapsulation();
                },
                tryReady: function () {
                  (this.ready = !1),
                    js.Lib.document.readyState &&
                      (this.doLoad(), (this.ready = !0)),
                    this.ready ||
                      haxe.Timer.delay($bind(this, this.tryReady), 100);
                },
                __class__: com.wiris.js.JsPluginTools,
              });
            var haxe = haxe || {};
            (haxe.Log = function () {}),
              (haxe.Log.__name__ = !0),
              (haxe.Log.trace = function (t, e) {
                js.Boot.__trace(t, e);
              }),
              (haxe.Log.clear = function () {
                js.Boot.__clear_trace();
              }),
              (haxe.Md5 = function () {}),
              (haxe.Md5.__name__ = !0),
              (haxe.Md5.encode = function (t) {
                return new haxe.Md5().doEncode(t);
              }),
              (haxe.Md5.prototype = {
                doEncode: function (t) {
                  for (
                    var e = this.str2blks(t),
                      i = 1732584193,
                      n = -271733879,
                      o = -1732584194,
                      r = 271733878,
                      s = 0;
                    s < e.length;

                  ) {
                    var a = i,
                      l = n,
                      c = o,
                      d = r;
                    0,
                      (i = this.ff(i, n, o, r, e[s], 7, -680876936)),
                      (r = this.ff(r, i, n, o, e[s + 1], 12, -389564586)),
                      (o = this.ff(o, r, i, n, e[s + 2], 17, 606105819)),
                      (n = this.ff(n, o, r, i, e[s + 3], 22, -1044525330)),
                      (i = this.ff(i, n, o, r, e[s + 4], 7, -176418897)),
                      (r = this.ff(r, i, n, o, e[s + 5], 12, 1200080426)),
                      (o = this.ff(o, r, i, n, e[s + 6], 17, -1473231341)),
                      (n = this.ff(n, o, r, i, e[s + 7], 22, -45705983)),
                      (i = this.ff(i, n, o, r, e[s + 8], 7, 1770035416)),
                      (r = this.ff(r, i, n, o, e[s + 9], 12, -1958414417)),
                      (o = this.ff(o, r, i, n, e[s + 10], 17, -42063)),
                      (n = this.ff(n, o, r, i, e[s + 11], 22, -1990404162)),
                      (i = this.ff(i, n, o, r, e[s + 12], 7, 1804603682)),
                      (r = this.ff(r, i, n, o, e[s + 13], 12, -40341101)),
                      (o = this.ff(o, r, i, n, e[s + 14], 17, -1502002290)),
                      (n = this.ff(n, o, r, i, e[s + 15], 22, 1236535329)),
                      (i = this.gg(i, n, o, r, e[s + 1], 5, -165796510)),
                      (r = this.gg(r, i, n, o, e[s + 6], 9, -1069501632)),
                      (o = this.gg(o, r, i, n, e[s + 11], 14, 643717713)),
                      (n = this.gg(n, o, r, i, e[s], 20, -373897302)),
                      (i = this.gg(i, n, o, r, e[s + 5], 5, -701558691)),
                      (r = this.gg(r, i, n, o, e[s + 10], 9, 38016083)),
                      (o = this.gg(o, r, i, n, e[s + 15], 14, -660478335)),
                      (n = this.gg(n, o, r, i, e[s + 4], 20, -405537848)),
                      (i = this.gg(i, n, o, r, e[s + 9], 5, 568446438)),
                      (r = this.gg(r, i, n, o, e[s + 14], 9, -1019803690)),
                      (o = this.gg(o, r, i, n, e[s + 3], 14, -187363961)),
                      (n = this.gg(n, o, r, i, e[s + 8], 20, 1163531501)),
                      (i = this.gg(i, n, o, r, e[s + 13], 5, -1444681467)),
                      (r = this.gg(r, i, n, o, e[s + 2], 9, -51403784)),
                      (o = this.gg(o, r, i, n, e[s + 7], 14, 1735328473)),
                      (n = this.gg(n, o, r, i, e[s + 12], 20, -1926607734)),
                      (i = this.hh(i, n, o, r, e[s + 5], 4, -378558)),
                      (r = this.hh(r, i, n, o, e[s + 8], 11, -2022574463)),
                      (o = this.hh(o, r, i, n, e[s + 11], 16, 1839030562)),
                      (n = this.hh(n, o, r, i, e[s + 14], 23, -35309556)),
                      (i = this.hh(i, n, o, r, e[s + 1], 4, -1530992060)),
                      (r = this.hh(r, i, n, o, e[s + 4], 11, 1272893353)),
                      (o = this.hh(o, r, i, n, e[s + 7], 16, -155497632)),
                      (n = this.hh(n, o, r, i, e[s + 10], 23, -1094730640)),
                      (i = this.hh(i, n, o, r, e[s + 13], 4, 681279174)),
                      (r = this.hh(r, i, n, o, e[s], 11, -358537222)),
                      (o = this.hh(o, r, i, n, e[s + 3], 16, -722521979)),
                      (n = this.hh(n, o, r, i, e[s + 6], 23, 76029189)),
                      (i = this.hh(i, n, o, r, e[s + 9], 4, -640364487)),
                      (r = this.hh(r, i, n, o, e[s + 12], 11, -421815835)),
                      (o = this.hh(o, r, i, n, e[s + 15], 16, 530742520)),
                      (n = this.hh(n, o, r, i, e[s + 2], 23, -995338651)),
                      (i = this.ii(i, n, o, r, e[s], 6, -198630844)),
                      (r = this.ii(r, i, n, o, e[s + 7], 10, 1126891415)),
                      (o = this.ii(o, r, i, n, e[s + 14], 15, -1416354905)),
                      (n = this.ii(n, o, r, i, e[s + 5], 21, -57434055)),
                      (i = this.ii(i, n, o, r, e[s + 12], 6, 1700485571)),
                      (r = this.ii(r, i, n, o, e[s + 3], 10, -1894986606)),
                      (o = this.ii(o, r, i, n, e[s + 10], 15, -1051523)),
                      (n = this.ii(n, o, r, i, e[s + 1], 21, -2054922799)),
                      (i = this.ii(i, n, o, r, e[s + 8], 6, 1873313359)),
                      (r = this.ii(r, i, n, o, e[s + 15], 10, -30611744)),
                      (o = this.ii(o, r, i, n, e[s + 6], 15, -1560198380)),
                      (n = this.ii(n, o, r, i, e[s + 13], 21, 1309151649)),
                      (i = this.ii(i, n, o, r, e[s + 4], 6, -145523070)),
                      (r = this.ii(r, i, n, o, e[s + 11], 10, -1120210379)),
                      (o = this.ii(o, r, i, n, e[s + 2], 15, 718787259)),
                      (n = this.ii(n, o, r, i, e[s + 9], 21, -343485551)),
                      (i = this.addme(i, a)),
                      (n = this.addme(n, l)),
                      (o = this.addme(o, c)),
                      (r = this.addme(r, d)),
                      (s += 16);
                  }
                  return (
                    this.rhex(i) + this.rhex(n) + this.rhex(o) + this.rhex(r)
                  );
                },
                ii: function (t, e, i, n, o, r, s) {
                  return this.cmn(
                    this.bitXOR(i, this.bitOR(e, ~n)),
                    t,
                    e,
                    o,
                    r,
                    s
                  );
                },
                hh: function (t, e, i, n, o, r, s) {
                  return this.cmn(
                    this.bitXOR(this.bitXOR(e, i), n),
                    t,
                    e,
                    o,
                    r,
                    s
                  );
                },
                gg: function (t, e, i, n, o, r, s) {
                  return this.cmn(
                    this.bitOR(this.bitAND(e, n), this.bitAND(i, ~n)),
                    t,
                    e,
                    o,
                    r,
                    s
                  );
                },
                ff: function (t, e, i, n, o, r, s) {
                  return this.cmn(
                    this.bitOR(this.bitAND(e, i), this.bitAND(~e, n)),
                    t,
                    e,
                    o,
                    r,
                    s
                  );
                },
                cmn: function (t, e, i, n, o, r) {
                  return this.addme(
                    this.rol(this.addme(this.addme(e, t), this.addme(n, r)), o),
                    i
                  );
                },
                rol: function (t, e) {
                  return (t << e) | (t >>> (32 - e));
                },
                str2blks: function (t) {
                  for (
                    var e = 1 + ((t.length + 8) >> 6),
                      i = new Array(),
                      n = 0,
                      o = 16 * e;
                    n < o;

                  ) {
                    i[(r = n++)] = 0;
                  }
                  for (var r = 0; r < t.length; )
                    (i[r >> 2] |=
                      HxOverrides.cca(t, r) << (((8 * t.length + r) % 4) * 8)),
                      r++;
                  i[r >> 2] |= 128 << (((8 * t.length + r) % 4) * 8);
                  var s = 8 * t.length,
                    a = 16 * e - 2;
                  return (
                    (i[a] = 255 & s),
                    (i[a] |= ((s >>> 8) & 255) << 8),
                    (i[a] |= ((s >>> 16) & 255) << 16),
                    (i[a] |= ((s >>> 24) & 255) << 24),
                    i
                  );
                },
                rhex: function (t) {
                  for (var e = "", i = 0; i < 4; ) {
                    var n = i++;
                    e +=
                      "0123456789abcdef".charAt((t >> (8 * n + 4)) & 15) +
                      "0123456789abcdef".charAt((t >> (8 * n)) & 15);
                  }
                  return e;
                },
                addme: function (t, e) {
                  var i = (65535 & t) + (65535 & e);
                  return (
                    (((t >> 16) + (e >> 16) + (i >> 16)) << 16) | (65535 & i)
                  );
                },
                bitAND: function (t, e) {
                  return (((t >>> 1) & (e >>> 1)) << 1) | (1 & t & e);
                },
                bitXOR: function (t, e) {
                  return (((t >>> 1) ^ (e >>> 1)) << 1) | ((1 & t) ^ (1 & e));
                },
                bitOR: function (t, e) {
                  return (((t >>> 1) | (e >>> 1)) << 1) | ((1 & t) | (1 & e));
                },
                __class__: haxe.Md5,
              }),
              (haxe.Timer = function (t) {
                var e = this;
                this.id = window.setInterval(function () {
                  e.run();
                }, t);
              }),
              (haxe.Timer.__name__ = !0),
              (haxe.Timer.delay = function (t, e) {
                var i = new haxe.Timer(e);
                return (
                  (i.run = function () {
                    i.stop(), t();
                  }),
                  i
                );
              }),
              (haxe.Timer.measure = function (t, e) {
                var i = haxe.Timer.stamp(),
                  n = t();
                return haxe.Log.trace(haxe.Timer.stamp() - i + "s", e), n;
              }),
              (haxe.Timer.stamp = function () {
                return new Date().getTime() / 1e3;
              }),
              (haxe.Timer.prototype = {
                run: function () {},
                stop: function () {
                  null != this.id &&
                    (window.clearInterval(this.id), (this.id = null));
                },
                __class__: haxe.Timer,
              });
            var js = js || {},
              $_;
            function $bind(t, e) {
              var i = function () {
                return i.method.apply(i.scope, arguments);
              };
              return (i.scope = t), (i.method = e), i;
            }
            (js.Boot = function () {}),
              (js.Boot.__name__ = !0),
              (js.Boot.__unhtml = function (t) {
                return t
                  .split("&")
                  .join("&amp;")
                  .split("<")
                  .join("&lt;")
                  .split(">")
                  .join("&gt;");
              }),
              (js.Boot.__trace = function (t, e) {
                var i,
                  n = null != e ? e.fileName + ":" + e.lineNumber + ": " : "";
                (n += js.Boot.__string_rec(t, "")),
                  "undefined" != typeof document &&
                  null != (i = document.getElementById("haxe:trace"))
                    ? (i.innerHTML += js.Boot.__unhtml(n) + "<br/>")
                    : "undefined" != typeof console &&
                      null != console.log &&
                      console.log(n);
              }),
              (js.Boot.__clear_trace = function () {
                var t = document.getElementById("haxe:trace");
                null != t && (t.innerHTML = "");
              }),
              (js.Boot.isClass = function (t) {
                return t.__name__;
              }),
              (js.Boot.isEnum = function (t) {
                return t.__ename__;
              }),
              (js.Boot.getClass = function (t) {
                return t.__class__;
              }),
              (js.Boot.__string_rec = function (t, e) {
                if (null == t) return "null";
                if (e.length >= 5) return "<...>";
                var i = typeof t;
                switch (
                  ("function" == i &&
                    (t.__name__ || t.__ename__) &&
                    (i = "object"),
                  i)
                ) {
                  case "object":
                    if (t instanceof Array) {
                      if (t.__enum__) {
                        if (2 == t.length) return t[0];
                        var n = t[0] + "(";
                        e += "\t";
                        for (var o = 2, r = t.length; o < r; ) {
                          n +=
                            2 != (s = o++)
                              ? "," + js.Boot.__string_rec(t[s], e)
                              : js.Boot.__string_rec(t[s], e);
                        }
                        return n + ")";
                      }
                      var s,
                        a = t.length;
                      n = "[";
                      e += "\t";
                      for (r = 0; r < a; ) {
                        var l = r++;
                        n += (l > 0 ? "," : "") + js.Boot.__string_rec(t[l], e);
                      }
                      return (n += "]");
                    }
                    var c;
                    try {
                      c = t.toString;
                    } catch (t) {
                      return "???";
                    }
                    if (null != c && c != Object.toString) {
                      var d = t.toString();
                      if ("[object Object]" != d) return d;
                    }
                    var h = null;
                    n = "{\n";
                    e += "\t";
                    var u = null != t.hasOwnProperty;
                    for (var h in t)
                      (u && !t.hasOwnProperty(h)) ||
                        ("prototype" != h &&
                          "__class__" != h &&
                          "__super__" != h &&
                          "__interfaces__" != h &&
                          "__properties__" != h &&
                          (2 != n.length && (n += ", \n"),
                          (n +=
                            e + h + " : " + js.Boot.__string_rec(t[h], e))));
                    return (n += "\n" + (e = e.substring(1)) + "}");
                  case "function":
                    return "<function>";
                  case "string":
                    return t;
                  default:
                    return String(t);
                }
              }),
              (js.Boot.__interfLoop = function (t, e) {
                if (null == t) return !1;
                if (t == e) return !0;
                var i = t.__interfaces__;
                if (null != i)
                  for (var n = 0, o = i.length; n < o; ) {
                    var r = i[n++];
                    if (r == e || js.Boot.__interfLoop(r, e)) return !0;
                  }
                return js.Boot.__interfLoop(t.__super__, e);
              }),
              (js.Boot.__instanceof = function (t, e) {
                try {
                  if (t instanceof e) return e != Array || null == t.__enum__;
                  if (js.Boot.__interfLoop(t.__class__, e)) return !0;
                } catch (t) {
                  if (null == e) return !1;
                }
                switch (e) {
                  case Int:
                    return Math.ceil(t % 2147483648) === t;
                  case Float:
                    return "number" == typeof t;
                  case Bool:
                    return !0 === t || !1 === t;
                  case String:
                    return "string" == typeof t;
                  case Dynamic:
                    return !0;
                  default:
                    return (
                      null != t &&
                      ((e == Class && null != t.__name__) ||
                        (e == Enum && null != t.__ename__) ||
                        t.__enum__ == e)
                    );
                }
              }),
              (js.Boot.__cast = function (t, e) {
                if (js.Boot.__instanceof(t, e)) return t;
                throw "Cannot cast " + Std.string(t) + " to " + Std.string(e);
              }),
              (js.Lib = function () {}),
              (js.Lib.__name__ = !0),
              (js.Lib.debug = function () {}),
              (js.Lib.alert = function (t) {
                alert(js.Boot.__string_rec(t, ""));
              }),
              (js.Lib.eval = function (code) {
                return eval(code);
              }),
              (js.Lib.setErrorHandler = function (t) {
                js.Lib.onerror = t;
              }),
              Array.prototype.indexOf &&
                (HxOverrides.remove = function (t, e) {
                  var i = t.indexOf(e);
                  return -1 != i && (t.splice(i, 1), !0);
                }),
              (Math.__name__ = ["Math"]),
              (Math.NaN = Number.NaN),
              (Math.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY),
              (Math.POSITIVE_INFINITY = Number.POSITIVE_INFINITY),
              (Math.isFinite = function (t) {
                return isFinite(t);
              }),
              (Math.isNaN = function (t) {
                return isNaN(t);
              }),
              (String.prototype.__class__ = String),
              (String.__name__ = !0),
              (Array.prototype.__class__ = Array),
              (Array.__name__ = !0),
              (Date.prototype.__class__ = Date),
              (Date.__name__ = ["Date"]);
            var Int = { __name__: ["Int"] },
              Dynamic = { __name__: ["Dynamic"] },
              Float = Number;
            Float.__name__ = ["Float"];
            var Bool = Boolean;
            Bool.__ename__ = ["Bool"];
            var Class = { __name__: ["Class"] },
              Enum = {},
              Void = { __ename__: ["Void"] };
            "undefined" != typeof document && (js.Lib.document = document),
              "undefined" != typeof window &&
                ((js.Lib.window = window),
                (js.Lib.window.onerror = function (t, e, i) {
                  var n = js.Lib.onerror;
                  return null != n && n(t, [e + ":" + i]);
                })),
              com.wiris.js.JsPluginTools.main();
          })(),
          delete Array.prototype.__class__;
      },
      function (t, e, i) {
        var n = i(1),
          o = i(97);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[t.i, o, ""]]);
        var r = {
          injectType: "singletonStyleTag",
          attributes: { "data-cke": !0 },
          insert: "head",
          singleton: !0,
        };
        n(o, r);
        t.exports = o.locals || {};
      },
      function (t, e) {
        t.exports =
          ".wrs_modal_overlay{position:fixed;font-family:arial,sans-serif;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.8);z-index:999998;opacity:.65;pointer-events:auto}.wrs_modal_overlay.wrs_modal_android,.wrs_modal_overlay.wrs_modal_ios{visibility:hidden;display:none}.wrs_modal_overlay.wrs_modal_ios.moodle{position:fixed}.wrs_modal_overlay.wrs_modal_desktop.wrs_stack{background:transparent;display:none}.wrs_modal_overlay.wrs_modal_desktop.wrs_maximized{background:rgba(0,0,0,.8)}.wrs_modal_overlay.wrs_modal_desktop.wrs_closed,.wrs_modal_overlay.wrs_modal_desktop.wrs_minimized{background:transparent;display:none}.wrs_modal_title{color:#fff;padding:5px 0 5px 10px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;text-align:left}.wrs_modal_close_button{background-repeat:no-repeat}.wrs_modal_close_button,.wrs_modal_minimize_button{float:right;cursor:pointer;color:#fff;padding:5px 10px 5px 0;margin:10px 7px 0 0}.wrs_modal_minimize_button{top:inherit}.wrs_modal_stack_button{float:right;cursor:pointer;color:#fff;margin:10px 7px 0 0;padding:5px 10px 5px 0;top:inherit}.wrs_modal_stack_button.wrs_minimized,.wrs_modal_stack_button.wrs_stack{visibility:hidden;margin:0;padding:0}.wrs_modal_maximize_button{float:right;cursor:pointer;color:#fff;margin:10px 7px 0 0;padding:5px 10px 5px 0;top:inherit}.wrs_modal_maximize_button.wrs_maximized{visibility:hidden;margin:0;padding:0}.wrs_modal_wrapper{display:block}.wrs_modal_title_bar{display:block;background-color:#778e9a}.wrs_modal_dialogContainer{border:none;background:#fafafa;z-index:999999}.wrs_modal_dialogContainer.wrs_modal_desktop{font-size:14px}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_maximized{position:fixed}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_minimized{position:fixed;top:inherit;margin:0 10px 0 0}.wrs_modal_dialogContainer.wrs_closed{visibility:hidden;display:none;opacity:0}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_stack{position:fixed;bottom:0;right:0;box-shadow:0 2px 8px rgba(0,0,0,.5)}.wrs_modal_dialogContainer.wrs_drag,.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_drag{box-shadow:0 2px 8px rgba(0,0,0,.5)}.wrs_modal_dialogContainer.wrs_modal_android{width:99%;height:99%}.wrs_modal_dialogContainer.wrs_modal_android,.wrs_modal_dialogContainer.wrs_modal_ios{margin:auto;overflow:hidden;transform:translate(50%,-50%);top:50%;right:50%!important;position:fixed}.wrs_modal_dialogContainer.wrs_modal_ios{width:100%;height:100%}.wrs_content_container.wrs_minimized{display:none}.wrs_content_container.wrs_modal_android{width:100%;flex-grow:1;display:flex;flex-direction:column}.wrs_content_container.wrs_modal_android>div:first-child,.wrs_content_container.wrs_modal_desktop>div:first-child,.wrs_content_container.wrs_modal_ios>div:first-child{flex-grow:1}.wrs_modal_wrapper.wrs_modal_android{margin:auto;display:flex;flex-direction:column;height:100%;width:100%}.wrs_content_container.wrs_modal_desktop,.wrs_content_container.wrs_modal_ios{width:100%;flex-grow:1;display:flex;flex-direction:column}.wrs_modal_wrapper.wrs_modal_ios{margin:auto;display:flex;flex-direction:column;height:100%;width:100%}.wrs_virtual_keyboard{height:100%;width:100%;top:0;left:50%;transform:translate(-50%)}@media (orientation:portrait){.wrs_modal_dialogContainer.wrs_modal_mobile{width:100vmin;height:100vmin;margin:auto;border-width:0}.wrs_modal_wrapper.wrs_modal_mobile{width:100vmin;height:100vmin;margin:auto}}@media (orientation:landscape){.wrs_modal_dialogContainer.wrs_modal_mobile{width:100vmin;height:100vmin;margin:auto;border-width:0}.wrs_modal_wrapper.wrs_modal_mobile{width:100vmin;height:100vmin;margin:auto}}.wrs_modal_dialogContainer.wrs_modal_badStock,.wrs_modal_wrapper.wrs_modal_badStock{width:100%;height:280px;margin:0 auto;border-width:0}.wrs_noselect{-khtml-user-select:none}.wrs_bottom_right_resizer,.wrs_noselect{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.wrs_bottom_right_resizer{width:10px;height:10px;color:#778e9a;position:absolute;right:4px;bottom:8px;cursor:se-resize}.wrs_bottom_left_resizer{width:15px;height:15px;color:#778e9a;position:absolute;left:0;top:0;cursor:se-resize}.wrs_modal_controls{height:42px;margin:3px 0;overflow:hidden;line-height:normal}.wrs_modal_links{margin:10px auto 0;font-family:arial,sans-serif;padding:6px;display:inline;float:right;text-align:right}.wrs_modal_links>a{text-decoration:none;color:#778e9a;font-size:16px}.wrs_modal_button_cancel,.wrs_modal_button_cancel:active,.wrs_modal_button_cancel:focus,.wrs_modal_button_cancel:hover,.wrs_modal_button_cancel:visited{min-width:80px;font-size:14px;border-radius:3px;border:1px solid #778e9a;padding:6px 8px;margin:10px auto 0 5px;cursor:pointer;font-family:arial,sans-serif;background-color:#ddd;height:32px}.wrs_modal_button_accept,.wrs_modal_button_accept:active,.wrs_modal_button_accept:focus,.wrs_modal_button_accept:hover,.wrs_modal_button_accept:visited{min-width:80px;font-size:14px;border-radius:3px;border:1px solid #778e9a;padding:6px 8px;margin:10px 5px 0 auto;color:#fff;background:#778e9a;cursor:pointer;font-family:arial,sans-serif;height:32px}.wrs_editor_vertical_bar{height:20px;float:right;background:none;width:20px;cursor:pointer}.wrs_modal_buttons_container{display:inline;float:left}.wrs_modal_buttons_container.wrs_modalAndroid{padding-left:6px}.wrs_modal_buttons_container.wrs_modalDesktop{padding-left:0}.wrs_modal_buttons_container>button{line-height:normal;background-image:none}.wrs_modal_wrapper{margin:6px;display:flex;flex-direction:column}.wrs_modal_wrapper.wrs_modal_desktop.wrs_minimized{display:none}@media only screen and (max-device-width:480px) and (orientation:portrait){#wrs_modal_wrapper{width:140%}}.wrs_popupmessage_overlay_envolture{display:none;width:100%}.wrs_popupmessage_overlay{position:absolute;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:4;cursor:pointer}.wrs_popupmessage_panel{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;background:#fff;max-width:500px;width:75%;border-radius:2px;padding:20px;font-family:sans-serif;font-size:15px;text-align:left;color:#2e2e2e;z-index:5;max-height:75%;overflow:auto}.wrs_popupmessage_button_area{margin:10px 0 0}.wrs_panelContainer *{border:0}.wrs_button_cancel,.wrs_button_cancel:active,.wrs_button_cancel:focus,.wrs_button_cancel:hover,.wrs_button_cancel:visited{min-width:80px;font-size:14px;border-radius:3px;border:1px solid #778e9a;padding:6px 8px;margin:10px auto 0 5px;cursor:pointer;font-family:arial,sans-serif;background-color:#ddd;background-image:none;height:32px}.wrs_button_accept,.wrs_button_accept:active,.wrs_button_accept:focus,.wrs_button_accept:hover,.wrs_button_accept:visited{min-width:80px;font-size:14px;border-radius:3px;border:1px solid #778e9a;padding:6px 8px;margin:10px 5px 0 auto;color:#fff;background:#778e9a;cursor:pointer;font-family:arial,sans-serif;height:32px}.wrs_editor button{box-shadow:none}.wrs_editor .wrs_header button{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.wrs_modal_overlay.wrs_modal_desktop.wrs_stack.wrs_overlay_active{display:block}.wrs_toolbar tr:focus,.wrs_toolbar tr:hover{background:none}.wrs_modal_rtl .wrs_modal_button_cancel{margin-right:5px;margin-left:0}.wrs_modal_rtl .wrs_modal_button_accept{margin-right:0;margin-left:5px}.wrs_modal_rtl .wrs_button_cancel{margin-right:5px;margin-left:0}.wrs_modal_rtl .wrs_button_accept{margin-right:0;margin-left:5px}";
      },
      function (t, e, i) {
        "use strict";
        i.r(e),
          i.d(e, "default", function () {
            return Ib;
          });
        var n = i(3),
          o = n.a.Symbol,
          r = Object.prototype,
          s = r.hasOwnProperty,
          a = r.toString,
          l = o ? o.toStringTag : void 0;
        var c = function (t) {
            var e = s.call(t, l),
              i = t[l];
            try {
              t[l] = void 0;
              var n = !0;
            } catch (t) {}
            var o = a.call(t);
            return n && (e ? (t[l] = i) : delete t[l]), o;
          },
          d = Object.prototype.toString;
        var h = function (t) {
            return d.call(t);
          },
          u = o ? o.toStringTag : void 0;
        var m = function (t) {
          return null == t
            ? void 0 === t
              ? "[object Undefined]"
              : "[object Null]"
            : u && u in Object(t)
            ? c(t)
            : h(t);
        };
        var g = function (t, e) {
            return function (i) {
              return t(e(i));
            };
          },
          f = g(Object.getPrototypeOf, Object);
        var p = function (t) {
            return null != t && "object" == typeof t;
          },
          b = Function.prototype,
          w = Object.prototype,
          _ = b.toString,
          k = w.hasOwnProperty,
          v = _.call(Object);
        var y = function (t) {
          if (!p(t) || "[object Object]" != m(t)) return !1;
          var e = f(t);
          if (null === e) return !0;
          var i = k.call(e, "constructor") && e.constructor;
          return "function" == typeof i && i instanceof i && _.call(i) == v;
        };
        var x = function () {
          (this.__data__ = []), (this.size = 0);
        };
        var A = function (t, e) {
          return t === e || (t != t && e != e);
        };
        var C = function (t, e) {
            for (var i = t.length; i--; ) if (A(t[i][0], e)) return i;
            return -1;
          },
          T = Array.prototype.splice;
        var M = function (t) {
          var e = this.__data__,
            i = C(e, t);
          return (
            !(i < 0) &&
            (i == e.length - 1 ? e.pop() : T.call(e, i, 1), --this.size, !0)
          );
        };
        var E = function (t) {
          var e = this.__data__,
            i = C(e, t);
          return i < 0 ? void 0 : e[i][1];
        };
        var P = function (t) {
          return C(this.__data__, t) > -1;
        };
        var S = function (t, e) {
          var i = this.__data__,
            n = C(i, t);
          return n < 0 ? (++this.size, i.push([t, e])) : (i[n][1] = e), this;
        };
        function I(t) {
          var e = -1,
            i = null == t ? 0 : t.length;
          for (this.clear(); ++e < i; ) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }
        (I.prototype.clear = x),
          (I.prototype.delete = M),
          (I.prototype.get = E),
          (I.prototype.has = P),
          (I.prototype.set = S);
        var O = I;
        var N = function () {
          (this.__data__ = new O()), (this.size = 0);
        };
        var R = function (t) {
          var e = this.__data__,
            i = e.delete(t);
          return (this.size = e.size), i;
        };
        var L = function (t) {
          return this.__data__.get(t);
        };
        var j = function (t) {
          return this.__data__.has(t);
        };
        var D = function (t) {
          var e = typeof t;
          return null != t && ("object" == e || "function" == e);
        };
        var z,
          B = function (t) {
            if (!D(t)) return !1;
            var e = m(t);
            return (
              "[object Function]" == e ||
              "[object GeneratorFunction]" == e ||
              "[object AsyncFunction]" == e ||
              "[object Proxy]" == e
            );
          },
          V = n.a["__core-js_shared__"],
          F = (z = /[^.]+$/.exec((V && V.keys && V.keys.IE_PROTO) || ""))
            ? "Symbol(src)_1." + z
            : "";
        var H = function (t) {
            return !!F && F in t;
          },
          U = Function.prototype.toString;
        var W = function (t) {
            if (null != t) {
              try {
                return U.call(t);
              } catch (t) {}
              try {
                return t + "";
              } catch (t) {}
            }
            return "";
          },
          q = /^\[object .+?Constructor\]$/,
          Y = Function.prototype,
          $ = Object.prototype,
          J = Y.toString,
          G = $.hasOwnProperty,
          Q = RegExp(
            "^" +
              J.call(G)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?"
                ) +
              "$"
          );
        var X = function (t) {
          return !(!D(t) || H(t)) && (B(t) ? Q : q).test(W(t));
        };
        var K = function (t, e) {
          return null == t ? void 0 : t[e];
        };
        var Z = function (t, e) {
            var i = K(t, e);
            return X(i) ? i : void 0;
          },
          tt = Z(n.a, "Map"),
          et = Z(Object, "create");
        var it = function () {
          (this.__data__ = et ? et(null) : {}), (this.size = 0);
        };
        var nt = function (t) {
            var e = this.has(t) && delete this.__data__[t];
            return (this.size -= e ? 1 : 0), e;
          },
          ot = Object.prototype.hasOwnProperty;
        var rt = function (t) {
            var e = this.__data__;
            if (et) {
              var i = e[t];
              return "__lodash_hash_undefined__" === i ? void 0 : i;
            }
            return ot.call(e, t) ? e[t] : void 0;
          },
          st = Object.prototype.hasOwnProperty;
        var at = function (t) {
          var e = this.__data__;
          return et ? void 0 !== e[t] : st.call(e, t);
        };
        var lt = function (t, e) {
          var i = this.__data__;
          return (
            (this.size += this.has(t) ? 0 : 1),
            (i[t] = et && void 0 === e ? "__lodash_hash_undefined__" : e),
            this
          );
        };
        function ct(t) {
          var e = -1,
            i = null == t ? 0 : t.length;
          for (this.clear(); ++e < i; ) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }
        (ct.prototype.clear = it),
          (ct.prototype.delete = nt),
          (ct.prototype.get = rt),
          (ct.prototype.has = at),
          (ct.prototype.set = lt);
        var dt = ct;
        var ht = function () {
          (this.size = 0),
            (this.__data__ = {
              hash: new dt(),
              map: new (tt || O)(),
              string: new dt(),
            });
        };
        var ut = function (t) {
          var e = typeof t;
          return "string" == e ||
            "number" == e ||
            "symbol" == e ||
            "boolean" == e
            ? "__proto__" !== t
            : null === t;
        };
        var mt = function (t, e) {
          var i = t.__data__;
          return ut(e) ? i["string" == typeof e ? "string" : "hash"] : i.map;
        };
        var gt = function (t) {
          var e = mt(this, t).delete(t);
          return (this.size -= e ? 1 : 0), e;
        };
        var ft = function (t) {
          return mt(this, t).get(t);
        };
        var pt = function (t) {
          return mt(this, t).has(t);
        };
        var bt = function (t, e) {
          var i = mt(this, t),
            n = i.size;
          return i.set(t, e), (this.size += i.size == n ? 0 : 1), this;
        };
        function wt(t) {
          var e = -1,
            i = null == t ? 0 : t.length;
          for (this.clear(); ++e < i; ) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }
        (wt.prototype.clear = ht),
          (wt.prototype.delete = gt),
          (wt.prototype.get = ft),
          (wt.prototype.has = pt),
          (wt.prototype.set = bt);
        var _t = wt;
        var kt = function (t, e) {
          var i = this.__data__;
          if (i instanceof O) {
            var n = i.__data__;
            if (!tt || n.length < 199)
              return n.push([t, e]), (this.size = ++i.size), this;
            i = this.__data__ = new _t(n);
          }
          return i.set(t, e), (this.size = i.size), this;
        };
        function vt(t) {
          var e = (this.__data__ = new O(t));
          this.size = e.size;
        }
        (vt.prototype.clear = N),
          (vt.prototype.delete = R),
          (vt.prototype.get = L),
          (vt.prototype.has = j),
          (vt.prototype.set = kt);
        var yt = vt;
        var xt = function (t, e) {
            for (
              var i = -1, n = null == t ? 0 : t.length;
              ++i < n && !1 !== e(t[i], i, t);

            );
            return t;
          },
          At = (function () {
            try {
              var t = Z(Object, "defineProperty");
              return t({}, "", {}), t;
            } catch (t) {}
          })();
        var Ct = function (t, e, i) {
            "__proto__" == e && At
              ? At(t, e, {
                  configurable: !0,
                  enumerable: !0,
                  value: i,
                  writable: !0,
                })
              : (t[e] = i);
          },
          Tt = Object.prototype.hasOwnProperty;
        var Mt = function (t, e, i) {
          var n = t[e];
          (Tt.call(t, e) && A(n, i) && (void 0 !== i || e in t)) || Ct(t, e, i);
        };
        var Et = function (t, e, i, n) {
          var o = !i;
          i || (i = {});
          for (var r = -1, s = e.length; ++r < s; ) {
            var a = e[r],
              l = n ? n(i[a], t[a], a, i, t) : void 0;
            void 0 === l && (l = t[a]), o ? Ct(i, a, l) : Mt(i, a, l);
          }
          return i;
        };
        var Pt = function (t, e) {
          for (var i = -1, n = Array(t); ++i < t; ) n[i] = e(i);
          return n;
        };
        var St = function (t) {
            return p(t) && "[object Arguments]" == m(t);
          },
          It = Object.prototype,
          Ot = It.hasOwnProperty,
          Nt = It.propertyIsEnumerable,
          Rt = St(
            (function () {
              return arguments;
            })()
          )
            ? St
            : function (t) {
                return p(t) && Ot.call(t, "callee") && !Nt.call(t, "callee");
              },
          Lt = Array.isArray,
          jt = i(4),
          Dt = /^(?:0|[1-9]\d*)$/;
        var zt = function (t, e) {
          var i = typeof t;
          return (
            !!(e = null == e ? 9007199254740991 : e) &&
            ("number" == i || ("symbol" != i && Dt.test(t))) &&
            t > -1 &&
            t % 1 == 0 &&
            t < e
          );
        };
        var Bt = function (t) {
            return (
              "number" == typeof t &&
              t > -1 &&
              t % 1 == 0 &&
              t <= 9007199254740991
            );
          },
          Vt = {};
        (Vt["[object Float32Array]"] =
          Vt["[object Float64Array]"] =
          Vt["[object Int8Array]"] =
          Vt["[object Int16Array]"] =
          Vt["[object Int32Array]"] =
          Vt["[object Uint8Array]"] =
          Vt["[object Uint8ClampedArray]"] =
          Vt["[object Uint16Array]"] =
          Vt["[object Uint32Array]"] =
            !0),
          (Vt["[object Arguments]"] =
            Vt["[object Array]"] =
            Vt["[object ArrayBuffer]"] =
            Vt["[object Boolean]"] =
            Vt["[object DataView]"] =
            Vt["[object Date]"] =
            Vt["[object Error]"] =
            Vt["[object Function]"] =
            Vt["[object Map]"] =
            Vt["[object Number]"] =
            Vt["[object Object]"] =
            Vt["[object RegExp]"] =
            Vt["[object Set]"] =
            Vt["[object String]"] =
            Vt["[object WeakMap]"] =
              !1);
        var Ft = function (t) {
          return p(t) && Bt(t.length) && !!Vt[m(t)];
        };
        var Ht = function (t) {
            return function (e) {
              return t(e);
            };
          },
          Ut = i(5),
          Wt = Ut.a && Ut.a.isTypedArray,
          qt = Wt ? Ht(Wt) : Ft,
          Yt = Object.prototype.hasOwnProperty;
        var $t = function (t, e) {
            var i = Lt(t),
              n = !i && Rt(t),
              o = !i && !n && Object(jt.a)(t),
              r = !i && !n && !o && qt(t),
              s = i || n || o || r,
              a = s ? Pt(t.length, String) : [],
              l = a.length;
            for (var c in t)
              (!e && !Yt.call(t, c)) ||
                (s &&
                  ("length" == c ||
                    (o && ("offset" == c || "parent" == c)) ||
                    (r &&
                      ("buffer" == c ||
                        "byteLength" == c ||
                        "byteOffset" == c)) ||
                    zt(c, l))) ||
                a.push(c);
            return a;
          },
          Jt = Object.prototype;
        var Gt = function (t) {
            var e = t && t.constructor;
            return t === (("function" == typeof e && e.prototype) || Jt);
          },
          Qt = g(Object.keys, Object),
          Xt = Object.prototype.hasOwnProperty;
        var Kt = function (t) {
          if (!Gt(t)) return Qt(t);
          var e = [];
          for (var i in Object(t))
            Xt.call(t, i) && "constructor" != i && e.push(i);
          return e;
        };
        var Zt = function (t) {
          return null != t && Bt(t.length) && !B(t);
        };
        var te = function (t) {
          return Zt(t) ? $t(t) : Kt(t);
        };
        var ee = function (t, e) {
          return t && Et(e, te(e), t);
        };
        var ie = function (t) {
            var e = [];
            if (null != t) for (var i in Object(t)) e.push(i);
            return e;
          },
          ne = Object.prototype.hasOwnProperty;
        var oe = function (t) {
          if (!D(t)) return ie(t);
          var e = Gt(t),
            i = [];
          for (var n in t)
            ("constructor" != n || (!e && ne.call(t, n))) && i.push(n);
          return i;
        };
        var re = function (t) {
          return Zt(t) ? $t(t, !0) : oe(t);
        };
        var se = function (t, e) {
            return t && Et(e, re(e), t);
          },
          ae = i(8);
        var le = function (t, e) {
          var i = -1,
            n = t.length;
          for (e || (e = Array(n)); ++i < n; ) e[i] = t[i];
          return e;
        };
        var ce = function (t, e) {
          for (
            var i = -1, n = null == t ? 0 : t.length, o = 0, r = [];
            ++i < n;

          ) {
            var s = t[i];
            e(s, i, t) && (r[o++] = s);
          }
          return r;
        };
        var de = function () {
            return [];
          },
          he = Object.prototype.propertyIsEnumerable,
          ue = Object.getOwnPropertySymbols,
          me = ue
            ? function (t) {
                return null == t
                  ? []
                  : ((t = Object(t)),
                    ce(ue(t), function (e) {
                      return he.call(t, e);
                    }));
              }
            : de;
        var ge = function (t, e) {
          return Et(t, me(t), e);
        };
        var fe = function (t, e) {
            for (var i = -1, n = e.length, o = t.length; ++i < n; )
              t[o + i] = e[i];
            return t;
          },
          pe = Object.getOwnPropertySymbols
            ? function (t) {
                for (var e = []; t; ) fe(e, me(t)), (t = f(t));
                return e;
              }
            : de;
        var be = function (t, e) {
          return Et(t, pe(t), e);
        };
        var we = function (t, e, i) {
          var n = e(t);
          return Lt(t) ? n : fe(n, i(t));
        };
        var _e = function (t) {
          return we(t, te, me);
        };
        var ke = function (t) {
            return we(t, re, pe);
          },
          ve = Z(n.a, "DataView"),
          ye = Z(n.a, "Promise"),
          xe = Z(n.a, "Set"),
          Ae = Z(n.a, "WeakMap"),
          Ce = W(ve),
          Te = W(tt),
          Me = W(ye),
          Ee = W(xe),
          Pe = W(Ae),
          Se = m;
        ((ve && "[object DataView]" != Se(new ve(new ArrayBuffer(1)))) ||
          (tt && "[object Map]" != Se(new tt())) ||
          (ye && "[object Promise]" != Se(ye.resolve())) ||
          (xe && "[object Set]" != Se(new xe())) ||
          (Ae && "[object WeakMap]" != Se(new Ae()))) &&
          (Se = function (t) {
            var e = m(t),
              i = "[object Object]" == e ? t.constructor : void 0,
              n = i ? W(i) : "";
            if (n)
              switch (n) {
                case Ce:
                  return "[object DataView]";
                case Te:
                  return "[object Map]";
                case Me:
                  return "[object Promise]";
                case Ee:
                  return "[object Set]";
                case Pe:
                  return "[object WeakMap]";
              }
            return e;
          });
        var Ie = Se,
          Oe = Object.prototype.hasOwnProperty;
        var Ne = function (t) {
            var e = t.length,
              i = new t.constructor(e);
            return (
              e &&
                "string" == typeof t[0] &&
                Oe.call(t, "index") &&
                ((i.index = t.index), (i.input = t.input)),
              i
            );
          },
          Re = n.a.Uint8Array;
        var Le = function (t) {
          var e = new t.constructor(t.byteLength);
          return new Re(e).set(new Re(t)), e;
        };
        var je = function (t, e) {
            var i = e ? Le(t.buffer) : t.buffer;
            return new t.constructor(i, t.byteOffset, t.byteLength);
          },
          De = /\w*$/;
        var ze = function (t) {
            var e = new t.constructor(t.source, De.exec(t));
            return (e.lastIndex = t.lastIndex), e;
          },
          Be = o ? o.prototype : void 0,
          Ve = Be ? Be.valueOf : void 0;
        var Fe = function (t) {
          return Ve ? Object(Ve.call(t)) : {};
        };
        var He = function (t, e) {
          var i = e ? Le(t.buffer) : t.buffer;
          return new t.constructor(i, t.byteOffset, t.length);
        };
        var Ue = function (t, e, i) {
            var n = t.constructor;
            switch (e) {
              case "[object ArrayBuffer]":
                return Le(t);
              case "[object Boolean]":
              case "[object Date]":
                return new n(+t);
              case "[object DataView]":
                return je(t, i);
              case "[object Float32Array]":
              case "[object Float64Array]":
              case "[object Int8Array]":
              case "[object Int16Array]":
              case "[object Int32Array]":
              case "[object Uint8Array]":
              case "[object Uint8ClampedArray]":
              case "[object Uint16Array]":
              case "[object Uint32Array]":
                return He(t, i);
              case "[object Map]":
                return new n();
              case "[object Number]":
              case "[object String]":
                return new n(t);
              case "[object RegExp]":
                return ze(t);
              case "[object Set]":
                return new n();
              case "[object Symbol]":
                return Fe(t);
            }
          },
          We = Object.create,
          qe = (function () {
            function t() {}
            return function (e) {
              if (!D(e)) return {};
              if (We) return We(e);
              t.prototype = e;
              var i = new t();
              return (t.prototype = void 0), i;
            };
          })();
        var Ye = function (t) {
          return "function" != typeof t.constructor || Gt(t) ? {} : qe(f(t));
        };
        var $e = function (t) {
            return p(t) && "[object Map]" == Ie(t);
          },
          Je = Ut.a && Ut.a.isMap,
          Ge = Je ? Ht(Je) : $e;
        var Qe = function (t) {
            return p(t) && "[object Set]" == Ie(t);
          },
          Xe = Ut.a && Ut.a.isSet,
          Ke = Xe ? Ht(Xe) : Qe,
          Ze = {};
        (Ze["[object Arguments]"] =
          Ze["[object Array]"] =
          Ze["[object ArrayBuffer]"] =
          Ze["[object DataView]"] =
          Ze["[object Boolean]"] =
          Ze["[object Date]"] =
          Ze["[object Float32Array]"] =
          Ze["[object Float64Array]"] =
          Ze["[object Int8Array]"] =
          Ze["[object Int16Array]"] =
          Ze["[object Int32Array]"] =
          Ze["[object Map]"] =
          Ze["[object Number]"] =
          Ze["[object Object]"] =
          Ze["[object RegExp]"] =
          Ze["[object Set]"] =
          Ze["[object String]"] =
          Ze["[object Symbol]"] =
          Ze["[object Uint8Array]"] =
          Ze["[object Uint8ClampedArray]"] =
          Ze["[object Uint16Array]"] =
          Ze["[object Uint32Array]"] =
            !0),
          (Ze["[object Error]"] =
            Ze["[object Function]"] =
            Ze["[object WeakMap]"] =
              !1);
        var ti = function t(e, i, n, o, r, s) {
          var a,
            l = 1 & i,
            c = 2 & i,
            d = 4 & i;
          if ((n && (a = r ? n(e, o, r, s) : n(e)), void 0 !== a)) return a;
          if (!D(e)) return e;
          var h = Lt(e);
          if (h) {
            if (((a = Ne(e)), !l)) return le(e, a);
          } else {
            var u = Ie(e),
              m = "[object Function]" == u || "[object GeneratorFunction]" == u;
            if (Object(jt.a)(e)) return Object(ae.a)(e, l);
            if (
              "[object Object]" == u ||
              "[object Arguments]" == u ||
              (m && !r)
            ) {
              if (((a = c || m ? {} : Ye(e)), !l))
                return c ? be(e, se(a, e)) : ge(e, ee(a, e));
            } else {
              if (!Ze[u]) return r ? e : {};
              a = Ue(e, u, l);
            }
          }
          s || (s = new yt());
          var g = s.get(e);
          if (g) return g;
          s.set(e, a),
            Ke(e)
              ? e.forEach(function (o) {
                  a.add(t(o, i, n, o, e, s));
                })
              : Ge(e) &&
                e.forEach(function (o, r) {
                  a.set(r, t(o, i, n, r, e, s));
                });
          var f = d ? (c ? ke : _e) : c ? keysIn : te,
            p = h ? void 0 : f(e);
          return (
            xt(p || e, function (o, r) {
              p && (o = e[(r = o)]), Mt(a, r, t(o, i, n, r, e, s));
            }),
            a
          );
        };
        var ei = function (t, e) {
          return ti(t, 5, (e = "function" == typeof e ? e : void 0));
        };
        var ii = function (t) {
          return p(t) && 1 === t.nodeType && !y(t);
        };
        class ni {
          constructor(t, e) {
            (this._config = {}),
              e && this.define(oi(e)),
              t && this._setObjectToTarget(this._config, t);
          }
          set(t, e) {
            this._setToTarget(this._config, t, e);
          }
          define(t, e) {
            this._setToTarget(this._config, t, e, !0);
          }
          get(t) {
            return this._getFromSource(this._config, t);
          }
          *names() {
            for (const t of Object.keys(this._config)) yield t;
          }
          _setToTarget(t, e, i, n = !1) {
            if (y(e)) return void this._setObjectToTarget(t, e, n);
            const o = e.split(".");
            e = o.pop();
            for (const e of o) y(t[e]) || (t[e] = {}), (t = t[e]);
            if (y(i))
              return (
                y(t[e]) || (t[e] = {}),
                (t = t[e]),
                void this._setObjectToTarget(t, i, n)
              );
            (n && void 0 !== t[e]) || (t[e] = i);
          }
          _getFromSource(t, e) {
            const i = e.split(".");
            e = i.pop();
            for (const e of i) {
              if (!y(t[e])) {
                t = null;
                break;
              }
              t = t[e];
            }
            return t ? oi(t[e]) : void 0;
          }
          _setObjectToTarget(t, e, i) {
            Object.keys(e).forEach((n) => {
              this._setToTarget(t, n, e[n], i);
            });
          }
        }
        function oi(t) {
          return ei(t, ri);
        }
        function ri(t) {
          return ii(t) ? t : void 0;
        }
        var si = function () {
          return function t() {
            t.called = !0;
          };
        };
        class ai {
          constructor(t, e) {
            (this.source = t),
              (this.name = e),
              (this.path = []),
              (this.stop = si()),
              (this.off = si());
          }
        }
        const li = new Array(256)
          .fill()
          .map((t, e) => ("0" + e.toString(16)).slice(-2));
        function ci() {
          const t = (4294967296 * Math.random()) >>> 0,
            e = (4294967296 * Math.random()) >>> 0,
            i = (4294967296 * Math.random()) >>> 0,
            n = (4294967296 * Math.random()) >>> 0;
          return (
            "e" +
            li[(t >> 0) & 255] +
            li[(t >> 8) & 255] +
            li[(t >> 16) & 255] +
            li[(t >> 24) & 255] +
            li[(e >> 0) & 255] +
            li[(e >> 8) & 255] +
            li[(e >> 16) & 255] +
            li[(e >> 24) & 255] +
            li[(i >> 0) & 255] +
            li[(i >> 8) & 255] +
            li[(i >> 16) & 255] +
            li[(i >> 24) & 255] +
            li[(n >> 0) & 255] +
            li[(n >> 8) & 255] +
            li[(n >> 16) & 255] +
            li[(n >> 24) & 255]
          );
        }
        var di = {
            get(t) {
              return "number" != typeof t ? this[t] || this.normal : t;
            },
            highest: 1e5,
            high: 1e3,
            normal: 0,
            low: -1e3,
            lowest: -1e5,
          },
          hi = (i(6), i(0));
        const ui = Symbol("listeningTo"),
          mi = Symbol("emitterId");
        var gi = {
          on(t, e, i = {}) {
            this.listenTo(this, t, e, i);
          },
          once(t, e, i) {
            let n = !1;
            this.listenTo(
              this,
              t,
              function (t, ...i) {
                n || ((n = !0), t.off(), e.call(this, t, ...i));
              },
              i
            );
          },
          off(t, e) {
            this.stopListening(this, t, e);
          },
          listenTo(t, e, i, n = {}) {
            let o, r;
            this[ui] || (this[ui] = {});
            const s = this[ui];
            pi(t) || fi(t);
            const a = pi(t);
            (o = s[a]) || (o = s[a] = { emitter: t, callbacks: {} }),
              (r = o.callbacks[e]) || (r = o.callbacks[e] = []),
              r.push(i),
              (function (t, e) {
                const i = bi(t);
                if (i[e]) return;
                let n = e,
                  o = null;
                const r = [];
                for (; "" !== n && !i[n]; )
                  (i[n] = { callbacks: [], childEvents: [] }),
                    r.push(i[n]),
                    o && i[n].childEvents.push(o),
                    (o = n),
                    (n = n.substr(0, n.lastIndexOf(":")));
                if ("" !== n) {
                  for (const t of r) t.callbacks = i[n].callbacks.slice();
                  i[n].childEvents.push(o);
                }
              })(t, e);
            const l = wi(t, e),
              c = di.get(n.priority),
              d = { callback: i, priority: c };
            for (const t of l) {
              let e = !1;
              for (let i = 0; i < t.length; i++)
                if (t[i].priority < c) {
                  t.splice(i, 0, d), (e = !0);
                  break;
                }
              e || t.push(d);
            }
          },
          stopListening(t, e, i) {
            const n = this[ui];
            let o = t && pi(t);
            const r = n && o && n[o],
              s = r && e && r.callbacks[e];
            if (!(!n || (t && !r) || (e && !s)))
              if (i) ki(t, e, i);
              else if (s) {
                for (; (i = s.pop()); ) ki(t, e, i);
                delete r.callbacks[e];
              } else if (r) {
                for (e in r.callbacks) this.stopListening(t, e);
                delete n[o];
              } else {
                for (o in n) this.stopListening(n[o].emitter);
                delete this[ui];
              }
          },
          fire(t, ...e) {
            try {
              const i = t instanceof ai ? t : new ai(this, t),
                n = i.name;
              let o = (function t(e, i) {
                let n;
                if (!e._events || !(n = e._events[i]) || !n.callbacks.length)
                  return i.indexOf(":") > -1
                    ? t(e, i.substr(0, i.lastIndexOf(":")))
                    : null;
                return n.callbacks;
              })(this, n);
              if ((i.path.push(this), o)) {
                const t = [i, ...e];
                o = Array.from(o);
                for (
                  let e = 0;
                  e < o.length &&
                  (o[e].callback.apply(this, t),
                  i.off.called &&
                    (delete i.off.called, ki(this, n, o[e].callback)),
                  !i.stop.called);
                  e++
                );
              }
              if (this._delegations) {
                const t = this._delegations.get(n),
                  o = this._delegations.get("*");
                t && _i(t, i, e), o && _i(o, i, e);
              }
              return i.return;
            } catch (t) {
              hi.b.rethrowUnexpectedError(t, this);
            }
          },
          delegate(...t) {
            return {
              to: (e, i) => {
                this._delegations || (this._delegations = new Map()),
                  t.forEach((t) => {
                    const n = this._delegations.get(t);
                    n
                      ? n.set(e, i)
                      : this._delegations.set(t, new Map([[e, i]]));
                  });
              },
            };
          },
          stopDelegating(t, e) {
            if (this._delegations)
              if (t)
                if (e) {
                  const i = this._delegations.get(t);
                  i && i.delete(e);
                } else this._delegations.delete(t);
              else this._delegations.clear();
          },
        };
        function fi(t, e) {
          t[mi] || (t[mi] = e || ci());
        }
        function pi(t) {
          return t[mi];
        }
        function bi(t) {
          return (
            t._events || Object.defineProperty(t, "_events", { value: {} }),
            t._events
          );
        }
        function wi(t, e) {
          const i = bi(t)[e];
          if (!i) return [];
          let n = [i.callbacks];
          for (let e = 0; e < i.childEvents.length; e++) {
            const o = wi(t, i.childEvents[e]);
            n = n.concat(o);
          }
          return n;
        }
        function _i(t, e, i) {
          for (let [n, o] of t) {
            o ? "function" == typeof o && (o = o(e.name)) : (o = e.name);
            const t = new ai(e.source, o);
            (t.path = [...e.path]), n.fire(t, ...i);
          }
        }
        function ki(t, e, i) {
          const n = wi(t, e);
          for (const t of n)
            for (let e = 0; e < t.length; e++)
              t[e].callback == i && (t.splice(e, 1), e--);
        }
        function vi(t) {
          return !(!t || !t[Symbol.iterator]);
        }
        function yi(t, ...e) {
          e.forEach((e) => {
            Object.getOwnPropertyNames(e)
              .concat(Object.getOwnPropertySymbols(e))
              .forEach((i) => {
                if (i in t.prototype) return;
                const n = Object.getOwnPropertyDescriptor(e, i);
                (n.enumerable = !1), Object.defineProperty(t.prototype, i, n);
              });
          });
        }
        class xi {
          constructor(t = {}, e = {}) {
            const i = vi(t);
            if (
              (i || (e = t),
              (this._items = []),
              (this._itemMap = new Map()),
              (this._idProperty = e.idProperty || "id"),
              (this._bindToExternalToInternalMap = new WeakMap()),
              (this._bindToInternalToExternalMap = new WeakMap()),
              (this._skippedIndexesFromExternal = []),
              i)
            )
              for (const e of t)
                this._items.push(e),
                  this._itemMap.set(this._getItemIdBeforeAdding(e), e);
          }
          get length() {
            return this._items.length;
          }
          get first() {
            return this._items[0] || null;
          }
          get last() {
            return this._items[this.length - 1] || null;
          }
          add(t, e) {
            const i = this._getItemIdBeforeAdding(t);
            if (void 0 === e) e = this._items.length;
            else if (e > this._items.length || e < 0)
              throw new hi.b("collection-add-item-invalid-index", this);
            return (
              this._items.splice(e, 0, t),
              this._itemMap.set(i, t),
              this.fire("add", t, e),
              this
            );
          }
          get(t) {
            let e;
            if ("string" == typeof t) e = this._itemMap.get(t);
            else {
              if ("number" != typeof t)
                throw new hi.b(
                  "collection-get-invalid-arg: Index or id must be given.",
                  this
                );
              e = this._items[t];
            }
            return e || null;
          }
          has(t) {
            if ("string" == typeof t) return this._itemMap.has(t);
            {
              const e = t[this._idProperty];
              return this._itemMap.has(e);
            }
          }
          getIndex(t) {
            let e;
            return (
              (e = "string" == typeof t ? this._itemMap.get(t) : t),
              this._items.indexOf(e)
            );
          }
          remove(t) {
            let e,
              i,
              n,
              o = !1;
            const r = this._idProperty;
            if (
              ("string" == typeof t
                ? ((i = t),
                  (n = this._itemMap.get(i)),
                  (o = !n),
                  n && (e = this._items.indexOf(n)))
                : "number" == typeof t
                ? ((e = t), (n = this._items[e]), (o = !n), n && (i = n[r]))
                : ((n = t),
                  (i = n[r]),
                  (e = this._items.indexOf(n)),
                  (o = -1 == e || !this._itemMap.get(i))),
              o)
            )
              throw new hi.b("collection-remove-404: Item not found.", this);
            this._items.splice(e, 1), this._itemMap.delete(i);
            const s = this._bindToInternalToExternalMap.get(n);
            return (
              this._bindToInternalToExternalMap.delete(n),
              this._bindToExternalToInternalMap.delete(s),
              this.fire("remove", n, e),
              n
            );
          }
          map(t, e) {
            return this._items.map(t, e);
          }
          find(t, e) {
            return this._items.find(t, e);
          }
          filter(t, e) {
            return this._items.filter(t, e);
          }
          clear() {
            for (
              this._bindToCollection &&
              (this.stopListening(this._bindToCollection),
              (this._bindToCollection = null));
              this.length;

            )
              this.remove(0);
          }
          bindTo(t) {
            if (this._bindToCollection)
              throw new hi.b(
                "collection-bind-to-rebind: The collection cannot be bound more than once.",
                this
              );
            return (
              (this._bindToCollection = t),
              {
                as: (t) => {
                  this._setUpBindToBinding((e) => new t(e));
                },
                using: (t) => {
                  "function" == typeof t
                    ? this._setUpBindToBinding((e) => t(e))
                    : this._setUpBindToBinding((e) => e[t]);
                },
              }
            );
          }
          _setUpBindToBinding(t) {
            const e = this._bindToCollection,
              i = (i, n, o) => {
                const r = e._bindToCollection == this,
                  s = e._bindToInternalToExternalMap.get(n);
                if (r && s)
                  this._bindToExternalToInternalMap.set(n, s),
                    this._bindToInternalToExternalMap.set(s, n);
                else {
                  const i = t(n);
                  if (!i) return void this._skippedIndexesFromExternal.push(o);
                  let r = o;
                  for (const t of this._skippedIndexesFromExternal)
                    o > t && r--;
                  for (const t of e._skippedIndexesFromExternal) r >= t && r++;
                  this._bindToExternalToInternalMap.set(n, i),
                    this._bindToInternalToExternalMap.set(i, n),
                    this.add(i, r);
                  for (let t = 0; t < e._skippedIndexesFromExternal.length; t++)
                    r <= e._skippedIndexesFromExternal[t] &&
                      e._skippedIndexesFromExternal[t]++;
                }
              };
            for (const t of e) i(0, t, e.getIndex(t));
            this.listenTo(e, "add", i),
              this.listenTo(e, "remove", (t, e, i) => {
                const n = this._bindToExternalToInternalMap.get(e);
                n && this.remove(n),
                  (this._skippedIndexesFromExternal =
                    this._skippedIndexesFromExternal.reduce(
                      (t, e) => (i < e && t.push(e - 1), i > e && t.push(e), t),
                      []
                    ));
              });
          }
          _getItemIdBeforeAdding(t) {
            const e = this._idProperty;
            let i;
            if (e in t) {
              if (((i = t[e]), "string" != typeof i))
                throw new hi.b("collection-add-invalid-id", this);
              if (this.get(i))
                throw new hi.b("collection-add-item-already-exists", this);
            } else t[e] = i = ci();
            return i;
          }
          [Symbol.iterator]() {
            return this._items[Symbol.iterator]();
          }
        }
        yi(xi, gi);
        class Ai {
          constructor(t, e = [], i = []) {
            (this._context = t),
              (this._plugins = new Map()),
              (this._availablePlugins = new Map());
            for (const t of e)
              t.pluginName && this._availablePlugins.set(t.pluginName, t);
            this._contextPlugins = new Map();
            for (const [t, e] of i)
              this._contextPlugins.set(t, e),
                this._contextPlugins.set(e, t),
                t.pluginName && this._availablePlugins.set(t.pluginName, t);
          }
          *[Symbol.iterator]() {
            for (const t of this._plugins)
              "function" == typeof t[0] && (yield t);
          }
          get(t) {
            const e = this._plugins.get(t);
            if (!e) {
              const e =
                "plugincollection-plugin-not-loaded: The requested plugin is not loaded.";
              let i = t;
              throw (
                ("function" == typeof t && (i = t.pluginName || t.name),
                new hi.b(e, this._context, { plugin: i }))
              );
            }
            return e;
          }
          has(t) {
            return this._plugins.has(t);
          }
          init(t, e = []) {
            const i = this,
              n = this._context,
              o = new Set(),
              r = [],
              s = u(t),
              a = u(e),
              l = (function (t) {
                const e = [];
                for (const i of t) h(i) || e.push(i);
                return e.length ? e : null;
              })(t);
            if (l) {
              const t =
                "plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";
              return (
                console.error(Object(hi.a)(t), { plugins: l }),
                Promise.reject(new hi.b(t, n, { plugins: l }))
              );
            }
            return Promise.all(s.map(c))
              .then(() => d(r, "init"))
              .then(() => d(r, "afterInit"))
              .then(() => r);
            function c(t) {
              if (!a.includes(t) && !i._plugins.has(t) && !o.has(t))
                return (function (t) {
                  return new Promise((s) => {
                    o.add(t),
                      t.requires &&
                        t.requires.forEach((i) => {
                          const o = h(i);
                          if (t.isContextPlugin && !o.isContextPlugin)
                            throw new hi.b(
                              "plugincollection-context-required: Context plugin can not require plugin which is not a context plugin",
                              null,
                              { plugin: o.name, requiredBy: t.name }
                            );
                          if (e.includes(o))
                            throw new hi.b(
                              "plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.",
                              n,
                              { plugin: o.name, requiredBy: t.name }
                            );
                          c(o);
                        });
                    const a = i._contextPlugins.get(t) || new t(n);
                    i._add(t, a), r.push(a), s();
                  });
                })(t).catch((e) => {
                  throw (
                    (console.error(
                      Object(hi.a)(
                        "plugincollection-load: It was not possible to load the plugin."
                      ),
                      { plugin: t }
                    ),
                    e)
                  );
                });
            }
            function d(t, e) {
              return t.reduce(
                (t, n) =>
                  n[e]
                    ? i._contextPlugins.has(n)
                      ? t
                      : t.then(n[e].bind(n))
                    : t,
                Promise.resolve()
              );
            }
            function h(t) {
              return "function" == typeof t ? t : i._availablePlugins.get(t);
            }
            function u(t) {
              return t.map((t) => h(t)).filter((t) => !!t);
            }
          }
          destroy() {
            const t = [];
            for (const [, e] of this)
              "function" != typeof e.destroy ||
                this._contextPlugins.has(e) ||
                t.push(e.destroy());
            return Promise.all(t);
          }
          _add(t, e) {
            this._plugins.set(t, e);
            const i = t.pluginName;
            if (i) {
              if (this._plugins.has(i))
                throw new hi.b(
                  "plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.",
                  null,
                  {
                    pluginName: i,
                    plugin1: this._plugins.get(i).constructor,
                    plugin2: t,
                  }
                );
              this._plugins.set(i, e);
            }
          }
        }
        function Ci(t, e, i = 1) {
          if ("number" != typeof i)
            throw new hi.b(
              "translation-service-quantity-not-a-number: Expecting `quantity` to be a number.",
              null,
              { quantity: i }
            );
          const n = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
          1 === n && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);
          const o = e.id || e.string;
          if (
            0 === n ||
            !(function (t, e) {
              return (
                !!window.CKEDITOR_TRANSLATIONS[t] &&
                !!window.CKEDITOR_TRANSLATIONS[t].dictionary[e]
              );
            })(t, o)
          )
            return 1 !== i ? e.plural : e.string;
          const r = window.CKEDITOR_TRANSLATIONS[t].dictionary,
            s =
              window.CKEDITOR_TRANSLATIONS[t].getPluralForm ||
              ((t) => (1 === t ? 0 : 1));
          if ("string" == typeof r[o]) return r[o];
          const a = Number(s(i));
          return r[o][a];
        }
        yi(Ai, gi),
          window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
        const Ti = ["ar", "fa", "he", "ku", "ug"];
        class Mi {
          constructor(t = {}) {
            (this.uiLanguage = t.uiLanguage || "en"),
              (this.contentLanguage = t.contentLanguage || this.uiLanguage),
              (this.uiLanguageDirection = Ei(this.uiLanguage)),
              (this.contentLanguageDirection = Ei(this.contentLanguage)),
              (this.t = (t, e) => this._t(t, e));
          }
          get language() {
            return (
              console.warn(
                "locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."
              ),
              this.uiLanguage
            );
          }
          _t(t, e = []) {
            Array.isArray(e) || (e = [e]),
              "string" == typeof t && (t = { string: t });
            const i = !!t.plural ? e[0] : 1;
            return (function (t, e) {
              return t.replace(/%(\d+)/g, (t, i) => (i < e.length ? e[i] : t));
            })(Ci(this.uiLanguage, t, i), e);
          }
        }
        function Ei(t) {
          return Ti.includes(t) ? "rtl" : "ltr";
        }
        class Pi {
          constructor(t) {
            this.config = new ni(t, this.constructor.defaultConfig);
            const e = this.constructor.builtinPlugins;
            this.config.define("plugins", e), (this.plugins = new Ai(this, e));
            const i = this.config.get("language") || {};
            (this.locale = new Mi({
              uiLanguage: "string" == typeof i ? i : i.ui,
              contentLanguage: this.config.get("language.content"),
            })),
              (this.t = this.locale.t),
              (this.editors = new xi()),
              (this._contextOwner = null);
          }
          initPlugins() {
            const t = this.config.get("plugins") || [];
            for (const e of t) {
              if ("function" != typeof e)
                throw new hi.b(
                  "context-initplugins-constructor-only: Only a constructor function is allowed as a context plugin.",
                  null,
                  { Plugin: e }
                );
              if (!0 !== e.isContextPlugin)
                throw new hi.b(
                  "context-initplugins-invalid-plugin: Only a plugin marked as a context plugin is allowed to be used with a context.",
                  null,
                  { Plugin: e }
                );
            }
            return this.plugins.init(t);
          }
          destroy() {
            return Promise.all(
              Array.from(this.editors, (t) => t.destroy())
            ).then(() => this.plugins.destroy());
          }
          _addEditor(t, e) {
            if (this._contextOwner)
              throw new hi.b(
                "context-addEditor-private-context: Cannot add multiple editors to the context which is created by the editor."
              );
            this.editors.add(t), e && (this._contextOwner = t);
          }
          _removeEditor(t) {
            return (
              this.editors.has(t) && this.editors.remove(t),
              this._contextOwner === t ? this.destroy() : Promise.resolve()
            );
          }
          _getEditorConfig() {
            const t = {};
            for (const e of this.config.names())
              ["plugins", "removePlugins", "extraPlugins"].includes(e) ||
                (t[e] = this.config.get(e));
            return t;
          }
          static create(t) {
            return new Promise((e) => {
              const i = new this(t);
              e(i.initPlugins().then(() => i));
            });
          }
        }
        function Si(t, e) {
          const i = Math.min(t.length, e.length);
          for (let n = 0; n < i; n++) if (t[n] != e[n]) return n;
          return t.length == e.length
            ? "same"
            : t.length < e.length
            ? "prefix"
            : "extension";
        }
        var Ii = function (t) {
          return ti(t, 4);
        };
        class Oi {
          constructor(t) {
            (this.document = t), (this.parent = null);
          }
          get index() {
            let t;
            if (!this.parent) return null;
            if (-1 == (t = this.parent.getChildIndex(this)))
              throw new hi.b(
                "view-node-not-found-in-parent: The node's parent does not contain this node.",
                this
              );
            return t;
          }
          get nextSibling() {
            const t = this.index;
            return (null !== t && this.parent.getChild(t + 1)) || null;
          }
          get previousSibling() {
            const t = this.index;
            return (null !== t && this.parent.getChild(t - 1)) || null;
          }
          get root() {
            let t = this;
            for (; t.parent; ) t = t.parent;
            return t;
          }
          isAttached() {
            return this.root.is("rootElement");
          }
          getPath() {
            const t = [];
            let e = this;
            for (; e.parent; ) t.unshift(e.index), (e = e.parent);
            return t;
          }
          getAncestors(t = { includeSelf: !1, parentFirst: !1 }) {
            const e = [];
            let i = t.includeSelf ? this : this.parent;
            for (; i; )
              e[t.parentFirst ? "push" : "unshift"](i), (i = i.parent);
            return e;
          }
          getCommonAncestor(t, e = {}) {
            const i = this.getAncestors(e),
              n = t.getAncestors(e);
            let o = 0;
            for (; i[o] == n[o] && i[o]; ) o++;
            return 0 === o ? null : i[o - 1];
          }
          isBefore(t) {
            if (this == t) return !1;
            if (this.root !== t.root) return !1;
            const e = this.getPath(),
              i = t.getPath(),
              n = Si(e, i);
            switch (n) {
              case "prefix":
                return !0;
              case "extension":
                return !1;
              default:
                return e[n] < i[n];
            }
          }
          isAfter(t) {
            return this != t && this.root === t.root && !this.isBefore(t);
          }
          _remove() {
            this.parent._removeChildren(this.index);
          }
          _fireChange(t, e) {
            this.fire("change:" + t, e),
              this.parent && this.parent._fireChange(t, e);
          }
          toJSON() {
            const t = Ii(this);
            return delete t.parent, t;
          }
          is(t) {
            return "node" === t || "view:node" === t;
          }
        }
        yi(Oi, gi);
        class Ni extends Oi {
          constructor(t, e) {
            super(t), (this._textData = e);
          }
          is(t) {
            return (
              "text" === t ||
              "view:text" === t ||
              "node" === t ||
              "view:node" === t
            );
          }
          get data() {
            return this._textData;
          }
          get _data() {
            return this.data;
          }
          set _data(t) {
            this._fireChange("text", this), (this._textData = t);
          }
          isSimilar(t) {
            return t instanceof Ni && (this === t || this.data === t.data);
          }
          _clone() {
            return new Ni(this.document, this.data);
          }
        }
        class Ri {
          constructor(t, e, i) {
            if (((this.textNode = t), e < 0 || e > t.data.length))
              throw new hi.b(
                "view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.",
                this
              );
            if (i < 0 || e + i > t.data.length)
              throw new hi.b(
                "view-textproxy-wrong-length: Given length value is incorrect.",
                this
              );
            (this.data = t.data.substring(e, e + i)), (this.offsetInText = e);
          }
          get offsetSize() {
            return this.data.length;
          }
          get isPartial() {
            return this.data.length !== this.textNode.data.length;
          }
          get parent() {
            return this.textNode.parent;
          }
          get root() {
            return this.textNode.root;
          }
          get document() {
            return this.textNode.document;
          }
          is(t) {
            return "textProxy" === t || "view:textProxy" === t;
          }
          getAncestors(t = { includeSelf: !1, parentFirst: !1 }) {
            const e = [];
            let i = t.includeSelf ? this.textNode : this.parent;
            for (; null !== i; )
              e[t.parentFirst ? "push" : "unshift"](i), (i = i.parent);
            return e;
          }
        }
        function Li(t) {
          return vi(t)
            ? new Map(t)
            : (function (t) {
                const e = new Map();
                for (const i in t) e.set(i, t[i]);
                return e;
              })(t);
        }
        class ji {
          constructor(...t) {
            (this._patterns = []), this.add(...t);
          }
          add(...t) {
            for (let e of t)
              ("string" == typeof e || e instanceof RegExp) &&
                (e = { name: e }),
                e.classes &&
                  ("string" == typeof e.classes ||
                    e.classes instanceof RegExp) &&
                  (e.classes = [e.classes]),
                this._patterns.push(e);
          }
          match(...t) {
            for (const e of t)
              for (const t of this._patterns) {
                const i = Di(e, t);
                if (i) return { element: e, pattern: t, match: i };
              }
            return null;
          }
          matchAll(...t) {
            const e = [];
            for (const i of t)
              for (const t of this._patterns) {
                const n = Di(i, t);
                n && e.push({ element: i, pattern: t, match: n });
              }
            return e.length > 0 ? e : null;
          }
          getElementName() {
            if (1 !== this._patterns.length) return null;
            const t = this._patterns[0],
              e = t.name;
            return "function" == typeof t || !e || e instanceof RegExp
              ? null
              : e;
          }
        }
        function Di(t, e) {
          if ("function" == typeof e) return e(t);
          const i = {};
          return (e.name &&
            ((i.name = (function (t, e) {
              if (t instanceof RegExp) return t.test(e);
              return t === e;
            })(e.name, t.name)),
            !i.name)) ||
            (e.attributes &&
              ((i.attributes = (function (t, e) {
                const i = [];
                for (const n in t) {
                  const o = t[n];
                  if (!e.hasAttribute(n)) return null;
                  {
                    const t = e.getAttribute(n);
                    if (!0 === o) i.push(n);
                    else if (o instanceof RegExp) {
                      if (!o.test(t)) return null;
                      i.push(n);
                    } else {
                      if (t !== o) return null;
                      i.push(n);
                    }
                  }
                }
                return i;
              })(e.attributes, t)),
              !i.attributes))
            ? null
            : !(
                e.classes &&
                ((i.classes = (function (t, e) {
                  const i = [];
                  for (const n of t)
                    if (n instanceof RegExp) {
                      const t = e.getClassNames();
                      for (const e of t) n.test(e) && i.push(e);
                      if (0 === i.length) return null;
                    } else {
                      if (!e.hasClass(n)) return null;
                      i.push(n);
                    }
                  return i;
                })(e.classes, t)),
                !i.classes)
              ) &&
                !(
                  e.styles &&
                  ((i.styles = (function (t, e) {
                    const i = [];
                    for (const n in t) {
                      const o = t[n];
                      if (!e.hasStyle(n)) return null;
                      {
                        const t = e.getStyle(n);
                        if (o instanceof RegExp) {
                          if (!o.test(t)) return null;
                          i.push(n);
                        } else {
                          if (t !== o) return null;
                          i.push(n);
                        }
                      }
                    }
                    return i;
                  })(e.styles, t)),
                  !i.styles)
                ) &&
                i;
        }
        var zi = function (t) {
            return "symbol" == typeof t || (p(t) && "[object Symbol]" == m(t));
          },
          Bi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          Vi = /^\w*$/;
        var Fi = function (t, e) {
          if (Lt(t)) return !1;
          var i = typeof t;
          return (
            !(
              "number" != i &&
              "symbol" != i &&
              "boolean" != i &&
              null != t &&
              !zi(t)
            ) ||
            Vi.test(t) ||
            !Bi.test(t) ||
            (null != e && t in Object(e))
          );
        };
        function Hi(t, e) {
          if ("function" != typeof t || (null != e && "function" != typeof e))
            throw new TypeError("Expected a function");
          var i = function () {
            var n = arguments,
              o = e ? e.apply(this, n) : n[0],
              r = i.cache;
            if (r.has(o)) return r.get(o);
            var s = t.apply(this, n);
            return (i.cache = r.set(o, s) || r), s;
          };
          return (i.cache = new (Hi.Cache || _t)()), i;
        }
        Hi.Cache = _t;
        var Ui = Hi;
        var Wi =
            /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          qi = /\\(\\)?/g,
          Yi = (function (t) {
            var e = Ui(t, function (t) {
                return 500 === i.size && i.clear(), t;
              }),
              i = e.cache;
            return e;
          })(function (t) {
            var e = [];
            return (
              46 === t.charCodeAt(0) && e.push(""),
              t.replace(Wi, function (t, i, n, o) {
                e.push(n ? o.replace(qi, "$1") : i || t);
              }),
              e
            );
          });
        var $i = function (t, e) {
            for (
              var i = -1, n = null == t ? 0 : t.length, o = Array(n);
              ++i < n;

            )
              o[i] = e(t[i], i, t);
            return o;
          },
          Ji = o ? o.prototype : void 0,
          Gi = Ji ? Ji.toString : void 0;
        var Qi = function t(e) {
          if ("string" == typeof e) return e;
          if (Lt(e)) return $i(e, t) + "";
          if (zi(e)) return Gi ? Gi.call(e) : "";
          var i = e + "";
          return "0" == i && 1 / e == -1 / 0 ? "-0" : i;
        };
        var Xi = function (t) {
          return null == t ? "" : Qi(t);
        };
        var Ki = function (t, e) {
          return Lt(t) ? t : Fi(t, e) ? [t] : Yi(Xi(t));
        };
        var Zi = function (t) {
          var e = null == t ? 0 : t.length;
          return e ? t[e - 1] : void 0;
        };
        var tn = function (t) {
          if ("string" == typeof t || zi(t)) return t;
          var e = t + "";
          return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
        };
        var en = function (t, e) {
          for (var i = 0, n = (e = Ki(e, t)).length; null != t && i < n; )
            t = t[tn(e[i++])];
          return i && i == n ? t : void 0;
        };
        var nn = function (t, e, i) {
          var n = -1,
            o = t.length;
          e < 0 && (e = -e > o ? 0 : o + e),
            (i = i > o ? o : i) < 0 && (i += o),
            (o = e > i ? 0 : (i - e) >>> 0),
            (e >>>= 0);
          for (var r = Array(o); ++n < o; ) r[n] = t[n + e];
          return r;
        };
        var on = function (t, e) {
          return e.length < 2 ? t : en(t, nn(e, 0, -1));
        };
        var rn = function (t, e) {
          return (e = Ki(e, t)), null == (t = on(t, e)) || delete t[tn(Zi(e))];
        };
        var sn = function (t, e) {
          return null == t || rn(t, e);
        };
        var an = function (t, e, i) {
          var n = null == t ? void 0 : en(t, e);
          return void 0 === n ? i : n;
        };
        var ln = function (t, e, i) {
          ((void 0 !== i && !A(t[e], i)) || (void 0 === i && !(e in t))) &&
            Ct(t, e, i);
        };
        var cn = (function (t) {
          return function (e, i, n) {
            for (var o = -1, r = Object(e), s = n(e), a = s.length; a--; ) {
              var l = s[t ? a : ++o];
              if (!1 === i(r[l], l, r)) break;
            }
            return e;
          };
        })();
        var dn = function (t) {
          return p(t) && Zt(t);
        };
        var hn = function (t, e) {
          if (
            ("constructor" !== e || "function" != typeof t[e]) &&
            "__proto__" != e
          )
            return t[e];
        };
        var un = function (t) {
          return Et(t, re(t));
        };
        var mn = function (t, e, i, n, o, r, s) {
          var a = hn(t, i),
            l = hn(e, i),
            c = s.get(l);
          if (c) ln(t, i, c);
          else {
            var d = r ? r(a, l, i + "", t, e, s) : void 0,
              h = void 0 === d;
            if (h) {
              var u = Lt(l),
                m = !u && Object(jt.a)(l),
                g = !u && !m && qt(l);
              (d = l),
                u || m || g
                  ? Lt(a)
                    ? (d = a)
                    : dn(a)
                    ? (d = le(a))
                    : m
                    ? ((h = !1), (d = Object(ae.a)(l, !0)))
                    : g
                    ? ((h = !1), (d = He(l, !0)))
                    : (d = [])
                  : y(l) || Rt(l)
                  ? ((d = a),
                    Rt(a) ? (d = un(a)) : (D(a) && !B(a)) || (d = Ye(l)))
                  : (h = !1);
            }
            h && (s.set(l, d), o(d, l, n, r, s), s.delete(l)), ln(t, i, d);
          }
        };
        var gn = function t(e, i, n, o, r) {
          e !== i &&
            cn(
              i,
              function (s, a) {
                if ((r || (r = new yt()), D(s))) mn(e, i, a, n, t, o, r);
                else {
                  var l = o ? o(hn(e, a), s, a + "", e, i, r) : void 0;
                  void 0 === l && (l = s), ln(e, a, l);
                }
              },
              re
            );
        };
        var fn = function (t) {
          return t;
        };
        var pn = function (t, e, i) {
            switch (i.length) {
              case 0:
                return t.call(e);
              case 1:
                return t.call(e, i[0]);
              case 2:
                return t.call(e, i[0], i[1]);
              case 3:
                return t.call(e, i[0], i[1], i[2]);
            }
            return t.apply(e, i);
          },
          bn = Math.max;
        var wn = function (t, e, i) {
          return (
            (e = bn(void 0 === e ? t.length - 1 : e, 0)),
            function () {
              for (
                var n = arguments,
                  o = -1,
                  r = bn(n.length - e, 0),
                  s = Array(r);
                ++o < r;

              )
                s[o] = n[e + o];
              o = -1;
              for (var a = Array(e + 1); ++o < e; ) a[o] = n[o];
              return (a[e] = i(s)), pn(t, this, a);
            }
          );
        };
        var _n = function (t) {
            return function () {
              return t;
            };
          },
          kn = At
            ? function (t, e) {
                return At(t, "toString", {
                  configurable: !0,
                  enumerable: !1,
                  value: _n(e),
                  writable: !0,
                });
              }
            : fn,
          vn = Date.now;
        var yn = (function (t) {
          var e = 0,
            i = 0;
          return function () {
            var n = vn(),
              o = 16 - (n - i);
            if (((i = n), o > 0)) {
              if (++e >= 800) return arguments[0];
            } else e = 0;
            return t.apply(void 0, arguments);
          };
        })(kn);
        var xn = function (t, e) {
          return yn(wn(t, e, fn), t + "");
        };
        var An = function (t, e, i) {
          if (!D(i)) return !1;
          var n = typeof e;
          return (
            !!("number" == n
              ? Zt(i) && zt(e, i.length)
              : "string" == n && e in i) && A(i[e], t)
          );
        };
        var Cn = function (t) {
            return xn(function (e, i) {
              var n = -1,
                o = i.length,
                r = o > 1 ? i[o - 1] : void 0,
                s = o > 2 ? i[2] : void 0;
              for (
                r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0,
                  s && An(i[0], i[1], s) && ((r = o < 3 ? void 0 : r), (o = 1)),
                  e = Object(e);
                ++n < o;

              ) {
                var a = i[n];
                a && t(e, a, n, r);
              }
              return e;
            });
          },
          Tn = Cn(function (t, e, i) {
            gn(t, e, i);
          });
        var Mn = function (t, e, i, n) {
          if (!D(t)) return t;
          for (
            var o = -1, r = (e = Ki(e, t)).length, s = r - 1, a = t;
            null != a && ++o < r;

          ) {
            var l = tn(e[o]),
              c = i;
            if (o != s) {
              var d = a[l];
              void 0 === (c = n ? n(d, l, a) : void 0) &&
                (c = D(d) ? d : zt(e[o + 1]) ? [] : {});
            }
            Mt(a, l, c), (a = a[l]);
          }
          return t;
        };
        var En = function (t, e, i) {
          return null == t ? t : Mn(t, e, i);
        };
        class Pn {
          constructor(t) {
            (this._styles = {}), (this._styleProcessor = t);
          }
          get isEmpty() {
            const t = Object.entries(this._styles);
            return !Array.from(t).length;
          }
          get size() {
            return this.isEmpty ? 0 : this.getStyleNames().length;
          }
          setTo(t) {
            this.clear();
            const e = Array.from(
              (function (t) {
                let e = null,
                  i = 0,
                  n = 0,
                  o = null;
                const r = new Map();
                if ("" === t) return r;
                ";" != t.charAt(t.length - 1) && (t += ";");
                for (let s = 0; s < t.length; s++) {
                  const a = t.charAt(s);
                  if (null === e)
                    switch (a) {
                      case ":":
                        o || ((o = t.substr(i, s - i)), (n = s + 1));
                        break;
                      case '"':
                      case "'":
                        e = a;
                        break;
                      case ";": {
                        const e = t.substr(n, s - n);
                        o && r.set(o.trim(), e.trim()), (o = null), (i = s + 1);
                        break;
                      }
                    }
                  else a === e && (e = null);
                }
                return r;
              })(t).entries()
            );
            for (const [t, i] of e)
              this._styleProcessor.toNormalizedForm(t, i, this._styles);
          }
          has(t) {
            if (this.isEmpty) return !1;
            const e = this._styleProcessor
              .getReducedForm(t, this._styles)
              .find(([e]) => e === t);
            return Array.isArray(e);
          }
          set(t, e) {
            if (D(t))
              for (const [e, i] of Object.entries(t))
                this._styleProcessor.toNormalizedForm(e, i, this._styles);
            else this._styleProcessor.toNormalizedForm(t, e, this._styles);
          }
          remove(t) {
            const e = In(t);
            sn(this._styles, e),
              delete this._styles[t],
              this._cleanEmptyObjectsOnPath(e);
          }
          getNormalized(t) {
            return this._styleProcessor.getNormalized(t, this._styles);
          }
          toString() {
            return this.isEmpty
              ? ""
              : this._getStylesEntries()
                  .map((t) => t.join(":"))
                  .sort()
                  .join(";") + ";";
          }
          getAsString(t) {
            if (this.isEmpty) return;
            if (this._styles[t] && !D(this._styles[t])) return this._styles[t];
            const e = this._styleProcessor
              .getReducedForm(t, this._styles)
              .find(([e]) => e === t);
            return Array.isArray(e) ? e[1] : void 0;
          }
          getStyleNames() {
            if (this.isEmpty) return [];
            return this._getStylesEntries().map(([t]) => t);
          }
          clear() {
            this._styles = {};
          }
          _getStylesEntries() {
            const t = [],
              e = Object.keys(this._styles);
            for (const i of e)
              t.push(...this._styleProcessor.getReducedForm(i, this._styles));
            return t;
          }
          _cleanEmptyObjectsOnPath(t) {
            const e = t.split(".");
            if (!(e.length > 1)) return;
            const i = e.splice(0, e.length - 1).join("."),
              n = an(this._styles, i);
            n && !Array.from(Object.keys(n)).length && this.remove(i);
          }
        }
        class Sn {
          constructor() {
            (this._normalizers = new Map()),
              (this._extractors = new Map()),
              (this._reducers = new Map()),
              (this._consumables = new Map());
          }
          toNormalizedForm(t, e, i) {
            if (D(e)) On(i, In(t), e);
            else if (this._normalizers.has(t)) {
              const n = this._normalizers.get(t),
                { path: o, value: r } = n(e);
              On(i, o, r);
            } else On(i, t, e);
          }
          getNormalized(t, e) {
            if (!t) return Tn({}, e);
            if (void 0 !== e[t]) return e[t];
            if (this._extractors.has(t)) {
              const i = this._extractors.get(t);
              if ("string" == typeof i) return an(e, i);
              const n = i(t, e);
              if (n) return n;
            }
            return an(e, In(t));
          }
          getReducedForm(t, e) {
            const i = this.getNormalized(t, e);
            if (void 0 === i) return [];
            if (this._reducers.has(t)) {
              return this._reducers.get(t)(i);
            }
            return [[t, i]];
          }
          getRelatedStyles(t) {
            return this._consumables.get(t) || [];
          }
          setNormalizer(t, e) {
            this._normalizers.set(t, e);
          }
          setExtractor(t, e) {
            this._extractors.set(t, e);
          }
          setReducer(t, e) {
            this._reducers.set(t, e);
          }
          setStyleRelation(t, e) {
            this._mapStyleNames(t, e);
            for (const i of e) this._mapStyleNames(i, [t]);
          }
          _mapStyleNames(t, e) {
            this._consumables.has(t) || this._consumables.set(t, []),
              this._consumables.get(t).push(...e);
          }
        }
        function In(t) {
          return t.replace("-", ".");
        }
        function On(t, e, i) {
          let n = i;
          D(i) && (n = Tn({}, an(t, e), i)), En(t, e, n);
        }
        class Nn extends Oi {
          constructor(t, e, i, n) {
            if (
              (super(t),
              (this.name = e),
              (this._attrs = (function (t) {
                t = Li(t);
                for (const [e, i] of t)
                  null === i
                    ? t.delete(e)
                    : "string" != typeof i && t.set(e, String(i));
                return t;
              })(i)),
              (this._children = []),
              n && this._insertChild(0, n),
              (this._classes = new Set()),
              this._attrs.has("class"))
            ) {
              const t = this._attrs.get("class");
              Rn(this._classes, t), this._attrs.delete("class");
            }
            (this._styles = new Pn(this.document.stylesProcessor)),
              this._attrs.has("style") &&
                (this._styles.setTo(this._attrs.get("style")),
                this._attrs.delete("style")),
              (this._customProperties = new Map());
          }
          get childCount() {
            return this._children.length;
          }
          get isEmpty() {
            return 0 === this._children.length;
          }
          is(t, e = null) {
            return e
              ? e === this.name && ("element" === t || "view:element" === t)
              : t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          getChild(t) {
            return this._children[t];
          }
          getChildIndex(t) {
            return this._children.indexOf(t);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          *getAttributeKeys() {
            this._classes.size > 0 && (yield "class"),
              this._styles.isEmpty || (yield "style"),
              yield* this._attrs.keys();
          }
          *getAttributes() {
            yield* this._attrs.entries(),
              this._classes.size > 0 &&
                (yield ["class", this.getAttribute("class")]),
              this._styles.isEmpty ||
                (yield ["style", this.getAttribute("style")]);
          }
          getAttribute(t) {
            if ("class" == t)
              return this._classes.size > 0
                ? [...this._classes].join(" ")
                : void 0;
            if ("style" == t) {
              const t = this._styles.toString();
              return "" == t ? void 0 : t;
            }
            return this._attrs.get(t);
          }
          hasAttribute(t) {
            return "class" == t
              ? this._classes.size > 0
              : "style" == t
              ? !this._styles.isEmpty
              : this._attrs.has(t);
          }
          isSimilar(t) {
            if (!(t instanceof Nn)) return !1;
            if (this === t) return !0;
            if (this.name != t.name) return !1;
            if (
              this._attrs.size !== t._attrs.size ||
              this._classes.size !== t._classes.size ||
              this._styles.size !== t._styles.size
            )
              return !1;
            for (const [e, i] of this._attrs)
              if (!t._attrs.has(e) || t._attrs.get(e) !== i) return !1;
            for (const e of this._classes) if (!t._classes.has(e)) return !1;
            for (const e of this._styles.getStyleNames())
              if (
                !t._styles.has(e) ||
                t._styles.getAsString(e) !== this._styles.getAsString(e)
              )
                return !1;
            return !0;
          }
          hasClass(...t) {
            for (const e of t) if (!this._classes.has(e)) return !1;
            return !0;
          }
          getClassNames() {
            return this._classes.keys();
          }
          getStyle(t) {
            return this._styles.getAsString(t);
          }
          getNormalizedStyle(t) {
            return this._styles.getNormalized(t);
          }
          getStyleNames() {
            return this._styles.getStyleNames();
          }
          hasStyle(...t) {
            for (const e of t) if (!this._styles.has(e)) return !1;
            return !0;
          }
          findAncestor(...t) {
            const e = new ji(...t);
            let i = this.parent;
            for (; i; ) {
              if (e.match(i)) return i;
              i = i.parent;
            }
            return null;
          }
          getCustomProperty(t) {
            return this._customProperties.get(t);
          }
          *getCustomProperties() {
            yield* this._customProperties.entries();
          }
          getIdentity() {
            const t = Array.from(this._classes).sort().join(","),
              e = this._styles.toString(),
              i = Array.from(this._attrs)
                .map((t) => `${t[0]}="${t[1]}"`)
                .sort()
                .join(" ");
            return (
              this.name +
              ("" == t ? "" : ` class="${t}"`) +
              (e ? ` style="${e}"` : "") +
              ("" == i ? "" : " " + i)
            );
          }
          _clone(t = !1) {
            const e = [];
            if (t) for (const i of this.getChildren()) e.push(i._clone(t));
            const i = new this.constructor(
              this.document,
              this.name,
              this._attrs,
              e
            );
            return (
              (i._classes = new Set(this._classes)),
              i._styles.set(this._styles.getNormalized()),
              (i._customProperties = new Map(this._customProperties)),
              (i.getFillerOffset = this.getFillerOffset),
              i
            );
          }
          _appendChild(t) {
            return this._insertChild(this.childCount, t);
          }
          _insertChild(t, e) {
            this._fireChange("children", this);
            let i = 0;
            const n = (function (t, e) {
              if ("string" == typeof e) return [new Ni(t, e)];
              vi(e) || (e = [e]);
              return Array.from(e).map((e) =>
                "string" == typeof e
                  ? new Ni(t, e)
                  : e instanceof Ri
                  ? new Ni(t, e.data)
                  : e
              );
            })(this.document, e);
            for (const e of n)
              null !== e.parent && e._remove(),
                (e.parent = this),
                (e.document = this.document),
                this._children.splice(t, 0, e),
                t++,
                i++;
            return i;
          }
          _removeChildren(t, e = 1) {
            this._fireChange("children", this);
            for (let i = t; i < t + e; i++) this._children[i].parent = null;
            return this._children.splice(t, e);
          }
          _setAttribute(t, e) {
            (e = String(e)),
              this._fireChange("attributes", this),
              "class" == t
                ? Rn(this._classes, e)
                : "style" == t
                ? this._styles.setTo(e)
                : this._attrs.set(t, e);
          }
          _removeAttribute(t) {
            return (
              this._fireChange("attributes", this),
              "class" == t
                ? this._classes.size > 0 && (this._classes.clear(), !0)
                : "style" == t
                ? !this._styles.isEmpty && (this._styles.clear(), !0)
                : this._attrs.delete(t)
            );
          }
          _addClass(t) {
            this._fireChange("attributes", this),
              (t = Array.isArray(t) ? t : [t]).forEach((t) =>
                this._classes.add(t)
              );
          }
          _removeClass(t) {
            this._fireChange("attributes", this),
              (t = Array.isArray(t) ? t : [t]).forEach((t) =>
                this._classes.delete(t)
              );
          }
          _setStyle(t, e) {
            this._fireChange("attributes", this), this._styles.set(t, e);
          }
          _removeStyle(t) {
            this._fireChange("attributes", this),
              (t = Array.isArray(t) ? t : [t]).forEach((t) =>
                this._styles.remove(t)
              );
          }
          _setCustomProperty(t, e) {
            this._customProperties.set(t, e);
          }
          _removeCustomProperty(t) {
            return this._customProperties.delete(t);
          }
        }
        function Rn(t, e) {
          const i = e.split(/\s+/);
          t.clear(), i.forEach((e) => t.add(e));
        }
        class Ln extends Nn {
          constructor(t, e, i, n) {
            super(t, e, i, n), (this.getFillerOffset = jn);
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "containerElement" === t ||
                  "view:containerElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
        }
        function jn() {
          const t = [...this.getChildren()],
            e = t[this.childCount - 1];
          if (e && e.is("element", "br")) return this.childCount;
          for (const e of t) if (!e.is("uiElement")) return null;
          return this.childCount;
        }
        var Dn = Cn(function (t, e) {
          Et(e, re(e), t);
        });
        const zn = Symbol("observableProperties"),
          Bn = Symbol("boundObservables"),
          Vn = Symbol("boundProperties"),
          Fn = {
            set(t, e) {
              if (D(t))
                return void Object.keys(t).forEach((e) => {
                  this.set(e, t[e]);
                }, this);
              Un(this);
              const i = this[zn];
              if (t in this && !i.has(t))
                throw new hi.b(
                  "observable-set-cannot-override: Cannot override an existing property.",
                  this
                );
              Object.defineProperty(this, t, {
                enumerable: !0,
                configurable: !0,
                get: () => i.get(t),
                set(e) {
                  const n = i.get(t);
                  let o = this.fire("set:" + t, t, e, n);
                  void 0 === o && (o = e),
                    (n === o && i.has(t)) ||
                      (i.set(t, o), this.fire("change:" + t, t, o, n));
                },
              }),
                (this[t] = e);
            },
            bind(...t) {
              if (!t.length || !Yn(t))
                throw new hi.b(
                  "observable-bind-wrong-properties: All properties must be strings.",
                  this
                );
              if (new Set(t).size !== t.length)
                throw new hi.b(
                  "observable-bind-duplicate-properties: Properties must be unique.",
                  this
                );
              Un(this);
              const e = this[Vn];
              t.forEach((t) => {
                if (e.has(t))
                  throw new hi.b(
                    "observable-bind-rebind: Cannot bind the same property more than once.",
                    this
                  );
              });
              const i = new Map();
              return (
                t.forEach((t) => {
                  const n = { property: t, to: [] };
                  e.set(t, n), i.set(t, n);
                }),
                {
                  to: Wn,
                  toMany: qn,
                  _observable: this,
                  _bindProperties: t,
                  _to: [],
                  _bindings: i,
                }
              );
            },
            unbind(...t) {
              if (!this[zn]) return;
              const e = this[Vn],
                i = this[Bn];
              if (t.length) {
                if (!Yn(t))
                  throw new hi.b(
                    "observable-unbind-wrong-properties: Properties must be strings.",
                    this
                  );
                t.forEach((t) => {
                  const n = e.get(t);
                  if (!n) return;
                  let o, r, s, a;
                  n.to.forEach((t) => {
                    (o = t[0]),
                      (r = t[1]),
                      (s = i.get(o)),
                      (a = s[r]),
                      a.delete(n),
                      a.size || delete s[r],
                      Object.keys(s).length ||
                        (i.delete(o), this.stopListening(o, "change"));
                  }),
                    e.delete(t);
                });
              } else
                i.forEach((t, e) => {
                  this.stopListening(e, "change");
                }),
                  i.clear(),
                  e.clear();
            },
            decorate(t) {
              const e = this[t];
              if (!e)
                throw new hi.b(
                  "observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.",
                  this,
                  { object: this, methodName: t }
                );
              this.on(t, (t, i) => {
                t.return = e.apply(this, i);
              }),
                (this[t] = function (...e) {
                  return this.fire(t, e);
                });
            },
          };
        Dn(Fn, gi);
        var Hn = Fn;
        function Un(t) {
          t[zn] ||
            (Object.defineProperty(t, zn, { value: new Map() }),
            Object.defineProperty(t, Bn, { value: new Map() }),
            Object.defineProperty(t, Vn, { value: new Map() }));
        }
        function Wn(...t) {
          const e = (function (...t) {
              if (!t.length)
                throw new hi.b(
                  "observable-bind-to-parse-error: Invalid argument syntax in `to()`.",
                  null
                );
              const e = { to: [] };
              let i;
              "function" == typeof t[t.length - 1] && (e.callback = t.pop());
              return (
                t.forEach((t) => {
                  if ("string" == typeof t) i.properties.push(t);
                  else {
                    if ("object" != typeof t)
                      throw new hi.b(
                        "observable-bind-to-parse-error: Invalid argument syntax in `to()`.",
                        null
                      );
                    (i = { observable: t, properties: [] }), e.to.push(i);
                  }
                }),
                e
              );
            })(...t),
            i = Array.from(this._bindings.keys()),
            n = i.length;
          if (!e.callback && e.to.length > 1)
            throw new hi.b(
              "observable-bind-to-no-callback: Binding multiple observables only possible with callback.",
              this
            );
          if (n > 1 && e.callback)
            throw new hi.b(
              "observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.",
              this
            );
          var o;
          e.to.forEach((t) => {
            if (t.properties.length && t.properties.length !== n)
              throw new hi.b(
                "observable-bind-to-properties-length: The number of properties must match.",
                this
              );
            t.properties.length || (t.properties = this._bindProperties);
          }),
            (this._to = e.to),
            e.callback && (this._bindings.get(i[0]).callback = e.callback),
            (o = this._observable),
            this._to.forEach((t) => {
              const e = o[Bn];
              let i;
              e.get(t.observable) ||
                o.listenTo(t.observable, "change", (n, r) => {
                  (i = e.get(t.observable)[r]),
                    i &&
                      i.forEach((t) => {
                        $n(o, t.property);
                      });
                });
            }),
            (function (t) {
              let e;
              t._bindings.forEach((i, n) => {
                t._to.forEach((o) => {
                  (e =
                    o.properties[
                      i.callback ? 0 : t._bindProperties.indexOf(n)
                    ]),
                    i.to.push([o.observable, e]),
                    (function (t, e, i, n) {
                      const o = t[Bn],
                        r = o.get(i),
                        s = r || {};
                      s[n] || (s[n] = new Set());
                      s[n].add(e), r || o.set(i, s);
                    })(t._observable, i, o.observable, e);
                });
              });
            })(this),
            this._bindProperties.forEach((t) => {
              $n(this._observable, t);
            });
        }
        function qn(t, e, i) {
          if (this._bindings.size > 1)
            throw new hi.b(
              "observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().",
              this
            );
          this.to(
            ...(function (t, e) {
              const i = t.map((t) => [t, e]);
              return Array.prototype.concat.apply([], i);
            })(t, e),
            i
          );
        }
        function Yn(t) {
          return t.every((t) => "string" == typeof t);
        }
        function $n(t, e) {
          const i = t[Vn].get(e);
          let n;
          i.callback
            ? (n = i.callback.apply(
                t,
                i.to.map((t) => t[0][t[1]])
              ))
            : ((n = i.to[0]), (n = n[0][n[1]])),
            t.hasOwnProperty(e) ? (t[e] = n) : t.set(e, n);
        }
        class Jn extends Ln {
          constructor(t, e, i, n) {
            super(t, e, i, n),
              this.set("isReadOnly", !1),
              this.set("isFocused", !1),
              this.bind("isReadOnly").to(t),
              this.bind("isFocused").to(
                t,
                "isFocused",
                (e) => e && t.selection.editableElement == this
              ),
              this.listenTo(t.selection, "change", () => {
                this.isFocused =
                  t.isFocused && t.selection.editableElement == this;
              });
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("editableElement" === t ||
                    "view:editableElement" === t ||
                    "containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "editableElement" === t ||
                  "view:editableElement" === t ||
                  "containerElement" === t ||
                  "view:containerElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          destroy() {
            this.stopListening();
          }
        }
        yi(Jn, Hn);
        const Gn = Symbol("rootName");
        class Qn extends Jn {
          constructor(t, e) {
            super(t, e), (this.rootName = "main");
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("rootElement" === t ||
                    "view:rootElement" === t ||
                    "editableElement" === t ||
                    "view:editableElement" === t ||
                    "containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "rootElement" === t ||
                  "view:rootElement" === t ||
                  "editableElement" === t ||
                  "view:editableElement" === t ||
                  "containerElement" === t ||
                  "view:containerElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          get rootName() {
            return this.getCustomProperty(Gn);
          }
          set rootName(t) {
            this._setCustomProperty(Gn, t);
          }
          set _name(t) {
            this.name = t;
          }
        }
        class Xn {
          constructor(t = {}) {
            if (!t.boundaries && !t.startPosition)
              throw new hi.b(
                "view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.",
                null
              );
            if (
              t.direction &&
              "forward" != t.direction &&
              "backward" != t.direction
            )
              throw new hi.b(
                "view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.",
                t.startPosition,
                { direction: t.direction }
              );
            (this.boundaries = t.boundaries || null),
              t.startPosition
                ? (this.position = Kn._createAt(t.startPosition))
                : (this.position = Kn._createAt(
                    t.boundaries["backward" == t.direction ? "end" : "start"]
                  )),
              (this.direction = t.direction || "forward"),
              (this.singleCharacters = !!t.singleCharacters),
              (this.shallow = !!t.shallow),
              (this.ignoreElementEnd = !!t.ignoreElementEnd),
              (this._boundaryStartParent = this.boundaries
                ? this.boundaries.start.parent
                : null),
              (this._boundaryEndParent = this.boundaries
                ? this.boundaries.end.parent
                : null);
          }
          [Symbol.iterator]() {
            return this;
          }
          skip(t) {
            let e, i, n;
            do {
              (n = this.position), ({ done: e, value: i } = this.next());
            } while (!e && t(i));
            e || (this.position = n);
          }
          next() {
            return "forward" == this.direction
              ? this._next()
              : this._previous();
          }
          _next() {
            let t = this.position.clone();
            const e = this.position,
              i = t.parent;
            if (null === i.parent && t.offset === i.childCount)
              return { done: !0 };
            if (
              i === this._boundaryEndParent &&
              t.offset == this.boundaries.end.offset
            )
              return { done: !0 };
            let n;
            if (i instanceof Ni) {
              if (t.isAtEnd)
                return (this.position = Kn._createAfter(i)), this._next();
              n = i.data[t.offset];
            } else n = i.getChild(t.offset);
            if (n instanceof Nn)
              return (
                this.shallow ? t.offset++ : (t = new Kn(n, 0)),
                (this.position = t),
                this._formatReturnValue("elementStart", n, e, t, 1)
              );
            if (n instanceof Ni) {
              if (this.singleCharacters)
                return (t = new Kn(n, 0)), (this.position = t), this._next();
              {
                let i,
                  o = n.data.length;
                return (
                  n == this._boundaryEndParent
                    ? ((o = this.boundaries.end.offset),
                      (i = new Ri(n, 0, o)),
                      (t = Kn._createAfter(i)))
                    : ((i = new Ri(n, 0, n.data.length)), t.offset++),
                  (this.position = t),
                  this._formatReturnValue("text", i, e, t, o)
                );
              }
            }
            if ("string" == typeof n) {
              let n;
              if (this.singleCharacters) n = 1;
              else {
                n =
                  (i === this._boundaryEndParent
                    ? this.boundaries.end.offset
                    : i.data.length) - t.offset;
              }
              const o = new Ri(i, t.offset, n);
              return (
                (t.offset += n),
                (this.position = t),
                this._formatReturnValue("text", o, e, t, n)
              );
            }
            return (
              (t = Kn._createAfter(i)),
              (this.position = t),
              this.ignoreElementEnd
                ? this._next()
                : this._formatReturnValue("elementEnd", i, e, t)
            );
          }
          _previous() {
            let t = this.position.clone();
            const e = this.position,
              i = t.parent;
            if (null === i.parent && 0 === t.offset) return { done: !0 };
            if (
              i == this._boundaryStartParent &&
              t.offset == this.boundaries.start.offset
            )
              return { done: !0 };
            let n;
            if (i instanceof Ni) {
              if (t.isAtStart)
                return (this.position = Kn._createBefore(i)), this._previous();
              n = i.data[t.offset - 1];
            } else n = i.getChild(t.offset - 1);
            if (n instanceof Nn)
              return this.shallow
                ? (t.offset--,
                  (this.position = t),
                  this._formatReturnValue("elementStart", n, e, t, 1))
                : ((t = new Kn(n, n.childCount)),
                  (this.position = t),
                  this.ignoreElementEnd
                    ? this._previous()
                    : this._formatReturnValue("elementEnd", n, e, t));
            if (n instanceof Ni) {
              if (this.singleCharacters)
                return (
                  (t = new Kn(n, n.data.length)),
                  (this.position = t),
                  this._previous()
                );
              {
                let i,
                  o = n.data.length;
                if (n == this._boundaryStartParent) {
                  const e = this.boundaries.start.offset;
                  (i = new Ri(n, e, n.data.length - e)),
                    (o = i.data.length),
                    (t = Kn._createBefore(i));
                } else (i = new Ri(n, 0, n.data.length)), t.offset--;
                return (
                  (this.position = t),
                  this._formatReturnValue("text", i, e, t, o)
                );
              }
            }
            if ("string" == typeof n) {
              let n;
              if (this.singleCharacters) n = 1;
              else {
                const e =
                  i === this._boundaryStartParent
                    ? this.boundaries.start.offset
                    : 0;
                n = t.offset - e;
              }
              t.offset -= n;
              const o = new Ri(i, t.offset, n);
              return (
                (this.position = t), this._formatReturnValue("text", o, e, t, n)
              );
            }
            return (
              (t = Kn._createBefore(i)),
              (this.position = t),
              this._formatReturnValue("elementStart", i, e, t, 1)
            );
          }
          _formatReturnValue(t, e, i, n, o) {
            return (
              e instanceof Ri &&
                (e.offsetInText + e.data.length == e.textNode.data.length &&
                  ("forward" != this.direction ||
                  (this.boundaries &&
                    this.boundaries.end.isEqual(this.position))
                    ? (i = Kn._createAfter(e.textNode))
                    : ((n = Kn._createAfter(e.textNode)), (this.position = n))),
                0 === e.offsetInText &&
                  ("backward" != this.direction ||
                  (this.boundaries &&
                    this.boundaries.start.isEqual(this.position))
                    ? (i = Kn._createBefore(e.textNode))
                    : ((n = Kn._createBefore(e.textNode)),
                      (this.position = n)))),
              {
                done: !1,
                value: {
                  type: t,
                  item: e,
                  previousPosition: i,
                  nextPosition: n,
                  length: o,
                },
              }
            );
          }
        }
        class Kn {
          constructor(t, e) {
            (this.parent = t), (this.offset = e);
          }
          get nodeAfter() {
            return this.parent.is("text")
              ? null
              : this.parent.getChild(this.offset) || null;
          }
          get nodeBefore() {
            return this.parent.is("text")
              ? null
              : this.parent.getChild(this.offset - 1) || null;
          }
          get isAtStart() {
            return 0 === this.offset;
          }
          get isAtEnd() {
            const t = this.parent.is("text")
              ? this.parent.data.length
              : this.parent.childCount;
            return this.offset === t;
          }
          get root() {
            return this.parent.root;
          }
          get editableElement() {
            let t = this.parent;
            for (; !(t instanceof Jn); ) {
              if (!t.parent) return null;
              t = t.parent;
            }
            return t;
          }
          getShiftedBy(t) {
            const e = Kn._createAt(this),
              i = e.offset + t;
            return (e.offset = i < 0 ? 0 : i), e;
          }
          getLastMatchingPosition(t, e = {}) {
            e.startPosition = this;
            const i = new Xn(e);
            return i.skip(t), i.position;
          }
          getAncestors() {
            return this.parent.is("documentFragment")
              ? [this.parent]
              : this.parent.getAncestors({ includeSelf: !0 });
          }
          getCommonAncestor(t) {
            const e = this.getAncestors(),
              i = t.getAncestors();
            let n = 0;
            for (; e[n] == i[n] && e[n]; ) n++;
            return 0 === n ? null : e[n - 1];
          }
          is(t) {
            return "position" === t || "view:position" === t;
          }
          isEqual(t) {
            return this.parent == t.parent && this.offset == t.offset;
          }
          isBefore(t) {
            return "before" == this.compareWith(t);
          }
          isAfter(t) {
            return "after" == this.compareWith(t);
          }
          compareWith(t) {
            if (this.root !== t.root) return "different";
            if (this.isEqual(t)) return "same";
            const e = this.parent.is("node") ? this.parent.getPath() : [],
              i = t.parent.is("node") ? t.parent.getPath() : [];
            e.push(this.offset), i.push(t.offset);
            const n = Si(e, i);
            switch (n) {
              case "prefix":
                return "before";
              case "extension":
                return "after";
              default:
                return e[n] < i[n] ? "before" : "after";
            }
          }
          getWalker(t = {}) {
            return (t.startPosition = this), new Xn(t);
          }
          clone() {
            return new Kn(this.parent, this.offset);
          }
          static _createAt(t, e) {
            if (t instanceof Kn) return new this(t.parent, t.offset);
            {
              const i = t;
              if ("end" == e) e = i.is("text") ? i.data.length : i.childCount;
              else {
                if ("before" == e) return this._createBefore(i);
                if ("after" == e) return this._createAfter(i);
                if (0 !== e && !e)
                  throw new hi.b(
                    "view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.",
                    i
                  );
              }
              return new Kn(i, e);
            }
          }
          static _createAfter(t) {
            if (t.is("textProxy"))
              return new Kn(t.textNode, t.offsetInText + t.data.length);
            if (!t.parent)
              throw new hi.b(
                "view-position-after-root: You can not make position after root.",
                t,
                { root: t }
              );
            return new Kn(t.parent, t.index + 1);
          }
          static _createBefore(t) {
            if (t.is("textProxy")) return new Kn(t.textNode, t.offsetInText);
            if (!t.parent)
              throw new hi.b(
                "view-position-before-root: You can not make position before root.",
                t,
                { root: t }
              );
            return new Kn(t.parent, t.index);
          }
        }
        class Zn {
          constructor(t, e = null) {
            (this.start = t.clone()), (this.end = e ? e.clone() : t.clone());
          }
          *[Symbol.iterator]() {
            yield* new Xn({ boundaries: this, ignoreElementEnd: !0 });
          }
          get isCollapsed() {
            return this.start.isEqual(this.end);
          }
          get isFlat() {
            return this.start.parent === this.end.parent;
          }
          get root() {
            return this.start.root;
          }
          getEnlarged() {
            let t = this.start.getLastMatchingPosition(to, {
                direction: "backward",
              }),
              e = this.end.getLastMatchingPosition(to);
            return (
              t.parent.is("text") &&
                t.isAtStart &&
                (t = Kn._createBefore(t.parent)),
              e.parent.is("text") &&
                e.isAtEnd &&
                (e = Kn._createAfter(e.parent)),
              new Zn(t, e)
            );
          }
          getTrimmed() {
            let t = this.start.getLastMatchingPosition(to);
            if (t.isAfter(this.end) || t.isEqual(this.end)) return new Zn(t, t);
            let e = this.end.getLastMatchingPosition(to, {
              direction: "backward",
            });
            const i = t.nodeAfter,
              n = e.nodeBefore;
            return (
              i && i.is("text") && (t = new Kn(i, 0)),
              n && n.is("text") && (e = new Kn(n, n.data.length)),
              new Zn(t, e)
            );
          }
          isEqual(t) {
            return (
              this == t ||
              (this.start.isEqual(t.start) && this.end.isEqual(t.end))
            );
          }
          containsPosition(t) {
            return t.isAfter(this.start) && t.isBefore(this.end);
          }
          containsRange(t, e = !1) {
            t.isCollapsed && (e = !1);
            const i =
                this.containsPosition(t.start) ||
                (e && this.start.isEqual(t.start)),
              n =
                this.containsPosition(t.end) || (e && this.end.isEqual(t.end));
            return i && n;
          }
          getDifference(t) {
            const e = [];
            return (
              this.isIntersecting(t)
                ? (this.containsPosition(t.start) &&
                    e.push(new Zn(this.start, t.start)),
                  this.containsPosition(t.end) &&
                    e.push(new Zn(t.end, this.end)))
                : e.push(this.clone()),
              e
            );
          }
          getIntersection(t) {
            if (this.isIntersecting(t)) {
              let e = this.start,
                i = this.end;
              return (
                this.containsPosition(t.start) && (e = t.start),
                this.containsPosition(t.end) && (i = t.end),
                new Zn(e, i)
              );
            }
            return null;
          }
          getWalker(t = {}) {
            return (t.boundaries = this), new Xn(t);
          }
          getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
          getContainedElement() {
            if (this.isCollapsed) return null;
            let t = this.start.nodeAfter,
              e = this.end.nodeBefore;
            return (
              this.start.parent.is("text") &&
                this.start.isAtEnd &&
                this.start.parent.nextSibling &&
                (t = this.start.parent.nextSibling),
              this.end.parent.is("text") &&
                this.end.isAtStart &&
                this.end.parent.previousSibling &&
                (e = this.end.parent.previousSibling),
              t && t.is("element") && t === e ? t : null
            );
          }
          clone() {
            return new Zn(this.start, this.end);
          }
          *getItems(t = {}) {
            (t.boundaries = this), (t.ignoreElementEnd = !0);
            const e = new Xn(t);
            for (const t of e) yield t.item;
          }
          *getPositions(t = {}) {
            t.boundaries = this;
            const e = new Xn(t);
            yield e.position;
            for (const t of e) yield t.nextPosition;
          }
          is(t) {
            return "range" === t || "view:range" === t;
          }
          isIntersecting(t) {
            return this.start.isBefore(t.end) && this.end.isAfter(t.start);
          }
          static _createFromParentsAndOffsets(t, e, i, n) {
            return new this(new Kn(t, e), new Kn(i, n));
          }
          static _createFromPositionAndShift(t, e) {
            const i = t,
              n = t.getShiftedBy(e);
            return e > 0 ? new this(i, n) : new this(n, i);
          }
          static _createIn(t) {
            return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
          }
          static _createOn(t) {
            const e = t.is("textProxy") ? t.offsetSize : 1;
            return this._createFromPositionAndShift(Kn._createBefore(t), e);
          }
        }
        function to(t) {
          return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
        }
        function eo(t) {
          let e = 0;
          for (const i of t) e++;
          return e;
        }
        class io {
          constructor(t = null, e, i) {
            (this._ranges = []),
              (this._lastRangeBackward = !1),
              (this._isFake = !1),
              (this._fakeSelectionLabel = ""),
              this.setTo(t, e, i);
          }
          get isFake() {
            return this._isFake;
          }
          get fakeSelectionLabel() {
            return this._fakeSelectionLabel;
          }
          get anchor() {
            if (!this._ranges.length) return null;
            const t = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t.end : t.start).clone();
          }
          get focus() {
            if (!this._ranges.length) return null;
            const t = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t.start : t.end).clone();
          }
          get isCollapsed() {
            return 1 === this.rangeCount && this._ranges[0].isCollapsed;
          }
          get rangeCount() {
            return this._ranges.length;
          }
          get isBackward() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
          get editableElement() {
            return this.anchor ? this.anchor.editableElement : null;
          }
          *getRanges() {
            for (const t of this._ranges) yield t.clone();
          }
          getFirstRange() {
            let t = null;
            for (const e of this._ranges)
              (t && !e.start.isBefore(t.start)) || (t = e);
            return t ? t.clone() : null;
          }
          getLastRange() {
            let t = null;
            for (const e of this._ranges)
              (t && !e.end.isAfter(t.end)) || (t = e);
            return t ? t.clone() : null;
          }
          getFirstPosition() {
            const t = this.getFirstRange();
            return t ? t.start.clone() : null;
          }
          getLastPosition() {
            const t = this.getLastRange();
            return t ? t.end.clone() : null;
          }
          isEqual(t) {
            if (this.isFake != t.isFake) return !1;
            if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel)
              return !1;
            if (this.rangeCount != t.rangeCount) return !1;
            if (0 === this.rangeCount) return !0;
            if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
              return !1;
            for (const e of this._ranges) {
              let i = !1;
              for (const n of t._ranges)
                if (e.isEqual(n)) {
                  i = !0;
                  break;
                }
              if (!i) return !1;
            }
            return !0;
          }
          isSimilar(t) {
            if (this.isBackward != t.isBackward) return !1;
            const e = eo(this.getRanges());
            if (e != eo(t.getRanges())) return !1;
            if (0 == e) return !0;
            for (let e of this.getRanges()) {
              e = e.getTrimmed();
              let i = !1;
              for (let n of t.getRanges())
                if (
                  ((n = n.getTrimmed()),
                  e.start.isEqual(n.start) && e.end.isEqual(n.end))
                ) {
                  i = !0;
                  break;
                }
              if (!i) return !1;
            }
            return !0;
          }
          getSelectedElement() {
            return 1 !== this.rangeCount
              ? null
              : this.getFirstRange().getContainedElement();
          }
          setTo(t, e, i) {
            if (null === t) this._setRanges([]), this._setFakeOptions(e);
            else if (t instanceof io || t instanceof no)
              this._setRanges(t.getRanges(), t.isBackward),
                this._setFakeOptions({
                  fake: t.isFake,
                  label: t.fakeSelectionLabel,
                });
            else if (t instanceof Zn)
              this._setRanges([t], e && e.backward), this._setFakeOptions(e);
            else if (t instanceof Kn)
              this._setRanges([new Zn(t)]), this._setFakeOptions(e);
            else if (t instanceof Oi) {
              const n = !!i && !!i.backward;
              let o;
              if (void 0 === e)
                throw new hi.b(
                  "view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.",
                  this
                );
              (o =
                "in" == e
                  ? Zn._createIn(t)
                  : "on" == e
                  ? Zn._createOn(t)
                  : new Zn(Kn._createAt(t, e))),
                this._setRanges([o], n),
                this._setFakeOptions(i);
            } else {
              if (!vi(t))
                throw new hi.b(
                  "view-selection-setTo-not-selectable: Cannot set selection to given place.",
                  this
                );
              this._setRanges(t, e && e.backward), this._setFakeOptions(e);
            }
            this.fire("change");
          }
          setFocus(t, e) {
            if (null === this.anchor)
              throw new hi.b(
                "view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.",
                this
              );
            const i = Kn._createAt(t, e);
            if ("same" == i.compareWith(this.focus)) return;
            const n = this.anchor;
            this._ranges.pop(),
              "before" == i.compareWith(n)
                ? this._addRange(new Zn(i, n), !0)
                : this._addRange(new Zn(n, i)),
              this.fire("change");
          }
          is(t) {
            return "selection" === t || "view:selection" === t;
          }
          _setRanges(t, e = !1) {
            (t = Array.from(t)), (this._ranges = []);
            for (const e of t) this._addRange(e);
            this._lastRangeBackward = !!e;
          }
          _setFakeOptions(t = {}) {
            (this._isFake = !!t.fake),
              (this._fakeSelectionLabel = (t.fake && t.label) || "");
          }
          _addRange(t, e = !1) {
            if (!(t instanceof Zn))
              throw new hi.b(
                "view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range",
                this
              );
            this._pushRange(t), (this._lastRangeBackward = !!e);
          }
          _pushRange(t) {
            for (const e of this._ranges)
              if (t.isIntersecting(e))
                throw new hi.b(
                  "view-selection-range-intersects: Trying to add a range that intersects with another range from selection.",
                  this,
                  { addedRange: t, intersectingRange: e }
                );
            this._ranges.push(new Zn(t.start, t.end));
          }
        }
        yi(io, gi);
        class no {
          constructor(t = null, e, i) {
            (this._selection = new io()),
              this._selection.delegate("change").to(this),
              this._selection.setTo(t, e, i);
          }
          get isFake() {
            return this._selection.isFake;
          }
          get fakeSelectionLabel() {
            return this._selection.fakeSelectionLabel;
          }
          get anchor() {
            return this._selection.anchor;
          }
          get focus() {
            return this._selection.focus;
          }
          get isCollapsed() {
            return this._selection.isCollapsed;
          }
          get rangeCount() {
            return this._selection.rangeCount;
          }
          get isBackward() {
            return this._selection.isBackward;
          }
          get editableElement() {
            return this._selection.editableElement;
          }
          get _ranges() {
            return this._selection._ranges;
          }
          *getRanges() {
            yield* this._selection.getRanges();
          }
          getFirstRange() {
            return this._selection.getFirstRange();
          }
          getLastRange() {
            return this._selection.getLastRange();
          }
          getFirstPosition() {
            return this._selection.getFirstPosition();
          }
          getLastPosition() {
            return this._selection.getLastPosition();
          }
          getSelectedElement() {
            return this._selection.getSelectedElement();
          }
          isEqual(t) {
            return this._selection.isEqual(t);
          }
          isSimilar(t) {
            return this._selection.isSimilar(t);
          }
          is(t) {
            return (
              "selection" === t ||
              "documentSelection" == t ||
              "view:selection" == t ||
              "view:documentSelection" == t
            );
          }
          _setTo(t, e, i) {
            this._selection.setTo(t, e, i);
          }
          _setFocus(t, e) {
            this._selection.setFocus(t, e);
          }
        }
        yi(no, gi);
        class oo {
          constructor(t) {
            (this.selection = new no()),
              (this.roots = new xi({ idProperty: "rootName" })),
              (this.stylesProcessor = t),
              this.set("isReadOnly", !1),
              this.set("isFocused", !1),
              this.set("isComposing", !1),
              (this._postFixers = new Set());
          }
          getRoot(t = "main") {
            return this.roots.get(t);
          }
          registerPostFixer(t) {
            this._postFixers.add(t);
          }
          destroy() {
            this.roots.map((t) => t.destroy()), this.stopListening();
          }
          _callPostFixers(t) {
            let e = !1;
            do {
              for (const i of this._postFixers) if (((e = i(t)), e)) break;
            } while (e);
          }
        }
        yi(oo, Hn);
        class ro extends Nn {
          constructor(t, e, i, n) {
            super(t, e, i, n),
              (this.getFillerOffset = so),
              (this._priority = 10),
              (this._id = null),
              (this._clonesGroup = null);
          }
          get priority() {
            return this._priority;
          }
          get id() {
            return this._id;
          }
          getElementsWithSameId() {
            if (null === this.id)
              throw new hi.b(
                "attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.",
                this
              );
            return new Set(this._clonesGroup);
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("attributeElement" === t ||
                    "view:attributeElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "attributeElement" === t ||
                  "view:attributeElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          isSimilar(t) {
            return null !== this.id || null !== t.id
              ? this.id === t.id
              : super.isSimilar(t) && this.priority == t.priority;
          }
          _clone(t) {
            const e = super._clone(t);
            return (e._priority = this._priority), (e._id = this._id), e;
          }
        }
        function so() {
          if (ao(this)) return null;
          let t = this.parent;
          for (; t && t.is("attributeElement"); ) {
            if (ao(t) > 1) return null;
            t = t.parent;
          }
          return !t || ao(t) > 1 ? null : this.childCount;
        }
        function ao(t) {
          return Array.from(t.getChildren()).filter((t) => !t.is("uiElement"))
            .length;
        }
        ro.DEFAULT_PRIORITY = 10;
        class lo extends Nn {
          constructor(t, e, i, n) {
            super(t, e, i, n), (this.getFillerOffset = co);
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("emptyElement" === t ||
                    "view:emptyElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "emptyElement" === t ||
                  "view:emptyElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          _insertChild(t, e) {
            if (e && (e instanceof Oi || Array.from(e).length > 0))
              throw new hi.b(
                "view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.",
                [this, e]
              );
          }
        }
        function co() {
          return null;
        }
        const ho = navigator.userAgent.toLowerCase();
        var uo = {
          isMac: (function (t) {
            return t.indexOf("macintosh") > -1;
          })(ho),
          isGecko: (function (t) {
            return !!t.match(/gecko\/\d+/);
          })(ho),
          isSafari: (function (t) {
            return (
              t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome")
            );
          })(ho),
          isAndroid: (function (t) {
            return t.indexOf("android") > -1;
          })(ho),
          features: {
            isRegExpUnicodePropertySupported: (function () {
              let t = !1;
              try {
                t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
              } catch (t) {}
              return t;
            })(),
          },
        };
        const mo = { "⌘": "ctrl", "⇧": "shift", "⌥": "alt" },
          go = { ctrl: "⌘", shift: "⇧", alt: "⌥" },
          fo = (function () {
            const t = {
              arrowleft: 37,
              arrowup: 38,
              arrowright: 39,
              arrowdown: 40,
              backspace: 8,
              delete: 46,
              enter: 13,
              space: 32,
              esc: 27,
              tab: 9,
              ctrl: 1114112,
              cmd: 1114112,
              shift: 2228224,
              alt: 4456448,
            };
            for (let e = 65; e <= 90; e++) {
              const i = String.fromCharCode(e);
              t[i.toLowerCase()] = e;
            }
            for (let e = 48; e <= 57; e++) t[e - 48] = e;
            for (let e = 112; e <= 123; e++) t["f" + (e - 111)] = e;
            return t;
          })();
        function po(t) {
          let e;
          if ("string" == typeof t) {
            if (((e = fo[t.toLowerCase()]), !e))
              throw new hi.b("keyboard-unknown-key: Unknown key name.", null, {
                key: t,
              });
          } else
            e =
              t.keyCode +
              (t.altKey ? fo.alt : 0) +
              (t.ctrlKey ? fo.ctrl : 0) +
              (t.shiftKey ? fo.shift : 0);
          return e;
        }
        function bo(t) {
          return (
            "string" == typeof t && (t = _o(t)),
            t
              .map((t) => ("string" == typeof t ? po(t) : t))
              .reduce((t, e) => e + t, 0)
          );
        }
        function wo(t) {
          return uo.isMac
            ? _o(t)
                .map((t) => go[t.toLowerCase()] || t)
                .reduce((t, e) => (t.slice(-1) in mo ? t + e : t + "+" + e))
            : t;
        }
        function _o(t) {
          return t.split(/\s*\+\s*/);
        }
        class ko extends Nn {
          constructor(t, e, i, n) {
            super(t, e, i, n), (this.getFillerOffset = yo);
          }
          is(t, e = null) {
            return e
              ? e === this.name &&
                  ("uiElement" === t ||
                    "view:uiElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "uiElement" === t ||
                  "view:uiElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          }
          _insertChild(t, e) {
            if (e && (e instanceof Oi || Array.from(e).length > 0))
              throw new hi.b(
                "view-uielement-cannot-add: Cannot add child nodes to UIElement instance.",
                this
              );
          }
          render(t) {
            return this.toDomElement(t);
          }
          toDomElement(t) {
            const e = t.createElement(this.name);
            for (const t of this.getAttributeKeys())
              e.setAttribute(t, this.getAttribute(t));
            return e;
          }
        }
        function vo(t) {
          t.document.on("keydown", (e, i) =>
            (function (t, e, i) {
              if (e.keyCode == fo.arrowright) {
                const t = e.domTarget.ownerDocument.defaultView.getSelection(),
                  n = 1 == t.rangeCount && t.getRangeAt(0).collapsed;
                if (n || e.shiftKey) {
                  const e = t.focusNode,
                    o = t.focusOffset,
                    r = i.domPositionToView(e, o);
                  if (null === r) return;
                  let s = !1;
                  const a = r.getLastMatchingPosition(
                    (t) => (
                      t.item.is("uiElement") && (s = !0),
                      !(
                        !t.item.is("uiElement") &&
                        !t.item.is("attributeElement")
                      )
                    )
                  );
                  if (s) {
                    const e = i.viewPositionToDom(a);
                    n
                      ? t.collapse(e.parent, e.offset)
                      : t.extend(e.parent, e.offset);
                  }
                }
              }
            })(0, i, t.domConverter)
          );
        }
        function yo() {
          return null;
        }
        class xo {
          constructor(t, e) {
            (this.document = t),
              (this._children = []),
              e && this._insertChild(0, e);
          }
          [Symbol.iterator]() {
            return this._children[Symbol.iterator]();
          }
          get childCount() {
            return this._children.length;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          get root() {
            return this;
          }
          get parent() {
            return null;
          }
          is(t) {
            return "documentFragment" === t || "view:documentFragment" === t;
          }
          _appendChild(t) {
            return this._insertChild(this.childCount, t);
          }
          getChild(t) {
            return this._children[t];
          }
          getChildIndex(t) {
            return this._children.indexOf(t);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          _insertChild(t, e) {
            this._fireChange("children", this);
            let i = 0;
            const n = (function (t, e) {
              if ("string" == typeof e) return [new Ni(t, e)];
              vi(e) || (e = [e]);
              return Array.from(e).map((e) =>
                "string" == typeof e
                  ? new Ni(t, e)
                  : e instanceof Ri
                  ? new Ni(t, e.data)
                  : e
              );
            })(this.document, e);
            for (const e of n)
              null !== e.parent && e._remove(),
                (e.parent = this),
                this._children.splice(t, 0, e),
                t++,
                i++;
            return i;
          }
          _removeChildren(t, e = 1) {
            this._fireChange("children", this);
            for (let i = t; i < t + e; i++) this._children[i].parent = null;
            return this._children.splice(t, e);
          }
          _fireChange(t, e) {
            this.fire("change:" + t, e);
          }
        }
        yi(xo, gi);
        class Ao {
          constructor(t) {
            (this.document = t), (this._cloneGroups = new Map());
          }
          setSelection(t, e, i) {
            this.document.selection._setTo(t, e, i);
          }
          setSelectionFocus(t, e) {
            this.document.selection._setFocus(t, e);
          }
          createText(t) {
            return new Ni(this.document, t);
          }
          createAttributeElement(t, e, i = {}) {
            const n = new ro(this.document, t, e);
            return (
              i.priority && (n._priority = i.priority),
              i.id && (n._id = i.id),
              n
            );
          }
          createContainerElement(t, e) {
            return new Ln(this.document, t, e);
          }
          createEditableElement(t, e) {
            const i = new Jn(this.document, t, e);
            return (i._document = this.document), i;
          }
          createEmptyElement(t, e) {
            return new lo(this.document, t, e);
          }
          createUIElement(t, e, i) {
            const n = new ko(this.document, t, e);
            return i && (n.render = i), n;
          }
          setAttribute(t, e, i) {
            i._setAttribute(t, e);
          }
          removeAttribute(t, e) {
            e._removeAttribute(t);
          }
          addClass(t, e) {
            e._addClass(t);
          }
          removeClass(t, e) {
            e._removeClass(t);
          }
          setStyle(t, e, i) {
            y(t) && void 0 === i && (i = e), i._setStyle(t, e);
          }
          removeStyle(t, e) {
            e._removeStyle(t);
          }
          setCustomProperty(t, e, i) {
            i._setCustomProperty(t, e);
          }
          removeCustomProperty(t, e) {
            return e._removeCustomProperty(t);
          }
          breakAttributes(t) {
            return t instanceof Kn
              ? this._breakAttributes(t)
              : this._breakAttributesRange(t);
          }
          breakContainer(t) {
            const e = t.parent;
            if (!e.is("containerElement"))
              throw new hi.b(
                "view-writer-break-non-container-element: Trying to break an element which is not a container element.",
                this.document
              );
            if (!e.parent)
              throw new hi.b(
                "view-writer-break-root: Trying to break root element.",
                this.document
              );
            if (t.isAtStart) return Kn._createBefore(e);
            if (!t.isAtEnd) {
              const i = e._clone(!1);
              this.insert(Kn._createAfter(e), i);
              const n = new Zn(t, Kn._createAt(e, "end")),
                o = new Kn(i, 0);
              this.move(n, o);
            }
            return Kn._createAfter(e);
          }
          mergeAttributes(t) {
            const e = t.offset,
              i = t.parent;
            if (i.is("text")) return t;
            if (i.is("attributeElement") && 0 === i.childCount) {
              const t = i.parent,
                e = i.index;
              return (
                i._remove(),
                this._removeFromClonedElementsGroup(i),
                this.mergeAttributes(new Kn(t, e))
              );
            }
            const n = i.getChild(e - 1),
              o = i.getChild(e);
            if (!n || !o) return t;
            if (n.is("text") && o.is("text")) return Po(n, o);
            if (
              n.is("attributeElement") &&
              o.is("attributeElement") &&
              n.isSimilar(o)
            ) {
              const t = n.childCount;
              return (
                n._appendChild(o.getChildren()),
                o._remove(),
                this._removeFromClonedElementsGroup(o),
                this.mergeAttributes(new Kn(n, t))
              );
            }
            return t;
          }
          mergeContainers(t) {
            const e = t.nodeBefore,
              i = t.nodeAfter;
            if (
              !(e && i && e.is("containerElement") && i.is("containerElement"))
            )
              throw new hi.b(
                "view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.",
                this.document
              );
            const n = e.getChild(e.childCount - 1),
              o =
                n instanceof Ni
                  ? Kn._createAt(n, "end")
                  : Kn._createAt(e, "end");
            return (
              this.move(Zn._createIn(i), Kn._createAt(e, "end")),
              this.remove(Zn._createOn(i)),
              o
            );
          }
          insert(t, e) {
            (function t(e, i) {
              for (const n of e) {
                if (!So.some((t) => n instanceof t))
                  throw new hi.b("view-writer-insert-invalid-node", i);
                n.is("text") || t(n.getChildren(), i);
              }
            })((e = vi(e) ? [...e] : [e]), this.document);
            const i = Co(t);
            if (!i)
              throw new hi.b(
                "view-writer-invalid-position-container",
                this.document
              );
            const n = this._breakAttributes(t, !0),
              o = i._insertChild(n.offset, e);
            for (const t of e) this._addToClonedElementsGroup(t);
            const r = n.getShiftedBy(o),
              s = this.mergeAttributes(n);
            if (0 === o) return new Zn(s, s);
            {
              s.isEqual(n) || r.offset--;
              const t = this.mergeAttributes(r);
              return new Zn(s, t);
            }
          }
          remove(t) {
            const e = t instanceof Zn ? t : Zn._createOn(t);
            if ((Oo(e, this.document), e.isCollapsed))
              return new xo(this.document);
            const { start: i, end: n } = this._breakAttributesRange(e, !0),
              o = i.parent,
              r = n.offset - i.offset,
              s = o._removeChildren(i.offset, r);
            for (const t of s) this._removeFromClonedElementsGroup(t);
            const a = this.mergeAttributes(i);
            return (e.start = a), (e.end = a.clone()), new xo(this.document, s);
          }
          clear(t, e) {
            Oo(t, this.document);
            const i = t.getWalker({
              direction: "backward",
              ignoreElementEnd: !0,
            });
            for (const n of i) {
              const i = n.item;
              let o;
              if (i.is("element") && e.isSimilar(i)) o = Zn._createOn(i);
              else if (!n.nextPosition.isAfter(t.start) && i.is("textProxy")) {
                const t = i
                  .getAncestors()
                  .find((t) => t.is("element") && e.isSimilar(t));
                t && (o = Zn._createIn(t));
              }
              o &&
                (o.end.isAfter(t.end) && (o.end = t.end),
                o.start.isBefore(t.start) && (o.start = t.start),
                this.remove(o));
            }
          }
          move(t, e) {
            let i;
            if (e.isAfter(t.end)) {
              const n = (e = this._breakAttributes(e, !0)).parent,
                o = n.childCount;
              (t = this._breakAttributesRange(t, !0)),
                (i = this.remove(t)),
                (e.offset += n.childCount - o);
            } else i = this.remove(t);
            return this.insert(e, i);
          }
          wrap(t, e) {
            if (!(e instanceof ro))
              throw new hi.b(
                "view-writer-wrap-invalid-attribute",
                this.document
              );
            if ((Oo(t, this.document), t.isCollapsed)) {
              let n = t.start;
              n.parent.is("element") &&
                ((i = n.parent),
                !Array.from(i.getChildren()).some((t) => !t.is("uiElement"))) &&
                (n = n.getLastMatchingPosition((t) => t.item.is("uiElement"))),
                (n = this._wrapPosition(n, e));
              const o = this.document.selection;
              return (
                o.isCollapsed &&
                  o.getFirstPosition().isEqual(t.start) &&
                  this.setSelection(n),
                new Zn(n)
              );
            }
            return this._wrapRange(t, e);
            var i;
          }
          unwrap(t, e) {
            if (!(e instanceof ro))
              throw new hi.b(
                "view-writer-unwrap-invalid-attribute",
                this.document
              );
            if ((Oo(t, this.document), t.isCollapsed)) return t;
            const { start: i, end: n } = this._breakAttributesRange(t, !0),
              o = i.parent,
              r = this._unwrapChildren(o, i.offset, n.offset, e),
              s = this.mergeAttributes(r.start);
            s.isEqual(r.start) || r.end.offset--;
            const a = this.mergeAttributes(r.end);
            return new Zn(s, a);
          }
          rename(t, e) {
            const i = new Ln(this.document, t, e.getAttributes());
            return (
              this.insert(Kn._createAfter(e), i),
              this.move(Zn._createIn(e), Kn._createAt(i, 0)),
              this.remove(Zn._createOn(e)),
              i
            );
          }
          clearClonedElementsGroup(t) {
            this._cloneGroups.delete(t);
          }
          createPositionAt(t, e) {
            return Kn._createAt(t, e);
          }
          createPositionAfter(t) {
            return Kn._createAfter(t);
          }
          createPositionBefore(t) {
            return Kn._createBefore(t);
          }
          createRange(t, e) {
            return new Zn(t, e);
          }
          createRangeOn(t) {
            return Zn._createOn(t);
          }
          createRangeIn(t) {
            return Zn._createIn(t);
          }
          createSelection(t, e, i) {
            return new io(t, e, i);
          }
          _wrapChildren(t, e, i, n) {
            let o = e;
            const r = [];
            for (; o < i; ) {
              const e = t.getChild(o),
                i = e.is("text"),
                s = e.is("attributeElement"),
                a = e.is("emptyElement"),
                l = e.is("uiElement");
              if (s && this._wrapAttributeElement(n, e)) r.push(new Kn(t, o));
              else if (i || a || l || (s && To(n, e))) {
                const i = n._clone();
                e._remove(),
                  i._appendChild(e),
                  t._insertChild(o, i),
                  this._addToClonedElementsGroup(i),
                  r.push(new Kn(t, o));
              } else s && this._wrapChildren(e, 0, e.childCount, n);
              o++;
            }
            let s = 0;
            for (const t of r) {
              if (((t.offset -= s), t.offset == e)) continue;
              this.mergeAttributes(t).isEqual(t) || (s++, i--);
            }
            return Zn._createFromParentsAndOffsets(t, e, t, i);
          }
          _unwrapChildren(t, e, i, n) {
            let o = e;
            const r = [];
            for (; o < i; ) {
              const e = t.getChild(o);
              if (e.is("attributeElement"))
                if (e.isSimilar(n)) {
                  const n = e.getChildren(),
                    s = e.childCount;
                  e._remove(),
                    t._insertChild(o, n),
                    this._removeFromClonedElementsGroup(e),
                    r.push(new Kn(t, o), new Kn(t, o + s)),
                    (o += s),
                    (i += s - 1);
                } else
                  this._unwrapAttributeElement(n, e)
                    ? (r.push(new Kn(t, o), new Kn(t, o + 1)), o++)
                    : (this._unwrapChildren(e, 0, e.childCount, n), o++);
              else o++;
            }
            let s = 0;
            for (const t of r) {
              if (((t.offset -= s), t.offset == e || t.offset == i)) continue;
              this.mergeAttributes(t).isEqual(t) || (s++, i--);
            }
            return Zn._createFromParentsAndOffsets(t, e, t, i);
          }
          _wrapRange(t, e) {
            const { start: i, end: n } = this._breakAttributesRange(t, !0),
              o = i.parent,
              r = this._wrapChildren(o, i.offset, n.offset, e),
              s = this.mergeAttributes(r.start);
            s.isEqual(r.start) || r.end.offset--;
            const a = this.mergeAttributes(r.end);
            return new Zn(s, a);
          }
          _wrapPosition(t, e) {
            if (e.isSimilar(t.parent)) return Mo(t.clone());
            t.parent.is("text") && (t = Eo(t));
            const i = this.createAttributeElement();
            (i._priority = Number.POSITIVE_INFINITY),
              (i.isSimilar = () => !1),
              t.parent._insertChild(t.offset, i);
            const n = new Zn(t, t.getShiftedBy(1));
            this.wrap(n, e);
            const o = new Kn(i.parent, i.index);
            i._remove();
            const r = o.nodeBefore,
              s = o.nodeAfter;
            return r instanceof Ni && s instanceof Ni ? Po(r, s) : Mo(o);
          }
          _wrapAttributeElement(t, e) {
            if (!No(t, e)) return !1;
            if (t.name !== e.name || t.priority !== e.priority) return !1;
            for (const i of t.getAttributeKeys())
              if (
                "class" !== i &&
                "style" !== i &&
                e.hasAttribute(i) &&
                e.getAttribute(i) !== t.getAttribute(i)
              )
                return !1;
            for (const i of t.getStyleNames())
              if (e.hasStyle(i) && e.getStyle(i) !== t.getStyle(i)) return !1;
            for (const i of t.getAttributeKeys())
              "class" !== i &&
                "style" !== i &&
                (e.hasAttribute(i) ||
                  this.setAttribute(i, t.getAttribute(i), e));
            for (const i of t.getStyleNames())
              e.hasStyle(i) || this.setStyle(i, t.getStyle(i), e);
            for (const i of t.getClassNames())
              e.hasClass(i) || this.addClass(i, e);
            return !0;
          }
          _unwrapAttributeElement(t, e) {
            if (!No(t, e)) return !1;
            if (t.name !== e.name || t.priority !== e.priority) return !1;
            for (const i of t.getAttributeKeys())
              if (
                "class" !== i &&
                "style" !== i &&
                (!e.hasAttribute(i) || e.getAttribute(i) !== t.getAttribute(i))
              )
                return !1;
            if (!e.hasClass(...t.getClassNames())) return !1;
            for (const i of t.getStyleNames())
              if (!e.hasStyle(i) || e.getStyle(i) !== t.getStyle(i)) return !1;
            for (const i of t.getAttributeKeys())
              "class" !== i && "style" !== i && this.removeAttribute(i, e);
            return (
              this.removeClass(Array.from(t.getClassNames()), e),
              this.removeStyle(Array.from(t.getStyleNames()), e),
              !0
            );
          }
          _breakAttributesRange(t, e = !1) {
            const i = t.start,
              n = t.end;
            if ((Oo(t, this.document), t.isCollapsed)) {
              const i = this._breakAttributes(t.start, e);
              return new Zn(i, i);
            }
            const o = this._breakAttributes(n, e),
              r = o.parent.childCount,
              s = this._breakAttributes(i, e);
            return (o.offset += o.parent.childCount - r), new Zn(s, o);
          }
          _breakAttributes(t, e = !1) {
            const i = t.offset,
              n = t.parent;
            if (t.parent.is("emptyElement"))
              throw new hi.b(
                "view-writer-cannot-break-empty-element",
                this.document
              );
            if (t.parent.is("uiElement"))
              throw new hi.b(
                "view-writer-cannot-break-ui-element",
                this.document
              );
            if (!e && n.is("text") && Io(n.parent)) return t.clone();
            if (Io(n)) return t.clone();
            if (n.is("text")) return this._breakAttributes(Eo(t), e);
            if (i == n.childCount) {
              const t = new Kn(n.parent, n.index + 1);
              return this._breakAttributes(t, e);
            }
            if (0 === i) {
              const t = new Kn(n.parent, n.index);
              return this._breakAttributes(t, e);
            }
            {
              const t = n.index + 1,
                o = n._clone();
              n.parent._insertChild(t, o), this._addToClonedElementsGroup(o);
              const r = n.childCount - i,
                s = n._removeChildren(i, r);
              o._appendChild(s);
              const a = new Kn(n.parent, t);
              return this._breakAttributes(a, e);
            }
          }
          _addToClonedElementsGroup(t) {
            if (!t.root.is("rootElement")) return;
            if (t.is("element"))
              for (const e of t.getChildren())
                this._addToClonedElementsGroup(e);
            const e = t.id;
            if (!e) return;
            let i = this._cloneGroups.get(e);
            i || ((i = new Set()), this._cloneGroups.set(e, i)),
              i.add(t),
              (t._clonesGroup = i);
          }
          _removeFromClonedElementsGroup(t) {
            if (t.is("element"))
              for (const e of t.getChildren())
                this._removeFromClonedElementsGroup(e);
            const e = t.id;
            if (!e) return;
            const i = this._cloneGroups.get(e);
            i && i.delete(t);
          }
        }
        function Co(t) {
          let e = t.parent;
          for (; !Io(e); ) {
            if (!e) return;
            e = e.parent;
          }
          return e;
        }
        function To(t, e) {
          return (
            t.priority < e.priority ||
            (!(t.priority > e.priority) && t.getIdentity() < e.getIdentity())
          );
        }
        function Mo(t) {
          const e = t.nodeBefore;
          if (e && e.is("text")) return new Kn(e, e.data.length);
          const i = t.nodeAfter;
          return i && i.is("text") ? new Kn(i, 0) : t;
        }
        function Eo(t) {
          if (t.offset == t.parent.data.length)
            return new Kn(t.parent.parent, t.parent.index + 1);
          if (0 === t.offset) return new Kn(t.parent.parent, t.parent.index);
          const e = t.parent.data.slice(t.offset);
          return (
            (t.parent._data = t.parent.data.slice(0, t.offset)),
            t.parent.parent._insertChild(
              t.parent.index + 1,
              new Ni(t.root.document, e)
            ),
            new Kn(t.parent.parent, t.parent.index + 1)
          );
        }
        function Po(t, e) {
          const i = t.data.length;
          return (t._data += e.data), e._remove(), new Kn(t, i);
        }
        const So = [Ni, ro, Ln, lo, ko];
        function Io(t) {
          return t && (t.is("containerElement") || t.is("documentFragment"));
        }
        function Oo(t, e) {
          const i = Co(t.start),
            n = Co(t.end);
          if (!i || !n || i !== n)
            throw new hi.b("view-writer-invalid-range-container", e);
        }
        function No(t, e) {
          return null === t.id && null === e.id;
        }
        function Ro(t) {
          return "[object Text]" == Object.prototype.toString.call(t);
        }
        const Lo = (t) => t.createTextNode(" "),
          jo = (t) => {
            const e = t.createElement("br");
            return (e.dataset.ckeFiller = !0), e;
          },
          Do = (() => {
            let t = "";
            for (let e = 0; e < 7; e++) t += "​";
            return t;
          })();
        function zo(t) {
          return Ro(t) && t.data.substr(0, 7) === Do;
        }
        function Bo(t) {
          return 7 == t.data.length && zo(t);
        }
        function Vo(t) {
          return zo(t) ? t.data.slice(7) : t.data;
        }
        function Fo(t, e) {
          if (e.keyCode == fo.arrowleft) {
            const t = e.domTarget.ownerDocument.defaultView.getSelection();
            if (1 == t.rangeCount && t.getRangeAt(0).collapsed) {
              const e = t.getRangeAt(0).startContainer,
                i = t.getRangeAt(0).startOffset;
              zo(e) && i <= 7 && t.collapse(e, 0);
            }
          }
        }
        function Ho(t, e, i, n = !1) {
          (i =
            i ||
            function (t, e) {
              return t === e;
            }),
            Array.isArray(t) || (t = Array.prototype.slice.call(t)),
            Array.isArray(e) || (e = Array.prototype.slice.call(e));
          const o = (function (t, e, i) {
            const n = Uo(t, e, i);
            if (-1 === n)
              return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
            const o = Wo(t, n),
              r = Wo(e, n),
              s = Uo(o, r, i),
              a = t.length - s,
              l = e.length - s;
            return { firstIndex: n, lastIndexOld: a, lastIndexNew: l };
          })(t, e, i);
          return n
            ? (function (t, e) {
                const { firstIndex: i, lastIndexOld: n, lastIndexNew: o } = t;
                if (-1 === i) return Array(e).fill("equal");
                let r = [];
                i > 0 && (r = r.concat(Array(i).fill("equal")));
                o - i > 0 && (r = r.concat(Array(o - i).fill("insert")));
                n - i > 0 && (r = r.concat(Array(n - i).fill("delete")));
                o < e && (r = r.concat(Array(e - o).fill("equal")));
                return r;
              })(o, e.length)
            : (function (t, e) {
                const i = [],
                  { firstIndex: n, lastIndexOld: o, lastIndexNew: r } = e;
                r - n > 0 &&
                  i.push({ index: n, type: "insert", values: t.slice(n, r) });
                o - n > 0 &&
                  i.push({
                    index: n + (r - n),
                    type: "delete",
                    howMany: o - n,
                  });
                return i;
              })(e, o);
        }
        function Uo(t, e, i) {
          for (let n = 0; n < Math.max(t.length, e.length); n++)
            if (void 0 === t[n] || void 0 === e[n] || !i(t[n], e[n])) return n;
          return -1;
        }
        function Wo(t, e) {
          return t.slice(e).reverse();
        }
        function qo(t, e, i) {
          i =
            i ||
            function (t, e) {
              return t === e;
            };
          const n = t.length,
            o = e.length;
          if (n > 200 || o > 200 || n + o > 300)
            return qo.fastDiff(t, e, i, !0);
          let r, s;
          if (o < n) {
            const i = t;
            (t = e), (e = i), (r = "delete"), (s = "insert");
          } else (r = "insert"), (s = "delete");
          const a = t.length,
            l = e.length,
            c = l - a,
            d = {},
            h = {};
          function u(n) {
            const o = (void 0 !== h[n - 1] ? h[n - 1] : -1) + 1,
              c = void 0 !== h[n + 1] ? h[n + 1] : -1,
              u = o > c ? -1 : 1;
            d[n + u] && (d[n] = d[n + u].slice(0)),
              d[n] || (d[n] = []),
              d[n].push(o > c ? r : s);
            let m = Math.max(o, c),
              g = m - n;
            for (; g < a && m < l && i(t[g], e[m]); )
              g++, m++, d[n].push("equal");
            return m;
          }
          let m,
            g = 0;
          do {
            for (m = -g; m < c; m++) h[m] = u(m);
            for (m = c + g; m > c; m--) h[m] = u(m);
            (h[c] = u(c)), g++;
          } while (h[c] !== l);
          return d[c].slice(1);
        }
        function Yo(t, e, i) {
          t.insertBefore(i, t.childNodes[e] || null);
        }
        function $o(t) {
          const e = t.parentNode;
          e && e.removeChild(t);
        }
        function Jo(t) {
          if (t) {
            if (t.defaultView) return t instanceof t.defaultView.Document;
            if (t.ownerDocument && t.ownerDocument.defaultView)
              return t instanceof t.ownerDocument.defaultView.Node;
          }
          return !1;
        }
        qo.fastDiff = Ho;
        class Go {
          constructor(t, e) {
            (this.domDocuments = new Set()),
              (this.domConverter = t),
              (this.markedAttributes = new Set()),
              (this.markedChildren = new Set()),
              (this.markedTexts = new Set()),
              (this.selection = e),
              (this.isFocused = !1),
              (this._inlineFiller = null),
              (this._fakeSelectionContainer = null);
          }
          markToSync(t, e) {
            if ("text" === t)
              this.domConverter.mapViewToDom(e.parent) &&
                this.markedTexts.add(e);
            else {
              if (!this.domConverter.mapViewToDom(e)) return;
              if ("attributes" === t) this.markedAttributes.add(e);
              else {
                if ("children" !== t)
                  throw new hi.b(
                    "view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.",
                    this
                  );
                this.markedChildren.add(e);
              }
            }
          }
          render() {
            let t;
            for (const t of this.markedChildren)
              this._updateChildrenMappings(t);
            this._inlineFiller &&
              !this._isSelectionInInlineFiller() &&
              this._removeInlineFiller(),
              this._inlineFiller
                ? (t = this._getInlineFillerPosition())
                : this._needsInlineFillerAtSelection() &&
                  ((t = this.selection.getFirstPosition()),
                  this.markedChildren.add(t.parent));
            for (const t of this.markedAttributes) this._updateAttrs(t);
            for (const e of this.markedChildren)
              this._updateChildren(e, { inlineFillerPosition: t });
            for (const e of this.markedTexts)
              !this.markedChildren.has(e.parent) &&
                this.domConverter.mapViewToDom(e.parent) &&
                this._updateText(e, { inlineFillerPosition: t });
            if (t) {
              const e = this.domConverter.viewPositionToDom(t),
                i = e.parent.ownerDocument;
              zo(e.parent)
                ? (this._inlineFiller = e.parent)
                : (this._inlineFiller = Qo(i, e.parent, e.offset));
            } else this._inlineFiller = null;
            this._updateSelection(),
              this._updateFocus(),
              this.markedTexts.clear(),
              this.markedAttributes.clear(),
              this.markedChildren.clear();
          }
          _updateChildrenMappings(t) {
            const e = this.domConverter.mapViewToDom(t);
            if (!e) return;
            const i = this.domConverter.mapViewToDom(t).childNodes,
              n = Array.from(
                this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
                  withChildren: !1,
                })
              ),
              o = this._diffNodeLists(i, n),
              r = this._findReplaceActions(o, i, n);
            if (-1 !== r.indexOf("replace")) {
              const e = { equal: 0, insert: 0, delete: 0 };
              for (const o of r)
                if ("replace" === o) {
                  const o = e.equal + e.insert,
                    r = e.equal + e.delete,
                    s = t.getChild(o);
                  s &&
                    !s.is("uiElement") &&
                    this._updateElementMappings(s, i[r]),
                    $o(n[o]),
                    e.equal++;
                } else e[o]++;
            }
          }
          _updateElementMappings(t, e) {
            this.domConverter.unbindDomElement(e),
              this.domConverter.bindElements(e, t),
              this.markedChildren.add(t),
              this.markedAttributes.add(t);
          }
          _getInlineFillerPosition() {
            const t = this.selection.getFirstPosition();
            return t.parent.is("text")
              ? Kn._createBefore(this.selection.getFirstPosition().parent)
              : t;
          }
          _isSelectionInInlineFiller() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
              return !1;
            const t = this.selection.getFirstPosition(),
              e = this.domConverter.viewPositionToDom(t);
            return !!(e && Ro(e.parent) && zo(e.parent));
          }
          _removeInlineFiller() {
            const t = this._inlineFiller;
            if (!zo(t))
              throw new hi.b(
                "view-renderer-filler-was-lost: The inline filler node was lost.",
                this
              );
            Bo(t) ? t.parentNode.removeChild(t) : (t.data = t.data.substr(7)),
              (this._inlineFiller = null);
          }
          _needsInlineFillerAtSelection() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
              return !1;
            const t = this.selection.getFirstPosition(),
              e = t.parent,
              i = t.offset;
            if (!this.domConverter.mapViewToDom(e.root)) return !1;
            if (!e.is("element")) return !1;
            if (
              !(function (t) {
                if ("false" == t.getAttribute("contenteditable")) return !1;
                const e = t.findAncestor((t) =>
                  t.hasAttribute("contenteditable")
                );
                return !e || "true" == e.getAttribute("contenteditable");
              })(e)
            )
              return !1;
            if (i === e.getFillerOffset()) return !1;
            const n = t.nodeBefore,
              o = t.nodeAfter;
            return !(n instanceof Ni || o instanceof Ni);
          }
          _updateText(t, e) {
            const i = this.domConverter.findCorrespondingDomText(t),
              n = this.domConverter.viewToDom(t, i.ownerDocument),
              o = i.data;
            let r = n.data;
            const s = e.inlineFillerPosition;
            if (
              (s && s.parent == t.parent && s.offset == t.index && (r = Do + r),
              o != r)
            ) {
              const t = Ho(o, r);
              for (const e of t)
                "insert" === e.type
                  ? i.insertData(e.index, e.values.join(""))
                  : i.deleteData(e.index, e.howMany);
            }
          }
          _updateAttrs(t) {
            const e = this.domConverter.mapViewToDom(t);
            if (!e) return;
            const i = Array.from(e.attributes).map((t) => t.name),
              n = t.getAttributeKeys();
            for (const i of n) e.setAttribute(i, t.getAttribute(i));
            for (const n of i) t.hasAttribute(n) || e.removeAttribute(n);
          }
          _updateChildren(t, e) {
            const i = this.domConverter.mapViewToDom(t);
            if (!i) return;
            const n = e.inlineFillerPosition,
              o = this.domConverter.mapViewToDom(t).childNodes,
              r = Array.from(
                this.domConverter.viewChildrenToDom(t, i.ownerDocument, {
                  bind: !0,
                  inlineFillerPosition: n,
                })
              );
            n && n.parent === t && Qo(i.ownerDocument, r, n.offset);
            const s = this._diffNodeLists(o, r);
            let a = 0;
            const l = new Set();
            for (const t of s)
              "delete" === t ? (l.add(o[a]), $o(o[a])) : "equal" === t && a++;
            a = 0;
            for (const t of s)
              "insert" === t
                ? (Yo(i, a, r[a]), a++)
                : "equal" === t &&
                  (this._markDescendantTextToSync(
                    this.domConverter.domToView(r[a])
                  ),
                  a++);
            for (const t of l)
              t.parentNode || this.domConverter.unbindDomElement(t);
          }
          _diffNodeLists(t, e) {
            return qo(
              (t = (function (t, e) {
                const i = Array.from(t);
                if (0 == i.length || !e) return i;
                i[i.length - 1] == e && i.pop();
                return i;
              })(t, this._fakeSelectionContainer)),
              e,
              Ko.bind(null, this.domConverter)
            );
          }
          _findReplaceActions(t, e, i) {
            if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete"))
              return t;
            let n = [],
              o = [],
              r = [];
            const s = { equal: 0, insert: 0, delete: 0 };
            for (const a of t)
              "insert" === a
                ? r.push(i[s.equal + s.insert])
                : "delete" === a
                ? o.push(e[s.equal + s.delete])
                : ((n = n.concat(
                    qo(o, r, Xo).map((t) => ("equal" === t ? "replace" : t))
                  )),
                  n.push("equal"),
                  (o = []),
                  (r = [])),
                s[a]++;
            return n.concat(
              qo(o, r, Xo).map((t) => ("equal" === t ? "replace" : t))
            );
          }
          _markDescendantTextToSync(t) {
            if (t)
              if (t.is("text")) this.markedTexts.add(t);
              else if (t.is("element"))
                for (const e of t.getChildren())
                  this._markDescendantTextToSync(e);
          }
          _updateSelection() {
            if (0 === this.selection.rangeCount)
              return (
                this._removeDomSelection(), void this._removeFakeSelection()
              );
            const t = this.domConverter.mapViewToDom(
              this.selection.editableElement
            );
            this.isFocused &&
              t &&
              (this.selection.isFake
                ? this._updateFakeSelection(t)
                : (this._removeFakeSelection(), this._updateDomSelection(t)));
          }
          _updateFakeSelection(t) {
            const e = t.ownerDocument;
            this._fakeSelectionContainer ||
              (this._fakeSelectionContainer = (function (t) {
                const e = t.createElement("div");
                return (
                  Object.assign(e.style, {
                    position: "fixed",
                    top: 0,
                    left: "-9999px",
                    width: "42px",
                  }),
                  (e.textContent = " "),
                  e
                );
              })(e));
            const i = this._fakeSelectionContainer;
            if (
              (this.domConverter.bindFakeSelection(i, this.selection),
              !this._fakeSelectionNeedsUpdate(t))
            )
              return;
            (i.parentElement && i.parentElement == t) || t.appendChild(i),
              (i.textContent = this.selection.fakeSelectionLabel || " ");
            const n = e.getSelection(),
              o = e.createRange();
            n.removeAllRanges(), o.selectNodeContents(i), n.addRange(o);
          }
          _updateDomSelection(t) {
            const e = t.ownerDocument.defaultView.getSelection();
            if (!this._domSelectionNeedsUpdate(e)) return;
            const i = this.domConverter.viewPositionToDom(
                this.selection.anchor
              ),
              n = this.domConverter.viewPositionToDom(this.selection.focus);
            t.focus(),
              e.collapse(i.parent, i.offset),
              e.extend(n.parent, n.offset),
              uo.isGecko &&
                (function (t, e) {
                  const i = t.parent;
                  if (
                    i.nodeType != Node.ELEMENT_NODE ||
                    t.offset != i.childNodes.length - 1
                  )
                    return;
                  const n = i.childNodes[t.offset];
                  n && "BR" == n.tagName && e.addRange(e.getRangeAt(0));
                })(n, e);
          }
          _domSelectionNeedsUpdate(t) {
            if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
            const e = t && this.domConverter.domSelectionToView(t);
            return (
              (!e || !this.selection.isEqual(e)) &&
              !(!this.selection.isCollapsed && this.selection.isSimilar(e))
            );
          }
          _fakeSelectionNeedsUpdate(t) {
            const e = this._fakeSelectionContainer,
              i = t.ownerDocument.getSelection();
            return (
              !e ||
              e.parentElement !== t ||
              (i.anchorNode !== e && !e.contains(i.anchorNode)) ||
              e.textContent !== this.selection.fakeSelectionLabel
            );
          }
          _removeDomSelection() {
            for (const t of this.domDocuments) {
              if (t.getSelection().rangeCount) {
                const e = t.activeElement,
                  i = this.domConverter.mapDomToView(e);
                e && i && t.getSelection().removeAllRanges();
              }
            }
          }
          _removeFakeSelection() {
            const t = this._fakeSelectionContainer;
            t && t.remove();
          }
          _updateFocus() {
            if (this.isFocused) {
              const t = this.selection.editableElement;
              t && this.domConverter.focus(t);
            }
          }
        }
        function Qo(t, e, i) {
          const n = e instanceof Array ? e : e.childNodes,
            o = n[i];
          if (Ro(o)) return (o.data = Do + o.data), o;
          {
            const o = t.createTextNode(Do);
            return Array.isArray(e) ? n.splice(i, 0, o) : Yo(e, i, o), o;
          }
        }
        function Xo(t, e) {
          return (
            Jo(t) &&
            Jo(e) &&
            !Ro(t) &&
            !Ro(e) &&
            t.tagName.toLowerCase() === e.tagName.toLowerCase()
          );
        }
        function Ko(t, e, i) {
          return (
            e === i ||
            (Ro(e) && Ro(i)
              ? e.data === i.data
              : !(!t.isBlockFiller(e) || !t.isBlockFiller(i)))
          );
        }
        yi(Go, Hn);
        var Zo = { window: window, document: document };
        function tr(t) {
          let e = 0;
          for (; t.previousSibling; ) (t = t.previousSibling), e++;
          return e;
        }
        function er(t) {
          const e = [];
          for (; t && t.nodeType != Node.DOCUMENT_NODE; )
            e.unshift(t), (t = t.parentNode);
          return e;
        }
        const ir = jo(document);
        class nr {
          constructor(t, e = {}) {
            (this.document = t),
              (this.blockFillerMode = e.blockFillerMode || "br"),
              (this.preElements = ["pre"]),
              (this.blockElements = [
                "p",
                "div",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "li",
                "dd",
                "dt",
                "figcaption",
              ]),
              (this._blockFiller = "br" == this.blockFillerMode ? jo : Lo),
              (this._domToViewMapping = new WeakMap()),
              (this._viewToDomMapping = new WeakMap()),
              (this._fakeSelectionMapping = new WeakMap());
          }
          bindFakeSelection(t, e) {
            this._fakeSelectionMapping.set(t, new io(e));
          }
          fakeSelectionToView(t) {
            return this._fakeSelectionMapping.get(t);
          }
          bindElements(t, e) {
            this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
          }
          unbindDomElement(t) {
            const e = this._domToViewMapping.get(t);
            if (e) {
              this._domToViewMapping.delete(t),
                this._viewToDomMapping.delete(e);
              for (const e of t.childNodes) this.unbindDomElement(e);
            }
          }
          bindDocumentFragments(t, e) {
            this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
          }
          viewToDom(t, e, i = {}) {
            if (t.is("text")) {
              const i = this._processDataFromViewText(t);
              return e.createTextNode(i);
            }
            {
              if (this.mapViewToDom(t)) return this.mapViewToDom(t);
              let n;
              if (t.is("documentFragment"))
                (n = e.createDocumentFragment()),
                  i.bind && this.bindDocumentFragments(n, t);
              else {
                if (t.is("uiElement"))
                  return (
                    (n = t.render(e)), i.bind && this.bindElements(n, t), n
                  );
                (n = t.hasAttribute("xmlns")
                  ? e.createElementNS(t.getAttribute("xmlns"), t.name)
                  : e.createElement(t.name)),
                  i.bind && this.bindElements(n, t);
                for (const e of t.getAttributeKeys())
                  n.setAttribute(e, t.getAttribute(e));
              }
              if (i.withChildren || void 0 === i.withChildren)
                for (const o of this.viewChildrenToDom(t, e, i))
                  n.appendChild(o);
              return n;
            }
          }
          *viewChildrenToDom(t, e, i = {}) {
            const n = t.getFillerOffset && t.getFillerOffset();
            let o = 0;
            for (const r of t.getChildren())
              n === o && (yield this._blockFiller(e)),
                yield this.viewToDom(r, e, i),
                o++;
            n === o && (yield this._blockFiller(e));
          }
          viewRangeToDom(t) {
            const e = this.viewPositionToDom(t.start),
              i = this.viewPositionToDom(t.end),
              n = document.createRange();
            return (
              n.setStart(e.parent, e.offset), n.setEnd(i.parent, i.offset), n
            );
          }
          viewPositionToDom(t) {
            const e = t.parent;
            if (e.is("text")) {
              const i = this.findCorrespondingDomText(e);
              if (!i) return null;
              let n = t.offset;
              return zo(i) && (n += 7), { parent: i, offset: n };
            }
            {
              let i, n, o;
              if (0 === t.offset) {
                if (((i = this.mapViewToDom(e)), !i)) return null;
                o = i.childNodes[0];
              } else {
                const e = t.nodeBefore;
                if (
                  ((n = e.is("text")
                    ? this.findCorrespondingDomText(e)
                    : this.mapViewToDom(t.nodeBefore)),
                  !n)
                )
                  return null;
                (i = n.parentNode), (o = n.nextSibling);
              }
              if (Ro(o) && zo(o)) return { parent: o, offset: 7 };
              return { parent: i, offset: n ? tr(n) + 1 : 0 };
            }
          }
          domToView(t, e = {}) {
            if (this.isBlockFiller(t, this.blockFillerMode)) return null;
            const i = this.getParentUIElement(t, this._domToViewMapping);
            if (i) return i;
            if (Ro(t)) {
              if (Bo(t)) return null;
              {
                const e = this._processDataFromDomText(t);
                return "" === e ? null : new Ni(this.document, e);
              }
            }
            if (this.isComment(t)) return null;
            {
              if (this.mapDomToView(t)) return this.mapDomToView(t);
              let i;
              if (this.isDocumentFragment(t))
                (i = new xo(this.document)),
                  e.bind && this.bindDocumentFragments(t, i);
              else {
                const n = e.keepOriginalCase
                  ? t.tagName
                  : t.tagName.toLowerCase();
                (i = new Nn(this.document, n)),
                  e.bind && this.bindElements(t, i);
                const o = t.attributes;
                for (let t = o.length - 1; t >= 0; t--)
                  i._setAttribute(o[t].name, o[t].value);
              }
              if (e.withChildren || void 0 === e.withChildren)
                for (const n of this.domChildrenToView(t, e)) i._appendChild(n);
              return i;
            }
          }
          *domChildrenToView(t, e = {}) {
            for (let i = 0; i < t.childNodes.length; i++) {
              const n = t.childNodes[i],
                o = this.domToView(n, e);
              null !== o && (yield o);
            }
          }
          domSelectionToView(t) {
            if (1 === t.rangeCount) {
              let e = t.getRangeAt(0).startContainer;
              Ro(e) && (e = e.parentNode);
              const i = this.fakeSelectionToView(e);
              if (i) return i;
            }
            const e = this.isDomSelectionBackward(t),
              i = [];
            for (let e = 0; e < t.rangeCount; e++) {
              const n = t.getRangeAt(e),
                o = this.domRangeToView(n);
              o && i.push(o);
            }
            return new io(i, { backward: e });
          }
          domRangeToView(t) {
            const e = this.domPositionToView(t.startContainer, t.startOffset),
              i = this.domPositionToView(t.endContainer, t.endOffset);
            return e && i ? new Zn(e, i) : null;
          }
          domPositionToView(t, e) {
            if (this.isBlockFiller(t, this.blockFillerMode))
              return this.domPositionToView(t.parentNode, tr(t));
            const i = this.mapDomToView(t);
            if (i && i.is("uiElement")) return Kn._createBefore(i);
            if (Ro(t)) {
              if (Bo(t)) return this.domPositionToView(t.parentNode, tr(t));
              const i = this.findCorrespondingViewText(t);
              let n = e;
              return i
                ? (zo(t) && ((n -= 7), (n = n < 0 ? 0 : n)), new Kn(i, n))
                : null;
            }
            if (0 === e) {
              const e = this.mapDomToView(t);
              if (e) return new Kn(e, 0);
            } else {
              const i = t.childNodes[e - 1],
                n = Ro(i)
                  ? this.findCorrespondingViewText(i)
                  : this.mapDomToView(i);
              if (n && n.parent) return new Kn(n.parent, n.index + 1);
            }
            return null;
          }
          mapDomToView(t) {
            return this.getParentUIElement(t) || this._domToViewMapping.get(t);
          }
          findCorrespondingViewText(t) {
            if (Bo(t)) return null;
            const e = this.getParentUIElement(t);
            if (e) return e;
            const i = t.previousSibling;
            if (i) {
              if (!this.isElement(i)) return null;
              const t = this.mapDomToView(i);
              if (t) {
                return t.nextSibling instanceof Ni ? t.nextSibling : null;
              }
            } else {
              const e = this.mapDomToView(t.parentNode);
              if (e) {
                const t = e.getChild(0);
                return t instanceof Ni ? t : null;
              }
            }
            return null;
          }
          mapViewToDom(t) {
            return this._viewToDomMapping.get(t);
          }
          findCorrespondingDomText(t) {
            const e = t.previousSibling;
            return e && this.mapViewToDom(e)
              ? this.mapViewToDom(e).nextSibling
              : !e && t.parent && this.mapViewToDom(t.parent)
              ? this.mapViewToDom(t.parent).childNodes[0]
              : null;
          }
          focus(t) {
            const e = this.mapViewToDom(t);
            if (e && e.ownerDocument.activeElement !== e) {
              const { scrollX: t, scrollY: i } = Zo.window,
                n = [];
              rr(e, (t) => {
                const { scrollLeft: e, scrollTop: i } = t;
                n.push([e, i]);
              }),
                e.focus(),
                rr(e, (t) => {
                  const [e, i] = n.shift();
                  (t.scrollLeft = e), (t.scrollTop = i);
                }),
                Zo.window.scrollTo(t, i);
            }
          }
          isElement(t) {
            return t && t.nodeType == Node.ELEMENT_NODE;
          }
          isDocumentFragment(t) {
            return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
          }
          isComment(t) {
            return t && t.nodeType == Node.COMMENT_NODE;
          }
          isBlockFiller(t) {
            return "br" == this.blockFillerMode
              ? t.isEqualNode(ir)
              : !(
                  "BR" !== t.tagName ||
                  !sr(t, this.blockElements) ||
                  1 !== t.parentNode.childNodes.length
                ) ||
                  (function (t, e) {
                    return (
                      Ro(t) &&
                      " " == t.data &&
                      sr(t, e) &&
                      1 === t.parentNode.childNodes.length
                    );
                  })(t, this.blockElements);
          }
          isDomSelectionBackward(t) {
            if (t.isCollapsed) return !1;
            const e = document.createRange();
            e.setStart(t.anchorNode, t.anchorOffset),
              e.setEnd(t.focusNode, t.focusOffset);
            const i = e.collapsed;
            return e.detach(), i;
          }
          getParentUIElement(t) {
            const e = er(t);
            for (e.pop(); e.length; ) {
              const t = e.pop(),
                i = this._domToViewMapping.get(t);
              if (i && i.is("uiElement")) return i;
            }
            return null;
          }
          isDomSelectionCorrect(t) {
            return (
              this._isDomSelectionPositionCorrect(
                t.anchorNode,
                t.anchorOffset
              ) &&
              this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset)
            );
          }
          _isDomSelectionPositionCorrect(t, e) {
            if (Ro(t) && zo(t) && e < 7) return !1;
            if (this.isElement(t) && zo(t.childNodes[e])) return !1;
            const i = this.mapDomToView(t);
            return !i || !i.is("uiElement");
          }
          _processDataFromViewText(t) {
            let e = t.data;
            if (t.getAncestors().some((t) => this.preElements.includes(t.name)))
              return e;
            if (" " == e.charAt(0)) {
              const i = this._getTouchingViewTextNode(t, !1);
              (!(i && this._nodeEndsWithSpace(i)) && i) ||
                (e = " " + e.substr(1));
            }
            if (" " == e.charAt(e.length - 1)) {
              const i = this._getTouchingViewTextNode(t, !0);
              (" " != e.charAt(e.length - 2) && i && " " != i.data.charAt(0)) ||
                (e = e.substr(0, e.length - 1) + " ");
            }
            return e.replace(/ {2}/g, "  ");
          }
          _nodeEndsWithSpace(t) {
            if (t.getAncestors().some((t) => this.preElements.includes(t.name)))
              return !1;
            const e = this._processDataFromViewText(t);
            return " " == e.charAt(e.length - 1);
          }
          _processDataFromDomText(t) {
            let e = t.data;
            if (or(t, this.preElements)) return Vo(t);
            e = e.replace(/[ \n\t\r]{1,}/g, " ");
            const i = this._getTouchingInlineDomNode(t, !1),
              n = this._getTouchingInlineDomNode(t, !0),
              o = this._checkShouldLeftTrimDomText(i),
              r = this._checkShouldRightTrimDomText(t, n);
            return (
              o && (e = e.replace(/^ /, "")),
              r && (e = e.replace(/ $/, "")),
              (e = Vo(new Text(e))),
              (e = e.replace(/ \u00A0/g, "  ")),
              (/( |\u00A0)\u00A0$/.test(e) ||
                !n ||
                (n.data && " " == n.data.charAt(0))) &&
                (e = e.replace(/\u00A0$/, " ")),
              o && (e = e.replace(/^\u00A0/, " ")),
              e
            );
          }
          _checkShouldLeftTrimDomText(t) {
            return (
              !t ||
              !!ii(t) ||
              /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1))
            );
          }
          _checkShouldRightTrimDomText(t, e) {
            return !e && !zo(t);
          }
          _getTouchingViewTextNode(t, e) {
            const i = new Xn({
              startPosition: e ? Kn._createAfter(t) : Kn._createBefore(t),
              direction: e ? "forward" : "backward",
            });
            for (const t of i) {
              if (t.item.is("containerElement")) return null;
              if (t.item.is("br")) return null;
              if (t.item.is("textProxy")) return t.item;
            }
            return null;
          }
          _getTouchingInlineDomNode(t, e) {
            if (!t.parentNode) return null;
            const i = e ? "nextNode" : "previousNode",
              n = t.ownerDocument,
              o = er(t)[0],
              r = n.createTreeWalker(
                o,
                NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
                {
                  acceptNode: (t) =>
                    Ro(t) || "BR" == t.tagName
                      ? NodeFilter.FILTER_ACCEPT
                      : NodeFilter.FILTER_SKIP,
                }
              );
            r.currentNode = t;
            const s = r[i]();
            if (null !== s) {
              const e = (function (t, e) {
                const i = er(t),
                  n = er(e);
                let o = 0;
                for (; i[o] == n[o] && i[o]; ) o++;
                return 0 === o ? null : i[o - 1];
              })(t, s);
              if (
                e &&
                !or(t, this.blockElements, e) &&
                !or(s, this.blockElements, e)
              )
                return s;
            }
            return null;
          }
        }
        function or(t, e, i) {
          let n = er(t);
          return (
            i && (n = n.slice(n.indexOf(i) + 1)),
            n.some((t) => t.tagName && e.includes(t.tagName.toLowerCase()))
          );
        }
        function rr(t, e) {
          for (; t && t != Zo.document; ) e(t), (t = t.parentNode);
        }
        function sr(t, e) {
          const i = t.parentNode;
          return i && i.tagName && e.includes(i.tagName.toLowerCase());
        }
        function ar(t) {
          const e = Object.prototype.toString.apply(t);
          return "[object Window]" == e || "[object global]" == e;
        }
        var lr = Dn({}, gi, {
          listenTo(t, ...e) {
            if (Jo(t) || ar(t)) {
              const i = this._getProxyEmitter(t) || new cr(t);
              i.attach(...e), (t = i);
            }
            gi.listenTo.call(this, t, ...e);
          },
          stopListening(t, e, i) {
            if (Jo(t) || ar(t)) {
              const e = this._getProxyEmitter(t);
              if (!e) return;
              t = e;
            }
            gi.stopListening.call(this, t, e, i),
              t instanceof cr && t.detach(e);
          },
          _getProxyEmitter(t) {
            return (
              (e = this),
              (i = dr(t)),
              e[ui] && e[ui][i] ? e[ui][i].emitter : null
            );
            var e, i;
          },
        });
        class cr {
          constructor(t) {
            fi(this, dr(t)), (this._domNode = t);
          }
        }
        function dr(t) {
          return t["data-ck-expando"] || (t["data-ck-expando"] = ci());
        }
        Dn(cr.prototype, gi, {
          attach(t, e, i = {}) {
            if (this._domListeners && this._domListeners[t]) return;
            const n = this._createDomListener(t, !!i.useCapture);
            this._domNode.addEventListener(t, n, !!i.useCapture),
              this._domListeners || (this._domListeners = {}),
              (this._domListeners[t] = n);
          },
          detach(t) {
            let e;
            !this._domListeners[t] ||
              ((e = this._events[t]) && e.callbacks.length) ||
              this._domListeners[t].removeListener();
          },
          _createDomListener(t, e) {
            const i = (e) => {
              this.fire(t, e);
            };
            return (
              (i.removeListener = () => {
                this._domNode.removeEventListener(t, i, e),
                  delete this._domListeners[t];
              }),
              i
            );
          },
        });
        class hr {
          constructor(t) {
            (this.view = t),
              (this.document = t.document),
              (this.isEnabled = !1);
          }
          enable() {
            this.isEnabled = !0;
          }
          disable() {
            this.isEnabled = !1;
          }
          destroy() {
            this.disable(), this.stopListening();
          }
        }
        yi(hr, lr);
        var ur = function (t) {
          return this.__data__.set(t, "__lodash_hash_undefined__"), this;
        };
        var mr = function (t) {
          return this.__data__.has(t);
        };
        function gr(t) {
          var e = -1,
            i = null == t ? 0 : t.length;
          for (this.__data__ = new _t(); ++e < i; ) this.add(t[e]);
        }
        (gr.prototype.add = gr.prototype.push = ur), (gr.prototype.has = mr);
        var fr = gr;
        var pr = function (t, e) {
          for (var i = -1, n = null == t ? 0 : t.length; ++i < n; )
            if (e(t[i], i, t)) return !0;
          return !1;
        };
        var br = function (t, e) {
          return t.has(e);
        };
        var wr = function (t, e, i, n, o, r) {
          var s = 1 & i,
            a = t.length,
            l = e.length;
          if (a != l && !(s && l > a)) return !1;
          var c = r.get(t);
          if (c && r.get(e)) return c == e;
          var d = -1,
            h = !0,
            u = 2 & i ? new fr() : void 0;
          for (r.set(t, e), r.set(e, t); ++d < a; ) {
            var m = t[d],
              g = e[d];
            if (n) var f = s ? n(g, m, d, e, t, r) : n(m, g, d, t, e, r);
            if (void 0 !== f) {
              if (f) continue;
              h = !1;
              break;
            }
            if (u) {
              if (
                !pr(e, function (t, e) {
                  if (!br(u, e) && (m === t || o(m, t, i, n, r)))
                    return u.push(e);
                })
              ) {
                h = !1;
                break;
              }
            } else if (m !== g && !o(m, g, i, n, r)) {
              h = !1;
              break;
            }
          }
          return r.delete(t), r.delete(e), h;
        };
        var _r = function (t) {
          var e = -1,
            i = Array(t.size);
          return (
            t.forEach(function (t, n) {
              i[++e] = [n, t];
            }),
            i
          );
        };
        var kr = function (t) {
            var e = -1,
              i = Array(t.size);
            return (
              t.forEach(function (t) {
                i[++e] = t;
              }),
              i
            );
          },
          vr = o ? o.prototype : void 0,
          yr = vr ? vr.valueOf : void 0;
        var xr = function (t, e, i, n, o, r, s) {
            switch (i) {
              case "[object DataView]":
                if (
                  t.byteLength != e.byteLength ||
                  t.byteOffset != e.byteOffset
                )
                  return !1;
                (t = t.buffer), (e = e.buffer);
              case "[object ArrayBuffer]":
                return !(
                  t.byteLength != e.byteLength || !r(new Re(t), new Re(e))
                );
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return A(+t, +e);
              case "[object Error]":
                return t.name == e.name && t.message == e.message;
              case "[object RegExp]":
              case "[object String]":
                return t == e + "";
              case "[object Map]":
                var a = _r;
              case "[object Set]":
                var l = 1 & n;
                if ((a || (a = kr), t.size != e.size && !l)) return !1;
                var c = s.get(t);
                if (c) return c == e;
                (n |= 2), s.set(t, e);
                var d = wr(a(t), a(e), n, o, r, s);
                return s.delete(t), d;
              case "[object Symbol]":
                if (yr) return yr.call(t) == yr.call(e);
            }
            return !1;
          },
          Ar = Object.prototype.hasOwnProperty;
        var Cr = function (t, e, i, n, o, r) {
            var s = 1 & i,
              a = _e(t),
              l = a.length;
            if (l != _e(e).length && !s) return !1;
            for (var c = l; c--; ) {
              var d = a[c];
              if (!(s ? d in e : Ar.call(e, d))) return !1;
            }
            var h = r.get(t);
            if (h && r.get(e)) return h == e;
            var u = !0;
            r.set(t, e), r.set(e, t);
            for (var m = s; ++c < l; ) {
              var g = t[(d = a[c])],
                f = e[d];
              if (n) var p = s ? n(f, g, d, e, t, r) : n(g, f, d, t, e, r);
              if (!(void 0 === p ? g === f || o(g, f, i, n, r) : p)) {
                u = !1;
                break;
              }
              m || (m = "constructor" == d);
            }
            if (u && !m) {
              var b = t.constructor,
                w = e.constructor;
              b == w ||
                !("constructor" in t) ||
                !("constructor" in e) ||
                ("function" == typeof b &&
                  b instanceof b &&
                  "function" == typeof w &&
                  w instanceof w) ||
                (u = !1);
            }
            return r.delete(t), r.delete(e), u;
          },
          Tr = Object.prototype.hasOwnProperty;
        var Mr = function (t, e, i, n, o, r) {
          var s = Lt(t),
            a = Lt(e),
            l = s ? "[object Array]" : Ie(t),
            c = a ? "[object Array]" : Ie(e),
            d =
              "[object Object]" ==
              (l = "[object Arguments]" == l ? "[object Object]" : l),
            h =
              "[object Object]" ==
              (c = "[object Arguments]" == c ? "[object Object]" : c),
            u = l == c;
          if (u && Object(jt.a)(t)) {
            if (!Object(jt.a)(e)) return !1;
            (s = !0), (d = !1);
          }
          if (u && !d)
            return (
              r || (r = new yt()),
              s || qt(t) ? wr(t, e, i, n, o, r) : xr(t, e, l, i, n, o, r)
            );
          if (!(1 & i)) {
            var m = d && Tr.call(t, "__wrapped__"),
              g = h && Tr.call(e, "__wrapped__");
            if (m || g) {
              var f = m ? t.value() : t,
                p = g ? e.value() : e;
              return r || (r = new yt()), o(f, p, i, n, r);
            }
          }
          return !!u && (r || (r = new yt()), Cr(t, e, i, n, o, r));
        };
        var Er = function t(e, i, n, o, r) {
          return (
            e === i ||
            (null == e || null == i || (!p(e) && !p(i))
              ? e != e && i != i
              : Mr(e, i, n, o, t, r))
          );
        };
        var Pr = function (t, e, i) {
          var n = (i = "function" == typeof i ? i : void 0) ? i(t, e) : void 0;
          return void 0 === n ? Er(t, e, void 0, i) : !!n;
        };
        class Sr extends hr {
          constructor(t) {
            super(t),
              (this._config = {
                childList: !0,
                characterData: !0,
                characterDataOldValue: !0,
                subtree: !0,
              }),
              (this.domConverter = t.domConverter),
              (this.renderer = t._renderer),
              (this._domElements = []),
              (this._mutationObserver = new window.MutationObserver(
                this._onMutations.bind(this)
              ));
          }
          flush() {
            this._onMutations(this._mutationObserver.takeRecords());
          }
          observe(t) {
            this._domElements.push(t),
              this.isEnabled && this._mutationObserver.observe(t, this._config);
          }
          enable() {
            super.enable();
            for (const t of this._domElements)
              this._mutationObserver.observe(t, this._config);
          }
          disable() {
            super.disable(), this._mutationObserver.disconnect();
          }
          destroy() {
            super.destroy(), this._mutationObserver.disconnect();
          }
          _onMutations(t) {
            if (0 === t.length) return;
            const e = this.domConverter,
              i = new Map(),
              n = new Set();
            for (const i of t)
              if ("childList" === i.type) {
                const t = e.mapDomToView(i.target);
                if (t && t.is("uiElement")) continue;
                t && !this._isBogusBrMutation(i) && n.add(t);
              }
            for (const o of t) {
              const t = e.mapDomToView(o.target);
              if ((!t || !t.is("uiElement")) && "characterData" === o.type) {
                const t = e.findCorrespondingViewText(o.target);
                t && !n.has(t.parent)
                  ? i.set(t, {
                      type: "text",
                      oldText: t.data,
                      newText: Vo(o.target),
                      node: t,
                    })
                  : !t &&
                    zo(o.target) &&
                    n.add(e.mapDomToView(o.target.parentNode));
              }
            }
            const o = [];
            for (const t of i.values())
              this.renderer.markToSync("text", t.node), o.push(t);
            for (const t of n) {
              const i = e.mapViewToDom(t),
                n = Array.from(t.getChildren()),
                r = Array.from(e.domChildrenToView(i, { withChildren: !1 }));
              Pr(n, r, a) ||
                (this.renderer.markToSync("children", t),
                o.push({
                  type: "children",
                  oldChildren: n,
                  newChildren: r,
                  node: t,
                }));
            }
            const r = t[0].target.ownerDocument.getSelection();
            let s = null;
            if (r && r.anchorNode) {
              const t = e.domPositionToView(r.anchorNode, r.anchorOffset),
                i = e.domPositionToView(r.focusNode, r.focusOffset);
              t && i && ((s = new io(t)), s.setFocus(i));
            }
            function a(t, e) {
              if (!Array.isArray(t))
                return (
                  t === e ||
                  (!(!t.is("text") || !e.is("text")) && t.data === e.data)
                );
            }
            o.length &&
              (this.document.fire("mutations", o, s), this.view.forceRender());
          }
          _isBogusBrMutation(t) {
            let e = null;
            return (
              null === t.nextSibling &&
                0 === t.removedNodes.length &&
                1 == t.addedNodes.length &&
                (e = this.domConverter.domToView(t.addedNodes[0], {
                  withChildren: !1,
                })),
              e && e.is("element", "br")
            );
          }
        }
        class Ir {
          constructor(t, e, i) {
            (this.view = t),
              (this.document = t.document),
              (this.domEvent = e),
              (this.domTarget = e.target),
              Dn(this, i);
          }
          get target() {
            return this.view.domConverter.mapDomToView(this.domTarget);
          }
          preventDefault() {
            this.domEvent.preventDefault();
          }
          stopPropagation() {
            this.domEvent.stopPropagation();
          }
        }
        class Or extends hr {
          constructor(t) {
            super(t), (this.useCapture = !1);
          }
          observe(t) {
            ("string" == typeof this.domEventType
              ? [this.domEventType]
              : this.domEventType
            ).forEach((e) => {
              this.listenTo(
                t,
                e,
                (t, e) => {
                  this.isEnabled && this.onDomEvent(e);
                },
                { useCapture: this.useCapture }
              );
            });
          }
          fire(t, e, i) {
            this.isEnabled && this.document.fire(t, new Ir(this.view, e, i));
          }
        }
        class Nr extends Or {
          constructor(t) {
            super(t), (this.domEventType = ["keydown", "keyup"]);
          }
          onDomEvent(t) {
            this.fire(t.type, t, {
              keyCode: t.keyCode,
              altKey: t.altKey,
              ctrlKey: t.ctrlKey || t.metaKey,
              shiftKey: t.shiftKey,
              get keystroke() {
                return po(this);
              },
            });
          }
        }
        var Rr = function () {
            return n.a.Date.now();
          },
          Lr = /^\s+|\s+$/g,
          jr = /^[-+]0x[0-9a-f]+$/i,
          Dr = /^0b[01]+$/i,
          zr = /^0o[0-7]+$/i,
          Br = parseInt;
        var Vr = function (t) {
            if ("number" == typeof t) return t;
            if (zi(t)) return NaN;
            if (D(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = D(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(Lr, "");
            var i = Dr.test(t);
            return i || zr.test(t)
              ? Br(t.slice(2), i ? 2 : 8)
              : jr.test(t)
              ? NaN
              : +t;
          },
          Fr = Math.max,
          Hr = Math.min;
        var Ur = function (t, e, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c = 0,
            d = !1,
            h = !1,
            u = !0;
          if ("function" != typeof t)
            throw new TypeError("Expected a function");
          function m(e) {
            var i = n,
              r = o;
            return (n = o = void 0), (c = e), (s = t.apply(r, i));
          }
          function g(t) {
            return (c = t), (a = setTimeout(p, e)), d ? m(t) : s;
          }
          function f(t) {
            var i = t - l;
            return void 0 === l || i >= e || i < 0 || (h && t - c >= r);
          }
          function p() {
            var t = Rr();
            if (f(t)) return b(t);
            a = setTimeout(
              p,
              (function (t) {
                var i = e - (t - l);
                return h ? Hr(i, r - (t - c)) : i;
              })(t)
            );
          }
          function b(t) {
            return (a = void 0), u && n ? m(t) : ((n = o = void 0), s);
          }
          function w() {
            var t = Rr(),
              i = f(t);
            if (((n = arguments), (o = this), (l = t), i)) {
              if (void 0 === a) return g(l);
              if (h) return clearTimeout(a), (a = setTimeout(p, e)), m(l);
            }
            return void 0 === a && (a = setTimeout(p, e)), s;
          }
          return (
            (e = Vr(e) || 0),
            D(i) &&
              ((d = !!i.leading),
              (r = (h = "maxWait" in i) ? Fr(Vr(i.maxWait) || 0, e) : r),
              (u = "trailing" in i ? !!i.trailing : u)),
            (w.cancel = function () {
              void 0 !== a && clearTimeout(a),
                (c = 0),
                (n = l = o = a = void 0);
            }),
            (w.flush = function () {
              return void 0 === a ? s : b(Rr());
            }),
            w
          );
        };
        class Wr extends hr {
          constructor(t) {
            super(t),
              (this._fireSelectionChangeDoneDebounced = Ur(
                (t) => this.document.fire("selectionChangeDone", t),
                200
              ));
          }
          observe() {
            const t = this.document;
            t.on(
              "keydown",
              (e, i) => {
                var n;
                t.selection.isFake &&
                  ((n = i.keyCode) == fo.arrowright ||
                    n == fo.arrowleft ||
                    n == fo.arrowup ||
                    n == fo.arrowdown) &&
                  this.isEnabled &&
                  (i.preventDefault(), this._handleSelectionMove(i.keyCode));
              },
              { priority: "lowest" }
            );
          }
          destroy() {
            super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
          }
          _handleSelectionMove(t) {
            const e = this.document.selection,
              i = new io(e.getRanges(), { backward: e.isBackward, fake: !1 });
            (t != fo.arrowleft && t != fo.arrowup) ||
              i.setTo(i.getFirstPosition()),
              (t != fo.arrowright && t != fo.arrowdown) ||
                i.setTo(i.getLastPosition());
            const n = { oldSelection: e, newSelection: i, domSelection: null };
            this.document.fire("selectionChange", n),
              this._fireSelectionChangeDoneDebounced(n);
          }
        }
        class qr extends hr {
          constructor(t) {
            super(t),
              (this.mutationObserver = t.getObserver(Sr)),
              (this.selection = this.document.selection),
              (this.domConverter = t.domConverter),
              (this._documents = new WeakSet()),
              (this._fireSelectionChangeDoneDebounced = Ur(
                (t) => this.document.fire("selectionChangeDone", t),
                200
              )),
              (this._clearInfiniteLoopInterval = setInterval(
                () => this._clearInfiniteLoop(),
                1e3
              )),
              (this._loopbackCounter = 0);
          }
          observe(t) {
            const e = t.ownerDocument;
            this._documents.has(e) ||
              (this.listenTo(e, "selectionchange", () => {
                this._handleSelectionChange(e);
              }),
              this._documents.add(e));
          }
          destroy() {
            super.destroy(),
              clearInterval(this._clearInfiniteLoopInterval),
              this._fireSelectionChangeDoneDebounced.cancel();
          }
          _handleSelectionChange(t) {
            if (!this.isEnabled) return;
            this.mutationObserver.flush();
            const e = t.defaultView.getSelection(),
              i = this.domConverter.domSelectionToView(e);
            if (0 != i.rangeCount) {
              if (
                ((this.view.hasDomSelection = !0),
                !(
                  (this.selection.isEqual(i) &&
                    this.domConverter.isDomSelectionCorrect(e)) ||
                  ++this._loopbackCounter > 60
                ))
              )
                if (this.selection.isSimilar(i)) this.view.forceRender();
                else {
                  const t = {
                    oldSelection: this.selection,
                    newSelection: i,
                    domSelection: e,
                  };
                  this.document.fire("selectionChange", t),
                    this._fireSelectionChangeDoneDebounced(t);
                }
            } else this.view.hasDomSelection = !1;
          }
          _clearInfiniteLoop() {
            this._loopbackCounter = 0;
          }
        }
        class Yr extends Or {
          constructor(t) {
            super(t),
              (this.domEventType = ["focus", "blur"]),
              (this.useCapture = !0);
            const e = this.document;
            e.on("focus", () => {
              (e.isFocused = !0),
                (this._renderTimeoutId = setTimeout(() => t.forceRender(), 50));
            }),
              e.on("blur", (i, n) => {
                const o = e.selection.editableElement;
                (null !== o && o !== n.target) ||
                  ((e.isFocused = !1), t.forceRender());
              });
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
          destroy() {
            this._renderTimeoutId && clearTimeout(this._renderTimeoutId),
              super.destroy();
          }
        }
        class $r extends Or {
          constructor(t) {
            super(t),
              (this.domEventType = [
                "compositionstart",
                "compositionupdate",
                "compositionend",
              ]);
            const e = this.document;
            e.on("compositionstart", () => {
              e.isComposing = !0;
            }),
              e.on("compositionend", () => {
                e.isComposing = !1;
              });
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
        }
        class Jr extends Or {
          constructor(t) {
            super(t), (this.domEventType = ["beforeinput"]);
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
        }
        function Gr(t) {
          return "[object Range]" == Object.prototype.toString.apply(t);
        }
        function Qr(t) {
          const e = t.ownerDocument.defaultView.getComputedStyle(t);
          return {
            top: parseInt(e.borderTopWidth, 10),
            right: parseInt(e.borderRightWidth, 10),
            bottom: parseInt(e.borderBottomWidth, 10),
            left: parseInt(e.borderLeftWidth, 10),
          };
        }
        const Xr = ["top", "right", "bottom", "left", "width", "height"];
        class Kr {
          constructor(t) {
            const e = Gr(t);
            if (
              (Object.defineProperty(this, "_source", {
                value: t._source || t,
                writable: !0,
                enumerable: !1,
              }),
              ii(t) || e)
            )
              Zr(
                this,
                e ? Kr.getDomRangeRects(t)[0] : t.getBoundingClientRect()
              );
            else if (ar(t)) {
              const { innerWidth: e, innerHeight: i } = t;
              Zr(this, {
                top: 0,
                right: e,
                bottom: i,
                left: 0,
                width: e,
                height: i,
              });
            } else Zr(this, t);
          }
          clone() {
            return new Kr(this);
          }
          moveTo(t, e) {
            return (
              (this.top = e),
              (this.right = t + this.width),
              (this.bottom = e + this.height),
              (this.left = t),
              this
            );
          }
          moveBy(t, e) {
            return (
              (this.top += e),
              (this.right += t),
              (this.left += t),
              (this.bottom += e),
              this
            );
          }
          getIntersection(t) {
            const e = {
              top: Math.max(this.top, t.top),
              right: Math.min(this.right, t.right),
              bottom: Math.min(this.bottom, t.bottom),
              left: Math.max(this.left, t.left),
            };
            return (
              (e.width = e.right - e.left),
              (e.height = e.bottom - e.top),
              e.width < 0 || e.height < 0 ? null : new Kr(e)
            );
          }
          getIntersectionArea(t) {
            const e = this.getIntersection(t);
            return e ? e.getArea() : 0;
          }
          getArea() {
            return this.width * this.height;
          }
          getVisible() {
            const t = this._source;
            let e = this.clone();
            if (!ts(t)) {
              let i = t.parentNode || t.commonAncestorContainer;
              for (; i && !ts(i); ) {
                const t = new Kr(i),
                  n = e.getIntersection(t);
                if (!n) return null;
                n.getArea() < e.getArea() && (e = n), (i = i.parentNode);
              }
            }
            return e;
          }
          isEqual(t) {
            for (const e of Xr) if (this[e] !== t[e]) return !1;
            return !0;
          }
          contains(t) {
            const e = this.getIntersection(t);
            return !(!e || !e.isEqual(t));
          }
          excludeScrollbarsAndBorders() {
            const t = this._source;
            let e, i, n;
            if (ar(t))
              (e = t.innerWidth - t.document.documentElement.clientWidth),
                (i = t.innerHeight - t.document.documentElement.clientHeight),
                (n = t.getComputedStyle(t.document.documentElement).direction);
            else {
              const o = Qr(this._source);
              (e = t.offsetWidth - t.clientWidth - o.left - o.right),
                (i = t.offsetHeight - t.clientHeight - o.top - o.bottom),
                (n = t.ownerDocument.defaultView.getComputedStyle(t).direction),
                (this.left += o.left),
                (this.top += o.top),
                (this.right -= o.right),
                (this.bottom -= o.bottom),
                (this.width = this.right - this.left),
                (this.height = this.bottom - this.top);
            }
            return (
              (this.width -= e),
              "ltr" === n ? (this.right -= e) : (this.left += e),
              (this.height -= i),
              (this.bottom -= i),
              this
            );
          }
          static getDomRangeRects(t) {
            const e = [],
              i = Array.from(t.getClientRects());
            if (i.length) for (const t of i) e.push(new Kr(t));
            else {
              let i = t.startContainer;
              Ro(i) && (i = i.parentNode);
              const n = new Kr(i.getBoundingClientRect());
              (n.right = n.left), (n.width = 0), e.push(n);
            }
            return e;
          }
        }
        function Zr(t, e) {
          for (const i of Xr) t[i] = e[i];
        }
        function ts(t) {
          return !!ii(t) && t === t.ownerDocument.body;
        }
        function es({ target: t, viewportOffset: e = 0 }) {
          const i = ls(t);
          let n = i,
            o = null;
          for (; n; ) {
            let r;
            (r = cs(n == i ? t : o)), ns(r, () => ds(t, n));
            const s = ds(t, n);
            if ((is(n, s, e), n.parent != n)) {
              if (((o = n.frameElement), (n = n.parent), !o)) return;
            } else n = null;
          }
        }
        function is(t, e, i) {
          const n = e.clone().moveBy(0, i),
            o = e.clone().moveBy(0, -i),
            r = new Kr(t).excludeScrollbarsAndBorders();
          if (![o, n].every((t) => r.contains(t))) {
            let { scrollX: s, scrollY: a } = t;
            rs(o, r)
              ? (a -= r.top - e.top + i)
              : os(n, r) && (a += e.bottom - r.bottom + i),
              ss(e, r)
                ? (s -= r.left - e.left + i)
                : as(e, r) && (s += e.right - r.right + i),
              t.scrollTo(s, a);
          }
        }
        function ns(t, e) {
          const i = ls(t);
          let n, o;
          for (; t != i.document.body; )
            (o = e()),
              (n = new Kr(t).excludeScrollbarsAndBorders()),
              n.contains(o) ||
                (rs(o, n)
                  ? (t.scrollTop -= n.top - o.top)
                  : os(o, n) && (t.scrollTop += o.bottom - n.bottom),
                ss(o, n)
                  ? (t.scrollLeft -= n.left - o.left)
                  : as(o, n) && (t.scrollLeft += o.right - n.right)),
              (t = t.parentNode);
        }
        function os(t, e) {
          return t.bottom > e.bottom;
        }
        function rs(t, e) {
          return t.top < e.top;
        }
        function ss(t, e) {
          return t.left < e.left;
        }
        function as(t, e) {
          return t.right > e.right;
        }
        function ls(t) {
          return Gr(t)
            ? t.startContainer.ownerDocument.defaultView
            : t.ownerDocument.defaultView;
        }
        function cs(t) {
          if (Gr(t)) {
            let e = t.commonAncestorContainer;
            return Ro(e) && (e = e.parentNode), e;
          }
          return t.parentNode;
        }
        function ds(t, e) {
          const i = ls(t),
            n = new Kr(t);
          if (i === e) return n;
          {
            let t = i;
            for (; t != e; ) {
              const e = t.frameElement,
                i = new Kr(e).excludeScrollbarsAndBorders();
              n.moveBy(i.left, i.top), (t = t.parent);
            }
          }
          return n;
        }
        Object.assign(
          {},
          {
            scrollViewportToShowTarget: es,
            scrollAncestorsToShowTarget: function (t) {
              ns(cs(t), () => new Kr(t));
            },
          }
        );
        class hs {
          constructor(t) {
            (this.document = new oo(t)),
              (this.domConverter = new nr(this.document)),
              (this.domRoots = new Map()),
              this.set("isRenderingInProgress", !1),
              this.set("hasDomSelection", !1),
              (this._renderer = new Go(
                this.domConverter,
                this.document.selection
              )),
              this._renderer.bind("isFocused").to(this.document),
              (this._initialDomRootAttributes = new WeakMap()),
              (this._observers = new Map()),
              (this._ongoingChange = !1),
              (this._postFixersInProgress = !1),
              (this._renderingDisabled = !1),
              (this._hasChangedSinceTheLastRendering = !1),
              (this._writer = new Ao(this.document)),
              this.addObserver(Sr),
              this.addObserver(qr),
              this.addObserver(Yr),
              this.addObserver(Nr),
              this.addObserver(Wr),
              this.addObserver($r),
              uo.isAndroid && this.addObserver(Jr),
              this.document.on("keydown", Fo),
              vo(this),
              this.on("render", () => {
                this._render(),
                  this.document.fire("layoutChanged"),
                  (this._hasChangedSinceTheLastRendering = !1);
              }),
              this.listenTo(this.document.selection, "change", () => {
                this._hasChangedSinceTheLastRendering = !0;
              });
          }
          attachDomRoot(t, e = "main") {
            const i = this.document.getRoot(e);
            i._name = t.tagName.toLowerCase();
            const n = {};
            for (const { name: e, value: o } of Array.from(t.attributes))
              (n[e] = o),
                "class" === e
                  ? this._writer.addClass(o.split(" "), i)
                  : this._writer.setAttribute(e, o, i);
            this._initialDomRootAttributes.set(t, n);
            const o = () => {
              this._writer.setAttribute("contenteditable", !i.isReadOnly, i),
                i.isReadOnly
                  ? this._writer.addClass("ck-read-only", i)
                  : this._writer.removeClass("ck-read-only", i);
            };
            o(),
              this.domRoots.set(e, t),
              this.domConverter.bindElements(t, i),
              this._renderer.markToSync("children", i),
              this._renderer.markToSync("attributes", i),
              this._renderer.domDocuments.add(t.ownerDocument),
              i.on("change:children", (t, e) =>
                this._renderer.markToSync("children", e)
              ),
              i.on("change:attributes", (t, e) =>
                this._renderer.markToSync("attributes", e)
              ),
              i.on("change:text", (t, e) =>
                this._renderer.markToSync("text", e)
              ),
              i.on("change:isReadOnly", () => this.change(o)),
              i.on("change", () => {
                this._hasChangedSinceTheLastRendering = !0;
              });
            for (const i of this._observers.values()) i.observe(t, e);
          }
          detachDomRoot(t) {
            const e = this.domRoots.get(t);
            Array.from(e.attributes).forEach(({ name: t }) =>
              e.removeAttribute(t)
            );
            const i = this._initialDomRootAttributes.get(e);
            for (const t in i) e.setAttribute(t, i[t]);
            this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
          }
          getDomRoot(t = "main") {
            return this.domRoots.get(t);
          }
          addObserver(t) {
            let e = this._observers.get(t);
            if (e) return e;
            (e = new t(this)), this._observers.set(t, e);
            for (const [t, i] of this.domRoots) e.observe(i, t);
            return e.enable(), e;
          }
          getObserver(t) {
            return this._observers.get(t);
          }
          disableObservers() {
            for (const t of this._observers.values()) t.disable();
          }
          enableObservers() {
            for (const t of this._observers.values()) t.enable();
          }
          scrollToTheSelection() {
            const t = this.document.selection.getFirstRange();
            t &&
              es({
                target: this.domConverter.viewRangeToDom(t),
                viewportOffset: 20,
              });
          }
          focus() {
            if (!this.document.isFocused) {
              const t = this.document.selection.editableElement;
              t && (this.domConverter.focus(t), this.forceRender());
            }
          }
          change(t) {
            if (this.isRenderingInProgress || this._postFixersInProgress)
              throw new hi.b(
                "cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.",
                this
              );
            try {
              if (this._ongoingChange) return t(this._writer);
              this._ongoingChange = !0;
              const e = t(this._writer);
              return (
                (this._ongoingChange = !1),
                !this._renderingDisabled &&
                  this._hasChangedSinceTheLastRendering &&
                  ((this._postFixersInProgress = !0),
                  this.document._callPostFixers(this._writer),
                  (this._postFixersInProgress = !1),
                  this.fire("render")),
                e
              );
            } catch (t) {
              hi.b.rethrowUnexpectedError(t, this);
            }
          }
          forceRender() {
            (this._hasChangedSinceTheLastRendering = !0), this.change(() => {});
          }
          destroy() {
            for (const t of this._observers.values()) t.destroy();
            this.document.destroy(), this.stopListening();
          }
          createPositionAt(t, e) {
            return Kn._createAt(t, e);
          }
          createPositionAfter(t) {
            return Kn._createAfter(t);
          }
          createPositionBefore(t) {
            return Kn._createBefore(t);
          }
          createRange(t, e) {
            return new Zn(t, e);
          }
          createRangeOn(t) {
            return Zn._createOn(t);
          }
          createRangeIn(t) {
            return Zn._createIn(t);
          }
          createSelection(t, e, i) {
            return new io(t, e, i);
          }
          _disableRendering(t) {
            (this._renderingDisabled = t), 0 == t && this.change(() => {});
          }
          _render() {
            (this.isRenderingInProgress = !0),
              this.disableObservers(),
              this._renderer.render(),
              this.enableObservers(),
              (this.isRenderingInProgress = !1);
          }
        }
        yi(hs, Hn);
        class us {
          constructor(t) {
            (this.parent = null), (this._attrs = Li(t));
          }
          get index() {
            let t;
            if (!this.parent) return null;
            if (null === (t = this.parent.getChildIndex(this)))
              throw new hi.b(
                "model-node-not-found-in-parent: The node's parent does not contain this node.",
                this
              );
            return t;
          }
          get startOffset() {
            let t;
            if (!this.parent) return null;
            if (null === (t = this.parent.getChildStartOffset(this)))
              throw new hi.b(
                "model-node-not-found-in-parent: The node's parent does not contain this node.",
                this
              );
            return t;
          }
          get offsetSize() {
            return 1;
          }
          get endOffset() {
            return this.parent ? this.startOffset + this.offsetSize : null;
          }
          get nextSibling() {
            const t = this.index;
            return (null !== t && this.parent.getChild(t + 1)) || null;
          }
          get previousSibling() {
            const t = this.index;
            return (null !== t && this.parent.getChild(t - 1)) || null;
          }
          get root() {
            let t = this;
            for (; t.parent; ) t = t.parent;
            return t;
          }
          isAttached() {
            return this.root.is("rootElement");
          }
          getPath() {
            const t = [];
            let e = this;
            for (; e.parent; ) t.unshift(e.startOffset), (e = e.parent);
            return t;
          }
          getAncestors(t = { includeSelf: !1, parentFirst: !1 }) {
            const e = [];
            let i = t.includeSelf ? this : this.parent;
            for (; i; )
              e[t.parentFirst ? "push" : "unshift"](i), (i = i.parent);
            return e;
          }
          getCommonAncestor(t, e = {}) {
            const i = this.getAncestors(e),
              n = t.getAncestors(e);
            let o = 0;
            for (; i[o] == n[o] && i[o]; ) o++;
            return 0 === o ? null : i[o - 1];
          }
          isBefore(t) {
            if (this == t) return !1;
            if (this.root !== t.root) return !1;
            const e = this.getPath(),
              i = t.getPath(),
              n = Si(e, i);
            switch (n) {
              case "prefix":
                return !0;
              case "extension":
                return !1;
              default:
                return e[n] < i[n];
            }
          }
          isAfter(t) {
            return this != t && this.root === t.root && !this.isBefore(t);
          }
          hasAttribute(t) {
            return this._attrs.has(t);
          }
          getAttribute(t) {
            return this._attrs.get(t);
          }
          getAttributes() {
            return this._attrs.entries();
          }
          getAttributeKeys() {
            return this._attrs.keys();
          }
          toJSON() {
            const t = {};
            return (
              this._attrs.size &&
                (t.attributes = Array.from(this._attrs).reduce(
                  (t, e) => ((t[e[0]] = e[1]), t),
                  {}
                )),
              t
            );
          }
          is(t) {
            return "node" === t || "model:node" === t;
          }
          _clone() {
            return new us(this._attrs);
          }
          _remove() {
            this.parent._removeChildren(this.index);
          }
          _setAttribute(t, e) {
            this._attrs.set(t, e);
          }
          _setAttributesTo(t) {
            this._attrs = Li(t);
          }
          _removeAttribute(t) {
            return this._attrs.delete(t);
          }
          _clearAttributes() {
            this._attrs.clear();
          }
        }
        class ms extends us {
          constructor(t, e) {
            super(e), (this._data = t || "");
          }
          get offsetSize() {
            return this.data.length;
          }
          get data() {
            return this._data;
          }
          is(t) {
            return (
              "text" === t ||
              "model:text" === t ||
              "node" === t ||
              "model:node" === t
            );
          }
          toJSON() {
            const t = super.toJSON();
            return (t.data = this.data), t;
          }
          _clone() {
            return new ms(this.data, this.getAttributes());
          }
          static fromJSON(t) {
            return new ms(t.data, t.attributes);
          }
        }
        class gs {
          constructor(t, e, i) {
            if (((this.textNode = t), e < 0 || e > t.offsetSize))
              throw new hi.b(
                "model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.",
                this
              );
            if (i < 0 || e + i > t.offsetSize)
              throw new hi.b(
                "model-textproxy-wrong-length: Given length value is incorrect.",
                this
              );
            (this.data = t.data.substring(e, e + i)), (this.offsetInText = e);
          }
          get startOffset() {
            return null !== this.textNode.startOffset
              ? this.textNode.startOffset + this.offsetInText
              : null;
          }
          get offsetSize() {
            return this.data.length;
          }
          get endOffset() {
            return null !== this.startOffset
              ? this.startOffset + this.offsetSize
              : null;
          }
          get isPartial() {
            return this.offsetSize !== this.textNode.offsetSize;
          }
          get parent() {
            return this.textNode.parent;
          }
          get root() {
            return this.textNode.root;
          }
          is(t) {
            return "textProxy" === t || "model:textProxy" === t;
          }
          getPath() {
            const t = this.textNode.getPath();
            return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
          }
          getAncestors(t = { includeSelf: !1, parentFirst: !1 }) {
            const e = [];
            let i = t.includeSelf ? this : this.parent;
            for (; i; )
              e[t.parentFirst ? "push" : "unshift"](i), (i = i.parent);
            return e;
          }
          hasAttribute(t) {
            return this.textNode.hasAttribute(t);
          }
          getAttribute(t) {
            return this.textNode.getAttribute(t);
          }
          getAttributes() {
            return this.textNode.getAttributes();
          }
          getAttributeKeys() {
            return this.textNode.getAttributeKeys();
          }
        }
        class fs {
          constructor(t) {
            (this._nodes = []), t && this._insertNodes(0, t);
          }
          [Symbol.iterator]() {
            return this._nodes[Symbol.iterator]();
          }
          get length() {
            return this._nodes.length;
          }
          get maxOffset() {
            return this._nodes.reduce((t, e) => t + e.offsetSize, 0);
          }
          getNode(t) {
            return this._nodes[t] || null;
          }
          getNodeIndex(t) {
            const e = this._nodes.indexOf(t);
            return -1 == e ? null : e;
          }
          getNodeStartOffset(t) {
            const e = this.getNodeIndex(t);
            return null === e
              ? null
              : this._nodes.slice(0, e).reduce((t, e) => t + e.offsetSize, 0);
          }
          indexToOffset(t) {
            if (t == this._nodes.length) return this.maxOffset;
            const e = this._nodes[t];
            if (!e)
              throw new hi.b(
                "model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.",
                this
              );
            return this.getNodeStartOffset(e);
          }
          offsetToIndex(t) {
            let e = 0;
            for (const i of this._nodes) {
              if (t >= e && t < e + i.offsetSize) return this.getNodeIndex(i);
              e += i.offsetSize;
            }
            if (e != t)
              throw new hi.b(
                "model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.",
                this,
                { offset: t, nodeList: this }
              );
            return this.length;
          }
          _insertNodes(t, e) {
            for (const t of e)
              if (!(t instanceof us))
                throw new hi.b(
                  "model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.",
                  this
                );
            this._nodes.splice(t, 0, ...e);
          }
          _removeNodes(t, e = 1) {
            return this._nodes.splice(t, e);
          }
          toJSON() {
            return this._nodes.map((t) => t.toJSON());
          }
        }
        class ps extends us {
          constructor(t, e, i) {
            super(e),
              (this.name = t),
              (this._children = new fs()),
              i && this._insertChild(0, i);
          }
          get childCount() {
            return this._children.length;
          }
          get maxOffset() {
            return this._children.maxOffset;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          is(t, e = null) {
            return e
              ? e === this.name && ("element" === t || "model:element" === t)
              : "element" === t ||
                  "model:element" === t ||
                  t === this.name ||
                  t === "model:" + this.name ||
                  "node" === t ||
                  "model:node" === t;
          }
          getChild(t) {
            return this._children.getNode(t);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          getChildIndex(t) {
            return this._children.getNodeIndex(t);
          }
          getChildStartOffset(t) {
            return this._children.getNodeStartOffset(t);
          }
          offsetToIndex(t) {
            return this._children.offsetToIndex(t);
          }
          getNodeByPath(t) {
            let e = this;
            for (const i of t) e = e.getChild(e.offsetToIndex(i));
            return e;
          }
          toJSON() {
            const t = super.toJSON();
            if (((t.name = this.name), this._children.length > 0)) {
              t.children = [];
              for (const e of this._children) t.children.push(e.toJSON());
            }
            return t;
          }
          _clone(t = !1) {
            const e = t
              ? Array.from(this._children).map((t) => t._clone(!0))
              : null;
            return new ps(this.name, this.getAttributes(), e);
          }
          _appendChild(t) {
            this._insertChild(this.childCount, t);
          }
          _insertChild(t, e) {
            const i = (function (t) {
              if ("string" == typeof t) return [new ms(t)];
              vi(t) || (t = [t]);
              return Array.from(t).map((t) =>
                "string" == typeof t
                  ? new ms(t)
                  : t instanceof gs
                  ? new ms(t.data, t.getAttributes())
                  : t
              );
            })(e);
            for (const t of i)
              null !== t.parent && t._remove(), (t.parent = this);
            this._children._insertNodes(t, i);
          }
          _removeChildren(t, e = 1) {
            const i = this._children._removeNodes(t, e);
            for (const t of i) t.parent = null;
            return i;
          }
          static fromJSON(t) {
            let e = null;
            if (t.children) {
              e = [];
              for (const i of t.children)
                i.name ? e.push(ps.fromJSON(i)) : e.push(ms.fromJSON(i));
            }
            return new ps(t.name, t.attributes, e);
          }
        }
        class bs {
          constructor(t = {}) {
            if (!t.boundaries && !t.startPosition)
              throw new hi.b(
                "model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.",
                null
              );
            const e = t.direction || "forward";
            if ("forward" != e && "backward" != e)
              throw new hi.b(
                "model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.",
                t,
                { direction: e }
              );
            (this.direction = e),
              (this.boundaries = t.boundaries || null),
              t.startPosition
                ? (this.position = t.startPosition.clone())
                : (this.position = _s._createAt(
                    this.boundaries[
                      "backward" == this.direction ? "end" : "start"
                    ]
                  )),
              (this.position.stickiness = "toNone"),
              (this.singleCharacters = !!t.singleCharacters),
              (this.shallow = !!t.shallow),
              (this.ignoreElementEnd = !!t.ignoreElementEnd),
              (this._boundaryStartParent = this.boundaries
                ? this.boundaries.start.parent
                : null),
              (this._boundaryEndParent = this.boundaries
                ? this.boundaries.end.parent
                : null),
              (this._visitedParent = this.position.parent);
          }
          [Symbol.iterator]() {
            return this;
          }
          skip(t) {
            let e, i, n, o;
            do {
              (n = this.position),
                (o = this._visitedParent),
                ({ done: e, value: i } = this.next());
            } while (!e && t(i));
            e || ((this.position = n), (this._visitedParent = o));
          }
          next() {
            return "forward" == this.direction
              ? this._next()
              : this._previous();
          }
          _next() {
            const t = this.position,
              e = this.position.clone(),
              i = this._visitedParent;
            if (null === i.parent && e.offset === i.maxOffset)
              return { done: !0 };
            if (
              i === this._boundaryEndParent &&
              e.offset == this.boundaries.end.offset
            )
              return { done: !0 };
            const n = e.parent,
              o = ks(e, n),
              r = o || vs(e, n, o);
            if (r instanceof ps)
              return (
                this.shallow
                  ? e.offset++
                  : (e.path.push(0), (this._visitedParent = r)),
                (this.position = e),
                ws("elementStart", r, t, e, 1)
              );
            if (r instanceof ms) {
              let n;
              if (this.singleCharacters) n = 1;
              else {
                let t = r.endOffset;
                this._boundaryEndParent == i &&
                  this.boundaries.end.offset < t &&
                  (t = this.boundaries.end.offset),
                  (n = t - e.offset);
              }
              const o = e.offset - r.startOffset,
                s = new gs(r, o, n);
              return (
                (e.offset += n), (this.position = e), ws("text", s, t, e, n)
              );
            }
            return (
              e.path.pop(),
              e.offset++,
              (this.position = e),
              (this._visitedParent = i.parent),
              this.ignoreElementEnd ? this._next() : ws("elementEnd", i, t, e)
            );
          }
          _previous() {
            const t = this.position,
              e = this.position.clone(),
              i = this._visitedParent;
            if (null === i.parent && 0 === e.offset) return { done: !0 };
            if (
              i == this._boundaryStartParent &&
              e.offset == this.boundaries.start.offset
            )
              return { done: !0 };
            const n = e.parent,
              o = ks(e, n),
              r = o || ys(e, n, o);
            if (r instanceof ps)
              return (
                e.offset--,
                this.shallow
                  ? ((this.position = e), ws("elementStart", r, t, e, 1))
                  : (e.path.push(r.maxOffset),
                    (this.position = e),
                    (this._visitedParent = r),
                    this.ignoreElementEnd
                      ? this._previous()
                      : ws("elementEnd", r, t, e))
              );
            if (r instanceof ms) {
              let n;
              if (this.singleCharacters) n = 1;
              else {
                let t = r.startOffset;
                this._boundaryStartParent == i &&
                  this.boundaries.start.offset > t &&
                  (t = this.boundaries.start.offset),
                  (n = e.offset - t);
              }
              const o = e.offset - r.startOffset,
                s = new gs(r, o - n, n);
              return (
                (e.offset -= n), (this.position = e), ws("text", s, t, e, n)
              );
            }
            return (
              e.path.pop(),
              (this.position = e),
              (this._visitedParent = i.parent),
              ws("elementStart", i, t, e, 1)
            );
          }
        }
        function ws(t, e, i, n, o) {
          return {
            done: !1,
            value: {
              type: t,
              item: e,
              previousPosition: i,
              nextPosition: n,
              length: o,
            },
          };
        }
        class _s {
          constructor(t, e, i = "toNone") {
            if (!t.is("element") && !t.is("documentFragment"))
              throw new hi.b(
                "model-position-root-invalid: Position root invalid.",
                t
              );
            if (!(e instanceof Array) || 0 === e.length)
              throw new hi.b(
                "model-position-path-incorrect-format: Position path must be an array with at least one item.",
                t,
                { path: e }
              );
            t.is("rootElement")
              ? (e = e.slice())
              : ((e = [...t.getPath(), ...e]), (t = t.root)),
              (this.root = t),
              (this.path = e),
              (this.stickiness = i);
          }
          get offset() {
            return this.path[this.path.length - 1];
          }
          set offset(t) {
            this.path[this.path.length - 1] = t;
          }
          get parent() {
            let t = this.root;
            for (let e = 0; e < this.path.length - 1; e++)
              if (((t = t.getChild(t.offsetToIndex(this.path[e]))), !t))
                throw new hi.b(
                  "model-position-path-incorrect: The position's path is incorrect.",
                  this,
                  { position: this }
                );
            if (t.is("text"))
              throw new hi.b(
                "model-position-path-incorrect: The position's path is incorrect.",
                this,
                { position: this }
              );
            return t;
          }
          get index() {
            return this.parent.offsetToIndex(this.offset);
          }
          get textNode() {
            return ks(this, this.parent);
          }
          get nodeAfter() {
            const t = this.parent;
            return vs(this, t, ks(this, t));
          }
          get nodeBefore() {
            const t = this.parent;
            return ys(this, t, ks(this, t));
          }
          get isAtStart() {
            return 0 === this.offset;
          }
          get isAtEnd() {
            return this.offset == this.parent.maxOffset;
          }
          compareWith(t) {
            if (this.root != t.root) return "different";
            const e = Si(this.path, t.path);
            switch (e) {
              case "same":
                return "same";
              case "prefix":
                return "before";
              case "extension":
                return "after";
              default:
                return this.path[e] < t.path[e] ? "before" : "after";
            }
          }
          getLastMatchingPosition(t, e = {}) {
            e.startPosition = this;
            const i = new bs(e);
            return i.skip(t), i.position;
          }
          getParentPath() {
            return this.path.slice(0, -1);
          }
          getAncestors() {
            const t = this.parent;
            return t.is("documentFragment")
              ? [t]
              : t.getAncestors({ includeSelf: !0 });
          }
          getCommonPath(t) {
            if (this.root != t.root) return [];
            const e = Si(this.path, t.path),
              i =
                "string" == typeof e
                  ? Math.min(this.path.length, t.path.length)
                  : e;
            return this.path.slice(0, i);
          }
          getCommonAncestor(t) {
            const e = this.getAncestors(),
              i = t.getAncestors();
            let n = 0;
            for (; e[n] == i[n] && e[n]; ) n++;
            return 0 === n ? null : e[n - 1];
          }
          getShiftedBy(t) {
            const e = this.clone(),
              i = e.offset + t;
            return (e.offset = i < 0 ? 0 : i), e;
          }
          isAfter(t) {
            return "after" == this.compareWith(t);
          }
          isBefore(t) {
            return "before" == this.compareWith(t);
          }
          isEqual(t) {
            return "same" == this.compareWith(t);
          }
          isTouching(t) {
            let e = null,
              i = null;
            switch (this.compareWith(t)) {
              case "same":
                return !0;
              case "before":
                (e = _s._createAt(this)), (i = _s._createAt(t));
                break;
              case "after":
                (e = _s._createAt(t)), (i = _s._createAt(this));
                break;
              default:
                return !1;
            }
            let n = e.parent;
            for (; e.path.length + i.path.length; ) {
              if (e.isEqual(i)) return !0;
              if (e.path.length > i.path.length) {
                if (e.offset !== n.maxOffset) return !1;
                (e.path = e.path.slice(0, -1)), (n = n.parent), e.offset++;
              } else {
                if (0 !== i.offset) return !1;
                i.path = i.path.slice(0, -1);
              }
            }
          }
          is(t) {
            return "position" === t || "model:position" === t;
          }
          hasSameParentAs(t) {
            if (this.root !== t.root) return !1;
            return "same" == Si(this.getParentPath(), t.getParentPath());
          }
          getTransformedByOperation(t) {
            let e;
            switch (t.type) {
              case "insert":
                e = this._getTransformedByInsertOperation(t);
                break;
              case "move":
              case "remove":
              case "reinsert":
                e = this._getTransformedByMoveOperation(t);
                break;
              case "split":
                e = this._getTransformedBySplitOperation(t);
                break;
              case "merge":
                e = this._getTransformedByMergeOperation(t);
                break;
              default:
                e = _s._createAt(this);
            }
            return e;
          }
          _getTransformedByInsertOperation(t) {
            return this._getTransformedByInsertion(t.position, t.howMany);
          }
          _getTransformedByMoveOperation(t) {
            return this._getTransformedByMove(
              t.sourcePosition,
              t.targetPosition,
              t.howMany
            );
          }
          _getTransformedBySplitOperation(t) {
            const e = t.movedRange;
            return e.containsPosition(this) ||
              (e.start.isEqual(this) && "toNext" == this.stickiness)
              ? this._getCombined(t.splitPosition, t.moveTargetPosition)
              : t.graveyardPosition
              ? this._getTransformedByMove(
                  t.graveyardPosition,
                  t.insertionPosition,
                  1
                )
              : this._getTransformedByInsertion(t.insertionPosition, 1);
          }
          _getTransformedByMergeOperation(t) {
            const e = t.movedRange;
            let i;
            return (
              e.containsPosition(this) || e.start.isEqual(this)
                ? ((i = this._getCombined(t.sourcePosition, t.targetPosition)),
                  t.sourcePosition.isBefore(t.targetPosition) &&
                    (i = i._getTransformedByDeletion(t.deletionPosition, 1)))
                : (i = this.isEqual(t.deletionPosition)
                    ? _s._createAt(t.deletionPosition)
                    : this._getTransformedByMove(
                        t.deletionPosition,
                        t.graveyardPosition,
                        1
                      )),
              i
            );
          }
          _getTransformedByDeletion(t, e) {
            const i = _s._createAt(this);
            if (this.root != t.root) return i;
            if ("same" == Si(t.getParentPath(), this.getParentPath())) {
              if (t.offset < this.offset) {
                if (t.offset + e > this.offset) return null;
                i.offset -= e;
              }
            } else if (
              "prefix" == Si(t.getParentPath(), this.getParentPath())
            ) {
              const n = t.path.length - 1;
              if (t.offset <= this.path[n]) {
                if (t.offset + e > this.path[n]) return null;
                i.path[n] -= e;
              }
            }
            return i;
          }
          _getTransformedByInsertion(t, e) {
            const i = _s._createAt(this);
            if (this.root != t.root) return i;
            if ("same" == Si(t.getParentPath(), this.getParentPath()))
              (t.offset < this.offset ||
                (t.offset == this.offset && "toPrevious" != this.stickiness)) &&
                (i.offset += e);
            else if ("prefix" == Si(t.getParentPath(), this.getParentPath())) {
              const n = t.path.length - 1;
              t.offset <= this.path[n] && (i.path[n] += e);
            }
            return i;
          }
          _getTransformedByMove(t, e, i) {
            if (((e = e._getTransformedByDeletion(t, i)), t.isEqual(e)))
              return _s._createAt(this);
            const n = this._getTransformedByDeletion(t, i);
            return null === n ||
              (t.isEqual(this) && "toNext" == this.stickiness) ||
              (t.getShiftedBy(i).isEqual(this) &&
                "toPrevious" == this.stickiness)
              ? this._getCombined(t, e)
              : n._getTransformedByInsertion(e, i);
          }
          _getCombined(t, e) {
            const i = t.path.length - 1,
              n = _s._createAt(e);
            return (
              (n.stickiness = this.stickiness),
              (n.offset = n.offset + this.path[i] - t.offset),
              (n.path = [...n.path, ...this.path.slice(i + 1)]),
              n
            );
          }
          toJSON() {
            return {
              root: this.root.toJSON(),
              path: Array.from(this.path),
              stickiness: this.stickiness,
            };
          }
          clone() {
            return new this.constructor(this.root, this.path, this.stickiness);
          }
          static _createAt(t, e, i = "toNone") {
            if (t instanceof _s) return new _s(t.root, t.path, t.stickiness);
            {
              const n = t;
              if ("end" == e) e = n.maxOffset;
              else {
                if ("before" == e) return this._createBefore(n, i);
                if ("after" == e) return this._createAfter(n, i);
                if (0 !== e && !e)
                  throw new hi.b(
                    "model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.",
                    [this, t]
                  );
              }
              if (!n.is("element") && !n.is("documentFragment"))
                throw new hi.b(
                  "model-position-parent-incorrect: Position parent have to be a element or document fragment.",
                  [this, t]
                );
              const o = n.getPath();
              return o.push(e), new this(n.root, o, i);
            }
          }
          static _createAfter(t, e) {
            if (!t.parent)
              throw new hi.b(
                "model-position-after-root: You cannot make a position after root.",
                [this, t],
                { root: t }
              );
            return this._createAt(t.parent, t.endOffset, e);
          }
          static _createBefore(t, e) {
            if (!t.parent)
              throw new hi.b(
                "model-position-before-root: You cannot make a position before root.",
                t,
                { root: t }
              );
            return this._createAt(t.parent, t.startOffset, e);
          }
          static fromJSON(t, e) {
            if ("$graveyard" === t.root) {
              const i = new _s(e.graveyard, t.path);
              return (i.stickiness = t.stickiness), i;
            }
            if (!e.getRoot(t.root))
              throw new hi.b(
                "model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.",
                e,
                { rootName: t.root }
              );
            return new _s(e.getRoot(t.root), t.path, t.stickiness);
          }
        }
        function ks(t, e) {
          const i = e.getChild(e.offsetToIndex(t.offset));
          return i && i.is("text") && i.startOffset < t.offset ? i : null;
        }
        function vs(t, e, i) {
          return null !== i ? null : e.getChild(e.offsetToIndex(t.offset));
        }
        function ys(t, e, i) {
          return null !== i ? null : e.getChild(e.offsetToIndex(t.offset) - 1);
        }
        class xs {
          constructor(t, e = null) {
            (this.start = _s._createAt(t)),
              (this.end = e ? _s._createAt(e) : _s._createAt(t)),
              (this.start.stickiness = this.isCollapsed ? "toNone" : "toNext"),
              (this.end.stickiness = this.isCollapsed
                ? "toNone"
                : "toPrevious");
          }
          *[Symbol.iterator]() {
            yield* new bs({ boundaries: this, ignoreElementEnd: !0 });
          }
          get isCollapsed() {
            return this.start.isEqual(this.end);
          }
          get isFlat() {
            return (
              "same" == Si(this.start.getParentPath(), this.end.getParentPath())
            );
          }
          get root() {
            return this.start.root;
          }
          containsPosition(t) {
            return t.isAfter(this.start) && t.isBefore(this.end);
          }
          containsRange(t, e = !1) {
            t.isCollapsed && (e = !1);
            const i =
                this.containsPosition(t.start) ||
                (e && this.start.isEqual(t.start)),
              n =
                this.containsPosition(t.end) || (e && this.end.isEqual(t.end));
            return i && n;
          }
          containsItem(t) {
            const e = _s._createBefore(t);
            return this.containsPosition(e) || this.start.isEqual(e);
          }
          is(t) {
            return "range" === t || "model:range" === t;
          }
          isEqual(t) {
            return this.start.isEqual(t.start) && this.end.isEqual(t.end);
          }
          isIntersecting(t) {
            return this.start.isBefore(t.end) && this.end.isAfter(t.start);
          }
          getDifference(t) {
            const e = [];
            return (
              this.isIntersecting(t)
                ? (this.containsPosition(t.start) &&
                    e.push(new xs(this.start, t.start)),
                  this.containsPosition(t.end) &&
                    e.push(new xs(t.end, this.end)))
                : e.push(new xs(this.start, this.end)),
              e
            );
          }
          getIntersection(t) {
            if (this.isIntersecting(t)) {
              let e = this.start,
                i = this.end;
              return (
                this.containsPosition(t.start) && (e = t.start),
                this.containsPosition(t.end) && (i = t.end),
                new xs(e, i)
              );
            }
            return null;
          }
          getMinimalFlatRanges() {
            const t = [],
              e = this.start.getCommonPath(this.end).length,
              i = _s._createAt(this.start);
            let n = i.parent;
            for (; i.path.length > e + 1; ) {
              const e = n.maxOffset - i.offset;
              0 !== e && t.push(new xs(i, i.getShiftedBy(e))),
                (i.path = i.path.slice(0, -1)),
                i.offset++,
                (n = n.parent);
            }
            for (; i.path.length <= this.end.path.length; ) {
              const e = this.end.path[i.path.length - 1],
                n = e - i.offset;
              0 !== n && t.push(new xs(i, i.getShiftedBy(n))),
                (i.offset = e),
                i.path.push(0);
            }
            return t;
          }
          getWalker(t = {}) {
            return (t.boundaries = this), new bs(t);
          }
          *getItems(t = {}) {
            (t.boundaries = this), (t.ignoreElementEnd = !0);
            const e = new bs(t);
            for (const t of e) yield t.item;
          }
          *getPositions(t = {}) {
            t.boundaries = this;
            const e = new bs(t);
            yield e.position;
            for (const t of e) yield t.nextPosition;
          }
          getTransformedByOperation(t) {
            switch (t.type) {
              case "insert":
                return this._getTransformedByInsertOperation(t);
              case "move":
              case "remove":
              case "reinsert":
                return this._getTransformedByMoveOperation(t);
              case "split":
                return [this._getTransformedBySplitOperation(t)];
              case "merge":
                return [this._getTransformedByMergeOperation(t)];
            }
            return [new xs(this.start, this.end)];
          }
          getTransformedByOperations(t) {
            const e = [new xs(this.start, this.end)];
            for (const i of t)
              for (let t = 0; t < e.length; t++) {
                const n = e[t].getTransformedByOperation(i);
                e.splice(t, 1, ...n), (t += n.length - 1);
              }
            for (let t = 0; t < e.length; t++) {
              const i = e[t];
              for (let n = t + 1; n < e.length; n++) {
                const t = e[n];
                (i.containsRange(t) || t.containsRange(i) || i.isEqual(t)) &&
                  e.splice(n, 1);
              }
            }
            return e;
          }
          getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
          getContainedElement() {
            if (this.isCollapsed) return null;
            const t = this.start.nodeAfter,
              e = this.end.nodeBefore;
            return t && t.is("element") && t === e ? t : null;
          }
          toJSON() {
            return { start: this.start.toJSON(), end: this.end.toJSON() };
          }
          clone() {
            return new this.constructor(this.start, this.end);
          }
          _getTransformedByInsertOperation(t, e = !1) {
            return this._getTransformedByInsertion(t.position, t.howMany, e);
          }
          _getTransformedByMoveOperation(t, e = !1) {
            const i = t.sourcePosition,
              n = t.howMany,
              o = t.targetPosition;
            return this._getTransformedByMove(i, o, n, e);
          }
          _getTransformedBySplitOperation(t) {
            const e = this.start._getTransformedBySplitOperation(t);
            let i = this.end._getTransformedBySplitOperation(t);
            return (
              this.end.isEqual(t.insertionPosition) &&
                (i = this.end.getShiftedBy(1)),
              e.root != i.root && (i = this.end.getShiftedBy(-1)),
              new xs(e, i)
            );
          }
          _getTransformedByMergeOperation(t) {
            if (
              this.start.isEqual(t.targetPosition) &&
              this.end.isEqual(t.deletionPosition)
            )
              return new xs(this.start);
            let e = this.start._getTransformedByMergeOperation(t),
              i = this.end._getTransformedByMergeOperation(t);
            return (
              e.root != i.root && (i = this.end.getShiftedBy(-1)),
              e.isAfter(i)
                ? (t.sourcePosition.isBefore(t.targetPosition)
                    ? ((e = _s._createAt(i)), (e.offset = 0))
                    : (t.deletionPosition.isEqual(e) ||
                        (i = t.deletionPosition),
                      (e = t.targetPosition)),
                  new xs(e, i))
                : new xs(e, i)
            );
          }
          _getTransformedByInsertion(t, e, i = !1) {
            if (i && this.containsPosition(t))
              return [
                new xs(this.start, t),
                new xs(
                  t.getShiftedBy(e),
                  this.end._getTransformedByInsertion(t, e)
                ),
              ];
            {
              const i = new xs(this.start, this.end);
              return (
                (i.start = i.start._getTransformedByInsertion(t, e)),
                (i.end = i.end._getTransformedByInsertion(t, e)),
                [i]
              );
            }
          }
          _getTransformedByMove(t, e, i, n = !1) {
            if (this.isCollapsed) {
              const n = this.start._getTransformedByMove(t, e, i);
              return [new xs(n)];
            }
            const o = xs._createFromPositionAndShift(t, i),
              r = e._getTransformedByDeletion(t, i);
            if (
              this.containsPosition(e) &&
              !n &&
              (o.containsPosition(this.start) || o.containsPosition(this.end))
            ) {
              const n = this.start._getTransformedByMove(t, e, i),
                o = this.end._getTransformedByMove(t, e, i);
              return [new xs(n, o)];
            }
            let s;
            const a = this.getDifference(o);
            let l = null;
            const c = this.getIntersection(o);
            if (
              (1 == a.length
                ? (l = new xs(
                    a[0].start._getTransformedByDeletion(t, i),
                    a[0].end._getTransformedByDeletion(t, i)
                  ))
                : 2 == a.length &&
                  (l = new xs(
                    this.start,
                    this.end._getTransformedByDeletion(t, i)
                  )),
              (s = l
                ? l._getTransformedByInsertion(r, i, null !== c || n)
                : []),
              c)
            ) {
              const t = new xs(
                c.start._getCombined(o.start, r),
                c.end._getCombined(o.start, r)
              );
              2 == s.length ? s.splice(1, 0, t) : s.push(t);
            }
            return s;
          }
          _getTransformedByDeletion(t, e) {
            let i = this.start._getTransformedByDeletion(t, e),
              n = this.end._getTransformedByDeletion(t, e);
            return null == i && null == n
              ? null
              : (null == i && (i = t), null == n && (n = t), new xs(i, n));
          }
          static _createFromPositionAndShift(t, e) {
            const i = t,
              n = t.getShiftedBy(e);
            return e > 0 ? new this(i, n) : new this(n, i);
          }
          static _createIn(t) {
            return new this(_s._createAt(t, 0), _s._createAt(t, t.maxOffset));
          }
          static _createOn(t) {
            return this._createFromPositionAndShift(
              _s._createBefore(t),
              t.offsetSize
            );
          }
          static _createFromRanges(t) {
            if (0 === t.length)
              throw new hi.b(
                "range-create-from-ranges-empty-array: At least one range has to be passed.",
                null
              );
            if (1 == t.length) return t[0].clone();
            const e = t[0];
            t.sort((t, e) => (t.start.isAfter(e.start) ? 1 : -1));
            const i = t.indexOf(e),
              n = new this(e.start, e.end);
            if (i > 0)
              for (let e = i - 1; t[e].end.isEqual(n.start); e++)
                n.start = _s._createAt(t[e].start);
            for (let e = i + 1; e < t.length && t[e].start.isEqual(n.end); e++)
              n.end = _s._createAt(t[e].end);
            return n;
          }
          static fromJSON(t, e) {
            return new this(_s.fromJSON(t.start, e), _s.fromJSON(t.end, e));
          }
        }
        class As {
          constructor() {
            (this._modelToViewMapping = new WeakMap()),
              (this._viewToModelMapping = new WeakMap()),
              (this._viewToModelLengthCallbacks = new Map()),
              (this._markerNameToElements = new Map()),
              (this._elementToMarkerNames = new Map()),
              (this._unboundMarkerNames = new Set()),
              this.on(
                "modelToViewPosition",
                (t, e) => {
                  if (e.viewPosition) return;
                  const i = this._modelToViewMapping.get(
                    e.modelPosition.parent
                  );
                  e.viewPosition = this._findPositionIn(
                    i,
                    e.modelPosition.offset
                  );
                },
                { priority: "low" }
              ),
              this.on(
                "viewToModelPosition",
                (t, e) => {
                  if (e.modelPosition) return;
                  const i = this.findMappedViewAncestor(e.viewPosition),
                    n = this._viewToModelMapping.get(i),
                    o = this._toModelOffset(
                      e.viewPosition.parent,
                      e.viewPosition.offset,
                      i
                    );
                  e.modelPosition = _s._createAt(n, o);
                },
                { priority: "low" }
              );
          }
          bindElements(t, e) {
            this._modelToViewMapping.set(t, e),
              this._viewToModelMapping.set(e, t);
          }
          unbindViewElement(t) {
            const e = this.toModelElement(t);
            if (
              (this._viewToModelMapping.delete(t),
              this._elementToMarkerNames.has(t))
            )
              for (const e of this._elementToMarkerNames.get(t))
                this._unboundMarkerNames.add(e);
            this._modelToViewMapping.get(e) == t &&
              this._modelToViewMapping.delete(e);
          }
          unbindModelElement(t) {
            const e = this.toViewElement(t);
            this._modelToViewMapping.delete(t),
              this._viewToModelMapping.get(e) == t &&
                this._viewToModelMapping.delete(e);
          }
          bindElementToMarker(t, e) {
            const i = this._markerNameToElements.get(e) || new Set();
            i.add(t);
            const n = this._elementToMarkerNames.get(t) || new Set();
            n.add(e),
              this._markerNameToElements.set(e, i),
              this._elementToMarkerNames.set(t, n);
          }
          unbindElementFromMarkerName(t, e) {
            const i = this._markerNameToElements.get(e);
            i &&
              (i.delete(t),
              0 == i.size && this._markerNameToElements.delete(e));
            const n = this._elementToMarkerNames.get(t);
            n &&
              (n.delete(e),
              0 == n.size && this._elementToMarkerNames.delete(t));
          }
          flushUnboundMarkerNames() {
            const t = Array.from(this._unboundMarkerNames);
            return this._unboundMarkerNames.clear(), t;
          }
          clearBindings() {
            (this._modelToViewMapping = new WeakMap()),
              (this._viewToModelMapping = new WeakMap()),
              (this._markerNameToElements = new Map()),
              (this._elementToMarkerNames = new Map()),
              (this._unboundMarkerNames = new Set());
          }
          toModelElement(t) {
            return this._viewToModelMapping.get(t);
          }
          toViewElement(t) {
            return this._modelToViewMapping.get(t);
          }
          toModelRange(t) {
            return new xs(
              this.toModelPosition(t.start),
              this.toModelPosition(t.end)
            );
          }
          toViewRange(t) {
            return new Zn(
              this.toViewPosition(t.start),
              this.toViewPosition(t.end)
            );
          }
          toModelPosition(t) {
            const e = { viewPosition: t, mapper: this };
            return this.fire("viewToModelPosition", e), e.modelPosition;
          }
          toViewPosition(t, e = { isPhantom: !1 }) {
            const i = {
              modelPosition: t,
              mapper: this,
              isPhantom: e.isPhantom,
            };
            return this.fire("modelToViewPosition", i), i.viewPosition;
          }
          markerNameToElements(t) {
            const e = this._markerNameToElements.get(t);
            if (!e) return null;
            const i = new Set();
            for (const t of e)
              if (t.is("attributeElement"))
                for (const e of t.getElementsWithSameId()) i.add(e);
              else i.add(t);
            return i;
          }
          registerViewToModelLength(t, e) {
            this._viewToModelLengthCallbacks.set(t, e);
          }
          findMappedViewAncestor(t) {
            let e = t.parent;
            for (; !this._viewToModelMapping.has(e); ) e = e.parent;
            return e;
          }
          _toModelOffset(t, e, i) {
            if (i != t) {
              return (
                this._toModelOffset(t.parent, t.index, i) +
                this._toModelOffset(t, e, t)
              );
            }
            if (t.is("text")) return e;
            let n = 0;
            for (let i = 0; i < e; i++) n += this.getModelLength(t.getChild(i));
            return n;
          }
          getModelLength(t) {
            if (this._viewToModelLengthCallbacks.get(t.name)) {
              return this._viewToModelLengthCallbacks.get(t.name)(t);
            }
            if (this._viewToModelMapping.has(t)) return 1;
            if (t.is("text")) return t.data.length;
            if (t.is("uiElement")) return 0;
            {
              let e = 0;
              for (const i of t.getChildren()) e += this.getModelLength(i);
              return e;
            }
          }
          _findPositionIn(t, e) {
            let i,
              n = 0,
              o = 0,
              r = 0;
            if (t.is("text")) return new Kn(t, e);
            for (; o < e; )
              (i = t.getChild(r)), (n = this.getModelLength(i)), (o += n), r++;
            return o == e
              ? this._moveViewPositionToTextNode(new Kn(t, r))
              : this._findPositionIn(i, e - (o - n));
          }
          _moveViewPositionToTextNode(t) {
            const e = t.nodeBefore,
              i = t.nodeAfter;
            return e instanceof Ni
              ? new Kn(e, e.data.length)
              : i instanceof Ni
              ? new Kn(i, 0)
              : t;
          }
        }
        yi(As, gi);
        class Cs {
          constructor() {
            (this._consumable = new Map()),
              (this._textProxyRegistry = new Map());
          }
          add(t, e) {
            (e = Ts(e)),
              t instanceof gs && (t = this._getSymbolForTextProxy(t)),
              this._consumable.has(t) || this._consumable.set(t, new Map()),
              this._consumable.get(t).set(e, !0);
          }
          consume(t, e) {
            return (
              (e = Ts(e)),
              t instanceof gs && (t = this._getSymbolForTextProxy(t)),
              !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0)
            );
          }
          test(t, e) {
            (e = Ts(e)),
              t instanceof gs && (t = this._getSymbolForTextProxy(t));
            const i = this._consumable.get(t);
            if (void 0 === i) return null;
            const n = i.get(e);
            return void 0 === n ? null : n;
          }
          revert(t, e) {
            (e = Ts(e)),
              t instanceof gs && (t = this._getSymbolForTextProxy(t));
            const i = this.test(t, e);
            return !1 === i
              ? (this._consumable.get(t).set(e, !0), !0)
              : !0 !== i && null;
          }
          _getSymbolForTextProxy(t) {
            let e = null;
            const i = this._textProxyRegistry.get(t.startOffset);
            if (i) {
              const n = i.get(t.endOffset);
              n && (e = n.get(t.parent));
            }
            return (
              e ||
                (e = this._addSymbolForTextProxy(
                  t.startOffset,
                  t.endOffset,
                  t.parent
                )),
              e
            );
          }
          _addSymbolForTextProxy(t, e, i) {
            const n = Symbol("textProxySymbol");
            let o, r;
            return (
              (o = this._textProxyRegistry.get(t)),
              o || ((o = new Map()), this._textProxyRegistry.set(t, o)),
              (r = o.get(e)),
              r || ((r = new Map()), o.set(e, r)),
              r.set(i, n),
              n
            );
          }
        }
        function Ts(t) {
          const e = t.split(":");
          return e.length > 1 ? e[0] + ":" + e[1] : e[0];
        }
        class Ms {
          constructor(t) {
            this.conversionApi = Dn({ dispatcher: this }, t);
          }
          convertChanges(t, e, i) {
            for (const e of t.getMarkersToRemove())
              this.convertMarkerRemove(e.name, e.range, i);
            for (const e of t.getChanges())
              "insert" == e.type
                ? this.convertInsert(
                    xs._createFromPositionAndShift(e.position, e.length),
                    i
                  )
                : "remove" == e.type
                ? this.convertRemove(e.position, e.length, e.name, i)
                : this.convertAttribute(
                    e.range,
                    e.attributeKey,
                    e.attributeOldValue,
                    e.attributeNewValue,
                    i
                  );
            for (const t of this.conversionApi.mapper.flushUnboundMarkerNames()) {
              const n = e.get(t).getRange();
              this.convertMarkerRemove(t, n, i), this.convertMarkerAdd(t, n, i);
            }
            for (const e of t.getMarkersToAdd())
              this.convertMarkerAdd(e.name, e.range, i);
          }
          convertInsert(t, e) {
            (this.conversionApi.writer = e),
              (this.conversionApi.consumable = this._createInsertConsumable(t));
            for (const e of t) {
              const t = e.item,
                i = {
                  item: t,
                  range: xs._createFromPositionAndShift(
                    e.previousPosition,
                    e.length
                  ),
                };
              this._testAndFire("insert", i);
              for (const e of t.getAttributeKeys())
                (i.attributeKey = e),
                  (i.attributeOldValue = null),
                  (i.attributeNewValue = t.getAttribute(e)),
                  this._testAndFire("attribute:" + e, i);
            }
            this._clearConversionApi();
          }
          convertRemove(t, e, i, n) {
            (this.conversionApi.writer = n),
              this.fire(
                "remove:" + i,
                { position: t, length: e },
                this.conversionApi
              ),
              this._clearConversionApi();
          }
          convertAttribute(t, e, i, n, o) {
            (this.conversionApi.writer = o),
              (this.conversionApi.consumable = this._createConsumableForRange(
                t,
                "attribute:" + e
              ));
            for (const o of t) {
              const t = {
                item: o.item,
                range: xs._createFromPositionAndShift(
                  o.previousPosition,
                  o.length
                ),
                attributeKey: e,
                attributeOldValue: i,
                attributeNewValue: n,
              };
              this._testAndFire("attribute:" + e, t);
            }
            this._clearConversionApi();
          }
          convertSelection(t, e, i) {
            const n = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
            if (
              ((this.conversionApi.writer = i),
              (this.conversionApi.consumable = this._createSelectionConsumable(
                t,
                n
              )),
              this.fire("selection", { selection: t }, this.conversionApi),
              t.isCollapsed)
            ) {
              for (const e of n) {
                const i = e.getRange();
                if (!Es(t.getFirstPosition(), e, this.conversionApi.mapper))
                  continue;
                const n = { item: t, markerName: e.name, markerRange: i };
                this.conversionApi.consumable.test(t, "addMarker:" + e.name) &&
                  this.fire("addMarker:" + e.name, n, this.conversionApi);
              }
              for (const e of t.getAttributeKeys()) {
                const i = {
                  item: t,
                  range: t.getFirstRange(),
                  attributeKey: e,
                  attributeOldValue: null,
                  attributeNewValue: t.getAttribute(e),
                };
                this.conversionApi.consumable.test(
                  t,
                  "attribute:" + i.attributeKey
                ) &&
                  this.fire(
                    "attribute:" + i.attributeKey + ":$text",
                    i,
                    this.conversionApi
                  );
              }
              this._clearConversionApi();
            }
          }
          convertMarkerAdd(t, e, i) {
            if (!e.root.document || "$graveyard" == e.root.rootName) return;
            this.conversionApi.writer = i;
            const n = "addMarker:" + t,
              o = new Cs();
            if (
              (o.add(e, n),
              (this.conversionApi.consumable = o),
              this.fire(
                n,
                { markerName: t, markerRange: e },
                this.conversionApi
              ),
              o.test(e, n))
            ) {
              this.conversionApi.consumable = this._createConsumableForRange(
                e,
                n
              );
              for (const i of e.getItems()) {
                if (!this.conversionApi.consumable.test(i, n)) continue;
                const o = {
                  item: i,
                  range: xs._createOn(i),
                  markerName: t,
                  markerRange: e,
                };
                this.fire(n, o, this.conversionApi);
              }
              this._clearConversionApi();
            }
          }
          convertMarkerRemove(t, e, i) {
            e.root.document &&
              "$graveyard" != e.root.rootName &&
              ((this.conversionApi.writer = i),
              this.fire(
                "removeMarker:" + t,
                { markerName: t, markerRange: e },
                this.conversionApi
              ),
              this._clearConversionApi());
          }
          _createInsertConsumable(t) {
            const e = new Cs();
            for (const i of t) {
              const t = i.item;
              e.add(t, "insert");
              for (const i of t.getAttributeKeys()) e.add(t, "attribute:" + i);
            }
            return e;
          }
          _createConsumableForRange(t, e) {
            const i = new Cs();
            for (const n of t.getItems()) i.add(n, e);
            return i;
          }
          _createSelectionConsumable(t, e) {
            const i = new Cs();
            i.add(t, "selection");
            for (const n of e) i.add(t, "addMarker:" + n.name);
            for (const e of t.getAttributeKeys()) i.add(t, "attribute:" + e);
            return i;
          }
          _testAndFire(t, e) {
            if (!this.conversionApi.consumable.test(e.item, t)) return;
            const i = e.item.name || "$text";
            this.fire(t + ":" + i, e, this.conversionApi);
          }
          _clearConversionApi() {
            delete this.conversionApi.writer,
              delete this.conversionApi.consumable;
          }
        }
        function Es(t, e, i) {
          const n = e.getRange(),
            o = Array.from(t.getAncestors());
          return (
            o.shift(),
            o.reverse(),
            !o.some((t) => {
              if (n.containsItem(t)) {
                return !!i.toViewElement(t).getCustomProperty("addHighlight");
              }
            })
          );
        }
        yi(Ms, gi);
        class Ps {
          constructor(t, e, i) {
            (this._lastRangeBackward = !1),
              (this._ranges = []),
              (this._attrs = new Map()),
              t && this.setTo(t, e, i);
          }
          get anchor() {
            if (this._ranges.length > 0) {
              const t = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? t.end : t.start;
            }
            return null;
          }
          get focus() {
            if (this._ranges.length > 0) {
              const t = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? t.start : t.end;
            }
            return null;
          }
          get isCollapsed() {
            return 1 === this._ranges.length && this._ranges[0].isCollapsed;
          }
          get rangeCount() {
            return this._ranges.length;
          }
          get isBackward() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
          isEqual(t) {
            if (this.rangeCount != t.rangeCount) return !1;
            if (0 === this.rangeCount) return !0;
            if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
              return !1;
            for (const e of this._ranges) {
              let i = !1;
              for (const n of t._ranges)
                if (e.isEqual(n)) {
                  i = !0;
                  break;
                }
              if (!i) return !1;
            }
            return !0;
          }
          *getRanges() {
            for (const t of this._ranges) yield new xs(t.start, t.end);
          }
          getFirstRange() {
            let t = null;
            for (const e of this._ranges)
              (t && !e.start.isBefore(t.start)) || (t = e);
            return t ? new xs(t.start, t.end) : null;
          }
          getLastRange() {
            let t = null;
            for (const e of this._ranges)
              (t && !e.end.isAfter(t.end)) || (t = e);
            return t ? new xs(t.start, t.end) : null;
          }
          getFirstPosition() {
            const t = this.getFirstRange();
            return t ? t.start.clone() : null;
          }
          getLastPosition() {
            const t = this.getLastRange();
            return t ? t.end.clone() : null;
          }
          setTo(t, e, i) {
            if (null === t) this._setRanges([]);
            else if (t instanceof Ps)
              this._setRanges(t.getRanges(), t.isBackward);
            else if (t && "function" == typeof t.getRanges)
              this._setRanges(t.getRanges(), t.isBackward);
            else if (t instanceof xs) this._setRanges([t], !!e && !!e.backward);
            else if (t instanceof _s) this._setRanges([new xs(t)]);
            else if (t instanceof us) {
              const n = !!i && !!i.backward;
              let o;
              if ("in" == e) o = xs._createIn(t);
              else if ("on" == e) o = xs._createOn(t);
              else {
                if (void 0 === e)
                  throw new hi.b(
                    "model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.",
                    [this, t]
                  );
                o = new xs(_s._createAt(t, e));
              }
              this._setRanges([o], n);
            } else {
              if (!vi(t))
                throw new hi.b(
                  "model-selection-setTo-not-selectable: Cannot set the selection to the given place.",
                  [this, t]
                );
              this._setRanges(t, e && !!e.backward);
            }
          }
          _setRanges(t, e = !1) {
            const i = (t = Array.from(t)).some((e) => {
              if (!(e instanceof xs))
                throw new hi.b(
                  "model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.",
                  [this, t]
                );
              return this._ranges.every((t) => !t.isEqual(e));
            });
            if (t.length !== this._ranges.length || i) {
              this._removeAllRanges();
              for (const e of t) this._pushRange(e);
              (this._lastRangeBackward = !!e),
                this.fire("change:range", { directChange: !0 });
            }
          }
          setFocus(t, e) {
            if (null === this.anchor)
              throw new hi.b(
                "model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.",
                [this, t]
              );
            const i = _s._createAt(t, e);
            if ("same" == i.compareWith(this.focus)) return;
            const n = this.anchor;
            this._ranges.length && this._popRange(),
              "before" == i.compareWith(n)
                ? (this._pushRange(new xs(i, n)),
                  (this._lastRangeBackward = !0))
                : (this._pushRange(new xs(n, i)),
                  (this._lastRangeBackward = !1)),
              this.fire("change:range", { directChange: !0 });
          }
          getAttribute(t) {
            return this._attrs.get(t);
          }
          getAttributes() {
            return this._attrs.entries();
          }
          getAttributeKeys() {
            return this._attrs.keys();
          }
          hasAttribute(t) {
            return this._attrs.has(t);
          }
          removeAttribute(t) {
            this.hasAttribute(t) &&
              (this._attrs.delete(t),
              this.fire("change:attribute", {
                attributeKeys: [t],
                directChange: !0,
              }));
          }
          setAttribute(t, e) {
            this.getAttribute(t) !== e &&
              (this._attrs.set(t, e),
              this.fire("change:attribute", {
                attributeKeys: [t],
                directChange: !0,
              }));
          }
          getSelectedElement() {
            return 1 !== this.rangeCount
              ? null
              : this.getFirstRange().getContainedElement();
          }
          is(t) {
            return "selection" === t || "model:selection" === t;
          }
          *getSelectedBlocks() {
            const t = new WeakSet();
            for (const e of this.getRanges()) {
              const i = Os(e.start, t);
              i && Ns(i, e) && (yield i);
              for (const i of e.getWalker()) {
                const n = i.item;
                "elementEnd" == i.type && Is(n, t, e) && (yield n);
              }
              const n = Os(e.end, t);
              n &&
                !e.end.isTouching(_s._createAt(n, 0)) &&
                Ns(n, e) &&
                (yield n);
            }
          }
          containsEntireContent(t = this.anchor.root) {
            const e = _s._createAt(t, 0),
              i = _s._createAt(t, "end");
            return (
              e.isTouching(this.getFirstPosition()) &&
              i.isTouching(this.getLastPosition())
            );
          }
          _pushRange(t) {
            this._checkRange(t), this._ranges.push(new xs(t.start, t.end));
          }
          _checkRange(t) {
            for (let e = 0; e < this._ranges.length; e++)
              if (t.isIntersecting(this._ranges[e]))
                throw new hi.b(
                  "model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.",
                  [this, t],
                  { addedRange: t, intersectingRange: this._ranges[e] }
                );
          }
          _removeAllRanges() {
            for (; this._ranges.length > 0; ) this._popRange();
          }
          _popRange() {
            this._ranges.pop();
          }
        }
        function Ss(t, e) {
          return (
            !e.has(t) &&
            (e.add(t), t.root.document.model.schema.isBlock(t) && t.parent)
          );
        }
        function Is(t, e, i) {
          return Ss(t, e) && Ns(t, i);
        }
        function Os(t, e) {
          const i = t.parent.root.document.model.schema,
            n = t.parent.getAncestors({ parentFirst: !0, includeSelf: !0 });
          let o = !1;
          const r = n.find((t) => !o && ((o = i.isLimit(t)), !o && Ss(t, e)));
          return n.forEach((t) => e.add(t)), r;
        }
        function Ns(t, e) {
          const i = (function (t) {
            const e = t.root.document.model.schema;
            let i = t.parent;
            for (; i; ) {
              if (e.isBlock(i)) return i;
              i = i.parent;
            }
          })(t);
          return !i || !e.containsRange(xs._createOn(i), !0);
        }
        yi(Ps, gi);
        class Rs extends xs {
          constructor(t, e) {
            super(t, e), Ls.call(this);
          }
          detach() {
            this.stopListening();
          }
          is(t) {
            return (
              "liveRange" === t ||
              "model:liveRange" === t ||
              "range" == t ||
              "model:range" === t
            );
          }
          toRange() {
            return new xs(this.start, this.end);
          }
          static fromRange(t) {
            return new Rs(t.start, t.end);
          }
        }
        function Ls() {
          this.listenTo(
            this.root.document.model,
            "applyOperation",
            (t, e) => {
              const i = e[0];
              i.isDocumentOperation && js.call(this, i);
            },
            { priority: "low" }
          );
        }
        function js(t) {
          const e = this.getTransformedByOperation(t),
            i = xs._createFromRanges(e),
            n = !i.isEqual(this),
            o = (function (t, e) {
              switch (e.type) {
                case "insert":
                  return t.containsPosition(e.position);
                case "move":
                case "remove":
                case "reinsert":
                case "merge":
                  return (
                    t.containsPosition(e.sourcePosition) ||
                    t.start.isEqual(e.sourcePosition) ||
                    t.containsPosition(e.targetPosition)
                  );
                case "split":
                  return (
                    t.containsPosition(e.splitPosition) ||
                    t.containsPosition(e.insertionPosition)
                  );
              }
              return !1;
            })(this, t);
          let r = null;
          if (n) {
            "$graveyard" == i.root.rootName &&
              (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);
            const e = this.toRange();
            (this.start = i.start),
              (this.end = i.end),
              this.fire("change:range", e, { deletionPosition: r });
          } else
            o &&
              this.fire("change:content", this.toRange(), {
                deletionPosition: r,
              });
        }
        yi(Rs, gi);
        class Ds {
          constructor(t) {
            (this._selection = new zs(t)),
              this._selection.delegate("change:range").to(this),
              this._selection.delegate("change:attribute").to(this),
              this._selection.delegate("change:marker").to(this);
          }
          get isCollapsed() {
            return this._selection.isCollapsed;
          }
          get anchor() {
            return this._selection.anchor;
          }
          get focus() {
            return this._selection.focus;
          }
          get rangeCount() {
            return this._selection.rangeCount;
          }
          get hasOwnRange() {
            return this._selection.hasOwnRange;
          }
          get isBackward() {
            return this._selection.isBackward;
          }
          get isGravityOverridden() {
            return this._selection.isGravityOverridden;
          }
          get markers() {
            return this._selection.markers;
          }
          get _ranges() {
            return this._selection._ranges;
          }
          getRanges() {
            return this._selection.getRanges();
          }
          getFirstPosition() {
            return this._selection.getFirstPosition();
          }
          getLastPosition() {
            return this._selection.getLastPosition();
          }
          getFirstRange() {
            return this._selection.getFirstRange();
          }
          getLastRange() {
            return this._selection.getLastRange();
          }
          getSelectedBlocks() {
            return this._selection.getSelectedBlocks();
          }
          getSelectedElement() {
            return this._selection.getSelectedElement();
          }
          containsEntireContent(t) {
            return this._selection.containsEntireContent(t);
          }
          destroy() {
            this._selection.destroy();
          }
          getAttributeKeys() {
            return this._selection.getAttributeKeys();
          }
          getAttributes() {
            return this._selection.getAttributes();
          }
          getAttribute(t) {
            return this._selection.getAttribute(t);
          }
          hasAttribute(t) {
            return this._selection.hasAttribute(t);
          }
          refresh() {
            this._selection._updateMarkers(),
              this._selection._updateAttributes(!1);
          }
          is(t) {
            return (
              "selection" === t ||
              "model:selection" == t ||
              "documentSelection" == t ||
              "model:documentSelection" == t
            );
          }
          _setFocus(t, e) {
            this._selection.setFocus(t, e);
          }
          _setTo(t, e, i) {
            this._selection.setTo(t, e, i);
          }
          _setAttribute(t, e) {
            this._selection.setAttribute(t, e);
          }
          _removeAttribute(t) {
            this._selection.removeAttribute(t);
          }
          _getStoredAttributes() {
            return this._selection._getStoredAttributes();
          }
          _overrideGravity() {
            return this._selection.overrideGravity();
          }
          _restoreGravity(t) {
            this._selection.restoreGravity(t);
          }
          static _getStoreAttributeKey(t) {
            return "selection:" + t;
          }
          static _isStoreAttributeKey(t) {
            return t.startsWith("selection:");
          }
        }
        yi(Ds, gi);
        class zs extends Ps {
          constructor(t) {
            super(),
              (this.markers = new xi({ idProperty: "name" })),
              (this._model = t.model),
              (this._document = t),
              (this._attributePriority = new Map()),
              (this._fixGraveyardRangesData = []),
              (this._hasChangedRange = !1),
              (this._overriddenGravityRegister = new Set()),
              this.listenTo(
                this._model,
                "applyOperation",
                (t, e) => {
                  const i = e[0];
                  if (
                    i.isDocumentOperation &&
                    "marker" != i.type &&
                    "rename" != i.type &&
                    "noop" != i.type
                  ) {
                    for (; this._fixGraveyardRangesData.length; ) {
                      const { liveRange: t, sourcePosition: e } =
                        this._fixGraveyardRangesData.shift();
                      this._fixGraveyardSelection(t, e);
                    }
                    this._hasChangedRange &&
                      ((this._hasChangedRange = !1),
                      this.fire("change:range", { directChange: !1 }));
                  }
                },
                { priority: "lowest" }
              ),
              this.on("change:range", () => {
                for (const t of this.getRanges())
                  if (!this._document._validateSelectionRange(t))
                    throw new hi.b(
                      "document-selection-wrong-position: Range from document selection starts or ends at incorrect position.",
                      this,
                      { range: t }
                    );
              }),
              this.listenTo(this._model.markers, "update", () =>
                this._updateMarkers()
              ),
              this.listenTo(this._document, "change", (t, e) => {
                !(function (t, e) {
                  const i = t.document.differ;
                  for (const n of i.getChanges()) {
                    if ("insert" != n.type) continue;
                    const i = n.position.parent;
                    n.length === i.maxOffset &&
                      t.enqueueChange(e, (t) => {
                        const e = Array.from(i.getAttributeKeys()).filter((t) =>
                          t.startsWith("selection:")
                        );
                        for (const n of e) t.removeAttribute(n, i);
                      });
                  }
                })(this._model, e);
              });
          }
          get isCollapsed() {
            return 0 === this._ranges.length
              ? this._document._getDefaultRange().isCollapsed
              : super.isCollapsed;
          }
          get anchor() {
            return super.anchor || this._document._getDefaultRange().start;
          }
          get focus() {
            return super.focus || this._document._getDefaultRange().end;
          }
          get rangeCount() {
            return this._ranges.length ? this._ranges.length : 1;
          }
          get hasOwnRange() {
            return this._ranges.length > 0;
          }
          get isGravityOverridden() {
            return !!this._overriddenGravityRegister.size;
          }
          destroy() {
            for (let t = 0; t < this._ranges.length; t++)
              this._ranges[t].detach();
            this.stopListening();
          }
          *getRanges() {
            this._ranges.length
              ? yield* super.getRanges()
              : yield this._document._getDefaultRange();
          }
          getFirstRange() {
            return super.getFirstRange() || this._document._getDefaultRange();
          }
          getLastRange() {
            return super.getLastRange() || this._document._getDefaultRange();
          }
          setTo(t, e, i) {
            super.setTo(t, e, i),
              this._updateAttributes(!0),
              this._updateMarkers();
          }
          setFocus(t, e) {
            super.setFocus(t, e),
              this._updateAttributes(!0),
              this._updateMarkers();
          }
          setAttribute(t, e) {
            if (this._setAttribute(t, e)) {
              const e = [t];
              this.fire("change:attribute", {
                attributeKeys: e,
                directChange: !0,
              });
            }
          }
          removeAttribute(t) {
            if (this._removeAttribute(t)) {
              const e = [t];
              this.fire("change:attribute", {
                attributeKeys: e,
                directChange: !0,
              });
            }
          }
          overrideGravity() {
            const t = ci();
            return (
              this._overriddenGravityRegister.add(t),
              1 === this._overriddenGravityRegister.size &&
                this._updateAttributes(!0),
              t
            );
          }
          restoreGravity(t) {
            if (!this._overriddenGravityRegister.has(t))
              throw new hi.b(
                "document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.",
                this,
                { uid: t }
              );
            this._overriddenGravityRegister.delete(t),
              this.isGravityOverridden || this._updateAttributes(!0);
          }
          _popRange() {
            this._ranges.pop().detach();
          }
          _pushRange(t) {
            const e = this._prepareRange(t);
            e && this._ranges.push(e);
          }
          _prepareRange(t) {
            if ((this._checkRange(t), t.root == this._document.graveyard))
              return;
            const e = Rs.fromRange(t);
            return (
              e.on("change:range", (t, i, n) => {
                (this._hasChangedRange = !0),
                  e.root == this._document.graveyard &&
                    this._fixGraveyardRangesData.push({
                      liveRange: e,
                      sourcePosition: n.deletionPosition,
                    });
              }),
              e
            );
          }
          _updateMarkers() {
            const t = [];
            let e = !1;
            for (const e of this._model.markers) {
              const i = e.getRange();
              for (const n of this.getRanges())
                i.containsRange(n, !n.isCollapsed) && t.push(e);
            }
            const i = Array.from(this.markers);
            for (const i of t)
              this.markers.has(i) || (this.markers.add(i), (e = !0));
            for (const i of Array.from(this.markers))
              t.includes(i) || (this.markers.remove(i), (e = !0));
            e &&
              this.fire("change:marker", { oldMarkers: i, directChange: !1 });
          }
          _updateAttributes(t) {
            const e = Li(this._getSurroundingAttributes()),
              i = Li(this.getAttributes());
            if (t)
              (this._attributePriority = new Map()), (this._attrs = new Map());
            else
              for (const [t, e] of this._attributePriority)
                "low" == e &&
                  (this._attrs.delete(t), this._attributePriority.delete(t));
            this._setAttributesTo(e);
            const n = [];
            for (const [t, e] of this.getAttributes())
              (i.has(t) && i.get(t) === e) || n.push(t);
            for (const [t] of i) this.hasAttribute(t) || n.push(t);
            n.length > 0 &&
              this.fire("change:attribute", {
                attributeKeys: n,
                directChange: !1,
              });
          }
          _setAttribute(t, e, i = !0) {
            const n = i ? "normal" : "low";
            return (
              ("low" != n || "normal" != this._attributePriority.get(t)) &&
              super.getAttribute(t) !== e &&
              (this._attrs.set(t, e), this._attributePriority.set(t, n), !0)
            );
          }
          _removeAttribute(t, e = !0) {
            const i = e ? "normal" : "low";
            return (
              ("low" != i || "normal" != this._attributePriority.get(t)) &&
              (this._attributePriority.set(t, i),
              !!super.hasAttribute(t) && (this._attrs.delete(t), !0))
            );
          }
          _setAttributesTo(t) {
            const e = new Set();
            for (const [e, i] of this.getAttributes())
              t.get(e) !== i && this._removeAttribute(e, !1);
            for (const [i, n] of t) {
              this._setAttribute(i, n, !1) && e.add(i);
            }
            return e;
          }
          *_getStoredAttributes() {
            const t = this.getFirstPosition().parent;
            if (this.isCollapsed && t.isEmpty)
              for (const e of t.getAttributeKeys())
                if (e.startsWith("selection:")) {
                  const i = e.substr("selection:".length);
                  yield [i, t.getAttribute(e)];
                }
          }
          _getSurroundingAttributes() {
            const t = this.getFirstPosition(),
              e = this._model.schema;
            let i = null;
            if (this.isCollapsed) {
              const e = t.textNode ? t.textNode : t.nodeBefore,
                n = t.textNode ? t.textNode : t.nodeAfter;
              if (
                (this.isGravityOverridden || (i = Bs(e)),
                i || (i = Bs(n)),
                !this.isGravityOverridden && !i)
              ) {
                let t = e;
                for (; t && !i; ) (t = t.previousSibling), (i = Bs(t));
              }
              if (!i) {
                let t = n;
                for (; t && !i; ) (t = t.nextSibling), (i = Bs(t));
              }
              i || (i = this._getStoredAttributes());
            } else {
              const t = this.getFirstRange();
              for (const n of t) {
                if (n.item.is("element") && e.isObject(n.item)) break;
                if ("text" == n.type) {
                  i = n.item.getAttributes();
                  break;
                }
              }
            }
            return i;
          }
          _fixGraveyardSelection(t, e) {
            const i = e.clone(),
              n = this._model.schema.getNearestSelectionRange(i),
              o = this._ranges.indexOf(t);
            if (
              (this._ranges.splice(o, 1),
              t.detach(),
              n && ((r = n), this._ranges.every((t) => !r.isEqual(t))))
            ) {
              const t = this._prepareRange(n);
              this._ranges.splice(o, 0, t);
            }
            var r;
          }
        }
        function Bs(t) {
          return t instanceof gs || t instanceof ms ? t.getAttributes() : null;
        }
        class Vs {
          constructor(t) {
            this._dispatchers = t;
          }
          add(t) {
            for (const e of this._dispatchers) t(e);
            return this;
          }
        }
        var Fs = function (t) {
          return ti(t, 5);
        };
        class Hs extends Vs {
          elementToElement(t) {
            return this.add(
              (function (t) {
                return (
                  ((t = Fs(t)).view = Ws(t.view, "container")),
                  (e) => {
                    var i;
                    e.on(
                      "insert:" + t.model,
                      ((i = t.view),
                      (t, e, n) => {
                        const o = i(e.item, n.writer);
                        if (!o) return;
                        if (!n.consumable.consume(e.item, "insert")) return;
                        const r = n.mapper.toViewPosition(e.range.start);
                        n.mapper.bindElements(e.item, o), n.writer.insert(r, o);
                      }),
                      { priority: t.converterPriority || "normal" }
                    );
                  }
                );
              })(t)
            );
          }
          attributeToElement(t) {
            return this.add(
              (function (t) {
                let e =
                  "attribute:" +
                  ((t = Fs(t)).model.key ? t.model.key : t.model);
                t.model.name && (e += ":" + t.model.name);
                if (t.model.values)
                  for (const e of t.model.values)
                    t.view[e] = Ws(t.view[e], "attribute");
                else t.view = Ws(t.view, "attribute");
                const i = qs(t);
                return (n) => {
                  n.on(
                    e,
                    (function (t) {
                      return (e, i, n) => {
                        const o = t(i.attributeOldValue, n.writer),
                          r = t(i.attributeNewValue, n.writer);
                        if (!o && !r) return;
                        if (!n.consumable.consume(i.item, e.name)) return;
                        const s = n.writer,
                          a = s.document.selection;
                        if (i.item instanceof Ps || i.item instanceof Ds)
                          s.wrap(a.getFirstRange(), r);
                        else {
                          let t = n.mapper.toViewRange(i.range);
                          null !== i.attributeOldValue &&
                            o &&
                            (t = s.unwrap(t, o)),
                            null !== i.attributeNewValue && r && s.wrap(t, r);
                        }
                      };
                    })(i),
                    { priority: t.converterPriority || "normal" }
                  );
                };
              })(t)
            );
          }
          attributeToAttribute(t) {
            return this.add(
              (function (t) {
                let e =
                  "attribute:" +
                  ((t = Fs(t)).model.key ? t.model.key : t.model);
                t.model.name && (e += ":" + t.model.name);
                if (t.model.values)
                  for (const e of t.model.values) t.view[e] = Ys(t.view[e]);
                else t.view = Ys(t.view);
                const i = qs(t);
                return (n) => {
                  var o;
                  n.on(
                    e,
                    ((o = i),
                    (t, e, i) => {
                      const n = o(e.attributeOldValue, e),
                        r = o(e.attributeNewValue, e);
                      if (!n && !r) return;
                      if (!i.consumable.consume(e.item, t.name)) return;
                      const s = i.mapper.toViewElement(e.item),
                        a = i.writer;
                      if (!s)
                        throw new hi.b(
                          "conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.",
                          [e, i]
                        );
                      if (null !== e.attributeOldValue && n)
                        if ("class" == n.key) {
                          const t = Array.isArray(n.value)
                            ? n.value
                            : [n.value];
                          for (const e of t) a.removeClass(e, s);
                        } else if ("style" == n.key) {
                          const t = Object.keys(n.value);
                          for (const e of t) a.removeStyle(e, s);
                        } else a.removeAttribute(n.key, s);
                      if (null !== e.attributeNewValue && r)
                        if ("class" == r.key) {
                          const t = Array.isArray(r.value)
                            ? r.value
                            : [r.value];
                          for (const e of t) a.addClass(e, s);
                        } else if ("style" == r.key) {
                          const t = Object.keys(r.value);
                          for (const e of t) a.setStyle(e, r.value[e], s);
                        } else a.setAttribute(r.key, r.value, s);
                    }),
                    { priority: t.converterPriority || "normal" }
                  );
                };
              })(t)
            );
          }
          markerToElement(t) {
            return this.add(
              (function (t) {
                return (
                  ((t = Fs(t)).view = Ws(t.view, "ui")),
                  (e) => {
                    var i;
                    e.on(
                      "addMarker:" + t.model,
                      ((i = t.view),
                      (t, e, n) => {
                        e.isOpening = !0;
                        const o = i(e, n.writer);
                        e.isOpening = !1;
                        const r = i(e, n.writer);
                        if (!o || !r) return;
                        const s = e.markerRange;
                        if (s.isCollapsed && !n.consumable.consume(s, t.name))
                          return;
                        for (const e of s)
                          if (!n.consumable.consume(e.item, t.name)) return;
                        const a = n.mapper,
                          l = n.writer;
                        l.insert(a.toViewPosition(s.start), o),
                          n.mapper.bindElementToMarker(o, e.markerName),
                          s.isCollapsed ||
                            (l.insert(a.toViewPosition(s.end), r),
                            n.mapper.bindElementToMarker(r, e.markerName)),
                          t.stop();
                      }),
                      { priority: t.converterPriority || "normal" }
                    ),
                      e.on(
                        "removeMarker:" + t.model,
                        (t.view,
                        (t, e, i) => {
                          const n = i.mapper.markerNameToElements(e.markerName);
                          if (n) {
                            for (const t of n)
                              i.mapper.unbindElementFromMarkerName(
                                t,
                                e.markerName
                              ),
                                i.writer.clear(i.writer.createRangeOn(t), t);
                            i.writer.clearClonedElementsGroup(e.markerName),
                              t.stop();
                          }
                        }),
                        { priority: t.converterPriority || "normal" }
                      );
                  }
                );
              })(t)
            );
          }
          markerToHighlight(t) {
            return this.add(
              (function (t) {
                return (e) => {
                  var i;
                  e.on(
                    "addMarker:" + t.model,
                    ((i = t.view),
                    (t, e, n) => {
                      if (!e.item) return;
                      if (
                        !(
                          e.item instanceof Ps ||
                          e.item instanceof Ds ||
                          e.item.is("textProxy")
                        )
                      )
                        return;
                      const o = $s(i, e, n);
                      if (!o) return;
                      if (!n.consumable.consume(e.item, t.name)) return;
                      const r = n.writer,
                        s = Us(r, o),
                        a = r.document.selection;
                      if (e.item instanceof Ps || e.item instanceof Ds)
                        r.wrap(a.getFirstRange(), s, a);
                      else {
                        const t = n.mapper.toViewRange(e.range),
                          i = r.wrap(t, s);
                        for (const t of i.getItems())
                          if (t.is("attributeElement") && t.isSimilar(s)) {
                            n.mapper.bindElementToMarker(t, e.markerName);
                            break;
                          }
                      }
                    }),
                    { priority: t.converterPriority || "normal" }
                  ),
                    e.on(
                      "addMarker:" + t.model,
                      (function (t) {
                        return (e, i, n) => {
                          if (!i.item) return;
                          if (!(i.item instanceof ps)) return;
                          const o = $s(t, i, n);
                          if (!o) return;
                          if (!n.consumable.test(i.item, e.name)) return;
                          const r = n.mapper.toViewElement(i.item);
                          if (r && r.getCustomProperty("addHighlight")) {
                            n.consumable.consume(i.item, e.name);
                            for (const t of xs._createIn(i.item))
                              n.consumable.consume(t.item, e.name);
                            r.getCustomProperty("addHighlight")(r, o, n.writer),
                              n.mapper.bindElementToMarker(r, i.markerName);
                          }
                        };
                      })(t.view),
                      { priority: t.converterPriority || "normal" }
                    ),
                    e.on(
                      "removeMarker:" + t.model,
                      (function (t) {
                        return (e, i, n) => {
                          if (i.markerRange.isCollapsed) return;
                          const o = $s(t, i, n);
                          if (!o) return;
                          const r = Us(n.writer, o),
                            s = n.mapper.markerNameToElements(i.markerName);
                          if (s) {
                            for (const t of s)
                              n.mapper.unbindElementFromMarkerName(
                                t,
                                i.markerName
                              ),
                                t.is("attributeElement")
                                  ? n.writer.unwrap(
                                      n.writer.createRangeOn(t),
                                      r
                                    )
                                  : t.getCustomProperty("removeHighlight")(
                                      t,
                                      o.id,
                                      n.writer
                                    );
                            n.writer.clearClonedElementsGroup(i.markerName),
                              e.stop();
                          }
                        };
                      })(t.view),
                      { priority: t.converterPriority || "normal" }
                    );
                };
              })(t)
            );
          }
        }
        function Us(t, e) {
          const i = t.createAttributeElement("span", e.attributes);
          return (
            e.classes && i._addClass(e.classes),
            e.priority && (i._priority = e.priority),
            (i._id = e.id),
            i
          );
        }
        function Ws(t, e) {
          return "function" == typeof t
            ? t
            : (i, n) =>
                (function (t, e, i) {
                  "string" == typeof t && (t = { name: t });
                  let n;
                  const o = Object.assign({}, t.attributes);
                  if ("container" == i) n = e.createContainerElement(t.name, o);
                  else if ("attribute" == i) {
                    const i = { priority: t.priority || ro.DEFAULT_PRIORITY };
                    n = e.createAttributeElement(t.name, o, i);
                  } else n = e.createUIElement(t.name, o);
                  if (t.styles) {
                    const i = Object.keys(t.styles);
                    for (const o of i) e.setStyle(o, t.styles[o], n);
                  }
                  if (t.classes) {
                    const i = t.classes;
                    if ("string" == typeof i) e.addClass(i, n);
                    else for (const t of i) e.addClass(t, n);
                  }
                  return n;
                })(t, n, e);
        }
        function qs(t) {
          return t.model.values
            ? (e, i) => {
                const n = t.view[e];
                return n ? n(e, i) : null;
              }
            : t.view;
        }
        function Ys(t) {
          return "string" == typeof t
            ? (e) => ({ key: t, value: e })
            : "object" == typeof t
            ? t.value
              ? () => t
              : (e) => ({ key: t.key, value: e })
            : t;
        }
        function $s(t, e, i) {
          const n = "function" == typeof t ? t(e, i) : t;
          return n
            ? (n.priority || (n.priority = 10),
              n.id || (n.id = e.markerName),
              n)
            : null;
        }
        class Js extends Vs {
          elementToElement(t) {
            return this.add(Gs(t));
          }
          elementToAttribute(t) {
            return this.add(
              (function (t) {
                Xs((t = Fs(t)));
                const e = Ks(t, !1),
                  i = Qs(t.view),
                  n = i ? "element:" + i : "element";
                return (i) => {
                  i.on(n, e, { priority: t.converterPriority || "low" });
                };
              })(t)
            );
          }
          attributeToAttribute(t) {
            return this.add(
              (function (t) {
                t = Fs(t);
                let e = null;
                ("string" == typeof t.view || t.view.key) &&
                  (e = (function (t) {
                    "string" == typeof t.view && (t.view = { key: t.view });
                    const e = t.view.key;
                    let i;
                    if ("class" == e || "style" == e) {
                      i = {
                        ["class" == e ? "classes" : "styles"]: t.view.value,
                      };
                    } else {
                      const n =
                        void 0 === t.view.value ? /[\s\S]*/ : t.view.value;
                      i = { attributes: { [e]: n } };
                    }
                    t.view.name && (i.name = t.view.name);
                    return (t.view = i), e;
                  })(t));
                Xs(t, e);
                const i = Ks(t, !0);
                return (e) => {
                  e.on("element", i, {
                    priority: t.converterPriority || "low",
                  });
                };
              })(t)
            );
          }
          elementToMarker(t) {
            return this.add(
              (function (t) {
                return (
                  (function (t) {
                    const e = t.model;
                    t.model = (t, i) => {
                      const n = "string" == typeof e ? e : e(t);
                      return i.createElement("$marker", { "data-name": n });
                    };
                  })((t = Fs(t))),
                  Gs(t)
                );
              })(t)
            );
          }
        }
        function Gs(t) {
          const e = (function (t) {
              const e = t.view ? new ji(t.view) : null;
              return (i, n, o) => {
                let r = {};
                if (e) {
                  const t = e.match(n.viewItem);
                  if (!t) return;
                  r = t.match;
                }
                r.name = !0;
                const s =
                  ((a = t.model),
                  (l = n.viewItem),
                  (c = o.writer),
                  a instanceof Function ? a(l, c) : c.createElement(a));
                var a, l, c;
                if (!s) return;
                if (!o.consumable.test(n.viewItem, r)) return;
                const d = o.splitToAllowedParent(s, n.modelCursor);
                if (!d) return;
                o.writer.insert(s, d.position),
                  o.convertChildren(
                    n.viewItem,
                    o.writer.createPositionAt(s, 0)
                  ),
                  o.consumable.consume(n.viewItem, r);
                const h = o.getSplitParts(s);
                (n.modelRange = new xs(
                  o.writer.createPositionBefore(s),
                  o.writer.createPositionAfter(h[h.length - 1])
                )),
                  d.cursorParent
                    ? (n.modelCursor = o.writer.createPositionAt(
                        d.cursorParent,
                        0
                      ))
                    : (n.modelCursor = n.modelRange.end);
              };
            })((t = Fs(t))),
            i = Qs(t.view),
            n = i ? "element:" + i : "element";
          return (i) => {
            i.on(n, e, { priority: t.converterPriority || "normal" });
          };
        }
        function Qs(t) {
          return "string" == typeof t
            ? t
            : "object" == typeof t && "string" == typeof t.name
            ? t.name
            : null;
        }
        function Xs(t, e = null) {
          const i = null === e || ((t) => t.getAttribute(e)),
            n = "object" != typeof t.model ? t.model : t.model.key,
            o =
              "object" != typeof t.model || void 0 === t.model.value
                ? i
                : t.model.value;
          t.model = { key: n, value: o };
        }
        function Ks(t, e) {
          const i = new ji(t.view);
          return (n, o, r) => {
            const s = i.match(o.viewItem);
            if (!s) return;
            const a = t.model.key,
              l =
                "function" == typeof t.model.value
                  ? t.model.value(o.viewItem)
                  : t.model.value;
            null !== l &&
              (!(function (t, e) {
                const i = "function" == typeof t ? t(e) : t;
                if ("object" == typeof i && !Qs(i)) return !1;
                return !i.classes && !i.attributes && !i.styles;
              })(t.view, o.viewItem)
                ? delete s.match.name
                : (s.match.name = !0),
              r.consumable.test(o.viewItem, s.match) &&
                (o.modelRange ||
                  (o = Object.assign(
                    o,
                    r.convertChildren(o.viewItem, o.modelCursor)
                  )),
                (function (t, e, i, n) {
                  let o = !1;
                  for (const r of Array.from(t.getItems({ shallow: i })))
                    n.schema.checkAttribute(r, e.key) &&
                      (n.writer.setAttribute(e.key, e.value, r), (o = !0));
                  return o;
                })(o.modelRange, { key: a, value: l }, e, r) &&
                  r.consumable.consume(o.viewItem, s.match)));
          };
        }
        class Zs {
          constructor(t, e) {
            (this.model = t),
              (this.view = new hs(e)),
              (this.mapper = new As()),
              (this.downcastDispatcher = new Ms({ mapper: this.mapper }));
            const i = this.model.document,
              n = i.selection,
              o = this.model.markers;
            this.listenTo(
              this.model,
              "_beforeChanges",
              () => {
                this.view._disableRendering(!0);
              },
              { priority: "highest" }
            ),
              this.listenTo(
                this.model,
                "_afterChanges",
                () => {
                  this.view._disableRendering(!1);
                },
                { priority: "lowest" }
              ),
              this.listenTo(
                i,
                "change",
                () => {
                  this.view.change((t) => {
                    this.downcastDispatcher.convertChanges(i.differ, o, t),
                      this.downcastDispatcher.convertSelection(n, o, t);
                  });
                },
                { priority: "low" }
              ),
              this.listenTo(
                this.view.document,
                "selectionChange",
                (function (t, e) {
                  return (i, n) => {
                    const o = n.newSelection,
                      r = new Ps(),
                      s = [];
                    for (const t of o.getRanges()) s.push(e.toModelRange(t));
                    r.setTo(s, { backward: o.isBackward }),
                      r.isEqual(t.document.selection) ||
                        t.change((t) => {
                          t.setSelection(r);
                        });
                  };
                })(this.model, this.mapper)
              ),
              this.downcastDispatcher.on(
                "insert:$text",
                (t, e, i) => {
                  if (!i.consumable.consume(e.item, "insert")) return;
                  const n = i.writer,
                    o = i.mapper.toViewPosition(e.range.start),
                    r = n.createText(e.item.data);
                  n.insert(o, r);
                },
                { priority: "lowest" }
              ),
              this.downcastDispatcher.on(
                "remove",
                (t, e, i) => {
                  const n = i.mapper.toViewPosition(e.position),
                    o = e.position.getShiftedBy(e.length),
                    r = i.mapper.toViewPosition(o, { isPhantom: !0 }),
                    s = i.writer.createRange(n, r),
                    a = i.writer.remove(s.getTrimmed());
                  for (const t of i.writer.createRangeIn(a).getItems())
                    i.mapper.unbindViewElement(t);
                },
                { priority: "low" }
              ),
              this.downcastDispatcher.on(
                "selection",
                (t, e, i) => {
                  const n = i.writer,
                    o = n.document.selection;
                  for (const t of o.getRanges())
                    t.isCollapsed &&
                      t.end.parent.isAttached() &&
                      i.writer.mergeAttributes(t.start);
                  n.setSelection(null);
                },
                { priority: "low" }
              ),
              this.downcastDispatcher.on(
                "selection",
                (t, e, i) => {
                  const n = e.selection;
                  if (n.isCollapsed) return;
                  if (!i.consumable.consume(n, "selection")) return;
                  const o = [];
                  for (const t of n.getRanges()) {
                    const e = i.mapper.toViewRange(t);
                    o.push(e);
                  }
                  i.writer.setSelection(o, { backward: n.isBackward });
                },
                { priority: "low" }
              ),
              this.downcastDispatcher.on(
                "selection",
                (t, e, i) => {
                  const n = e.selection;
                  if (!n.isCollapsed) return;
                  if (!i.consumable.consume(n, "selection")) return;
                  const o = i.writer,
                    r = n.getFirstPosition(),
                    s = i.mapper.toViewPosition(r),
                    a = o.breakAttributes(s);
                  o.setSelection(a);
                },
                { priority: "low" }
              ),
              this.view.document.roots
                .bindTo(this.model.document.roots)
                .using((t) => {
                  if ("$graveyard" == t.rootName) return null;
                  const e = new Qn(this.view.document, t.name);
                  return (
                    (e.rootName = t.rootName), this.mapper.bindElements(t, e), e
                  );
                });
          }
          destroy() {
            this.view.destroy(), this.stopListening();
          }
        }
        yi(Zs, Hn);
        class ta {
          constructor() {
            this._commands = new Map();
          }
          add(t, e) {
            this._commands.set(t, e);
          }
          get(t) {
            return this._commands.get(t);
          }
          execute(t, ...e) {
            const i = this.get(t);
            if (!i)
              throw new hi.b(
                "commandcollection-command-not-found: Command does not exist.",
                this,
                { commandName: t }
              );
            i.execute(...e);
          }
          *names() {
            yield* this._commands.keys();
          }
          *commands() {
            yield* this._commands.values();
          }
          [Symbol.iterator]() {
            return this._commands[Symbol.iterator]();
          }
          destroy() {
            for (const t of this.commands()) t.destroy();
          }
        }
        class ea {
          constructor() {
            this._consumables = new Map();
          }
          add(t, e) {
            let i;
            t.is("text") || t.is("documentFragment")
              ? this._consumables.set(t, !0)
              : (this._consumables.has(t)
                  ? (i = this._consumables.get(t))
                  : ((i = new ia(t)), this._consumables.set(t, i)),
                i.add(e));
          }
          test(t, e) {
            const i = this._consumables.get(t);
            return void 0 === i
              ? null
              : t.is("text") || t.is("documentFragment")
              ? i
              : i.test(e);
          }
          consume(t, e) {
            return (
              !!this.test(t, e) &&
              (t.is("text") || t.is("documentFragment")
                ? this._consumables.set(t, !1)
                : this._consumables.get(t).consume(e),
              !0)
            );
          }
          revert(t, e) {
            const i = this._consumables.get(t);
            void 0 !== i &&
              (t.is("text") || t.is("documentFragment")
                ? this._consumables.set(t, !0)
                : i.revert(e));
          }
          static consumablesFromElement(t) {
            const e = {
                element: t,
                name: !0,
                attributes: [],
                classes: [],
                styles: [],
              },
              i = t.getAttributeKeys();
            for (const t of i)
              "style" != t && "class" != t && e.attributes.push(t);
            const n = t.getClassNames();
            for (const t of n) e.classes.push(t);
            const o = t.getStyleNames();
            for (const t of o) e.styles.push(t);
            return e;
          }
          static createFrom(t, e) {
            if ((e || (e = new ea(t)), t.is("text"))) return e.add(t), e;
            t.is("element") && e.add(t, ea.consumablesFromElement(t)),
              t.is("documentFragment") && e.add(t);
            for (const i of t.getChildren()) e = ea.createFrom(i, e);
            return e;
          }
        }
        class ia {
          constructor(t) {
            (this.element = t),
              (this._canConsumeName = null),
              (this._consumables = {
                attributes: new Map(),
                styles: new Map(),
                classes: new Map(),
              });
          }
          add(t) {
            t.name && (this._canConsumeName = !0);
            for (const e in this._consumables) e in t && this._add(e, t[e]);
          }
          test(t) {
            if (t.name && !this._canConsumeName) return this._canConsumeName;
            for (const e in this._consumables)
              if (e in t) {
                const i = this._test(e, t[e]);
                if (!0 !== i) return i;
              }
            return !0;
          }
          consume(t) {
            t.name && (this._canConsumeName = !1);
            for (const e in this._consumables) e in t && this._consume(e, t[e]);
          }
          revert(t) {
            t.name && (this._canConsumeName = !0);
            for (const e in this._consumables) e in t && this._revert(e, t[e]);
          }
          _add(t, e) {
            const i = Lt(e) ? e : [e],
              n = this._consumables[t];
            for (const e of i) {
              if ("attributes" === t && ("class" === e || "style" === e))
                throw new hi.b(
                  "viewconsumable-invalid-attribute: Classes and styles should be handled separately.",
                  this
                );
              if ((n.set(e, !0), "styles" === t))
                for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                  e
                ))
                  n.set(t, !0);
            }
          }
          _test(t, e) {
            const i = Lt(e) ? e : [e],
              n = this._consumables[t];
            for (const e of i)
              if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                const t = n.get(e);
                if (void 0 === t) return null;
                if (!t) return !1;
              } else {
                const t = "class" == e ? "classes" : "styles",
                  i = this._test(t, [...this._consumables[t].keys()]);
                if (!0 !== i) return i;
              }
            return !0;
          }
          _consume(t, e) {
            const i = Lt(e) ? e : [e],
              n = this._consumables[t];
            for (const e of i)
              if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                if ((n.set(e, !1), "styles" == t))
                  for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                    e
                  ))
                    n.set(t, !1);
              } else {
                const t = "class" == e ? "classes" : "styles";
                this._consume(t, [...this._consumables[t].keys()]);
              }
          }
          _revert(t, e) {
            const i = Lt(e) ? e : [e],
              n = this._consumables[t];
            for (const e of i)
              if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                !1 === n.get(e) && n.set(e, !0);
              } else {
                const t = "class" == e ? "classes" : "styles";
                this._revert(t, [...this._consumables[t].keys()]);
              }
          }
        }
        class na {
          constructor() {
            (this._sourceDefinitions = {}),
              (this._attributeProperties = {}),
              this.decorate("checkChild"),
              this.decorate("checkAttribute"),
              this.on(
                "checkAttribute",
                (t, e) => {
                  e[0] = new oa(e[0]);
                },
                { priority: "highest" }
              ),
              this.on(
                "checkChild",
                (t, e) => {
                  (e[0] = new oa(e[0])), (e[1] = this.getDefinition(e[1]));
                },
                { priority: "highest" }
              );
          }
          register(t, e) {
            if (this._sourceDefinitions[t])
              throw new hi.b(
                "schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.",
                this,
                { itemName: t }
              );
            (this._sourceDefinitions[t] = [Object.assign({}, e)]),
              this._clearCache();
          }
          extend(t, e) {
            if (!this._sourceDefinitions[t])
              throw new hi.b(
                "schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.",
                this,
                { itemName: t }
              );
            this._sourceDefinitions[t].push(Object.assign({}, e)),
              this._clearCache();
          }
          getDefinitions() {
            return (
              this._compiledDefinitions || this._compile(),
              this._compiledDefinitions
            );
          }
          getDefinition(t) {
            let e;
            return (
              (e =
                "string" == typeof t
                  ? t
                  : t.is && (t.is("text") || t.is("textProxy"))
                  ? "$text"
                  : t.name),
              this.getDefinitions()[e]
            );
          }
          isRegistered(t) {
            return !!this.getDefinition(t);
          }
          isBlock(t) {
            const e = this.getDefinition(t);
            return !(!e || !e.isBlock);
          }
          isLimit(t) {
            const e = this.getDefinition(t);
            return !!e && !(!e.isLimit && !e.isObject);
          }
          isObject(t) {
            const e = this.getDefinition(t);
            return !(!e || !e.isObject);
          }
          isInline(t) {
            const e = this.getDefinition(t);
            return !(!e || !e.isInline);
          }
          checkChild(t, e) {
            return !!e && this._checkContextMatch(e, t);
          }
          checkAttribute(t, e) {
            const i = this.getDefinition(t.last);
            return !!i && i.allowAttributes.includes(e);
          }
          checkMerge(t, e = null) {
            if (t instanceof _s) {
              const e = t.nodeBefore,
                i = t.nodeAfter;
              if (!(e instanceof ps))
                throw new hi.b(
                  "schema-check-merge-no-element-before: The node before the merge position must be an element.",
                  this
                );
              if (!(i instanceof ps))
                throw new hi.b(
                  "schema-check-merge-no-element-after: The node after the merge position must be an element.",
                  this
                );
              return this.checkMerge(e, i);
            }
            for (const i of e.getChildren())
              if (!this.checkChild(t, i)) return !1;
            return !0;
          }
          addChildCheck(t) {
            this.on(
              "checkChild",
              (e, [i, n]) => {
                if (!n) return;
                const o = t(i, n);
                "boolean" == typeof o && (e.stop(), (e.return = o));
              },
              { priority: "high" }
            );
          }
          addAttributeCheck(t) {
            this.on(
              "checkAttribute",
              (e, [i, n]) => {
                const o = t(i, n);
                "boolean" == typeof o && (e.stop(), (e.return = o));
              },
              { priority: "high" }
            );
          }
          setAttributeProperties(t, e) {
            this._attributeProperties[t] = Object.assign(
              this.getAttributeProperties(t),
              e
            );
          }
          getAttributeProperties(t) {
            return this._attributeProperties[t] || {};
          }
          getLimitElement(t) {
            let e;
            if (t instanceof _s) e = t.parent;
            else {
              e = (t instanceof xs ? [t] : Array.from(t.getRanges())).reduce(
                (t, e) => {
                  const i = e.getCommonAncestor();
                  return t ? t.getCommonAncestor(i, { includeSelf: !0 }) : i;
                },
                null
              );
            }
            for (; !this.isLimit(e) && e.parent; ) e = e.parent;
            return e;
          }
          checkAttributeInSelection(t, e) {
            if (t.isCollapsed) {
              const i = [
                ...t.getFirstPosition().getAncestors(),
                new ms("", t.getAttributes()),
              ];
              return this.checkAttribute(i, e);
            }
            {
              const i = t.getRanges();
              for (const t of i)
                for (const i of t)
                  if (this.checkAttribute(i.item, e)) return !0;
            }
            return !1;
          }
          *getValidRanges(t, e) {
            t = (function* (t) {
              for (const e of t) yield* e.getMinimalFlatRanges();
            })(t);
            for (const i of t) yield* this._getValidRangesForRange(i, e);
          }
          getNearestSelectionRange(t, e = "both") {
            if (this.checkChild(t, "$text")) return new xs(t);
            let i, n;
            const o =
              t
                .getAncestors()
                .reverse()
                .find((t) => this.isLimit(t)) || t.root;
            ("both" != e && "backward" != e) ||
              (i = new bs({
                boundaries: xs._createIn(o),
                startPosition: t,
                direction: "backward",
              })),
              ("both" != e && "forward" != e) ||
                (n = new bs({ boundaries: xs._createIn(o), startPosition: t }));
            for (const t of (function* (t, e) {
              let i = !1;
              for (; !i; ) {
                if (((i = !0), t)) {
                  const e = t.next();
                  e.done || ((i = !1), yield { walker: t, value: e.value });
                }
                if (e) {
                  const t = e.next();
                  t.done || ((i = !1), yield { walker: e, value: t.value });
                }
              }
            })(i, n)) {
              const e = t.walker == i ? "elementEnd" : "elementStart",
                n = t.value;
              if (n.type == e && this.isObject(n.item))
                return xs._createOn(n.item);
              if (this.checkChild(n.nextPosition, "$text"))
                return new xs(n.nextPosition);
            }
            return null;
          }
          findAllowedParent(t, e) {
            let i = t.parent;
            for (; i; ) {
              if (this.checkChild(i, e)) return i;
              if (this.isLimit(i)) return null;
              i = i.parent;
            }
            return null;
          }
          removeDisallowedAttributes(t, e) {
            for (const i of t)
              if (i.is("text")) fa(this, i, e);
              else {
                const t = xs._createIn(i).getPositions();
                for (const i of t) {
                  fa(this, i.nodeBefore || i.parent, e);
                }
              }
          }
          createContext(t) {
            return new oa(t);
          }
          _clearCache() {
            this._compiledDefinitions = null;
          }
          _compile() {
            const t = {},
              e = this._sourceDefinitions,
              i = Object.keys(e);
            for (const n of i) t[n] = ra(e[n], n);
            for (const e of i) sa(t, e);
            for (const e of i) aa(t, e);
            for (const e of i) la(t, e), ca(t, e);
            for (const e of i) da(t, e), ha(t, e);
            this._compiledDefinitions = t;
          }
          _checkContextMatch(t, e, i = e.length - 1) {
            const n = e.getItem(i);
            if (t.allowIn.includes(n.name)) {
              if (0 == i) return !0;
              {
                const t = this.getDefinition(n);
                return this._checkContextMatch(t, e, i - 1);
              }
            }
            return !1;
          }
          *_getValidRangesForRange(t, e) {
            let i = t.start,
              n = t.start;
            for (const o of t.getItems({ shallow: !0 }))
              o.is("element") &&
                (yield* this._getValidRangesForRange(xs._createIn(o), e)),
                this.checkAttribute(o, e) ||
                  (i.isEqual(n) || (yield new xs(i, n)),
                  (i = _s._createAfter(o))),
                (n = _s._createAfter(o));
            i.isEqual(n) || (yield new xs(i, n));
          }
        }
        yi(na, Hn);
        class oa {
          constructor(t) {
            if (t instanceof oa) return t;
            "string" == typeof t
              ? (t = [t])
              : Array.isArray(t) || (t = t.getAncestors({ includeSelf: !0 })),
              t[0] &&
                "string" != typeof t[0] &&
                t[0].is("documentFragment") &&
                t.shift(),
              (this._items = t.map(ga));
          }
          get length() {
            return this._items.length;
          }
          get last() {
            return this._items[this._items.length - 1];
          }
          [Symbol.iterator]() {
            return this._items[Symbol.iterator]();
          }
          push(t) {
            const e = new oa([t]);
            return (e._items = [...this._items, ...e._items]), e;
          }
          getItem(t) {
            return this._items[t];
          }
          *getNames() {
            yield* this._items.map((t) => t.name);
          }
          endsWith(t) {
            return Array.from(this.getNames()).join(" ").endsWith(t);
          }
          startsWith(t) {
            return Array.from(this.getNames()).join(" ").startsWith(t);
          }
        }
        function ra(t, e) {
          const i = {
            name: e,
            allowIn: [],
            allowContentOf: [],
            allowWhere: [],
            allowAttributes: [],
            allowAttributesOf: [],
            inheritTypesFrom: [],
          };
          return (
            (function (t, e) {
              for (const i of t) {
                const t = Object.keys(i).filter((t) => t.startsWith("is"));
                for (const n of t) e[n] = i[n];
              }
            })(t, i),
            ua(t, i, "allowIn"),
            ua(t, i, "allowContentOf"),
            ua(t, i, "allowWhere"),
            ua(t, i, "allowAttributes"),
            ua(t, i, "allowAttributesOf"),
            ua(t, i, "inheritTypesFrom"),
            (function (t, e) {
              for (const i of t) {
                const t = i.inheritAllFrom;
                t &&
                  (e.allowContentOf.push(t),
                  e.allowWhere.push(t),
                  e.allowAttributesOf.push(t),
                  e.inheritTypesFrom.push(t));
              }
            })(t, i),
            i
          );
        }
        function sa(t, e) {
          for (const i of t[e].allowContentOf)
            if (t[i]) {
              ma(t, i).forEach((t) => {
                t.allowIn.push(e);
              });
            }
          delete t[e].allowContentOf;
        }
        function aa(t, e) {
          for (const i of t[e].allowWhere) {
            const n = t[i];
            if (n) {
              const i = n.allowIn;
              t[e].allowIn.push(...i);
            }
          }
          delete t[e].allowWhere;
        }
        function la(t, e) {
          for (const i of t[e].allowAttributesOf) {
            const n = t[i];
            if (n) {
              const i = n.allowAttributes;
              t[e].allowAttributes.push(...i);
            }
          }
          delete t[e].allowAttributesOf;
        }
        function ca(t, e) {
          const i = t[e];
          for (const e of i.inheritTypesFrom) {
            const n = t[e];
            if (n) {
              const t = Object.keys(n).filter((t) => t.startsWith("is"));
              for (const e of t) e in i || (i[e] = n[e]);
            }
          }
          delete i.inheritTypesFrom;
        }
        function da(t, e) {
          const i = t[e],
            n = i.allowIn.filter((e) => t[e]);
          i.allowIn = Array.from(new Set(n));
        }
        function ha(t, e) {
          const i = t[e];
          i.allowAttributes = Array.from(new Set(i.allowAttributes));
        }
        function ua(t, e, i) {
          for (const n of t)
            "string" == typeof n[i]
              ? e[i].push(n[i])
              : Array.isArray(n[i]) && e[i].push(...n[i]);
        }
        function ma(t, e) {
          const i = t[e];
          return ((n = t), Object.keys(n).map((t) => n[t])).filter((t) =>
            t.allowIn.includes(i.name)
          );
          var n;
        }
        function ga(t) {
          return "string" == typeof t
            ? { name: t, *getAttributeKeys() {}, getAttribute() {} }
            : {
                name: t.is("element") ? t.name : "$text",
                *getAttributeKeys() {
                  yield* t.getAttributeKeys();
                },
                getAttribute: (e) => t.getAttribute(e),
              };
        }
        function fa(t, e, i) {
          for (const n of e.getAttributeKeys())
            t.checkAttribute(e, n) || i.removeAttribute(n, e);
        }
        class pa {
          constructor(t = {}) {
            (this._splitParts = new Map()),
              (this._modelCursor = null),
              (this.conversionApi = Object.assign({}, t)),
              (this.conversionApi.convertItem = this._convertItem.bind(this)),
              (this.conversionApi.convertChildren =
                this._convertChildren.bind(this)),
              (this.conversionApi.splitToAllowedParent =
                this._splitToAllowedParent.bind(this)),
              (this.conversionApi.getSplitParts =
                this._getSplitParts.bind(this));
          }
          convert(t, e, i = ["$root"]) {
            this.fire("viewCleanup", t),
              (this._modelCursor = (function (t, e) {
                let i;
                for (const n of new oa(t)) {
                  const t = {};
                  for (const e of n.getAttributeKeys())
                    t[e] = n.getAttribute(e);
                  const o = e.createElement(n.name, t);
                  i && e.append(o, i), (i = _s._createAt(o, 0));
                }
                return i;
              })(i, e)),
              (this.conversionApi.writer = e),
              (this.conversionApi.consumable = ea.createFrom(t)),
              (this.conversionApi.store = {});
            const { modelRange: n } = this._convertItem(t, this._modelCursor),
              o = e.createDocumentFragment();
            if (n) {
              this._removeEmptyElements();
              for (const t of Array.from(
                this._modelCursor.parent.getChildren()
              ))
                e.append(t, o);
              o.markers = (function (t, e) {
                const i = new Set(),
                  n = new Map(),
                  o = xs._createIn(t).getItems();
                for (const t of o) "$marker" == t.name && i.add(t);
                for (const t of i) {
                  const i = t.getAttribute("data-name"),
                    o = e.createPositionBefore(t);
                  n.has(i)
                    ? (n.get(i).end = o.clone())
                    : n.set(i, new xs(o.clone())),
                    e.remove(t);
                }
                return n;
              })(o, e);
            }
            return (
              (this._modelCursor = null),
              this._splitParts.clear(),
              (this.conversionApi.writer = null),
              (this.conversionApi.store = null),
              o
            );
          }
          _convertItem(t, e) {
            const i = Object.assign({
              viewItem: t,
              modelCursor: e,
              modelRange: null,
            });
            if (
              (t.is("element")
                ? this.fire("element:" + t.name, i, this.conversionApi)
                : t.is("text")
                ? this.fire("text", i, this.conversionApi)
                : this.fire("documentFragment", i, this.conversionApi),
              i.modelRange && !(i.modelRange instanceof xs))
            )
              throw new hi.b(
                "view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.",
                this
              );
            return { modelRange: i.modelRange, modelCursor: i.modelCursor };
          }
          _convertChildren(t, e) {
            const i = new xs(e);
            let n = e;
            for (const e of Array.from(t.getChildren())) {
              const t = this._convertItem(e, n);
              t.modelRange instanceof xs &&
                ((i.end = t.modelRange.end), (n = t.modelCursor));
            }
            return { modelRange: i, modelCursor: n };
          }
          _splitToAllowedParent(t, e) {
            const i = this.conversionApi.schema.findAllowedParent(e, t);
            if (!i) return null;
            if (i === e.parent) return { position: e };
            if (this._modelCursor.parent.getAncestors().includes(i))
              return null;
            const n = this.conversionApi.writer.split(e, i),
              o = [];
            for (const t of n.range.getWalker())
              if ("elementEnd" == t.type) o.push(t.item);
              else {
                const e = o.pop(),
                  i = t.item;
                this._registerSplitPair(e, i);
              }
            return { position: n.position, cursorParent: n.range.end.parent };
          }
          _registerSplitPair(t, e) {
            this._splitParts.has(t) || this._splitParts.set(t, [t]);
            const i = this._splitParts.get(t);
            this._splitParts.set(e, i), i.push(e);
          }
          _getSplitParts(t) {
            let e;
            return (
              (e = this._splitParts.has(t) ? this._splitParts.get(t) : [t]), e
            );
          }
          _removeEmptyElements() {
            let t = !1;
            for (const e of this._splitParts.keys())
              e.isEmpty &&
                (this.conversionApi.writer.remove(e),
                this._splitParts.delete(e),
                (t = !0));
            t && this._removeEmptyElements();
          }
        }
        yi(pa, gi);
        class ba {
          constructor(t, e) {
            (this.model = t),
              (this.stylesProcessor = e),
              this.processor,
              (this.mapper = new As()),
              (this.downcastDispatcher = new Ms({ mapper: this.mapper })),
              this.downcastDispatcher.on(
                "insert:$text",
                (t, e, i) => {
                  if (!i.consumable.consume(e.item, "insert")) return;
                  const n = i.writer,
                    o = i.mapper.toViewPosition(e.range.start),
                    r = n.createText(e.item.data);
                  n.insert(o, r);
                },
                { priority: "lowest" }
              ),
              (this.upcastDispatcher = new pa({ schema: t.schema })),
              (this.viewDocument = new oo(e)),
              (this._viewWriter = new Ao(this.viewDocument)),
              this.upcastDispatcher.on(
                "text",
                (t, e, i) => {
                  if (
                    i.schema.checkChild(e.modelCursor, "$text") &&
                    i.consumable.consume(e.viewItem)
                  ) {
                    const t = i.writer.createText(e.viewItem.data);
                    i.writer.insert(t, e.modelCursor),
                      (e.modelRange = xs._createFromPositionAndShift(
                        e.modelCursor,
                        t.offsetSize
                      )),
                      (e.modelCursor = e.modelRange.end);
                  }
                },
                { priority: "lowest" }
              ),
              this.upcastDispatcher.on(
                "element",
                (t, e, i) => {
                  if (
                    !e.modelRange &&
                    i.consumable.consume(e.viewItem, { name: !0 })
                  ) {
                    const { modelRange: t, modelCursor: n } = i.convertChildren(
                      e.viewItem,
                      e.modelCursor
                    );
                    (e.modelRange = t), (e.modelCursor = n);
                  }
                },
                { priority: "lowest" }
              ),
              this.upcastDispatcher.on(
                "documentFragment",
                (t, e, i) => {
                  if (
                    !e.modelRange &&
                    i.consumable.consume(e.viewItem, { name: !0 })
                  ) {
                    const { modelRange: t, modelCursor: n } = i.convertChildren(
                      e.viewItem,
                      e.modelCursor
                    );
                    (e.modelRange = t), (e.modelCursor = n);
                  }
                },
                { priority: "lowest" }
              ),
              this.decorate("init"),
              this.on(
                "init",
                () => {
                  this.fire("ready");
                },
                { priority: "lowest" }
              );
          }
          get(t) {
            const { rootName: e = "main", trim: i = "empty" } = t || {};
            if (!this._checkIfRootsExists([e]))
              throw new hi.b(
                "datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.",
                this
              );
            const n = this.model.document.getRoot(e);
            return "empty" !== i ||
              this.model.hasContent(n, { ignoreWhitespaces: !0 })
              ? this.stringify(n)
              : "";
          }
          stringify(t) {
            const e = this.toView(t);
            return this.processor.toData(e);
          }
          toView(t) {
            const e = this.viewDocument,
              i = this._viewWriter;
            this.mapper.clearBindings();
            const n = xs._createIn(t),
              o = new xo(e);
            if (
              (this.mapper.bindElements(t, o),
              this.downcastDispatcher.convertInsert(n, i),
              !t.is("documentFragment"))
            ) {
              const e = (function (t) {
                const e = [],
                  i = t.root.document;
                if (!i) return [];
                const n = xs._createIn(t);
                for (const t of i.model.markers) {
                  const i = n.getIntersection(t.getRange());
                  i && e.push([t.name, i]);
                }
                return e;
              })(t);
              for (const [t, n] of e)
                this.downcastDispatcher.convertMarkerAdd(t, n, i);
            }
            return o;
          }
          init(t) {
            if (this.model.document.version)
              throw new hi.b(
                "datacontroller-init-document-not-empty: Trying to set initial data to not empty document.",
                this
              );
            let e = {};
            if (
              ("string" == typeof t ? (e.main = t) : (e = t),
              !this._checkIfRootsExists(Object.keys(e)))
            )
              throw new hi.b(
                "datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.",
                this
              );
            return (
              this.model.enqueueChange("transparent", (t) => {
                for (const i of Object.keys(e)) {
                  const n = this.model.document.getRoot(i);
                  t.insert(this.parse(e[i], n), n, 0);
                }
              }),
              Promise.resolve()
            );
          }
          set(t) {
            let e = {};
            if (
              ("string" == typeof t ? (e.main = t) : (e = t),
              !this._checkIfRootsExists(Object.keys(e)))
            )
              throw new hi.b(
                "datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.",
                this
              );
            this.model.enqueueChange("transparent", (t) => {
              t.setSelection(null),
                t.removeSelectionAttribute(
                  this.model.document.selection.getAttributeKeys()
                );
              for (const i of Object.keys(e)) {
                const n = this.model.document.getRoot(i);
                t.remove(t.createRangeIn(n)),
                  t.insert(this.parse(e[i], n), n, 0);
              }
            });
          }
          parse(t, e = "$root") {
            const i = this.processor.toView(t);
            return this.toModel(i, e);
          }
          toModel(t, e = "$root") {
            return this.model.change((i) =>
              this.upcastDispatcher.convert(t, i, e)
            );
          }
          addStyleProcessorRules(t) {
            t(this.stylesProcessor);
          }
          destroy() {
            this.stopListening();
          }
          _checkIfRootsExists(t) {
            for (const e of t)
              if (!this.model.document.getRootNames().includes(e)) return !1;
            return !0;
          }
        }
        yi(ba, Hn);
        class wa {
          constructor(t, e) {
            (this._helpers = new Map()),
              (this._downcast = Array.isArray(t) ? t : [t]),
              this._createConversionHelpers({
                name: "downcast",
                dispatchers: this._downcast,
                isDowncast: !0,
              }),
              (this._upcast = Array.isArray(e) ? e : [e]),
              this._createConversionHelpers({
                name: "upcast",
                dispatchers: this._upcast,
                isDowncast: !1,
              });
          }
          addAlias(t, e) {
            const i = this._downcast.includes(e);
            if (!this._upcast.includes(e) && !i)
              throw new hi.b(
                "conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.",
                this
              );
            this._createConversionHelpers({
              name: t,
              dispatchers: [e],
              isDowncast: i,
            });
          }
          for(t) {
            if (!this._helpers.has(t))
              throw new hi.b(
                "conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.",
                this
              );
            return this._helpers.get(t);
          }
          elementToElement(t) {
            this.for("downcast").elementToElement(t);
            for (const { model: e, view: i } of _a(t))
              this.for("upcast").elementToElement({
                model: e,
                view: i,
                converterPriority: t.converterPriority,
              });
          }
          attributeToElement(t) {
            this.for("downcast").attributeToElement(t);
            for (const { model: e, view: i } of _a(t))
              this.for("upcast").elementToAttribute({
                view: i,
                model: e,
                converterPriority: t.converterPriority,
              });
          }
          attributeToAttribute(t) {
            this.for("downcast").attributeToAttribute(t);
            for (const { model: e, view: i } of _a(t))
              this.for("upcast").attributeToAttribute({ view: i, model: e });
          }
          _createConversionHelpers({ name: t, dispatchers: e, isDowncast: i }) {
            if (this._helpers.has(t))
              throw new hi.b(
                "conversion-group-exists: Trying to register a group name that has already been registered.",
                this
              );
            const n = i ? new Hs(e) : new Js(e);
            this._helpers.set(t, n);
          }
        }
        function* _a(t) {
          if (t.model.values)
            for (const e of t.model.values) {
              const i = { key: t.model.key, value: e },
                n = t.view[e],
                o = t.upcastAlso ? t.upcastAlso[e] : void 0;
              yield* ka(i, n, o);
            }
          else yield* ka(t.model, t.view, t.upcastAlso);
        }
        function* ka(t, e, i) {
          if ((yield { model: t, view: e }, i)) {
            i = Array.isArray(i) ? i : [i];
            for (const e of i) yield { model: t, view: e };
          }
        }
        class va {
          constructor(t = "default") {
            (this.operations = []), (this.type = t);
          }
          get baseVersion() {
            for (const t of this.operations)
              if (null !== t.baseVersion) return t.baseVersion;
            return null;
          }
          addOperation(t) {
            return (t.batch = this), this.operations.push(t), t;
          }
        }
        class ya {
          constructor(t) {
            (this.baseVersion = t),
              (this.isDocumentOperation = null !== this.baseVersion),
              (this.batch = null);
          }
          _validate() {}
          toJSON() {
            const t = Object.assign({}, this);
            return (
              (t.__className = this.constructor.className),
              delete t.batch,
              delete t.isDocumentOperation,
              t
            );
          }
          static get className() {
            return "Operation";
          }
          static fromJSON(t) {
            return new this(t.baseVersion);
          }
        }
        class xa {
          constructor(t) {
            (this.markers = new Map()),
              (this._children = new fs()),
              t && this._insertChild(0, t);
          }
          [Symbol.iterator]() {
            return this.getChildren();
          }
          get childCount() {
            return this._children.length;
          }
          get maxOffset() {
            return this._children.maxOffset;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          get root() {
            return this;
          }
          get parent() {
            return null;
          }
          is(t) {
            return "documentFragment" === t || "model:documentFragment" === t;
          }
          getChild(t) {
            return this._children.getNode(t);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          getChildIndex(t) {
            return this._children.getNodeIndex(t);
          }
          getChildStartOffset(t) {
            return this._children.getNodeStartOffset(t);
          }
          getPath() {
            return [];
          }
          getNodeByPath(t) {
            let e = this;
            for (const i of t) e = e.getChild(e.offsetToIndex(i));
            return e;
          }
          offsetToIndex(t) {
            return this._children.offsetToIndex(t);
          }
          toJSON() {
            const t = [];
            for (const e of this._children) t.push(e.toJSON());
            return t;
          }
          static fromJSON(t) {
            const e = [];
            for (const i of t)
              i.name ? e.push(ps.fromJSON(i)) : e.push(ms.fromJSON(i));
            return new xa(e);
          }
          _appendChild(t) {
            this._insertChild(this.childCount, t);
          }
          _insertChild(t, e) {
            const i = (function (t) {
              if ("string" == typeof t) return [new ms(t)];
              vi(t) || (t = [t]);
              return Array.from(t).map((t) =>
                "string" == typeof t
                  ? new ms(t)
                  : t instanceof gs
                  ? new ms(t.data, t.getAttributes())
                  : t
              );
            })(e);
            for (const t of i)
              null !== t.parent && t._remove(), (t.parent = this);
            this._children._insertNodes(t, i);
          }
          _removeChildren(t, e = 1) {
            const i = this._children._removeNodes(t, e);
            for (const t of i) t.parent = null;
            return i;
          }
        }
        function Aa(t, e) {
          const i = (e = Ma(e)).reduce((t, e) => t + e.offsetSize, 0),
            n = t.parent;
          Pa(t);
          const o = t.index;
          return (
            n._insertChild(o, e),
            Ea(n, o + e.length),
            Ea(n, o),
            new xs(t, t.getShiftedBy(i))
          );
        }
        function Ca(t) {
          if (!t.isFlat)
            throw new hi.b(
              "operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.",
              this
            );
          const e = t.start.parent;
          Pa(t.start), Pa(t.end);
          const i = e._removeChildren(
            t.start.index,
            t.end.index - t.start.index
          );
          return Ea(e, t.start.index), i;
        }
        function Ta(t, e) {
          if (!t.isFlat)
            throw new hi.b(
              "operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.",
              this
            );
          const i = Ca(t);
          return Aa(
            (e = e._getTransformedByDeletion(
              t.start,
              t.end.offset - t.start.offset
            )),
            i
          );
        }
        function Ma(t) {
          const e = [];
          t instanceof Array || (t = [t]);
          for (let i = 0; i < t.length; i++)
            if ("string" == typeof t[i]) e.push(new ms(t[i]));
            else if (t[i] instanceof gs)
              e.push(new ms(t[i].data, t[i].getAttributes()));
            else if (t[i] instanceof xa || t[i] instanceof fs)
              for (const n of t[i]) e.push(n);
            else t[i] instanceof us && e.push(t[i]);
          for (let t = 1; t < e.length; t++) {
            const i = e[t],
              n = e[t - 1];
            i instanceof ms &&
              n instanceof ms &&
              Sa(i, n) &&
              (e.splice(t - 1, 2, new ms(n.data + i.data, n.getAttributes())),
              t--);
          }
          return e;
        }
        function Ea(t, e) {
          const i = t.getChild(e - 1),
            n = t.getChild(e);
          if (i && n && i.is("text") && n.is("text") && Sa(i, n)) {
            const o = new ms(i.data + n.data, i.getAttributes());
            t._removeChildren(e - 1, 2), t._insertChild(e - 1, o);
          }
        }
        function Pa(t) {
          const e = t.textNode,
            i = t.parent;
          if (e) {
            const n = t.offset - e.startOffset,
              o = e.index;
            i._removeChildren(o, 1);
            const r = new ms(e.data.substr(0, n), e.getAttributes()),
              s = new ms(e.data.substr(n), e.getAttributes());
            i._insertChild(o, [r, s]);
          }
        }
        function Sa(t, e) {
          const i = t.getAttributes(),
            n = e.getAttributes();
          for (const t of i) {
            if (t[1] !== e.getAttribute(t[0])) return !1;
            n.next();
          }
          return n.next().done;
        }
        var Ia = function (t, e) {
          return Er(t, e);
        };
        class Oa extends ya {
          constructor(t, e, i, n, o) {
            super(o),
              (this.range = t.clone()),
              (this.key = e),
              (this.oldValue = void 0 === i ? null : i),
              (this.newValue = void 0 === n ? null : n);
          }
          get type() {
            return null === this.oldValue
              ? "addAttribute"
              : null === this.newValue
              ? "removeAttribute"
              : "changeAttribute";
          }
          clone() {
            return new Oa(
              this.range,
              this.key,
              this.oldValue,
              this.newValue,
              this.baseVersion
            );
          }
          getReversed() {
            return new Oa(
              this.range,
              this.key,
              this.newValue,
              this.oldValue,
              this.baseVersion + 1
            );
          }
          toJSON() {
            const t = super.toJSON();
            return (t.range = this.range.toJSON()), t;
          }
          _validate() {
            if (!this.range.isFlat)
              throw new hi.b(
                "attribute-operation-range-not-flat: The range to change is not flat.",
                this
              );
            for (const t of this.range.getItems({ shallow: !0 })) {
              if (
                null !== this.oldValue &&
                !Ia(t.getAttribute(this.key), this.oldValue)
              )
                throw new hi.b(
                  "attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.",
                  this,
                  { item: t, key: this.key, value: this.oldValue }
                );
              if (
                null === this.oldValue &&
                null !== this.newValue &&
                t.hasAttribute(this.key)
              )
                throw new hi.b(
                  "attribute-operation-attribute-exists: The attribute with given key already exists.",
                  this,
                  { node: t, key: this.key }
                );
            }
          }
          _execute() {
            Ia(this.oldValue, this.newValue) ||
              (function (t, e, i) {
                Pa(t.start), Pa(t.end);
                for (const n of t.getItems({ shallow: !0 })) {
                  const t = n.is("textProxy") ? n.textNode : n;
                  null !== i ? t._setAttribute(e, i) : t._removeAttribute(e),
                    Ea(t.parent, t.index);
                }
                Ea(t.end.parent, t.end.index);
              })(this.range, this.key, this.newValue);
          }
          static get className() {
            return "AttributeOperation";
          }
          static fromJSON(t, e) {
            return new Oa(
              xs.fromJSON(t.range, e),
              t.key,
              t.oldValue,
              t.newValue,
              t.baseVersion
            );
          }
        }
        class Na extends ya {
          constructor(t, e) {
            super(null), (this.sourcePosition = t.clone()), (this.howMany = e);
          }
          get type() {
            return "detach";
          }
          toJSON() {
            const t = super.toJSON();
            return (t.sourcePosition = this.sourcePosition.toJSON()), t;
          }
          _validate() {
            if (this.sourcePosition.root.document)
              throw new hi.b(
                "detach-operation-on-document-node: Cannot detach document node.",
                this
              );
          }
          _execute() {
            Ca(
              xs._createFromPositionAndShift(this.sourcePosition, this.howMany)
            );
          }
          static get className() {
            return "DetachOperation";
          }
        }
        class Ra extends ya {
          constructor(t, e, i, n) {
            super(n),
              (this.sourcePosition = t.clone()),
              (this.sourcePosition.stickiness = "toNext"),
              (this.howMany = e),
              (this.targetPosition = i.clone()),
              (this.targetPosition.stickiness = "toNone");
          }
          get type() {
            return "$graveyard" == this.targetPosition.root.rootName
              ? "remove"
              : "$graveyard" == this.sourcePosition.root.rootName
              ? "reinsert"
              : "move";
          }
          clone() {
            return new this.constructor(
              this.sourcePosition,
              this.howMany,
              this.targetPosition,
              this.baseVersion
            );
          }
          getMovedRangeStart() {
            return this.targetPosition._getTransformedByDeletion(
              this.sourcePosition,
              this.howMany
            );
          }
          getReversed() {
            const t = this.sourcePosition._getTransformedByInsertion(
              this.targetPosition,
              this.howMany
            );
            return new this.constructor(
              this.getMovedRangeStart(),
              this.howMany,
              t,
              this.baseVersion + 1
            );
          }
          _validate() {
            const t = this.sourcePosition.parent,
              e = this.targetPosition.parent,
              i = this.sourcePosition.offset,
              n = this.targetPosition.offset;
            if (i + this.howMany > t.maxOffset)
              throw new hi.b(
                "move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.",
                this
              );
            if (t === e && i < n && n < i + this.howMany)
              throw new hi.b(
                "move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.",
                this
              );
            if (
              this.sourcePosition.root == this.targetPosition.root &&
              "prefix" ==
                Si(
                  this.sourcePosition.getParentPath(),
                  this.targetPosition.getParentPath()
                )
            ) {
              const t = this.sourcePosition.path.length - 1;
              if (
                this.targetPosition.path[t] >= i &&
                this.targetPosition.path[t] < i + this.howMany
              )
                throw new hi.b(
                  "move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.",
                  this
                );
            }
          }
          _execute() {
            Ta(
              xs._createFromPositionAndShift(this.sourcePosition, this.howMany),
              this.targetPosition
            );
          }
          toJSON() {
            const t = super.toJSON();
            return (
              (t.sourcePosition = this.sourcePosition.toJSON()),
              (t.targetPosition = this.targetPosition.toJSON()),
              t
            );
          }
          static get className() {
            return "MoveOperation";
          }
          static fromJSON(t, e) {
            const i = _s.fromJSON(t.sourcePosition, e),
              n = _s.fromJSON(t.targetPosition, e);
            return new this(i, t.howMany, n, t.baseVersion);
          }
        }
        class La extends ya {
          constructor(t, e, i) {
            super(i),
              (this.position = t.clone()),
              (this.position.stickiness = "toNone"),
              (this.nodes = new fs(Ma(e))),
              (this.shouldReceiveAttributes = !1);
          }
          get type() {
            return "insert";
          }
          get howMany() {
            return this.nodes.maxOffset;
          }
          clone() {
            const t = new fs([...this.nodes].map((t) => t._clone(!0))),
              e = new La(this.position, t, this.baseVersion);
            return (
              (e.shouldReceiveAttributes = this.shouldReceiveAttributes), e
            );
          }
          getReversed() {
            const t = this.position.root.document.graveyard,
              e = new _s(t, [0]);
            return new Ra(
              this.position,
              this.nodes.maxOffset,
              e,
              this.baseVersion + 1
            );
          }
          _validate() {
            const t = this.position.parent;
            if (!t || t.maxOffset < this.position.offset)
              throw new hi.b(
                "insert-operation-position-invalid: Insertion position is invalid.",
                this
              );
          }
          _execute() {
            const t = this.nodes;
            (this.nodes = new fs([...t].map((t) => t._clone(!0)))),
              Aa(this.position, t);
          }
          toJSON() {
            const t = super.toJSON();
            return (
              (t.position = this.position.toJSON()),
              (t.nodes = this.nodes.toJSON()),
              t
            );
          }
          static get className() {
            return "InsertOperation";
          }
          static fromJSON(t, e) {
            const i = [];
            for (const e of t.nodes)
              e.name ? i.push(ps.fromJSON(e)) : i.push(ms.fromJSON(e));
            const n = new La(_s.fromJSON(t.position, e), i, t.baseVersion);
            return (n.shouldReceiveAttributes = t.shouldReceiveAttributes), n;
          }
        }
        class ja extends ya {
          constructor(t, e, i, n, o, r) {
            super(r),
              (this.name = t),
              (this.oldRange = e ? e.clone() : null),
              (this.newRange = i ? i.clone() : null),
              (this.affectsData = o),
              (this._markers = n);
          }
          get type() {
            return "marker";
          }
          clone() {
            return new ja(
              this.name,
              this.oldRange,
              this.newRange,
              this._markers,
              this.affectsData,
              this.baseVersion
            );
          }
          getReversed() {
            return new ja(
              this.name,
              this.newRange,
              this.oldRange,
              this._markers,
              this.affectsData,
              this.baseVersion + 1
            );
          }
          _execute() {
            const t = this.newRange ? "_set" : "_remove";
            this._markers[t](this.name, this.newRange, !0, this.affectsData);
          }
          toJSON() {
            const t = super.toJSON();
            return (
              this.oldRange && (t.oldRange = this.oldRange.toJSON()),
              this.newRange && (t.newRange = this.newRange.toJSON()),
              delete t._markers,
              t
            );
          }
          static get className() {
            return "MarkerOperation";
          }
          static fromJSON(t, e) {
            return new ja(
              t.name,
              t.oldRange ? xs.fromJSON(t.oldRange, e) : null,
              t.newRange ? xs.fromJSON(t.newRange, e) : null,
              e.model.markers,
              t.affectsData,
              t.baseVersion
            );
          }
        }
        class Da extends ya {
          constructor(t, e, i, n) {
            super(n),
              (this.position = t),
              (this.position.stickiness = "toNext"),
              (this.oldName = e),
              (this.newName = i);
          }
          get type() {
            return "rename";
          }
          clone() {
            return new Da(
              this.position.clone(),
              this.oldName,
              this.newName,
              this.baseVersion
            );
          }
          getReversed() {
            return new Da(
              this.position.clone(),
              this.newName,
              this.oldName,
              this.baseVersion + 1
            );
          }
          _validate() {
            const t = this.position.nodeAfter;
            if (!(t instanceof ps))
              throw new hi.b(
                "rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.",
                this
              );
            if (t.name !== this.oldName)
              throw new hi.b(
                "rename-operation-wrong-name: Element to change has different name than operation's old name.",
                this
              );
          }
          _execute() {
            this.position.nodeAfter.name = this.newName;
          }
          toJSON() {
            const t = super.toJSON();
            return (t.position = this.position.toJSON()), t;
          }
          static get className() {
            return "RenameOperation";
          }
          static fromJSON(t, e) {
            return new Da(
              _s.fromJSON(t.position, e),
              t.oldName,
              t.newName,
              t.baseVersion
            );
          }
        }
        class za extends ya {
          constructor(t, e, i, n, o) {
            super(o),
              (this.root = t),
              (this.key = e),
              (this.oldValue = i),
              (this.newValue = n);
          }
          get type() {
            return null === this.oldValue
              ? "addRootAttribute"
              : null === this.newValue
              ? "removeRootAttribute"
              : "changeRootAttribute";
          }
          clone() {
            return new za(
              this.root,
              this.key,
              this.oldValue,
              this.newValue,
              this.baseVersion
            );
          }
          getReversed() {
            return new za(
              this.root,
              this.key,
              this.newValue,
              this.oldValue,
              this.baseVersion + 1
            );
          }
          _validate() {
            if (this.root != this.root.root || this.root.is("documentFragment"))
              throw new hi.b(
                "rootattribute-operation-not-a-root: The element to change is not a root element.",
                this,
                { root: this.root, key: this.key }
              );
            if (
              null !== this.oldValue &&
              this.root.getAttribute(this.key) !== this.oldValue
            )
              throw new hi.b(
                "rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.",
                this,
                { root: this.root, key: this.key }
              );
            if (
              null === this.oldValue &&
              null !== this.newValue &&
              this.root.hasAttribute(this.key)
            )
              throw new hi.b(
                "rootattribute-operation-attribute-exists: The attribute with given key already exists.",
                this,
                { root: this.root, key: this.key }
              );
          }
          _execute() {
            null !== this.newValue
              ? this.root._setAttribute(this.key, this.newValue)
              : this.root._removeAttribute(this.key);
          }
          toJSON() {
            const t = super.toJSON();
            return (t.root = this.root.toJSON()), t;
          }
          static get className() {
            return "RootAttributeOperation";
          }
          static fromJSON(t, e) {
            if (!e.getRoot(t.root))
              throw new hi.b(
                "rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.",
                this,
                { rootName: t.root }
              );
            return new za(
              e.getRoot(t.root),
              t.key,
              t.oldValue,
              t.newValue,
              t.baseVersion
            );
          }
        }
        class Ba extends ya {
          constructor(t, e, i, n, o) {
            super(o),
              (this.sourcePosition = t.clone()),
              (this.sourcePosition.stickiness = "toPrevious"),
              (this.howMany = e),
              (this.targetPosition = i.clone()),
              (this.targetPosition.stickiness = "toNext"),
              (this.graveyardPosition = n.clone());
          }
          get type() {
            return "merge";
          }
          get deletionPosition() {
            return new _s(
              this.sourcePosition.root,
              this.sourcePosition.path.slice(0, -1)
            );
          }
          get movedRange() {
            const t = this.sourcePosition.getShiftedBy(
              Number.POSITIVE_INFINITY
            );
            return new xs(this.sourcePosition, t);
          }
          clone() {
            return new this.constructor(
              this.sourcePosition,
              this.howMany,
              this.targetPosition,
              this.graveyardPosition,
              this.baseVersion
            );
          }
          getReversed() {
            const t = this.targetPosition._getTransformedByMergeOperation(this),
              e = this.sourcePosition.path.slice(0, -1),
              i = new _s(
                this.sourcePosition.root,
                e
              )._getTransformedByMergeOperation(this),
              n = new Va(
                t,
                this.howMany,
                this.graveyardPosition,
                this.baseVersion + 1
              );
            return (n.insertionPosition = i), n;
          }
          _validate() {
            const t = this.sourcePosition.parent,
              e = this.targetPosition.parent;
            if (!t.parent)
              throw new hi.b(
                "merge-operation-source-position-invalid: Merge source position is invalid.",
                this
              );
            if (!e.parent)
              throw new hi.b(
                "merge-operation-target-position-invalid: Merge target position is invalid.",
                this
              );
            if (this.howMany != t.maxOffset)
              throw new hi.b(
                "merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.",
                this
              );
          }
          _execute() {
            const t = this.sourcePosition.parent;
            Ta(xs._createIn(t), this.targetPosition),
              Ta(xs._createOn(t), this.graveyardPosition);
          }
          toJSON() {
            const t = super.toJSON();
            return (
              (t.sourcePosition = t.sourcePosition.toJSON()),
              (t.targetPosition = t.targetPosition.toJSON()),
              (t.graveyardPosition = t.graveyardPosition.toJSON()),
              t
            );
          }
          static get className() {
            return "MergeOperation";
          }
          static fromJSON(t, e) {
            const i = _s.fromJSON(t.sourcePosition, e),
              n = _s.fromJSON(t.targetPosition, e),
              o = _s.fromJSON(t.graveyardPosition, e);
            return new this(i, t.howMany, n, o, t.baseVersion);
          }
        }
        class Va extends ya {
          constructor(t, e, i, n) {
            super(n),
              (this.splitPosition = t.clone()),
              (this.splitPosition.stickiness = "toNext"),
              (this.howMany = e),
              (this.insertionPosition = Va.getInsertionPosition(t)),
              (this.insertionPosition.stickiness = "toNone"),
              (this.graveyardPosition = i ? i.clone() : null),
              this.graveyardPosition &&
                (this.graveyardPosition.stickiness = "toNext");
          }
          get type() {
            return "split";
          }
          get moveTargetPosition() {
            const t = this.insertionPosition.path.slice();
            return t.push(0), new _s(this.insertionPosition.root, t);
          }
          get movedRange() {
            const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
            return new xs(this.splitPosition, t);
          }
          clone() {
            const t = new this.constructor(
              this.splitPosition,
              this.howMany,
              this.graveyardPosition,
              this.baseVersion
            );
            return (t.insertionPosition = this.insertionPosition), t;
          }
          getReversed() {
            const t = this.splitPosition.root.document.graveyard,
              e = new _s(t, [0]);
            return new Ba(
              this.moveTargetPosition,
              this.howMany,
              this.splitPosition,
              e,
              this.baseVersion + 1
            );
          }
          _validate() {
            const t = this.splitPosition.parent,
              e = this.splitPosition.offset;
            if (!t || t.maxOffset < e)
              throw new hi.b(
                "split-operation-position-invalid: Split position is invalid.",
                this
              );
            if (!t.parent)
              throw new hi.b(
                "split-operation-split-in-root: Cannot split root element.",
                this
              );
            if (this.howMany != t.maxOffset - this.splitPosition.offset)
              throw new hi.b(
                "split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.",
                this
              );
            if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
              throw new hi.b(
                "split-operation-graveyard-position-invalid: Graveyard position invalid.",
                this
              );
          }
          _execute() {
            const t = this.splitPosition.parent;
            if (this.graveyardPosition)
              Ta(
                xs._createFromPositionAndShift(this.graveyardPosition, 1),
                this.insertionPosition
              );
            else {
              const e = t._clone();
              Aa(this.insertionPosition, e);
            }
            Ta(
              new xs(
                _s._createAt(t, this.splitPosition.offset),
                _s._createAt(t, t.maxOffset)
              ),
              this.moveTargetPosition
            );
          }
          toJSON() {
            const t = super.toJSON();
            return (
              (t.splitPosition = this.splitPosition.toJSON()),
              (t.insertionPosition = this.insertionPosition.toJSON()),
              this.graveyardPosition &&
                (t.graveyardPosition = this.graveyardPosition.toJSON()),
              t
            );
          }
          static get className() {
            return "SplitOperation";
          }
          static getInsertionPosition(t) {
            const e = t.path.slice(0, -1);
            return e[e.length - 1]++, new _s(t.root, e);
          }
          static fromJSON(t, e) {
            const i = _s.fromJSON(t.splitPosition, e),
              n = _s.fromJSON(t.insertionPosition, e),
              o = t.graveyardPosition
                ? _s.fromJSON(t.graveyardPosition, e)
                : null,
              r = new this(i, t.howMany, o, t.baseVersion);
            return (r.insertionPosition = n), r;
          }
        }
        class Fa extends ps {
          constructor(t, e, i = "main") {
            super(e), (this._document = t), (this.rootName = i);
          }
          get document() {
            return this._document;
          }
          is(t, e) {
            return e
              ? e === this.name &&
                  ("rootElement" === t ||
                    "model:rootElement" === t ||
                    "element" === t ||
                    "model:element" === t)
              : "rootElement" === t ||
                  "model:rootElement" === t ||
                  "element" === t ||
                  "model:element" === t ||
                  t === this.name ||
                  t === "model:" + this.name ||
                  "node" === t ||
                  "model:node" === t;
          }
          toJSON() {
            return this.rootName;
          }
        }
        class Ha {
          constructor(t, e) {
            (this.model = t), (this.batch = e);
          }
          createText(t, e) {
            return new ms(t, e);
          }
          createElement(t, e) {
            return new ps(t, e);
          }
          createDocumentFragment() {
            return new xa();
          }
          insert(t, e, i = 0) {
            if (
              (this._assertWriterUsedCorrectly(),
              t instanceof ms && "" == t.data)
            )
              return;
            const n = _s._createAt(e, i);
            if (t.parent) {
              if ($a(t.root, n.root)) return void this.move(xs._createOn(t), n);
              if (t.root.document)
                throw new hi.b(
                  "model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.",
                  this
                );
              this.remove(t);
            }
            const o = n.root.document ? n.root.document.version : null,
              r = new La(n, t, o);
            if (
              (t instanceof ms && (r.shouldReceiveAttributes = !0),
              this.batch.addOperation(r),
              this.model.applyOperation(r),
              t instanceof xa)
            )
              for (const [e, i] of t.markers) {
                const t = _s._createAt(i.root, 0),
                  o = {
                    range: new xs(
                      i.start._getCombined(t, n),
                      i.end._getCombined(t, n)
                    ),
                    usingOperation: !0,
                    affectsData: !0,
                  };
                this.model.markers.has(e)
                  ? this.updateMarker(e, o)
                  : this.addMarker(e, o);
              }
          }
          insertText(t, e, i, n) {
            e instanceof xa || e instanceof ps || e instanceof _s
              ? this.insert(this.createText(t), e, i)
              : this.insert(this.createText(t, e), i, n);
          }
          insertElement(t, e, i, n) {
            e instanceof xa || e instanceof ps || e instanceof _s
              ? this.insert(this.createElement(t), e, i)
              : this.insert(this.createElement(t, e), i, n);
          }
          append(t, e) {
            this.insert(t, e, "end");
          }
          appendText(t, e, i) {
            e instanceof xa || e instanceof ps
              ? this.insert(this.createText(t), e, "end")
              : this.insert(this.createText(t, e), i, "end");
          }
          appendElement(t, e, i) {
            e instanceof xa || e instanceof ps
              ? this.insert(this.createElement(t), e, "end")
              : this.insert(this.createElement(t, e), i, "end");
          }
          setAttribute(t, e, i) {
            if ((this._assertWriterUsedCorrectly(), i instanceof xs)) {
              const n = i.getMinimalFlatRanges();
              for (const i of n) Ua(this, t, e, i);
            } else Wa(this, t, e, i);
          }
          setAttributes(t, e) {
            for (const [i, n] of Li(t)) this.setAttribute(i, n, e);
          }
          removeAttribute(t, e) {
            if ((this._assertWriterUsedCorrectly(), e instanceof xs)) {
              const i = e.getMinimalFlatRanges();
              for (const e of i) Ua(this, t, null, e);
            } else Wa(this, t, null, e);
          }
          clearAttributes(t) {
            this._assertWriterUsedCorrectly();
            const e = (t) => {
              for (const e of t.getAttributeKeys()) this.removeAttribute(e, t);
            };
            if (t instanceof xs) for (const i of t.getItems()) e(i);
            else e(t);
          }
          move(t, e, i) {
            if ((this._assertWriterUsedCorrectly(), !(t instanceof xs)))
              throw new hi.b(
                "writer-move-invalid-range: Invalid range to move.",
                this
              );
            if (!t.isFlat)
              throw new hi.b(
                "writer-move-range-not-flat: Range to move is not flat.",
                this
              );
            const n = _s._createAt(e, i);
            if (n.isEqual(t.start)) return;
            if (
              (this._addOperationForAffectedMarkers("move", t),
              !$a(t.root, n.root))
            )
              throw new hi.b(
                "writer-move-different-document: Range is going to be moved between different documents.",
                this
              );
            const o = t.root.document ? t.root.document.version : null,
              r = new Ra(t.start, t.end.offset - t.start.offset, n, o);
            this.batch.addOperation(r), this.model.applyOperation(r);
          }
          remove(t) {
            this._assertWriterUsedCorrectly();
            const e = (t instanceof xs ? t : xs._createOn(t))
              .getMinimalFlatRanges()
              .reverse();
            for (const t of e)
              this._addOperationForAffectedMarkers("move", t),
                Ya(
                  t.start,
                  t.end.offset - t.start.offset,
                  this.batch,
                  this.model
                );
          }
          merge(t) {
            this._assertWriterUsedCorrectly();
            const e = t.nodeBefore,
              i = t.nodeAfter;
            if (
              (this._addOperationForAffectedMarkers("merge", t),
              !(e instanceof ps))
            )
              throw new hi.b(
                "writer-merge-no-element-before: Node before merge position must be an element.",
                this
              );
            if (!(i instanceof ps))
              throw new hi.b(
                "writer-merge-no-element-after: Node after merge position must be an element.",
                this
              );
            t.root.document ? this._merge(t) : this._mergeDetached(t);
          }
          createPositionFromPath(t, e, i) {
            return this.model.createPositionFromPath(t, e, i);
          }
          createPositionAt(t, e) {
            return this.model.createPositionAt(t, e);
          }
          createPositionAfter(t) {
            return this.model.createPositionAfter(t);
          }
          createPositionBefore(t) {
            return this.model.createPositionBefore(t);
          }
          createRange(t, e) {
            return this.model.createRange(t, e);
          }
          createRangeIn(t) {
            return this.model.createRangeIn(t);
          }
          createRangeOn(t) {
            return this.model.createRangeOn(t);
          }
          createSelection(t, e, i) {
            return this.model.createSelection(t, e, i);
          }
          _mergeDetached(t) {
            const e = t.nodeBefore,
              i = t.nodeAfter;
            this.move(xs._createIn(i), _s._createAt(e, "end")), this.remove(i);
          }
          _merge(t) {
            const e = _s._createAt(t.nodeBefore, "end"),
              i = _s._createAt(t.nodeAfter, 0),
              n = t.root.document.graveyard,
              o = new _s(n, [0]),
              r = t.root.document.version,
              s = new Ba(i, t.nodeAfter.maxOffset, e, o, r);
            this.batch.addOperation(s), this.model.applyOperation(s);
          }
          rename(t, e) {
            if ((this._assertWriterUsedCorrectly(), !(t instanceof ps)))
              throw new hi.b(
                "writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.",
                this
              );
            const i = t.root.document ? t.root.document.version : null,
              n = new Da(_s._createBefore(t), t.name, e, i);
            this.batch.addOperation(n), this.model.applyOperation(n);
          }
          split(t, e) {
            this._assertWriterUsedCorrectly();
            let i,
              n,
              o = t.parent;
            if (!o.parent)
              throw new hi.b(
                "writer-split-element-no-parent: Element with no parent can not be split.",
                this
              );
            if (
              (e || (e = o.parent),
              !t.parent.getAncestors({ includeSelf: !0 }).includes(e))
            )
              throw new hi.b(
                "writer-split-invalid-limit-element: Limit element is not a position ancestor.",
                this
              );
            do {
              const e = o.root.document ? o.root.document.version : null,
                r = o.maxOffset - t.offset,
                s = new Va(t, r, null, e);
              this.batch.addOperation(s),
                this.model.applyOperation(s),
                i || n || ((i = o), (n = t.parent.nextSibling)),
                (o = (t = this.createPositionAfter(t.parent)).parent);
            } while (o !== e);
            return {
              position: t,
              range: new xs(_s._createAt(i, "end"), _s._createAt(n, 0)),
            };
          }
          wrap(t, e) {
            if ((this._assertWriterUsedCorrectly(), !t.isFlat))
              throw new hi.b(
                "writer-wrap-range-not-flat: Range to wrap is not flat.",
                this
              );
            const i = e instanceof ps ? e : new ps(e);
            if (i.childCount > 0)
              throw new hi.b(
                "writer-wrap-element-not-empty: Element to wrap with is not empty.",
                this
              );
            if (null !== i.parent)
              throw new hi.b(
                "writer-wrap-element-attached: Element to wrap with is already attached to tree model.",
                this
              );
            this.insert(i, t.start);
            const n = new xs(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
            this.move(n, _s._createAt(i, 0));
          }
          unwrap(t) {
            if ((this._assertWriterUsedCorrectly(), null === t.parent))
              throw new hi.b(
                "writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.",
                this
              );
            this.move(xs._createIn(t), this.createPositionAfter(t)),
              this.remove(t);
          }
          addMarker(t, e) {
            if (
              (this._assertWriterUsedCorrectly(),
              !e || "boolean" != typeof e.usingOperation)
            )
              throw new hi.b(
                "writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.",
                this
              );
            const i = e.usingOperation,
              n = e.range,
              o = void 0 !== e.affectsData && e.affectsData;
            if (this.model.markers.has(t))
              throw new hi.b(
                "writer-addMarker-marker-exists: Marker with provided name already exists.",
                this
              );
            if (!n)
              throw new hi.b(
                "writer-addMarker-no-range: Range parameter is required when adding a new marker.",
                this
              );
            return i
              ? (qa(this, t, null, n, o), this.model.markers.get(t))
              : this.model.markers._set(t, n, i, o);
          }
          updateMarker(t, e) {
            this._assertWriterUsedCorrectly();
            const i = "string" == typeof t ? t : t.name,
              n = this.model.markers.get(i);
            if (!n)
              throw new hi.b(
                "writer-updateMarker-marker-not-exists: Marker with provided name does not exists.",
                this
              );
            if (!e) return void this.model.markers._refresh(n);
            const o = "boolean" == typeof e.usingOperation,
              r = "boolean" == typeof e.affectsData,
              s = r ? e.affectsData : n.affectsData;
            if (!o && !e.range && !r)
              throw new hi.b(
                "writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.",
                this
              );
            const a = n.getRange(),
              l = e.range ? e.range : a;
            o && e.usingOperation !== n.managedUsingOperations
              ? e.usingOperation
                ? qa(this, i, null, l, s)
                : (qa(this, i, a, null, s),
                  this.model.markers._set(i, l, void 0, s))
              : n.managedUsingOperations
              ? qa(this, i, a, l, s)
              : this.model.markers._set(i, l, void 0, s);
          }
          removeMarker(t) {
            this._assertWriterUsedCorrectly();
            const e = "string" == typeof t ? t : t.name;
            if (!this.model.markers.has(e))
              throw new hi.b(
                "writer-removeMarker-no-marker: Trying to remove marker which does not exist.",
                this
              );
            const i = this.model.markers.get(e);
            i.managedUsingOperations
              ? qa(this, e, i.getRange(), null, i.affectsData)
              : this.model.markers._remove(e);
          }
          setSelection(t, e, i) {
            this._assertWriterUsedCorrectly(),
              this.model.document.selection._setTo(t, e, i);
          }
          setSelectionFocus(t, e) {
            this._assertWriterUsedCorrectly(),
              this.model.document.selection._setFocus(t, e);
          }
          setSelectionAttribute(t, e) {
            if ((this._assertWriterUsedCorrectly(), "string" == typeof t))
              this._setSelectionAttribute(t, e);
            else for (const [e, i] of Li(t)) this._setSelectionAttribute(e, i);
          }
          removeSelectionAttribute(t) {
            if ((this._assertWriterUsedCorrectly(), "string" == typeof t))
              this._removeSelectionAttribute(t);
            else for (const e of t) this._removeSelectionAttribute(e);
          }
          overrideSelectionGravity() {
            return this.model.document.selection._overrideGravity();
          }
          restoreSelectionGravity(t) {
            this.model.document.selection._restoreGravity(t);
          }
          _setSelectionAttribute(t, e) {
            const i = this.model.document.selection;
            if (i.isCollapsed && i.anchor.parent.isEmpty) {
              const n = Ds._getStoreAttributeKey(t);
              this.setAttribute(n, e, i.anchor.parent);
            }
            i._setAttribute(t, e);
          }
          _removeSelectionAttribute(t) {
            const e = this.model.document.selection;
            if (e.isCollapsed && e.anchor.parent.isEmpty) {
              const i = Ds._getStoreAttributeKey(t);
              this.removeAttribute(i, e.anchor.parent);
            }
            e._removeAttribute(t);
          }
          _assertWriterUsedCorrectly() {
            if (this.model._currentWriter !== this)
              throw new hi.b(
                "writer-incorrect-use: Trying to use a writer outside the change() block.",
                this
              );
          }
          _addOperationForAffectedMarkers(t, e) {
            for (const i of this.model.markers) {
              if (!i.managedUsingOperations) continue;
              const n = i.getRange();
              let o = !1;
              if ("move" === t)
                o =
                  e.containsPosition(n.start) ||
                  e.start.isEqual(n.start) ||
                  e.containsPosition(n.end) ||
                  e.end.isEqual(n.end);
              else {
                const t = e.nodeBefore,
                  i = e.nodeAfter,
                  r = n.start.parent == t && n.start.isAtEnd,
                  s = n.end.parent == i && 0 == n.end.offset,
                  a = n.end.nodeAfter == i,
                  l = n.start.nodeAfter == i;
                o = r || s || a || l;
              }
              o && this.updateMarker(i.name, { range: n });
            }
          }
        }
        function Ua(t, e, i, n) {
          const o = t.model,
            r = o.document;
          let s,
            a,
            l,
            c = n.start;
          for (const t of n.getWalker({ shallow: !0 }))
            (l = t.item.getAttribute(e)),
              s && a != l && (a != i && d(), (c = s)),
              (s = t.nextPosition),
              (a = l);
          function d() {
            const n = new xs(c, s),
              l = n.root.document ? r.version : null,
              d = new Oa(n, e, a, i, l);
            t.batch.addOperation(d), o.applyOperation(d);
          }
          s instanceof _s && s != c && a != i && d();
        }
        function Wa(t, e, i, n) {
          const o = t.model,
            r = o.document,
            s = n.getAttribute(e);
          let a, l;
          if (s != i) {
            if (n.root === n) {
              const t = n.document ? r.version : null;
              l = new za(n, e, s, i, t);
            } else {
              a = new xs(_s._createBefore(n), t.createPositionAfter(n));
              const o = a.root.document ? r.version : null;
              l = new Oa(a, e, s, i, o);
            }
            t.batch.addOperation(l), o.applyOperation(l);
          }
        }
        function qa(t, e, i, n, o) {
          const r = t.model,
            s = r.document,
            a = new ja(e, i, n, r.markers, o, s.version);
          t.batch.addOperation(a), r.applyOperation(a);
        }
        function Ya(t, e, i, n) {
          let o;
          if (t.root.document) {
            const i = n.document,
              r = new _s(i.graveyard, [0]);
            o = new Ra(t, e, r, i.version);
          } else o = new Na(t, e);
          i.addOperation(o), n.applyOperation(o);
        }
        function $a(t, e) {
          return t === e || (t instanceof Fa && e instanceof Fa);
        }
        class Ja {
          constructor(t) {
            (this._markerCollection = t),
              (this._changesInElement = new Map()),
              (this._elementSnapshots = new Map()),
              (this._changedMarkers = new Map()),
              (this._changeCount = 0),
              (this._cachedChanges = null),
              (this._cachedChangesWithGraveyard = null);
          }
          get isEmpty() {
            return (
              0 == this._changesInElement.size && 0 == this._changedMarkers.size
            );
          }
          refreshItem(t) {
            if (this._isInInsertedElement(t.parent)) return;
            this._markRemove(t.parent, t.startOffset, t.offsetSize),
              this._markInsert(t.parent, t.startOffset, t.offsetSize);
            const e = xs._createOn(t);
            for (const t of this._markerCollection.getMarkersIntersectingRange(
              e
            )) {
              const e = t.getRange();
              this.bufferMarkerChange(t.name, e, e, t.affectsData);
            }
            this._cachedChanges = null;
          }
          bufferOperation(t) {
            switch (t.type) {
              case "insert":
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markInsert(
                  t.position.parent,
                  t.position.offset,
                  t.nodes.maxOffset
                );
                break;
              case "addAttribute":
              case "removeAttribute":
              case "changeAttribute":
                for (const e of t.range.getItems({ shallow: !0 }))
                  this._isInInsertedElement(e.parent) || this._markAttribute(e);
                break;
              case "remove":
              case "move":
              case "reinsert": {
                if (
                  t.sourcePosition.isEqual(t.targetPosition) ||
                  t.sourcePosition
                    .getShiftedBy(t.howMany)
                    .isEqual(t.targetPosition)
                )
                  return;
                const e = this._isInInsertedElement(t.sourcePosition.parent),
                  i = this._isInInsertedElement(t.targetPosition.parent);
                e ||
                  this._markRemove(
                    t.sourcePosition.parent,
                    t.sourcePosition.offset,
                    t.howMany
                  ),
                  i ||
                    this._markInsert(
                      t.targetPosition.parent,
                      t.getMovedRangeStart().offset,
                      t.howMany
                    );
                break;
              }
              case "rename": {
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markRemove(t.position.parent, t.position.offset, 1),
                  this._markInsert(t.position.parent, t.position.offset, 1);
                const e = xs._createFromPositionAndShift(t.position, 1);
                for (const t of this._markerCollection.getMarkersIntersectingRange(
                  e
                )) {
                  const e = t.getRange();
                  this.bufferMarkerChange(t.name, e, e, t.affectsData);
                }
                break;
              }
              case "split": {
                const e = t.splitPosition.parent;
                this._isInInsertedElement(e) ||
                  this._markRemove(e, t.splitPosition.offset, t.howMany),
                  this._isInInsertedElement(t.insertionPosition.parent) ||
                    this._markInsert(
                      t.insertionPosition.parent,
                      t.insertionPosition.offset,
                      1
                    ),
                  t.graveyardPosition &&
                    this._markRemove(
                      t.graveyardPosition.parent,
                      t.graveyardPosition.offset,
                      1
                    );
                break;
              }
              case "merge": {
                const e = t.sourcePosition.parent;
                this._isInInsertedElement(e.parent) ||
                  this._markRemove(e.parent, e.startOffset, 1);
                const i = t.graveyardPosition.parent;
                this._markInsert(i, t.graveyardPosition.offset, 1);
                const n = t.targetPosition.parent;
                this._isInInsertedElement(n) ||
                  this._markInsert(n, t.targetPosition.offset, e.maxOffset);
                break;
              }
            }
            this._cachedChanges = null;
          }
          bufferMarkerChange(t, e, i, n) {
            const o = this._changedMarkers.get(t);
            o
              ? ((o.newRange = i),
                (o.affectsData = n),
                null == o.oldRange &&
                  null == o.newRange &&
                  this._changedMarkers.delete(t))
              : this._changedMarkers.set(t, {
                  oldRange: e,
                  newRange: i,
                  affectsData: n,
                });
          }
          getMarkersToRemove() {
            const t = [];
            for (const [e, i] of this._changedMarkers)
              null != i.oldRange && t.push({ name: e, range: i.oldRange });
            return t;
          }
          getMarkersToAdd() {
            const t = [];
            for (const [e, i] of this._changedMarkers)
              null != i.newRange && t.push({ name: e, range: i.newRange });
            return t;
          }
          getChangedMarkers() {
            return Array.from(this._changedMarkers).map((t) => ({
              name: t[0],
              data: { oldRange: t[1].oldRange, newRange: t[1].newRange },
            }));
          }
          hasDataChanges() {
            for (const [, t] of this._changedMarkers)
              if (t.affectsData) return !0;
            return this._changesInElement.size > 0;
          }
          getChanges(t = { includeChangesInGraveyard: !1 }) {
            if (this._cachedChanges)
              return t.includeChangesInGraveyard
                ? this._cachedChangesWithGraveyard.slice()
                : this._cachedChanges.slice();
            const e = [];
            for (const t of this._changesInElement.keys()) {
              const i = this._changesInElement
                  .get(t)
                  .sort((t, e) =>
                    t.offset === e.offset
                      ? t.type != e.type
                        ? "remove" == t.type
                          ? -1
                          : 1
                        : 0
                      : t.offset < e.offset
                      ? -1
                      : 1
                  ),
                n = this._elementSnapshots.get(t),
                o = Ga(t.getChildren()),
                r = Qa(n.length, i);
              let s = 0,
                a = 0;
              for (const i of r)
                if ("i" === i)
                  e.push(this._getInsertDiff(t, s, o[s].name)), s++;
                else if ("r" === i)
                  e.push(this._getRemoveDiff(t, s, n[a].name)), a++;
                else if ("a" === i) {
                  const i = o[s].attributes,
                    r = n[a].attributes;
                  let l;
                  if ("$text" == o[s].name)
                    l = new xs(_s._createAt(t, s), _s._createAt(t, s + 1));
                  else {
                    const e = t.offsetToIndex(s);
                    l = new xs(
                      _s._createAt(t, s),
                      _s._createAt(t.getChild(e), 0)
                    );
                  }
                  e.push(...this._getAttributesDiff(l, r, i)), s++, a++;
                } else s++, a++;
            }
            e.sort((t, e) =>
              t.position.root != e.position.root
                ? t.position.root.rootName < e.position.root.rootName
                  ? -1
                  : 1
                : t.position.isEqual(e.position)
                ? t.changeCount - e.changeCount
                : t.position.isBefore(e.position)
                ? -1
                : 1
            );
            for (let t = 1; t < e.length; t++) {
              const i = e[t - 1],
                n = e[t],
                o =
                  "remove" == i.type &&
                  "remove" == n.type &&
                  "$text" == i.name &&
                  "$text" == n.name &&
                  i.position.isEqual(n.position),
                r =
                  "insert" == i.type &&
                  "insert" == n.type &&
                  "$text" == i.name &&
                  "$text" == n.name &&
                  i.position.parent == n.position.parent &&
                  i.position.offset + i.length == n.position.offset,
                s =
                  "attribute" == i.type &&
                  "attribute" == n.type &&
                  i.position.parent == n.position.parent &&
                  i.range.isFlat &&
                  n.range.isFlat &&
                  i.position.offset + i.length == n.position.offset &&
                  i.attributeKey == n.attributeKey &&
                  i.attributeOldValue == n.attributeOldValue &&
                  i.attributeNewValue == n.attributeNewValue;
              (o || r || s) &&
                (e[t - 1].length++,
                s && (e[t - 1].range.end = e[t - 1].range.end.getShiftedBy(1)),
                e.splice(t, 1),
                t--);
            }
            for (const t of e)
              delete t.changeCount,
                "attribute" == t.type && (delete t.position, delete t.length);
            return (
              (this._changeCount = 0),
              (this._cachedChangesWithGraveyard = e.slice()),
              (this._cachedChanges = e.slice().filter(Xa)),
              t.includeChangesInGraveyard
                ? this._cachedChangesWithGraveyard
                : this._cachedChanges
            );
          }
          reset() {
            this._changesInElement.clear(),
              this._elementSnapshots.clear(),
              this._changedMarkers.clear(),
              (this._cachedChanges = null);
          }
          _markInsert(t, e, i) {
            const n = {
              type: "insert",
              offset: e,
              howMany: i,
              count: this._changeCount++,
            };
            this._markChange(t, n);
          }
          _markRemove(t, e, i) {
            const n = {
              type: "remove",
              offset: e,
              howMany: i,
              count: this._changeCount++,
            };
            this._markChange(t, n), this._removeAllNestedChanges(t, e, i);
          }
          _markAttribute(t) {
            const e = {
              type: "attribute",
              offset: t.startOffset,
              howMany: t.offsetSize,
              count: this._changeCount++,
            };
            this._markChange(t.parent, e);
          }
          _markChange(t, e) {
            this._makeSnapshot(t);
            const i = this._getChangesForElement(t);
            this._handleChange(e, i), i.push(e);
            for (let t = 0; t < i.length; t++)
              i[t].howMany < 1 && (i.splice(t, 1), t--);
          }
          _getChangesForElement(t) {
            let e;
            return (
              this._changesInElement.has(t)
                ? (e = this._changesInElement.get(t))
                : ((e = []), this._changesInElement.set(t, e)),
              e
            );
          }
          _makeSnapshot(t) {
            this._elementSnapshots.has(t) ||
              this._elementSnapshots.set(t, Ga(t.getChildren()));
          }
          _handleChange(t, e) {
            t.nodesToHandle = t.howMany;
            for (const i of e) {
              const n = t.offset + t.howMany,
                o = i.offset + i.howMany;
              if (
                "insert" == t.type &&
                ("insert" == i.type &&
                  (t.offset <= i.offset
                    ? (i.offset += t.howMany)
                    : t.offset < o &&
                      ((i.howMany += t.nodesToHandle), (t.nodesToHandle = 0))),
                "remove" == i.type &&
                  t.offset < i.offset &&
                  (i.offset += t.howMany),
                "attribute" == i.type)
              )
                if (t.offset <= i.offset) i.offset += t.howMany;
                else if (t.offset < o) {
                  const o = i.howMany;
                  (i.howMany = t.offset - i.offset),
                    e.unshift({
                      type: "attribute",
                      offset: n,
                      howMany: o - i.howMany,
                      count: this._changeCount++,
                    });
                }
              if ("remove" == t.type) {
                if ("insert" == i.type)
                  if (n <= i.offset) i.offset -= t.howMany;
                  else if (n <= o)
                    if (t.offset < i.offset) {
                      const e = n - i.offset;
                      (i.offset = t.offset),
                        (i.howMany -= e),
                        (t.nodesToHandle -= e);
                    } else
                      (i.howMany -= t.nodesToHandle), (t.nodesToHandle = 0);
                  else if (t.offset <= i.offset)
                    (t.nodesToHandle -= i.howMany), (i.howMany = 0);
                  else if (t.offset < o) {
                    const e = o - t.offset;
                    (i.howMany -= e), (t.nodesToHandle -= e);
                  }
                if (
                  ("remove" == i.type &&
                    (n <= i.offset
                      ? (i.offset -= t.howMany)
                      : t.offset < i.offset &&
                        ((t.nodesToHandle += i.howMany), (i.howMany = 0))),
                  "attribute" == i.type)
                )
                  if (n <= i.offset) i.offset -= t.howMany;
                  else if (t.offset < i.offset) {
                    const e = n - i.offset;
                    (i.offset = t.offset), (i.howMany -= e);
                  } else if (t.offset < o)
                    if (n <= o) {
                      const n = i.howMany;
                      i.howMany = t.offset - i.offset;
                      const o = n - i.howMany - t.nodesToHandle;
                      e.unshift({
                        type: "attribute",
                        offset: t.offset,
                        howMany: o,
                        count: this._changeCount++,
                      });
                    } else i.howMany -= o - t.offset;
              }
              if ("attribute" == t.type) {
                if ("insert" == i.type)
                  if (t.offset < i.offset && n > i.offset) {
                    if (n > o) {
                      const t = {
                        type: "attribute",
                        offset: o,
                        howMany: n - o,
                        count: this._changeCount++,
                      };
                      this._handleChange(t, e), e.push(t);
                    }
                    (t.nodesToHandle = i.offset - t.offset),
                      (t.howMany = t.nodesToHandle);
                  } else
                    t.offset >= i.offset &&
                      t.offset < o &&
                      (n > o
                        ? ((t.nodesToHandle = n - o), (t.offset = o))
                        : (t.nodesToHandle = 0));
                if ("remove" == i.type && t.offset < i.offset && n > i.offset) {
                  const o = {
                    type: "attribute",
                    offset: i.offset,
                    howMany: n - i.offset,
                    count: this._changeCount++,
                  };
                  this._handleChange(o, e),
                    e.push(o),
                    (t.nodesToHandle = i.offset - t.offset),
                    (t.howMany = t.nodesToHandle);
                }
                "attribute" == i.type &&
                  (t.offset >= i.offset && n <= o
                    ? ((t.nodesToHandle = 0), (t.howMany = 0), (t.offset = 0))
                    : t.offset <= i.offset && n >= o && (i.howMany = 0));
              }
            }
            (t.howMany = t.nodesToHandle), delete t.nodesToHandle;
          }
          _getInsertDiff(t, e, i) {
            return {
              type: "insert",
              position: _s._createAt(t, e),
              name: i,
              length: 1,
              changeCount: this._changeCount++,
            };
          }
          _getRemoveDiff(t, e, i) {
            return {
              type: "remove",
              position: _s._createAt(t, e),
              name: i,
              length: 1,
              changeCount: this._changeCount++,
            };
          }
          _getAttributesDiff(t, e, i) {
            const n = [];
            i = new Map(i);
            for (const [o, r] of e) {
              const e = i.has(o) ? i.get(o) : null;
              e !== r &&
                n.push({
                  type: "attribute",
                  position: t.start,
                  range: t.clone(),
                  length: 1,
                  attributeKey: o,
                  attributeOldValue: r,
                  attributeNewValue: e,
                  changeCount: this._changeCount++,
                }),
                i.delete(o);
            }
            for (const [e, o] of i)
              n.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: e,
                attributeOldValue: null,
                attributeNewValue: o,
                changeCount: this._changeCount++,
              });
            return n;
          }
          _isInInsertedElement(t) {
            const e = t.parent;
            if (!e) return !1;
            const i = this._changesInElement.get(e),
              n = t.startOffset;
            if (i)
              for (const t of i)
                if (
                  "insert" == t.type &&
                  n >= t.offset &&
                  n < t.offset + t.howMany
                )
                  return !0;
            return this._isInInsertedElement(e);
          }
          _removeAllNestedChanges(t, e, i) {
            const n = new xs(_s._createAt(t, e), _s._createAt(t, e + i));
            for (const t of n.getItems({ shallow: !0 }))
              t.is("element") &&
                (this._elementSnapshots.delete(t),
                this._changesInElement.delete(t),
                this._removeAllNestedChanges(t, 0, t.maxOffset));
          }
        }
        function Ga(t) {
          const e = [];
          for (const i of t)
            if (i.is("text"))
              for (let t = 0; t < i.data.length; t++)
                e.push({
                  name: "$text",
                  attributes: new Map(i.getAttributes()),
                });
            else
              e.push({ name: i.name, attributes: new Map(i.getAttributes()) });
          return e;
        }
        function Qa(t, e) {
          const i = [];
          let n = 0,
            o = 0;
          for (const t of e) {
            if (t.offset > n) {
              for (let e = 0; e < t.offset - n; e++) i.push("e");
              o += t.offset - n;
            }
            if ("insert" == t.type) {
              for (let e = 0; e < t.howMany; e++) i.push("i");
              n = t.offset + t.howMany;
            } else if ("remove" == t.type) {
              for (let e = 0; e < t.howMany; e++) i.push("r");
              (n = t.offset), (o += t.howMany);
            } else
              i.push(..."a".repeat(t.howMany).split("")),
                (n = t.offset + t.howMany),
                (o += t.howMany);
          }
          if (o < t) for (let e = 0; e < t - o - n; e++) i.push("e");
          return i;
        }
        function Xa(t) {
          const e = t.position && "$graveyard" == t.position.root.rootName,
            i = t.range && "$graveyard" == t.range.root.rootName;
          return !e && !i;
        }
        class Ka {
          constructor() {
            (this._operations = []),
              (this._undoPairs = new Map()),
              (this._undoneOperations = new Set());
          }
          addOperation(t) {
            this._operations.includes(t) || this._operations.push(t);
          }
          getOperations(t = 0, e = Number.POSITIVE_INFINITY) {
            return t < 0 ? [] : this._operations.slice(t, e);
          }
          getOperation(t) {
            return this._operations[t];
          }
          setOperationAsUndone(t, e) {
            this._undoPairs.set(e, t), this._undoneOperations.add(t);
          }
          isUndoingOperation(t) {
            return this._undoPairs.has(t);
          }
          isUndoneOperation(t) {
            return this._undoneOperations.has(t);
          }
          getUndoneOperation(t) {
            return this._undoPairs.get(t);
          }
        }
        function Za(t, e) {
          return (
            !!(i = t.charAt(e - 1)) &&
            1 == i.length &&
            /[\ud800-\udbff]/.test(i) &&
            (function (t) {
              return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
            })(t.charAt(e))
          );
          var i;
        }
        function tl(t, e) {
          return (
            !!(i = t.charAt(e)) &&
            1 == i.length &&
            /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(
              i
            )
          );
          var i;
        }
        class el {
          constructor(t) {
            (this.model = t),
              (this.version = 0),
              (this.history = new Ka(this)),
              (this.selection = new Ds(this)),
              (this.roots = new xi({ idProperty: "rootName" })),
              (this.differ = new Ja(t.markers)),
              (this._postFixers = new Set()),
              (this._hasSelectionChangedFromTheLastChangeBlock = !1),
              this.createRoot("$root", "$graveyard"),
              this.listenTo(
                t,
                "applyOperation",
                (t, e) => {
                  const i = e[0];
                  if (i.isDocumentOperation && i.baseVersion !== this.version)
                    throw new hi.b(
                      "model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.",
                      this,
                      { operation: i }
                    );
                },
                { priority: "highest" }
              ),
              this.listenTo(
                t,
                "applyOperation",
                (t, e) => {
                  const i = e[0];
                  i.isDocumentOperation && this.differ.bufferOperation(i);
                },
                { priority: "high" }
              ),
              this.listenTo(
                t,
                "applyOperation",
                (t, e) => {
                  const i = e[0];
                  i.isDocumentOperation &&
                    (this.version++, this.history.addOperation(i));
                },
                { priority: "low" }
              ),
              this.listenTo(this.selection, "change", () => {
                this._hasSelectionChangedFromTheLastChangeBlock = !0;
              }),
              this.listenTo(t.markers, "update", (t, e, i, n) => {
                this.differ.bufferMarkerChange(e.name, i, n, e.affectsData),
                  null === i &&
                    e.on("change", (t, i) => {
                      this.differ.bufferMarkerChange(
                        e.name,
                        i,
                        e.getRange(),
                        e.affectsData
                      );
                    });
              });
          }
          get graveyard() {
            return this.getRoot("$graveyard");
          }
          createRoot(t = "$root", e = "main") {
            if (this.roots.get(e))
              throw new hi.b(
                "model-document-createRoot-name-exists: Root with specified name already exists.",
                this,
                { name: e }
              );
            const i = new Fa(this, t, e);
            return this.roots.add(i), i;
          }
          destroy() {
            this.selection.destroy(), this.stopListening();
          }
          getRoot(t = "main") {
            return this.roots.get(t);
          }
          getRootNames() {
            return Array.from(this.roots, (t) => t.rootName).filter(
              (t) => "$graveyard" != t
            );
          }
          registerPostFixer(t) {
            this._postFixers.add(t);
          }
          toJSON() {
            const t = Ii(this);
            return (
              (t.selection = "[engine.model.DocumentSelection]"),
              (t.model = "[engine.model.Model]"),
              t
            );
          }
          _handleChangeBlock(t) {
            this._hasDocumentChangedFromTheLastChangeBlock() &&
              (this._callPostFixers(t),
              this.selection.refresh(),
              this.differ.hasDataChanges()
                ? this.fire("change:data", t.batch)
                : this.fire("change", t.batch),
              this.selection.refresh(),
              this.differ.reset()),
              (this._hasSelectionChangedFromTheLastChangeBlock = !1);
          }
          _hasDocumentChangedFromTheLastChangeBlock() {
            return (
              !this.differ.isEmpty ||
              this._hasSelectionChangedFromTheLastChangeBlock
            );
          }
          _getDefaultRoot() {
            for (const t of this.roots) if (t !== this.graveyard) return t;
            return this.graveyard;
          }
          _getDefaultRange() {
            const t = this._getDefaultRoot(),
              e = this.model,
              i = e.schema,
              n = e.createPositionFromPath(t, [0]);
            return i.getNearestSelectionRange(n) || e.createRange(n);
          }
          _validateSelectionRange(t) {
            return il(t.start) && il(t.end);
          }
          _callPostFixers(t) {
            let e = !1;
            do {
              for (const i of this._postFixers)
                if ((this.selection.refresh(), (e = i(t)), e)) break;
            } while (e);
          }
        }
        function il(t) {
          const e = t.textNode;
          if (e) {
            const i = e.data,
              n = t.offset - e.startOffset;
            return !Za(i, n) && !tl(i, n);
          }
          return !0;
        }
        yi(el, gi);
        class nl {
          constructor() {
            this._markers = new Map();
          }
          [Symbol.iterator]() {
            return this._markers.values();
          }
          has(t) {
            return this._markers.has(t);
          }
          get(t) {
            return this._markers.get(t) || null;
          }
          _set(t, e, i = !1, n = !1) {
            const o = t instanceof ol ? t.name : t,
              r = this._markers.get(o);
            if (r) {
              const t = r.getRange();
              let s = !1;
              return (
                t.isEqual(e) || (r._attachLiveRange(Rs.fromRange(e)), (s = !0)),
                i != r.managedUsingOperations &&
                  ((r._managedUsingOperations = i), (s = !0)),
                "boolean" == typeof n &&
                  n != r.affectsData &&
                  ((r._affectsData = n), (s = !0)),
                s && this.fire("update:" + o, r, t, e),
                r
              );
            }
            const s = Rs.fromRange(e),
              a = new ol(o, s, i, n);
            return (
              this._markers.set(o, a), this.fire("update:" + o, a, null, e), a
            );
          }
          _remove(t) {
            const e = t instanceof ol ? t.name : t,
              i = this._markers.get(e);
            return (
              !!i &&
              (this._markers.delete(e),
              this.fire("update:" + e, i, i.getRange(), null),
              this._destroyMarker(i),
              !0)
            );
          }
          _refresh(t) {
            const e = t instanceof ol ? t.name : t,
              i = this._markers.get(e);
            if (!i)
              throw new hi.b(
                "markercollection-refresh-marker-not-exists: Marker with provided name does not exists.",
                this
              );
            const n = i.getRange();
            this.fire(
              "update:" + e,
              i,
              n,
              n,
              i.managedUsingOperations,
              i.affectsData
            );
          }
          *getMarkersAtPosition(t) {
            for (const e of this) e.getRange().containsPosition(t) && (yield e);
          }
          *getMarkersIntersectingRange(t) {
            for (const e of this)
              null !== e.getRange().getIntersection(t) && (yield e);
          }
          destroy() {
            for (const t of this._markers.values()) this._destroyMarker(t);
            (this._markers = null), this.stopListening();
          }
          *getMarkersGroup(t) {
            for (const e of this._markers.values())
              e.name.startsWith(t + ":") && (yield e);
          }
          _destroyMarker(t) {
            t.stopListening(), t._detachLiveRange();
          }
        }
        yi(nl, gi);
        class ol {
          constructor(t, e, i, n) {
            (this.name = t),
              (this._liveRange = this._attachLiveRange(e)),
              (this._managedUsingOperations = i),
              (this._affectsData = n);
          }
          get managedUsingOperations() {
            if (!this._liveRange)
              throw new hi.b(
                "marker-destroyed: Cannot use a destroyed marker instance.",
                this
              );
            return this._managedUsingOperations;
          }
          get affectsData() {
            if (!this._liveRange)
              throw new hi.b(
                "marker-destroyed: Cannot use a destroyed marker instance.",
                this
              );
            return this._affectsData;
          }
          getStart() {
            if (!this._liveRange)
              throw new hi.b(
                "marker-destroyed: Cannot use a destroyed marker instance.",
                this
              );
            return this._liveRange.start.clone();
          }
          getEnd() {
            if (!this._liveRange)
              throw new hi.b(
                "marker-destroyed: Cannot use a destroyed marker instance.",
                this
              );
            return this._liveRange.end.clone();
          }
          getRange() {
            if (!this._liveRange)
              throw new hi.b(
                "marker-destroyed: Cannot use a destroyed marker instance.",
                this
              );
            return this._liveRange.toRange();
          }
          is(t) {
            return "marker" === t || "model:marker" === t;
          }
          _attachLiveRange(t) {
            return (
              this._liveRange && this._detachLiveRange(),
              t.delegate("change:range").to(this),
              t.delegate("change:content").to(this),
              (this._liveRange = t),
              t
            );
          }
          _detachLiveRange() {
            this._liveRange.stopDelegating("change:range", this),
              this._liveRange.stopDelegating("change:content", this),
              this._liveRange.detach(),
              (this._liveRange = null);
          }
        }
        yi(ol, gi);
        class rl extends ya {
          get type() {
            return "noop";
          }
          clone() {
            return new rl(this.baseVersion);
          }
          getReversed() {
            return new rl(this.baseVersion + 1);
          }
          _execute() {}
          static get className() {
            return "NoOperation";
          }
        }
        const sl = {};
        (sl[Oa.className] = Oa),
          (sl[La.className] = La),
          (sl[ja.className] = ja),
          (sl[Ra.className] = Ra),
          (sl[rl.className] = rl),
          (sl[ya.className] = ya),
          (sl[Da.className] = Da),
          (sl[za.className] = za),
          (sl[Va.className] = Va),
          (sl[Ba.className] = Ba);
        class al extends _s {
          constructor(t, e, i = "toNone") {
            if ((super(t, e, i), !this.root.is("rootElement")))
              throw new hi.b(
                "model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.",
                t
              );
            ll.call(this);
          }
          detach() {
            this.stopListening();
          }
          is(t) {
            return (
              "livePosition" === t ||
              "model:livePosition" === t ||
              "position" == t ||
              "model:position" === t
            );
          }
          toPosition() {
            return new _s(this.root, this.path.slice(), this.stickiness);
          }
          static fromPosition(t, e) {
            return new this(t.root, t.path.slice(), e || t.stickiness);
          }
        }
        function ll() {
          this.listenTo(
            this.root.document.model,
            "applyOperation",
            (t, e) => {
              const i = e[0];
              i.isDocumentOperation && cl.call(this, i);
            },
            { priority: "low" }
          );
        }
        function cl(t) {
          const e = this.getTransformedByOperation(t);
          if (!this.isEqual(e)) {
            const t = this.toPosition();
            (this.path = e.path), (this.root = e.root), this.fire("change", t);
          }
        }
        yi(al, gi);
        class dl {
          constructor(t, e, i) {
            (this.model = t),
              (this.writer = e),
              (this.position = i),
              (this.canMergeWith = new Set([this.position.parent])),
              (this.schema = t.schema),
              (this._filterAttributesOf = []),
              (this._affectedStart = null),
              (this._affectedEnd = null);
          }
          handleNodes(t, e) {
            t = Array.from(t);
            for (let i = 0; i < t.length; i++) {
              const n = t[i];
              this._handleNode(n, {
                isFirst: 0 === i && e.isFirst,
                isLast: i === t.length - 1 && e.isLast,
              });
            }
            this.schema.removeDisallowedAttributes(
              this._filterAttributesOf,
              this.writer
            ),
              (this._filterAttributesOf = []);
          }
          getSelectionRange() {
            return this.nodeToSelect
              ? xs._createOn(this.nodeToSelect)
              : this.model.schema.getNearestSelectionRange(this.position);
          }
          getAffectedRange() {
            return this._affectedStart
              ? new xs(this._affectedStart, this._affectedEnd)
              : null;
          }
          destroy() {
            this._affectedStart && this._affectedStart.detach(),
              this._affectedEnd && this._affectedEnd.detach();
          }
          _handleNode(t, e) {
            if (this.schema.isObject(t)) return void this._handleObject(t, e);
            this._checkAndSplitToAllowedPosition(t, e)
              ? (this._insert(t), this._mergeSiblingsOf(t, e))
              : this._handleDisallowedNode(t, e);
          }
          _handleObject(t, e) {
            this._checkAndSplitToAllowedPosition(t)
              ? this._insert(t)
              : this._tryAutoparagraphing(t, e);
          }
          _handleDisallowedNode(t, e) {
            t.is("element")
              ? this.handleNodes(t.getChildren(), e)
              : this._tryAutoparagraphing(t, e);
          }
          _insert(t) {
            if (!this.schema.checkChild(this.position, t))
              throw new hi.b(
                "insertcontent-wrong-position: Given node cannot be inserted on the given position.",
                this,
                { node: t, position: this.position }
              );
            const e = al.fromPosition(this.position, "toNext");
            this._setAffectedBoundaries(this.position),
              this.writer.insert(t, this.position),
              (this.position = e.toPosition()),
              e.detach(),
              this.schema.isObject(t) &&
              !this.schema.checkChild(this.position, "$text")
                ? (this.nodeToSelect = t)
                : (this.nodeToSelect = null),
              this._filterAttributesOf.push(t);
          }
          _setAffectedBoundaries(t) {
            this._affectedStart ||
              (this._affectedStart = al.fromPosition(t, "toPrevious")),
              (this._affectedEnd && !this._affectedEnd.isBefore(t)) ||
                (this._affectedEnd && this._affectedEnd.detach(),
                (this._affectedEnd = al.fromPosition(t, "toNext")));
          }
          _mergeSiblingsOf(t, e) {
            if (!(t instanceof ps)) return;
            const i = this._canMergeLeft(t, e),
              n = this._canMergeRight(t, e),
              o = al._createBefore(t);
            o.stickiness = "toNext";
            const r = al._createAfter(t);
            if (((r.stickiness = "toNext"), i)) {
              const t = al.fromPosition(this.position);
              (t.stickiness = "toNext"),
                this._affectedStart.isEqual(o) &&
                  (this._affectedStart.detach(),
                  (this._affectedStart = al._createAt(
                    o.nodeBefore,
                    "end",
                    "toPrevious"
                  ))),
                this.writer.merge(o),
                o.isEqual(this._affectedEnd) &&
                  e.isLast &&
                  (this._affectedEnd.detach(),
                  (this._affectedEnd = al._createAt(
                    o.nodeBefore,
                    "end",
                    "toNext"
                  ))),
                (this.position = t.toPosition()),
                t.detach();
            }
            if (n) {
              if (!this.position.isEqual(r))
                throw new hi.b(
                  "insertcontent-invalid-insertion-position",
                  this
                );
              this.position = _s._createAt(r.nodeBefore, "end");
              const t = al.fromPosition(this.position, "toPrevious");
              this._affectedEnd.isEqual(r) &&
                (this._affectedEnd.detach(),
                (this._affectedEnd = al._createAt(
                  r.nodeBefore,
                  "end",
                  "toNext"
                ))),
                this.writer.merge(r),
                r.getShiftedBy(-1).isEqual(this._affectedStart) &&
                  e.isFirst &&
                  (this._affectedStart.detach(),
                  (this._affectedStart = al._createAt(
                    r.nodeBefore,
                    0,
                    "toPrevious"
                  ))),
                (this.position = t.toPosition()),
                t.detach();
            }
            (i || n) && this._filterAttributesOf.push(this.position.parent),
              o.detach(),
              r.detach();
          }
          _canMergeLeft(t, e) {
            const i = t.previousSibling;
            return (
              e.isFirst &&
              i instanceof ps &&
              this.canMergeWith.has(i) &&
              this.model.schema.checkMerge(i, t)
            );
          }
          _canMergeRight(t, e) {
            const i = t.nextSibling;
            return (
              e.isLast &&
              i instanceof ps &&
              this.canMergeWith.has(i) &&
              this.model.schema.checkMerge(t, i)
            );
          }
          _tryAutoparagraphing(t, e) {
            const i = this.writer.createElement("paragraph");
            this._getAllowedIn(i, this.position.parent) &&
              this.schema.checkChild(i, t) &&
              (i._appendChild(t), this._handleNode(i, e));
          }
          _checkAndSplitToAllowedPosition(t) {
            const e = this._getAllowedIn(t, this.position.parent);
            if (!e) return !1;
            for (; e != this.position.parent; ) {
              if (this.schema.isLimit(this.position.parent)) return !1;
              if (this.position.isAtStart) {
                const t = this.position.parent;
                (this.position = this.writer.createPositionBefore(t)),
                  t.isEmpty && t.parent === e && this.writer.remove(t);
              } else if (this.position.isAtEnd)
                this.position = this.writer.createPositionAfter(
                  this.position.parent
                );
              else {
                const t = this.writer.createPositionAfter(this.position.parent);
                this._setAffectedBoundaries(this.position),
                  this.writer.split(this.position),
                  (this.position = t),
                  this.canMergeWith.add(this.position.nodeAfter);
              }
            }
            return !0;
          }
          _getAllowedIn(t, e) {
            return this.schema.checkChild(e, t)
              ? e
              : e.parent
              ? this._getAllowedIn(t, e.parent)
              : null;
          }
        }
        function hl(t, e, i = {}) {
          if (e.isCollapsed) return;
          const n = e.getFirstRange();
          if ("$graveyard" == n.root.rootName) return;
          const o = t.schema;
          t.change((t) => {
            if (
              !i.doNotResetEntireContent &&
              (function (t, e) {
                const i = t.getLimitElement(e);
                if (!e.containsEntireContent(i)) return !1;
                const n = e.getFirstRange();
                if (n.start.parent == n.end.parent) return !1;
                return t.checkChild(i, "paragraph");
              })(o, e)
            )
              return void (function (t, e) {
                const i = t.model.schema.getLimitElement(e);
                t.remove(t.createRangeIn(i)),
                  ul(t, t.createPositionAt(i, 0), e);
              })(t, e);
            const r = n.start,
              s = al.fromPosition(n.end, "toNext");
            n.start.isTouching(n.end) || t.remove(n),
              i.leaveUnmerged ||
                (!(function t(e, i, n) {
                  const o = i.parent,
                    r = n.parent;
                  if (o == r) return;
                  if (e.model.schema.isLimit(o) || e.model.schema.isLimit(r))
                    return;
                  if (
                    !(function (t, e, i) {
                      const n = new xs(t, e);
                      for (const t of n.getWalker())
                        if (i.isLimit(t.item)) return !1;
                      return !0;
                    })(i, n, e.model.schema)
                  )
                    return;
                  (i = e.createPositionAfter(o)),
                    (n = e.createPositionBefore(r)).isEqual(i) ||
                      e.insert(r, i);
                  e.merge(i);
                  for (; n.parent.isEmpty; ) {
                    const t = n.parent;
                    (n = e.createPositionBefore(t)), e.remove(t);
                  }
                  t(e, i, n);
                })(t, r, s),
                o.removeDisallowedAttributes(r.parent.getChildren(), t)),
              ml(t, e, r),
              !i.doNotAutoparagraph &&
                (function (t, e) {
                  const i = t.checkChild(e, "$text"),
                    n = t.checkChild(e, "paragraph");
                  return !i && n;
                })(o, r) &&
                ul(t, r, e),
              s.detach();
          });
        }
        function ul(t, e, i) {
          const n = t.createElement("paragraph");
          t.insert(n, e), ml(t, i, t.createPositionAt(n, 0));
        }
        function ml(t, e, i) {
          e instanceof Ds ? t.setSelection(i) : e.setTo(i);
        }
        function gl(t, e) {
          if ("text" == e.type)
            return "word" === t.unit
              ? (function (t, e) {
                  let i = t.position.textNode;
                  if (i) {
                    let n = t.position.offset - i.startOffset;
                    for (; !pl(i.data, n, e) && !bl(i, n, e); ) {
                      t.next();
                      const o = e
                        ? t.position.nodeAfter
                        : t.position.nodeBefore;
                      if (o && o.is("text")) {
                        const n = o.data.charAt(e ? 0 : o.data.length - 1);
                        ' ,.?!:;"-()'.includes(n) ||
                          (t.next(), (i = t.position.textNode));
                      }
                      n = t.position.offset - i.startOffset;
                    }
                  }
                  return t.position;
                })(t.walker, t.isForward)
              : (function (t, e) {
                  const i = t.position.textNode;
                  if (i) {
                    const n = i.data;
                    let o = t.position.offset - i.startOffset;
                    for (; Za(n, o) || ("character" == e && tl(n, o)); )
                      t.next(), (o = t.position.offset - i.startOffset);
                  }
                  return t.position;
                })(t.walker, t.unit, t.isForward);
          if (e.type == (t.isForward ? "elementStart" : "elementEnd")) {
            if (t.schema.isObject(e.item))
              return _s._createAt(e.item, t.isForward ? "after" : "before");
            if (t.schema.checkChild(e.nextPosition, "$text"))
              return e.nextPosition;
          } else {
            if (t.schema.isLimit(e.item)) return void t.walker.skip(() => !0);
            if (t.schema.checkChild(e.nextPosition, "$text"))
              return e.nextPosition;
          }
        }
        function fl(t, e) {
          const i = t.root,
            n = _s._createAt(i, e ? "end" : 0);
          return e ? new xs(t, n) : new xs(n, t);
        }
        function pl(t, e, i) {
          const n = e + (i ? 0 : -1);
          return ' ,.?!:;"-()'.includes(t.charAt(n));
        }
        function bl(t, e, i) {
          return e === (i ? t.endOffset : 0);
        }
        function wl(t, e) {
          const i = [];
          Array.from(t.getItems({ direction: "backward" }))
            .map((t) => e.createRangeOn(t))
            .filter(
              (e) =>
                (e.start.isAfter(t.start) || e.start.isEqual(t.start)) &&
                (e.end.isBefore(t.end) || e.end.isEqual(t.end))
            )
            .forEach((t) => {
              i.push(t.start.parent), e.remove(t);
            }),
            i.forEach((t) => {
              let i = t;
              for (; i.parent && i.isEmpty; ) {
                const t = e.createRangeOn(i);
                (i = i.parent), e.remove(t);
              }
            });
        }
        function _l(t) {
          t.document.registerPostFixer((e) =>
            (function (t, e) {
              const i = e.document.selection,
                n = e.schema,
                o = [];
              let r = !1;
              for (const t of i.getRanges()) {
                const e = kl(t, n);
                e ? (o.push(e), (r = !0)) : o.push(t);
              }
              r &&
                t.setSelection(
                  (function (t) {
                    const e = [];
                    e.push(t.shift());
                    for (const i of t) {
                      const t = e.pop();
                      if (i.isIntersecting(t)) {
                        const n = t.start.isAfter(i.start) ? i.start : t.start,
                          o = t.end.isAfter(i.end) ? t.end : i.end,
                          r = new xs(n, o);
                        e.push(r);
                      } else e.push(t), e.push(i);
                    }
                    return e;
                  })(o),
                  { backward: i.isBackward }
                );
            })(e, t)
          );
        }
        function kl(t, e) {
          return t.isCollapsed
            ? (function (t, e) {
                const i = t.start,
                  n = e.getNearestSelectionRange(i);
                if (!n) return null;
                if (!n.isCollapsed) return n;
                const o = n.start;
                if (i.isEqual(o)) return null;
                return new xs(o);
              })(t, e)
            : (function (t, e) {
                const i = t.start,
                  n = t.end,
                  o = e.checkChild(i, "$text"),
                  r = e.checkChild(n, "$text"),
                  s = e.getLimitElement(i),
                  a = e.getLimitElement(n);
                if (s === a) {
                  if (o && r) return null;
                  if (
                    (function (t, e, i) {
                      const n =
                          (t.nodeAfter && !i.isLimit(t.nodeAfter)) ||
                          i.checkChild(t, "$text"),
                        o =
                          (e.nodeBefore && !i.isLimit(e.nodeBefore)) ||
                          i.checkChild(e, "$text");
                      return n || o;
                    })(i, n, e)
                  ) {
                    const t =
                        i.nodeAfter && e.isObject(i.nodeAfter)
                          ? null
                          : e.getNearestSelectionRange(i, "forward"),
                      o =
                        n.nodeBefore && e.isObject(n.nodeBefore)
                          ? null
                          : e.getNearestSelectionRange(n, "backward"),
                      r = t ? t.start : i,
                      s = o ? o.start : n;
                    return new xs(r, s);
                  }
                }
                const l = s && !s.is("rootElement"),
                  c = a && !a.is("rootElement");
                if (l || c) {
                  const t =
                      i.nodeAfter &&
                      n.nodeBefore &&
                      i.nodeAfter.parent === n.nodeBefore.parent,
                    o = l && (!t || !yl(i.nodeAfter, e)),
                    r = c && (!t || !yl(n.nodeBefore, e));
                  let d = i,
                    h = n;
                  return (
                    o && (d = _s._createBefore(vl(s, e))),
                    r && (h = _s._createAfter(vl(a, e))),
                    new xs(d, h)
                  );
                }
                return null;
              })(t, e);
        }
        function vl(t, e) {
          let i = t,
            n = i;
          for (; e.isLimit(n) && n.parent; ) (i = n), (n = n.parent);
          return i;
        }
        function yl(t, e) {
          return t && e.isObject(t);
        }
        class xl {
          constructor() {
            (this.markers = new nl()),
              (this.document = new el(this)),
              (this.schema = new na()),
              (this._pendingChanges = []),
              (this._currentWriter = null),
              [
                "insertContent",
                "deleteContent",
                "modifySelection",
                "getSelectedContent",
                "applyOperation",
              ].forEach((t) => this.decorate(t)),
              this.on(
                "applyOperation",
                (t, e) => {
                  e[0]._validate();
                },
                { priority: "highest" }
              ),
              this.schema.register("$root", { isLimit: !0 }),
              this.schema.register("$block", { allowIn: "$root", isBlock: !0 }),
              this.schema.register("$text", {
                allowIn: "$block",
                isInline: !0,
              }),
              this.schema.register("$clipboardHolder", {
                allowContentOf: "$root",
                isLimit: !0,
              }),
              this.schema.extend("$text", { allowIn: "$clipboardHolder" }),
              this.schema.register("$marker"),
              this.schema.addChildCheck((t, e) => {
                if ("$marker" === e.name) return !0;
              }),
              _l(this);
          }
          change(t) {
            try {
              return 0 === this._pendingChanges.length
                ? (this._pendingChanges.push({ batch: new va(), callback: t }),
                  this._runPendingChanges()[0])
                : t(this._currentWriter);
            } catch (t) {
              hi.b.rethrowUnexpectedError(t, this);
            }
          }
          enqueueChange(t, e) {
            try {
              "string" == typeof t
                ? (t = new va(t))
                : "function" == typeof t && ((e = t), (t = new va())),
                this._pendingChanges.push({ batch: t, callback: e }),
                1 == this._pendingChanges.length && this._runPendingChanges();
            } catch (t) {
              hi.b.rethrowUnexpectedError(t, this);
            }
          }
          applyOperation(t) {
            t._execute();
          }
          insertContent(t, e, i) {
            return (function (t, e, i, n) {
              return t.change((o) => {
                let r;
                (r = i
                  ? i instanceof Ps || i instanceof Ds
                    ? i
                    : o.createSelection(i, n)
                  : t.document.selection),
                  r.isCollapsed ||
                    t.deleteContent(r, { doNotAutoparagraph: !0 });
                const s = new dl(t, o, r.anchor);
                let a;
                (a = e.is("documentFragment") ? e.getChildren() : [e]),
                  s.handleNodes(a, { isFirst: !0, isLast: !0 });
                const l = s.getSelectionRange();
                l && (r instanceof Ds ? o.setSelection(l) : r.setTo(l));
                const c = s.getAffectedRange() || t.createRange(r.anchor);
                return s.destroy(), c;
              });
            })(this, t, e, i);
          }
          deleteContent(t, e) {
            hl(this, t, e);
          }
          modifySelection(t, e) {
            !(function (t, e, i = {}) {
              const n = t.schema,
                o = "backward" != i.direction,
                r = i.unit ? i.unit : "character",
                s = e.focus,
                a = new bs({
                  boundaries: fl(s, o),
                  singleCharacters: !0,
                  direction: o ? "forward" : "backward",
                }),
                l = { walker: a, schema: n, isForward: o, unit: r };
              let c;
              for (; (c = a.next()); ) {
                if (c.done) return;
                const i = gl(l, c.value);
                if (i)
                  return void (e instanceof Ds
                    ? t.change((t) => {
                        t.setSelectionFocus(i);
                      })
                    : e.setFocus(i));
              }
            })(this, t, e);
          }
          getSelectedContent(t) {
            return (function (t, e) {
              return t.change((t) => {
                const i = t.createDocumentFragment(),
                  n = e.getFirstRange();
                if (!n || n.isCollapsed) return i;
                const o = n.start.root,
                  r = n.start.getCommonPath(n.end),
                  s = o.getNodeByPath(r);
                let a;
                a =
                  n.start.parent == n.end.parent
                    ? n
                    : t.createRange(
                        t.createPositionAt(s, n.start.path[r.length]),
                        t.createPositionAt(s, n.end.path[r.length] + 1)
                      );
                const l = a.end.offset - a.start.offset;
                for (const e of a.getItems({ shallow: !0 }))
                  e.is("textProxy")
                    ? t.appendText(e.data, e.getAttributes(), i)
                    : t.append(e._clone(!0), i);
                if (a != n) {
                  const e = n._getTransformedByMove(
                      a.start,
                      t.createPositionAt(i, 0),
                      l
                    )[0],
                    o = t.createRange(t.createPositionAt(i, 0), e.start);
                  wl(t.createRange(e.end, t.createPositionAt(i, "end")), t),
                    wl(o, t);
                }
                return i;
              });
            })(this, t);
          }
          hasContent(t, e) {
            const i = t instanceof ps ? xs._createIn(t) : t;
            if (i.isCollapsed) return !1;
            for (const t of this.markers.getMarkersIntersectingRange(i))
              if (t.affectsData) return !0;
            const { ignoreWhitespaces: n = !1 } = e || {};
            for (const t of i.getItems())
              if (t.is("textProxy")) {
                if (!n) return !0;
                if (-1 !== t.data.search(/\S/)) return !0;
              } else if (this.schema.isObject(t)) return !0;
            return !1;
          }
          createPositionFromPath(t, e, i) {
            return new _s(t, e, i);
          }
          createPositionAt(t, e) {
            return _s._createAt(t, e);
          }
          createPositionAfter(t) {
            return _s._createAfter(t);
          }
          createPositionBefore(t) {
            return _s._createBefore(t);
          }
          createRange(t, e) {
            return new xs(t, e);
          }
          createRangeIn(t) {
            return xs._createIn(t);
          }
          createRangeOn(t) {
            return xs._createOn(t);
          }
          createSelection(t, e, i) {
            return new Ps(t, e, i);
          }
          createBatch(t) {
            return new va(t);
          }
          createOperationFromJSON(t) {
            return class {
              static fromJSON(t, e) {
                return sl[t.__className].fromJSON(t, e);
              }
            }.fromJSON(t, this.document);
          }
          destroy() {
            this.document.destroy(), this.stopListening();
          }
          _runPendingChanges() {
            const t = [];
            for (this.fire("_beforeChanges"); this._pendingChanges.length; ) {
              const e = this._pendingChanges[0].batch;
              this._currentWriter = new Ha(this, e);
              const i = this._pendingChanges[0].callback(this._currentWriter);
              t.push(i),
                this.document._handleChangeBlock(this._currentWriter),
                this._pendingChanges.shift(),
                (this._currentWriter = null);
            }
            return this.fire("_afterChanges"), t;
          }
        }
        yi(xl, Hn);
        class Al {
          constructor() {
            this._listener = Object.create(lr);
          }
          listenTo(t) {
            this._listener.listenTo(t, "keydown", (t, e) => {
              this._listener.fire("_keydown:" + po(e), e);
            });
          }
          set(t, e, i = {}) {
            const n = bo(t),
              o = i.priority;
            this._listener.listenTo(
              this._listener,
              "_keydown:" + n,
              (t, i) => {
                e(i, () => {
                  i.preventDefault(), i.stopPropagation(), t.stop();
                }),
                  (t.return = !0);
              },
              { priority: o }
            );
          }
          press(t) {
            return !!this._listener.fire("_keydown:" + po(t), t);
          }
          destroy() {
            this._listener.stopListening();
          }
        }
        class Cl extends Al {
          constructor(t) {
            super(), (this.editor = t);
          }
          set(t, e, i = {}) {
            if ("string" == typeof e) {
              const t = e;
              e = (e, i) => {
                this.editor.execute(t), i();
              };
            }
            super.set(t, e, i);
          }
        }
        class Tl {
          constructor(t = {}) {
            (this._context = t.context || new Pi({ language: t.language })),
              this._context._addEditor(this, !t.context);
            const e = Array.from(this.constructor.builtinPlugins || []);
            (this.config = new ni(t, this.constructor.defaultConfig)),
              this.config.define("plugins", e),
              this.config.define(this._context._getEditorConfig()),
              (this.plugins = new Ai(this, e, this._context.plugins)),
              (this.locale = this._context.locale),
              (this.t = this.locale.t),
              (this.commands = new ta()),
              this.set("state", "initializing"),
              this.once("ready", () => (this.state = "ready"), {
                priority: "high",
              }),
              this.once("destroy", () => (this.state = "destroyed"), {
                priority: "high",
              }),
              this.set("isReadOnly", !1),
              (this.model = new xl());
            const i = new Sn();
            (this.data = new ba(this.model, i)),
              (this.editing = new Zs(this.model, i)),
              this.editing.view.document.bind("isReadOnly").to(this),
              (this.conversion = new wa(
                [this.editing.downcastDispatcher, this.data.downcastDispatcher],
                this.data.upcastDispatcher
              )),
              this.conversion.addAlias(
                "dataDowncast",
                this.data.downcastDispatcher
              ),
              this.conversion.addAlias(
                "editingDowncast",
                this.editing.downcastDispatcher
              ),
              (this.keystrokes = new Cl(this)),
              this.keystrokes.listenTo(this.editing.view.document);
          }
          initPlugins() {
            const t = this.config,
              e = t.get("plugins"),
              i = t.get("removePlugins") || [],
              n = t.get("extraPlugins") || [];
            return this.plugins.init(e.concat(n), i);
          }
          destroy() {
            let t = Promise.resolve();
            return (
              "initializing" == this.state &&
                (t = new Promise((t) => this.once("ready", t))),
              t
                .then(() => {
                  this.fire("destroy"),
                    this.stopListening(),
                    this.commands.destroy();
                })
                .then(() => this.plugins.destroy())
                .then(() => {
                  this.model.destroy(),
                    this.data.destroy(),
                    this.editing.destroy(),
                    this.keystrokes.destroy();
                })
                .then(() => this._context._removeEditor(this))
            );
          }
          execute(...t) {
            try {
              this.commands.execute(...t);
            } catch (t) {
              hi.b.rethrowUnexpectedError(t, this);
            }
          }
        }
        yi(Tl, Hn);
        var Ml = {
          setData(t) {
            this.data.set(t);
          },
          getData(t) {
            return this.data.get(t);
          },
        };
        var El = {
          updateSourceElement() {
            if (!this.sourceElement)
              throw new hi.b(
                "editor-missing-sourceelement: Cannot update the source element of a detached editor.",
                this
              );
            var t, e;
            (t = this.sourceElement),
              (e = this.data.get()),
              t instanceof HTMLTextAreaElement && (t.value = e),
              (t.innerHTML = e);
          },
        };
        class Pl {
          getHtml(t) {
            const e = document.implementation
              .createHTMLDocument("")
              .createElement("div");
            return e.appendChild(t), e.innerHTML;
          }
        }
        class Sl {
          constructor(t) {
            (this._domParser = new DOMParser()),
              (this._domConverter = new nr(t, { blockFillerMode: "nbsp" })),
              (this._htmlWriter = new Pl());
          }
          toData(t) {
            const e = this._domConverter.viewToDom(t, document);
            return this._htmlWriter.getHtml(e);
          }
          toView(t) {
            const e = this._toDom(t);
            return this._domConverter.domToView(e);
          }
          _toDom(t) {
            const e = this._domParser.parseFromString(t, "text/html"),
              i = e.createDocumentFragment(),
              n = e.body.childNodes;
            for (; n.length > 0; ) i.appendChild(n[0]);
            return i;
          }
        }
        class Il {
          constructor(t) {
            (this.editor = t), (this._components = new Map());
          }
          *names() {
            for (const t of this._components.values()) yield t.originalName;
          }
          add(t, e) {
            if (this.has(t))
              throw new hi.b(
                "componentfactory-item-exists: The item already exists in the component factory.",
                this,
                { name: t }
              );
            this._components.set(Ol(t), { callback: e, originalName: t });
          }
          create(t) {
            if (!this.has(t))
              throw new hi.b(
                "componentfactory-item-missing: The required component is not registered in the factory.",
                this,
                { name: t }
              );
            return this._components.get(Ol(t)).callback(this.editor.locale);
          }
          has(t) {
            return this._components.has(Ol(t));
          }
        }
        function Ol(t) {
          return String(t).toLowerCase();
        }
        class Nl {
          constructor() {
            this.set("isFocused", !1),
              this.set("focusedElement", null),
              (this._elements = new Set()),
              (this._nextEventLoopTimeout = null);
          }
          add(t) {
            if (this._elements.has(t))
              throw new hi.b("focusTracker-add-element-already-exist", this);
            this.listenTo(t, "focus", () => this._focus(t), { useCapture: !0 }),
              this.listenTo(t, "blur", () => this._blur(), { useCapture: !0 }),
              this._elements.add(t);
          }
          remove(t) {
            t === this.focusedElement && this._blur(t),
              this._elements.has(t) &&
                (this.stopListening(t), this._elements.delete(t));
          }
          destroy() {
            this.stopListening();
          }
          _focus(t) {
            clearTimeout(this._nextEventLoopTimeout),
              (this.focusedElement = t),
              (this.isFocused = !0);
          }
          _blur() {
            clearTimeout(this._nextEventLoopTimeout),
              (this._nextEventLoopTimeout = setTimeout(() => {
                (this.focusedElement = null), (this.isFocused = !1);
              }, 0));
          }
        }
        yi(Nl, lr), yi(Nl, Hn);
        class Rl {
          constructor(t) {
            (this.editor = t),
              (this.componentFactory = new Il(t)),
              (this.focusTracker = new Nl()),
              (this._editableElementsMap = new Map()),
              this.listenTo(t.editing.view.document, "layoutChanged", () =>
                this.update()
              );
          }
          get element() {
            return null;
          }
          update() {
            this.fire("update");
          }
          destroy() {
            this.stopListening(), this.focusTracker.destroy();
            for (const t of this._editableElementsMap.values())
              t.ckeditorInstance = null;
            this._editableElementsMap = new Map();
          }
          setEditableElement(t, e) {
            this._editableElementsMap.set(t, e),
              e.ckeditorInstance || (e.ckeditorInstance = this.editor);
          }
          getEditableElement(t = "main") {
            return this._editableElementsMap.get(t);
          }
          getEditableElementsNames() {
            return this._editableElementsMap.keys();
          }
          get _editableElements() {
            return (
              console.warn(
                "editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.",
                { editorUI: this }
              ),
              this._editableElementsMap
            );
          }
        }
        yi(Rl, gi);
        i(14);
        const Ll = new WeakMap();
        function jl(t) {
          const { view: e, element: i, text: n, isDirectHost: o = !0 } = t,
            r = e.document;
          Ll.has(r) ||
            (Ll.set(r, new Map()), r.registerPostFixer((t) => zl(r, t))),
            Ll.get(r).set(i, { text: n, isDirectHost: o }),
            e.change((t) => zl(r, t));
        }
        function Dl(t, e) {
          return (
            !!e.hasClass("ck-placeholder") &&
            (t.removeClass("ck-placeholder", e), !0)
          );
        }
        function zl(t, e) {
          const i = Ll.get(t);
          let n = !1;
          for (const [t, o] of i) Bl(e, t, o) && (n = !0);
          return n;
        }
        function Bl(t, e, i) {
          const { text: n, isDirectHost: o } = i,
            r = o
              ? e
              : (function (t) {
                  if (1 === t.childCount) {
                    const e = t.getChild(0);
                    if (e.is("element") && !e.is("uiElement")) return e;
                  }
                  return null;
                })(e);
          let s = !1;
          return (
            !!r &&
            ((i.hostElement = r),
            r.getAttribute("data-placeholder") !== n &&
              (t.setAttribute("data-placeholder", n, r), (s = !0)),
            !(function (t) {
              if (!t.isAttached()) return !1;
              const e = !Array.from(t.getChildren()).some(
                  (t) => !t.is("uiElement")
                ),
                i = t.document;
              if (!i.isFocused && e) return !0;
              const n = i.selection.anchor;
              return !(!e || !n || n.parent === t);
            })(r)
              ? Dl(t, r) && (s = !0)
              : (function (t, e) {
                  return (
                    !e.hasClass("ck-placeholder") &&
                    (t.addClass("ck-placeholder", e), !0)
                  );
                })(t, r) && (s = !0),
            s)
          );
        }
        class Vl {
          constructor() {
            this._replacedElements = [];
          }
          replace(t, e) {
            this._replacedElements.push({ element: t, newElement: e }),
              (t.style.display = "none"),
              e && t.parentNode.insertBefore(e, t.nextSibling);
          }
          restore() {
            this._replacedElements.forEach(({ element: t, newElement: e }) => {
              (t.style.display = ""), e && e.remove();
            }),
              (this._replacedElements = []);
          }
        }
        class Fl extends Rl {
          constructor(t, e) {
            var i;
            super(t),
              (this.view = e),
              (this._toolbarConfig =
                ((i = t.config.get("toolbar")),
                Array.isArray(i)
                  ? { items: i }
                  : i
                  ? Object.assign({ items: [] }, i)
                  : { items: [] })),
              (this._elementReplacer = new Vl());
          }
          get element() {
            return this.view.element;
          }
          init(t) {
            const e = this.editor,
              i = this.view,
              n = e.editing.view,
              o = i.editable,
              r = n.document.getRoot();
            (o.name = r.rootName), i.render();
            const s = o.element;
            this.setEditableElement(o.name, s),
              this.focusTracker.add(s),
              i.editable.bind("isFocused").to(this.focusTracker),
              n.attachDomRoot(s),
              t && this._elementReplacer.replace(t, this.element),
              this._initPlaceholder(),
              this._initToolbar(),
              this.fire("ready");
          }
          destroy() {
            const t = this.view,
              e = this.editor.editing.view;
            this._elementReplacer.restore(),
              e.detachDomRoot(t.editable.name),
              t.destroy(),
              super.destroy();
          }
          _initToolbar() {
            const t = this.editor,
              e = this.view,
              i = t.editing.view;
            e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"),
              (e.stickyPanel.limiterElement = e.element),
              this._toolbarConfig.viewportTopOffset &&
                (e.stickyPanel.viewportTopOffset =
                  this._toolbarConfig.viewportTopOffset),
              e.toolbar.fillFromConfig(
                this._toolbarConfig.items,
                this.componentFactory
              ),
              (function ({
                origin: t,
                originKeystrokeHandler: e,
                originFocusTracker: i,
                toolbar: n,
                beforeFocus: o,
                afterBlur: r,
              }) {
                i.add(n.element),
                  e.set("Alt+F10", (t, e) => {
                    i.isFocused &&
                      !n.focusTracker.isFocused &&
                      (o && o(), n.focus(), e());
                  }),
                  n.keystrokes.set("Esc", (e, i) => {
                    n.focusTracker.isFocused && (t.focus(), r && r(), i());
                  });
              })({
                origin: i,
                originFocusTracker: this.focusTracker,
                originKeystrokeHandler: t.keystrokes,
                toolbar: e.toolbar,
              });
          }
          _initPlaceholder() {
            const t = this.editor,
              e = t.editing.view,
              i = e.document.getRoot(),
              n = t.sourceElement,
              o =
                t.config.get("placeholder") ||
                (n &&
                  "textarea" === n.tagName.toLowerCase() &&
                  n.getAttribute("placeholder"));
            o && jl({ view: e, element: i, text: o, isDirectHost: !1 });
          }
        }
        class Hl extends xi {
          constructor(t = []) {
            super(t, { idProperty: "viewUid" }),
              this.on("add", (t, e, i) => {
                this._renderViewIntoCollectionParent(e, i);
              }),
              this.on("remove", (t, e) => {
                e.element && this._parentElement && e.element.remove();
              }),
              (this._parentElement = null);
          }
          destroy() {
            this.map((t) => t.destroy());
          }
          setParent(t) {
            this._parentElement = t;
            for (const t of this) this._renderViewIntoCollectionParent(t);
          }
          delegate(...t) {
            if (!t.length || !t.every((t) => "string" == typeof t))
              throw new hi.b(
                "ui-viewcollection-delegate-wrong-events: All event names must be strings.",
                this
              );
            return {
              to: (e) => {
                for (const i of this) for (const n of t) i.delegate(n).to(e);
                this.on("add", (i, n) => {
                  for (const i of t) n.delegate(i).to(e);
                }),
                  this.on("remove", (i, n) => {
                    for (const i of t) n.stopDelegating(i, e);
                  });
              },
            };
          }
          _renderViewIntoCollectionParent(t, e) {
            t.isRendered || t.render(),
              t.element &&
                this._parentElement &&
                this._parentElement.insertBefore(
                  t.element,
                  this._parentElement.children[e]
                );
          }
        }
        class Ul {
          constructor(t) {
            Object.assign(this, Zl(Kl(t))),
              (this._isRendered = !1),
              (this._revertData = null);
          }
          render() {
            const t = this._renderNode({ intoFragment: !0 });
            return (this._isRendered = !0), t;
          }
          apply(t) {
            return (
              (this._revertData = {
                children: [],
                bindings: [],
                attributes: {},
              }),
              this._renderNode({
                node: t,
                isApplying: !0,
                revertData: this._revertData,
              }),
              t
            );
          }
          revert(t) {
            if (!this._revertData)
              throw new hi.b(
                "ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.",
                [this, t]
              );
            this._revertTemplateFromNode(t, this._revertData);
          }
          *getViews() {
            yield* (function* t(e) {
              if (e.children)
                for (const i of e.children)
                  oc(i) ? yield i : rc(i) && (yield* t(i));
            })(this);
          }
          static bind(t, e) {
            return {
              to: (i, n) =>
                new ql({
                  eventNameOrFunction: i,
                  attribute: i,
                  observable: t,
                  emitter: e,
                  callback: n,
                }),
              if: (i, n, o) =>
                new Yl({
                  observable: t,
                  emitter: e,
                  attribute: i,
                  valueIfTrue: n,
                  callback: o,
                }),
            };
          }
          static extend(t, e) {
            if (t._isRendered)
              throw new hi.b(
                "template-extend-render: Attempting to extend a template which has already been rendered.",
                [this, t]
              );
            !(function t(e, i) {
              i.attributes &&
                (e.attributes || (e.attributes = {}),
                ic(e.attributes, i.attributes));
              i.eventListeners &&
                (e.eventListeners || (e.eventListeners = {}),
                ic(e.eventListeners, i.eventListeners));
              i.text && e.text.push(...i.text);
              if (i.children && i.children.length) {
                if (e.children.length != i.children.length)
                  throw new hi.b(
                    "ui-template-extend-children-mismatch: The number of children in extended definition does not match.",
                    e
                  );
                let n = 0;
                for (const o of i.children) t(e.children[n++], o);
              }
            })(t, Zl(Kl(e)));
          }
          _renderNode(t) {
            let e;
            if (
              ((e = t.node
                ? this.tag && this.text
                : this.tag
                ? this.text
                : !this.text),
              e)
            )
              throw new hi.b(
                'ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.',
                this
              );
            return this.text ? this._renderText(t) : this._renderElement(t);
          }
          _renderElement(t) {
            let e = t.node;
            return (
              e ||
                (e = t.node =
                  document.createElementNS(
                    this.ns || "http://www.w3.org/1999/xhtml",
                    this.tag
                  )),
              this._renderAttributes(t),
              this._renderElementChildren(t),
              this._setUpListeners(t),
              e
            );
          }
          _renderText(t) {
            let e = t.node;
            return (
              e
                ? (t.revertData.text = e.textContent)
                : (e = t.node = document.createTextNode("")),
              $l(this.text)
                ? this._bindToObservable({
                    schema: this.text,
                    updater: Gl(e),
                    data: t,
                  })
                : (e.textContent = this.text.join("")),
              e
            );
          }
          _renderAttributes(t) {
            let e, i, n, o;
            if (!this.attributes) return;
            const r = t.node,
              s = t.revertData;
            for (e in this.attributes)
              if (
                ((n = r.getAttribute(e)),
                (i = this.attributes[e]),
                s && (s.attributes[e] = n),
                (o = D(i[0]) && i[0].ns ? i[0].ns : null),
                $l(i))
              ) {
                const a = o ? i[0].value : i;
                s && ac(e) && a.unshift(n),
                  this._bindToObservable({
                    schema: a,
                    updater: Ql(r, e, o),
                    data: t,
                  });
              } else
                "style" == e && "string" != typeof i[0]
                  ? this._renderStyleAttribute(i[0], t)
                  : (s && n && ac(e) && i.unshift(n),
                    (i = i
                      .map((t) => (t && t.value) || t)
                      .reduce((t, e) => t.concat(e), [])
                      .reduce(ec, "")),
                    nc(i) || r.setAttributeNS(o, e, i));
          }
          _renderStyleAttribute(t, e) {
            const i = e.node;
            for (const n in t) {
              const o = t[n];
              $l(o)
                ? this._bindToObservable({
                    schema: [o],
                    updater: Xl(i, n),
                    data: e,
                  })
                : (i.style[n] = o);
            }
          }
          _renderElementChildren(t) {
            const e = t.node,
              i = t.intoFragment ? document.createDocumentFragment() : e,
              n = t.isApplying;
            let o = 0;
            for (const r of this.children)
              if (sc(r)) {
                if (!n) {
                  r.setParent(e);
                  for (const t of r) i.appendChild(t.element);
                }
              } else if (oc(r))
                n || (r.isRendered || r.render(), i.appendChild(r.element));
              else if (Jo(r)) i.appendChild(r);
              else if (n) {
                const e = { children: [], bindings: [], attributes: {} };
                t.revertData.children.push(e),
                  r._renderNode({
                    node: i.childNodes[o++],
                    isApplying: !0,
                    revertData: e,
                  });
              } else i.appendChild(r.render());
            t.intoFragment && e.appendChild(i);
          }
          _setUpListeners(t) {
            if (this.eventListeners)
              for (const e in this.eventListeners) {
                const i = this.eventListeners[e].map((i) => {
                  const [n, o] = e.split("@");
                  return i.activateDomEventListener(n, o, t);
                });
                t.revertData && t.revertData.bindings.push(i);
              }
          }
          _bindToObservable({ schema: t, updater: e, data: i }) {
            const n = i.revertData;
            Jl(t, e, i);
            const o = t
              .filter((t) => !nc(t))
              .filter((t) => t.observable)
              .map((n) => n.activateAttributeListener(t, e, i));
            n && n.bindings.push(o);
          }
          _revertTemplateFromNode(t, e) {
            for (const t of e.bindings) for (const e of t) e();
            if (e.text) t.textContent = e.text;
            else {
              for (const i in e.attributes) {
                const n = e.attributes[i];
                null === n ? t.removeAttribute(i) : t.setAttribute(i, n);
              }
              for (let i = 0; i < e.children.length; ++i)
                this._revertTemplateFromNode(t.childNodes[i], e.children[i]);
            }
          }
        }
        yi(Ul, gi);
        class Wl {
          constructor(t) {
            Object.assign(this, t);
          }
          getValue(t) {
            const e = this.observable[this.attribute];
            return this.callback ? this.callback(e, t) : e;
          }
          activateAttributeListener(t, e, i) {
            const n = () => Jl(t, e, i);
            return (
              this.emitter.listenTo(
                this.observable,
                "change:" + this.attribute,
                n
              ),
              () => {
                this.emitter.stopListening(
                  this.observable,
                  "change:" + this.attribute,
                  n
                );
              }
            );
          }
        }
        class ql extends Wl {
          activateDomEventListener(t, e, i) {
            const n = (t, i) => {
              (e && !i.target.matches(e)) ||
                ("function" == typeof this.eventNameOrFunction
                  ? this.eventNameOrFunction(i)
                  : this.observable.fire(this.eventNameOrFunction, i));
            };
            return (
              this.emitter.listenTo(i.node, t, n),
              () => {
                this.emitter.stopListening(i.node, t, n);
              }
            );
          }
        }
        class Yl extends Wl {
          getValue(t) {
            return !nc(super.getValue(t)) && (this.valueIfTrue || !0);
          }
        }
        function $l(t) {
          return (
            !!t &&
            (t.value && (t = t.value),
            Array.isArray(t) ? t.some($l) : t instanceof Wl)
          );
        }
        function Jl(t, e, { node: i }) {
          let n = (function (t, e) {
            return t.map((t) => (t instanceof Wl ? t.getValue(e) : t));
          })(t, i);
          (n = 1 == t.length && t[0] instanceof Yl ? n[0] : n.reduce(ec, "")),
            nc(n) ? e.remove() : e.set(n);
        }
        function Gl(t) {
          return {
            set(e) {
              t.textContent = e;
            },
            remove() {
              t.textContent = "";
            },
          };
        }
        function Ql(t, e, i) {
          return {
            set(n) {
              t.setAttributeNS(i, e, n);
            },
            remove() {
              t.removeAttributeNS(i, e);
            },
          };
        }
        function Xl(t, e) {
          return {
            set(i) {
              t.style[e] = i;
            },
            remove() {
              t.style[e] = null;
            },
          };
        }
        function Kl(t) {
          return ei(t, (t) => {
            if (t && (t instanceof Wl || rc(t) || oc(t) || sc(t))) return t;
          });
        }
        function Zl(t) {
          if (
            ("string" == typeof t
              ? (t = (function (t) {
                  return { text: [t] };
                })(t))
              : t.text &&
                (function (t) {
                  Array.isArray(t.text) || (t.text = [t.text]);
                })(t),
            t.on &&
              ((t.eventListeners = (function (t) {
                for (const e in t) tc(t, e);
                return t;
              })(t.on)),
              delete t.on),
            !t.text)
          ) {
            t.attributes &&
              (function (t) {
                for (const e in t)
                  t[e].value && (t[e].value = [].concat(t[e].value)), tc(t, e);
              })(t.attributes);
            const e = [];
            if (t.children)
              if (sc(t.children)) e.push(t.children);
              else
                for (const i of t.children)
                  rc(i) || oc(i) || Jo(i) ? e.push(i) : e.push(new Ul(i));
            t.children = e;
          }
          return t;
        }
        function tc(t, e) {
          Array.isArray(t[e]) || (t[e] = [t[e]]);
        }
        function ec(t, e) {
          return nc(e) ? t : nc(t) ? e : `${t} ${e}`;
        }
        function ic(t, e) {
          for (const i in e) t[i] ? t[i].push(...e[i]) : (t[i] = e[i]);
        }
        function nc(t) {
          return !t && 0 !== t;
        }
        function oc(t) {
          return t instanceof lc;
        }
        function rc(t) {
          return t instanceof Ul;
        }
        function sc(t) {
          return t instanceof Hl;
        }
        function ac(t) {
          return "class" == t || "style" == t;
        }
        i(16);
        class lc {
          constructor(t) {
            (this.element = null),
              (this.isRendered = !1),
              (this.locale = t),
              (this.t = t && t.t),
              (this._viewCollections = new xi()),
              (this._unboundChildren = this.createCollection()),
              this._viewCollections.on("add", (e, i) => {
                i.locale = t;
              }),
              this.decorate("render");
          }
          get bindTemplate() {
            return this._bindTemplate
              ? this._bindTemplate
              : (this._bindTemplate = Ul.bind(this, this));
          }
          createCollection(t) {
            const e = new Hl(t);
            return this._viewCollections.add(e), e;
          }
          registerChild(t) {
            vi(t) || (t = [t]);
            for (const e of t) this._unboundChildren.add(e);
          }
          deregisterChild(t) {
            vi(t) || (t = [t]);
            for (const e of t) this._unboundChildren.remove(e);
          }
          setTemplate(t) {
            this.template = new Ul(t);
          }
          extendTemplate(t) {
            Ul.extend(this.template, t);
          }
          render() {
            if (this.isRendered)
              throw new hi.b(
                "ui-view-render-already-rendered: This View has already been rendered.",
                this
              );
            this.template &&
              ((this.element = this.template.render()),
              this.registerChild(this.template.getViews())),
              (this.isRendered = !0);
          }
          destroy() {
            this.stopListening(),
              this._viewCollections.map((t) => t.destroy()),
              this.template &&
                this.template._revertData &&
                this.template.revert(this.element);
          }
        }
        yi(lc, lr), yi(lc, Hn);
        var cc = function (t) {
          return (
            "string" == typeof t ||
            (!Lt(t) && p(t) && "[object String]" == m(t))
          );
        };
        class dc extends Hl {
          constructor(t, e = []) {
            super(e), (this.locale = t);
          }
          attachToDom() {
            this._bodyCollectionContainer = new Ul({
              tag: "div",
              attributes: {
                class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
                dir: this.locale.uiLanguageDirection,
              },
              children: this,
            }).render();
            let t = document.querySelector(".ck-body-wrapper");
            t ||
              ((t = (function (t, e, i = {}, n = []) {
                const o = i && i.xmlns,
                  r = o ? t.createElementNS(o, e) : t.createElement(e);
                for (const t in i) r.setAttribute(t, i[t]);
                (!cc(n) && vi(n)) || (n = [n]);
                for (let e of n)
                  cc(e) && (e = t.createTextNode(e)), r.appendChild(e);
                return r;
              })(document, "div", { class: "ck-body-wrapper" })),
              document.body.appendChild(t)),
              t.appendChild(this._bodyCollectionContainer);
          }
          detachFromDom() {
            super.destroy(),
              this._bodyCollectionContainer &&
                this._bodyCollectionContainer.remove();
            const t = document.querySelector(".ck-body-wrapper");
            t && 0 == t.childElementCount && t.remove();
          }
        }
        i(18);
        class hc extends lc {
          constructor(t) {
            super(t), (this.body = new dc(t));
          }
          render() {
            super.render(), this.body.attachToDom();
          }
          destroy() {
            return this.body.detachFromDom(), super.destroy();
          }
        }
        i(20);
        class uc extends lc {
          constructor(t) {
            super(t),
              this.set("text"),
              this.set("for"),
              (this.id = "ck-editor__label_" + ci());
            const e = this.bindTemplate;
            this.setTemplate({
              tag: "label",
              attributes: {
                class: ["ck", "ck-label"],
                id: this.id,
                for: e.to("for"),
              },
              children: [{ text: e.to("text") }],
            });
          }
        }
        class mc extends hc {
          constructor(t) {
            super(t),
              (this.top = this.createCollection()),
              (this.main = this.createCollection()),
              (this._voiceLabelView = this._createVoiceLabel()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
                  role: "application",
                  dir: t.uiLanguageDirection,
                  lang: t.uiLanguage,
                  "aria-labelledby": this._voiceLabelView.id,
                },
                children: [
                  this._voiceLabelView,
                  {
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-editor__top", "ck-reset_all"],
                      role: "presentation",
                    },
                    children: this.top,
                  },
                  {
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-editor__main"],
                      role: "presentation",
                    },
                    children: this.main,
                  },
                ],
              });
          }
          _createVoiceLabel() {
            const t = this.t,
              e = new uc();
            return (
              (e.text = t("Rich Text Editor")),
              e.extendTemplate({ attributes: { class: "ck-voice-label" } }),
              e
            );
          }
        }
        class gc extends lc {
          constructor(t, e, i) {
            super(t),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-content",
                    "ck-editor__editable",
                    "ck-rounded-corners",
                  ],
                  lang: t.contentLanguage,
                  dir: t.contentLanguageDirection,
                },
              }),
              (this.name = null),
              this.set("isFocused", !1),
              (this._editableElement = i),
              (this._hasExternalElement = !!this._editableElement),
              (this._editingView = e);
          }
          render() {
            super.render(),
              this._hasExternalElement
                ? this.template.apply((this.element = this._editableElement))
                : (this._editableElement = this.element),
              this.on("change:isFocused", () => this._updateIsFocusedClasses()),
              this._updateIsFocusedClasses();
          }
          destroy() {
            this._hasExternalElement &&
              this.template.revert(this._editableElement),
              super.destroy();
          }
          _updateIsFocusedClasses() {
            const t = this._editingView;
            function e(e) {
              t.change((i) => {
                const n = t.document.getRoot(e.name);
                i.addClass(e.isFocused ? "ck-focused" : "ck-blurred", n),
                  i.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", n);
              });
            }
            t.isRenderingInProgress
              ? (function i(n) {
                  t.once("change:isRenderingInProgress", (t, o, r) => {
                    r ? i(n) : e(n);
                  });
                })(this)
              : e(this);
          }
        }
        class fc extends gc {
          constructor(t, e, i) {
            super(t, e, i),
              this.extendTemplate({
                attributes: {
                  role: "textbox",
                  class: "ck-editor__editable_inline",
                },
              });
          }
          render() {
            super.render();
            const t = this._editingView,
              e = this.t;
            t.change((i) => {
              const n = t.document.getRoot(this.name);
              i.setAttribute(
                "aria-label",
                e("Rich Text Editor, %0", [this.name]),
                n
              );
            });
          }
        }
        function pc(t) {
          return (e) => e + t;
        }
        i(22);
        const bc = pc("px");
        class wc extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate;
            this.set("isActive", !1),
              this.set("isSticky", !1),
              this.set("limiterElement", null),
              this.set("limiterBottomOffset", 50),
              this.set("viewportTopOffset", 0),
              this.set("_marginLeft", null),
              this.set("_isStickyToTheLimiter", !1),
              this.set("_hasViewportTopOffset", !1),
              (this.content = this.createCollection()),
              (this._contentPanelPlaceholder = new Ul({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-sticky-panel__placeholder"],
                  style: {
                    display: e.to("isSticky", (t) => (t ? "block" : "none")),
                    height: e.to("isSticky", (t) =>
                      t ? bc(this._panelRect.height) : null
                    ),
                  },
                },
              }).render()),
              (this._contentPanel = new Ul({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-sticky-panel__content",
                    e.if("isSticky", "ck-sticky-panel__content_sticky"),
                    e.if(
                      "_isStickyToTheLimiter",
                      "ck-sticky-panel__content_sticky_bottom-limit"
                    ),
                  ],
                  style: {
                    width: e.to("isSticky", (t) =>
                      t
                        ? bc(
                            this._contentPanelPlaceholder.getBoundingClientRect()
                              .width
                          )
                        : null
                    ),
                    top: e.to("_hasViewportTopOffset", (t) =>
                      t ? bc(this.viewportTopOffset) : null
                    ),
                    bottom: e.to("_isStickyToTheLimiter", (t) =>
                      t ? bc(this.limiterBottomOffset) : null
                    ),
                    marginLeft: e.to("_marginLeft"),
                  },
                },
                children: this.content,
              }).render()),
              this.setTemplate({
                tag: "div",
                attributes: { class: ["ck", "ck-sticky-panel"] },
                children: [this._contentPanelPlaceholder, this._contentPanel],
              });
          }
          render() {
            super.render(),
              this._checkIfShouldBeSticky(),
              this.listenTo(Zo.window, "scroll", () => {
                this._checkIfShouldBeSticky();
              }),
              this.listenTo(this, "change:isActive", () => {
                this._checkIfShouldBeSticky();
              });
          }
          _checkIfShouldBeSticky() {
            const t = (this._panelRect =
              this._contentPanel.getBoundingClientRect());
            let e;
            this.limiterElement
              ? ((e = this._limiterRect =
                  this.limiterElement.getBoundingClientRect()),
                (this.isSticky =
                  this.isActive &&
                  e.top < this.viewportTopOffset &&
                  this._panelRect.height + this.limiterBottomOffset < e.height))
              : (this.isSticky = !1),
              this.isSticky
                ? ((this._isStickyToTheLimiter =
                    e.bottom <
                    t.height +
                      this.limiterBottomOffset +
                      this.viewportTopOffset),
                  (this._hasViewportTopOffset =
                    !this._isStickyToTheLimiter && !!this.viewportTopOffset),
                  (this._marginLeft = this._isStickyToTheLimiter
                    ? null
                    : bc(-Zo.window.scrollX)))
                : ((this._isStickyToTheLimiter = !1),
                  (this._hasViewportTopOffset = !1),
                  (this._marginLeft = null));
          }
        }
        class _c {
          constructor(t) {
            if ((Object.assign(this, t), t.actions && t.keystrokeHandler))
              for (const e in t.actions) {
                let i = t.actions[e];
                "string" == typeof i && (i = [i]);
                for (const n of i)
                  t.keystrokeHandler.set(n, (t, i) => {
                    this[e](), i();
                  });
              }
          }
          get first() {
            return this.focusables.find(kc) || null;
          }
          get last() {
            return this.focusables.filter(kc).slice(-1)[0] || null;
          }
          get next() {
            return this._getFocusableItem(1);
          }
          get previous() {
            return this._getFocusableItem(-1);
          }
          get current() {
            let t = null;
            return null === this.focusTracker.focusedElement
              ? null
              : (this.focusables.find((e, i) => {
                  const n = e.element === this.focusTracker.focusedElement;
                  return n && (t = i), n;
                }),
                t);
          }
          focusFirst() {
            this._focus(this.first);
          }
          focusLast() {
            this._focus(this.last);
          }
          focusNext() {
            this._focus(this.next);
          }
          focusPrevious() {
            this._focus(this.previous);
          }
          _focus(t) {
            t && t.focus();
          }
          _getFocusableItem(t) {
            const e = this.current,
              i = this.focusables.length;
            if (!i) return null;
            if (null === e) return this[1 === t ? "first" : "last"];
            let n = (e + i + t) % i;
            do {
              const e = this.focusables.get(n);
              if (kc(e)) return e;
              n = (n + i + t) % i;
            } while (n !== e);
            return null;
          }
        }
        function kc(t) {
          return !(
            !t.focus || "none" == Zo.window.getComputedStyle(t.element).display
          );
        }
        class vc extends lc {
          constructor(t) {
            super(t),
              this.setTemplate({
                tag: "span",
                attributes: { class: ["ck", "ck-toolbar__separator"] },
              });
          }
        }
        class yc {
          constructor(t, e) {
            yc._observerInstance || yc._createObserver(),
              (this._element = t),
              (this._callback = e),
              yc._addElementCallback(t, e),
              yc._observerInstance.observe(t);
          }
          destroy() {
            yc._deleteElementCallback(this._element, this._callback);
          }
          static _addElementCallback(t, e) {
            yc._elementCallbacks || (yc._elementCallbacks = new Map());
            let i = yc._elementCallbacks.get(t);
            i || ((i = new Set()), yc._elementCallbacks.set(t, i)), i.add(e);
          }
          static _deleteElementCallback(t, e) {
            const i = yc._getElementCallbacks(t);
            i &&
              (i.delete(e),
              i.size ||
                (yc._elementCallbacks.delete(t),
                yc._observerInstance.unobserve(t))),
              yc._elementCallbacks &&
                !yc._elementCallbacks.size &&
                ((yc._observerInstance = null), (yc._elementCallbacks = null));
          }
          static _getElementCallbacks(t) {
            return yc._elementCallbacks ? yc._elementCallbacks.get(t) : null;
          }
          static _createObserver() {
            let t;
            (t =
              "function" == typeof Zo.window.ResizeObserver
                ? Zo.window.ResizeObserver
                : xc),
              (yc._observerInstance = new t((t) => {
                for (const e of t) {
                  if (!e.target.offsetParent) continue;
                  const t = yc._getElementCallbacks(e.target);
                  if (t) for (const i of t) i(e);
                }
              }));
          }
        }
        (yc._observerInstance = null), (yc._elementCallbacks = null);
        class xc {
          constructor(t) {
            (this._callback = t),
              (this._elements = new Set()),
              (this._previousRects = new Map()),
              (this._periodicCheckTimeout = null);
          }
          observe(t) {
            this._elements.add(t),
              this._checkElementRectsAndExecuteCallback(),
              1 === this._elements.size && this._startPeriodicCheck();
          }
          unobserve(t) {
            this._elements.delete(t),
              this._previousRects.delete(t),
              this._elements.size || this._stopPeriodicCheck();
          }
          _startPeriodicCheck() {
            const t = () => {
              this._checkElementRectsAndExecuteCallback(),
                (this._periodicCheckTimeout = setTimeout(t, 100));
            };
            this.listenTo(Zo.window, "resize", () => {
              this._checkElementRectsAndExecuteCallback();
            }),
              (this._periodicCheckTimeout = setTimeout(t, 100));
          }
          _stopPeriodicCheck() {
            clearTimeout(this._periodicCheckTimeout),
              this.stopListening(),
              this._previousRects.clear();
          }
          _checkElementRectsAndExecuteCallback() {
            const t = [];
            for (const e of this._elements)
              this._hasRectChanged(e) &&
                t.push({ target: e, contentRect: this._previousRects.get(e) });
            t.length && this._callback(t);
          }
          _hasRectChanged(t) {
            if (!t.ownerDocument.body.contains(t)) return !1;
            const e = new Kr(t),
              i = this._previousRects.get(t),
              n = !i || !i.isEqual(e);
            return this._previousRects.set(t, e), n;
          }
        }
        yi(xc, lr);
        class Ac extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate;
            this.set("isVisible", !1),
              this.set("position", "se"),
              (this.children = this.createCollection()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-reset",
                    "ck-dropdown__panel",
                    e.to("position", (t) => "ck-dropdown__panel_" + t),
                    e.if("isVisible", "ck-dropdown__panel-visible"),
                  ],
                },
                children: this.children,
                on: { selectstart: e.to((t) => t.preventDefault()) },
              });
          }
          focus() {
            this.children.length && this.children.first.focus();
          }
          focusLast() {
            if (this.children.length) {
              const t = this.children.last;
              "function" == typeof t.focusLast ? t.focusLast() : t.focus();
            }
          }
        }
        i(24);
        function Cc({
          element: t,
          target: e,
          positions: i,
          limiter: n,
          fitInViewport: o,
        }) {
          B(e) && (e = e()), B(n) && (n = n());
          const r = (function (t) {
              return t && t.parentNode
                ? t.offsetParent === Zo.document.body
                  ? null
                  : t.offsetParent
                : null;
            })(t),
            s = new Kr(t),
            a = new Kr(e);
          let l, c;
          if (n || o) {
            const t = (function (t, e) {
              const { elementRect: i, viewportRect: n } = e,
                o = i.getArea(),
                r = (function (
                  t,
                  {
                    targetRect: e,
                    elementRect: i,
                    limiterRect: n,
                    viewportRect: o,
                  }
                ) {
                  const r = [],
                    s = i.getArea();
                  for (const a of t) {
                    const [t, l] = Tc(a, e, i);
                    let c = 0,
                      d = 0;
                    if (n)
                      if (o) {
                        const t = n.getIntersection(o);
                        t && (c = t.getIntersectionArea(l));
                      } else c = n.getIntersectionArea(l);
                    o && (d = o.getIntersectionArea(l));
                    const h = {
                      positionName: t,
                      positionRect: l,
                      limiterIntersectArea: c,
                      viewportIntersectArea: d,
                    };
                    if (c === s) return [h];
                    r.push(h);
                  }
                  return r;
                })(t, e);
              if (n) {
                const t = Mc(
                  r.filter(({ viewportIntersectArea: t }) => t === o),
                  o
                );
                if (t) return t;
              }
              return Mc(r, o);
            })(i, {
              targetRect: a,
              elementRect: s,
              limiterRect: n && new Kr(n).getVisible(),
              viewportRect: o && new Kr(Zo.window),
            });
            [c, l] = t || Tc(i[0], a, s);
          } else [c, l] = Tc(i[0], a, s);
          let d = Ec(l);
          return (
            r &&
              (d = (function ({ left: t, top: e }, i) {
                const n = Ec(new Kr(i)),
                  o = Qr(i);
                return (
                  (t -= n.left),
                  (e -= n.top),
                  (t += i.scrollLeft),
                  (e += i.scrollTop),
                  (t -= o.left),
                  (e -= o.top),
                  { left: t, top: e }
                );
              })(d, r)),
            { left: d.left, top: d.top, name: c }
          );
        }
        function Tc(t, e, i) {
          const { left: n, top: o, name: r } = t(e, i);
          return [r, i.clone().moveTo(n, o)];
        }
        function Mc(t, e) {
          let i,
            n,
            o = 0;
          for (const {
            positionName: r,
            positionRect: s,
            limiterIntersectArea: a,
            viewportIntersectArea: l,
          } of t) {
            if (a === e) return [r, s];
            const t = l ** 2 + a ** 2;
            t > o && ((o = t), (i = s), (n = r));
          }
          return i ? [n, i] : null;
        }
        function Ec({ left: t, top: e }) {
          const { scrollX: i, scrollY: n } = Zo.window;
          return { left: t + i, top: e + n };
        }
        class Pc extends lc {
          constructor(t, e, i) {
            super(t);
            const n = this.bindTemplate;
            (this.buttonView = e),
              (this.panelView = i),
              this.set("isOpen", !1),
              this.set("isEnabled", !0),
              this.set("class"),
              this.set("id"),
              this.set("panelPosition", "auto"),
              (this.keystrokes = new Al()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-dropdown",
                    n.to("class"),
                    n.if("isEnabled", "ck-disabled", (t) => !t),
                  ],
                  id: n.to("id"),
                  "aria-describedby": n.to("ariaDescribedById"),
                },
                children: [e, i],
              }),
              e.extendTemplate({
                attributes: { class: ["ck-dropdown__button"] },
              });
          }
          render() {
            super.render(),
              this.listenTo(this.buttonView, "open", () => {
                this.isOpen = !this.isOpen;
              }),
              this.panelView.bind("isVisible").to(this, "isOpen"),
              this.on("change:isOpen", () => {
                this.isOpen &&
                  ("auto" === this.panelPosition
                    ? (this.panelView.position = Pc._getOptimalPosition({
                        element: this.panelView.element,
                        target: this.buttonView.element,
                        fitInViewport: !0,
                        positions: this._panelPositions,
                      }).name)
                    : (this.panelView.position = this.panelPosition));
              }),
              this.keystrokes.listenTo(this.element);
            const t = (t, e) => {
              this.isOpen && (this.buttonView.focus(), (this.isOpen = !1), e());
            };
            this.keystrokes.set("arrowdown", (t, e) => {
              this.buttonView.isEnabled &&
                !this.isOpen &&
                ((this.isOpen = !0), e());
            }),
              this.keystrokes.set("arrowright", (t, e) => {
                this.isOpen && e();
              }),
              this.keystrokes.set("arrowleft", t),
              this.keystrokes.set("esc", t);
          }
          focus() {
            this.buttonView.focus();
          }
          get _panelPositions() {
            const {
              southEast: t,
              southWest: e,
              northEast: i,
              northWest: n,
            } = Pc.defaultPanelPositions;
            return "ltr" === this.locale.uiLanguageDirection
              ? [t, e, i, n]
              : [e, t, n, i];
          }
        }
        (Pc.defaultPanelPositions = {
          southEast: (t) => ({ top: t.bottom, left: t.left, name: "se" }),
          southWest: (t, e) => ({
            top: t.bottom,
            left: t.left - e.width + t.width,
            name: "sw",
          }),
          northEast: (t, e) => ({
            top: t.top - e.height,
            left: t.left,
            name: "ne",
          }),
          northWest: (t, e) => ({
            top: t.bottom - e.height,
            left: t.left - e.width + t.width,
            name: "nw",
          }),
        }),
          (Pc._getOptimalPosition = Cc);
        i(26);
        class Sc extends lc {
          constructor() {
            super();
            const t = this.bindTemplate;
            this.set("content", ""),
              this.set("viewBox", "0 0 20 20"),
              this.set("fillColor", ""),
              this.setTemplate({
                tag: "svg",
                ns: "http://www.w3.org/2000/svg",
                attributes: {
                  class: ["ck", "ck-icon"],
                  viewBox: t.to("viewBox"),
                },
              });
          }
          render() {
            super.render(),
              this._updateXMLContent(),
              this._colorFillPaths(),
              this.on("change:content", () => {
                this._updateXMLContent(), this._colorFillPaths();
              }),
              this.on("change:fillColor", () => {
                this._colorFillPaths();
              });
          }
          _updateXMLContent() {
            if (this.content) {
              const t = new DOMParser()
                  .parseFromString(this.content.trim(), "image/svg+xml")
                  .querySelector("svg"),
                e = t.getAttribute("viewBox");
              for (
                e && (this.viewBox = e), this.element.innerHTML = "";
                t.childNodes.length > 0;

              )
                this.element.appendChild(t.childNodes[0]);
            }
          }
          _colorFillPaths() {
            this.fillColor &&
              this.element.querySelectorAll(".ck-icon__fill").forEach((t) => {
                t.style.fill = this.fillColor;
              });
          }
        }
        i(28);
        class Ic extends lc {
          constructor(t) {
            super(t), this.set("text", ""), this.set("position", "s");
            const e = this.bindTemplate;
            this.setTemplate({
              tag: "span",
              attributes: {
                class: [
                  "ck",
                  "ck-tooltip",
                  e.to("position", (t) => "ck-tooltip_" + t),
                  e.if("text", "ck-hidden", (t) => !t.trim()),
                ],
              },
              children: [
                {
                  tag: "span",
                  attributes: { class: ["ck", "ck-tooltip__text"] },
                  children: [{ text: e.to("text") }],
                },
              ],
            });
          }
        }
        i(30);
        class Oc extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate,
              i = ci();
            this.set("class"),
              this.set("labelStyle"),
              this.set("icon"),
              this.set("isEnabled", !0),
              this.set("isOn", !1),
              this.set("isVisible", !0),
              this.set("isToggleable", !1),
              this.set("keystroke"),
              this.set("label"),
              this.set("tabindex", -1),
              this.set("tooltip"),
              this.set("tooltipPosition", "s"),
              this.set("type", "button"),
              this.set("withText", !1),
              this.set("withKeystroke", !1),
              (this.children = this.createCollection()),
              (this.tooltipView = this._createTooltipView()),
              (this.labelView = this._createLabelView(i)),
              (this.iconView = new Sc()),
              this.iconView.extendTemplate({
                attributes: { class: "ck-button__icon" },
              }),
              (this.keystrokeView = this._createKeystrokeView()),
              this.bind("_tooltipString").to(
                this,
                "tooltip",
                this,
                "label",
                this,
                "keystroke",
                this._getTooltipString.bind(this)
              ),
              this.setTemplate({
                tag: "button",
                attributes: {
                  class: [
                    "ck",
                    "ck-button",
                    e.to("class"),
                    e.if("isEnabled", "ck-disabled", (t) => !t),
                    e.if("isVisible", "ck-hidden", (t) => !t),
                    e.to("isOn", (t) => (t ? "ck-on" : "ck-off")),
                    e.if("withText", "ck-button_with-text"),
                    e.if("withKeystroke", "ck-button_with-keystroke"),
                  ],
                  type: e.to("type", (t) => t || "button"),
                  tabindex: e.to("tabindex"),
                  "aria-labelledby": "ck-editor__aria-label_" + i,
                  "aria-disabled": e.if("isEnabled", !0, (t) => !t),
                  "aria-pressed": e.to(
                    "isOn",
                    (t) => !!this.isToggleable && String(t)
                  ),
                },
                children: this.children,
                on: {
                  mousedown: e.to((t) => {
                    t.preventDefault();
                  }),
                  click: e.to((t) => {
                    this.isEnabled ? this.fire("execute") : t.preventDefault();
                  }),
                },
              });
          }
          render() {
            super.render(),
              this.icon &&
                (this.iconView.bind("content").to(this, "icon"),
                this.children.add(this.iconView)),
              this.children.add(this.tooltipView),
              this.children.add(this.labelView),
              this.withKeystroke && this.children.add(this.keystrokeView);
          }
          focus() {
            this.element.focus();
          }
          _createTooltipView() {
            const t = new Ic();
            return (
              t.bind("text").to(this, "_tooltipString"),
              t.bind("position").to(this, "tooltipPosition"),
              t
            );
          }
          _createLabelView(t) {
            const e = new lc(),
              i = this.bindTemplate;
            return (
              e.setTemplate({
                tag: "span",
                attributes: {
                  class: ["ck", "ck-button__label"],
                  style: i.to("labelStyle"),
                  id: "ck-editor__aria-label_" + t,
                },
                children: [{ text: this.bindTemplate.to("label") }],
              }),
              e
            );
          }
          _createKeystrokeView() {
            const t = new lc();
            return (
              t.setTemplate({
                tag: "span",
                attributes: { class: ["ck", "ck-button__keystroke"] },
                children: [
                  { text: this.bindTemplate.to("keystroke", (t) => wo(t)) },
                ],
              }),
              t
            );
          }
          _getTooltipString(t, e, i) {
            return t
              ? "string" == typeof t
                ? t
                : (i && (i = wo(i)),
                  t instanceof Function ? t(e, i) : `${e}${i ? ` (${i})` : ""}`)
              : "";
          }
        }
        var Nc =
          '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
        class Rc extends Oc {
          constructor(t) {
            super(t),
              (this.arrowView = this._createArrowView()),
              this.extendTemplate({ attributes: { "aria-haspopup": !0 } }),
              this.delegate("execute").to(this, "open");
          }
          render() {
            super.render(), this.children.add(this.arrowView);
          }
          _createArrowView() {
            const t = new Sc();
            return (
              (t.content = Nc),
              t.extendTemplate({ attributes: { class: "ck-dropdown__arrow" } }),
              t
            );
          }
        }
        i(32);
        class Lc extends lc {
          constructor() {
            super(),
              (this.items = this.createCollection()),
              (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              (this._focusCycler = new _c({
                focusables: this.items,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: { focusPrevious: "arrowup", focusNext: "arrowdown" },
              })),
              this.setTemplate({
                tag: "ul",
                attributes: { class: ["ck", "ck-reset", "ck-list"] },
                children: this.items,
              });
          }
          render() {
            super.render();
            for (const t of this.items) this.focusTracker.add(t.element);
            this.items.on("add", (t, e) => {
              this.focusTracker.add(e.element);
            }),
              this.items.on("remove", (t, e) => {
                this.focusTracker.remove(e.element);
              }),
              this.keystrokes.listenTo(this.element);
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          focusLast() {
            this._focusCycler.focusLast();
          }
        }
        class jc extends lc {
          constructor(t) {
            super(t),
              (this.children = this.createCollection()),
              this.setTemplate({
                tag: "li",
                attributes: { class: ["ck", "ck-list__item"] },
                children: this.children,
              });
          }
          focus() {
            this.children.first.focus();
          }
        }
        class Dc extends lc {
          constructor(t) {
            super(t),
              this.setTemplate({
                tag: "li",
                attributes: { class: ["ck", "ck-list__separator"] },
              });
          }
        }
        i(34);
        class zc extends Oc {
          constructor(t) {
            super(t),
              (this.isToggleable = !0),
              (this.toggleSwitchView = this._createToggleView()),
              this.extendTemplate({ attributes: { class: "ck-switchbutton" } });
          }
          render() {
            super.render(), this.children.add(this.toggleSwitchView);
          }
          _createToggleView() {
            const t = new lc();
            return (
              t.setTemplate({
                tag: "span",
                attributes: { class: ["ck", "ck-button__toggle"] },
                children: [
                  {
                    tag: "span",
                    attributes: { class: ["ck", "ck-button__toggle__inner"] },
                  },
                ],
              }),
              t
            );
          }
        }
        function Bc({
          emitter: t,
          activator: e,
          callback: i,
          contextElements: n,
        }) {
          t.listenTo(document, "mousedown", (t, { target: o }) => {
            if (e()) {
              for (const t of n) if (t.contains(o)) return;
              i();
            }
          });
        }
        i(36), i(38);
        function Vc(t, e = Rc) {
          const i = new e(t),
            n = new Ac(t),
            o = new Pc(t, i, n);
          return (
            i.bind("isEnabled").to(o),
            i instanceof Rc
              ? i.bind("isOn").to(o, "isOpen")
              : i.arrowView.bind("isOn").to(o, "isOpen"),
            (function (t) {
              (function (t) {
                t.on("render", () => {
                  Bc({
                    emitter: t,
                    activator: () => t.isOpen,
                    callback: () => {
                      t.isOpen = !1;
                    },
                    contextElements: [t.element],
                  });
                });
              })(t),
                (function (t) {
                  t.on("execute", (e) => {
                    e.source instanceof zc || (t.isOpen = !1);
                  });
                })(t),
                (function (t) {
                  t.keystrokes.set("arrowdown", (e, i) => {
                    t.isOpen && (t.panelView.focus(), i());
                  }),
                    t.keystrokes.set("arrowup", (e, i) => {
                      t.isOpen && (t.panelView.focusLast(), i());
                    });
                })(t);
            })(o),
            o
          );
        }
        function Fc(t, e) {
          const i = t.locale,
            n = i.t,
            o = (t.toolbarView = new Uc(i));
          o.set("ariaLabel", n("Dropdown toolbar")),
            t.extendTemplate({
              attributes: { class: ["ck-toolbar-dropdown"] },
            }),
            e.map((t) => o.items.add(t)),
            t.panelView.children.add(o),
            o.items.delegate("execute").to(t);
        }
        function Hc(t, e) {
          const i = t.locale,
            n = (t.listView = new Lc(i));
          n.items.bindTo(e).using(({ type: t, model: e }) => {
            if ("separator" === t) return new Dc(i);
            if ("button" === t || "switchbutton" === t) {
              const n = new jc(i);
              let o;
              return (
                (o = "button" === t ? new Oc(i) : new zc(i)),
                o.bind(...Object.keys(e)).to(e),
                o.delegate("execute").to(n),
                n.children.add(o),
                n
              );
            }
          }),
            t.panelView.children.add(n),
            n.items.delegate("execute").to(t);
        }
        i(40);
        class Uc extends lc {
          constructor(t, e) {
            super(t);
            const i = this.bindTemplate,
              n = this.t;
            var o;
            (this.options = e || {}),
              this.set("ariaLabel", n("Editor toolbar")),
              this.set("maxWidth", "auto"),
              (this.items = this.createCollection()),
              (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              this.set("class"),
              this.set("isCompact", !1),
              (this.itemsView = new Wc(t)),
              (this.children = this.createCollection()),
              this.children.add(this.itemsView),
              (this.focusables = this.createCollection()),
              (this._focusCycler = new _c({
                focusables: this.focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: {
                  focusPrevious: ["arrowleft", "arrowup"],
                  focusNext: ["arrowright", "arrowdown"],
                },
              })),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-toolbar",
                    i.to("class"),
                    i.if("isCompact", "ck-toolbar_compact"),
                  ],
                  role: "toolbar",
                  "aria-label": i.to("ariaLabel"),
                  style: { maxWidth: i.to("maxWidth") },
                },
                children: this.children,
                on: {
                  mousedown:
                    ((o = this),
                    o.bindTemplate.to((t) => {
                      t.target === o.element && t.preventDefault();
                    })),
                },
              }),
              (this._behavior = this.options.shouldGroupWhenFull
                ? new Yc(this)
                : new qc(this));
          }
          render() {
            super.render();
            for (const t of this.items) this.focusTracker.add(t.element);
            this.items.on("add", (t, e) => {
              this.focusTracker.add(e.element);
            }),
              this.items.on("remove", (t, e) => {
                this.focusTracker.remove(e.element);
              }),
              this.keystrokes.listenTo(this.element),
              this._behavior.render(this);
          }
          destroy() {
            return this._behavior.destroy(), super.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          focusLast() {
            this._focusCycler.focusLast();
          }
          fillFromConfig(t, e) {
            t.map((t) => {
              "|" == t
                ? this.items.add(new vc())
                : e.has(t)
                ? this.items.add(e.create(t))
                : console.warn(
                    Object(hi.a)(
                      "toolbarview-item-unavailable: The requested toolbar item is unavailable."
                    ),
                    { name: t }
                  );
            });
          }
        }
        class Wc extends lc {
          constructor(t) {
            super(t),
              (this.children = this.createCollection()),
              this.setTemplate({
                tag: "div",
                attributes: { class: ["ck", "ck-toolbar__items"] },
                children: this.children,
              });
          }
        }
        class qc {
          constructor(t) {
            const e = t.bindTemplate;
            t.set("isVertical", !1),
              t.itemsView.children.bindTo(t.items).using((t) => t),
              t.focusables.bindTo(t.items).using((t) => t),
              t.extendTemplate({
                attributes: {
                  class: [e.if("isVertical", "ck-toolbar_vertical")],
                },
              });
          }
          render() {}
          destroy() {}
        }
        class Yc {
          constructor(t) {
            (this.viewChildren = t.children),
              (this.viewFocusables = t.focusables),
              (this.viewItemsView = t.itemsView),
              (this.viewFocusTracker = t.focusTracker),
              (this.viewLocale = t.locale),
              (this.ungroupedItems = t.createCollection()),
              (this.groupedItems = t.createCollection()),
              (this.groupedItemsDropdown = this._createGroupedItemsDropdown()),
              (this.resizeObserver = null),
              (this.cachedPadding = null),
              (this.shouldUpdateGroupingOnNextResize = !1),
              t.itemsView.children.bindTo(this.ungroupedItems).using((t) => t),
              this.ungroupedItems.on(
                "add",
                this._updateFocusCycleableItems.bind(this)
              ),
              this.ungroupedItems.on(
                "remove",
                this._updateFocusCycleableItems.bind(this)
              ),
              t.children.on("add", this._updateFocusCycleableItems.bind(this)),
              t.children.on(
                "remove",
                this._updateFocusCycleableItems.bind(this)
              ),
              t.items.on("add", (t, e, i) => {
                i > this.ungroupedItems.length
                  ? this.groupedItems.add(e, i - this.ungroupedItems.length)
                  : this.ungroupedItems.add(e, i),
                  this._updateGrouping();
              }),
              t.items.on("remove", (t, e, i) => {
                i > this.ungroupedItems.length
                  ? this.groupedItems.remove(e)
                  : this.ungroupedItems.remove(e),
                  this._updateGrouping();
              }),
              t.extendTemplate({
                attributes: { class: ["ck-toolbar_grouping"] },
              });
          }
          render(t) {
            (this.viewElement = t.element),
              this._enableGroupingOnResize(),
              this._enableGroupingOnMaxWidthChange(t);
          }
          destroy() {
            this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
          }
          _updateGrouping() {
            if (!this.viewElement.ownerDocument.body.contains(this.viewElement))
              return;
            if (!this.viewElement.offsetParent)
              return void (this.shouldUpdateGroupingOnNextResize = !0);
            let t;
            for (; this._areItemsOverflowing; ) this._groupLastItem(), (t = !0);
            if (!t && this.groupedItems.length) {
              for (; this.groupedItems.length && !this._areItemsOverflowing; )
                this._ungroupFirstItem();
              this._areItemsOverflowing && this._groupLastItem();
            }
          }
          get _areItemsOverflowing() {
            if (!this.ungroupedItems.length) return !1;
            const t = this.viewElement,
              e = this.viewLocale.uiLanguageDirection,
              i = new Kr(t.lastChild),
              n = new Kr(t);
            if (!this.cachedPadding) {
              const i = Zo.window.getComputedStyle(t),
                n = "ltr" === e ? "paddingRight" : "paddingLeft";
              this.cachedPadding = Number.parseInt(i[n]);
            }
            return "ltr" === e
              ? i.right > n.right - this.cachedPadding
              : i.left < n.left + this.cachedPadding;
          }
          _enableGroupingOnResize() {
            let t;
            (this.resizeObserver = new yc(this.viewElement, (e) => {
              (t &&
                t === e.contentRect.width &&
                !this.shouldUpdateGroupingOnNextResize) ||
                ((this.shouldUpdateGroupingOnNextResize = !1),
                this._updateGrouping(),
                (t = e.contentRect.width));
            })),
              this._updateGrouping();
          }
          _enableGroupingOnMaxWidthChange(t) {
            t.on("change:maxWidth", () => {
              this._updateGrouping();
            });
          }
          _groupLastItem() {
            this.groupedItems.length ||
              (this.viewChildren.add(new vc()),
              this.viewChildren.add(this.groupedItemsDropdown),
              this.viewFocusTracker.add(this.groupedItemsDropdown.element)),
              this.groupedItems.add(
                this.ungroupedItems.remove(this.ungroupedItems.last),
                0
              );
          }
          _ungroupFirstItem() {
            this.ungroupedItems.add(
              this.groupedItems.remove(this.groupedItems.first)
            ),
              this.groupedItems.length ||
                (this.viewChildren.remove(this.groupedItemsDropdown),
                this.viewChildren.remove(this.viewChildren.last),
                this.viewFocusTracker.remove(
                  this.groupedItemsDropdown.element
                ));
          }
          _createGroupedItemsDropdown() {
            const t = this.viewLocale,
              e = t.t,
              i = Vc(t);
            return (
              (i.class = "ck-toolbar__grouped-dropdown"),
              (i.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se"),
              Fc(i, []),
              i.buttonView.set({
                label: e("Show more items"),
                tooltip: !0,
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
              }),
              i.toolbarView.items.bindTo(this.groupedItems).using((t) => t),
              i
            );
          }
          _updateFocusCycleableItems() {
            this.viewFocusables.clear(),
              this.ungroupedItems.map((t) => {
                this.viewFocusables.add(t);
              }),
              this.groupedItems.length &&
                this.viewFocusables.add(this.groupedItemsDropdown);
          }
        }
        i(42);
        class $c extends mc {
          constructor(t, e, i = {}) {
            super(t),
              (this.stickyPanel = new wc(t)),
              (this.toolbar = new Uc(t, {
                shouldGroupWhenFull: i.shouldToolbarGroupWhenFull,
              })),
              (this.editable = new fc(t, e));
          }
          render() {
            super.render(),
              this.stickyPanel.content.add(this.toolbar),
              this.top.add(this.stickyPanel),
              this.main.add(this.editable);
          }
        }
        class Jc extends Tl {
          constructor(t, e) {
            super(e),
              ii(t) && (this.sourceElement = t),
              (this.data.processor = new Sl(this.data.viewDocument)),
              this.model.document.createRoot();
            const i = !this.config.get("toolbar.shouldNotGroupWhenFull"),
              n = new $c(this.locale, this.editing.view, {
                shouldToolbarGroupWhenFull: i,
              });
            (this.ui = new Fl(this, n)),
              (function (t) {
                if (!B(t.updateSourceElement))
                  throw new hi.b(
                    "attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.",
                    t
                  );
                const e = t.sourceElement;
                if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
                  let i;
                  const n = e.form,
                    o = () => t.updateSourceElement();
                  B(n.submit) &&
                    ((i = n.submit),
                    (n.submit = () => {
                      o(), i.apply(n);
                    })),
                    n.addEventListener("submit", o),
                    t.on("destroy", () => {
                      n.removeEventListener("submit", o), i && (n.submit = i);
                    });
                }
              })(this);
          }
          destroy() {
            return (
              this.sourceElement && this.updateSourceElement(),
              this.ui.destroy(),
              super.destroy()
            );
          }
          static create(t, e = {}) {
            return new Promise((i) => {
              const n = new this(t, e);
              i(
                n
                  .initPlugins()
                  .then(() => n.ui.init(ii(t) ? t : null))
                  .then(() => {
                    if (!ii(t) && e.initialData)
                      throw new hi.b(
                        "editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().",
                        null
                      );
                    const i =
                      e.initialData ||
                      (function (t) {
                        return ii(t)
                          ? ((e = t),
                            e instanceof HTMLTextAreaElement
                              ? e.value
                              : e.innerHTML)
                          : t;
                        var e;
                      })(t);
                    return n.data.init(i);
                  })
                  .then(() => n.fire("ready"))
                  .then(() => n)
              );
            });
          }
        }
        yi(Jc, Ml), yi(Jc, El);
        class Gc {
          constructor(t) {
            (this.editor = t),
              this.set("isEnabled", !0),
              (this._disableStack = new Set());
          }
          forceDisabled(t) {
            this._disableStack.add(t),
              1 == this._disableStack.size &&
                (this.on("set:isEnabled", Qc, { priority: "highest" }),
                (this.isEnabled = !1));
          }
          clearForceDisabled(t) {
            this._disableStack.delete(t),
              0 == this._disableStack.size &&
                (this.off("set:isEnabled", Qc), (this.isEnabled = !0));
          }
          destroy() {
            this.stopListening();
          }
          static get isContextPlugin() {
            return !1;
          }
        }
        function Qc(t) {
          (t.return = !1), t.stop();
        }
        yi(Gc, Hn);
        class Xc {
          constructor(t) {
            (this.files = (function (t) {
              const e = t.files ? Array.from(t.files) : [],
                i = t.items ? Array.from(t.items) : [];
              if (e.length) return e;
              return i
                .filter((t) => "file" === t.kind)
                .map((t) => t.getAsFile());
            })(t)),
              (this._native = t);
          }
          get types() {
            return this._native.types;
          }
          getData(t) {
            return this._native.getData(t);
          }
          setData(t, e) {
            this._native.setData(t, e);
          }
        }
        class Kc extends Or {
          constructor(t) {
            super(t);
            const e = this.document;
            function i(t, i) {
              i.preventDefault();
              const n = i.dropRange
                  ? [i.dropRange]
                  : Array.from(e.selection.getRanges()),
                o = new ai(e, "clipboardInput");
              e.fire(o, { dataTransfer: i.dataTransfer, targetRanges: n }),
                o.stop.called && i.stopPropagation();
            }
            (this.domEventType = ["paste", "copy", "cut", "drop", "dragover"]),
              this.listenTo(e, "paste", i, { priority: "low" }),
              this.listenTo(e, "drop", i, { priority: "low" });
          }
          onDomEvent(t) {
            const e = {
              dataTransfer: new Xc(
                t.clipboardData ? t.clipboardData : t.dataTransfer
              ),
            };
            "drop" == t.type &&
              (e.dropRange = (function (t, e) {
                const i = e.target.ownerDocument,
                  n = e.clientX,
                  o = e.clientY;
                let r;
                i.caretRangeFromPoint && i.caretRangeFromPoint(n, o)
                  ? (r = i.caretRangeFromPoint(n, o))
                  : e.rangeParent &&
                    ((r = i.createRange()),
                    r.setStart(e.rangeParent, e.rangeOffset),
                    r.collapse(!0));
                return r
                  ? t.domConverter.domRangeToView(r)
                  : t.document.selection.getFirstRange();
              })(this.view, t)),
              this.fire(t.type, t, e);
          }
        }
        const Zc = ["figcaption", "li"];
        class td extends Gc {
          static get pluginName() {
            return "Clipboard";
          }
          init() {
            const t = this.editor,
              e = t.model.document,
              i = t.editing.view,
              n = i.document;
            function o(i, o) {
              const r = o.dataTransfer;
              o.preventDefault();
              const s = t.data.toView(t.model.getSelectedContent(e.selection));
              n.fire("clipboardOutput", {
                dataTransfer: r,
                content: s,
                method: i.name,
              });
            }
            (this._htmlDataProcessor = new Sl(n)),
              i.addObserver(Kc),
              this.listenTo(
                n,
                "clipboardInput",
                (e) => {
                  t.isReadOnly && e.stop();
                },
                { priority: "highest" }
              ),
              this.listenTo(
                n,
                "clipboardInput",
                (t, e) => {
                  const n = e.dataTransfer;
                  let o = "";
                  var r;
                  n.getData("text/html")
                    ? (o = (function (t) {
                        return t.replace(
                          /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
                          (t, e) => (1 == e.length ? " " : e)
                        );
                      })(n.getData("text/html")))
                    : n.getData("text/plain") &&
                      ((r = (r = n.getData("text/plain"))
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/\n/g, "</p><p>")
                        .replace(/^\s/, "&nbsp;")
                        .replace(/\s$/, "&nbsp;")
                        .replace(/\s\s/g, " &nbsp;")).indexOf("</p><p>") > -1 &&
                        (r = `<p>${r}</p>`),
                      (o = r)),
                    (o = this._htmlDataProcessor.toView(o));
                  const s = new ai(this, "inputTransformation");
                  this.fire(s, { content: o, dataTransfer: n }),
                    s.stop.called && t.stop(),
                    i.scrollToTheSelection();
                },
                { priority: "low" }
              ),
              this.listenTo(
                this,
                "inputTransformation",
                (t, e) => {
                  if (!e.content.isEmpty) {
                    const i = this.editor.data,
                      n = this.editor.model,
                      o = i.toModel(e.content, "$clipboardHolder");
                    if (0 == o.childCount) return;
                    n.insertContent(o), t.stop();
                  }
                },
                { priority: "low" }
              ),
              this.listenTo(n, "copy", o, { priority: "low" }),
              this.listenTo(
                n,
                "cut",
                (e, i) => {
                  t.isReadOnly ? i.preventDefault() : o(e, i);
                },
                { priority: "low" }
              ),
              this.listenTo(
                n,
                "clipboardOutput",
                (i, n) => {
                  n.content.isEmpty ||
                    (n.dataTransfer.setData(
                      "text/html",
                      this._htmlDataProcessor.toData(n.content)
                    ),
                    n.dataTransfer.setData(
                      "text/plain",
                      (function t(e) {
                        let i = "";
                        if (e.is("text") || e.is("textProxy")) i = e.data;
                        else if (e.is("img") && e.hasAttribute("alt"))
                          i = e.getAttribute("alt");
                        else {
                          let n = null;
                          for (const o of e.getChildren()) {
                            const e = t(o);
                            n &&
                              (n.is("containerElement") ||
                                o.is("containerElement")) &&
                              (Zc.includes(n.name) || Zc.includes(o.name)
                                ? (i += "\n")
                                : (i += "\n\n")),
                              (i += e),
                              (n = o);
                          }
                        }
                        return i;
                      })(n.content)
                    )),
                    "cut" == n.method && t.model.deleteContent(e.selection);
                },
                { priority: "low" }
              );
          }
        }
        class ed {
          constructor(t) {
            (this.editor = t),
              this.set("value", void 0),
              this.set("isEnabled", !1),
              (this._disableStack = new Set()),
              this.decorate("execute"),
              this.listenTo(this.editor.model.document, "change", () => {
                this.refresh();
              }),
              this.on(
                "execute",
                (t) => {
                  this.isEnabled || t.stop();
                },
                { priority: "high" }
              ),
              this.listenTo(t, "change:isReadOnly", (t, e, i) => {
                i
                  ? this.forceDisabled("readOnlyMode")
                  : this.clearForceDisabled("readOnlyMode");
              });
          }
          refresh() {
            this.isEnabled = !0;
          }
          forceDisabled(t) {
            this._disableStack.add(t),
              1 == this._disableStack.size &&
                (this.on("set:isEnabled", id, { priority: "highest" }),
                (this.isEnabled = !1));
          }
          clearForceDisabled(t) {
            this._disableStack.delete(t),
              0 == this._disableStack.size &&
                (this.off("set:isEnabled", id), this.refresh());
          }
          execute() {}
          destroy() {
            this.stopListening();
          }
        }
        function id(t) {
          (t.return = !1), t.stop();
        }
        function* nd(t, e) {
          for (const i of e)
            i && t.getAttributeProperties(i[0]).copyOnEnter && (yield i);
        }
        yi(ed, Hn);
        class od extends ed {
          execute() {
            const t = this.editor.model,
              e = t.document;
            t.change((i) => {
              !(function (t, e, i, n) {
                const o = i.isCollapsed,
                  r = i.getFirstRange(),
                  s = r.start.parent,
                  a = r.end.parent;
                if (n.isLimit(s) || n.isLimit(a))
                  return void (o || s != a || t.deleteContent(i));
                if (o) {
                  const t = nd(e.model.schema, i.getAttributes());
                  rd(e, r.start), e.setSelectionAttribute(t);
                } else {
                  const n = !(r.start.isAtStart && r.end.isAtEnd),
                    o = s == a;
                  t.deleteContent(i, { leaveUnmerged: n }),
                    n && (o ? rd(e, i.focus) : e.setSelection(a, 0));
                }
              })(this.editor.model, i, e.selection, t.schema),
                this.fire("afterExecute", { writer: i });
            });
          }
        }
        function rd(t, e) {
          t.split(e), t.setSelection(e.parent.nextSibling, 0);
        }
        class sd extends hr {
          constructor(t) {
            super(t);
            const e = this.document;
            e.on("keydown", (t, i) => {
              if (this.isEnabled && i.keyCode == fo.enter) {
                let n;
                e.once("enter", (t) => (n = t), { priority: "highest" }),
                  e.fire(
                    "enter",
                    new Ir(e, i.domEvent, { isSoft: i.shiftKey })
                  ),
                  n && n.stop.called && t.stop();
              }
            });
          }
          observe() {}
        }
        class ad extends Gc {
          static get pluginName() {
            return "Enter";
          }
          init() {
            const t = this.editor,
              e = t.editing.view,
              i = e.document;
            e.addObserver(sd),
              t.commands.add("enter", new od(t)),
              this.listenTo(
                i,
                "enter",
                (i, n) => {
                  n.preventDefault(),
                    n.isSoft || (t.execute("enter"), e.scrollToTheSelection());
                },
                { priority: "low" }
              );
          }
        }
        class ld extends ed {
          execute() {
            const t = this.editor.model,
              e = t.document;
            t.change((i) => {
              !(function (t, e, i) {
                const n = i.isCollapsed,
                  o = i.getFirstRange(),
                  r = o.start.parent,
                  s = o.end.parent,
                  a = r == s;
                if (n) {
                  const n = nd(t.schema, i.getAttributes());
                  cd(t, e, o.end),
                    e.removeSelectionAttribute(i.getAttributeKeys()),
                    e.setSelectionAttribute(n);
                } else {
                  const n = !(o.start.isAtStart && o.end.isAtEnd);
                  t.deleteContent(i, { leaveUnmerged: n }),
                    a ? cd(t, e, i.focus) : n && e.setSelection(s, 0);
                }
              })(t, i, e.selection),
                this.fire("afterExecute", { writer: i });
            });
          }
          refresh() {
            const t = this.editor.model,
              e = t.document;
            this.isEnabled = (function (t, e) {
              if (e.rangeCount > 1) return !1;
              const i = e.anchor;
              if (!i || !t.checkChild(i, "softBreak")) return !1;
              const n = e.getFirstRange(),
                o = n.start.parent,
                r = n.end.parent;
              if ((dd(o, t) || dd(r, t)) && o !== r) return !1;
              return !0;
            })(t.schema, e.selection);
          }
        }
        function cd(t, e, i) {
          const n = e.createElement("softBreak");
          t.insertContent(n, i), e.setSelection(n, "after");
        }
        function dd(t, e) {
          return !t.is("rootElement") && (e.isLimit(t) || dd(t.parent, e));
        }
        class hd extends Gc {
          static get pluginName() {
            return "ShiftEnter";
          }
          init() {
            const t = this.editor,
              e = t.model.schema,
              i = t.conversion,
              n = t.editing.view,
              o = n.document;
            e.register("softBreak", { allowWhere: "$text", isInline: !0 }),
              i
                .for("upcast")
                .elementToElement({ model: "softBreak", view: "br" }),
              i
                .for("downcast")
                .elementToElement({
                  model: "softBreak",
                  view: (t, e) => e.createEmptyElement("br"),
                }),
              n.addObserver(sd),
              t.commands.add("shiftEnter", new ld(t)),
              this.listenTo(
                o,
                "enter",
                (e, i) => {
                  i.preventDefault(),
                    i.isSoft &&
                      (t.execute("shiftEnter"), n.scrollToTheSelection());
                },
                { priority: "low" }
              );
          }
        }
        class ud extends ed {
          execute() {
            const t = this.editor.model,
              e = t.schema.getLimitElement(t.document.selection);
            t.change((t) => {
              t.setSelection(e, "in");
            });
          }
        }
        const md = bo("Ctrl+A");
        class gd extends Gc {
          static get pluginName() {
            return "SelectAllEditing";
          }
          init() {
            const t = this.editor,
              e = t.editing.view.document;
            t.commands.add("selectAll", new ud(t)),
              this.listenTo(e, "keydown", (e, i) => {
                po(i) === md && (t.execute("selectAll"), i.preventDefault());
              });
          }
        }
        class fd extends Gc {
          static get pluginName() {
            return "SelectAllUI";
          }
          init() {
            const t = this.editor;
            t.ui.componentFactory.add("selectAll", (e) => {
              const i = t.commands.get("selectAll"),
                n = new Oc(e),
                o = e.t;
              return (
                n.set({
                  label: o("Select all"),
                  icon: '<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
                  keystroke: "Ctrl+A",
                  tooltip: !0,
                }),
                n.bind("isOn", "isEnabled").to(i, "value", "isEnabled"),
                this.listenTo(n, "execute", () => {
                  t.execute("selectAll"), t.editing.view.focus();
                }),
                n
              );
            });
          }
        }
        class pd extends Gc {
          static get requires() {
            return [gd, fd];
          }
          static get pluginName() {
            return "SelectAll";
          }
        }
        class bd {
          constructor(t, e = 20) {
            (this.model = t),
              (this.size = 0),
              (this.limit = e),
              (this.isLocked = !1),
              (this._changeCallback = (t, e) => {
                "transparent" != e.type && e !== this._batch && this._reset(!0);
              }),
              (this._selectionChangeCallback = () => {
                this._reset();
              }),
              this.model.document.on("change", this._changeCallback),
              this.model.document.selection.on(
                "change:range",
                this._selectionChangeCallback
              ),
              this.model.document.selection.on(
                "change:attribute",
                this._selectionChangeCallback
              );
          }
          get batch() {
            return (
              this._batch || (this._batch = this.model.createBatch()),
              this._batch
            );
          }
          input(t) {
            (this.size += t), this.size >= this.limit && this._reset(!0);
          }
          lock() {
            this.isLocked = !0;
          }
          unlock() {
            this.isLocked = !1;
          }
          destroy() {
            this.model.document.off("change", this._changeCallback),
              this.model.document.selection.off(
                "change:range",
                this._selectionChangeCallback
              ),
              this.model.document.selection.off(
                "change:attribute",
                this._selectionChangeCallback
              );
          }
          _reset(t) {
            (this.isLocked && !t) || ((this._batch = null), (this.size = 0));
          }
        }
        class wd extends ed {
          constructor(t, e) {
            super(t),
              (this._buffer = new bd(t.model, e)),
              (this._batches = new WeakSet());
          }
          get buffer() {
            return this._buffer;
          }
          destroy() {
            super.destroy(), this._buffer.destroy();
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.document,
              n = t.text || "",
              o = n.length,
              r = t.range ? e.createSelection(t.range) : i.selection,
              s = t.resultRange;
            e.enqueueChange(this._buffer.batch, (t) => {
              this._buffer.lock(),
                e.deleteContent(r),
                n &&
                  e.insertContent(
                    t.createText(n, i.selection.getAttributes()),
                    r
                  ),
                s
                  ? t.setSelection(s)
                  : r.is("documentSelection") || t.setSelection(r),
                this._buffer.unlock(),
                this._buffer.input(o),
                this._batches.add(this._buffer.batch);
            });
          }
        }
        function _d(t) {
          let e = null;
          const i = t.model,
            n = t.editing.view,
            o = t.commands.get("input");
          function r(t) {
            const r = i.document,
              a = n.document.isComposing,
              l = e && e.isEqual(r.selection);
            (e = null),
              o.isEnabled &&
                ((function (t) {
                  if (t.ctrlKey) return !0;
                  return kd.includes(t.keyCode);
                })(t) ||
                  r.selection.isCollapsed ||
                  (a && 229 === t.keyCode) ||
                  (!a && 229 === t.keyCode && l) ||
                  s());
          }
          function s() {
            const t = o.buffer;
            t.lock(),
              i.enqueueChange(t.batch, () => {
                i.deleteContent(i.document.selection);
              }),
              t.unlock();
          }
          uo.isAndroid
            ? n.document.on("beforeinput", (t, e) => r(e), {
                priority: "lowest",
              })
            : n.document.on("keydown", (t, e) => r(e), { priority: "lowest" }),
            n.document.on(
              "compositionstart",
              function () {
                const t = i.document,
                  e =
                    1 !== t.selection.rangeCount ||
                    t.selection.getFirstRange().isFlat;
                if (t.selection.isCollapsed || e) return;
                s();
              },
              { priority: "lowest" }
            ),
            n.document.on(
              "compositionend",
              () => {
                e = i.createSelection(i.document.selection);
              },
              { priority: "lowest" }
            );
        }
        const kd = [
          po("arrowUp"),
          po("arrowRight"),
          po("arrowDown"),
          po("arrowLeft"),
          9,
          16,
          17,
          18,
          19,
          20,
          27,
          33,
          34,
          35,
          36,
          45,
          91,
          93,
          144,
          145,
          173,
          174,
          175,
          176,
          177,
          178,
          179,
          255,
        ];
        for (let t = 112; t <= 135; t++) kd.push(t);
        function vd(t) {
          if (t.newChildren.length - t.oldChildren.length != 1) return;
          const e = (function (t, e) {
            const i = [];
            let n,
              o = 0;
            return (
              t.forEach((t) => {
                "equal" == t
                  ? (r(), o++)
                  : "insert" == t
                  ? (s("insert")
                      ? n.values.push(e[o])
                      : (r(),
                        (n = { type: "insert", index: o, values: [e[o]] })),
                    o++)
                  : s("delete")
                  ? n.howMany++
                  : (r(), (n = { type: "delete", index: o, howMany: 1 }));
              }),
              r(),
              i
            );
            function r() {
              n && (i.push(n), (n = null));
            }
            function s(t) {
              return n && n.type == t;
            }
          })(qo(t.oldChildren, t.newChildren, yd), t.newChildren);
          if (e.length > 1) return;
          const i = e[0];
          return i.values[0] && i.values[0].is("text") ? i : void 0;
        }
        function yd(t, e) {
          return t && t.is("text") && e && e.is("text")
            ? t.data === e.data
            : t === e;
        }
        class xd {
          constructor(t) {
            (this.editor = t), (this.editing = this.editor.editing);
          }
          handle(t, e) {
            if (
              (function (t) {
                if (0 == t.length) return !1;
                for (const e of t)
                  if ("children" === e.type && !vd(e)) return !0;
                return !1;
              })(t)
            )
              this._handleContainerChildrenMutations(t, e);
            else
              for (const i of t)
                this._handleTextMutation(i, e),
                  this._handleTextNodeInsertion(i);
          }
          _handleContainerChildrenMutations(t, e) {
            const i = (function (t) {
              const e = t
                .map((t) => t.node)
                .reduce((t, e) => t.getCommonAncestor(e, { includeSelf: !0 }));
              if (!e) return;
              return e
                .getAncestors({ includeSelf: !0, parentFirst: !0 })
                .find((t) => t.is("containerElement") || t.is("rootElement"));
            })(t);
            if (!i) return;
            const n = this.editor.editing.view.domConverter.mapViewToDom(i),
              o = new nr(this.editor.editing.view.document),
              r = this.editor.data.toModel(o.domToView(n)).getChild(0),
              s = this.editor.editing.mapper.toModelElement(i);
            if (!s) return;
            const a = Array.from(r.getChildren()),
              l = Array.from(s.getChildren()),
              c = a[a.length - 1],
              d = l[l.length - 1];
            c && c.is("softBreak") && d && !d.is("softBreak") && a.pop();
            const h = this.editor.model.schema;
            if (!Ad(a, h) || !Ad(l, h)) return;
            const u = a
                .map((t) => (t.is("text") ? t.data : "@"))
                .join("")
                .replace(/\u00A0/g, " "),
              m = l
                .map((t) => (t.is("text") ? t.data : "@"))
                .join("")
                .replace(/\u00A0/g, " ");
            if (m === u) return;
            const g = qo(m, u),
              { firstChangeAt: f, insertions: p, deletions: b } = Cd(g);
            let w = null;
            e && (w = this.editing.mapper.toModelRange(e.getFirstRange()));
            const _ = u.substr(f, p),
              k = this.editor.model.createRange(
                this.editor.model.createPositionAt(s, f),
                this.editor.model.createPositionAt(s, f + b)
              );
            this.editor.execute("input", { text: _, range: k, resultRange: w });
          }
          _handleTextMutation(t, e) {
            if ("text" != t.type) return;
            const i = t.newText.replace(/\u00A0/g, " "),
              n = t.oldText.replace(/\u00A0/g, " ");
            if (n === i) return;
            const o = qo(n, i),
              { firstChangeAt: r, insertions: s, deletions: a } = Cd(o);
            let l = null;
            e && (l = this.editing.mapper.toModelRange(e.getFirstRange()));
            const c = this.editing.view.createPositionAt(t.node, r),
              d = this.editing.mapper.toModelPosition(c),
              h = this.editor.model.createRange(d, d.getShiftedBy(a)),
              u = i.substr(r, s);
            this.editor.execute("input", { text: u, range: h, resultRange: l });
          }
          _handleTextNodeInsertion(t) {
            if ("children" != t.type) return;
            const e = vd(t),
              i = this.editing.view.createPositionAt(t.node, e.index),
              n = this.editing.mapper.toModelPosition(i),
              o = e.values[0].data;
            this.editor.execute("input", {
              text: o.replace(/\u00A0/g, " "),
              range: this.editor.model.createRange(n),
            });
          }
        }
        function Ad(t, e) {
          return t.every((t) => e.isInline(t));
        }
        function Cd(t) {
          let e = null,
            i = null;
          for (let n = 0; n < t.length; n++) {
            "equal" != t[n] && ((e = null === e ? n : e), (i = n));
          }
          let n = 0,
            o = 0;
          for (let r = e; r <= i; r++)
            "insert" != t[r] && n++, "delete" != t[r] && o++;
          return { insertions: o, deletions: n, firstChangeAt: e };
        }
        class Td extends Gc {
          static get pluginName() {
            return "Input";
          }
          init() {
            const t = this.editor,
              e = new wd(t, t.config.get("typing.undoStep") || 20);
            t.commands.add("input", e),
              _d(t),
              (function (t) {
                t.editing.view.document.on("mutations", (e, i, n) => {
                  new xd(t).handle(i, n);
                });
              })(t);
          }
          isInput(t) {
            return this.editor.commands.get("input")._batches.has(t);
          }
        }
        class Md extends ed {
          constructor(t, e) {
            super(t),
              (this.direction = e),
              (this._buffer = new bd(t.model, t.config.get("typing.undoStep")));
          }
          get buffer() {
            return this._buffer;
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.document;
            e.enqueueChange(this._buffer.batch, (n) => {
              this._buffer.lock();
              const o = n.createSelection(t.selection || i.selection),
                r = o.isCollapsed;
              if (
                (o.isCollapsed &&
                  e.modifySelection(o, {
                    direction: this.direction,
                    unit: t.unit,
                  }),
                this._shouldEntireContentBeReplacedWithParagraph(
                  t.sequence || 1
                ))
              )
                return void this._replaceEntireContentWithParagraph(n);
              if (o.isCollapsed) return;
              let s = 0;
              o
                .getFirstRange()
                .getMinimalFlatRanges()
                .forEach((t) => {
                  s += eo(
                    t.getWalker({
                      singleCharacters: !0,
                      ignoreElementEnd: !0,
                      shallow: !0,
                    })
                  );
                }),
                e.deleteContent(o, {
                  doNotResetEntireContent: r,
                  direction: this.direction,
                }),
                this._buffer.input(s),
                n.setSelection(o),
                this._buffer.unlock();
            });
          }
          _shouldEntireContentBeReplacedWithParagraph(t) {
            if (t > 1) return !1;
            const e = this.editor.model,
              i = e.document.selection,
              n = e.schema.getLimitElement(i);
            if (!(i.isCollapsed && i.containsEntireContent(n))) return !1;
            if (!e.schema.checkChild(n, "paragraph")) return !1;
            const o = n.getChild(0);
            return !o || "paragraph" !== o.name;
          }
          _replaceEntireContentWithParagraph(t) {
            const e = this.editor.model,
              i = e.document.selection,
              n = e.schema.getLimitElement(i),
              o = t.createElement("paragraph");
            t.remove(t.createRangeIn(n)), t.insert(o, n), t.setSelection(o, 0);
          }
        }
        class Ed extends hr {
          constructor(t) {
            super(t);
            const e = t.document;
            let i = 0;
            function n(t, i, n) {
              let o;
              e.once("delete", (t) => (o = t), {
                priority: Number.POSITIVE_INFINITY,
              }),
                e.fire("delete", new Ir(e, i, n)),
                o && o.stop.called && t.stop();
            }
            e.on("keyup", (t, e) => {
              (e.keyCode != fo.delete && e.keyCode != fo.backspace) || (i = 0);
            }),
              e.on("keydown", (t, e) => {
                const o = {};
                if (e.keyCode == fo.delete)
                  (o.direction = "forward"), (o.unit = "character");
                else {
                  if (e.keyCode != fo.backspace) return;
                  (o.direction = "backward"), (o.unit = "codePoint");
                }
                const r = uo.isMac ? e.altKey : e.ctrlKey;
                (o.unit = r ? "word" : o.unit),
                  (o.sequence = ++i),
                  n(t, e.domEvent, o);
              }),
              uo.isAndroid &&
                e.on("beforeinput", (e, i) => {
                  if ("deleteContentBackward" != i.domEvent.inputType) return;
                  const o = {
                      unit: "codepoint",
                      direction: "backward",
                      sequence: 1,
                    },
                    r = i.domTarget.ownerDocument.defaultView.getSelection();
                  r.anchorNode == r.focusNode &&
                    r.anchorOffset + 1 != r.focusOffset &&
                    (o.selectionToRemove =
                      t.domConverter.domSelectionToView(r)),
                    n(e, i.domEvent, o);
                });
          }
          observe() {}
        }
        class Pd extends Gc {
          static get pluginName() {
            return "Delete";
          }
          init() {
            const t = this.editor,
              e = t.editing.view,
              i = e.document;
            if (
              (e.addObserver(Ed),
              t.commands.add("forwardDelete", new Md(t, "forward")),
              t.commands.add("delete", new Md(t, "backward")),
              this.listenTo(i, "delete", (i, n) => {
                const o = { unit: n.unit, sequence: n.sequence };
                if (n.selectionToRemove) {
                  const e = t.model.createSelection(),
                    i = [];
                  for (const e of n.selectionToRemove.getRanges())
                    i.push(t.editing.mapper.toModelRange(e));
                  e.setTo(i), (o.selection = e);
                }
                t.execute(
                  "forward" == n.direction ? "forwardDelete" : "delete",
                  o
                ),
                  n.preventDefault(),
                  e.scrollToTheSelection();
              }),
              uo.isAndroid)
            ) {
              let t = null;
              this.listenTo(
                i,
                "delete",
                (e, i) => {
                  const n =
                    i.domTarget.ownerDocument.defaultView.getSelection();
                  t = {
                    anchorNode: n.anchorNode,
                    anchorOffset: n.anchorOffset,
                    focusNode: n.focusNode,
                    focusOffset: n.focusOffset,
                  };
                },
                { priority: "lowest" }
              ),
                this.listenTo(i, "keyup", (e, i) => {
                  if (t) {
                    const e =
                      i.domTarget.ownerDocument.defaultView.getSelection();
                    e.collapse(t.anchorNode, t.anchorOffset),
                      e.extend(t.focusNode, t.focusOffset),
                      (t = null);
                  }
                });
            }
          }
        }
        class Sd extends Gc {
          static get requires() {
            return [Td, Pd];
          }
          static get pluginName() {
            return "Typing";
          }
        }
        const Id = new Map();
        function Od(t, e, i) {
          let n = Id.get(t);
          n || ((n = new Map()), Id.set(t, n)), n.set(e, i);
        }
        function Nd(t) {
          return [t];
        }
        function Rd(t, e, i = {}) {
          const n = (function (t, e) {
            const i = Id.get(t);
            return i && i.has(e) ? i.get(e) : Nd;
          })(t.constructor, e.constructor);
          try {
            return n((t = t.clone()), e, i);
          } catch (t) {
            throw t;
          }
        }
        function Ld(t, e, i) {
          (t = t.slice()), (e = e.slice());
          const n = new jd(i.document, i.useRelations, i.forceWeakRemove);
          n.setOriginalOperations(t), n.setOriginalOperations(e);
          const o = n.originalOperations;
          if (0 == t.length || 0 == e.length)
            return { operationsA: t, operationsB: e, originalOperations: o };
          const r = new WeakMap();
          for (const e of t) r.set(e, 0);
          const s = {
            nextBaseVersionA: t[t.length - 1].baseVersion + 1,
            nextBaseVersionB: e[e.length - 1].baseVersion + 1,
            originalOperationsACount: t.length,
            originalOperationsBCount: e.length,
          };
          let a = 0;
          for (; a < t.length; ) {
            const i = t[a],
              o = r.get(i);
            if (o == e.length) {
              a++;
              continue;
            }
            const s = e[o],
              l = Rd(i, s, n.getContext(i, s, !0)),
              c = Rd(s, i, n.getContext(s, i, !1));
            n.updateRelation(i, s),
              n.setOriginalOperations(l, i),
              n.setOriginalOperations(c, s);
            for (const t of l) r.set(t, o + c.length);
            t.splice(a, 1, ...l), e.splice(o, 1, ...c);
          }
          if (i.padWithNoOps) {
            const i = t.length - s.originalOperationsACount,
              n = e.length - s.originalOperationsBCount;
            zd(t, n - i), zd(e, i - n);
          }
          return (
            Dd(t, s.nextBaseVersionB),
            Dd(e, s.nextBaseVersionA),
            { operationsA: t, operationsB: e, originalOperations: o }
          );
        }
        class jd {
          constructor(t, e, i = !1) {
            (this.originalOperations = new Map()),
              (this._history = t.history),
              (this._useRelations = e),
              (this._forceWeakRemove = !!i),
              (this._relations = new Map());
          }
          setOriginalOperations(t, e = null) {
            const i = e ? this.originalOperations.get(e) : null;
            for (const e of t) this.originalOperations.set(e, i || e);
          }
          updateRelation(t, e) {
            switch (t.constructor) {
              case Ra:
                switch (e.constructor) {
                  case Ba:
                    t.targetPosition.isEqual(e.sourcePosition) ||
                    e.movedRange.containsPosition(t.targetPosition)
                      ? this._setRelation(t, e, "insertAtSource")
                      : t.targetPosition.isEqual(e.deletionPosition)
                      ? this._setRelation(t, e, "insertBetween")
                      : t.targetPosition.isAfter(e.sourcePosition) &&
                        this._setRelation(t, e, "moveTargetAfter");
                    break;
                  case Ra:
                    t.targetPosition.isEqual(e.sourcePosition) ||
                    t.targetPosition.isBefore(e.sourcePosition)
                      ? this._setRelation(t, e, "insertBefore")
                      : this._setRelation(t, e, "insertAfter");
                }
                break;
              case Va:
                switch (e.constructor) {
                  case Ba:
                    t.splitPosition.isBefore(e.sourcePosition) &&
                      this._setRelation(t, e, "splitBefore");
                    break;
                  case Ra:
                    (t.splitPosition.isEqual(e.sourcePosition) ||
                      t.splitPosition.isBefore(e.sourcePosition)) &&
                      this._setRelation(t, e, "splitBefore");
                }
                break;
              case Ba:
                switch (e.constructor) {
                  case Ba:
                    t.targetPosition.isEqual(e.sourcePosition) ||
                      this._setRelation(t, e, "mergeTargetNotMoved"),
                      t.sourcePosition.isEqual(e.targetPosition) &&
                        this._setRelation(t, e, "mergeSourceNotMoved"),
                      t.sourcePosition.isEqual(e.sourcePosition) &&
                        this._setRelation(t, e, "mergeSameElement");
                    break;
                  case Va:
                    t.sourcePosition.isEqual(e.splitPosition) &&
                      this._setRelation(t, e, "splitAtSource");
                }
                break;
              case ja: {
                const i = t.newRange;
                if (!i) return;
                switch (e.constructor) {
                  case Ra: {
                    const n = xs._createFromPositionAndShift(
                        e.sourcePosition,
                        e.howMany
                      ),
                      o =
                        n.containsPosition(i.start) || n.start.isEqual(i.start),
                      r = n.containsPosition(i.end) || n.end.isEqual(i.end);
                    (!o && !r) ||
                      n.containsRange(i) ||
                      this._setRelation(t, e, {
                        side: o ? "left" : "right",
                        path: o ? i.start.path.slice() : i.end.path.slice(),
                      });
                    break;
                  }
                  case Ba: {
                    const n = i.start.isEqual(e.targetPosition),
                      o = i.start.isEqual(e.deletionPosition),
                      r = i.end.isEqual(e.deletionPosition),
                      s = i.end.isEqual(e.sourcePosition);
                    (n || o || r || s) &&
                      this._setRelation(t, e, {
                        wasInLeftElement: n,
                        wasStartBeforeMergedElement: o,
                        wasEndBeforeMergedElement: r,
                        wasInRightElement: s,
                      });
                    break;
                  }
                }
                break;
              }
            }
          }
          getContext(t, e, i) {
            return {
              aIsStrong: i,
              aWasUndone: this._wasUndone(t),
              bWasUndone: this._wasUndone(e),
              abRelation: this._useRelations ? this._getRelation(t, e) : null,
              baRelation: this._useRelations ? this._getRelation(e, t) : null,
              forceWeakRemove: this._forceWeakRemove,
            };
          }
          _wasUndone(t) {
            const e = this.originalOperations.get(t);
            return e.wasUndone || this._history.isUndoneOperation(e);
          }
          _getRelation(t, e) {
            const i = this.originalOperations.get(e),
              n = this._history.getUndoneOperation(i);
            if (!n) return null;
            const o = this.originalOperations.get(t),
              r = this._relations.get(o);
            return (r && r.get(n)) || null;
          }
          _setRelation(t, e, i) {
            const n = this.originalOperations.get(t),
              o = this.originalOperations.get(e);
            let r = this._relations.get(n);
            r || ((r = new Map()), this._relations.set(n, r)), r.set(o, i);
          }
        }
        function Dd(t, e) {
          for (const i of t) i.baseVersion = e++;
        }
        function zd(t, e) {
          for (let i = 0; i < e; i++) t.push(new rl(0));
        }
        function Bd(t, e, i) {
          const n = t.nodes.getNode(0).getAttribute(e);
          if (n == i) return null;
          const o = new xs(t.position, t.position.getShiftedBy(t.howMany));
          return new Oa(o, e, n, i, 0);
        }
        function Vd(t, e) {
          return (
            null ===
            t.targetPosition._getTransformedByDeletion(
              e.sourcePosition,
              e.howMany
            )
          );
        }
        function Fd(t, e) {
          const i = [];
          for (let n = 0; n < t.length; n++) {
            const o = t[n],
              r = new Ra(o.start, o.end.offset - o.start.offset, e, 0);
            i.push(r);
            for (let e = n + 1; e < t.length; e++)
              t[e] = t[e]._getTransformedByMove(
                r.sourcePosition,
                r.targetPosition,
                r.howMany
              )[0];
            e = e._getTransformedByMove(
              r.sourcePosition,
              r.targetPosition,
              r.howMany
            );
          }
          return i;
        }
        Od(Oa, Oa, (t, e, i) => {
          if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
            const n = t.range
                .getDifference(e.range)
                .map((e) => new Oa(e, t.key, t.oldValue, t.newValue, 0)),
              o = t.range.getIntersection(e.range);
            return (
              o &&
                i.aIsStrong &&
                n.push(new Oa(o, e.key, e.newValue, t.newValue, 0)),
              0 == n.length ? [new rl(0)] : n
            );
          }
          return [t];
        }),
          Od(Oa, La, (t, e) => {
            if (
              t.range.start.hasSameParentAs(e.position) &&
              t.range.containsPosition(e.position)
            ) {
              const i = t.range
                ._getTransformedByInsertion(
                  e.position,
                  e.howMany,
                  !e.shouldReceiveAttributes
                )
                .map(
                  (e) => new Oa(e, t.key, t.oldValue, t.newValue, t.baseVersion)
                );
              if (e.shouldReceiveAttributes) {
                const n = Bd(e, t.key, t.oldValue);
                n && i.unshift(n);
              }
              return i;
            }
            return (
              (t.range = t.range._getTransformedByInsertion(
                e.position,
                e.howMany,
                !1
              )[0]),
              [t]
            );
          }),
          Od(Oa, Ba, (t, e) => {
            const i = [];
            t.range.start.hasSameParentAs(e.deletionPosition) &&
              (t.range.containsPosition(e.deletionPosition) ||
                t.range.start.isEqual(e.deletionPosition)) &&
              i.push(xs._createFromPositionAndShift(e.graveyardPosition, 1));
            const n = t.range._getTransformedByMergeOperation(e);
            return (
              n.isCollapsed || i.push(n),
              i.map(
                (e) => new Oa(e, t.key, t.oldValue, t.newValue, t.baseVersion)
              )
            );
          }),
          Od(Oa, Ra, (t, e) =>
            (function (t, e) {
              const i = xs._createFromPositionAndShift(
                e.sourcePosition,
                e.howMany
              );
              let n = null,
                o = [];
              i.containsRange(t, !0)
                ? (n = t)
                : t.start.hasSameParentAs(i.start)
                ? ((o = t.getDifference(i)), (n = t.getIntersection(i)))
                : (o = [t]);
              const r = [];
              for (let t of o) {
                t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
                const i = e.getMovedRangeStart(),
                  n = t.start.hasSameParentAs(i);
                (t = t._getTransformedByInsertion(i, e.howMany, n)),
                  r.push(...t);
              }
              n &&
                r.push(
                  n._getTransformedByMove(
                    e.sourcePosition,
                    e.targetPosition,
                    e.howMany,
                    !1
                  )[0]
                );
              return r;
            })(t.range, e).map(
              (e) => new Oa(e, t.key, t.oldValue, t.newValue, t.baseVersion)
            )
          ),
          Od(Oa, Va, (t, e) => {
            if (t.range.end.isEqual(e.insertionPosition))
              return e.graveyardPosition || t.range.end.offset++, [t];
            if (
              t.range.start.hasSameParentAs(e.splitPosition) &&
              t.range.containsPosition(e.splitPosition)
            ) {
              const i = t.clone();
              return (
                (i.range = new xs(
                  e.moveTargetPosition.clone(),
                  t.range.end._getCombined(
                    e.splitPosition,
                    e.moveTargetPosition
                  )
                )),
                (t.range.end = e.splitPosition.clone()),
                (t.range.end.stickiness = "toPrevious"),
                [t, i]
              );
            }
            return (t.range = t.range._getTransformedBySplitOperation(e)), [t];
          }),
          Od(La, Oa, (t, e) => {
            const i = [t];
            if (
              t.shouldReceiveAttributes &&
              t.position.hasSameParentAs(e.range.start) &&
              e.range.containsPosition(t.position)
            ) {
              const n = Bd(t, e.key, e.newValue);
              n && i.push(n);
            }
            return i;
          }),
          Od(
            La,
            La,
            (t, e, i) => (
              (t.position.isEqual(e.position) && i.aIsStrong) ||
                (t.position = t.position._getTransformedByInsertOperation(e)),
              [t]
            )
          ),
          Od(
            La,
            Ra,
            (t, e) => (
              (t.position = t.position._getTransformedByMoveOperation(e)), [t]
            )
          ),
          Od(
            La,
            Va,
            (t, e) => (
              (t.position = t.position._getTransformedBySplitOperation(e)), [t]
            )
          ),
          Od(
            La,
            Ba,
            (t, e) => (
              (t.position = t.position._getTransformedByMergeOperation(e)), [t]
            )
          ),
          Od(
            ja,
            La,
            (t, e) => (
              t.oldRange &&
                (t.oldRange =
                  t.oldRange._getTransformedByInsertOperation(e)[0]),
              t.newRange &&
                (t.newRange =
                  t.newRange._getTransformedByInsertOperation(e)[0]),
              [t]
            )
          ),
          Od(ja, ja, (t, e, i) => {
            if (t.name == e.name) {
              if (!i.aIsStrong) return [new rl(0)];
              t.oldRange = e.newRange ? e.newRange.clone() : null;
            }
            return [t];
          }),
          Od(
            ja,
            Ba,
            (t, e) => (
              t.oldRange &&
                (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)),
              t.newRange &&
                (t.newRange = t.newRange._getTransformedByMergeOperation(e)),
              [t]
            )
          ),
          Od(ja, Ra, (t, e, i) => {
            if (
              (t.oldRange &&
                (t.oldRange = xs._createFromRanges(
                  t.oldRange._getTransformedByMoveOperation(e)
                )),
              t.newRange)
            ) {
              if (i.abRelation) {
                const n = xs._createFromRanges(
                  t.newRange._getTransformedByMoveOperation(e)
                );
                if (
                  "left" == i.abRelation.side &&
                  e.targetPosition.isEqual(t.newRange.start)
                )
                  return (
                    (t.newRange.start.path = i.abRelation.path),
                    (t.newRange.end = n.end),
                    [t]
                  );
                if (
                  "right" == i.abRelation.side &&
                  e.targetPosition.isEqual(t.newRange.end)
                )
                  return (
                    (t.newRange.start = n.start),
                    (t.newRange.end.path = i.abRelation.path),
                    [t]
                  );
              }
              t.newRange = xs._createFromRanges(
                t.newRange._getTransformedByMoveOperation(e)
              );
            }
            return [t];
          }),
          Od(ja, Va, (t, e, i) => {
            if (
              (t.oldRange &&
                (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)),
              t.newRange)
            ) {
              if (i.abRelation) {
                const n = t.newRange._getTransformedBySplitOperation(e);
                return (
                  t.newRange.start.isEqual(e.splitPosition) &&
                  i.abRelation.wasStartBeforeMergedElement
                    ? (t.newRange.start = _s._createAt(e.insertionPosition))
                    : t.newRange.start.isEqual(e.splitPosition) &&
                      !i.abRelation.wasInLeftElement &&
                      (t.newRange.start = _s._createAt(e.moveTargetPosition)),
                  t.newRange.end.isEqual(e.splitPosition) &&
                  i.abRelation.wasInRightElement
                    ? (t.newRange.end = _s._createAt(e.moveTargetPosition))
                    : t.newRange.end.isEqual(e.splitPosition) &&
                      i.abRelation.wasEndBeforeMergedElement
                    ? (t.newRange.end = _s._createAt(e.insertionPosition))
                    : (t.newRange.end = n.end),
                  [t]
                );
              }
              t.newRange = t.newRange._getTransformedBySplitOperation(e);
            }
            return [t];
          }),
          Od(
            Ba,
            La,
            (t, e) => (
              t.sourcePosition.hasSameParentAs(e.position) &&
                (t.howMany += e.howMany),
              (t.sourcePosition =
                t.sourcePosition._getTransformedByInsertOperation(e)),
              (t.targetPosition =
                t.targetPosition._getTransformedByInsertOperation(e)),
              [t]
            )
          ),
          Od(Ba, Ba, (t, e, i) => {
            if (
              t.sourcePosition.isEqual(e.sourcePosition) &&
              t.targetPosition.isEqual(e.targetPosition)
            ) {
              if (i.bWasUndone) {
                const i = e.graveyardPosition.path.slice();
                return (
                  i.push(0),
                  (t.sourcePosition = new _s(e.graveyardPosition.root, i)),
                  (t.howMany = 0),
                  [t]
                );
              }
              return [new rl(0)];
            }
            if (
              t.sourcePosition.isEqual(e.sourcePosition) &&
              !t.targetPosition.isEqual(e.targetPosition) &&
              !i.bWasUndone &&
              "splitAtSource" != i.abRelation
            ) {
              const n = "$graveyard" == t.targetPosition.root.rootName,
                o = "$graveyard" == e.targetPosition.root.rootName,
                r = n && !o;
              if ((o && !n) || (!r && i.aIsStrong)) {
                const i = e.targetPosition._getTransformedByMergeOperation(e),
                  n = t.targetPosition._getTransformedByMergeOperation(e);
                return [new Ra(i, t.howMany, n, 0)];
              }
              return [new rl(0)];
            }
            return (
              t.sourcePosition.hasSameParentAs(e.targetPosition) &&
                (t.howMany += e.howMany),
              (t.sourcePosition =
                t.sourcePosition._getTransformedByMergeOperation(e)),
              (t.targetPosition =
                t.targetPosition._getTransformedByMergeOperation(e)),
              (t.graveyardPosition.isEqual(e.graveyardPosition) &&
                i.aIsStrong) ||
                (t.graveyardPosition =
                  t.graveyardPosition._getTransformedByMergeOperation(e)),
              [t]
            );
          }),
          Od(Ba, Ra, (t, e, i) => {
            const n = xs._createFromPositionAndShift(
              e.sourcePosition,
              e.howMany
            );
            return "remove" == e.type &&
              !i.bWasUndone &&
              !i.forceWeakRemove &&
              t.deletionPosition.hasSameParentAs(e.sourcePosition) &&
              n.containsPosition(t.sourcePosition)
              ? [new rl(0)]
              : (t.sourcePosition.hasSameParentAs(e.targetPosition) &&
                  (t.howMany += e.howMany),
                t.sourcePosition.hasSameParentAs(e.sourcePosition) &&
                  (t.howMany -= e.howMany),
                (t.sourcePosition =
                  t.sourcePosition._getTransformedByMoveOperation(e)),
                (t.targetPosition =
                  t.targetPosition._getTransformedByMoveOperation(e)),
                t.graveyardPosition.isEqual(e.targetPosition) ||
                  (t.graveyardPosition =
                    t.graveyardPosition._getTransformedByMoveOperation(e)),
                [t]);
          }),
          Od(Ba, Va, (t, e, i) => {
            if (
              (e.graveyardPosition &&
                ((t.graveyardPosition =
                  t.graveyardPosition._getTransformedByDeletion(
                    e.graveyardPosition,
                    1
                  )),
                t.deletionPosition.isEqual(e.graveyardPosition) &&
                  (t.howMany = e.howMany)),
              t.targetPosition.isEqual(e.splitPosition))
            ) {
              const n = 0 != e.howMany,
                o =
                  e.graveyardPosition &&
                  t.deletionPosition.isEqual(e.graveyardPosition);
              if (n || o || "mergeTargetNotMoved" == i.abRelation)
                return (
                  (t.sourcePosition =
                    t.sourcePosition._getTransformedBySplitOperation(e)),
                  [t]
                );
            }
            if (t.sourcePosition.isEqual(e.splitPosition)) {
              if ("mergeSourceNotMoved" == i.abRelation)
                return (
                  (t.howMany = 0),
                  (t.targetPosition =
                    t.targetPosition._getTransformedBySplitOperation(e)),
                  [t]
                );
              if (
                "mergeSameElement" == i.abRelation ||
                t.sourcePosition.offset > 0
              )
                return (
                  (t.sourcePosition = e.moveTargetPosition.clone()),
                  (t.targetPosition =
                    t.targetPosition._getTransformedBySplitOperation(e)),
                  [t]
                );
            }
            return (
              t.sourcePosition.hasSameParentAs(e.splitPosition) &&
                (t.howMany = e.splitPosition.offset),
              (t.sourcePosition =
                t.sourcePosition._getTransformedBySplitOperation(e)),
              (t.targetPosition =
                t.targetPosition._getTransformedBySplitOperation(e)),
              [t]
            );
          }),
          Od(Ra, La, (t, e) => {
            const i = xs
              ._createFromPositionAndShift(t.sourcePosition, t.howMany)
              ._getTransformedByInsertOperation(e, !1)[0];
            return (
              (t.sourcePosition = i.start),
              (t.howMany = i.end.offset - i.start.offset),
              t.targetPosition.isEqual(e.position) ||
                (t.targetPosition =
                  t.targetPosition._getTransformedByInsertOperation(e)),
              [t]
            );
          }),
          Od(Ra, Ra, (t, e, i) => {
            const n = xs._createFromPositionAndShift(
                t.sourcePosition,
                t.howMany
              ),
              o = xs._createFromPositionAndShift(e.sourcePosition, e.howMany);
            let r,
              s = i.aIsStrong,
              a = !i.aIsStrong;
            if (
              ("insertBefore" == i.abRelation || "insertAfter" == i.baRelation
                ? (a = !0)
                : ("insertAfter" != i.abRelation &&
                    "insertBefore" != i.baRelation) ||
                  (a = !1),
              (r =
                t.targetPosition.isEqual(e.targetPosition) && a
                  ? t.targetPosition._getTransformedByDeletion(
                      e.sourcePosition,
                      e.howMany
                    )
                  : t.targetPosition._getTransformedByMove(
                      e.sourcePosition,
                      e.targetPosition,
                      e.howMany
                    )),
              Vd(t, e) && Vd(e, t))
            )
              return [e.getReversed()];
            if (n.containsPosition(e.targetPosition) && n.containsRange(o, !0))
              return (
                (n.start = n.start._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany
                )),
                (n.end = n.end._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany
                )),
                Fd([n], r)
              );
            if (o.containsPosition(t.targetPosition) && o.containsRange(n, !0))
              return (
                (n.start = n.start._getCombined(
                  e.sourcePosition,
                  e.getMovedRangeStart()
                )),
                (n.end = n.end._getCombined(
                  e.sourcePosition,
                  e.getMovedRangeStart()
                )),
                Fd([n], r)
              );
            const l = Si(
              t.sourcePosition.getParentPath(),
              e.sourcePosition.getParentPath()
            );
            if ("prefix" == l || "extension" == l)
              return (
                (n.start = n.start._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany
                )),
                (n.end = n.end._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany
                )),
                Fd([n], r)
              );
            "remove" != t.type ||
            "remove" == e.type ||
            i.aWasUndone ||
            i.forceWeakRemove
              ? "remove" == t.type ||
                "remove" != e.type ||
                i.bWasUndone ||
                i.forceWeakRemove ||
                (s = !1)
              : (s = !0);
            const c = [],
              d = n.getDifference(o);
            for (const t of d) {
              (t.start = t.start._getTransformedByDeletion(
                e.sourcePosition,
                e.howMany
              )),
                (t.end = t.end._getTransformedByDeletion(
                  e.sourcePosition,
                  e.howMany
                ));
              const i =
                  "same" ==
                  Si(
                    t.start.getParentPath(),
                    e.getMovedRangeStart().getParentPath()
                  ),
                n = t._getTransformedByInsertion(
                  e.getMovedRangeStart(),
                  e.howMany,
                  i
                );
              c.push(...n);
            }
            const h = n.getIntersection(o);
            return (
              null !== h &&
                s &&
                ((h.start = h.start._getCombined(
                  e.sourcePosition,
                  e.getMovedRangeStart()
                )),
                (h.end = h.end._getCombined(
                  e.sourcePosition,
                  e.getMovedRangeStart()
                )),
                0 === c.length
                  ? c.push(h)
                  : 1 == c.length
                  ? o.start.isBefore(n.start) || o.start.isEqual(n.start)
                    ? c.unshift(h)
                    : c.push(h)
                  : c.splice(1, 0, h)),
              0 === c.length ? [new rl(t.baseVersion)] : Fd(c, r)
            );
          }),
          Od(Ra, Va, (t, e, i) => {
            let n = t.targetPosition.clone();
            (t.targetPosition.isEqual(e.insertionPosition) &&
              e.graveyardPosition &&
              "moveTargetAfter" != i.abRelation) ||
              (n = t.targetPosition._getTransformedBySplitOperation(e));
            const o = xs._createFromPositionAndShift(
              t.sourcePosition,
              t.howMany
            );
            if (o.end.isEqual(e.insertionPosition))
              return (
                e.graveyardPosition || t.howMany++, (t.targetPosition = n), [t]
              );
            if (
              o.start.hasSameParentAs(e.splitPosition) &&
              o.containsPosition(e.splitPosition)
            ) {
              let t = new xs(e.splitPosition, o.end);
              return (
                (t = t._getTransformedBySplitOperation(e)),
                Fd([new xs(o.start, e.splitPosition), t], n)
              );
            }
            t.targetPosition.isEqual(e.splitPosition) &&
              "insertAtSource" == i.abRelation &&
              (n = e.moveTargetPosition),
              t.targetPosition.isEqual(e.insertionPosition) &&
                "insertBetween" == i.abRelation &&
                (n = t.targetPosition);
            const r = [o._getTransformedBySplitOperation(e)];
            if (e.graveyardPosition) {
              const n =
                o.start.isEqual(e.graveyardPosition) ||
                o.containsPosition(e.graveyardPosition);
              t.howMany > 1 &&
                n &&
                !i.aWasUndone &&
                r.push(xs._createFromPositionAndShift(e.insertionPosition, 1));
            }
            return Fd(r, n);
          }),
          Od(Ra, Ba, (t, e, i) => {
            const n = xs._createFromPositionAndShift(
              t.sourcePosition,
              t.howMany
            );
            if (
              e.deletionPosition.hasSameParentAs(t.sourcePosition) &&
              n.containsPosition(e.sourcePosition)
            )
              if ("remove" != t.type || i.forceWeakRemove) {
                if (1 == t.howMany)
                  return i.bWasUndone
                    ? ((t.sourcePosition = e.graveyardPosition.clone()),
                      (t.targetPosition =
                        t.targetPosition._getTransformedByMergeOperation(e)),
                      [t])
                    : [new rl(0)];
              } else if (!i.aWasUndone) {
                const i = [];
                let n = e.graveyardPosition.clone(),
                  o = e.targetPosition._getTransformedByMergeOperation(e);
                t.howMany > 1 &&
                  (i.push(
                    new Ra(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)
                  ),
                  (n = n._getTransformedByMove(
                    t.sourcePosition,
                    t.targetPosition,
                    t.howMany - 1
                  )),
                  (o = o._getTransformedByMove(
                    t.sourcePosition,
                    t.targetPosition,
                    t.howMany - 1
                  )));
                const r = e.deletionPosition._getCombined(
                    t.sourcePosition,
                    t.targetPosition
                  ),
                  s = new Ra(n, 1, r, 0),
                  a = s.getMovedRangeStart().path.slice();
                a.push(0);
                const l = new _s(s.targetPosition.root, a);
                o = o._getTransformedByMove(n, r, 1);
                const c = new Ra(o, e.howMany, l, 0);
                return i.push(s), i.push(c), i;
              }
            const o = xs
              ._createFromPositionAndShift(t.sourcePosition, t.howMany)
              ._getTransformedByMergeOperation(e);
            return (
              (t.sourcePosition = o.start),
              (t.howMany = o.end.offset - o.start.offset),
              (t.targetPosition =
                t.targetPosition._getTransformedByMergeOperation(e)),
              [t]
            );
          }),
          Od(
            Da,
            La,
            (t, e) => (
              (t.position = t.position._getTransformedByInsertOperation(e)), [t]
            )
          ),
          Od(Da, Ba, (t, e) =>
            t.position.isEqual(e.deletionPosition)
              ? ((t.position = e.graveyardPosition.clone()),
                (t.position.stickiness = "toNext"),
                [t])
              : ((t.position = t.position._getTransformedByMergeOperation(e)),
                [t])
          ),
          Od(
            Da,
            Ra,
            (t, e) => (
              (t.position = t.position._getTransformedByMoveOperation(e)), [t]
            )
          ),
          Od(Da, Da, (t, e, i) => {
            if (t.position.isEqual(e.position)) {
              if (!i.aIsStrong) return [new rl(0)];
              t.oldName = e.newName;
            }
            return [t];
          }),
          Od(Da, Va, (t, e) => {
            if (
              "same" == Si(t.position.path, e.splitPosition.getParentPath()) &&
              !e.graveyardPosition
            ) {
              const e = new Da(
                t.position.getShiftedBy(1),
                t.oldName,
                t.newName,
                0
              );
              return [t, e];
            }
            return (
              (t.position = t.position._getTransformedBySplitOperation(e)), [t]
            );
          }),
          Od(za, za, (t, e, i) => {
            if (t.root === e.root && t.key === e.key) {
              if (!i.aIsStrong || t.newValue === e.newValue) return [new rl(0)];
              t.oldValue = e.newValue;
            }
            return [t];
          }),
          Od(
            Va,
            La,
            (t, e) => (
              t.splitPosition.hasSameParentAs(e.position) &&
                t.splitPosition.offset < e.position.offset &&
                (t.howMany += e.howMany),
              (t.splitPosition =
                t.splitPosition._getTransformedByInsertOperation(e)),
              (t.insertionPosition = Va.getInsertionPosition(t.splitPosition)),
              [t]
            )
          ),
          Od(Va, Ba, (t, e, i) => {
            if (
              !t.graveyardPosition &&
              !i.bWasUndone &&
              t.splitPosition.hasSameParentAs(e.sourcePosition)
            ) {
              const i = e.graveyardPosition.path.slice();
              i.push(0);
              const n = new _s(e.graveyardPosition.root, i),
                o = Va.getInsertionPosition(
                  new _s(e.graveyardPosition.root, i)
                ),
                r = new Va(n, 0, null, 0);
              return (
                (r.insertionPosition = o),
                (t.splitPosition =
                  t.splitPosition._getTransformedByMergeOperation(e)),
                (t.insertionPosition = Va.getInsertionPosition(
                  t.splitPosition
                )),
                (t.graveyardPosition = r.insertionPosition.clone()),
                (t.graveyardPosition.stickiness = "toNext"),
                [r, t]
              );
            }
            return (
              t.splitPosition.hasSameParentAs(e.deletionPosition) &&
                !t.splitPosition.isAfter(e.deletionPosition) &&
                t.howMany--,
              t.splitPosition.hasSameParentAs(e.targetPosition) &&
                (t.howMany += e.howMany),
              (t.splitPosition =
                t.splitPosition._getTransformedByMergeOperation(e)),
              (t.insertionPosition = Va.getInsertionPosition(t.splitPosition)),
              t.graveyardPosition &&
                (t.graveyardPosition =
                  t.graveyardPosition._getTransformedByMergeOperation(e)),
              [t]
            );
          }),
          Od(Va, Ra, (t, e, i) => {
            const n = xs._createFromPositionAndShift(
              e.sourcePosition,
              e.howMany
            );
            if (t.graveyardPosition) {
              const o =
                n.start.isEqual(t.graveyardPosition) ||
                n.containsPosition(t.graveyardPosition);
              if (!i.bWasUndone && o) {
                const i = t.splitPosition._getTransformedByMoveOperation(e),
                  n = t.graveyardPosition._getTransformedByMoveOperation(e),
                  o = n.path.slice();
                o.push(0);
                const r = new _s(n.root, o);
                return [new Ra(i, t.howMany, r, 0)];
              }
              t.graveyardPosition =
                t.graveyardPosition._getTransformedByMoveOperation(e);
            }
            if (
              t.splitPosition.hasSameParentAs(e.sourcePosition) &&
              n.containsPosition(t.splitPosition)
            ) {
              const i =
                e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
              return (
                (t.howMany -= i),
                t.splitPosition.hasSameParentAs(e.targetPosition) &&
                  t.splitPosition.offset < e.targetPosition.offset &&
                  (t.howMany += e.howMany),
                (t.splitPosition = e.sourcePosition.clone()),
                (t.insertionPosition = Va.getInsertionPosition(
                  t.splitPosition
                )),
                [t]
              );
            }
            return !t.splitPosition.isEqual(e.targetPosition) ||
              ("insertAtSource" != i.baRelation &&
                "splitBefore" != i.abRelation)
              ? (e.sourcePosition.isEqual(e.targetPosition) ||
                  (t.splitPosition.hasSameParentAs(e.sourcePosition) &&
                    t.splitPosition.offset <= e.sourcePosition.offset &&
                    (t.howMany -= e.howMany),
                  t.splitPosition.hasSameParentAs(e.targetPosition) &&
                    t.splitPosition.offset < e.targetPosition.offset &&
                    (t.howMany += e.howMany)),
                (t.splitPosition.stickiness = "toNone"),
                (t.splitPosition =
                  t.splitPosition._getTransformedByMoveOperation(e)),
                (t.splitPosition.stickiness = "toNext"),
                t.graveyardPosition
                  ? (t.insertionPosition =
                      t.insertionPosition._getTransformedByMoveOperation(e))
                  : (t.insertionPosition = Va.getInsertionPosition(
                      t.splitPosition
                    )),
                [t])
              : ((t.howMany += e.howMany),
                (t.splitPosition = t.splitPosition._getTransformedByDeletion(
                  e.sourcePosition,
                  e.howMany
                )),
                (t.insertionPosition = Va.getInsertionPosition(
                  t.splitPosition
                )),
                [t]);
          }),
          Od(Va, Va, (t, e, i) => {
            if (t.splitPosition.isEqual(e.splitPosition)) {
              if (!t.graveyardPosition && !e.graveyardPosition)
                return [new rl(0)];
              if (
                t.graveyardPosition &&
                e.graveyardPosition &&
                t.graveyardPosition.isEqual(e.graveyardPosition)
              )
                return [new rl(0)];
              if ("splitBefore" == i.abRelation)
                return (
                  (t.howMany = 0),
                  (t.graveyardPosition =
                    t.graveyardPosition._getTransformedBySplitOperation(e)),
                  [t]
                );
            }
            if (
              t.graveyardPosition &&
              e.graveyardPosition &&
              t.graveyardPosition.isEqual(e.graveyardPosition)
            ) {
              const n = "$graveyard" == t.splitPosition.root.rootName,
                o = "$graveyard" == e.splitPosition.root.rootName,
                r = n && !o;
              if ((o && !n) || (!r && i.aIsStrong)) {
                const i = [];
                return (
                  e.howMany &&
                    i.push(
                      new Ra(
                        e.moveTargetPosition,
                        e.howMany,
                        e.splitPosition,
                        0
                      )
                    ),
                  t.howMany &&
                    i.push(
                      new Ra(
                        t.splitPosition,
                        t.howMany,
                        t.moveTargetPosition,
                        0
                      )
                    ),
                  i
                );
              }
              return [new rl(0)];
            }
            if (
              (t.graveyardPosition &&
                (t.graveyardPosition =
                  t.graveyardPosition._getTransformedBySplitOperation(e)),
              t.splitPosition.isEqual(e.insertionPosition) &&
                "splitBefore" == i.abRelation)
            )
              return t.howMany++, [t];
            if (
              e.splitPosition.isEqual(t.insertionPosition) &&
              "splitBefore" == i.baRelation
            ) {
              const i = e.insertionPosition.path.slice();
              i.push(0);
              const n = new _s(e.insertionPosition.root, i);
              return [t, new Ra(t.insertionPosition, 1, n, 0)];
            }
            return (
              t.splitPosition.hasSameParentAs(e.splitPosition) &&
                t.splitPosition.offset < e.splitPosition.offset &&
                (t.howMany -= e.howMany),
              (t.splitPosition =
                t.splitPosition._getTransformedBySplitOperation(e)),
              (t.insertionPosition = Va.getInsertionPosition(t.splitPosition)),
              [t]
            );
          });
        class Hd extends ed {
          constructor(t) {
            super(t),
              (this._stack = []),
              (this._createdBatches = new WeakSet()),
              this.refresh();
          }
          refresh() {
            this.isEnabled = this._stack.length > 0;
          }
          addBatch(t) {
            const e = this.editor.model.document.selection,
              i = {
                ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
                isBackward: e.isBackward,
              };
            this._stack.push({ batch: t, selection: i }), this.refresh();
          }
          clearStack() {
            (this._stack = []), this.refresh();
          }
          _restoreSelection(t, e, i) {
            const n = this.editor.model,
              o = n.document,
              r = [];
            for (const e of t) {
              const t = Ud(e, i).find((t) => t.start.root != o.graveyard);
              t && r.push(t);
            }
            r.length &&
              n.change((t) => {
                t.setSelection(r, { backward: e });
              });
          }
          _undo(t, e) {
            const i = this.editor.model,
              n = i.document;
            this._createdBatches.add(e);
            const o = t.operations.slice().filter((t) => t.isDocumentOperation);
            o.reverse();
            for (const t of o) {
              const o = t.baseVersion + 1,
                r = Array.from(n.history.getOperations(o)),
                s = Ld([t.getReversed()], r, {
                  useRelations: !0,
                  document: this.editor.model.document,
                  padWithNoOps: !1,
                  forceWeakRemove: !0,
                }).operationsA;
              for (const o of s)
                e.addOperation(o),
                  i.applyOperation(o),
                  n.history.setOperationAsUndone(t, o);
            }
          }
        }
        function Ud(t, e) {
          const i = t.getTransformedByOperations(e);
          i.sort((t, e) => (t.start.isBefore(e.start) ? -1 : 1));
          for (let t = 1; t < i.length; t++) {
            const e = i[t - 1],
              n = i[t];
            e.end.isTouching(n.start) && ((e.end = n.end), i.splice(t, 1), t--);
          }
          return i;
        }
        class Wd extends Hd {
          execute(t = null) {
            const e = t
                ? this._stack.findIndex((e) => e.batch == t)
                : this._stack.length - 1,
              i = this._stack.splice(e, 1)[0],
              n = this.editor.model.createBatch("transparent");
            this.editor.model.enqueueChange(n, () => {
              this._undo(i.batch, n);
              const t = this.editor.model.document.history.getOperations(
                i.batch.baseVersion
              );
              this._restoreSelection(
                i.selection.ranges,
                i.selection.isBackward,
                t
              ),
                this.fire("revert", i.batch, n);
            }),
              this.refresh();
          }
        }
        class qd extends Hd {
          execute() {
            const t = this._stack.pop(),
              e = this.editor.model.createBatch("transparent");
            this.editor.model.enqueueChange(e, () => {
              const i =
                  t.batch.operations[t.batch.operations.length - 1]
                    .baseVersion + 1,
                n = this.editor.model.document.history.getOperations(i);
              this._restoreSelection(
                t.selection.ranges,
                t.selection.isBackward,
                n
              ),
                this._undo(t.batch, e);
            }),
              this.refresh();
          }
        }
        class Yd extends Gc {
          static get pluginName() {
            return "UndoEditing";
          }
          constructor(t) {
            super(t), (this._batchRegistry = new WeakSet());
          }
          init() {
            const t = this.editor;
            (this._undoCommand = new Wd(t)),
              (this._redoCommand = new qd(t)),
              t.commands.add("undo", this._undoCommand),
              t.commands.add("redo", this._redoCommand),
              this.listenTo(
                t.model,
                "applyOperation",
                (t, e) => {
                  const i = e[0];
                  if (!i.isDocumentOperation) return;
                  const n = i.batch,
                    o = this._redoCommand._createdBatches.has(n),
                    r = this._undoCommand._createdBatches.has(n);
                  this._batchRegistry.has(n) ||
                    ("transparent" == n.type && !o && !r) ||
                    (o
                      ? this._undoCommand.addBatch(n)
                      : r ||
                        (this._undoCommand.addBatch(n),
                        this._redoCommand.clearStack()),
                    this._batchRegistry.add(n));
                },
                { priority: "highest" }
              ),
              this.listenTo(this._undoCommand, "revert", (t, e, i) => {
                this._redoCommand.addBatch(i);
              }),
              t.keystrokes.set("CTRL+Z", "undo"),
              t.keystrokes.set("CTRL+Y", "redo"),
              t.keystrokes.set("CTRL+SHIFT+Z", "redo");
          }
        }
        var $d =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
          Jd =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
        class Gd extends Gc {
          init() {
            const t = this.editor,
              e = t.locale,
              i = t.t,
              n = "ltr" == e.uiLanguageDirection ? $d : Jd,
              o = "ltr" == e.uiLanguageDirection ? Jd : $d;
            this._addButton("undo", i("Undo"), "CTRL+Z", n),
              this._addButton("redo", i("Redo"), "CTRL+Y", o);
          }
          _addButton(t, e, i, n) {
            const o = this.editor;
            o.ui.componentFactory.add(t, (r) => {
              const s = o.commands.get(t),
                a = new Oc(r);
              return (
                a.set({ label: e, icon: n, keystroke: i, tooltip: !0 }),
                a.bind("isEnabled").to(s, "isEnabled"),
                this.listenTo(a, "execute", () => {
                  o.execute(t), o.editing.view.focus();
                }),
                a
              );
            });
          }
        }
        class Qd extends Gc {
          static get requires() {
            return [Yd, Gd];
          }
          static get pluginName() {
            return "Undo";
          }
        }
        class Xd {
          constructor(t) {
            this.context = t;
          }
          destroy() {
            this.stopListening();
          }
          static get isContextPlugin() {
            return !0;
          }
        }
        yi(Xd, Hn);
        class Kd extends Xd {
          static get pluginName() {
            return "PendingActions";
          }
          init() {
            this.set("hasAny", !1),
              (this._actions = new xi({ idProperty: "_id" })),
              this._actions.delegate("add", "remove").to(this);
          }
          add(t) {
            if ("string" != typeof t)
              throw new hi.b(
                "pendingactions-add-invalid-message: The message must be a string.",
                this
              );
            const e = Object.create(Hn);
            return (
              e.set("message", t), this._actions.add(e), (this.hasAny = !0), e
            );
          }
          remove(t) {
            this._actions.remove(t), (this.hasAny = !!this._actions.length);
          }
          get first() {
            return this._actions.get(0);
          }
          [Symbol.iterator]() {
            return this._actions[Symbol.iterator]();
          }
        }
        class Zd {
          constructor() {
            const t = new window.FileReader();
            (this._reader = t),
              (this._data = void 0),
              this.set("loaded", 0),
              (t.onprogress = (t) => {
                this.loaded = t.loaded;
              });
          }
          get error() {
            return this._reader.error;
          }
          get data() {
            return this._data;
          }
          read(t) {
            const e = this._reader;
            return (
              (this.total = t.size),
              new Promise((i, n) => {
                (e.onload = () => {
                  const t = e.result;
                  (this._data = t), i(t);
                }),
                  (e.onerror = () => {
                    n("error");
                  }),
                  (e.onabort = () => {
                    n("aborted");
                  }),
                  this._reader.readAsDataURL(t);
              })
            );
          }
          abort() {
            this._reader.abort();
          }
        }
        yi(Zd, Hn);
        class th extends Gc {
          static get pluginName() {
            return "FileRepository";
          }
          static get requires() {
            return [Kd];
          }
          init() {
            (this.loaders = new xi()),
              this.loaders.on("add", () => this._updatePendingAction()),
              this.loaders.on("remove", () => this._updatePendingAction()),
              (this._loadersMap = new Map()),
              (this._pendingAction = null),
              this.set("uploaded", 0),
              this.set("uploadTotal", null),
              this.bind("uploadedPercent").to(
                this,
                "uploaded",
                this,
                "uploadTotal",
                (t, e) => (e ? (t / e) * 100 : 0)
              );
          }
          getLoader(t) {
            return this._loadersMap.get(t) || null;
          }
          createLoader(t) {
            if (!this.createUploadAdapter)
              return (
                console.warn(
                  Object(hi.a)(
                    "filerepository-no-upload-adapter: Upload adapter is not defined."
                  )
                ),
                null
              );
            const e = new eh(Promise.resolve(t), this.createUploadAdapter);
            return (
              this.loaders.add(e),
              this._loadersMap.set(t, e),
              t instanceof Promise &&
                e.file
                  .then((t) => {
                    this._loadersMap.set(t, e);
                  })
                  .catch(() => {}),
              e.on("change:uploaded", () => {
                let t = 0;
                for (const e of this.loaders) t += e.uploaded;
                this.uploaded = t;
              }),
              e.on("change:uploadTotal", () => {
                let t = 0;
                for (const e of this.loaders)
                  e.uploadTotal && (t += e.uploadTotal);
                this.uploadTotal = t;
              }),
              e
            );
          }
          destroyLoader(t) {
            const e = t instanceof eh ? t : this.getLoader(t);
            e._destroy(),
              this.loaders.remove(e),
              this._loadersMap.forEach((t, i) => {
                t === e && this._loadersMap.delete(i);
              });
          }
          _updatePendingAction() {
            const t = this.editor.plugins.get(Kd);
            if (this.loaders.length) {
              if (!this._pendingAction) {
                const e = this.editor.t,
                  i = (t) => `${e("Upload in progress")} ${parseInt(t)}%.`;
                (this._pendingAction = t.add(i(this.uploadedPercent))),
                  this._pendingAction
                    .bind("message")
                    .to(this, "uploadedPercent", i);
              }
            } else t.remove(this._pendingAction), (this._pendingAction = null);
          }
        }
        yi(th, Hn);
        class eh {
          constructor(t, e) {
            (this.id = ci()),
              (this._filePromiseWrapper = this._createFilePromiseWrapper(t)),
              (this._adapter = e(this)),
              (this._reader = new Zd()),
              this.set("status", "idle"),
              this.set("uploaded", 0),
              this.set("uploadTotal", null),
              this.bind("uploadedPercent").to(
                this,
                "uploaded",
                this,
                "uploadTotal",
                (t, e) => (e ? (t / e) * 100 : 0)
              ),
              this.set("uploadResponse", null);
          }
          get file() {
            return this._filePromiseWrapper
              ? this._filePromiseWrapper.promise.then((t) =>
                  this._filePromiseWrapper ? t : null
                )
              : Promise.resolve(null);
          }
          get data() {
            return this._reader.data;
          }
          read() {
            if ("idle" != this.status)
              throw new hi.b(
                "filerepository-read-wrong-status: You cannot call read if the status is different than idle.",
                this
              );
            return (
              (this.status = "reading"),
              this.file
                .then((t) => this._reader.read(t))
                .then((t) => {
                  if ("reading" !== this.status) throw this.status;
                  return (this.status = "idle"), t;
                })
                .catch((t) => {
                  if ("aborted" === t)
                    throw ((this.status = "aborted"), "aborted");
                  throw (
                    ((this.status = "error"),
                    this._reader.error ? this._reader.error : t)
                  );
                })
            );
          }
          upload() {
            if ("idle" != this.status)
              throw new hi.b(
                "filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.",
                this
              );
            return (
              (this.status = "uploading"),
              this.file
                .then(() => this._adapter.upload())
                .then(
                  (t) => ((this.uploadResponse = t), (this.status = "idle"), t)
                )
                .catch((t) => {
                  if ("aborted" === this.status) throw "aborted";
                  throw ((this.status = "error"), t);
                })
            );
          }
          abort() {
            const t = this.status;
            (this.status = "aborted"),
              this._filePromiseWrapper.isFulfilled
                ? "reading" == t
                  ? this._reader.abort()
                  : "uploading" == t &&
                    this._adapter.abort &&
                    this._adapter.abort()
                : (this._filePromiseWrapper.promise.catch(() => {}),
                  this._filePromiseWrapper.rejecter("aborted")),
              this._destroy();
          }
          _destroy() {
            (this._filePromiseWrapper = void 0),
              (this._reader = void 0),
              (this._adapter = void 0),
              (this.uploadResponse = void 0);
          }
          _createFilePromiseWrapper(t) {
            const e = {};
            return (
              (e.promise = new Promise((i, n) => {
                (e.rejecter = n),
                  (e.isFulfilled = !1),
                  t
                    .then((t) => {
                      (e.isFulfilled = !0), i(t);
                    })
                    .catch((t) => {
                      (e.isFulfilled = !0), n(t);
                    });
              })),
              e
            );
          }
        }
        yi(eh, Hn);
        function ih() {
          let t = (function (t) {
            t = t.toLowerCase();
            const e = document.cookie.split(";");
            for (const i of e) {
              const e = i.split("=");
              if (decodeURIComponent(e[0].trim().toLowerCase()) === t)
                return decodeURIComponent(e[1]);
            }
            return null;
          })("ckCsrfToken");
          var e, i;
          return (
            (t && 40 == t.length) ||
              ((t = (function (t) {
                let e = "";
                const i = new Uint8Array(t);
                window.crypto.getRandomValues(i);
                for (let t = 0; t < i.length; t++) {
                  const n = "abcdefghijklmnopqrstuvwxyz0123456789".charAt(
                    i[t] % "abcdefghijklmnopqrstuvwxyz0123456789".length
                  );
                  e += Math.random() > 0.5 ? n.toUpperCase() : n;
                }
                return e;
              })(40)),
              (e = "ckCsrfToken"),
              (i = t),
              (document.cookie =
                encodeURIComponent(e) +
                "=" +
                encodeURIComponent(i) +
                ";path=/")),
            t
          );
        }
        class nh extends Gc {
          static get requires() {
            return [th];
          }
          static get pluginName() {
            return "CKFinderUploadAdapter";
          }
          init() {
            const t = this.editor.config.get("ckfinder.uploadUrl");
            t &&
              (this.editor.plugins.get(th).createUploadAdapter = (e) =>
                new oh(e, t, this.editor.t));
          }
        }
        class oh {
          constructor(t, e, i) {
            (this.loader = t), (this.url = e), (this.t = i);
          }
          upload() {
            return this.loader.file.then(
              (t) =>
                new Promise((e, i) => {
                  this._initRequest(),
                    this._initListeners(e, i, t),
                    this._sendRequest(t);
                })
            );
          }
          abort() {
            this.xhr && this.xhr.abort();
          }
          _initRequest() {
            const t = (this.xhr = new XMLHttpRequest());
            t.open("POST", this.url, !0), (t.responseType = "json");
          }
          _initListeners(t, e, i) {
            const n = this.xhr,
              o = this.loader,
              r = (0, this.t)("Cannot upload file:") + ` ${i.name}.`;
            n.addEventListener("error", () => e(r)),
              n.addEventListener("abort", () => e()),
              n.addEventListener("load", () => {
                const i = n.response;
                if (!i || !i.uploaded)
                  return e(
                    i && i.error && i.error.message ? i.error.message : r
                  );
                t({ default: i.url });
              }),
              n.upload &&
                n.upload.addEventListener("progress", (t) => {
                  t.lengthComputable &&
                    ((o.uploadTotal = t.total), (o.uploaded = t.loaded));
                });
          }
          _sendRequest(t) {
            const e = new FormData();
            e.append("upload", t),
              e.append("ckCsrfToken", ih()),
              this.xhr.send(e);
          }
        }
        class rh {
          static get pluginName() {
            return "BlockAutoformatEditing";
          }
          constructor(t, e, i) {
            let n,
              o = null;
            "function" == typeof i
              ? (n = i)
              : ((o = t.commands.get(i)),
                (n = () => {
                  t.execute(i);
                })),
              t.model.document.on("change", (i, r) => {
                if (o && !o.isEnabled) return;
                if ("transparent" == r.type) return;
                const s = Array.from(t.model.document.differ.getChanges()),
                  a = s[0];
                if (
                  1 != s.length ||
                  "insert" !== a.type ||
                  "$text" != a.name ||
                  1 != a.length
                )
                  return;
                const l = a.position.parent;
                if (!l.is("paragraph") || 1 !== l.childCount) return;
                const c = e.exec(l.getChild(0).data);
                c &&
                  t.model.enqueueChange((t) => {
                    const e = t.createPositionAt(l, 0),
                      i = t.createPositionAt(l, c[0].length),
                      o = new Rs(e, i);
                    !1 !== n({ match: c }) && t.remove(o), o.detach();
                  });
              });
          }
        }
        function sh(t, e) {
          let i = t.start;
          return {
            text: Array.from(t.getItems()).reduce(
              (t, n) =>
                n.is("text") || n.is("textProxy")
                  ? t + n.data
                  : ((i = e.createPositionAfter(n)), ""),
              ""
            ),
            range: e.createRange(i, t.end),
          };
        }
        class ah {
          static get pluginName() {
            return "InlineAutoformatEditing";
          }
          constructor(t, e, i) {
            let n, o, r, s;
            e instanceof RegExp ? (n = e) : (r = e),
              "string" == typeof i ? (o = i) : (s = i),
              (r =
                r ||
                ((t) => {
                  let e;
                  const i = [],
                    o = [];
                  for (; null !== (e = n.exec(t)) && !(e && e.length < 4); ) {
                    let { index: t, 1: n, 2: r, 3: s } = e;
                    const a = n + r + s;
                    t += e[0].length - a.length;
                    const l = [t, t + n.length],
                      c = [
                        t + n.length + r.length,
                        t + n.length + r.length + s.length,
                      ];
                    i.push(l),
                      i.push(c),
                      o.push([t + n.length, t + n.length + r.length]);
                  }
                  return { remove: i, format: o };
                })),
              (s =
                s ||
                ((e, i) => {
                  const n = t.model.schema.getValidRanges(i, o);
                  for (const t of n) e.setAttribute(o, !0, t);
                  e.removeSelectionAttribute(o);
                })),
              t.model.document.on("change", (e, i) => {
                if ("transparent" == i.type) return;
                const n = t.model,
                  o = n.document.selection;
                if (!o.isCollapsed) return;
                const a = Array.from(n.document.differ.getChanges()),
                  l = a[0];
                if (
                  1 != a.length ||
                  "insert" !== l.type ||
                  "$text" != l.name ||
                  1 != l.length
                )
                  return;
                const c = o.focus,
                  d = c.parent,
                  { text: h, range: u } = sh(
                    n.createRange(n.createPositionAt(d, 0), c),
                    n
                  ),
                  m = r(h),
                  g = lh(u.start, m.format, n),
                  f = lh(u.start, m.remove, n);
                g.length &&
                  f.length &&
                  n.enqueueChange((t) => {
                    if (!1 !== s(t, g))
                      for (const e of f.reverse()) t.remove(e);
                  });
              });
          }
        }
        function lh(t, e, i) {
          return e
            .filter((t) => void 0 !== t[0] && void 0 !== t[1])
            .map((e) =>
              i.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]))
            );
        }
        function ch(t, e) {
          return (i, n) => {
            if (!t.commands.get(e).isEnabled) return !1;
            const o = t.model.schema.getValidRanges(n, e);
            for (const t of o) i.setAttribute(e, !0, t);
            i.removeSelectionAttribute(e);
          };
        }
        class dh extends ed {
          constructor(t, e) {
            super(t), (this.attributeKey = e);
          }
          refresh() {
            const t = this.editor.model,
              e = t.document;
            (this.value = this._getValueFromFirstAllowedNode()),
              (this.isEnabled = t.schema.checkAttributeInSelection(
                e.selection,
                this.attributeKey
              ));
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.document.selection,
              n = void 0 === t.forceValue ? !this.value : t.forceValue;
            e.change((t) => {
              if (i.isCollapsed)
                n
                  ? t.setSelectionAttribute(this.attributeKey, !0)
                  : t.removeSelectionAttribute(this.attributeKey);
              else {
                const o = e.schema.getValidRanges(
                  i.getRanges(),
                  this.attributeKey
                );
                for (const e of o)
                  n
                    ? t.setAttribute(this.attributeKey, n, e)
                    : t.removeAttribute(this.attributeKey, e);
              }
            });
          }
          _getValueFromFirstAllowedNode() {
            const t = this.editor.model,
              e = t.schema,
              i = t.document.selection;
            if (i.isCollapsed) return i.hasAttribute(this.attributeKey);
            for (const t of i.getRanges())
              for (const i of t.getItems())
                if (e.checkAttribute(i, this.attributeKey))
                  return i.hasAttribute(this.attributeKey);
            return !1;
          }
        }
        class hh extends Gc {
          static get pluginName() {
            return "BoldEditing";
          }
          init() {
            const t = this.editor;
            t.model.schema.extend("$text", { allowAttributes: "bold" }),
              t.model.schema.setAttributeProperties("bold", {
                isFormatting: !0,
                copyOnEnter: !0,
              }),
              t.conversion.attributeToElement({
                model: "bold",
                view: "strong",
                upcastAlso: [
                  "b",
                  (t) => {
                    const e = t.getStyle("font-weight");
                    return e
                      ? "bold" == e || Number(e) >= 600
                        ? { name: !0, styles: ["font-weight"] }
                        : void 0
                      : null;
                  },
                ],
              }),
              t.commands.add("bold", new dh(t, "bold")),
              t.keystrokes.set("CTRL+B", "bold");
          }
        }
        class uh extends Gc {
          init() {
            const t = this.editor,
              e = t.t;
            t.ui.componentFactory.add("bold", (i) => {
              const n = t.commands.get("bold"),
                o = new Oc(i);
              return (
                o.set({
                  label: e("Bold"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
                  keystroke: "CTRL+B",
                  tooltip: !0,
                  isToggleable: !0,
                }),
                o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"),
                this.listenTo(o, "execute", () => {
                  t.execute("bold"), t.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        class mh extends Gc {
          static get pluginName() {
            return "ItalicEditing";
          }
          init() {
            const t = this.editor;
            t.model.schema.extend("$text", { allowAttributes: "italic" }),
              t.model.schema.setAttributeProperties("italic", {
                isFormatting: !0,
                copyOnEnter: !0,
              }),
              t.conversion.attributeToElement({
                model: "italic",
                view: "i",
                upcastAlso: ["em", { styles: { "font-style": "italic" } }],
              }),
              t.commands.add("italic", new dh(t, "italic")),
              t.keystrokes.set("CTRL+I", "italic");
          }
        }
        class gh extends Gc {
          init() {
            const t = this.editor,
              e = t.t;
            t.ui.componentFactory.add("italic", (i) => {
              const n = t.commands.get("italic"),
                o = new Oc(i);
              return (
                o.set({
                  label: e("Italic"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
                  keystroke: "CTRL+I",
                  tooltip: !0,
                  isToggleable: !0,
                }),
                o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"),
                this.listenTo(o, "execute", () => {
                  t.execute("italic"), t.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        function fh(t) {
          const e = t.next();
          return e.done ? null : e.value;
        }
        class ph extends ed {
          refresh() {
            (this.value = this._getValue()),
              (this.isEnabled = this._checkEnabled());
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.schema,
              n = e.document.selection,
              o = Array.from(n.getSelectedBlocks()),
              r = void 0 === t.forceValue ? !this.value : t.forceValue;
            e.change((t) => {
              if (r) {
                const e = o.filter((t) => bh(t) || _h(i, t));
                this._applyQuote(t, e);
              } else this._removeQuote(t, o.filter(bh));
            });
          }
          _getValue() {
            const t = fh(
              this.editor.model.document.selection.getSelectedBlocks()
            );
            return !(!t || !bh(t));
          }
          _checkEnabled() {
            if (this.value) return !0;
            const t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              i = fh(t.getSelectedBlocks());
            return !!i && _h(e, i);
          }
          _removeQuote(t, e) {
            wh(t, e)
              .reverse()
              .forEach((e) => {
                if (e.start.isAtStart && e.end.isAtEnd)
                  return void t.unwrap(e.start.parent);
                if (e.start.isAtStart) {
                  const i = t.createPositionBefore(e.start.parent);
                  return void t.move(e, i);
                }
                e.end.isAtEnd || t.split(e.end);
                const i = t.createPositionAfter(e.end.parent);
                t.move(e, i);
              });
          }
          _applyQuote(t, e) {
            const i = [];
            wh(t, e)
              .reverse()
              .forEach((e) => {
                let n = bh(e.start);
                n || ((n = t.createElement("blockQuote")), t.wrap(e, n)),
                  i.push(n);
              }),
              i
                .reverse()
                .reduce((e, i) =>
                  e.nextSibling == i
                    ? (t.merge(t.createPositionAfter(e)), e)
                    : i
                );
          }
        }
        function bh(t) {
          return "blockQuote" == t.parent.name ? t.parent : null;
        }
        function wh(t, e) {
          let i,
            n = 0;
          const o = [];
          for (; n < e.length; ) {
            const r = e[n],
              s = e[n + 1];
            i || (i = t.createPositionBefore(r)),
              (s && r.nextSibling == s) ||
                (o.push(t.createRange(i, t.createPositionAfter(r))),
                (i = null)),
              n++;
          }
          return o;
        }
        function _h(t, e) {
          const i = t.checkChild(e.parent, "blockQuote"),
            n = t.checkChild(["$root", "blockQuote"], e);
          return i && n;
        }
        class kh extends Gc {
          static get pluginName() {
            return "BlockQuoteEditing";
          }
          init() {
            const t = this.editor,
              e = t.model.schema;
            t.commands.add("blockQuote", new ph(t)),
              e.register("blockQuote", {
                allowWhere: "$block",
                allowContentOf: "$root",
              }),
              e.addChildCheck((t, e) => {
                if (t.endsWith("blockQuote") && "blockQuote" == e.name)
                  return !1;
              }),
              t.conversion.elementToElement({
                model: "blockQuote",
                view: "blockquote",
              }),
              t.model.document.registerPostFixer((i) => {
                const n = t.model.document.differ.getChanges();
                for (const t of n)
                  if ("insert" == t.type) {
                    const n = t.position.nodeAfter;
                    if (!n) continue;
                    if (n.is("blockQuote") && n.isEmpty) return i.remove(n), !0;
                    if (n.is("blockQuote") && !e.checkChild(t.position, n))
                      return i.unwrap(n), !0;
                    if (n.is("element")) {
                      const t = i.createRangeIn(n);
                      for (const n of t.getItems())
                        if (
                          n.is("blockQuote") &&
                          !e.checkChild(i.createPositionBefore(n), n)
                        )
                          return i.unwrap(n), !0;
                    }
                  } else if ("remove" == t.type) {
                    const e = t.position.parent;
                    if (e.is("blockQuote") && e.isEmpty) return i.remove(e), !0;
                  }
                return !1;
              });
          }
          afterInit() {
            const t = this.editor.commands.get("blockQuote");
            this.listenTo(
              this.editor.editing.view.document,
              "enter",
              (e, i) => {
                const n = this.editor.model.document,
                  o = n.selection.getLastPosition().parent;
                n.selection.isCollapsed &&
                  o.isEmpty &&
                  t.value &&
                  (this.editor.execute("blockQuote"),
                  this.editor.editing.view.scrollToTheSelection(),
                  i.preventDefault(),
                  e.stop());
              }
            );
          }
        }
        i(44);
        class vh extends Gc {
          init() {
            const t = this.editor,
              e = t.t;
            t.ui.componentFactory.add("blockQuote", (i) => {
              const n = t.commands.get("blockQuote"),
                o = new Oc(i);
              return (
                o.set({
                  label: e("Block quote"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
                  tooltip: !0,
                  isToggleable: !0,
                }),
                o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"),
                this.listenTo(o, "execute", () => {
                  t.execute("blockQuote"), t.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        class yh extends Gc {
          static get pluginName() {
            return "CKFinderUI";
          }
          init() {
            const t = this.editor,
              e = t.ui.componentFactory,
              i = t.t;
            e.add("ckfinder", (e) => {
              const n = t.commands.get("ckfinder"),
                o = new Oc(e);
              return (
                o.set({
                  label: i("Insert image or file"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',
                  tooltip: !0,
                }),
                o.bind("isEnabled").to(n),
                o.on("execute", () => {
                  t.execute("ckfinder"), t.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        class xh extends hr {
          observe(t) {
            this.listenTo(
              t,
              "load",
              (t, e) => {
                "IMG" == e.target.tagName && this._fireEvents(e);
              },
              { useCapture: !0 }
            );
          }
          _fireEvents(t) {
            this.isEnabled &&
              (this.document.fire("layoutChanged"),
              this.document.fire("imageLoaded", t));
          }
        }
        class Ah {
          constructor() {
            this._stack = [];
          }
          add(t, e) {
            const i = this._stack,
              n = i[0];
            this._insertDescriptor(t);
            const o = i[0];
            n === o ||
              Ch(n, o) ||
              this.fire("change:top", {
                oldDescriptor: n,
                newDescriptor: o,
                writer: e,
              });
          }
          remove(t, e) {
            const i = this._stack,
              n = i[0];
            this._removeDescriptor(t);
            const o = i[0];
            n === o ||
              Ch(n, o) ||
              this.fire("change:top", {
                oldDescriptor: n,
                newDescriptor: o,
                writer: e,
              });
          }
          _insertDescriptor(t) {
            const e = this._stack,
              i = e.findIndex((e) => e.id === t.id);
            if (Ch(t, e[i])) return;
            i > -1 && e.splice(i, 1);
            let n = 0;
            for (; e[n] && Th(e[n], t); ) n++;
            e.splice(n, 0, t);
          }
          _removeDescriptor(t) {
            const e = this._stack,
              i = e.findIndex((e) => e.id === t);
            i > -1 && e.splice(i, 1);
          }
        }
        function Ch(t, e) {
          return (
            t && e && t.priority == e.priority && Mh(t.classes) == Mh(e.classes)
          );
        }
        function Th(t, e) {
          return (
            t.priority > e.priority ||
            (!(t.priority < e.priority) && Mh(t.classes) > Mh(e.classes))
          );
        }
        function Mh(t) {
          return Array.isArray(t) ? t.sort().join(",") : t;
        }
        yi(Ah, gi);
        function Eh(t) {
          return !!t.is("element") && !!t.getCustomProperty("widget");
        }
        function Ph(t, e, i = {}) {
          return (
            e.setAttribute("contenteditable", "false", t),
            e.addClass("ck-widget", t),
            e.setCustomProperty("widget", !0, t),
            (t.getFillerOffset = Nh),
            i.label &&
              (function (t, e, i) {
                i.setCustomProperty("widgetLabel", e, t);
              })(t, i.label, e),
            i.hasSelectionHandle &&
              (function (t, e) {
                const i = e.createUIElement(
                  "div",
                  { class: "ck ck-widget__selection-handle" },
                  function (t) {
                    const e = this.toDomElement(t),
                      i = new Sc();
                    return (
                      i.set(
                        "content",
                        '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>'
                      ),
                      i.render(),
                      e.appendChild(i.element),
                      e
                    );
                  }
                );
                e.insert(e.createPositionAt(t, 0), i),
                  e.addClass(["ck-widget_with-selection-handle"], t);
              })(t, e),
            (function (t, e, i, n) {
              const o = new Ah();
              o.on("change:top", (e, o) => {
                o.oldDescriptor && n(t, o.oldDescriptor, o.writer),
                  o.newDescriptor && i(t, o.newDescriptor, o.writer);
              }),
                e.setCustomProperty(
                  "addHighlight",
                  (t, e, i) => o.add(e, i),
                  t
                ),
                e.setCustomProperty(
                  "removeHighlight",
                  (t, e, i) => o.remove(e, i),
                  t
                );
            })(
              t,
              e,
              (t, e, i) => i.addClass(n(e.classes), t),
              (t, e, i) => i.removeClass(n(e.classes), t)
            ),
            t
          );
          function n(t) {
            return Array.isArray(t) ? t : [t];
          }
        }
        function Sh(t) {
          const e = t.getCustomProperty("widgetLabel");
          return e ? ("function" == typeof e ? e() : e) : "";
        }
        function Ih(t, e) {
          return (
            e.addClass(
              ["ck-editor__editable", "ck-editor__nested-editable"],
              t
            ),
            e.setAttribute(
              "contenteditable",
              t.isReadOnly ? "false" : "true",
              t
            ),
            t.on("change:isReadOnly", (i, n, o) => {
              e.setAttribute("contenteditable", o ? "false" : "true", t);
            }),
            t.on("change:isFocused", (i, n, o) => {
              o
                ? e.addClass("ck-editor__nested-editable_focused", t)
                : e.removeClass("ck-editor__nested-editable_focused", t);
            }),
            t
          );
        }
        function Oh(t, e) {
          const i = t.getSelectedElement();
          if (i && e.schema.isBlock(i)) return e.createPositionAfter(i);
          const n = t.getSelectedBlocks().next().value;
          if (n) {
            if (n.isEmpty) return e.createPositionAt(n, 0);
            const i = e.createPositionAfter(n);
            return t.focus.isTouching(i) ? i : e.createPositionBefore(n);
          }
          return t.focus;
        }
        function Nh() {
          return null;
        }
        function Rh(t) {
          const e = t.getSelectedElement();
          return e &&
            (function (t) {
              return !!t.getCustomProperty("image") && Eh(t);
            })(e)
            ? e
            : null;
        }
        function Lh(t) {
          return !!t && t.is("image");
        }
        function jh(t, e, i = {}) {
          const n = t.createElement("image", i),
            o = Oh(e.document.selection, e);
          e.insertContent(n, o), n.parent && t.setSelection(n, "on");
        }
        function Dh(t) {
          const e = t.schema,
            i = t.document.selection;
          return (
            (function (t, e, i) {
              const n = (function (t, e) {
                const i = Oh(t, e).parent;
                if (i.isEmpty && !i.is("$root")) return i.parent;
                return i;
              })(t, i);
              return e.checkChild(n, "image");
            })(i, e, t) &&
            !(function (t, e) {
              const i = t.getSelectedElement();
              return i && e.isObject(i);
            })(i, e) &&
            (function (t) {
              return [...t.focus.getAncestors()].every((t) => !t.is("image"));
            })(i)
          );
        }
        function zh(t) {
          return Array.from(t.getChildren()).find((t) => t.is("img"));
        }
        function Bh(t) {
          return (i) => {
            i.on(`attribute:${t}:image`, e);
          };
          function e(t, e, i) {
            if (!i.consumable.consume(e.item, t.name)) return;
            const n = i.writer,
              o = zh(i.mapper.toViewElement(e.item));
            null !== e.attributeNewValue
              ? n.setAttribute(e.attributeKey, e.attributeNewValue, o)
              : n.removeAttribute(e.attributeKey, o);
          }
        }
        class Vh extends ed {
          refresh() {
            this.isEnabled = Dh(this.editor.model);
          }
          execute(t) {
            const e = this.editor.model;
            e.change((i) => {
              const n = Array.isArray(t.source) ? t.source : [t.source];
              for (const t of n) jh(i, e, { src: t });
            });
          }
        }
        class Fh extends Gc {
          static get pluginName() {
            return "ImageEditing";
          }
          init() {
            const t = this.editor,
              e = t.model.schema,
              i = t.t,
              n = t.conversion;
            t.editing.view.addObserver(xh),
              e.register("image", {
                isObject: !0,
                isBlock: !0,
                allowWhere: "$block",
                allowAttributes: ["alt", "src", "srcset"],
              }),
              n
                .for("dataDowncast")
                .elementToElement({ model: "image", view: (t, e) => Hh(e) }),
              n.for("editingDowncast").elementToElement({
                model: "image",
                view: (t, e) => {
                  return (
                    (n = Hh(e)),
                    (o = e),
                    (r = i("image widget")),
                    o.setCustomProperty("image", !0, n),
                    Ph(n, o, {
                      label: function () {
                        const t = zh(n).getAttribute("alt");
                        return t ? `${t} ${r}` : r;
                      },
                    })
                  );
                  var n, o, r;
                },
              }),
              n
                .for("downcast")
                .add(Bh("src"))
                .add(Bh("alt"))
                .add(
                  (function () {
                    return (e) => {
                      e.on("attribute:srcset:image", t);
                    };
                    function t(t, e, i) {
                      if (!i.consumable.consume(e.item, t.name)) return;
                      const n = i.writer,
                        o = zh(i.mapper.toViewElement(e.item));
                      if (null === e.attributeNewValue) {
                        const t = e.attributeOldValue;
                        t.data &&
                          (n.removeAttribute("srcset", o),
                          n.removeAttribute("sizes", o),
                          t.width && n.removeAttribute("width", o));
                      } else {
                        const t = e.attributeNewValue;
                        t.data &&
                          (n.setAttribute("srcset", t.data, o),
                          n.setAttribute("sizes", "100vw", o),
                          t.width && n.setAttribute("width", t.width, o));
                      }
                    }
                  })()
                ),
              n
                .for("upcast")
                .elementToElement({
                  view: { name: "img", attributes: { src: !0 } },
                  model: (t, e) =>
                    e.createElement("image", { src: t.getAttribute("src") }),
                })
                .attributeToAttribute({
                  view: { name: "img", key: "alt" },
                  model: "alt",
                })
                .attributeToAttribute({
                  view: { name: "img", key: "srcset" },
                  model: {
                    key: "srcset",
                    value: (t) => {
                      const e = { data: t.getAttribute("srcset") };
                      return (
                        t.hasAttribute("width") &&
                          (e.width = t.getAttribute("width")),
                        e
                      );
                    },
                  },
                })
                .add(
                  (function () {
                    return (e) => {
                      e.on("element:figure", t);
                    };
                    function t(t, e, i) {
                      if (
                        !i.consumable.test(e.viewItem, {
                          name: !0,
                          classes: "image",
                        })
                      )
                        return;
                      const n = zh(e.viewItem);
                      if (
                        !n ||
                        !n.hasAttribute("src") ||
                        !i.consumable.test(n, { name: !0 })
                      )
                        return;
                      const o = i.convertItem(n, e.modelCursor),
                        r = fh(o.modelRange.getItems());
                      r &&
                        (i.convertChildren(
                          e.viewItem,
                          i.writer.createPositionAt(r, 0)
                        ),
                        (e.modelRange = o.modelRange),
                        (e.modelCursor = o.modelCursor));
                    }
                  })()
                ),
              t.commands.add("imageInsert", new Vh(t));
          }
        }
        function Hh(t) {
          const e = t.createEmptyElement("img"),
            i = t.createContainerElement("figure", { class: "image" });
          return t.insert(t.createPositionAt(i, 0), e), i;
        }
        function Uh(t, e, i) {
          return i.createRange(Wh(t, e, !0, i), Wh(t, e, !1, i));
        }
        function Wh(t, e, i, n) {
          let o = t.textNode || (i ? t.nodeBefore : t.nodeAfter),
            r = null;
          for (; o && o.getAttribute("linkHref") == e; )
            (r = o), (o = i ? o.previousSibling : o.nextSibling);
          return r ? n.createPositionAt(r, i ? "before" : "after") : t;
        }
        class qh extends ed {
          constructor(t) {
            super(t), (this.manualDecorators = new xi());
          }
          restoreManualDecoratorStates() {
            for (const t of this.manualDecorators)
              t.value = this._getDecoratorStateFromModel(t.id);
          }
          refresh() {
            const t = this.editor.model,
              e = t.document;
            this.value = e.selection.getAttribute("linkHref");
            for (const t of this.manualDecorators)
              t.value = this._getDecoratorStateFromModel(t.id);
            this.isEnabled = t.schema.checkAttributeInSelection(
              e.selection,
              "linkHref"
            );
          }
          execute(t, e = {}) {
            const i = this.editor.model,
              n = i.document.selection,
              o = [],
              r = [];
            for (const t in e) e[t] ? o.push(t) : r.push(t);
            i.change((e) => {
              if (n.isCollapsed) {
                const s = n.getFirstPosition();
                if (n.hasAttribute("linkHref")) {
                  const a = Uh(s, n.getAttribute("linkHref"), i);
                  e.setAttribute("linkHref", t, a),
                    o.forEach((t) => {
                      e.setAttribute(t, !0, a);
                    }),
                    r.forEach((t) => {
                      e.removeAttribute(t, a);
                    }),
                    e.setSelection(a);
                } else if ("" !== t) {
                  const r = Li(n.getAttributes());
                  r.set("linkHref", t),
                    o.forEach((t) => {
                      r.set(t, !0);
                    });
                  const a = e.createText(t, r);
                  i.insertContent(a, s), e.setSelection(e.createRangeOn(a));
                }
              } else {
                const s = i.schema.getValidRanges(n.getRanges(), "linkHref");
                for (const i of s)
                  e.setAttribute("linkHref", t, i),
                    o.forEach((t) => {
                      e.setAttribute(t, !0, i);
                    }),
                    r.forEach((t) => {
                      e.removeAttribute(t, i);
                    });
              }
            });
          }
          _getDecoratorStateFromModel(t) {
            return this.editor.model.document.selection.getAttribute(t);
          }
        }
        class Yh extends ed {
          refresh() {
            this.isEnabled =
              this.editor.model.document.selection.hasAttribute("linkHref");
          }
          execute() {
            const t = this.editor,
              e = this.editor.model,
              i = e.document.selection,
              n = t.commands.get("link");
            e.change((t) => {
              const o = i.isCollapsed
                ? [Uh(i.getFirstPosition(), i.getAttribute("linkHref"), e)]
                : i.getRanges();
              for (const e of o)
                if ((t.removeAttribute("linkHref", e), n))
                  for (const i of n.manualDecorators)
                    t.removeAttribute(i.id, e);
            });
          }
        }
        var $h = function (t, e, i) {
            var n = t.length;
            return (i = void 0 === i ? n : i), !e && i >= n ? t : nn(t, e, i);
          },
          Jh = RegExp(
            "[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"
          );
        var Gh = function (t) {
          return Jh.test(t);
        };
        var Qh = function (t) {
            return t.split("");
          },
          Xh = "[\\ud800-\\udfff]",
          Kh = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
          Zh = "\\ud83c[\\udffb-\\udfff]",
          tu = "[^\\ud800-\\udfff]",
          eu = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          iu = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          nu = "(?:" + Kh + "|" + Zh + ")" + "?",
          ou =
            "[\\ufe0e\\ufe0f]?" +
            nu +
            ("(?:\\u200d(?:" +
              [tu, eu, iu].join("|") +
              ")[\\ufe0e\\ufe0f]?" +
              nu +
              ")*"),
          ru = "(?:" + [tu + Kh + "?", Kh, eu, iu, Xh].join("|") + ")",
          su = RegExp(Zh + "(?=" + Zh + ")|" + ru + ou, "g");
        var au = function (t) {
          return t.match(su) || [];
        };
        var lu = function (t) {
          return Gh(t) ? au(t) : Qh(t);
        };
        var cu = (function (t) {
          return function (e) {
            e = Xi(e);
            var i = Gh(e) ? lu(e) : void 0,
              n = i ? i[0] : e.charAt(0),
              o = i ? $h(i, 1).join("") : e.slice(1);
            return n[t]() + o;
          };
        })("toUpperCase");
        const du =
            /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
          hu =
            /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
        function uu(t, e) {
          const i = e.createAttributeElement("a", { href: t }, { priority: 5 });
          return e.setCustomProperty("link", !0, i), i;
        }
        function mu(t) {
          return (function (t) {
            return t.replace(du, "").match(hu);
          })((t = String(t)))
            ? t
            : "#";
        }
        class gu {
          constructor() {
            this._definitions = new Set();
          }
          get length() {
            return this._definitions.size;
          }
          add(t) {
            Array.isArray(t)
              ? t.forEach((t) => this._definitions.add(t))
              : this._definitions.add(t);
          }
          getDispatcher() {
            return (t) => {
              t.on(
                "attribute:linkHref",
                (t, e, i) => {
                  if (!i.consumable.test(e.item, "attribute:linkHref")) return;
                  const n = i.writer,
                    o = n.document.selection;
                  for (const t of this._definitions) {
                    const r = n.createAttributeElement("a", t.attributes, {
                      priority: 5,
                    });
                    n.setCustomProperty("link", !0, r),
                      t.callback(e.attributeNewValue)
                        ? e.item.is("selection")
                          ? n.wrap(o.getFirstRange(), r)
                          : n.wrap(i.mapper.toViewRange(e.range), r)
                        : n.unwrap(i.mapper.toViewRange(e.range), r);
                  }
                },
                { priority: "high" }
              );
            };
          }
        }
        class fu {
          constructor({ id: t, label: e, attributes: i, defaultValue: n }) {
            (this.id = t),
              this.set("value"),
              (this.defaultValue = n),
              (this.label = e),
              (this.attributes = i);
          }
        }
        yi(fu, Hn);
        class pu {
          constructor(t, e, i) {
            (this.model = t),
              (this.attribute = i),
              (this._modelSelection = t.document.selection),
              (this._overrideUid = null),
              (this._isNextGravityRestorationSkipped = !1),
              e.listenTo(this._modelSelection, "change:range", (t, e) => {
                this._isNextGravityRestorationSkipped
                  ? (this._isNextGravityRestorationSkipped = !1)
                  : this._isGravityOverridden &&
                    ((!e.directChange &&
                      bu(this._modelSelection.getFirstPosition(), i)) ||
                      this._restoreGravity());
              });
          }
          handleForwardMovement(t, e) {
            const i = this.attribute;
            if (
              !(
                this._isGravityOverridden ||
                (t.isAtStart && this._hasSelectionAttribute)
              )
            )
              return ku(t, i) && this._hasSelectionAttribute
                ? (this._preventCaretMovement(e),
                  this._removeSelectionAttribute(),
                  !0)
                : wu(t, i) || (_u(t, i) && this._hasSelectionAttribute)
                ? (this._preventCaretMovement(e), this._overrideGravity(), !0)
                : void 0;
          }
          handleBackwardMovement(t, e) {
            const i = this.attribute;
            return this._isGravityOverridden
              ? ku(t, i) && this._hasSelectionAttribute
                ? (this._preventCaretMovement(e),
                  this._restoreGravity(),
                  this._removeSelectionAttribute(),
                  !0)
                : (this._preventCaretMovement(e),
                  this._restoreGravity(),
                  t.isAtStart && this._removeSelectionAttribute(),
                  !0)
              : ku(t, i) && !this._hasSelectionAttribute
              ? (this._preventCaretMovement(e),
                this._setSelectionAttributeFromTheNodeBefore(t),
                !0)
              : t.isAtEnd && _u(t, i)
              ? this._hasSelectionAttribute
                ? void (
                    vu(t, i) &&
                    (this._skipNextAutomaticGravityRestoration(),
                    this._overrideGravity())
                  )
                : (this._preventCaretMovement(e),
                  this._setSelectionAttributeFromTheNodeBefore(t),
                  !0)
              : t.isAtStart
              ? this._hasSelectionAttribute
                ? (this._removeSelectionAttribute(),
                  this._preventCaretMovement(e),
                  !0)
                : void 0
              : void (
                  vu(t, i) &&
                  (this._skipNextAutomaticGravityRestoration(),
                  this._overrideGravity())
                );
          }
          get _isGravityOverridden() {
            return !!this._overrideUid;
          }
          get _hasSelectionAttribute() {
            return this._modelSelection.hasAttribute(this.attribute);
          }
          _overrideGravity() {
            this._overrideUid = this.model.change((t) =>
              t.overrideSelectionGravity()
            );
          }
          _restoreGravity() {
            this.model.change((t) => {
              t.restoreSelectionGravity(this._overrideUid),
                (this._overrideUid = null);
            });
          }
          _preventCaretMovement(t) {
            t.preventDefault();
          }
          _removeSelectionAttribute() {
            this.model.change((t) => {
              t.removeSelectionAttribute(this.attribute);
            });
          }
          _setSelectionAttributeFromTheNodeBefore(t) {
            const e = this.attribute;
            this.model.change((i) => {
              i.setSelectionAttribute(
                this.attribute,
                t.nodeBefore.getAttribute(e)
              );
            });
          }
          _skipNextAutomaticGravityRestoration() {
            this._isNextGravityRestorationSkipped = !0;
          }
        }
        function bu(t, e) {
          return wu(t, e) || _u(t, e);
        }
        function wu(t, e) {
          const { nodeBefore: i, nodeAfter: n } = t,
            o = !!i && i.hasAttribute(e);
          return (
            !!n &&
            n.hasAttribute(e) &&
            (!o || i.getAttribute(e) !== n.getAttribute(e))
          );
        }
        function _u(t, e) {
          const { nodeBefore: i, nodeAfter: n } = t,
            o = !!i && i.hasAttribute(e),
            r = !!n && n.hasAttribute(e);
          return o && (!r || i.getAttribute(e) !== n.getAttribute(e));
        }
        function ku(t, e) {
          const { nodeBefore: i, nodeAfter: n } = t,
            o = !!i && i.hasAttribute(e);
          if (!!n && n.hasAttribute(e) && o)
            return n.getAttribute(e) !== i.getAttribute(e);
        }
        function vu(t, e) {
          return bu(t.getShiftedBy(-1), e);
        }
        i(46);
        const yu = /^(https?:)?\/\//;
        class xu extends Gc {
          static get pluginName() {
            return "LinkEditing";
          }
          constructor(t) {
            super(t), t.config.define("link", { addTargetToExternalLinks: !1 });
          }
          init() {
            const t = this.editor,
              e = t.locale;
            t.model.schema.extend("$text", { allowAttributes: "linkHref" }),
              t.conversion
                .for("dataDowncast")
                .attributeToElement({ model: "linkHref", view: uu }),
              t.conversion
                .for("editingDowncast")
                .attributeToElement({
                  model: "linkHref",
                  view: (t, e) => uu(mu(t), e),
                }),
              t.conversion
                .for("upcast")
                .elementToAttribute({
                  view: { name: "a", attributes: { href: !0 } },
                  model: {
                    key: "linkHref",
                    value: (t) => t.getAttribute("href"),
                  },
                }),
              t.commands.add("link", new qh(t)),
              t.commands.add("unlink", new Yh(t));
            const i = (function (t, e) {
              const i = {
                "Open in a new tab": t("Open in a new tab"),
                Downloadable: t("Downloadable"),
              };
              return (
                e.forEach(
                  (t) => (t.label && i[t.label] && (t.label = i[t.label]), t)
                ),
                e
              );
            })(
              t.t,
              (function (t) {
                const e = [];
                if (t)
                  for (const [i, n] of Object.entries(t)) {
                    const t = Object.assign({}, n, { id: "link" + cu(i) });
                    e.push(t);
                  }
                return e;
              })(t.config.get("link.decorators"))
            );
            this._enableAutomaticDecorators(
              i.filter((t) => "automatic" === t.mode)
            ),
              this._enableManualDecorators(
                i.filter((t) => "manual" === t.mode)
              ),
              (function ({
                view: t,
                model: e,
                emitter: i,
                attribute: n,
                locale: o,
              }) {
                const r = new pu(e, i, n),
                  s = e.document.selection;
                i.listenTo(
                  t.document,
                  "keydown",
                  (t, e) => {
                    if (!s.isCollapsed) return;
                    if (e.shiftKey || e.altKey || e.ctrlKey) return;
                    const i = e.keyCode == fo.arrowright,
                      n = e.keyCode == fo.arrowleft;
                    if (!i && !n) return;
                    const a = s.getFirstPosition(),
                      l = o.contentLanguageDirection;
                    let c;
                    (c =
                      ("ltr" === l && i) || ("rtl" === l && n)
                        ? r.handleForwardMovement(a, e)
                        : r.handleBackwardMovement(a, e)),
                      c && t.stop();
                  },
                  { priority: di.get("high") + 1 }
                );
              })({
                view: t.editing.view,
                model: t.model,
                emitter: this,
                attribute: "linkHref",
                locale: e,
              }),
              this._setupLinkHighlight(),
              this._enableInsertContentSelectionAttributesFixer();
          }
          _enableAutomaticDecorators(t) {
            const e = this.editor,
              i = new gu();
            e.config.get("link.addTargetToExternalLinks") &&
              i.add({
                id: "linkIsExternal",
                mode: "automatic",
                callback: (t) => yu.test(t),
                attributes: { target: "_blank", rel: "noopener noreferrer" },
              }),
              i.add(t),
              i.length && e.conversion.for("downcast").add(i.getDispatcher());
          }
          _enableManualDecorators(t) {
            if (!t.length) return;
            const e = this.editor,
              i = e.commands.get("link").manualDecorators;
            t.forEach((t) => {
              e.model.schema.extend("$text", { allowAttributes: t.id }),
                i.add(new fu(t)),
                e.conversion.for("downcast").attributeToElement({
                  model: t.id,
                  view: (e, n) => {
                    if (e) {
                      const e = i.get(t.id).attributes,
                        o = n.createAttributeElement("a", e, { priority: 5 });
                      return n.setCustomProperty("link", !0, o), o;
                    }
                  },
                }),
                e.conversion
                  .for("upcast")
                  .elementToAttribute({
                    view: { name: "a", attributes: i.get(t.id).attributes },
                    model: { key: t.id },
                  });
            });
          }
          _setupLinkHighlight() {
            const t = this.editor,
              e = t.editing.view,
              i = new Set();
            e.document.registerPostFixer((e) => {
              const n = t.model.document.selection;
              let o = !1;
              if (n.hasAttribute("linkHref")) {
                const r = Uh(
                    n.getFirstPosition(),
                    n.getAttribute("linkHref"),
                    t.model
                  ),
                  s = t.editing.mapper.toViewRange(r);
                for (const t of s.getItems())
                  t.is("a") &&
                    !t.hasClass("ck-link_selected") &&
                    (e.addClass("ck-link_selected", t), i.add(t), (o = !0));
              }
              return o;
            }),
              t.conversion.for("editingDowncast").add((t) => {
                function n() {
                  e.change((t) => {
                    for (const e of i.values())
                      t.removeClass("ck-link_selected", e), i.delete(e);
                  });
                }
                t.on("insert", n, { priority: "highest" }),
                  t.on("remove", n, { priority: "highest" }),
                  t.on("attribute", n, { priority: "highest" }),
                  t.on("selection", n, { priority: "highest" });
              });
          }
          _enableInsertContentSelectionAttributesFixer() {
            const t = this.editor.model,
              e = t.document.selection;
            t.on(
              "insertContent",
              () => {
                const i = e.anchor.nodeBefore,
                  n = e.anchor.nodeAfter;
                e.hasAttribute("linkHref") &&
                  i &&
                  i.hasAttribute("linkHref") &&
                  ((n && n.hasAttribute("linkHref")) ||
                    t.change((e) => {
                      [...t.document.selection.getAttributeKeys()]
                        .filter((t) => t.startsWith("link"))
                        .forEach((t) => e.removeSelectionAttribute(t));
                    }));
              },
              { priority: "low" }
            );
          }
        }
        class Au extends Xd {
          static get pluginName() {
            return "Notification";
          }
          init() {
            this.on(
              "show:warning",
              (t, e) => {
                window.alert(e.message);
              },
              { priority: "lowest" }
            );
          }
          showSuccess(t, e = {}) {
            this._showNotification({
              message: t,
              type: "success",
              namespace: e.namespace,
              title: e.title,
            });
          }
          showInfo(t, e = {}) {
            this._showNotification({
              message: t,
              type: "info",
              namespace: e.namespace,
              title: e.title,
            });
          }
          showWarning(t, e = {}) {
            this._showNotification({
              message: t,
              type: "warning",
              namespace: e.namespace,
              title: e.title,
            });
          }
          _showNotification(t) {
            const e = "show:" + t.type + (t.namespace ? ":" + t.namespace : "");
            this.fire(e, {
              message: t.message,
              type: t.type,
              title: t.title || "",
            });
          }
        }
        class Cu extends ed {
          constructor(t) {
            super(t),
              this.stopListening(this.editor.model.document, "change"),
              this.listenTo(
                this.editor.model.document,
                "change",
                () => this.refresh(),
                { priority: "low" }
              );
          }
          refresh() {
            const t = this.editor.commands.get("imageInsert"),
              e = this.editor.commands.get("link");
            this.isEnabled = t.isEnabled || e.isEnabled;
          }
          execute() {
            const t = this.editor,
              e = this.editor.config.get("ckfinder.openerMethod") || "modal";
            if ("popup" != e && "modal" != e)
              throw new hi.b(
                'ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".',
                t
              );
            const i = this.editor.config.get("ckfinder.options") || {};
            i.chooseFiles = !0;
            const n = i.onInit;
            i.language || (i.language = t.locale.uiLanguage),
              (i.onInit = (e) => {
                n && n(e),
                  e.on("files:choose", (i) => {
                    const n = i.data.files.toArray(),
                      o = n.filter((t) => !t.isImage()),
                      r = n.filter((t) => t.isImage());
                    for (const e of o) t.execute("link", e.getUrl());
                    const s = [];
                    for (const t of r) {
                      const i = t.getUrl();
                      s.push(i || e.request("file:getProxyUrl", { file: t }));
                    }
                    s.length && Tu(t, s);
                  }),
                  e.on("file:choose:resizedImage", (e) => {
                    const i = e.data.resizedUrl;
                    if (i) Tu(t, [i]);
                    else {
                      const e = t.plugins.get("Notification"),
                        i = t.locale.t;
                      e.showWarning(i("Could not obtain resized image URL."), {
                        title: i("Selecting resized image failed"),
                        namespace: "ckfinder",
                      });
                    }
                  });
              }),
              window.CKFinder[e](i);
          }
        }
        function Tu(t, e) {
          if (t.commands.get("imageInsert").isEnabled)
            t.execute("imageInsert", { source: e });
          else {
            const e = t.plugins.get("Notification"),
              i = t.locale.t;
            e.showWarning(
              i("Could not insert image at the current position."),
              { title: i("Inserting image failed"), namespace: "ckfinder" }
            );
          }
        }
        class Mu extends Gc {
          static get pluginName() {
            return "CKFinderEditing";
          }
          static get requires() {
            return [Au, Fh, xu];
          }
          init() {
            const t = this.editor;
            t.commands.add("ckfinder", new Cu(t));
          }
        }
        const Eu = /^data:(\S*?);base64,/;
        class Pu {
          constructor(t, e, i) {
            if (!t)
              throw new hi.b(
                "fileuploader-missing-file: File must be provided as the first argument",
                null
              );
            if (!e)
              throw new hi.b(
                "fileuploader-missing-token: Token must be provided as the second argument.",
                null
              );
            if (!i)
              throw new hi.b(
                "fileuploader-missing-api-address: Api address must be provided as the third argument.",
                null
              );
            (this.file = (function (t) {
              if ("string" != typeof t) return !1;
              const e = t.match(Eu);
              return !(!e || !e.length);
            })(t)
              ? (function (t, e = 512) {
                  try {
                    const i = t.match(Eu)[1],
                      n = atob(t.replace(Eu, "")),
                      o = [];
                    for (let t = 0; t < n.length; t += e) {
                      const i = n.slice(t, t + e),
                        r = new Array(i.length);
                      for (let t = 0; t < i.length; t++) r[t] = i.charCodeAt(t);
                      o.push(new Uint8Array(r));
                    }
                    return new Blob(o, { type: i });
                  } catch (t) {
                    throw new hi.b(
                      "fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.",
                      null
                    );
                  }
                })(t)
              : t),
              (this._token = e),
              (this._apiAddress = i);
          }
          onProgress(t) {
            return this.on("progress", (e, i) => t(i)), this;
          }
          onError(t) {
            return this.once("error", (e, i) => t(i)), this;
          }
          abort() {
            this.xhr.abort();
          }
          send() {
            return (
              this._prepareRequest(),
              this._attachXHRListeners(),
              this._sendRequest()
            );
          }
          _prepareRequest() {
            const t = new XMLHttpRequest();
            t.open("POST", this._apiAddress),
              t.setRequestHeader("Authorization", this._token.value),
              (t.responseType = "json"),
              (this.xhr = t);
          }
          _attachXHRListeners() {
            const t = this,
              e = this.xhr;
            function i(e) {
              return () => t.fire("error", e);
            }
            e.addEventListener("error", i("Network Error")),
              e.addEventListener("abort", i("Abort")),
              e.upload &&
                e.upload.addEventListener("progress", (t) => {
                  t.lengthComputable &&
                    this.fire("progress", {
                      total: t.total,
                      uploaded: t.loaded,
                    });
                }),
              e.addEventListener("load", () => {
                const t = e.status,
                  i = e.response;
                if (t < 200 || t > 299)
                  return this.fire("error", i.message || i.error);
              });
          }
          _sendRequest() {
            const t = new FormData(),
              e = this.xhr;
            return (
              t.append("file", this.file),
              new Promise((i, n) => {
                e.addEventListener("load", () => {
                  const t = e.status,
                    o = e.response;
                  return t < 200 || t > 299
                    ? o.message
                      ? n(
                          new hi.b(
                            "fileuploader-uploading-data-failed: Uploading file failed.",
                            this,
                            { message: o.message }
                          )
                        )
                      : n(o.error)
                    : i(o);
                }),
                  e.addEventListener("error", () =>
                    n(new Error("Network Error"))
                  ),
                  e.addEventListener("abort", () => n(new Error("Abort"))),
                  e.send(t);
              })
            );
          }
        }
        yi(Pu, gi);
        const Su = { refreshInterval: 36e5, autoRefresh: !0 };
        class Iu {
          constructor(t, e = Su) {
            if (!t)
              throw new hi.b(
                "token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.",
                this
              );
            this.set("value", e.initValue),
              (this._refresh =
                "function" == typeof t
                  ? t
                  : () => {
                      return (
                        (e = t),
                        new Promise((t, i) => {
                          const n = new XMLHttpRequest();
                          n.open("GET", e),
                            n.addEventListener("load", () => {
                              const e = n.status,
                                o = n.response;
                              return e < 200 || e > 299
                                ? i(
                                    new hi.b(
                                      "token-cannot-download-new-token: Cannot download new token from the provided url.",
                                      null
                                    )
                                  )
                                : t(o);
                            }),
                            n.addEventListener("error", () =>
                              i(new Error("Network Error"))
                            ),
                            n.addEventListener("abort", () =>
                              i(new Error("Abort"))
                            ),
                            n.send();
                        })
                      );
                      var e;
                    }),
              (this._options = Object.assign({}, Su, e));
          }
          init() {
            return new Promise((t, e) => {
              this._options.autoRefresh && this._startRefreshing(),
                this.value ? t(this) : this.refreshToken().then(t).catch(e);
            });
          }
          refreshToken() {
            return this._refresh()
              .then((t) => this.set("value", t))
              .then(() => this);
          }
          destroy() {
            this._stopRefreshing();
          }
          _startRefreshing() {
            this._refreshInterval = setInterval(
              () => this.refreshToken(),
              this._options.refreshInterval
            );
          }
          _stopRefreshing() {
            clearInterval(this._refreshInterval);
          }
          static create(t, e = Su) {
            return new Iu(t, e).init();
          }
        }
        yi(Iu, Hn);
        var Ou = Iu;
        class Nu extends Xd {
          static get pluginName() {
            return "CloudServices";
          }
          init() {
            const t = this.context.config.get("cloudServices") || {};
            for (const e in t) this[e] = t[e];
            if (this.tokenUrl)
              return (
                (this.token = new Nu.Token(this.tokenUrl)), this.token.init()
              );
            this.token = null;
          }
        }
        Nu.Token = Ou;
        class Ru extends Gc {
          static get requires() {
            return [th, Nu];
          }
          init() {
            const t = this.editor,
              e = t.plugins.get(Nu),
              i = e.token,
              n = e.uploadUrl;
            i &&
              ((this._uploadGateway = new Ru._UploadGateway(i, n)),
              (t.plugins.get(th).createUploadAdapter = (t) =>
                new Lu(this._uploadGateway, t)));
          }
        }
        class Lu {
          constructor(t, e) {
            (this.uploadGateway = t), (this.loader = e);
          }
          upload() {
            return this.loader.file.then(
              (t) => (
                (this.fileUploader = this.uploadGateway.upload(t)),
                this.fileUploader.on("progress", (t, e) => {
                  (this.loader.uploadTotal = e.total),
                    (this.loader.uploaded = e.uploaded);
                }),
                this.fileUploader.send()
              )
            );
          }
          abort() {
            this.fileUploader.abort();
          }
        }
        Ru._UploadGateway = class {
          constructor(t, e) {
            if (!t)
              throw new hi.b(
                "uploadgateway-missing-token: Token must be provided.",
                null
              );
            if (!e)
              throw new hi.b(
                "uploadgateway-missing-api-address: Api address must be provided.",
                null
              );
            (this._token = t), (this._apiAddress = e);
          }
          upload(t) {
            return new Pu(t, this._token, this._apiAddress);
          }
        };
        class ju extends Or {
          constructor(t) {
            super(t), (this.domEventType = "mousedown");
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
        }
        i(48);
        class Du extends Gc {
          static get pluginName() {
            return "Widget";
          }
          init() {
            const t = this.editor.editing.view,
              e = t.document;
            (this._previouslySelected = new Set()),
              this.editor.editing.downcastDispatcher.on(
                "selection",
                (t, e, i) => {
                  this._clearPreviouslySelectedWidgets(i.writer);
                  const n = i.writer,
                    o = n.document.selection,
                    r = o.getSelectedElement();
                  let s = null;
                  for (const t of o.getRanges())
                    for (const e of t) {
                      const t = e.item;
                      Eh(t) &&
                        !zu(t, s) &&
                        (n.addClass("ck-widget_selected", t),
                        this._previouslySelected.add(t),
                        (s = t),
                        t == r &&
                          n.setSelection(o.getRanges(), {
                            fake: !0,
                            label: Sh(r),
                          }));
                    }
                },
                { priority: "low" }
              ),
              t.addObserver(ju),
              this.listenTo(e, "mousedown", (...t) => this._onMousedown(...t)),
              this.listenTo(e, "keydown", (...t) => this._onKeydown(...t), {
                priority: "high",
              }),
              this.listenTo(
                e,
                "delete",
                (t, e) => {
                  this._handleDelete("forward" == e.direction) &&
                    (e.preventDefault(), t.stop());
                },
                { priority: "high" }
              );
          }
          _onMousedown(t, e) {
            const i = this.editor,
              n = i.editing.view,
              o = n.document;
            let r = e.target;
            if (
              (function (t) {
                for (; t; ) {
                  if (t.is("editableElement") && !t.is("rootElement"))
                    return !0;
                  if (Eh(t)) return !1;
                  t = t.parent;
                }
                return !1;
              })(r)
            ) {
              if (uo.isSafari && e.domEvent.detail >= 3) {
                const t = i.editing.mapper.toModelElement(r);
                this.editor.model.change((i) => {
                  e.preventDefault(), i.setSelection(t, "in");
                });
              }
              return;
            }
            if (!Eh(r) && ((r = r.findAncestor(Eh)), !r)) return;
            e.preventDefault(), o.isFocused || n.focus();
            const s = i.editing.mapper.toModelElement(r);
            this._setSelectionOverElement(s);
          }
          _onKeydown(t, e) {
            const i = e.keyCode,
              n = "ltr" === this.editor.locale.contentLanguageDirection,
              o = i == fo.arrowdown || i == fo[n ? "arrowright" : "arrowleft"];
            let r = !1;
            !(function (t) {
              return (
                t == fo.arrowright ||
                t == fo.arrowleft ||
                t == fo.arrowup ||
                t == fo.arrowdown
              );
            })(i)
              ? i === fo.enter && (r = this._handleEnterKey(e.shiftKey))
              : (r = this._handleArrowKeys(o)),
              r && (e.preventDefault(), t.stop());
          }
          _handleDelete(t) {
            if (this.editor.isReadOnly) return;
            const e = this.editor.model.document.selection;
            if (!e.isCollapsed) return;
            const i = this._getObjectElementNextToSelection(t);
            return i
              ? (this.editor.model.change((t) => {
                  let n = e.anchor.parent;
                  for (; n.isEmpty; ) {
                    const e = n;
                    (n = e.parent), t.remove(e);
                  }
                  this._setSelectionOverElement(i);
                }),
                !0)
              : void 0;
          }
          _handleArrowKeys(t) {
            const e = this.editor.model,
              i = e.schema,
              n = e.document.selection,
              o = n.getSelectedElement();
            if (o && i.isObject(o)) {
              const o = t ? n.getLastPosition() : n.getFirstPosition(),
                r = i.getNearestSelectionRange(o, t ? "forward" : "backward");
              return (
                r &&
                  e.change((t) => {
                    t.setSelection(r);
                  }),
                !0
              );
            }
            if (!n.isCollapsed) return;
            const r = this._getObjectElementNextToSelection(t);
            return r && i.isObject(r)
              ? (this._setSelectionOverElement(r), !0)
              : void 0;
          }
          _handleEnterKey(t) {
            const e = this.editor.model,
              i = e.document.selection.getSelectedElement();
            if (((n = i), (o = e.schema), n && o.isObject(n) && !o.isInline(n)))
              return (
                e.change((n) => {
                  let o = n.createPositionAt(i, t ? "before" : "after");
                  const r = n.createElement("paragraph");
                  if (e.schema.isBlock(i.parent)) {
                    const t = e.schema.findAllowedParent(o, r);
                    o = n.split(o, t).position;
                  }
                  n.insert(r, o), n.setSelection(r, "in");
                }),
                !0
              );
            var n, o;
          }
          _setSelectionOverElement(t) {
            this.editor.model.change((e) => {
              e.setSelection(e.createRangeOn(t));
            });
          }
          _getObjectElementNextToSelection(t) {
            const e = this.editor.model,
              i = e.schema,
              n = e.document.selection,
              o = e.createSelection(n);
            e.modifySelection(o, { direction: t ? "forward" : "backward" });
            const r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
            return r && i.isObject(r) ? r : null;
          }
          _clearPreviouslySelectedWidgets(t) {
            for (const e of this._previouslySelected)
              t.removeClass("ck-widget_selected", e);
            this._previouslySelected.clear();
          }
        }
        function zu(t, e) {
          return !!e && Array.from(t.getAncestors()).includes(e);
        }
        class Bu extends ed {
          refresh() {
            const t = this.editor.model.document.selection.getSelectedElement();
            (this.isEnabled = Lh(t)),
              Lh(t) && t.hasAttribute("alt")
                ? (this.value = t.getAttribute("alt"))
                : (this.value = !1);
          }
          execute(t) {
            const e = this.editor.model,
              i = e.document.selection.getSelectedElement();
            e.change((e) => {
              e.setAttribute("alt", t.newValue, i);
            });
          }
        }
        class Vu extends Gc {
          static get pluginName() {
            return "ImageTextAlternativeEditing";
          }
          init() {
            this.editor.commands.add(
              "imageTextAlternative",
              new Bu(this.editor)
            );
          }
        }
        i(50);
        class Fu extends lc {
          constructor(t, e) {
            super(t);
            const i = "ck-labeled-field-view-" + ci(),
              n = "ck-labeled-field-view-status-" + ci();
            (this.fieldView = e(this, i, n)),
              this.set("label"),
              this.set("isEnabled", !0),
              this.set("errorText", null),
              this.set("infoText", null),
              this.set("class"),
              (this.labelView = this._createLabelView(i)),
              (this.statusView = this._createStatusView(n)),
              this.bind("_statusText").to(
                this,
                "errorText",
                this,
                "infoText",
                (t, e) => t || e
              );
            const o = this.bindTemplate;
            this.setTemplate({
              tag: "div",
              attributes: {
                class: [
                  "ck",
                  "ck-labeled-field-view",
                  o.to("class"),
                  o.if("isEnabled", "ck-disabled", (t) => !t),
                ],
              },
              children: [this.labelView, this.fieldView, this.statusView],
            });
          }
          _createLabelView(t) {
            const e = new uc(this.locale);
            return (e.for = t), e.bind("text").to(this, "label"), e;
          }
          _createStatusView(t) {
            const e = new lc(this.locale),
              i = this.bindTemplate;
            return (
              e.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-labeled-field-view__status",
                    i.if("errorText", "ck-labeled-field-view__status_error"),
                    i.if("_statusText", "ck-hidden", (t) => !t),
                  ],
                  id: t,
                  role: i.if("errorText", "alert"),
                },
                children: [{ text: i.to("_statusText") }],
              }),
              e
            );
          }
          focus() {
            this.fieldView.focus();
          }
        }
        i(52);
        class Hu extends lc {
          constructor(t) {
            super(t),
              this.set("value"),
              this.set("id"),
              this.set("placeholder"),
              this.set("isReadOnly", !1),
              this.set("hasError", !1),
              this.set("ariaDescribedById");
            const e = this.bindTemplate;
            this.setTemplate({
              tag: "input",
              attributes: {
                type: "text",
                class: [
                  "ck",
                  "ck-input",
                  "ck-input-text",
                  e.if("hasError", "ck-error"),
                ],
                id: e.to("id"),
                placeholder: e.to("placeholder"),
                readonly: e.to("isReadOnly"),
                "aria-invalid": e.if("hasError", !0),
                "aria-describedby": e.to("ariaDescribedById"),
              },
              on: { input: e.to("input") },
            });
          }
          render() {
            super.render();
            const t = (t) => {
              this.element.value = t || 0 === t ? t : "";
            };
            t(this.value),
              this.on("change:value", (e, i, n) => {
                t(n);
              });
          }
          select() {
            this.element.select();
          }
          focus() {
            this.element.focus();
          }
        }
        function Uu(t, e, i) {
          const n = new Hu(t.locale);
          return (
            n.set({ id: e, ariaDescribedById: i }),
            n.bind("isReadOnly").to(t, "isEnabled", (t) => !t),
            n.bind("hasError").to(t, "errorText", (t) => !!t),
            n.on("input", () => {
              t.errorText = null;
            }),
            n
          );
        }
        function Wu({ view: t }) {
          t.listenTo(
            t.element,
            "submit",
            (e, i) => {
              i.preventDefault(), t.fire("submit");
            },
            { useCapture: !0 }
          );
        }
        var qu =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
          Yu =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
        i(54);
        class $u extends lc {
          constructor(t) {
            super(t);
            const e = this.locale.t;
            (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              (this.labeledInput = this._createLabeledInputView()),
              (this.saveButtonView = this._createButton(
                e("Save"),
                qu,
                "ck-button-save"
              )),
              (this.saveButtonView.type = "submit"),
              (this.cancelButtonView = this._createButton(
                e("Cancel"),
                Yu,
                "ck-button-cancel",
                "cancel"
              )),
              (this._focusables = new Hl()),
              (this._focusCycler = new _c({
                focusables: this._focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: { focusPrevious: "shift + tab", focusNext: "tab" },
              })),
              this.setTemplate({
                tag: "form",
                attributes: {
                  class: ["ck", "ck-text-alternative-form"],
                  tabindex: "-1",
                },
                children: [
                  this.labeledInput,
                  this.saveButtonView,
                  this.cancelButtonView,
                ],
              });
          }
          render() {
            super.render(),
              this.keystrokes.listenTo(this.element),
              Wu({ view: this }),
              [
                this.labeledInput,
                this.saveButtonView,
                this.cancelButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              });
          }
          _createButton(t, e, i, n) {
            const o = new Oc(this.locale);
            return (
              o.set({ label: t, icon: e, tooltip: !0 }),
              o.extendTemplate({ attributes: { class: i } }),
              n && o.delegate("execute").to(this, n),
              o
            );
          }
          _createLabeledInputView() {
            const t = this.locale.t,
              e = new Fu(this.locale, Uu);
            return (
              (e.label = t("Text alternative")),
              (e.fieldView.placeholder = t("Text alternative")),
              e
            );
          }
        }
        i(56);
        const Ju = pc("px"),
          Gu = Zo.document.body;
        class Qu extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate;
            this.set("top", 0),
              this.set("left", 0),
              this.set("position", "arrow_nw"),
              this.set("isVisible", !1),
              this.set("withArrow", !0),
              this.set("class"),
              (this.content = this.createCollection()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-balloon-panel",
                    e.to("position", (t) => "ck-balloon-panel_" + t),
                    e.if("isVisible", "ck-balloon-panel_visible"),
                    e.if("withArrow", "ck-balloon-panel_with-arrow"),
                    e.to("class"),
                  ],
                  style: { top: e.to("top", Ju), left: e.to("left", Ju) },
                },
                children: this.content,
              });
          }
          show() {
            this.isVisible = !0;
          }
          hide() {
            this.isVisible = !1;
          }
          attachTo(t) {
            this.show();
            const e = Qu.defaultPositions,
              i = Object.assign(
                {},
                {
                  element: this.element,
                  positions: [
                    e.southArrowNorth,
                    e.southArrowNorthMiddleWest,
                    e.southArrowNorthMiddleEast,
                    e.southArrowNorthWest,
                    e.southArrowNorthEast,
                    e.northArrowSouth,
                    e.northArrowSouthMiddleWest,
                    e.northArrowSouthMiddleEast,
                    e.northArrowSouthWest,
                    e.northArrowSouthEast,
                  ],
                  limiter: Gu,
                  fitInViewport: !0,
                },
                t
              ),
              n = Qu._getOptimalPosition(i),
              o = parseInt(n.left),
              r = parseInt(n.top),
              s = n.name;
            Object.assign(this, { top: r, left: o, position: s });
          }
          pin(t) {
            this.unpin(),
              (this._pinWhenIsVisibleCallback = () => {
                this.isVisible ? this._startPinning(t) : this._stopPinning();
              }),
              this._startPinning(t),
              this.listenTo(
                this,
                "change:isVisible",
                this._pinWhenIsVisibleCallback
              );
          }
          unpin() {
            this._pinWhenIsVisibleCallback &&
              (this._stopPinning(),
              this.stopListening(
                this,
                "change:isVisible",
                this._pinWhenIsVisibleCallback
              ),
              (this._pinWhenIsVisibleCallback = null),
              this.hide());
          }
          _startPinning(t) {
            this.attachTo(t);
            const e = Xu(t.target),
              i = t.limiter ? Xu(t.limiter) : Gu;
            this.listenTo(
              Zo.document,
              "scroll",
              (n, o) => {
                const r = o.target,
                  s = e && r.contains(e),
                  a = i && r.contains(i);
                (!s && !a && e && i) || this.attachTo(t);
              },
              { useCapture: !0 }
            ),
              this.listenTo(Zo.window, "resize", () => {
                this.attachTo(t);
              });
          }
          _stopPinning() {
            this.stopListening(Zo.document, "scroll"),
              this.stopListening(Zo.window, "resize");
          }
        }
        function Xu(t) {
          return ii(t)
            ? t
            : Gr(t)
            ? t.commonAncestorContainer
            : "function" == typeof t
            ? Xu(t())
            : null;
        }
        function Ku(t, e) {
          return t.top - e.height - Qu.arrowVerticalOffset;
        }
        function Zu(t) {
          return t.bottom + Qu.arrowVerticalOffset;
        }
        (Qu.arrowHorizontalOffset = 25),
          (Qu.arrowVerticalOffset = 10),
          (Qu._getOptimalPosition = Cc),
          (Qu.defaultPositions = {
            northWestArrowSouthWest: (t, e) => ({
              top: Ku(t, e),
              left: t.left - Qu.arrowHorizontalOffset,
              name: "arrow_sw",
            }),
            northWestArrowSouthMiddleWest: (t, e) => ({
              top: Ku(t, e),
              left: t.left - 0.25 * e.width - Qu.arrowHorizontalOffset,
              name: "arrow_smw",
            }),
            northWestArrowSouth: (t, e) => ({
              top: Ku(t, e),
              left: t.left - e.width / 2,
              name: "arrow_s",
            }),
            northWestArrowSouthMiddleEast: (t, e) => ({
              top: Ku(t, e),
              left: t.left - 0.75 * e.width + Qu.arrowHorizontalOffset,
              name: "arrow_sme",
            }),
            northWestArrowSouthEast: (t, e) => ({
              top: Ku(t, e),
              left: t.left - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_se",
            }),
            northArrowSouthWest: (t, e) => ({
              top: Ku(t, e),
              left: t.left + t.width / 2 - Qu.arrowHorizontalOffset,
              name: "arrow_sw",
            }),
            northArrowSouthMiddleWest: (t, e) => ({
              top: Ku(t, e),
              left:
                t.left +
                t.width / 2 -
                0.25 * e.width -
                Qu.arrowHorizontalOffset,
              name: "arrow_smw",
            }),
            northArrowSouth: (t, e) => ({
              top: Ku(t, e),
              left: t.left + t.width / 2 - e.width / 2,
              name: "arrow_s",
            }),
            northArrowSouthMiddleEast: (t, e) => ({
              top: Ku(t, e),
              left:
                t.left +
                t.width / 2 -
                0.75 * e.width +
                Qu.arrowHorizontalOffset,
              name: "arrow_sme",
            }),
            northArrowSouthEast: (t, e) => ({
              top: Ku(t, e),
              left: t.left + t.width / 2 - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_se",
            }),
            northEastArrowSouthWest: (t, e) => ({
              top: Ku(t, e),
              left: t.right - Qu.arrowHorizontalOffset,
              name: "arrow_sw",
            }),
            northEastArrowSouthMiddleWest: (t, e) => ({
              top: Ku(t, e),
              left: t.right - 0.25 * e.width - Qu.arrowHorizontalOffset,
              name: "arrow_smw",
            }),
            northEastArrowSouth: (t, e) => ({
              top: Ku(t, e),
              left: t.right - e.width / 2,
              name: "arrow_s",
            }),
            northEastArrowSouthMiddleEast: (t, e) => ({
              top: Ku(t, e),
              left: t.right - 0.75 * e.width + Qu.arrowHorizontalOffset,
              name: "arrow_sme",
            }),
            northEastArrowSouthEast: (t, e) => ({
              top: Ku(t, e),
              left: t.right - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_se",
            }),
            southWestArrowNorthWest: (t, e) => ({
              top: Zu(t),
              left: t.left - Qu.arrowHorizontalOffset,
              name: "arrow_nw",
            }),
            southWestArrowNorthMiddleWest: (t, e) => ({
              top: Zu(t),
              left: t.left - 0.25 * e.width - Qu.arrowHorizontalOffset,
              name: "arrow_nmw",
            }),
            southWestArrowNorth: (t, e) => ({
              top: Zu(t),
              left: t.left - e.width / 2,
              name: "arrow_n",
            }),
            southWestArrowNorthMiddleEast: (t, e) => ({
              top: Zu(t),
              left: t.left - 0.75 * e.width + Qu.arrowHorizontalOffset,
              name: "arrow_nme",
            }),
            southWestArrowNorthEast: (t, e) => ({
              top: Zu(t),
              left: t.left - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_ne",
            }),
            southArrowNorthWest: (t, e) => ({
              top: Zu(t),
              left: t.left + t.width / 2 - Qu.arrowHorizontalOffset,
              name: "arrow_nw",
            }),
            southArrowNorthMiddleWest: (t, e) => ({
              top: Zu(t),
              left:
                t.left +
                t.width / 2 -
                0.25 * e.width -
                Qu.arrowHorizontalOffset,
              name: "arrow_nmw",
            }),
            southArrowNorth: (t, e) => ({
              top: Zu(t),
              left: t.left + t.width / 2 - e.width / 2,
              name: "arrow_n",
            }),
            southArrowNorthMiddleEast: (t, e) => ({
              top: Zu(t),
              left:
                t.left +
                t.width / 2 -
                0.75 * e.width +
                Qu.arrowHorizontalOffset,
              name: "arrow_nme",
            }),
            southArrowNorthEast: (t, e) => ({
              top: Zu(t),
              left: t.left + t.width / 2 - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_ne",
            }),
            southEastArrowNorthWest: (t, e) => ({
              top: Zu(t),
              left: t.right - Qu.arrowHorizontalOffset,
              name: "arrow_nw",
            }),
            southEastArrowNorthMiddleWest: (t, e) => ({
              top: Zu(t),
              left: t.right - 0.25 * e.width - Qu.arrowHorizontalOffset,
              name: "arrow_nmw",
            }),
            southEastArrowNorth: (t, e) => ({
              top: Zu(t),
              left: t.right - e.width / 2,
              name: "arrow_n",
            }),
            southEastArrowNorthMiddleEast: (t, e) => ({
              top: Zu(t),
              left: t.right - 0.75 * e.width + Qu.arrowHorizontalOffset,
              name: "arrow_nme",
            }),
            southEastArrowNorthEast: (t, e) => ({
              top: Zu(t),
              left: t.right - e.width + Qu.arrowHorizontalOffset,
              name: "arrow_ne",
            }),
          });
        i(58), i(60);
        const tm = pc("px");
        class em extends Gc {
          static get pluginName() {
            return "ContextualBalloon";
          }
          constructor(t) {
            super(t),
              (this.positionLimiter = () => {
                const t = this.editor.editing.view,
                  e = t.document.selection.editableElement;
                return e ? t.domConverter.mapViewToDom(e.root) : null;
              }),
              this.set("visibleView", null),
              (this.view = new Qu(t.locale)),
              t.ui.view.body.add(this.view),
              t.ui.focusTracker.add(this.view.element),
              (this._viewToStack = new Map()),
              (this._idToStack = new Map()),
              this.set("_numberOfStacks", 0),
              this.set("_singleViewMode", !1),
              (this._rotatorView = this._createRotatorView()),
              (this._fakePanelsView = this._createFakePanelsView());
          }
          hasView(t) {
            return Array.from(this._viewToStack.keys()).includes(t);
          }
          add(t) {
            if (this.hasView(t.view))
              throw new hi.b(
                "contextualballoon-add-view-exist: Cannot add configuration of the same view twice.",
                [this, t]
              );
            const e = t.stackId || "main";
            if (!this._idToStack.has(e))
              return (
                this._idToStack.set(e, new Map([[t.view, t]])),
                this._viewToStack.set(t.view, this._idToStack.get(e)),
                (this._numberOfStacks = this._idToStack.size),
                void (
                  (this._visibleStack && !t.singleViewMode) ||
                  this.showStack(e)
                )
              );
            const i = this._idToStack.get(e);
            t.singleViewMode && this.showStack(e),
              i.set(t.view, t),
              this._viewToStack.set(t.view, i),
              i === this._visibleStack && this._showView(t);
          }
          remove(t) {
            if (!this.hasView(t))
              throw new hi.b(
                "contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.",
                [this, t]
              );
            const e = this._viewToStack.get(t);
            this._singleViewMode &&
              this.visibleView === t &&
              (this._singleViewMode = !1),
              this.visibleView === t &&
                (1 === e.size
                  ? this._idToStack.size > 1
                    ? this._showNextStack()
                    : (this.view.hide(),
                      (this.visibleView = null),
                      this._rotatorView.hideView())
                  : this._showView(Array.from(e.values())[e.size - 2])),
              1 === e.size
                ? (this._idToStack.delete(this._getStackId(e)),
                  (this._numberOfStacks = this._idToStack.size))
                : e.delete(t),
              this._viewToStack.delete(t);
          }
          updatePosition(t) {
            t && (this._visibleStack.get(this.visibleView).position = t),
              this.view.pin(this._getBalloonPosition()),
              this._fakePanelsView.updatePosition();
          }
          showStack(t) {
            this.visibleStack = t;
            const e = this._idToStack.get(t);
            if (!e)
              throw new hi.b(
                "contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.",
                this
              );
            this._visibleStack !== e &&
              this._showView(Array.from(e.values()).pop());
          }
          get _visibleStack() {
            return this._viewToStack.get(this.visibleView);
          }
          _getStackId(t) {
            return Array.from(this._idToStack.entries()).find(
              (e) => e[1] === t
            )[0];
          }
          _showNextStack() {
            const t = Array.from(this._idToStack.values());
            let e = t.indexOf(this._visibleStack) + 1;
            t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
          }
          _showPrevStack() {
            const t = Array.from(this._idToStack.values());
            let e = t.indexOf(this._visibleStack) - 1;
            t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
          }
          _createRotatorView() {
            const t = new im(this.editor.locale),
              e = this.editor.locale.t;
            return (
              this.view.content.add(t),
              t
                .bind("isNavigationVisible")
                .to(
                  this,
                  "_numberOfStacks",
                  this,
                  "_singleViewMode",
                  (t, e) => !e && t > 1
                ),
              t.on("change:isNavigationVisible", () => this.updatePosition(), {
                priority: "low",
              }),
              t
                .bind("counter")
                .to(this, "visibleView", this, "_numberOfStacks", (t, i) => {
                  if (i < 2) return "";
                  const n =
                    Array.from(this._idToStack.values()).indexOf(
                      this._visibleStack
                    ) + 1;
                  return e("%0 of %1", [n, i]);
                }),
              t.buttonNextView.on("execute", () => {
                t.focusTracker.isFocused && this.editor.editing.view.focus(),
                  this._showNextStack();
              }),
              t.buttonPrevView.on("execute", () => {
                t.focusTracker.isFocused && this.editor.editing.view.focus(),
                  this._showPrevStack();
              }),
              t
            );
          }
          _createFakePanelsView() {
            const t = new nm(this.editor.locale, this.view);
            return (
              t
                .bind("numberOfPanels")
                .to(this, "_numberOfStacks", this, "_singleViewMode", (t, e) =>
                  !e && t >= 2 ? Math.min(t - 1, 2) : 0
                ),
              t.listenTo(this.view, "change:top", () => t.updatePosition()),
              t.listenTo(this.view, "change:left", () => t.updatePosition()),
              this.editor.ui.view.body.add(t),
              t
            );
          }
          _showView({
            view: t,
            balloonClassName: e = "",
            withArrow: i = !0,
            singleViewMode: n = !1,
          }) {
            (this.view.class = e),
              (this.view.withArrow = i),
              this._rotatorView.showView(t),
              (this.visibleView = t),
              this.view.pin(this._getBalloonPosition()),
              this._fakePanelsView.updatePosition(),
              n && (this._singleViewMode = !0);
          }
          _getBalloonPosition() {
            let t = Array.from(this._visibleStack.values()).pop().position;
            return (
              t &&
                !t.limiter &&
                (t = Object.assign({}, t, { limiter: this.positionLimiter })),
              t
            );
          }
        }
        class im extends lc {
          constructor(t) {
            super(t);
            const e = t.t,
              i = this.bindTemplate;
            this.set("isNavigationVisible", !0),
              (this.focusTracker = new Nl()),
              (this.buttonPrevView = this._createButtonView(
                e("Previous"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'
              )),
              (this.buttonNextView = this._createButtonView(
                e("Next"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'
              )),
              (this.content = this.createCollection()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-balloon-rotator"],
                  "z-index": "-1",
                },
                children: [
                  {
                    tag: "div",
                    attributes: {
                      class: [
                        "ck-balloon-rotator__navigation",
                        i.to("isNavigationVisible", (t) =>
                          t ? "" : "ck-hidden"
                        ),
                      ],
                    },
                    children: [
                      this.buttonPrevView,
                      {
                        tag: "span",
                        attributes: { class: ["ck-balloon-rotator__counter"] },
                        children: [{ text: i.to("counter") }],
                      },
                      this.buttonNextView,
                    ],
                  },
                  {
                    tag: "div",
                    attributes: { class: "ck-balloon-rotator__content" },
                    children: this.content,
                  },
                ],
              });
          }
          render() {
            super.render(), this.focusTracker.add(this.element);
          }
          showView(t) {
            this.hideView(), this.content.add(t);
          }
          hideView() {
            this.content.clear();
          }
          _createButtonView(t, e) {
            const i = new Oc(this.locale);
            return i.set({ label: t, icon: e, tooltip: !0 }), i;
          }
        }
        class nm extends lc {
          constructor(t, e) {
            super(t);
            const i = this.bindTemplate;
            this.set("top", 0),
              this.set("left", 0),
              this.set("height", 0),
              this.set("width", 0),
              this.set("numberOfPanels", 0),
              (this.content = this.createCollection()),
              (this._balloonPanelView = e),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck-fake-panel",
                    i.to("numberOfPanels", (t) => (t ? "" : "ck-hidden")),
                  ],
                  style: {
                    top: i.to("top", tm),
                    left: i.to("left", tm),
                    width: i.to("width", tm),
                    height: i.to("height", tm),
                  },
                },
                children: this.content,
              }),
              this.on("change:numberOfPanels", (t, e, i, n) => {
                i > n ? this._addPanels(i - n) : this._removePanels(n - i),
                  this.updatePosition();
              });
          }
          _addPanels(t) {
            for (; t--; ) {
              const t = new lc();
              t.setTemplate({ tag: "div" }),
                this.content.add(t),
                this.registerChild(t);
            }
          }
          _removePanels(t) {
            for (; t--; ) {
              const t = this.content.last;
              this.content.remove(t), this.deregisterChild(t), t.destroy();
            }
          }
          updatePosition() {
            if (this.numberOfPanels) {
              const { top: t, left: e } = this._balloonPanelView,
                { width: i, height: n } = new Kr(
                  this._balloonPanelView.element
                );
              Object.assign(this, { top: t, left: e, width: i, height: n });
            }
          }
        }
        function om(t) {
          const e = t.editing.view,
            i = Qu.defaultPositions;
          return {
            target: e.domConverter.viewToDom(
              e.document.selection.getSelectedElement()
            ),
            positions: [
              i.northArrowSouth,
              i.northArrowSouthWest,
              i.northArrowSouthEast,
              i.southArrowNorth,
              i.southArrowNorthWest,
              i.southArrowNorthEast,
            ],
          };
        }
        class rm extends Gc {
          static get requires() {
            return [em];
          }
          static get pluginName() {
            return "ImageTextAlternativeUI";
          }
          init() {
            this._createButton(), this._createForm();
          }
          destroy() {
            super.destroy(), this._form.destroy();
          }
          _createButton() {
            const t = this.editor,
              e = t.t;
            t.ui.componentFactory.add("imageTextAlternative", (i) => {
              const n = t.commands.get("imageTextAlternative"),
                o = new Oc(i);
              return (
                o.set({
                  label: e("Change image text alternative"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
                  tooltip: !0,
                }),
                o.bind("isEnabled").to(n, "isEnabled"),
                this.listenTo(o, "execute", () => {
                  this._showForm();
                }),
                o
              );
            });
          }
          _createForm() {
            const t = this.editor,
              e = t.editing.view.document;
            (this._balloon = this.editor.plugins.get("ContextualBalloon")),
              (this._form = new $u(t.locale)),
              this._form.render(),
              this.listenTo(this._form, "submit", () => {
                t.execute("imageTextAlternative", {
                  newValue: this._form.labeledInput.fieldView.element.value,
                }),
                  this._hideForm(!0);
              }),
              this.listenTo(this._form, "cancel", () => {
                this._hideForm(!0);
              }),
              this._form.keystrokes.set("Esc", (t, e) => {
                this._hideForm(!0), e();
              }),
              this.listenTo(t.ui, "update", () => {
                Rh(e.selection)
                  ? this._isVisible &&
                    (function (t) {
                      const e = t.plugins.get("ContextualBalloon");
                      if (Rh(t.editing.view.document.selection)) {
                        const i = om(t);
                        e.updatePosition(i);
                      }
                    })(t)
                  : this._hideForm(!0);
              }),
              Bc({
                emitter: this._form,
                activator: () => this._isVisible,
                contextElements: [this._balloon.view.element],
                callback: () => this._hideForm(),
              });
          }
          _showForm() {
            if (this._isVisible) return;
            const t = this.editor,
              e = t.commands.get("imageTextAlternative"),
              i = this._form.labeledInput;
            this._isInBalloon ||
              this._balloon.add({ view: this._form, position: om(t) }),
              (i.fieldView.value = i.fieldView.element.value = e.value || ""),
              this._form.labeledInput.fieldView.select();
          }
          _hideForm(t) {
            this._isInBalloon &&
              (this._form.focusTracker.isFocused &&
                this._form.saveButtonView.focus(),
              this._balloon.remove(this._form),
              t && this.editor.editing.view.focus());
          }
          get _isVisible() {
            return this._balloon.visibleView === this._form;
          }
          get _isInBalloon() {
            return this._balloon.hasView(this._form);
          }
        }
        class sm extends Gc {
          static get requires() {
            return [Vu, rm];
          }
          static get pluginName() {
            return "ImageTextAlternative";
          }
        }
        i(62);
        class am extends Gc {
          static get requires() {
            return [Fh, Du, sm];
          }
          static get pluginName() {
            return "Image";
          }
        }
        class lm extends lc {
          constructor(t) {
            super(t),
              (this.buttonView = new Oc(t)),
              (this._fileInputView = new cm(t)),
              this._fileInputView.bind("acceptedType").to(this),
              this._fileInputView.bind("allowMultipleFiles").to(this),
              this._fileInputView.delegate("done").to(this),
              this.setTemplate({
                tag: "span",
                attributes: { class: "ck-file-dialog-button" },
                children: [this.buttonView, this._fileInputView],
              }),
              this.buttonView.on("execute", () => {
                this._fileInputView.open();
              });
          }
          focus() {
            this.buttonView.focus();
          }
        }
        class cm extends lc {
          constructor(t) {
            super(t),
              this.set("acceptedType"),
              this.set("allowMultipleFiles", !1);
            const e = this.bindTemplate;
            this.setTemplate({
              tag: "input",
              attributes: {
                class: ["ck-hidden"],
                type: "file",
                tabindex: "-1",
                accept: e.to("acceptedType"),
                multiple: e.to("allowMultipleFiles"),
              },
              on: {
                change: e.to(() => {
                  this.element &&
                    this.element.files &&
                    this.element.files.length &&
                    this.fire("done", this.element.files),
                    (this.element.value = "");
                }),
              },
            });
          }
          open() {
            this.element.click();
          }
        }
        function dm(t) {
          const e = t.map((t) => t.replace("+", "\\+"));
          return new RegExp(`^image\\/(${e.join("|")})$`);
        }
        class hm extends Gc {
          init() {
            const t = this.editor,
              e = t.t;
            t.ui.componentFactory.add("imageUpload", (i) => {
              const n = new lm(i),
                o = t.commands.get("imageUpload"),
                r = t.config.get("image.upload.types"),
                s = dm(r);
              return (
                n.set({
                  acceptedType: r.map((t) => "image/" + t).join(","),
                  allowMultipleFiles: !0,
                }),
                n.buttonView.set({
                  label: e("Insert image"),
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
                  tooltip: !0,
                }),
                n.buttonView.bind("isEnabled").to(o),
                n.on("done", (e, i) => {
                  const n = Array.from(i).filter((t) => s.test(t.type));
                  n.length && t.execute("imageUpload", { file: n });
                }),
                n
              );
            });
          }
        }
        i(64), i(66), i(68);
        class um extends Gc {
          constructor(t) {
            super(t),
              (this.placeholder =
                "data:image/svg+xml;utf8," +
                encodeURIComponent(
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>'
                ));
          }
          init() {
            this.editor.editing.downcastDispatcher.on(
              "attribute:uploadStatus:image",
              (...t) => this.uploadStatusChange(...t)
            );
          }
          uploadStatusChange(t, e, i) {
            const n = this.editor,
              o = e.item,
              r = o.getAttribute("uploadId");
            if (!i.consumable.consume(e.item, t.name)) return;
            const s = n.plugins.get(th),
              a = r ? e.attributeNewValue : null,
              l = this.placeholder,
              c = n.editing.mapper.toViewElement(o),
              d = i.writer;
            if ("reading" == a) return mm(c, d), void gm(l, c, d);
            if ("uploading" == a) {
              const t = s.loaders.get(r);
              return (
                mm(c, d),
                void (t
                  ? (fm(c, d),
                    (function (t, e, i, n) {
                      const o = (function (t) {
                        const e = t.createUIElement("div", {
                          class: "ck-progress-bar",
                        });
                        return t.setCustomProperty("progressBar", !0, e), e;
                      })(e);
                      e.insert(e.createPositionAt(t, "end"), o),
                        i.on("change:uploadedPercent", (t, e, i) => {
                          n.change((t) => {
                            t.setStyle("width", i + "%", o);
                          });
                        });
                    })(c, d, t, n.editing.view),
                    (function (t, e, i) {
                      if (i.data) {
                        const n = zh(t);
                        e.setAttribute("src", i.data, n);
                      }
                    })(c, d, t))
                  : gm(l, c, d))
              );
            }
            "complete" == a &&
              s.loaders.get(r) &&
              (function (t, e, i) {
                const n = e.createUIElement("div", {
                  class: "ck-image-upload-complete-icon",
                });
                e.insert(e.createPositionAt(t, "end"), n),
                  setTimeout(() => {
                    i.change((t) => t.remove(t.createRangeOn(n)));
                  }, 3e3);
              })(c, d, n.editing.view),
              (function (t, e) {
                bm(t, e, "progressBar");
              })(c, d),
              fm(c, d),
              (function (t, e) {
                e.removeClass("ck-appear", t);
              })(c, d);
          }
        }
        function mm(t, e) {
          t.hasClass("ck-appear") || e.addClass("ck-appear", t);
        }
        function gm(t, e, i) {
          e.hasClass("ck-image-upload-placeholder") ||
            i.addClass("ck-image-upload-placeholder", e);
          const n = zh(e);
          n.getAttribute("src") !== t && i.setAttribute("src", t, n),
            pm(e, "placeholder") ||
              i.insert(
                i.createPositionAfter(n),
                (function (t) {
                  const e = t.createUIElement("div", {
                    class: "ck-upload-placeholder-loader",
                  });
                  return t.setCustomProperty("placeholder", !0, e), e;
                })(i)
              );
        }
        function fm(t, e) {
          t.hasClass("ck-image-upload-placeholder") &&
            e.removeClass("ck-image-upload-placeholder", t),
            bm(t, e, "placeholder");
        }
        function pm(t, e) {
          for (const i of t.getChildren()) if (i.getCustomProperty(e)) return i;
        }
        function bm(t, e, i) {
          const n = pm(t, i);
          n && e.remove(e.createRangeOn(n));
        }
        class wm {
          constructor(t) {
            this.document = t;
          }
          createDocumentFragment(t) {
            return new xo(this.document, t);
          }
          createElement(t, e, i) {
            return new Nn(this.document, t, e, i);
          }
          createText(t) {
            return new Ni(this.document, t);
          }
          clone(t, e = !1) {
            return t._clone(e);
          }
          appendChild(t, e) {
            return e._appendChild(t);
          }
          insertChild(t, e, i) {
            return i._insertChild(t, e);
          }
          removeChildren(t, e, i) {
            return i._removeChildren(t, e);
          }
          remove(t) {
            const e = t.parent;
            return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
          }
          replace(t, e) {
            const i = t.parent;
            if (i) {
              const n = i.getChildIndex(t);
              return (
                this.removeChildren(n, 1, i), this.insertChild(n, e, i), !0
              );
            }
            return !1;
          }
          unwrapElement(t) {
            const e = t.parent;
            if (e) {
              const i = e.getChildIndex(t);
              this.remove(t), this.insertChild(i, t.getChildren(), e);
            }
          }
          rename(t, e) {
            const i = new Nn(
              this.document,
              t,
              e.getAttributes(),
              e.getChildren()
            );
            return this.replace(e, i) ? i : null;
          }
          setAttribute(t, e, i) {
            i._setAttribute(t, e);
          }
          removeAttribute(t, e) {
            e._removeAttribute(t);
          }
          addClass(t, e) {
            e._addClass(t);
          }
          removeClass(t, e) {
            e._removeClass(t);
          }
          setStyle(t, e, i) {
            y(t) && void 0 === i && (i = e), i._setStyle(t, e);
          }
          removeStyle(t, e) {
            e._removeStyle(t);
          }
          setCustomProperty(t, e, i) {
            i._setCustomProperty(t, e);
          }
          removeCustomProperty(t, e) {
            return e._removeCustomProperty(t);
          }
          createPositionAt(t, e) {
            return Kn._createAt(t, e);
          }
          createPositionAfter(t) {
            return Kn._createAfter(t);
          }
          createPositionBefore(t) {
            return Kn._createBefore(t);
          }
          createRange(t, e) {
            return new Zn(t, e);
          }
          createRangeOn(t) {
            return Zn._createOn(t);
          }
          createRangeIn(t) {
            return Zn._createIn(t);
          }
          createSelection(t, e, i) {
            return new io(t, e, i);
          }
        }
        class _m extends ed {
          refresh() {
            this.isEnabled = Dh(this.editor.model);
          }
          execute(t) {
            const e = this.editor,
              i = e.model,
              n = e.plugins.get(th);
            i.change((e) => {
              const o = Array.isArray(t.file) ? t.file : [t.file];
              for (const t of o) km(e, i, n, t);
            });
          }
        }
        function km(t, e, i, n) {
          const o = i.createLoader(n);
          o && jh(t, e, { uploadId: o.id });
        }
        class vm extends Gc {
          static get requires() {
            return [th, Au, td];
          }
          static get pluginName() {
            return "ImageUploadEditing";
          }
          constructor(t) {
            super(t),
              t.config.define("image", {
                upload: {
                  types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"],
                },
              });
          }
          init() {
            const t = this.editor,
              e = t.model.document,
              i = t.model.schema,
              n = t.conversion,
              o = t.plugins.get(th),
              r = dm(t.config.get("image.upload.types"));
            i.extend("image", {
              allowAttributes: ["uploadId", "uploadStatus"],
            }),
              t.commands.add("imageUpload", new _m(t)),
              n
                .for("upcast")
                .attributeToAttribute({
                  view: { name: "img", key: "uploadId" },
                  model: "uploadId",
                }),
              this.listenTo(
                t.editing.view.document,
                "clipboardInput",
                (e, i) => {
                  if (
                    ((n = i.dataTransfer),
                    Array.from(n.types).includes("text/html") &&
                      "" !== n.getData("text/html"))
                  )
                    return;
                  var n;
                  const o = Array.from(i.dataTransfer.files).filter(
                      (t) => !!t && r.test(t.type)
                    ),
                    s = i.targetRanges.map((e) =>
                      t.editing.mapper.toModelRange(e)
                    );
                  t.model.change((i) => {
                    i.setSelection(s),
                      o.length &&
                        (e.stop(),
                        t.model.enqueueChange("default", () => {
                          t.execute("imageUpload", { file: o });
                        }));
                  });
                }
              ),
              this.listenTo(
                t.plugins.get(td),
                "inputTransformation",
                (e, i) => {
                  const n = Array.from(t.editing.view.createRangeIn(i.content))
                    .filter((t) => {
                      return (
                        !(
                          !(e = t.item).is("element", "img") ||
                          !e.getAttribute("src")
                        ) &&
                        (e
                          .getAttribute("src")
                          .match(/^data:image\/\w+;base64,/g) ||
                          e.getAttribute("src").match(/^blob:/g)) &&
                        !t.item.getAttribute("uploadProcessed")
                      );
                      var e;
                    })
                    .map((t) => {
                      return {
                        promise:
                          ((e = t.item),
                          new Promise((t, i) => {
                            const n = e.getAttribute("src");
                            fetch(n)
                              .then((t) => t.blob())
                              .then((e) => {
                                const i = (function (t, e) {
                                    return t.type
                                      ? t.type
                                      : e.match(/data:(image\/\w+);base64/)
                                      ? e
                                          .match(/data:(image\/\w+);base64/)[1]
                                          .toLowerCase()
                                      : "image/jpeg";
                                  })(e, n),
                                  o = i.replace("image/", ""),
                                  r = new File([e], "image." + o, { type: i });
                                t(r);
                              })
                              .catch(i);
                          })),
                        imageElement: t.item,
                      };
                      var e;
                    });
                  if (!n.length) return;
                  const r = new wm(t.editing.view.document);
                  for (const t of n) {
                    r.setAttribute("uploadProcessed", !0, t.imageElement);
                    const e = o.createLoader(t.promise);
                    e &&
                      (r.setAttribute("src", "", t.imageElement),
                      r.setAttribute("uploadId", e.id, t.imageElement));
                  }
                }
              ),
              t.editing.view.document.on("dragover", (t, e) => {
                e.preventDefault();
              }),
              e.on("change", () => {
                const i = e.differ.getChanges({
                  includeChangesInGraveyard: !0,
                });
                for (const e of i)
                  if ("insert" == e.type && "$text" != e.name) {
                    const i = e.position.nodeAfter,
                      n = "$graveyard" == e.position.root.rootName;
                    for (const e of ym(t, i)) {
                      const t = e.getAttribute("uploadId");
                      if (!t) continue;
                      const i = o.loaders.get(t);
                      i &&
                        (n
                          ? i.abort()
                          : "idle" == i.status && this._readAndUpload(i, e));
                    }
                  }
              });
          }
          _readAndUpload(t, e) {
            const i = this.editor,
              n = i.model,
              o = i.locale.t,
              r = i.plugins.get(th),
              s = i.plugins.get(Au);
            return (
              n.enqueueChange("transparent", (t) => {
                t.setAttribute("uploadStatus", "reading", e);
              }),
              t
                .read()
                .then(() => {
                  const o = t.upload();
                  if (uo.isSafari) {
                    const t = zh(i.editing.mapper.toViewElement(e));
                    i.editing.view.once("render", () => {
                      if (!t.parent) return;
                      const e = i.editing.view.domConverter.mapViewToDom(
                        t.parent
                      );
                      if (!e) return;
                      const n = e.style.display;
                      (e.style.display = "none"),
                        (e._ckHack = e.offsetHeight),
                        (e.style.display = n);
                    });
                  }
                  return (
                    n.enqueueChange("transparent", (t) => {
                      t.setAttribute("uploadStatus", "uploading", e);
                    }),
                    o
                  );
                })
                .then((t) => {
                  n.enqueueChange("transparent", (i) => {
                    i.setAttributes(
                      { uploadStatus: "complete", src: t.default },
                      e
                    ),
                      this._parseAndSetSrcsetAttributeOnImage(t, e, i);
                  }),
                    a();
                })
                .catch((i) => {
                  if ("error" !== t.status && "aborted" !== t.status) throw i;
                  "error" == t.status &&
                    i &&
                    s.showWarning(i, {
                      title: o("Upload failed"),
                      namespace: "upload",
                    }),
                    a(),
                    n.enqueueChange("transparent", (t) => {
                      t.remove(e);
                    });
                })
            );
            function a() {
              n.enqueueChange("transparent", (t) => {
                t.removeAttribute("uploadId", e),
                  t.removeAttribute("uploadStatus", e);
              }),
                r.destroyLoader(t);
            }
          }
          _parseAndSetSrcsetAttributeOnImage(t, e, i) {
            let n = 0;
            const o = Object.keys(t)
              .filter((t) => {
                const e = parseInt(t, 10);
                if (!isNaN(e)) return (n = Math.max(n, e)), !0;
              })
              .map((e) => `${t[e]} ${e}w`)
              .join(", ");
            "" != o && i.setAttribute("srcset", { data: o, width: n }, e);
          }
        }
        function ym(t, e) {
          return Array.from(t.model.createRangeOn(e))
            .filter((t) => t.item.is("image"))
            .map((t) => t.item);
        }
        class xm extends Gc {
          static get pluginName() {
            return "ImageUpload";
          }
          static get requires() {
            return [vm, hm, um];
          }
        }
        class Am extends ed {
          refresh() {
            const t = this.editor.model,
              e = fh(t.document.selection.getSelectedBlocks());
            (this.value = !!e && e.is("paragraph")),
              (this.isEnabled = !!e && Cm(e, t.schema));
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.document;
            e.change((n) => {
              const o = (t.selection || i.selection).getSelectedBlocks();
              for (const t of o)
                !t.is("paragraph") &&
                  Cm(t, e.schema) &&
                  n.rename(t, "paragraph");
            });
          }
        }
        function Cm(t, e) {
          return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
        }
        class Tm extends Gc {
          static get pluginName() {
            return "Paragraph";
          }
          init() {
            const t = this.editor,
              e = t.model,
              i = t.data;
            t.commands.add("paragraph", new Am(t)),
              e.schema.register("paragraph", { inheritAllFrom: "$block" }),
              t.conversion.elementToElement({ model: "paragraph", view: "p" }),
              t.conversion
                .for("upcast")
                .elementToElement({
                  model: (t, e) =>
                    Tm.paragraphLikeElements.has(t.name)
                      ? t.isEmpty
                        ? null
                        : e.createElement("paragraph")
                      : null,
                  converterPriority: "low",
                }),
              i.upcastDispatcher.on(
                "element",
                (t, e, i) => {
                  i.consumable.test(e.viewItem, { name: e.viewItem.name }) &&
                    Em(e.viewItem, e.modelCursor, i.schema) &&
                    Object.assign(e, Mm(e.viewItem, e.modelCursor, i));
                },
                { priority: "low" }
              ),
              i.upcastDispatcher.on(
                "text",
                (t, e, i) => {
                  e.modelRange ||
                    (Em(e.viewItem, e.modelCursor, i.schema) &&
                      Object.assign(e, Mm(e.viewItem, e.modelCursor, i)));
                },
                { priority: "lowest" }
              ),
              e.document.registerPostFixer((t) =>
                this._autoparagraphEmptyRoots(t)
              ),
              t.data.on(
                "ready",
                () => {
                  e.enqueueChange("transparent", (t) =>
                    this._autoparagraphEmptyRoots(t)
                  );
                },
                { priority: "lowest" }
              );
          }
          _autoparagraphEmptyRoots(t) {
            const e = this.editor.model;
            for (const i of e.document.getRootNames()) {
              const n = e.document.getRoot(i);
              if (
                n.isEmpty &&
                "$graveyard" != n.rootName &&
                e.schema.checkChild(n, "paragraph")
              )
                return t.insertElement("paragraph", n), !0;
            }
          }
        }
        function Mm(t, e, i) {
          const n = i.writer.createElement("paragraph");
          return (
            i.writer.insert(n, e),
            i.convertItem(t, i.writer.createPositionAt(n, 0))
          );
        }
        function Em(t, e, i) {
          const n = i.createContext(e);
          return (
            !!i.checkChild(n, "paragraph") &&
            !!i.checkChild(n.push("paragraph"), t)
          );
        }
        Tm.paragraphLikeElements = new Set([
          "blockquote",
          "dd",
          "div",
          "dt",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "li",
          "p",
          "td",
        ]);
        class Pm extends ed {
          constructor(t, e) {
            super(t), (this.modelElements = e);
          }
          refresh() {
            const t = fh(
              this.editor.model.document.selection.getSelectedBlocks()
            );
            (this.value = !!t && this.modelElements.includes(t.name) && t.name),
              (this.isEnabled =
                !!t &&
                this.modelElements.some((e) =>
                  Sm(t, e, this.editor.model.schema)
                ));
          }
          execute(t) {
            const e = this.editor.model,
              i = e.document,
              n = t.value;
            e.change((t) => {
              const o = Array.from(i.selection.getSelectedBlocks()).filter(
                (t) => Sm(t, n, e.schema)
              );
              for (const e of o) e.is(n) || t.rename(e, n);
            });
          }
        }
        function Sm(t, e, i) {
          return i.checkChild(t.parent, e) && !i.isObject(t);
        }
        class Im extends Gc {
          static get pluginName() {
            return "HeadingEditing";
          }
          constructor(t) {
            super(t),
              t.config.define("heading", {
                options: [
                  {
                    model: "paragraph",
                    title: "Paragraph",
                    class: "ck-heading_paragraph",
                  },
                  {
                    model: "heading1",
                    view: "h2",
                    title: "Heading 1",
                    class: "ck-heading_heading1",
                  },
                  {
                    model: "heading2",
                    view: "h3",
                    title: "Heading 2",
                    class: "ck-heading_heading2",
                  },
                  {
                    model: "heading3",
                    view: "h4",
                    title: "Heading 3",
                    class: "ck-heading_heading3",
                  },
                ],
              });
          }
          static get requires() {
            return [Tm];
          }
          init() {
            const t = this.editor,
              e = t.config.get("heading.options"),
              i = [];
            for (const n of e)
              "paragraph" !== n.model &&
                (t.model.schema.register(n.model, { inheritAllFrom: "$block" }),
                t.conversion.elementToElement(n),
                i.push(n.model));
            this._addDefaultH1Conversion(t),
              t.commands.add("heading", new Pm(t, i));
          }
          afterInit() {
            const t = this.editor,
              e = t.commands.get("enter"),
              i = t.config.get("heading.options");
            e &&
              this.listenTo(e, "afterExecute", (e, n) => {
                const o = t.model.document.selection.getFirstPosition().parent;
                i.some((t) => o.is(t.model)) &&
                  !o.is("paragraph") &&
                  0 === o.childCount &&
                  n.writer.rename(o, "paragraph");
              });
          }
          _addDefaultH1Conversion(t) {
            t.conversion
              .for("upcast")
              .elementToElement({
                model: "heading1",
                view: "h1",
                converterPriority: di.get("low") + 1,
              });
          }
        }
        class Om {
          constructor(t, e) {
            e && Dn(this, e), t && this.set(t);
          }
        }
        yi(Om, Hn);
        i(11);
        class Nm extends Gc {
          init() {
            const t = this.editor,
              e = t.t,
              i = (function (t) {
                const e = t.t,
                  i = {
                    Paragraph: e("Paragraph"),
                    "Heading 1": e("Heading 1"),
                    "Heading 2": e("Heading 2"),
                    "Heading 3": e("Heading 3"),
                    "Heading 4": e("Heading 4"),
                    "Heading 5": e("Heading 5"),
                    "Heading 6": e("Heading 6"),
                  };
                return t.config.get("heading.options").map((t) => {
                  const e = i[t.title];
                  return e && e != t.title && (t.title = e), t;
                });
              })(t),
              n = e("Choose heading"),
              o = e("Heading");
            t.ui.componentFactory.add("heading", (e) => {
              const r = {},
                s = new xi(),
                a = t.commands.get("heading"),
                l = t.commands.get("paragraph"),
                c = [a];
              for (const t of i) {
                const e = {
                  type: "button",
                  model: new Om({
                    label: t.title,
                    class: t.class,
                    withText: !0,
                  }),
                };
                "paragraph" === t.model
                  ? (e.model.bind("isOn").to(l, "value"),
                    e.model.set("commandName", "paragraph"),
                    c.push(l))
                  : (e.model.bind("isOn").to(a, "value", (e) => e === t.model),
                    e.model.set({
                      commandName: "heading",
                      commandValue: t.model,
                    })),
                  s.add(e),
                  (r[t.model] = t.title);
              }
              const d = Vc(e);
              return (
                Hc(d, s),
                d.buttonView.set({ isOn: !1, withText: !0, tooltip: o }),
                d.extendTemplate({
                  attributes: { class: ["ck-heading-dropdown"] },
                }),
                d
                  .bind("isEnabled")
                  .toMany(c, "isEnabled", (...t) => t.some((t) => t)),
                d.buttonView
                  .bind("label")
                  .to(a, "value", l, "value", (t, e) => {
                    const i = t || (e && "paragraph");
                    return r[i] ? r[i] : n;
                  }),
                this.listenTo(d, "execute", (e) => {
                  t.execute(
                    e.source.commandName,
                    e.source.commandValue
                      ? { value: e.source.commandValue }
                      : void 0
                  ),
                    t.editing.view.focus();
                }),
                d
              );
            });
          }
        }
        function Rm(t) {
          for (const e of t.getChildren()) if (e && e.is("caption")) return e;
          return null;
        }
        function Lm(t) {
          const e = t.parent;
          return "figcaption" == t.name &&
            e &&
            "figure" == e.name &&
            e.hasClass("image")
            ? { name: !0 }
            : null;
        }
        class jm extends Gc {
          static get pluginName() {
            return "ImageCaptionEditing";
          }
          init() {
            const t = this.editor,
              e = t.editing.view,
              i = t.model.schema,
              n = t.data,
              o = t.editing,
              r = t.t;
            i.register("caption", {
              allowIn: "image",
              allowContentOf: "$block",
              isLimit: !0,
            }),
              t.model.document.registerPostFixer((t) =>
                this._insertMissingModelCaptionElement(t)
              ),
              t.conversion
                .for("upcast")
                .elementToElement({ view: Lm, model: "caption" });
            n.downcastDispatcher.on(
              "insert:caption",
              Dm((t) => t.createContainerElement("figcaption"), !1)
            );
            const s = (function (t, e) {
              return (i) => {
                const n = i.createEditableElement("figcaption");
                return (
                  i.setCustomProperty("imageCaption", !0, n),
                  jl({ view: t, element: n, text: e }),
                  Ih(n, i)
                );
              };
            })(e, r("Enter image caption"));
            o.downcastDispatcher.on("insert:caption", Dm(s)),
              o.downcastDispatcher.on(
                "insert",
                this._fixCaptionVisibility((t) => t.item),
                { priority: "high" }
              ),
              o.downcastDispatcher.on(
                "remove",
                this._fixCaptionVisibility((t) => t.position.parent),
                { priority: "high" }
              ),
              e.document.registerPostFixer((t) =>
                this._updateCaptionVisibility(t)
              );
          }
          _updateCaptionVisibility(t) {
            const e = this.editor.editing.mapper,
              i = this._lastSelectedCaption;
            let n;
            const o = this.editor.model.document.selection,
              r = o.getSelectedElement();
            if (r && r.is("image")) {
              const t = Rm(r);
              n = e.toViewElement(t);
            }
            const s = zm(o.getFirstPosition().parent);
            if ((s && (n = e.toViewElement(s)), n))
              return i
                ? (i === n || (Bm(i, t), (this._lastSelectedCaption = n)),
                  Vm(n, t))
                : ((this._lastSelectedCaption = n), Vm(n, t));
            if (i) {
              const e = Bm(i, t);
              return (this._lastSelectedCaption = null), e;
            }
            return !1;
          }
          _fixCaptionVisibility(t) {
            return (e, i, n) => {
              const o = zm(t(i)),
                r = this.editor.editing.mapper,
                s = n.writer;
              if (o) {
                const t = r.toViewElement(o);
                t &&
                  (o.childCount
                    ? s.removeClass("ck-hidden", t)
                    : s.addClass("ck-hidden", t));
              }
            };
          }
          _insertMissingModelCaptionElement(t) {
            const e = this.editor.model,
              i = e.document.differ.getChanges(),
              n = [];
            for (const t of i)
              if ("insert" == t.type && "$text" != t.name) {
                const i = t.position.nodeAfter;
                if (
                  (i.is("image") && !Rm(i) && n.push(i),
                  !i.is("image") && i.childCount)
                )
                  for (const t of e.createRangeIn(i).getItems())
                    t.is("image") && !Rm(t) && n.push(t);
              }
            for (const e of n) t.appendElement("caption", e);
            return !!n.length;
          }
        }
        function Dm(t, e = !0) {
          return (i, n, o) => {
            const r = n.item;
            if ((r.childCount || e) && Lh(r.parent)) {
              if (!o.consumable.consume(n.item, "insert")) return;
              const e = o.mapper.toViewElement(n.range.start.parent),
                i = t(o.writer),
                s = o.writer;
              r.childCount || s.addClass("ck-hidden", i),
                (function (t, e, i, n) {
                  const o = n.writer.createPositionAt(i, "end");
                  n.writer.insert(o, t), n.mapper.bindElements(e, t);
                })(i, n.item, e, o);
            }
          };
        }
        function zm(t) {
          const e = t
            .getAncestors({ includeSelf: !0 })
            .find((t) => "caption" == t.name);
          return e && e.parent && "image" == e.parent.name ? e : null;
        }
        function Bm(t, e) {
          return (
            !t.childCount &&
            !t.hasClass("ck-hidden") &&
            (e.addClass("ck-hidden", t), !0)
          );
        }
        function Vm(t, e) {
          return (
            !!t.hasClass("ck-hidden") && (e.removeClass("ck-hidden", t), !0)
          );
        }
        i(71);
        class Fm extends ed {
          constructor(t, e) {
            super(t),
              (this.defaultStyle = !1),
              (this.styles = e.reduce(
                (t, e) => (
                  (t[e.name] = e),
                  e.isDefault && (this.defaultStyle = e.name),
                  t
                ),
                {}
              ));
          }
          refresh() {
            const t = this.editor.model.document.selection.getSelectedElement();
            if (((this.isEnabled = Lh(t)), t))
              if (t.hasAttribute("imageStyle")) {
                const e = t.getAttribute("imageStyle");
                this.value = !!this.styles[e] && e;
              } else this.value = this.defaultStyle;
            else this.value = !1;
          }
          execute(t) {
            const e = t.value,
              i = this.editor.model,
              n = i.document.selection.getSelectedElement();
            i.change((t) => {
              this.styles[e].isDefault
                ? t.removeAttribute("imageStyle", n)
                : t.setAttribute("imageStyle", e, n);
            });
          }
        }
        function Hm(t, e) {
          for (const i of e) if (i.name === t) return i;
        }
        var Um =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>',
          Wm =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" strokeLinejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>',
          qm =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>',
          Ym =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
        const $m = {
            full: {
              name: "full",
              title: "Full size image",
              icon: Um,
              isDefault: !0,
            },
            side: {
              name: "side",
              title: "Side image",
              icon: Ym,
              className: "image-style-side",
            },
            alignLeft: {
              name: "alignLeft",
              title: "Left aligned image",
              icon: Wm,
              className: "image-style-align-left",
            },
            alignCenter: {
              name: "alignCenter",
              title: "Centered image",
              icon: qm,
              className: "image-style-align-center",
            },
            alignRight: {
              name: "alignRight",
              title: "Right aligned image",
              icon: Ym,
              className: "image-style-align-right",
            },
          },
          Jm = { full: Um, left: Wm, right: Ym, center: qm };
        function Gm(t = []) {
          return t.map(Qm);
        }
        function Qm(t) {
          if ("string" == typeof t) {
            const e = t;
            $m[e]
              ? (t = Object.assign({}, $m[e]))
              : (console.warn(
                  Object(hi.a)(
                    "image-style-not-found: There is no such image style of given name."
                  ),
                  { name: e }
                ),
                (t = { name: e }));
          } else if ($m[t.name]) {
            const e = $m[t.name],
              i = Object.assign({}, t);
            for (const n in e) t.hasOwnProperty(n) || (i[n] = e[n]);
            t = i;
          }
          return (
            "string" == typeof t.icon && Jm[t.icon] && (t.icon = Jm[t.icon]), t
          );
        }
        class Xm extends Gc {
          static get pluginName() {
            return "ImageStyleEditing";
          }
          init() {
            const t = this.editor,
              e = t.model.schema,
              i = t.data,
              n = t.editing;
            t.config.define("image.styles", ["full", "side"]);
            const o = Gm(t.config.get("image.styles"));
            e.extend("image", { allowAttributes: "imageStyle" });
            const r = (function (t) {
              return (e, i, n) => {
                if (!n.consumable.consume(i.item, e.name)) return;
                const o = Hm(i.attributeNewValue, t),
                  r = Hm(i.attributeOldValue, t),
                  s = n.mapper.toViewElement(i.item),
                  a = n.writer;
                r && a.removeClass(r.className, s),
                  o && a.addClass(o.className, s);
              };
            })(o);
            n.downcastDispatcher.on("attribute:imageStyle:image", r),
              i.downcastDispatcher.on("attribute:imageStyle:image", r),
              i.upcastDispatcher.on(
                "element:figure",
                (function (t) {
                  const e = t.filter((t) => !t.isDefault);
                  return (t, i, n) => {
                    if (!i.modelRange) return;
                    const o = i.viewItem,
                      r = fh(i.modelRange.getItems());
                    if (n.schema.checkAttribute(r, "imageStyle"))
                      for (const t of e)
                        n.consumable.consume(o, { classes: t.className }) &&
                          n.writer.setAttribute("imageStyle", t.name, r);
                  };
                })(o),
                { priority: "low" }
              ),
              t.commands.add("imageStyle", new Fm(t, o));
          }
        }
        i(73);
        class Km extends Gc {
          static get pluginName() {
            return "ImageStyleUI";
          }
          get localizedDefaultStylesTitles() {
            const t = this.editor.t;
            return {
              "Full size image": t("Full size image"),
              "Side image": t("Side image"),
              "Left aligned image": t("Left aligned image"),
              "Centered image": t("Centered image"),
              "Right aligned image": t("Right aligned image"),
            };
          }
          init() {
            const t = (function (t, e) {
              for (const i of t) e[i.title] && (i.title = e[i.title]);
              return t;
            })(
              Gm(this.editor.config.get("image.styles")),
              this.localizedDefaultStylesTitles
            );
            for (const e of t) this._createButton(e);
          }
          _createButton(t) {
            const e = this.editor,
              i = "imageStyle:" + t.name;
            e.ui.componentFactory.add(i, (i) => {
              const n = e.commands.get("imageStyle"),
                o = new Oc(i);
              return (
                o.set({
                  label: t.title,
                  icon: t.icon,
                  tooltip: !0,
                  isToggleable: !0,
                }),
                o.bind("isEnabled").to(n, "isEnabled"),
                o.bind("isOn").to(n, "value", (e) => e === t.name),
                this.listenTo(o, "execute", () => {
                  e.execute("imageStyle", { value: t.name }),
                    e.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        class Zm extends Gc {
          static get requires() {
            return [em];
          }
          static get pluginName() {
            return "WidgetToolbarRepository";
          }
          init() {
            const t = this.editor;
            if (t.plugins.has("BalloonToolbar")) {
              const e = t.plugins.get("BalloonToolbar");
              this.listenTo(
                e,
                "show",
                (e) => {
                  (function (t) {
                    const e = t.getSelectedElement();
                    return !(!e || !Eh(e));
                  })(t.editing.view.document.selection) && e.stop();
                },
                { priority: "high" }
              );
            }
            (this._toolbarDefinitions = new Map()),
              (this._balloon = this.editor.plugins.get("ContextualBalloon")),
              this.on("change:isEnabled", () => {
                this._updateToolbarsVisibility();
              }),
              this.listenTo(t.ui, "update", () => {
                this._updateToolbarsVisibility();
              }),
              this.listenTo(
                t.ui.focusTracker,
                "change:isFocused",
                () => {
                  this._updateToolbarsVisibility();
                },
                { priority: "low" }
              );
          }
          destroy() {
            super.destroy();
            for (const t of this._toolbarDefinitions.values()) t.view.destroy();
          }
          register(
            t,
            {
              ariaLabel: e,
              items: i,
              getRelatedElement: n,
              balloonClassName: o = "ck-toolbar-container",
            }
          ) {
            const r = this.editor,
              s = r.t,
              a = new Uc(r.locale);
            if (
              ((a.ariaLabel = e || s("Widget toolbar")),
              this._toolbarDefinitions.has(t))
            )
              throw new hi.b(
                "widget-toolbar-duplicated: Toolbar with the given id was already added.",
                this,
                { toolbarId: t }
              );
            a.fillFromConfig(i, r.ui.componentFactory),
              this._toolbarDefinitions.set(t, {
                view: a,
                getRelatedElement: n,
                balloonClassName: o,
              });
          }
          _updateToolbarsVisibility() {
            let t = 0,
              e = null,
              i = null;
            for (const n of this._toolbarDefinitions.values()) {
              const o = n.getRelatedElement(
                this.editor.editing.view.document.selection
              );
              if (this.isEnabled && o)
                if (this.editor.ui.focusTracker.isFocused) {
                  const r = o.getAncestors().length;
                  r > t && ((t = r), (e = o), (i = n));
                } else this._isToolbarVisible(n) && this._hideToolbar(n);
              else this._isToolbarInBalloon(n) && this._hideToolbar(n);
            }
            i && this._showToolbar(i, e);
          }
          _hideToolbar(t) {
            this._balloon.remove(t.view),
              this.stopListening(this._balloon, "change:visibleView");
          }
          _showToolbar(t, e) {
            this._isToolbarVisible(t)
              ? tg(this.editor, e)
              : this._isToolbarInBalloon(t) ||
                (this._balloon.add({
                  view: t.view,
                  position: eg(this.editor, e),
                  balloonClassName: t.balloonClassName,
                }),
                this.listenTo(this._balloon, "change:visibleView", () => {
                  for (const t of this._toolbarDefinitions.values())
                    if (this._isToolbarVisible(t)) {
                      const e = t.getRelatedElement(
                        this.editor.editing.view.document.selection
                      );
                      tg(this.editor, e);
                    }
                }));
          }
          _isToolbarVisible(t) {
            return this._balloon.visibleView === t.view;
          }
          _isToolbarInBalloon(t) {
            return this._balloon.hasView(t.view);
          }
        }
        function tg(t, e) {
          const i = t.plugins.get("ContextualBalloon"),
            n = eg(t, e);
          i.updatePosition(n);
        }
        function eg(t, e) {
          const i = t.editing.view,
            n = Qu.defaultPositions;
          return {
            target: i.domConverter.mapViewToDom(e),
            positions: [
              n.northArrowSouth,
              n.northArrowSouthWest,
              n.northArrowSouthEast,
              n.southArrowNorth,
              n.southArrowNorthWest,
              n.southArrowNorthEast,
            ],
          };
        }
        class ig extends ed {
          constructor(t) {
            super(t), (this._childCommands = []);
          }
          refresh() {}
          execute(...t) {
            this._getFirstEnabledCommand().execute(t);
          }
          registerChildCommand(t) {
            this._childCommands.push(t),
              t.on("change:isEnabled", () => this._checkEnabled()),
              this._checkEnabled();
          }
          _checkEnabled() {
            this.isEnabled = !!this._getFirstEnabledCommand();
          }
          _getFirstEnabledCommand() {
            return this._childCommands.find((t) => t.isEnabled);
          }
        }
        class ng extends Gc {
          static get pluginName() {
            return "IndentEditing";
          }
          init() {
            const t = this.editor;
            t.commands.add("indent", new ig(t)),
              t.commands.add("outdent", new ig(t));
          }
        }
        var og =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95L5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
          rg =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
        class sg extends Gc {
          static get pluginName() {
            return "IndentUI";
          }
          init() {
            const t = this.editor,
              e = t.locale,
              i = t.t,
              n = "ltr" == e.uiLanguageDirection ? og : rg,
              o = "ltr" == e.uiLanguageDirection ? rg : og;
            this._defineButton("indent", i("Increase indent"), n),
              this._defineButton("outdent", i("Decrease indent"), o);
          }
          _defineButton(t, e, i) {
            const n = this.editor;
            n.ui.componentFactory.add(t, (o) => {
              const r = n.commands.get(t),
                s = new Oc(o);
              return (
                s.set({ label: e, icon: i, tooltip: !0 }),
                s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"),
                this.listenTo(s, "execute", () => {
                  n.execute(t), n.editing.view.focus();
                }),
                s
              );
            });
          }
        }
        class ag extends Or {
          constructor(t) {
            super(t), (this.domEventType = "click");
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
        }
        i(75);
        class lg extends lc {
          constructor(t, e) {
            super(t);
            const i = t.t;
            (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              (this.urlInputView = this._createUrlInput()),
              (this.saveButtonView = this._createButton(
                i("Save"),
                qu,
                "ck-button-save"
              )),
              (this.saveButtonView.type = "submit"),
              (this.cancelButtonView = this._createButton(
                i("Cancel"),
                Yu,
                "ck-button-cancel",
                "cancel"
              )),
              (this._manualDecoratorSwitches =
                this._createManualDecoratorSwitches(e)),
              (this.children = this._createFormChildren(e.manualDecorators)),
              (this._focusables = new Hl()),
              (this._focusCycler = new _c({
                focusables: this._focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: { focusPrevious: "shift + tab", focusNext: "tab" },
              }));
            const n = ["ck", "ck-link-form"];
            e.manualDecorators.length && n.push("ck-link-form_layout-vertical"),
              this.setTemplate({
                tag: "form",
                attributes: { class: n, tabindex: "-1" },
                children: this.children,
              });
          }
          getDecoratorSwitchesState() {
            return Array.from(this._manualDecoratorSwitches).reduce(
              (t, e) => ((t[e.name] = e.isOn), t),
              {}
            );
          }
          render() {
            super.render(),
              Wu({ view: this }),
              [
                this.urlInputView,
                ...this._manualDecoratorSwitches,
                this.saveButtonView,
                this.cancelButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
              this.keystrokes.listenTo(this.element);
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          _createUrlInput() {
            const t = this.locale.t,
              e = new Fu(this.locale, Uu);
            return (
              (e.label = t("Link URL")),
              (e.fieldView.placeholder = "https://example.com"),
              e
            );
          }
          _createButton(t, e, i, n) {
            const o = new Oc(this.locale);
            return (
              o.set({ label: t, icon: e, tooltip: !0 }),
              o.extendTemplate({ attributes: { class: i } }),
              n && o.delegate("execute").to(this, n),
              o
            );
          }
          _createManualDecoratorSwitches(t) {
            const e = this.createCollection();
            for (const i of t.manualDecorators) {
              const n = new zc(this.locale);
              n.set({ name: i.id, label: i.label, withText: !0 }),
                n
                  .bind("isOn")
                  .toMany([i, t], "value", (t, e) =>
                    void 0 === e && void 0 === t ? i.defaultValue : t
                  ),
                n.on("execute", () => {
                  i.set("value", !n.isOn);
                }),
                e.add(n);
            }
            return e;
          }
          _createFormChildren(t) {
            const e = this.createCollection();
            if ((e.add(this.urlInputView), t.length)) {
              const t = new lc();
              t.setTemplate({
                tag: "ul",
                children: this._manualDecoratorSwitches.map((t) => ({
                  tag: "li",
                  children: [t],
                  attributes: { class: ["ck", "ck-list__item"] },
                })),
                attributes: { class: ["ck", "ck-reset", "ck-list"] },
              }),
                e.add(t);
            }
            return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
          }
        }
        i(77);
        class cg extends lc {
          constructor(t) {
            super(t);
            const e = t.t;
            (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              (this.previewButtonView = this._createPreviewButton()),
              (this.unlinkButtonView = this._createButton(
                e("Unlink"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',
                "unlink"
              )),
              (this.editButtonView = this._createButton(
                e("Edit link"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>',
                "edit"
              )),
              this.set("href"),
              (this._focusables = new Hl()),
              (this._focusCycler = new _c({
                focusables: this._focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: { focusPrevious: "shift + tab", focusNext: "tab" },
              })),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-link-actions"],
                  tabindex: "-1",
                },
                children: [
                  this.previewButtonView,
                  this.editButtonView,
                  this.unlinkButtonView,
                ],
              });
          }
          render() {
            super.render(),
              [
                this.previewButtonView,
                this.editButtonView,
                this.unlinkButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
              this.keystrokes.listenTo(this.element);
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          _createButton(t, e, i) {
            const n = new Oc(this.locale);
            return (
              n.set({ label: t, icon: e, tooltip: !0 }),
              n.delegate("execute").to(this, i),
              n
            );
          }
          _createPreviewButton() {
            const t = new Oc(this.locale),
              e = this.bindTemplate,
              i = this.t;
            return (
              t.set({ withText: !0, tooltip: i("Open link in new tab") }),
              t.extendTemplate({
                attributes: {
                  class: ["ck", "ck-link-actions__preview"],
                  href: e.to("href", (t) => t && mu(t)),
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              }),
              t
                .bind("label")
                .to(this, "href", (t) => t || i("This link has no URL")),
              t.bind("isEnabled").to(this, "href", (t) => !!t),
              (t.template.tag = "a"),
              (t.template.eventListeners = {}),
              t
            );
          }
        }
        class dg extends Gc {
          static get requires() {
            return [em];
          }
          static get pluginName() {
            return "LinkUI";
          }
          init() {
            const t = this.editor;
            t.editing.view.addObserver(ag),
              (this.actionsView = this._createActionsView()),
              (this.formView = this._createFormView()),
              (this._balloon = t.plugins.get(em)),
              this._createToolbarLinkButton(),
              this._enableUserBalloonInteractions();
          }
          destroy() {
            super.destroy(), this.formView.destroy();
          }
          _createActionsView() {
            const t = this.editor,
              e = new cg(t.locale),
              i = t.commands.get("link"),
              n = t.commands.get("unlink");
            return (
              e.bind("href").to(i, "value"),
              e.editButtonView.bind("isEnabled").to(i),
              e.unlinkButtonView.bind("isEnabled").to(n),
              this.listenTo(e, "edit", () => {
                this._addFormView();
              }),
              this.listenTo(e, "unlink", () => {
                t.execute("unlink"), this._hideUI();
              }),
              e.keystrokes.set("Esc", (t, e) => {
                this._hideUI(), e();
              }),
              e.keystrokes.set("Ctrl+K", (t, e) => {
                this._addFormView(), e();
              }),
              e
            );
          }
          _createFormView() {
            const t = this.editor,
              e = t.commands.get("link"),
              i = new lg(t.locale, e);
            return (
              i.urlInputView.fieldView.bind("value").to(e, "value"),
              i.urlInputView.bind("isReadOnly").to(e, "isEnabled", (t) => !t),
              i.saveButtonView.bind("isEnabled").to(e),
              this.listenTo(i, "submit", () => {
                t.execute(
                  "link",
                  i.urlInputView.fieldView.element.value,
                  i.getDecoratorSwitchesState()
                ),
                  this._closeFormView();
              }),
              this.listenTo(i, "cancel", () => {
                this._closeFormView();
              }),
              i.keystrokes.set("Esc", (t, e) => {
                this._closeFormView(), e();
              }),
              i
            );
          }
          _createToolbarLinkButton() {
            const t = this.editor,
              e = t.commands.get("link"),
              i = t.t;
            t.keystrokes.set("Ctrl+K", (t, e) => {
              e(), this._showUI(!0);
            }),
              t.ui.componentFactory.add("link", (t) => {
                const n = new Oc(t);
                return (
                  (n.isEnabled = !0),
                  (n.label = i("Link")),
                  (n.icon =
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>'),
                  (n.keystroke = "Ctrl+K"),
                  (n.tooltip = !0),
                  (n.isToggleable = !0),
                  n.bind("isEnabled").to(e, "isEnabled"),
                  n.bind("isOn").to(e, "value", (t) => !!t),
                  this.listenTo(n, "execute", () => this._showUI(!0)),
                  n
                );
              });
          }
          _enableUserBalloonInteractions() {
            const t = this.editor.editing.view.document;
            this.listenTo(t, "click", () => {
              this._getSelectedLinkElement() && this._showUI();
            }),
              this.editor.keystrokes.set(
                "Tab",
                (t, e) => {
                  this._areActionsVisible &&
                    !this.actionsView.focusTracker.isFocused &&
                    (this.actionsView.focus(), e());
                },
                { priority: "high" }
              ),
              this.editor.keystrokes.set("Esc", (t, e) => {
                this._isUIVisible && (this._hideUI(), e());
              }),
              Bc({
                emitter: this.formView,
                activator: () => this._isUIInPanel,
                contextElements: [this._balloon.view.element],
                callback: () => this._hideUI(),
              });
          }
          _addActionsView() {
            this._areActionsInPanel ||
              this._balloon.add({
                view: this.actionsView,
                position: this._getBalloonPositionData(),
              });
          }
          _addFormView() {
            if (this._isFormInPanel) return;
            const t = this.editor.commands.get("link");
            this._balloon.add({
              view: this.formView,
              position: this._getBalloonPositionData(),
            }),
              this._balloon.visibleView === this.formView &&
                this.formView.urlInputView.fieldView.select(),
              (this.formView.urlInputView.fieldView.element.value =
                t.value || "");
          }
          _closeFormView() {
            const t = this.editor.commands.get("link");
            t.restoreManualDecoratorStates(),
              void 0 !== t.value ? this._removeFormView() : this._hideUI();
          }
          _removeFormView() {
            this._isFormInPanel &&
              (this.formView.saveButtonView.focus(),
              this._balloon.remove(this.formView),
              this.editor.editing.view.focus());
          }
          _showUI(t = !1) {
            this._getSelectedLinkElement()
              ? (this._areActionsVisible
                  ? this._addFormView()
                  : this._addActionsView(),
                t && this._balloon.showStack("main"))
              : (this._addActionsView(),
                t && this._balloon.showStack("main"),
                this._addFormView()),
              this._startUpdatingUI();
          }
          _hideUI() {
            if (!this._isUIInPanel) return;
            const t = this.editor;
            this.stopListening(t.ui, "update"),
              this.stopListening(this._balloon, "change:visibleView"),
              t.editing.view.focus(),
              this._removeFormView(),
              this._balloon.remove(this.actionsView);
          }
          _startUpdatingUI() {
            const t = this.editor,
              e = t.editing.view.document;
            let i = this._getSelectedLinkElement(),
              n = r();
            const o = () => {
              const t = this._getSelectedLinkElement(),
                e = r();
              (i && !t) || (!i && e !== n)
                ? this._hideUI()
                : this._isUIVisible &&
                  this._balloon.updatePosition(this._getBalloonPositionData()),
                (i = t),
                (n = e);
            };
            function r() {
              return e.selection.focus
                .getAncestors()
                .reverse()
                .find((t) => t.is("element"));
            }
            this.listenTo(t.ui, "update", o),
              this.listenTo(this._balloon, "change:visibleView", o);
          }
          get _isFormInPanel() {
            return this._balloon.hasView(this.formView);
          }
          get _areActionsInPanel() {
            return this._balloon.hasView(this.actionsView);
          }
          get _areActionsVisible() {
            return this._balloon.visibleView === this.actionsView;
          }
          get _isUIInPanel() {
            return this._isFormInPanel || this._areActionsInPanel;
          }
          get _isUIVisible() {
            return (
              this._balloon.visibleView == this.formView ||
              this._areActionsVisible
            );
          }
          _getBalloonPositionData() {
            const t = this.editor.editing.view,
              e = t.document,
              i = this._getSelectedLinkElement();
            return {
              target: i
                ? t.domConverter.mapViewToDom(i)
                : t.domConverter.viewRangeToDom(e.selection.getFirstRange()),
            };
          }
          _getSelectedLinkElement() {
            const t = this.editor.editing.view,
              e = t.document.selection;
            if (e.isCollapsed) return hg(e.getFirstPosition());
            {
              const i = e.getFirstRange().getTrimmed(),
                n = hg(i.start),
                o = hg(i.end);
              return n && n == o && t.createRangeIn(n).getTrimmed().isEqual(i)
                ? n
                : null;
            }
          }
        }
        function hg(t) {
          return t.getAncestors().find((t) => {
            return (
              (e = t).is("attributeElement") && !!e.getCustomProperty("link")
            );
            var e;
          });
        }
        class ug extends ed {
          constructor(t, e) {
            super(t), (this.type = e);
          }
          refresh() {
            (this.value = this._getValue()),
              (this.isEnabled = this._checkEnabled());
          }
          execute() {
            const t = this.editor.model,
              e = t.document,
              i = Array.from(e.selection.getSelectedBlocks()).filter((e) =>
                gg(e, t.schema)
              ),
              n = !0 === this.value;
            t.change((t) => {
              if (n) {
                let e = i[i.length - 1].nextSibling,
                  n = Number.POSITIVE_INFINITY,
                  o = [];
                for (
                  ;
                  e &&
                  "listItem" == e.name &&
                  0 !== e.getAttribute("listIndent");

                ) {
                  const t = e.getAttribute("listIndent");
                  t < n && (n = t);
                  const i = t - n;
                  o.push({ element: e, listIndent: i }), (e = e.nextSibling);
                }
                o = o.reverse();
                for (const e of o)
                  t.setAttribute("listIndent", e.listIndent, e.element);
              }
              if (!n) {
                let t = Number.POSITIVE_INFINITY;
                for (const e of i)
                  e.is("listItem") &&
                    e.getAttribute("listIndent") < t &&
                    (t = e.getAttribute("listIndent"));
                (t = 0 === t ? 1 : t), mg(i, !0, t), mg(i, !1, t);
              }
              for (const e of i.reverse())
                n && "listItem" == e.name
                  ? t.rename(e, "paragraph")
                  : n || "listItem" == e.name
                  ? n ||
                    "listItem" != e.name ||
                    e.getAttribute("listType") == this.type ||
                    t.setAttribute("listType", this.type, e)
                  : (t.setAttributes({ listType: this.type, listIndent: 0 }, e),
                    t.rename(e, "listItem"));
            });
          }
          _getValue() {
            const t = fh(
              this.editor.model.document.selection.getSelectedBlocks()
            );
            return (
              !!t && t.is("listItem") && t.getAttribute("listType") == this.type
            );
          }
          _checkEnabled() {
            if (this.value) return !0;
            const t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              i = fh(t.getSelectedBlocks());
            return !!i && gg(i, e);
          }
        }
        function mg(t, e, i) {
          const n = e ? t[0] : t[t.length - 1];
          if (n.is("listItem")) {
            let o = n[e ? "previousSibling" : "nextSibling"],
              r = n.getAttribute("listIndent");
            for (; o && o.is("listItem") && o.getAttribute("listIndent") >= i; )
              r > o.getAttribute("listIndent") &&
                (r = o.getAttribute("listIndent")),
                o.getAttribute("listIndent") == r &&
                  t[e ? "unshift" : "push"](o),
                (o = o[e ? "previousSibling" : "nextSibling"]);
          }
        }
        function gg(t, e) {
          return e.checkChild(t.parent, "listItem") && !e.isObject(t);
        }
        class fg extends ed {
          constructor(t, e) {
            super(t), (this._indentBy = "forward" == e ? 1 : -1);
          }
          refresh() {
            this.isEnabled = this._checkEnabled();
          }
          execute() {
            const t = this.editor.model,
              e = t.document;
            let i = Array.from(e.selection.getSelectedBlocks());
            t.change((t) => {
              const e = i[i.length - 1];
              let n = e.nextSibling;
              for (
                ;
                n &&
                "listItem" == n.name &&
                n.getAttribute("listIndent") > e.getAttribute("listIndent");

              )
                i.push(n), (n = n.nextSibling);
              this._indentBy < 0 && (i = i.reverse());
              for (const e of i) {
                const i = e.getAttribute("listIndent") + this._indentBy;
                i < 0
                  ? t.rename(e, "paragraph")
                  : t.setAttribute("listIndent", i, e);
              }
            });
          }
          _checkEnabled() {
            const t = fh(
              this.editor.model.document.selection.getSelectedBlocks()
            );
            if (!t || !t.is("listItem")) return !1;
            if (this._indentBy > 0) {
              const e = t.getAttribute("listIndent"),
                i = t.getAttribute("listType");
              let n = t.previousSibling;
              for (
                ;
                n && n.is("listItem") && n.getAttribute("listIndent") >= e;

              ) {
                if (n.getAttribute("listIndent") == e)
                  return n.getAttribute("listType") == i;
                n = n.previousSibling;
              }
              return !1;
            }
            return !0;
          }
        }
        function pg(t, e) {
          const i = e.mapper,
            n = e.writer,
            o = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
            r = (function (t) {
              const e = t.createContainerElement("li");
              return (e.getFillerOffset = yg), e;
            })(n),
            s = n.createContainerElement(o, null);
          return n.insert(n.createPositionAt(s, 0), r), i.bindElements(t, r), r;
        }
        function bg(t, e, i, n) {
          const o = e.parent,
            r = i.mapper,
            s = i.writer;
          let a = r.toViewPosition(n.createPositionBefore(t));
          const l = kg(t.previousSibling, {
              sameIndent: !0,
              smallerIndent: !0,
              listIndent: t.getAttribute("listIndent"),
            }),
            c = t.previousSibling;
          if (
            l &&
            l.getAttribute("listIndent") == t.getAttribute("listIndent")
          ) {
            const t = r.toViewElement(l);
            a = s.breakContainer(s.createPositionAfter(t));
          } else
            a =
              c && "listItem" == c.name
                ? r.toViewPosition(n.createPositionAt(c, "end"))
                : r.toViewPosition(n.createPositionBefore(t));
          if (((a = _g(a)), s.insert(a, o), c && "listItem" == c.name)) {
            const t = r.toViewElement(c),
              i = s
                .createRange(s.createPositionAt(t, 0), a)
                .getWalker({ ignoreElementEnd: !0 });
            for (const t of i)
              if (t.item.is("li")) {
                const n = s.breakContainer(s.createPositionBefore(t.item)),
                  o = t.item.parent,
                  r = s.createPositionAt(e, "end");
                wg(s, r.nodeBefore, r.nodeAfter),
                  s.move(s.createRangeOn(o), r),
                  (i.position = n);
              }
          } else {
            const i = o.nextSibling;
            if (i && (i.is("ul") || i.is("ol"))) {
              let n = null;
              for (const e of i.getChildren()) {
                const i = r.toModelElement(e);
                if (
                  !(
                    i &&
                    i.getAttribute("listIndent") > t.getAttribute("listIndent")
                  )
                )
                  break;
                n = e;
              }
              n &&
                (s.breakContainer(s.createPositionAfter(n)),
                s.move(
                  s.createRangeOn(n.parent),
                  s.createPositionAt(e, "end")
                ));
            }
          }
          wg(s, o, o.nextSibling), wg(s, o.previousSibling, o);
        }
        function wg(t, e, i) {
          return !e ||
            !i ||
            ("ul" != e.name && "ol" != e.name) ||
            e.name != i.name ||
            e.getAttribute("class") !== i.getAttribute("class")
            ? null
            : t.mergeContainers(t.createPositionAfter(e));
        }
        function _g(t) {
          return t.getLastMatchingPosition((t) => t.item.is("uiElement"));
        }
        function kg(t, e) {
          const i = !!e.sameIndent,
            n = !!e.smallerIndent,
            o = e.listIndent;
          let r = t;
          for (; r && "listItem" == r.name; ) {
            const t = r.getAttribute("listIndent");
            if ((i && o == t) || (n && o > t)) return r;
            r = r.previousSibling;
          }
          return null;
        }
        function vg(t, e, i, n) {
          t.ui.componentFactory.add(e, (o) => {
            const r = t.commands.get(e),
              s = new Oc(o);
            return (
              s.set({ label: i, icon: n, tooltip: !0, isToggleable: !0 }),
              s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"),
              s.on("execute", () => {
                t.execute(e), t.editing.view.focus();
              }),
              s
            );
          });
        }
        function yg() {
          const t =
            !this.isEmpty &&
            ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
          return this.isEmpty || t ? 0 : jn.call(this);
        }
        function xg(t) {
          return (e, i, n) => {
            const o = n.consumable;
            if (
              !o.test(i.item, "insert") ||
              !o.test(i.item, "attribute:listType") ||
              !o.test(i.item, "attribute:listIndent")
            )
              return;
            o.consume(i.item, "insert"),
              o.consume(i.item, "attribute:listType"),
              o.consume(i.item, "attribute:listIndent");
            const r = i.item;
            bg(r, pg(r, n), n, t);
          };
        }
        function Ag(t, e, i) {
          if (!i.consumable.consume(e.item, "attribute:listType")) return;
          const n = i.mapper.toViewElement(e.item),
            o = i.writer;
          o.breakContainer(o.createPositionBefore(n)),
            o.breakContainer(o.createPositionAfter(n));
          const r = n.parent,
            s = "numbered" == e.attributeNewValue ? "ol" : "ul";
          o.rename(s, r);
        }
        function Cg(t, e, i) {
          const n = i.mapper.toViewElement(e.item).parent,
            o = i.writer;
          wg(o, n, n.nextSibling), wg(o, n.previousSibling, n);
          for (const t of e.item.getChildren())
            i.consumable.consume(t, "insert");
        }
        function Tg(t, e, i) {
          if ("listItem" != e.item.name) {
            let t = i.mapper.toViewPosition(e.range.start);
            const n = i.writer,
              o = [];
            for (
              ;
              ("ul" == t.parent.name || "ol" == t.parent.name) &&
              ((t = n.breakContainer(t)), "li" == t.parent.name);

            ) {
              const e = t,
                i = n.createPositionAt(t.parent, "end");
              if (!e.isEqual(i)) {
                const t = n.remove(n.createRange(e, i));
                o.push(t);
              }
              t = n.createPositionAfter(t.parent);
            }
            if (o.length > 0) {
              for (let e = 0; e < o.length; e++) {
                const i = t.nodeBefore;
                if (((t = n.insert(t, o[e]).end), e > 0)) {
                  const e = wg(n, i, i.nextSibling);
                  e && e.parent == i && t.offset--;
                }
              }
              wg(n, t.nodeBefore, t.nodeAfter);
            }
          }
        }
        function Mg(t, e, i) {
          const n = i.mapper.toViewPosition(e.position),
            o = n.nodeBefore,
            r = n.nodeAfter;
          wg(i.writer, o, r);
        }
        function Eg(t, e, i) {
          if (i.consumable.consume(e.viewItem, { name: !0 })) {
            const t = i.writer,
              n = t.createElement("listItem"),
              o = (function (t) {
                let e = 0,
                  i = t.parent;
                for (; i; ) {
                  if (i.is("li")) e++;
                  else {
                    const t = i.previousSibling;
                    t && t.is("li") && e++;
                  }
                  i = i.parent;
                }
                return e;
              })(e.viewItem);
            t.setAttribute("listIndent", o, n);
            const r =
              e.viewItem.parent && "ol" == e.viewItem.parent.name
                ? "numbered"
                : "bulleted";
            t.setAttribute("listType", r, n);
            const s = i.splitToAllowedParent(n, e.modelCursor);
            if (!s) return;
            t.insert(n, s.position);
            const a = (function (t, e, i) {
              const { writer: n, schema: o } = i;
              let r = n.createPositionAfter(t);
              for (const s of e)
                if ("ul" == s.name || "ol" == s.name)
                  r = i.convertItem(s, r).modelCursor;
                else {
                  const e = i.convertItem(s, n.createPositionAt(t, "end")),
                    a = e.modelRange.start.nodeAfter;
                  a &&
                    a.is("element") &&
                    !o.checkChild(t, a.name) &&
                    ((t = e.modelCursor.parent.is("listItem")
                      ? e.modelCursor.parent
                      : Ng(e.modelCursor)),
                    (r = n.createPositionAfter(t)));
                }
              return r;
            })(n, e.viewItem.getChildren(), i);
            (e.modelRange = t.createRange(e.modelCursor, a)),
              s.cursorParent
                ? (e.modelCursor = t.createPositionAt(s.cursorParent, 0))
                : (e.modelCursor = e.modelRange.end);
          }
        }
        function Pg(t, e, i) {
          if (i.consumable.test(e.viewItem, { name: !0 })) {
            const t = Array.from(e.viewItem.getChildren());
            for (const e of t) {
              !(e.is("li") || Lg(e)) && e._remove();
            }
          }
        }
        function Sg(t, e, i) {
          if (i.consumable.test(e.viewItem, { name: !0 })) {
            if (0 === e.viewItem.childCount) return;
            const t = [...e.viewItem.getChildren()];
            let i = !1,
              n = !0;
            for (const e of t)
              i && !Lg(e) && e._remove(),
                e.is("text")
                  ? (n && (e._data = e.data.replace(/^\s+/, "")),
                    (e.nextSibling && !Lg(e.nextSibling)) ||
                      (e._data = e.data.replace(/\s+$/, "")))
                  : Lg(e) && (i = !0),
                (n = !1);
          }
        }
        function Ig(t) {
          return (e, i) => {
            if (i.isPhantom) return;
            const n = i.modelPosition.nodeBefore;
            if (n && n.is("listItem")) {
              const e = i.mapper.toViewElement(n),
                o = e.getAncestors().find(Lg),
                r = t.createPositionAt(e, 0).getWalker();
              for (const t of r) {
                if ("elementStart" == t.type && t.item.is("li")) {
                  i.viewPosition = t.previousPosition;
                  break;
                }
                if ("elementEnd" == t.type && t.item == o) {
                  i.viewPosition = t.nextPosition;
                  break;
                }
              }
            }
          };
        }
        function Og(t, [e, i]) {
          let n,
            o = e.is("documentFragment") ? e.getChild(0) : e;
          if (
            ((n = i ? this.createSelection(i) : this.document.selection),
            o && o.is("listItem"))
          ) {
            const t = n.getFirstPosition();
            let e = null;
            if (
              (t.parent.is("listItem")
                ? (e = t.parent)
                : t.nodeBefore &&
                  t.nodeBefore.is("listItem") &&
                  (e = t.nodeBefore),
              e)
            ) {
              const t = e.getAttribute("listIndent");
              if (t > 0)
                for (; o && o.is("listItem"); )
                  o._setAttribute(
                    "listIndent",
                    o.getAttribute("listIndent") + t
                  ),
                    (o = o.nextSibling);
            }
          }
        }
        function Ng(t) {
          const e = new bs({ startPosition: t });
          let i;
          do {
            i = e.next();
          } while (!i.value.item.is("listItem"));
          return i.value.item;
        }
        function Rg(t, e, i, n, o, r) {
          const s = kg(e.nodeBefore, {
              sameIndent: !0,
              smallerIndent: !0,
              listIndent: t,
              foo: "b",
            }),
            a = o.mapper,
            l = o.writer,
            c = s ? s.getAttribute("listIndent") : null;
          let d;
          if (s)
            if (c == t) {
              const t = a.toViewElement(s).parent;
              d = l.createPositionAfter(t);
            } else {
              const t = r.createPositionAt(s, "end");
              d = a.toViewPosition(t);
            }
          else d = i;
          d = _g(d);
          for (const t of [...n.getChildren()])
            Lg(t) &&
              ((d = l.move(l.createRangeOn(t), d).end),
              wg(l, t, t.nextSibling),
              wg(l, t.previousSibling, t));
        }
        function Lg(t) {
          return t.is("ol") || t.is("ul");
        }
        class jg extends Gc {
          static get pluginName() {
            return "ListEditing";
          }
          static get requires() {
            return [Tm];
          }
          init() {
            const t = this.editor;
            t.model.schema.register("listItem", {
              inheritAllFrom: "$block",
              allowAttributes: ["listType", "listIndent"],
            });
            const e = t.data,
              i = t.editing;
            var n;
            t.model.document.registerPostFixer((e) =>
              (function (t, e) {
                const i = t.document.differ.getChanges(),
                  n = new Map();
                let o = !1;
                for (const n of i)
                  if ("insert" == n.type && "listItem" == n.name) r(n.position);
                  else if ("insert" == n.type && "listItem" != n.name) {
                    if ("$text" != n.name) {
                      const i = n.position.nodeAfter;
                      i.hasAttribute("listIndent") &&
                        (e.removeAttribute("listIndent", i), (o = !0)),
                        i.hasAttribute("listType") &&
                          (e.removeAttribute("listType", i), (o = !0));
                      for (const e of Array.from(t.createRangeIn(i)).filter(
                        (t) => t.item.is("listItem")
                      ))
                        r(e.previousPosition);
                    }
                    r(n.position.getShiftedBy(n.length));
                  } else
                    "remove" == n.type && "listItem" == n.name
                      ? r(n.position)
                      : (("attribute" == n.type &&
                          "listIndent" == n.attributeKey) ||
                          ("attribute" == n.type &&
                            "listType" == n.attributeKey)) &&
                        r(n.range.start);
                for (const t of n.values()) s(t), a(t);
                return o;
                function r(t) {
                  const e = t.nodeBefore;
                  if (e && e.is("listItem")) {
                    let t = e;
                    if (n.has(t)) return;
                    for (
                      let e = t.previousSibling;
                      e && e.is("listItem");
                      e = t.previousSibling
                    )
                      if (((t = e), n.has(t))) return;
                    n.set(e, t);
                  } else {
                    const e = t.nodeAfter;
                    e && e.is("listItem") && n.set(e, e);
                  }
                }
                function s(t) {
                  let i = 0,
                    n = null;
                  for (; t && t.is("listItem"); ) {
                    const r = t.getAttribute("listIndent");
                    if (r > i) {
                      let s;
                      null === n
                        ? ((n = r - i), (s = i))
                        : (n > r && (n = r), (s = r - n)),
                        e.setAttribute("listIndent", s, t),
                        (o = !0);
                    } else (n = null), (i = t.getAttribute("listIndent") + 1);
                    t = t.nextSibling;
                  }
                }
                function a(t) {
                  let i = [],
                    n = null;
                  for (; t && t.is("listItem"); ) {
                    const r = t.getAttribute("listIndent");
                    if (
                      (n &&
                        n.getAttribute("listIndent") > r &&
                        (i = i.slice(0, r + 1)),
                      0 != r)
                    )
                      if (i[r]) {
                        const n = i[r];
                        t.getAttribute("listType") != n &&
                          (e.setAttribute("listType", n, t), (o = !0));
                      } else i[r] = t.getAttribute("listType");
                    (n = t), (t = t.nextSibling);
                  }
                }
              })(t.model, e)
            ),
              i.mapper.registerViewToModelLength("li", Dg),
              e.mapper.registerViewToModelLength("li", Dg),
              i.mapper.on("modelToViewPosition", Ig(i.view)),
              i.mapper.on(
                "viewToModelPosition",
                ((n = t.model),
                (t, e) => {
                  const i = e.viewPosition,
                    o = i.parent,
                    r = e.mapper;
                  if ("ul" == o.name || "ol" == o.name) {
                    if (i.isAtEnd) {
                      const t = r.toModelElement(i.nodeBefore),
                        o = r.getModelLength(i.nodeBefore);
                      e.modelPosition = n
                        .createPositionBefore(t)
                        .getShiftedBy(o);
                    } else {
                      const t = r.toModelElement(i.nodeAfter);
                      e.modelPosition = n.createPositionBefore(t);
                    }
                    t.stop();
                  } else if (
                    "li" == o.name &&
                    i.nodeBefore &&
                    ("ul" == i.nodeBefore.name || "ol" == i.nodeBefore.name)
                  ) {
                    const s = r.toModelElement(o);
                    let a = 1,
                      l = i.nodeBefore;
                    for (; l && Lg(l); )
                      (a += r.getModelLength(l)), (l = l.previousSibling);
                    (e.modelPosition = n
                      .createPositionBefore(s)
                      .getShiftedBy(a)),
                      t.stop();
                  }
                })
              ),
              e.mapper.on("modelToViewPosition", Ig(i.view)),
              t.conversion.for("editingDowncast").add((e) => {
                e.on("insert", Tg, { priority: "high" }),
                  e.on("insert:listItem", xg(t.model)),
                  e.on("attribute:listType:listItem", Ag, { priority: "high" }),
                  e.on("attribute:listType:listItem", Cg, { priority: "low" }),
                  e.on(
                    "attribute:listIndent:listItem",
                    (function (t) {
                      return (e, i, n) => {
                        if (
                          !n.consumable.consume(i.item, "attribute:listIndent")
                        )
                          return;
                        const o = n.mapper.toViewElement(i.item),
                          r = n.writer;
                        r.breakContainer(r.createPositionBefore(o)),
                          r.breakContainer(r.createPositionAfter(o));
                        const s = o.parent,
                          a = s.previousSibling,
                          l = r.createRangeOn(s);
                        r.remove(l),
                          a && a.nextSibling && wg(r, a, a.nextSibling),
                          Rg(
                            i.attributeOldValue + 1,
                            i.range.start,
                            l.start,
                            o,
                            n,
                            t
                          ),
                          bg(i.item, o, n, t);
                        for (const t of i.item.getChildren())
                          n.consumable.consume(t, "insert");
                      };
                    })(t.model)
                  ),
                  e.on(
                    "remove:listItem",
                    (function (t) {
                      return (e, i, n) => {
                        const o = n.mapper
                            .toViewPosition(i.position)
                            .getLastMatchingPosition(
                              (t) => !t.item.is("li")
                            ).nodeAfter,
                          r = n.writer;
                        r.breakContainer(r.createPositionBefore(o)),
                          r.breakContainer(r.createPositionAfter(o));
                        const s = o.parent,
                          a = s.previousSibling,
                          l = r.createRangeOn(s),
                          c = r.remove(l);
                        a && a.nextSibling && wg(r, a, a.nextSibling),
                          Rg(
                            n.mapper
                              .toModelElement(o)
                              .getAttribute("listIndent") + 1,
                            i.position,
                            l.start,
                            o,
                            n,
                            t
                          );
                        for (const t of r.createRangeIn(c).getItems())
                          n.mapper.unbindViewElement(t);
                        e.stop();
                      };
                    })(t.model)
                  ),
                  e.on("remove", Mg, { priority: "low" });
              }),
              t.conversion.for("dataDowncast").add((e) => {
                e.on("insert", Tg, { priority: "high" }),
                  e.on("insert:listItem", xg(t.model));
              }),
              t.conversion.for("upcast").add((t) => {
                t.on("element:ul", Pg, { priority: "high" }),
                  t.on("element:ol", Pg, { priority: "high" }),
                  t.on("element:li", Sg, { priority: "high" }),
                  t.on("element:li", Eg);
              }),
              t.model.on("insertContent", Og, { priority: "high" }),
              t.commands.add("numberedList", new ug(t, "numbered")),
              t.commands.add("bulletedList", new ug(t, "bulleted")),
              t.commands.add("indentList", new fg(t, "forward")),
              t.commands.add("outdentList", new fg(t, "backward"));
            const o = i.view.document;
            this.listenTo(o, "enter", (t, e) => {
              const i = this.editor.model.document,
                n = i.selection.getLastPosition().parent;
              i.selection.isCollapsed &&
                "listItem" == n.name &&
                n.isEmpty &&
                (this.editor.execute("outdentList"),
                e.preventDefault(),
                t.stop());
            }),
              this.listenTo(
                o,
                "delete",
                (t, e) => {
                  if ("backward" !== e.direction) return;
                  const i = this.editor.model.document.selection;
                  if (!i.isCollapsed) return;
                  const n = i.getFirstPosition();
                  if (!n.isAtStart) return;
                  const o = n.parent;
                  "listItem" === o.name &&
                    ((o.previousSibling &&
                      "listItem" === o.previousSibling.name) ||
                      (this.editor.execute("outdentList"),
                      e.preventDefault(),
                      t.stop()));
                },
                { priority: "high" }
              );
            const r = (t) => (e, i) => {
              this.editor.commands.get(t).isEnabled &&
                (this.editor.execute(t), i());
            };
            t.keystrokes.set("Tab", r("indentList")),
              t.keystrokes.set("Shift+Tab", r("outdentList"));
          }
          afterInit() {
            const t = this.editor.commands,
              e = t.get("indent"),
              i = t.get("outdent");
            e && e.registerChildCommand(t.get("indentList")),
              i && i.registerChildCommand(t.get("outdentList"));
          }
        }
        function Dg(t) {
          let e = 1;
          for (const i of t.getChildren())
            if ("ul" == i.name || "ol" == i.name)
              for (const t of i.getChildren()) e += Dg(t);
          return e;
        }
        class zg extends Gc {
          init() {
            const t = this.editor.t;
            vg(
              this.editor,
              "numberedList",
              t("Numbered List"),
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'
            ),
              vg(
                this.editor,
                "bulletedList",
                t("Bulleted List"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>'
              );
          }
        }
        function Bg(t, e) {
          return (t) => {
            t.on("attribute:url:media", i);
          };
          function i(i, n, o) {
            if (!o.consumable.consume(n.item, i.name)) return;
            const r = n.attributeNewValue,
              s = o.writer,
              a = o.mapper.toViewElement(n.item);
            s.remove(s.createRangeIn(a));
            const l = t.getMediaViewElement(s, r, e);
            s.insert(s.createPositionAt(a, 0), l);
          }
        }
        function Vg(t, e, i, n) {
          const o = t.createContainerElement("figure", { class: "media" });
          return (
            (o.getFillerOffset = Ug),
            t.insert(t.createPositionAt(o, 0), e.getMediaViewElement(t, i, n)),
            o
          );
        }
        function Fg(t) {
          const e = t.getSelectedElement();
          return e && e.is("media") ? e : null;
        }
        function Hg(t, e, i) {
          t.change((n) => {
            const o = n.createElement("media", { url: e });
            t.insertContent(o, i), n.setSelection(o, "on");
          });
        }
        function Ug() {
          return null;
        }
        class Wg extends ed {
          refresh() {
            const t = this.editor.model,
              e = t.document.selection,
              i = t.schema,
              n = e.getFirstPosition(),
              o = Fg(e);
            let r = n.parent;
            r != r.root && (r = r.parent),
              (this.value = o ? o.getAttribute("url") : null),
              (this.isEnabled = i.checkChild(r, "media"));
          }
          execute(t) {
            const e = this.editor.model,
              i = e.document.selection,
              n = Fg(i);
            if (n)
              e.change((e) => {
                e.setAttribute("url", t, n);
              });
            else {
              const n = Oh(i, e);
              Hg(e, t, n);
            }
          }
        }
        class qg {
          constructor(t, e) {
            const i = e.providers,
              n = e.extraProviders || [],
              o = new Set(e.removeProviders),
              r = i.concat(n).filter((t) => {
                const e = t.name;
                return e
                  ? !o.has(e)
                  : (console.warn(
                      Object(hi.a)(
                        "media-embed-no-provider-name: The configured media provider has no name and cannot be used."
                      ),
                      { provider: t }
                    ),
                    !1);
              });
            (this.locale = t), (this.providerDefinitions = r);
          }
          hasMedia(t) {
            return !!this._getMedia(t);
          }
          getMediaViewElement(t, e, i) {
            return this._getMedia(e).getViewElement(t, i);
          }
          _getMedia(t) {
            if (!t) return new Yg(this.locale);
            t = t.trim();
            for (const e of this.providerDefinitions) {
              const i = e.html;
              let n = e.url;
              Array.isArray(n) || (n = [n]);
              for (const e of n) {
                const n = this._getUrlMatches(t, e);
                if (n) return new Yg(this.locale, t, n, i);
              }
            }
            return null;
          }
          _getUrlMatches(t, e) {
            let i = t.match(e);
            if (i) return i;
            let n = t.replace(/^https?:\/\//, "");
            return (
              (i = n.match(e)),
              i || ((n = n.replace(/^www\./, "")), (i = n.match(e)), i || null)
            );
          }
        }
        class Yg {
          constructor(t, e, i, n) {
            (this.url = this._getValidUrl(e)),
              (this._t = t.t),
              (this._match = i),
              (this._previewRenderer = n);
          }
          getViewElement(t, e) {
            const i = {};
            if (
              e.renderForEditingView ||
              (e.renderMediaPreview && this.url && this._previewRenderer)
            ) {
              this.url && (i["data-oembed-url"] = this.url),
                e.renderForEditingView && (i.class = "ck-media__wrapper");
              const n = this._getPreviewHtml(e);
              return t.createUIElement("div", i, function (t) {
                const e = this.toDomElement(t);
                return (e.innerHTML = n), e;
              });
            }
            return (
              this.url && (i.url = this.url), t.createEmptyElement("oembed", i)
            );
          }
          _getPreviewHtml(t) {
            return this._previewRenderer
              ? this._previewRenderer(this._match)
              : this.url && t.renderForEditingView
              ? this._getPlaceholderHtml()
              : "";
          }
          _getPlaceholderHtml() {
            const t = new Ic(),
              e = new Sc();
            return (
              (t.text = this._t("Open media in new tab")),
              (e.content =
                '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>'),
              (e.viewBox = "0 0 64 42"),
              new Ul({
                tag: "div",
                attributes: { class: "ck ck-reset_all ck-media__placeholder" },
                children: [
                  {
                    tag: "div",
                    attributes: { class: "ck-media__placeholder__icon" },
                    children: [e],
                  },
                  {
                    tag: "a",
                    attributes: {
                      class: "ck-media__placeholder__url",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: this.url,
                    },
                    children: [
                      {
                        tag: "span",
                        attributes: {
                          class: "ck-media__placeholder__url__text",
                        },
                        children: [this.url],
                      },
                      t,
                    ],
                  },
                ],
              }).render().outerHTML
            );
          }
          _getValidUrl(t) {
            return t ? (t.match(/^https?/) ? t : "https://" + t) : null;
          }
        }
        i(79);
        class $g extends Gc {
          static get pluginName() {
            return "MediaEmbedEditing";
          }
          constructor(t) {
            super(t),
              t.config.define("mediaEmbed", {
                providers: [
                  {
                    name: "dailymotion",
                    url: /^dailymotion\.com\/video\/(\w+)/,
                    html: (t) =>
                      `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`,
                  },
                  {
                    name: "spotify",
                    url: [
                      /^open\.spotify\.com\/(artist\/\w+)/,
                      /^open\.spotify\.com\/(album\/\w+)/,
                      /^open\.spotify\.com\/(track\/\w+)/,
                    ],
                    html: (t) =>
                      `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`,
                  },
                  {
                    name: "youtube",
                    url: [
                      /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,
                      /^(?:m\.)?youtube\.com\/v\/([\w-]+)/,
                      /^youtube\.com\/embed\/([\w-]+)/,
                      /^youtu\.be\/([\w-]+)/,
                    ],
                    html: (t) =>
                      `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`,
                  },
                  {
                    name: "vimeo",
                    url: [
                      /^vimeo\.com\/(\d+)/,
                      /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                      /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                      /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                      /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                      /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                      /^player\.vimeo\.com\/video\/(\d+)/,
                    ],
                    html: (t) =>
                      `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`,
                  },
                  { name: "instagram", url: /^instagram\.com\/p\/(\w+)/ },
                  { name: "twitter", url: /^twitter\.com/ },
                  { name: "googleMaps", url: /^google\.com\/maps/ },
                  { name: "flickr", url: /^flickr\.com/ },
                  { name: "facebook", url: /^facebook\.com/ },
                ],
              }),
              (this.registry = new qg(t.locale, t.config.get("mediaEmbed")));
          }
          init() {
            const t = this.editor,
              e = t.model.schema,
              i = t.t,
              n = t.conversion,
              o = t.config.get("mediaEmbed.previewsInData"),
              r = this.registry;
            t.commands.add("mediaEmbed", new Wg(t)),
              e.register("media", {
                isObject: !0,
                isBlock: !0,
                allowWhere: "$block",
                allowAttributes: ["url"],
              }),
              n.for("dataDowncast").elementToElement({
                model: "media",
                view: (t, e) => {
                  const i = t.getAttribute("url");
                  return Vg(e, r, i, { renderMediaPreview: i && o });
                },
              }),
              n.for("dataDowncast").add(Bg(r, { renderMediaPreview: o })),
              n.for("editingDowncast").elementToElement({
                model: "media",
                view: (t, e) => {
                  const n = t.getAttribute("url"),
                    o = Vg(e, r, n, { renderForEditingView: !0 });
                  return (
                    (s = o),
                    (a = e),
                    (l = i("media widget")),
                    a.setCustomProperty("media", !0, s),
                    Ph(s, a, { label: l })
                  );
                  var s, a, l;
                },
              }),
              n.for("editingDowncast").add(Bg(r, { renderForEditingView: !0 })),
              n
                .for("upcast")
                .elementToElement({
                  view: { name: "oembed", attributes: { url: !0 } },
                  model: (t, e) => {
                    const i = t.getAttribute("url");
                    if (r.hasMedia(i))
                      return e.createElement("media", { url: i });
                  },
                })
                .elementToElement({
                  view: { name: "div", attributes: { "data-oembed-url": !0 } },
                  model: (t, e) => {
                    const i = t.getAttribute("data-oembed-url");
                    if (r.hasMedia(i))
                      return e.createElement("media", { url: i });
                  },
                });
          }
        }
        const Jg =
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
        class Gg extends Gc {
          static get requires() {
            return [td, Qd];
          }
          static get pluginName() {
            return "AutoMediaEmbed";
          }
          constructor(t) {
            super(t), (this._timeoutId = null), (this._positionToInsert = null);
          }
          init() {
            const t = this.editor,
              e = t.model.document;
            this.listenTo(t.plugins.get(td), "inputTransformation", () => {
              const t = e.selection.getFirstRange(),
                i = al.fromPosition(t.start);
              i.stickiness = "toPrevious";
              const n = al.fromPosition(t.end);
              (n.stickiness = "toNext"),
                e.once(
                  "change:data",
                  () => {
                    this._embedMediaBetweenPositions(i, n),
                      i.detach(),
                      n.detach();
                  },
                  { priority: "high" }
                );
            }),
              t.commands.get("undo").on(
                "execute",
                () => {
                  this._timeoutId &&
                    (Zo.window.clearTimeout(this._timeoutId),
                    this._positionToInsert.detach(),
                    (this._timeoutId = null),
                    (this._positionToInsert = null));
                },
                { priority: "high" }
              );
          }
          _embedMediaBetweenPositions(t, e) {
            const i = this.editor,
              n = i.plugins.get($g).registry,
              o = new Rs(t, e),
              r = o.getWalker({ ignoreElementEnd: !0 });
            let s = "";
            for (const t of r) t.item.is("textProxy") && (s += t.item.data);
            if (((s = s.trim()), !s.match(Jg))) return;
            if (!n.hasMedia(s)) return;
            i.commands.get("mediaEmbed").isEnabled &&
              ((this._positionToInsert = al.fromPosition(t)),
              (this._timeoutId = Zo.window.setTimeout(() => {
                i.model.change((t) => {
                  let e;
                  (this._timeoutId = null),
                    t.remove(o),
                    "$graveyard" !== this._positionToInsert.root.rootName &&
                      (e = this._positionToInsert),
                    Hg(i.model, s, e),
                    this._positionToInsert.detach(),
                    (this._positionToInsert = null);
                });
              }, 100)));
          }
        }
        i(81);
        class Qg extends lc {
          constructor(t, e) {
            super(e);
            const i = e.t;
            (this.focusTracker = new Nl()),
              (this.keystrokes = new Al()),
              (this.urlInputView = this._createUrlInput()),
              (this.saveButtonView = this._createButton(
                i("Save"),
                qu,
                "ck-button-save"
              )),
              (this.saveButtonView.type = "submit"),
              (this.cancelButtonView = this._createButton(
                i("Cancel"),
                Yu,
                "ck-button-cancel",
                "cancel"
              )),
              (this._focusables = new Hl()),
              (this._focusCycler = new _c({
                focusables: this._focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: { focusPrevious: "shift + tab", focusNext: "tab" },
              })),
              (this._validators = t),
              this.setTemplate({
                tag: "form",
                attributes: { class: ["ck", "ck-media-form"], tabindex: "-1" },
                children: [
                  this.urlInputView,
                  this.saveButtonView,
                  this.cancelButtonView,
                ],
              });
          }
          render() {
            super.render(),
              Wu({ view: this }),
              [
                this.urlInputView,
                this.saveButtonView,
                this.cancelButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
              this.keystrokes.listenTo(this.element);
            const t = (t) => t.stopPropagation();
            this.keystrokes.set("arrowright", t),
              this.keystrokes.set("arrowleft", t),
              this.keystrokes.set("arrowup", t),
              this.keystrokes.set("arrowdown", t),
              this.listenTo(
                this.urlInputView.element,
                "selectstart",
                (t, e) => {
                  e.stopPropagation();
                },
                { priority: "high" }
              );
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          get url() {
            return this.urlInputView.fieldView.element.value.trim();
          }
          set url(t) {
            this.urlInputView.fieldView.element.value = t.trim();
          }
          isValid() {
            this.resetFormStatus();
            for (const t of this._validators) {
              const e = t(this);
              if (e) return (this.urlInputView.errorText = e), !1;
            }
            return !0;
          }
          resetFormStatus() {
            (this.urlInputView.errorText = null),
              (this.urlInputView.infoText = this._urlInputViewInfoDefault);
          }
          _createUrlInput() {
            const t = this.locale.t,
              e = new Fu(this.locale, Uu),
              i = e.fieldView;
            return (
              (this._urlInputViewInfoDefault = t(
                "Paste the media URL in the input."
              )),
              (this._urlInputViewInfoTip = t(
                "Tip: Paste the URL into the content to embed faster."
              )),
              (e.label = t("Media URL")),
              (e.infoText = this._urlInputViewInfoDefault),
              (i.placeholder = "https://example.com"),
              i.on("input", () => {
                e.infoText = i.element.value
                  ? this._urlInputViewInfoTip
                  : this._urlInputViewInfoDefault;
              }),
              e
            );
          }
          _createButton(t, e, i, n) {
            const o = new Oc(this.locale);
            return (
              o.set({ label: t, icon: e, tooltip: !0 }),
              o.extendTemplate({ attributes: { class: i } }),
              n && o.delegate("execute").to(this, n),
              o
            );
          }
        }
        class Xg extends Gc {
          static get requires() {
            return [$g];
          }
          static get pluginName() {
            return "MediaEmbedUI";
          }
          init() {
            const t = this.editor,
              e = t.commands.get("mediaEmbed"),
              i = t.plugins.get($g).registry;
            (this.form = new Qg(
              (function (t, e) {
                return [
                  (e) => {
                    if (!e.url.length) return t("The URL must not be empty.");
                  },
                  (i) => {
                    if (!e.hasMedia(i.url))
                      return t("This media URL is not supported.");
                  },
                ];
              })(t.t, i),
              t.locale
            )),
              t.ui.componentFactory.add("mediaEmbed", (i) => {
                const n = Vc(i);
                return (
                  this._setUpDropdown(n, this.form, e, t),
                  this._setUpForm(this.form, n, e),
                  n
                );
              });
          }
          _setUpDropdown(t, e, i) {
            const n = this.editor,
              o = n.t,
              r = t.buttonView;
            function s() {
              n.editing.view.focus(), (t.isOpen = !1);
            }
            t.bind("isEnabled").to(i),
              t.panelView.children.add(e),
              r.set({
                label: o("Insert media"),
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 01.593-.351l5.133 2.824a.4.4 0 010 .7l-5.133 2.824a.4.4 0 01-.593-.35V7.176v.001z"/></svg>\n',
                tooltip: !0,
              }),
              r.on(
                "open",
                () => {
                  (e.url = i.value || ""),
                    e.urlInputView.fieldView.select(),
                    e.focus();
                },
                { priority: "low" }
              ),
              t.on("submit", () => {
                e.isValid() && (n.execute("mediaEmbed", e.url), s());
              }),
              t.on("change:isOpen", () => e.resetFormStatus()),
              t.on("cancel", () => s());
          }
          _setUpForm(t, e, i) {
            t.delegate("submit", "cancel").to(e),
              t.urlInputView.bind("value").to(i, "value"),
              t.urlInputView.bind("isReadOnly").to(i, "isEnabled", (t) => !t),
              t.saveButtonView.bind("isEnabled").to(i);
          }
        }
        i(83);
        function Kg(t, e) {
          if (!t.childCount) return;
          const i = new wm(t.document),
            n = (function (t, e) {
              const i = e.createRangeIn(t),
                n = new ji({ name: /^p|h\d+$/, styles: { "mso-list": /.*/ } }),
                o = [];
              for (const t of i)
                if ("elementStart" === t.type && n.match(t.item)) {
                  const e = tf(t.item);
                  o.push({
                    element: t.item,
                    id: e.id,
                    order: e.order,
                    indent: e.indent,
                  });
                }
              return o;
            })(t, i);
          if (!n.length) return;
          let o = null,
            r = 1;
          n.forEach((t, s) => {
            const a = (function (t, e) {
                if (!t) return !0;
                if (t.id !== e.id) return !0;
                const i = e.element.previousSibling;
                if (!i) return !0;
                return (n = i), !(n.is("ol") || n.is("ul"));
                var n;
              })(n[s - 1], t),
              l = a ? null : n[s - 1],
              c = ((h = t), (d = l) ? h.indent - d.indent : h.indent - 1);
            var d, h;
            if ((a && ((o = null), (r = 1)), !o || 0 !== c)) {
              const n = (function (t, e) {
                const i = new RegExp(
                    `@list l${t.id}:level${t.indent}\\s*({[^}]*)`,
                    "gi"
                  ),
                  n = /mso-level-number-format:([^;]*);/gi,
                  o = i.exec(e);
                let r = "decimal";
                if (o && o[1]) {
                  const t = n.exec(o[1]);
                  t && t[1] && (r = t[1].trim());
                }
                return {
                  type: "bullet" !== r && "image" !== r ? "ol" : "ul",
                  style: r,
                };
              })(t, e);
              if (o) {
                if (t.indent > r) {
                  const t = o.getChild(o.childCount - 1),
                    e = t.getChild(t.childCount - 1);
                  (o = Zg(n, e, i)), (r += 1);
                } else if (t.indent < r) {
                  const e = r - t.indent;
                  (o = (function (t, e) {
                    const i = t.getAncestors({ parentFirst: !0 });
                    let n = null,
                      o = 0;
                    for (const t of i)
                      if (
                        (("ul" !== t.name && "ol" !== t.name) || o++, o === e)
                      ) {
                        n = t;
                        break;
                      }
                    return n;
                  })(o, e)),
                    (r = parseInt(t.indent));
                }
              } else o = Zg(n, t.element, i);
              t.indent <= r && (o.is(n.type) || (o = i.rename(n.type, o)));
            }
            const u = (function (t, e) {
              return (
                (function (t, e) {
                  const i = new ji({
                      name: "span",
                      styles: { "mso-list": "Ignore" },
                    }),
                    n = e.createRangeIn(t);
                  for (const t of n)
                    "elementStart" === t.type &&
                      i.match(t.item) &&
                      e.remove(t.item);
                })(t, e),
                e.rename("li", t)
              );
            })(t.element, i);
            i.appendChild(u, o);
          });
        }
        function Zg(t, e, i) {
          const n = e.parent,
            o = i.createElement(t.type),
            r = n.getChildIndex(e) + 1;
          return i.insertChild(r, o, n), o;
        }
        function tf(t) {
          const e = {},
            i = t.getStyle("mso-list");
          if (i) {
            const t = i.match(/(^|\s+)l(\d+)/i),
              n = i.match(/\s*lfo(\d+)/i),
              o = i.match(/\s*level(\d+)/i);
            t && n && o && ((e.id = t[2]), (e.order = n[1]), (e.indent = o[1]));
          }
          return e;
        }
        const ef = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
        class nf {
          constructor(t) {
            this.document = t;
          }
          isActive(t) {
            return ef.test(t);
          }
          execute(t) {
            const e = new wm(this.document);
            !(function (t, e) {
              for (const i of t.getChildren())
                if (i.is("b") && "normal" === i.getStyle("font-weight")) {
                  const n = t.getChildIndex(i);
                  e.remove(i), e.insertChild(n, i.getChildren(), t);
                }
            })(t.content, e),
              (function (t, e) {
                for (const i of e.createRangeIn(t)) {
                  const t = i.item;
                  if (t.is("li")) {
                    const i = t.getChild(0);
                    i.is("p") && e.unwrapElement(i);
                  }
                }
              })(t.content, e);
          }
        }
        function of(t) {
          return t.replace(
            /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
            (t, e) =>
              1 === e.length
                ? " "
                : Array(e.length + 1)
                    .join("  ")
                    .substr(0, e.length)
          );
        }
        function rf(t) {
          const e = new DOMParser(),
            i = (function (t) {
              return of(of(t))
                .replace(
                  /(<span\s+style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g,
                  "$1$2"
                )
                .replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "")
                .replace(/ <\//g, " </")
                .replace(/ <o:p><\/o:p>/g, " <o:p></o:p>")
                .replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "")
                .replace(/>(\s*[\r\n]\s*)</g, "><");
            })(
              (function (t) {
                const e = t.match(/<\/body>(.*?)(<\/html>|$)/);
                e &&
                  e[1] &&
                  (t =
                    t.slice(0, e.index) + t.slice(e.index).replace(e[1], ""));
                return t;
              })((t = t.replace(/<!--\[if gte vml 1]>/g, "")))
            ),
            n = e.parseFromString(i, "text/html");
          !(function (t) {
            t.querySelectorAll("span[style*=spacerun]").forEach((t) => {
              const e = t.innerText.length || 0;
              t.innerHTML = Array(e + 1)
                .join("  ")
                .substr(0, e);
            });
          })(n);
          const o = n.body.innerHTML,
            r = (function (t) {
              const e = new oo(new Sn()),
                i = new nr(e, { blockFillerMode: "nbsp" }),
                n = t.createDocumentFragment(),
                o = t.body.childNodes;
              for (; o.length > 0; ) n.appendChild(o[0]);
              return i.domToView(n);
            })(n),
            s = (function (t) {
              const e = [],
                i = [],
                n = Array.from(t.getElementsByTagName("style"));
              for (const t of n)
                t.sheet &&
                  t.sheet.cssRules &&
                  t.sheet.cssRules.length &&
                  (e.push(t.sheet), i.push(t.innerHTML));
              return { styles: e, stylesString: i.join(" ") };
            })(n);
          return {
            body: r,
            bodyString: o,
            styles: s.styles,
            stylesString: s.stylesString,
          };
        }
        function sf(t, e) {
          if (!t.childCount) return;
          const i = new wm();
          !(function (t, e, i) {
            const n = i.createRangeIn(e),
              o = new ji({ name: "img" }),
              r = [];
            for (const e of n)
              if (o.match(e.item)) {
                const i = e.item,
                  n = i.getAttribute("v:shapes")
                    ? i.getAttribute("v:shapes").split(" ")
                    : [];
                n.length && n.every((e) => t.indexOf(e) > -1)
                  ? r.push(i)
                  : i.getAttribute("src") || r.push(i);
              }
            for (const t of r) i.remove(t);
          })(
            (function (t, e) {
              const i = e.createRangeIn(t),
                n = new ji({ name: /v:(.+)/ }),
                o = [];
              for (const t of i) {
                const e = t.item,
                  i = (e.previousSibling && e.previousSibling.name) || null;
                n.match(e) &&
                  e.getAttribute("o:gfxdata") &&
                  "v:shapetype" !== i &&
                  o.push(t.item.getAttribute("id"));
              }
              return o;
            })(t, i),
            t,
            i
          ),
            (function (t, e) {
              const i = e.createRangeIn(t),
                n = new ji({ name: /v:(.+)/ }),
                o = [];
              for (const t of i) n.match(t.item) && o.push(t.item);
              for (const t of o) e.remove(t);
            })(t, i);
          const n = (function (t, e) {
            const i = e.createRangeIn(t),
              n = new ji({ name: "img" }),
              o = [];
            for (const t of i)
              n.match(t.item) &&
                t.item.getAttribute("src").startsWith("file://") &&
                o.push(t.item);
            return o;
          })(t, i);
          n.length &&
            (function (t, e, i) {
              if (t.length === e.length)
                for (let o = 0; o < t.length; o++) {
                  const r = `data:${e[o].type};base64,${
                    ((n = e[o].hex),
                    btoa(
                      n
                        .match(/\w{2}/g)
                        .map((t) => String.fromCharCode(parseInt(t, 16)))
                        .join("")
                    ))
                  }`;
                  i.setAttribute("src", r, t[o]);
                }
              var n;
            })(
              n,
              (function (t) {
                if (!t) return [];
                const e =
                    /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
                  i = new RegExp(
                    "(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}",
                    "g"
                  ),
                  n = t.match(i),
                  o = [];
                if (n)
                  for (const t of n) {
                    let i = !1;
                    t.includes("\\pngblip")
                      ? (i = "image/png")
                      : t.includes("\\jpegblip") && (i = "image/jpeg"),
                      i &&
                        o.push({
                          hex: t.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                          type: i,
                        });
                  }
                return o;
              })(e),
              i
            );
        }
        const af =
            /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
          lf = /xmlns:o="urn:schemas-microsoft-com/i;
        class cf {
          isActive(t) {
            return af.test(t) || lf.test(t);
          }
          execute(t) {
            const { body: e, stylesString: i } = rf(
              t.dataTransfer.getData("text/html")
            );
            Kg(e, i),
              sf(e, t.dataTransfer.getData("text/rtf")),
              (t.content = e);
          }
        }
        function df(t, e) {
          let i = e.parent;
          for (; i; ) {
            if (i.name === t) return i;
            i = i.parent;
          }
        }
        function hf(t, e, i, n, o = 1) {
          e > o ? n.setAttribute(t, e, i) : n.removeAttribute(t, i);
        }
        function uf(t, e, i = {}) {
          const n = t.createElement("tableCell", i);
          t.insertElement("paragraph", n), t.insert(n, e);
        }
        function mf(t, e) {
          const i = e.parent.parent,
            n = parseInt(i.getAttribute("headingColumns") || 0),
            { column: o } = t.getCellLocation(e);
          return !!n && o < n;
        }
        function gf() {
          return (t) => {
            t.on("element:table", (t, e, i) => {
              const n = e.viewItem;
              if (!i.consumable.test(n, { name: !0 })) return;
              const {
                  rows: o,
                  headingRows: r,
                  headingColumns: s,
                } = (function (t) {
                  const e = { headingRows: 0, headingColumns: 0 },
                    i = [],
                    n = [];
                  let o;
                  for (const r of Array.from(t.getChildren()))
                    if (
                      "tbody" === r.name ||
                      "thead" === r.name ||
                      "tfoot" === r.name
                    ) {
                      "thead" !== r.name || o || (o = r);
                      const t = Array.from(r.getChildren()).filter((t) =>
                        t.is("element", "tr")
                      );
                      for (const r of t)
                        if ("thead" === r.parent.name && r.parent === o)
                          e.headingRows++, i.push(r);
                        else {
                          n.push(r);
                          const t = pf(r);
                          t > e.headingColumns && (e.headingColumns = t);
                        }
                    }
                  return (e.rows = [...i, ...n]), e;
                })(n),
                a = {};
              s && (a.headingColumns = s), r && (a.headingRows = r);
              const l = i.writer.createElement("table", a),
                c = i.splitToAllowedParent(l, e.modelCursor);
              if (c) {
                if (
                  (i.writer.insert(l, c.position),
                  i.consumable.consume(n, { name: !0 }),
                  o.length)
                )
                  o.forEach((t) =>
                    i.convertItem(t, i.writer.createPositionAt(l, "end"))
                  );
                else {
                  const t = i.writer.createElement("tableRow");
                  i.writer.insert(t, i.writer.createPositionAt(l, "end")),
                    uf(i.writer, i.writer.createPositionAt(t, "end"));
                }
                (e.modelRange = i.writer.createRange(
                  i.writer.createPositionBefore(l),
                  i.writer.createPositionAfter(l)
                )),
                  c.cursorParent
                    ? (e.modelCursor = i.writer.createPositionAt(
                        c.cursorParent,
                        0
                      ))
                    : (e.modelCursor = e.modelRange.end);
              }
            });
          };
        }
        function ff(t) {
          return (e) => {
            e.on("element:" + t, (t, e, i) => {
              const n = e.viewItem;
              if (!i.consumable.test(n, { name: !0 })) return;
              const o = i.writer.createElement("tableCell"),
                r = i.splitToAllowedParent(o, e.modelCursor);
              if (!r) return;
              i.writer.insert(o, r.position),
                i.consumable.consume(n, { name: !0 });
              const s = i.writer.createPositionAt(o, 0);
              i.convertChildren(n, s),
                o.childCount || i.writer.insertElement("paragraph", s),
                (e.modelRange = i.writer.createRange(
                  i.writer.createPositionBefore(o),
                  i.writer.createPositionAfter(o)
                )),
                (e.modelCursor = e.modelRange.end);
            });
          };
        }
        function pf(t) {
          let e = 0,
            i = 0;
          const n = Array.from(t.getChildren()).filter(
            (t) => "th" === t.name || "td" === t.name
          );
          for (; i < n.length && "th" === n[i].name; ) {
            const t = n[i];
            (e += parseInt(t.getAttribute("colspan") || 1)), i++;
          }
          return e;
        }
        class bf {
          constructor(t, e = {}) {
            (this.table = t),
              (this.startRow = e.startRow || 0),
              (this.endRow = "number" == typeof e.endRow ? e.endRow : void 0),
              (this.includeSpanned = !!e.includeSpanned),
              (this.column = "number" == typeof e.column ? e.column : void 0),
              (this._skipRows = new Set()),
              (this._row = 0),
              (this._column = 0),
              (this._cellIndex = 0),
              (this._spannedCells = new Map()),
              (this._nextCellAtColumn = -1);
          }
          [Symbol.iterator]() {
            return this;
          }
          next() {
            const t = this.table.getChild(this._row);
            if (!t || this._isOverEndRow()) return { done: !0 };
            let e, i, n;
            if (this._isSpanned(this._row, this._column))
              (e = this._getSpanned(this._row, this._column)),
                (i =
                  !this.includeSpanned ||
                  this._shouldSkipRow() ||
                  this._shouldSkipColumn()),
                (n = this._formatOutValue(e, this._column, !0));
            else {
              if (((e = t.getChild(this._cellIndex)), !e))
                return (
                  this._row++,
                  (this._column = 0),
                  (this._cellIndex = 0),
                  (this._nextCellAtColumn = -1),
                  this.next()
                );
              const o = parseInt(e.getAttribute("colspan") || 1),
                r = parseInt(e.getAttribute("rowspan") || 1);
              (o > 1 || r > 1) &&
                this._recordSpans(this._row, this._column, r, o, e),
                (this._nextCellAtColumn = this._column + o),
                (i = this._shouldSkipRow() || this._shouldSkipColumn()),
                (n = this._formatOutValue(e, this._column, !1, r, o));
            }
            return (
              this._column++,
              this._column == this._nextCellAtColumn && this._cellIndex++,
              i ? this.next() : n
            );
          }
          skipRow(t) {
            this._skipRows.add(t);
          }
          _isOverEndRow() {
            return void 0 !== this.endRow && this._row > this.endRow;
          }
          _formatOutValue(t, e, i, n = 1, o = 1) {
            return {
              done: !1,
              value: {
                cell: t,
                row: this._row,
                column: e,
                isSpanned: i,
                rowspan: n,
                colspan: o,
                cellIndex: this._cellIndex,
              },
            };
          }
          _shouldSkipRow() {
            const t = this._row < this.startRow,
              e = this._skipRows.has(this._row);
            return t || e;
          }
          _shouldSkipColumn() {
            return void 0 !== this.column && this.column != this._column;
          }
          _isSpanned(t, e) {
            if (!this._spannedCells.has(t)) return !1;
            return this._spannedCells.get(t).has(e);
          }
          _getSpanned(t, e) {
            return this._spannedCells.get(t).get(e);
          }
          _recordSpans(t, e, i, n, o) {
            for (let i = e + 1; i <= e + n - 1; i++)
              this._markSpannedCell(t, i, o);
            for (let r = t + 1; r < t + i; r++)
              for (let t = e; t <= e + n - 1; t++)
                this._markSpannedCell(r, t, o);
          }
          _markSpannedCell(t, e, i) {
            this._spannedCells.has(t) || this._spannedCells.set(t, new Map()),
              this._spannedCells.get(t).set(e, i);
          }
        }
        function wf(t) {
          return !!t.getCustomProperty("table") && Eh(t);
        }
        function _f(t) {
          const e = t.getSelectedElement();
          return e && wf(e) ? e : null;
        }
        function kf(t) {
          const e = df("table", t.getFirstPosition());
          return e && wf(e.parent) ? e.parent : null;
        }
        function vf(t) {
          const e = [];
          for (const n of ((i = t.getRanges()), Array.from(i).sort(Mf))) {
            const t = n.getContainedElement();
            t && t.is("tableCell") && e.push(t);
          }
          var i;
          return e;
        }
        function yf(t) {
          const e = [];
          for (const i of t.getRanges()) {
            const t = df("tableCell", i.start);
            t && e.push(t);
          }
          return e;
        }
        function xf(t) {
          const e = vf(t);
          return e.length ? e : yf(t);
        }
        function Af(t) {
          return Tf(t.map((t) => t.parent.index));
        }
        function Cf(t) {
          const e = df("table", t[0]);
          return Tf(
            [...new bf(e)]
              .filter((e) => t.includes(e.cell))
              .map((t) => t.column)
          );
        }
        function Tf(t) {
          const e = t.sort((t, e) => t - e);
          return { first: e[0], last: e[e.length - 1] };
        }
        function Mf(t, e) {
          const i = t.start,
            n = e.start;
          return i.isBefore(n) ? -1 : 1;
        }
        function Ef(t = {}) {
          return (e) =>
            e.on("insert:table", (e, i, n) => {
              const o = i.item;
              if (!n.consumable.consume(o, "insert")) return;
              n.consumable.consume(o, "attribute:headingRows:table"),
                n.consumable.consume(o, "attribute:headingColumns:table");
              const r = t && t.asWidget,
                s = n.writer.createContainerElement("figure", {
                  class: "table",
                }),
                a = n.writer.createContainerElement("table");
              let l;
              var c, d;
              n.writer.insert(n.writer.createPositionAt(s, 0), a),
                r &&
                  ((c = s),
                  (d = n.writer).setCustomProperty("table", !0, c),
                  (l = Ph(c, d, { hasSelectionHandle: !0 })));
              const h = new bf(o),
                u = {
                  headingRows: o.getAttribute("headingRows") || 0,
                  headingColumns: o.getAttribute("headingColumns") || 0,
                },
                m = new Map();
              for (const e of h) {
                const { row: i, cell: r } = e,
                  s = Bf(zf(i, u), a, n),
                  l = o.getChild(i),
                  c = m.get(i) || jf(l, i, s, n);
                m.set(i, c),
                  n.consumable.consume(r, "insert"),
                  Lf(e, u, n.writer.createPositionAt(c, "end"), n, t);
              }
              const g = n.mapper.toViewPosition(i.range.start);
              n.mapper.bindElements(o, r ? l : s),
                n.writer.insert(g, r ? l : s);
            });
        }
        function Pf(t = {}) {
          return (e) =>
            e.on("insert:tableRow", (e, i, n) => {
              const o = i.item;
              if (!n.consumable.consume(o, "insert")) return;
              const r = o.parent,
                s = Uf(n.mapper.toViewElement(r)),
                a = r.getChildIndex(o),
                l = new bf(r, { startRow: a, endRow: a }),
                c = {
                  headingRows: r.getAttribute("headingRows") || 0,
                  headingColumns: r.getAttribute("headingColumns") || 0,
                },
                d = new Map();
              for (const e of l) {
                const i = Bf(zf(a, c), s, n),
                  r = d.get(a) || jf(o, a, i, n);
                d.set(a, r),
                  n.consumable.consume(e.cell, "insert"),
                  Lf(e, c, n.writer.createPositionAt(r, "end"), n, t);
              }
            });
        }
        function Sf(t = {}) {
          return (e) =>
            e.on("insert:tableCell", (e, i, n) => {
              const o = i.item;
              if (!n.consumable.consume(o, "insert")) return;
              const r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                l = new bf(s, { startRow: a, endRow: a }),
                c = {
                  headingRows: s.getAttribute("headingRows") || 0,
                  headingColumns: s.getAttribute("headingColumns") || 0,
                };
              for (const e of l)
                if (e.cell === o) {
                  const i = n.mapper.toViewElement(r);
                  return void Lf(
                    e,
                    c,
                    n.writer.createPositionAt(i, r.getChildIndex(o)),
                    n,
                    t
                  );
                }
            });
        }
        function If(t = {}) {
          const e = !!t.asWidget;
          return (t) =>
            t.on("attribute:headingRows:table", (t, i, n) => {
              const o = i.item;
              if (!n.consumable.consume(i.item, t.name)) return;
              const r = Uf(n.mapper.toViewElement(o)),
                s = i.attributeOldValue,
                a = i.attributeNewValue;
              if (a > s) {
                const t = Array.from(o.getChildren()).filter(({ index: t }) =>
                  l(t, s - 1, a)
                );
                Hf(t, Bf("thead", r, n), n, "end");
                for (const i of t)
                  for (const t of i.getChildren()) Nf(t, "th", n, e);
              } else {
                Hf(
                  Array.from(o.getChildren())
                    .filter(({ index: t }) => l(t, a - 1, s))
                    .reverse(),
                  Bf("tbody", r, n),
                  n,
                  0
                );
                const t = new bf(o, { startRow: a ? a - 1 : a, endRow: s - 1 }),
                  i = {
                    headingRows: o.getAttribute("headingRows") || 0,
                    headingColumns: o.getAttribute("headingColumns") || 0,
                  };
                for (const o of t) Rf(o, i, n, e);
              }
              function l(t, e, i) {
                return t > e && t < i;
              }
              Ff("thead", r, n), Ff("tbody", r, n);
            });
        }
        function Of(t = {}) {
          const e = !!t.asWidget;
          return (t) =>
            t.on("attribute:headingColumns:table", (t, i, n) => {
              const o = i.item;
              if (!n.consumable.consume(i.item, t.name)) return;
              const r = {
                  headingRows: o.getAttribute("headingRows") || 0,
                  headingColumns: o.getAttribute("headingColumns") || 0,
                },
                s = i.attributeOldValue,
                a = i.attributeNewValue,
                l = (s > a ? s : a) - 1;
              for (const t of new bf(o)) t.column > l || Rf(t, r, n, e);
            });
        }
        function Nf(t, e, i, n) {
          const o = i.writer,
            r = i.mapper.toViewElement(t);
          if (!r) return;
          let s;
          if (n) {
            (s = Ih(o.createEditableElement(e, r.getAttributes()), o)),
              o.insert(o.createPositionAfter(r), s),
              o.move(o.createRangeIn(r), o.createPositionAt(s, 0)),
              o.remove(o.createRangeOn(r));
          } else s = o.rename(e, r);
          i.mapper.unbindViewElement(r), i.mapper.bindElements(t, s);
        }
        function Rf(t, e, i, n) {
          const { cell: o } = t,
            r = Df(t, e),
            s = i.mapper.toViewElement(o);
          s && s.name !== r && Nf(o, r, i, n);
        }
        function Lf(t, e, i, n, o) {
          const r = o && o.asWidget,
            s = Df(t, e),
            a = r
              ? Ih(n.writer.createEditableElement(s), n.writer)
              : n.writer.createContainerElement(s),
            l = t.cell,
            c = l.getChild(0),
            d = 1 === l.childCount && "paragraph" === c.name;
          if ((n.writer.insert(i, a), d && ![...c.getAttributeKeys()].length)) {
            const t = l.getChild(0),
              e = n.writer.createPositionAt(a, "end");
            if ((n.consumable.consume(t, "insert"), o.asWidget)) {
              const i = n.writer.createContainerElement("span", {
                style: "display:inline-block",
              });
              n.mapper.bindElements(t, i),
                n.writer.insert(e, i),
                n.mapper.bindElements(l, a);
            } else n.mapper.bindElements(l, a), n.mapper.bindElements(t, a);
          } else n.mapper.bindElements(l, a);
        }
        function jf(t, e, i, n) {
          n.consumable.consume(t, "insert");
          const o = n.writer.createContainerElement("tr");
          n.mapper.bindElements(t, o);
          const r = t.parent.getAttribute("headingRows") || 0,
            s = r > 0 && e >= r ? e - r : e,
            a = n.writer.createPositionAt(i, s);
          return n.writer.insert(a, o), o;
        }
        function Df(t, e) {
          const { row: i, column: n } = t,
            { headingColumns: o, headingRows: r } = e;
          return (r && r > i) || (o && o > n) ? "th" : "td";
        }
        function zf(t, e) {
          return t < e.headingRows ? "thead" : "tbody";
        }
        function Bf(t, e, i) {
          const n = Vf(t, e);
          return (
            n ||
            (function (t, e, i) {
              const n = i.writer.createContainerElement(t),
                o = i.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
              return i.writer.insert(o, n), n;
            })(t, e, i)
          );
        }
        function Vf(t, e) {
          for (const i of e.getChildren()) if (i.name == t) return i;
        }
        function Ff(t, e, i) {
          const n = Vf(t, e);
          n && 0 === n.childCount && i.writer.remove(i.writer.createRangeOn(n));
        }
        function Hf(t, e, i, n) {
          for (const o of t) {
            const t = i.mapper.toViewElement(o);
            t &&
              i.writer.move(
                i.writer.createRangeOn(t),
                i.writer.createPositionAt(e, n)
              );
          }
        }
        function Uf(t) {
          for (const e of t.getChildren()) if ("table" === e.name) return e;
        }
        class Wf extends ed {
          refresh() {
            const t = this.editor.model,
              e = t.document.selection,
              i = t.schema,
              n = (function (t) {
                const e = t.parent;
                return e === e.root ? e : e.parent;
              })(e.getFirstPosition());
            this.isEnabled = i.checkChild(n, "table");
          }
          execute(t = {}) {
            const e = this.editor.model,
              i = e.document.selection,
              n = this.editor.plugins.get("TableUtils"),
              o = parseInt(t.rows) || 2,
              r = parseInt(t.columns) || 2,
              s = Oh(i, e);
            e.change((t) => {
              const i = n.createTable(t, o, r);
              e.insertContent(i, s),
                t.setSelection(
                  t.createPositionAt(i.getNodeByPath([0, 0, 0]), 0)
                );
            });
          }
        }
        class qf extends ed {
          constructor(t, e = {}) {
            super(t), (this.order = e.order || "below");
          }
          refresh() {
            const t = df(
              "table",
              this.editor.model.document.selection.getFirstPosition()
            );
            this.isEnabled = !!t;
          }
          execute() {
            const t = this.editor,
              e = t.model.document.selection,
              i = t.plugins.get("TableUtils"),
              n = "above" === this.order,
              o = n ? e.getFirstPosition() : e.getLastPosition(),
              r = (
                (n
                  ? e.getFirstRange()
                  : e.getLastRange()
                ).getContainedElement() || df("tableCell", o)
              ).parent,
              s = r.parent,
              a = s.getChildIndex(r);
            i.insertRows(s, {
              rows: 1,
              at: "below" === this.order ? a + 1 : a,
            });
          }
        }
        class Yf extends ed {
          constructor(t, e = {}) {
            super(t), (this.order = e.order || "right");
          }
          refresh() {
            const t = df(
              "table",
              this.editor.model.document.selection.getFirstPosition()
            );
            this.isEnabled = !!t;
          }
          execute() {
            const t = this.editor,
              e = t.model.document.selection,
              i = t.plugins.get("TableUtils"),
              n = "left" === this.order,
              o = n ? e.getFirstPosition() : e.getLastPosition(),
              r =
                (n
                  ? e.getFirstRange()
                  : e.getLastRange()
                ).getContainedElement() || df("tableCell", o),
              s = r.parent.parent,
              { column: a } = i.getCellLocation(r);
            i.insertColumns(s, { columns: 1, at: n ? a : a + 1 });
          }
        }
        class $f extends ed {
          constructor(t, e = {}) {
            super(t), (this.direction = e.direction || "horizontally");
          }
          refresh() {
            const t = xf(this.editor.model.document.selection);
            this.isEnabled = 1 === t.length;
          }
          execute() {
            const t = xf(this.editor.model.document.selection)[0],
              e = "horizontally" === this.direction,
              i = this.editor.plugins.get("TableUtils");
            e ? i.splitCellHorizontally(t, 2) : i.splitCellVertically(t, 2);
          }
        }
        class Jf extends ed {
          constructor(t, e) {
            super(t),
              (this.direction = e.direction),
              (this.isHorizontal =
                "right" == this.direction || "left" == this.direction);
          }
          refresh() {
            const t = this._getMergeableCell();
            (this.value = t), (this.isEnabled = !!t);
          }
          execute() {
            const t = this.editor.model,
              e = yf(t.document.selection)[0],
              i = this.value,
              n = this.direction;
            t.change((t) => {
              const o = "right" == n || "down" == n,
                r = o ? e : i,
                s = o ? i : e,
                a = s.parent;
              !(function (t, e, i) {
                Gf(t) ||
                  (Gf(e) && i.remove(i.createRangeIn(e)),
                  i.move(i.createRangeIn(t), i.createPositionAt(e, "end")));
                i.remove(t);
              })(s, r, t);
              const l = this.isHorizontal ? "colspan" : "rowspan",
                c = parseInt(e.getAttribute(l) || 1),
                d = parseInt(i.getAttribute(l) || 1);
              t.setAttribute(l, c + d, r),
                t.setSelection(t.createRangeIn(r)),
                a.childCount ||
                  (function (t, e) {
                    const i = t.parent,
                      n = i.getChildIndex(t);
                    for (const { cell: t, row: o, rowspan: r } of new bf(i, {
                      endRow: n,
                    })) {
                      o + r - 1 >= n && hf("rowspan", r - 1, t, e);
                    }
                    e.remove(t);
                  })(a, t);
            });
          }
          _getMergeableCell() {
            const t = yf(this.editor.model.document.selection)[0];
            if (!t) return;
            const e = this.editor.plugins.get("TableUtils"),
              i = this.isHorizontal
                ? (function (t, e, i) {
                    const n = t.parent.parent,
                      o = "right" == e ? t.nextSibling : t.previousSibling,
                      r = (n.getAttribute("headingColumns") || 0) > 0;
                    if (!o) return;
                    const s = "right" == e ? t : o,
                      a = "right" == e ? o : t,
                      { column: l } = i.getCellLocation(s),
                      { column: c } = i.getCellLocation(a),
                      d = parseInt(s.getAttribute("colspan") || 1),
                      h = mf(i, s),
                      u = mf(i, a);
                    if (r && h != u) return;
                    return l + d === c ? o : void 0;
                  })(t, this.direction, e)
                : (function (t, e) {
                    const i = t.parent,
                      n = i.parent,
                      o = n.getChildIndex(i);
                    if (
                      ("down" == e && o === n.childCount - 1) ||
                      ("up" == e && 0 === o)
                    )
                      return;
                    const r = parseInt(t.getAttribute("rowspan") || 1),
                      s = n.getAttribute("headingRows") || 0,
                      a = "down" == e && o + r === s,
                      l = "up" == e && o === s;
                    if (s && (a || l)) return;
                    const c = parseInt(t.getAttribute("rowspan") || 1),
                      d = "down" == e ? o + c : o,
                      h = [...new bf(n, { endRow: d })],
                      u = h.find((e) => e.cell === t).column,
                      m = h.find(
                        ({ row: t, rowspan: i, column: n }) =>
                          n === u && ("down" == e ? t === d : d === t + i)
                      );
                    return m && m.cell;
                  })(t, this.direction);
            if (!i) return;
            const n = this.isHorizontal ? "rowspan" : "colspan",
              o = parseInt(t.getAttribute(n) || 1);
            return parseInt(i.getAttribute(n) || 1) === o ? i : void 0;
          }
        }
        function Gf(t) {
          return (
            1 == t.childCount &&
            t.getChild(0).is("paragraph") &&
            t.getChild(0).isEmpty
          );
        }
        class Qf extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection),
              e = t[0];
            if (e) {
              const i = df("table", e),
                n = this.editor.plugins.get("TableUtils").getRows(i) - 1,
                o = Af(t),
                r = 0 === o.first && o.last === n;
              this.isEnabled = !r;
            } else this.isEnabled = !1;
          }
          execute() {
            const t = this.editor.model,
              e = xf(t.document.selection),
              i = Af(e),
              n = e[0],
              o = df("table", n),
              r = this.editor.plugins
                .get("TableUtils")
                .getCellLocation(n).column,
              s = t.createBatch();
            t.enqueueChange(s, (t) => {
              t.setSelection(t.createSelection(o, "on"));
              const e = i.last - i.first + 1;
              this.editor.plugins
                .get("TableUtils")
                .removeRows(o, { at: i.first, rows: e, batch: s });
            }),
              t.enqueueChange(s, (t) => {
                const e = (function (t, e, i) {
                  const n = t.getChild(e) || t.getChild(t.childCount - 1);
                  let o = n.getChild(0),
                    r = 0;
                  for (const t of n.getChildren()) {
                    if (r > i) return o;
                    (o = t), (r += parseInt(t.getAttribute("colspan") || 1));
                  }
                  return o;
                })(o, i.first, r);
                t.setSelection(t.createPositionAt(e, 0));
              });
          }
        }
        class Xf extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection),
              e = t[0];
            if (e) {
              const i = df("table", e),
                n = this.editor.plugins.get("TableUtils").getColumns(i),
                { first: o, last: r } = Cf(t);
              this.isEnabled = r - o < n - 1;
            } else this.isEnabled = !1;
          }
          execute() {
            const [t, e] = (function (t) {
                const e = xf(t),
                  i = e[0],
                  n = e.pop(),
                  o = [i, n];
                return i.isBefore(n) ? o : o.reverse();
              })(this.editor.model.document.selection),
              i = t.parent.parent,
              n = [...new bf(i)],
              o = {
                first: n.find((e) => e.cell === t).column,
                last: n.find((t) => t.cell === e).column,
              },
              r = (function (t, e, i, n) {
                return parseInt(i.getAttribute("colspan") || 1) > 1
                  ? i
                  : e.previousSibling || i.nextSibling
                  ? i.nextSibling || e.previousSibling
                  : n.first
                  ? t.reverse().find(({ column: t }) => t < n.first).cell
                  : t.reverse().find(({ column: t }) => t > n.last).cell;
              })(n, t, e, o);
            this.editor.model.change((t) => {
              const e = o.last - o.first + 1;
              this.editor.plugins
                .get("TableUtils")
                .removeColumns(i, { at: o.first, columns: e }),
                t.setSelection(t.createPositionAt(r, 0));
            });
          }
        }
        class Kf extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection),
              e = t.length > 0;
            (this.isEnabled = e),
              (this.value =
                e && t.every((t) => this._isInHeading(t, t.parent.parent)));
          }
          execute(t = {}) {
            if (t.forceValue === this.value) return;
            const e = this.editor.model,
              i = xf(e.document.selection),
              n = df("table", i[0]),
              { first: o, last: r } = Af(i),
              s = this.value ? o : r + 1,
              a = n.getAttribute("headingRows") || 0;
            e.change((t) => {
              if (s) {
                const e = (function (t, e, i) {
                  const n = [],
                    o = new bf(t, { startRow: e > i ? i : 0, endRow: e - 1 });
                  for (const { row: t, rowspan: i, cell: r } of o)
                    i > 1 && t + i > e && n.push(r);
                  return n;
                })(n, s, a);
                for (const i of e) Zf(i, s, t);
              }
              hf("headingRows", s, n, t, 0);
            });
          }
          _isInHeading(t, e) {
            const i = parseInt(e.getAttribute("headingRows") || 0);
            return !!i && t.parent.index < i;
          }
        }
        function Zf(t, e, i) {
          const n = t.parent,
            o = n.parent,
            r = e - n.index,
            s = {},
            a = parseInt(t.getAttribute("rowspan")) - r;
          a > 1 && (s.rowspan = a);
          const l = parseInt(t.getAttribute("colspan") || 1);
          l > 1 && (s.colspan = l);
          const c = o.getChildIndex(n),
            d = c + r,
            h = [...new bf(o, { startRow: c, endRow: d, includeSpanned: !0 })];
          let u;
          for (const { row: e, column: n, cell: r, cellIndex: a } of h)
            if (
              (r === t && void 0 === u && (u = n),
              void 0 !== u && u === n && e === d)
            ) {
              const t = o.getChild(e),
                n = i.createPositionAt(t, a);
              uf(i, n, s);
            }
          hf("rowspan", r, t, i);
        }
        class tp extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection),
              e = this.editor.plugins.get("TableUtils"),
              i = t.length > 0;
            (this.isEnabled = i), (this.value = i && t.every((t) => mf(e, t)));
          }
          execute(t = {}) {
            if (t.forceValue === this.value) return;
            const e = this.editor.model,
              i = xf(e.document.selection),
              { first: n, last: o } = Cf(i),
              r = this.value ? n : o + 1;
            e.change((t) => {
              const e = df("table", i[0]);
              hf("headingColumns", r, e, t, 0);
            });
          }
        }
        class ep extends Gc {
          static get pluginName() {
            return "TableUtils";
          }
          getCellLocation(t) {
            const e = t.parent,
              i = e.parent,
              n = i.getChildIndex(e),
              o = new bf(i, { startRow: n, endRow: n });
            for (const { cell: e, row: i, column: n } of o)
              if (e === t) return { row: i, column: n };
          }
          createTable(t, e, i) {
            const n = t.createElement("table");
            return ip(t, n, 0, e, i), n;
          }
          insertRows(t, e = {}) {
            const i = this.editor.model,
              n = e.at || 0,
              o = e.rows || 1;
            i.change((e) => {
              const i = t.getAttribute("headingRows") || 0;
              if (
                (i > n && e.setAttribute("headingRows", i + o, t),
                0 === n || n === t.childCount)
              )
                return void ip(e, t, n, o, this.getColumns(t));
              const r = new bf(t, { endRow: n });
              let s = 0;
              for (const { row: t, rowspan: i, colspan: a, cell: l } of r) {
                const r = t + i > n;
                t < n && r && e.setAttribute("rowspan", i + o, l),
                  t === n && (s += a);
              }
              ip(e, t, n, o, s);
            });
          }
          insertColumns(t, e = {}) {
            const i = this.editor.model,
              n = e.at || 0,
              o = e.columns || 1;
            i.change((e) => {
              const i = t.getAttribute("headingColumns");
              n < i && e.setAttribute("headingColumns", i + o, t);
              const r = this.getColumns(t);
              if (0 === n || r === n) {
                for (const i of t.getChildren())
                  np(o, e, e.createPositionAt(i, n ? "end" : 0));
                return;
              }
              const s = new bf(t, { column: n, includeSpanned: !0 });
              for (const { row: i, cell: r, cellIndex: a } of s) {
                const l = parseInt(r.getAttribute("rowspan") || 1),
                  c = parseInt(r.getAttribute("colspan") || 1);
                if (a !== n && c > 1) {
                  if (
                    (e.setAttribute("colspan", c + o, r), s.skipRow(i), l > 1)
                  )
                    for (let t = i + 1; t < i + l; t++) s.skipRow(t);
                } else {
                  const n = e.createPositionAt(t.getChild(i), a);
                  np(o, e, n);
                }
              }
            });
          }
          removeRows(t, e) {
            const i = this.editor.model,
              n = e.rows || 1,
              o = e.at,
              r = o + n - 1,
              s = e.batch || "default",
              { cellsToMove: a, cellsToTrim: l } = (function (t, e, i) {
                const n = new Map(),
                  o = [];
                for (const { row: r, column: s, rowspan: a, cell: l } of new bf(
                  t,
                  { endRow: i }
                )) {
                  const t = r + a - 1;
                  if (r >= e && r <= i && t > i) {
                    const t = a - (i - r + 1);
                    n.set(s, { cell: l, rowspan: t });
                  }
                  if (r < e && t >= e) {
                    let n;
                    (n = t >= i ? i - e + 1 : t - e + 1),
                      o.push({ cell: l, rowspan: a - n });
                  }
                }
                return { cellsToMove: n, cellsToTrim: o };
              })(t, o, r);
            i.enqueueChange(s, (e) => {
              !(function (t, e, i, n) {
                const o = [
                    ...new bf(t, {
                      includeSpanned: !0,
                      startRow: e,
                      endRow: e,
                    }),
                  ],
                  r = t.getChild(e);
                let s;
                for (const { column: t, cell: e, isSpanned: a } of o)
                  if (i.has(t)) {
                    const { cell: e, rowspan: o } = i.get(t),
                      a = s
                        ? n.createPositionAfter(s)
                        : n.createPositionAt(r, 0);
                    n.move(n.createRangeOn(e), a),
                      hf("rowspan", o, e, n),
                      (s = e);
                  } else a || (s = e);
              })(t, r + 1, a, e);
              for (let i = r; i >= o; i--) e.remove(t.getChild(i));
              for (const { rowspan: t, cell: i } of l) hf("rowspan", t, i, e);
              !(function (t, e, i, n, o) {
                const r = t.getAttribute("headingRows") || 0;
                if (e < r) {
                  const s = i < r ? r - (i - e + 1) : e;
                  n.enqueueChange(o, (e) => {
                    hf("headingRows", s, t, e, 0);
                  });
                }
              })(t, o, r, i, s);
            });
          }
          removeColumns(t, e) {
            const i = this.editor.model,
              n = e.at,
              o = e.columns || 1,
              r = e.at + o - 1;
            i.change((e) => {
              !(function (t, e, i) {
                const n = t.getAttribute("headingColumns") || 0;
                if (n && e.first < n) {
                  const o = Math.min(n - 1, e.last) - e.first + 1;
                  i.setAttribute("headingColumns", n - o, t);
                }
              })(t, { first: n, last: r }, e);
              for (let i = r; i >= n; i--)
                for (const { cell: n, column: o, colspan: r } of [...new bf(t)])
                  if (o <= i && r > 1 && o + r > i) hf("colspan", r - 1, n, e);
                  else if (o === i) {
                    const i = n.parent;
                    e.remove(n),
                      i.childCount || this.removeRows(t, { at: i.index });
                  }
            });
          }
          splitCellVertically(t, e = 2) {
            const i = this.editor.model,
              n = t.parent.parent,
              o = parseInt(t.getAttribute("rowspan") || 1),
              r = parseInt(t.getAttribute("colspan") || 1);
            i.change((i) => {
              if (r > 1) {
                const { newCellsSpan: n, updatedSpan: s } = op(r, e);
                hf("colspan", s, t, i);
                const a = {};
                n > 1 && (a.colspan = n),
                  o > 1 && (a.rowspan = o),
                  np(r > e ? e - 1 : r - 1, i, i.createPositionAfter(t), a);
              }
              if (r < e) {
                const s = e - r,
                  a = [...new bf(n)],
                  { column: l } = a.find(({ cell: e }) => e === t),
                  c = a.filter(
                    ({ cell: e, colspan: i, column: n }) =>
                      (e !== t && n === l) || (n < l && n + i > l)
                  );
                for (const { cell: t, colspan: e } of c)
                  i.setAttribute("colspan", e + s, t);
                const d = {};
                o > 1 && (d.rowspan = o), np(s, i, i.createPositionAfter(t), d);
                const h = n.getAttribute("headingColumns") || 0;
                h > l && hf("headingColumns", h + s, n, i);
              }
            });
          }
          splitCellHorizontally(t, e = 2) {
            const i = this.editor.model,
              n = t.parent,
              o = n.parent,
              r = o.getChildIndex(n),
              s = parseInt(t.getAttribute("rowspan") || 1),
              a = parseInt(t.getAttribute("colspan") || 1);
            i.change((i) => {
              if (s > 1) {
                const n = [
                    ...new bf(o, {
                      startRow: r,
                      endRow: r + s - 1,
                      includeSpanned: !0,
                    }),
                  ],
                  { newCellsSpan: l, updatedSpan: c } = op(s, e);
                hf("rowspan", c, t, i);
                const { column: d } = n.find(({ cell: e }) => e === t),
                  h = {};
                l > 1 && (h.rowspan = l), a > 1 && (h.colspan = a);
                for (const { column: t, row: e, cellIndex: s } of n) {
                  const n = t === d,
                    a = (e + r + c) % l == 0;
                  if (e >= r + c && n && a) {
                    const t = i.createPositionAt(o.getChild(e), s);
                    np(1, i, t, h);
                  }
                }
              }
              if (s < e) {
                const n = e - s,
                  l = [...new bf(o, { startRow: 0, endRow: r })];
                for (const { cell: e, rowspan: o, row: s } of l)
                  if (e !== t && s + o > r) {
                    const t = o + n;
                    i.setAttribute("rowspan", t, e);
                  }
                const c = {};
                a > 1 && (c.colspan = a), ip(i, o, r + 1, n, 1, c);
                const d = o.getAttribute("headingRows") || 0;
                d > r && hf("headingRows", d + n, o, i);
              }
            });
          }
          getColumns(t) {
            return [...t.getChild(0).getChildren()].reduce(
              (t, e) => t + parseInt(e.getAttribute("colspan") || 1),
              0
            );
          }
          getRows(t) {
            return t.childCount;
          }
        }
        function ip(t, e, i, n, o, r = {}) {
          for (let s = 0; s < n; s++) {
            const n = t.createElement("tableRow");
            t.insert(n, e, i), np(o, t, t.createPositionAt(n, "end"), r);
          }
        }
        function np(t, e, i, n = {}) {
          for (let o = 0; o < t; o++) uf(e, i, n);
        }
        function op(t, e) {
          if (t < e) return { newCellsSpan: 1, updatedSpan: 1 };
          const i = Math.floor(t / e);
          return { newCellsSpan: i, updatedSpan: t - i * e + i };
        }
        class rp extends ed {
          refresh() {
            this.isEnabled = (function (t, e) {
              const i = vf(t);
              if (
                i.length < 2 ||
                !(function (t) {
                  const e = df("table", t[0]),
                    i = Af(t),
                    n = parseInt(e.getAttribute("headingRows") || 0);
                  if (!cp(i, n)) return !1;
                  const o = parseInt(e.getAttribute("headingColumns") || 0);
                  return cp(Cf(t), o);
                })(i)
              )
                return !1;
              const n = new Set(),
                o = new Set();
              let r = 0;
              for (const t of i) {
                const { row: i, column: s } = e.getCellLocation(t),
                  a = parseInt(t.getAttribute("rowspan") || 1),
                  l = parseInt(t.getAttribute("colspan") || 1);
                n.add(i),
                  o.add(s),
                  a > 1 && n.add(i + a - 1),
                  l > 1 && o.add(s + l - 1),
                  (r += a * l);
              }
              return (
                (function (t, e) {
                  const i = Array.from(t.values()),
                    n = Array.from(e.values()),
                    o = Math.max(...i),
                    r = Math.min(...i),
                    s = Math.max(...n),
                    a = Math.min(...n);
                  return (o - r + 1) * (s - a + 1);
                })(n, o) == r
              );
            })(
              this.editor.model.document.selection,
              this.editor.plugins.get(ep)
            );
          }
          execute() {
            const t = this.editor.model,
              e = this.editor.plugins.get(ep);
            t.change((i) => {
              const n = vf(t.document.selection),
                o = n.shift();
              i.setSelection(o, 0);
              const { mergeWidth: r, mergeHeight: s } = (function (t, e, i) {
                let n = 0,
                  o = 0;
                for (const t of e) {
                  const { row: e, column: r } = i.getCellLocation(t);
                  (n = dp(t, r, n, "colspan")), (o = dp(t, e, o, "rowspan"));
                }
                const { row: r, column: s } = i.getCellLocation(t);
                return { mergeWidth: n - s, mergeHeight: o - r };
              })(o, n, e);
              hf("colspan", r, o, i), hf("rowspan", s, o, i);
              for (const t of n) {
                const e = t.parent;
                ap(t, o, i), sp(e, i);
              }
              i.setSelection(o, "in");
            });
          }
        }
        function sp(t, e) {
          if (t.childCount) return;
          const i = t.parent,
            n = i.getChildIndex(t);
          for (const { cell: t, row: o, rowspan: r } of new bf(i, {
            endRow: n,
          })) {
            o + r - 1 >= n && hf("rowspan", r - 1, t, e);
          }
          e.remove(t);
        }
        function ap(t, e, i) {
          lp(t) ||
            (lp(e) && i.remove(i.createRangeIn(e)),
            i.move(i.createRangeIn(t), i.createPositionAt(e, "end"))),
            i.remove(t);
        }
        function lp(t) {
          return (
            1 == t.childCount &&
            t.getChild(0).is("paragraph") &&
            t.getChild(0).isEmpty
          );
        }
        function cp({ first: t, last: e }, i) {
          return t < i === e < i;
        }
        function dp(t, e, i, n) {
          const o = parseInt(t.getAttribute(n) || 1);
          return Math.max(i, e + o);
        }
        class hp extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection);
            this.isEnabled = t.length > 0;
          }
          execute() {
            const t = this.editor.model,
              e = xf(t.document.selection),
              i = Af(e),
              n = df("table", e[0]),
              o = [];
            for (let e = i.first; e <= i.last; e++)
              for (const i of n.getChild(e).getChildren())
                o.push(t.createRangeOn(i));
            t.change((t) => {
              t.setSelection(o);
            });
          }
        }
        class up extends ed {
          refresh() {
            const t = xf(this.editor.model.document.selection);
            this.isEnabled = t.length > 0;
          }
          execute() {
            const t = this.editor.model,
              e = xf(t.document.selection),
              i = e[0],
              n = e.pop(),
              o = this.editor.plugins.get("TableUtils"),
              r = o.getCellLocation(i),
              s = o.getCellLocation(n),
              a = Math.min(r.column, s.column),
              l = Math.max(r.column, s.column),
              c = [];
            for (const e of new bf(df("table", i)))
              e.column >= a && e.column <= l && c.push(t.createRangeOn(e.cell));
            t.change((t) => {
              t.setSelection(c);
            });
          }
        }
        function mp(t) {
          t.document.registerPostFixer((e) =>
            (function (t, e) {
              const i = e.document.differ.getChanges();
              let n = !1;
              const o = new Set();
              for (const e of i) {
                let i;
                "table" == e.name &&
                  "insert" == e.type &&
                  (i = e.position.nodeAfter),
                  ("tableRow" != e.name && "tableCell" != e.name) ||
                    (i = df("table", e.position)),
                  pp(e) && (i = df("table", e.range.start)),
                  i &&
                    !o.has(i) &&
                    ((n = gp(i, t) || n), (n = fp(i, t) || n), o.add(i));
              }
              return n;
            })(e, t)
          );
        }
        function gp(t, e) {
          let i = !1;
          const n = (function (t) {
            const e = parseInt(t.getAttribute("headingRows") || 0),
              i = t.childCount,
              n = [];
            for (const { row: o, rowspan: r, cell: s } of new bf(t)) {
              if (r < 2) continue;
              const t = o < e ? e : i;
              if (o + r > t) {
                const e = t - o;
                n.push({ cell: s, rowspan: e });
              }
            }
            return n;
          })(t);
          if (n.length) {
            i = !0;
            for (const t of n) hf("rowspan", t.rowspan, t.cell, e, 1);
          }
          return i;
        }
        function fp(t, e) {
          let i = !1;
          const n = (function (t) {
              const e = {};
              for (const { row: i } of new bf(t, { includeSpanned: !0 }))
                e[i] || (e[i] = 0), (e[i] += 1);
              return e;
            })(t),
            o = n[0];
          if (!Object.values(n).every((t) => t === o)) {
            const o = Object.values(n).reduce((t, e) => (e > t ? e : t), 0);
            for (const [r, s] of Object.entries(n)) {
              const n = o - s;
              if (n) {
                for (let i = 0; i < n; i++)
                  uf(e, e.createPositionAt(t.getChild(r), "end"));
                i = !0;
              }
            }
          }
          return i;
        }
        function pp(t) {
          const e = "attribute" === t.type,
            i = t.attributeKey;
          return (
            e && ("headingRows" === i || "colspan" === i || "rowspan" === i)
          );
        }
        function bp(t) {
          t.document.registerPostFixer((e) =>
            (function (t, e) {
              const i = e.document.differ.getChanges();
              let n = !1;
              for (const e of i)
                "insert" == e.type &&
                  "table" == e.name &&
                  (n = wp(e.position.nodeAfter, t) || n),
                  "insert" == e.type &&
                    "tableRow" == e.name &&
                    (n = _p(e.position.nodeAfter, t) || n),
                  "insert" == e.type &&
                    "tableCell" == e.name &&
                    (n = kp(e.position.nodeAfter, t) || n),
                  vp(e) && (n = kp(e.position.parent, t) || n);
              return n;
            })(e, t)
          );
        }
        function wp(t, e) {
          let i = !1;
          for (const n of t.getChildren()) i = _p(n, e) || i;
          return i;
        }
        function _p(t, e) {
          let i = !1;
          for (const n of t.getChildren()) i = kp(n, e) || i;
          return i;
        }
        function kp(t, e) {
          if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
          const i = Array.from(t.getChildren()).filter((t) => t.is("text"));
          for (const t of i) e.wrap(e.createRangeOn(t), "paragraph");
          return !!i.length;
        }
        function vp(t) {
          return (
            !(!t.position || !t.position.parent.is("tableCell")) &&
            (("insert" == t.type && "$text" == t.name) || "remove" == t.type)
          );
        }
        function yp(t) {
          t.document.registerPostFixer(() =>
            (function (t) {
              const e = t.document.differ,
                i = new Set();
              for (const t of e.getChanges()) {
                const e =
                  "insert" == t.type || "remove" == t.type
                    ? t.position.parent
                    : t.range.start.parent;
                e.is("tableCell") && xp(e, t.type) && i.add(e);
              }
              if (i.size) {
                for (const t of i.values()) e.refreshItem(t);
                return !0;
              }
              return !1;
            })(t)
          );
        }
        function xp(t, e) {
          if (!Array.from(t.getChildren()).some((t) => t.is("paragraph")))
            return !1;
          if ("attribute" == e) {
            const e = Array.from(t.getChild(0).getAttributeKeys()).length;
            return 1 === t.childCount && e < 2;
          }
          return t.childCount <= ("insert" == e ? 2 : 1);
        }
        i(85);
        class Ap extends Gc {
          static get pluginName() {
            return "TableEditing";
          }
          init() {
            const t = this.editor,
              e = t.model,
              i = e.schema,
              n = t.conversion;
            i.register("table", {
              allowWhere: "$block",
              allowAttributes: ["headingRows", "headingColumns"],
              isLimit: !0,
              isObject: !0,
              isBlock: !0,
            }),
              i.register("tableRow", { allowIn: "table", isLimit: !0 }),
              i.register("tableCell", {
                allowIn: "tableRow",
                allowAttributes: ["colspan", "rowspan"],
                isObject: !0,
              }),
              i.extend("$block", { allowIn: "tableCell" }),
              i.addChildCheck((t, e) => {
                if (
                  "table" == e.name &&
                  Array.from(t.getNames()).includes("table")
                )
                  return !1;
              }),
              n.for("upcast").add(gf()),
              n.for("editingDowncast").add(Ef({ asWidget: !0 })),
              n.for("dataDowncast").add(Ef()),
              n
                .for("upcast")
                .elementToElement({ model: "tableRow", view: "tr" }),
              n.for("editingDowncast").add(Pf({ asWidget: !0 })),
              n.for("dataDowncast").add(Pf()),
              n.for("downcast").add((t) =>
                t.on(
                  "remove:tableRow",
                  (t, e, i) => {
                    t.stop();
                    const n = i.writer,
                      o = i.mapper,
                      r = o
                        .toViewPosition(e.position)
                        .getLastMatchingPosition(
                          (t) => !t.item.is("tr")
                        ).nodeAfter,
                      s = r.parent.parent,
                      a = n.createRangeOn(r),
                      l = n.remove(a);
                    for (const t of n.createRangeIn(l).getItems())
                      o.unbindViewElement(t);
                    Ff("thead", s, i), Ff("tbody", s, i);
                  },
                  { priority: "higher" }
                )
              ),
              n.for("upcast").add(ff("td")),
              n.for("upcast").add(ff("th")),
              n.for("editingDowncast").add(Sf({ asWidget: !0 })),
              n.for("dataDowncast").add(Sf()),
              n.attributeToAttribute({ model: "colspan", view: "colspan" }),
              n.attributeToAttribute({ model: "rowspan", view: "rowspan" }),
              n.for("editingDowncast").add(Of({ asWidget: !0 })),
              n.for("dataDowncast").add(Of()),
              n.for("editingDowncast").add(If({ asWidget: !0 })),
              n.for("dataDowncast").add(If()),
              t.commands.add("insertTable", new Wf(t)),
              t.commands.add(
                "insertTableRowAbove",
                new qf(t, { order: "above" })
              ),
              t.commands.add(
                "insertTableRowBelow",
                new qf(t, { order: "below" })
              ),
              t.commands.add(
                "insertTableColumnLeft",
                new Yf(t, { order: "left" })
              ),
              t.commands.add(
                "insertTableColumnRight",
                new Yf(t, { order: "right" })
              ),
              t.commands.add("removeTableRow", new Qf(t)),
              t.commands.add("removeTableColumn", new Xf(t)),
              t.commands.add(
                "splitTableCellVertically",
                new $f(t, { direction: "vertically" })
              ),
              t.commands.add(
                "splitTableCellHorizontally",
                new $f(t, { direction: "horizontally" })
              ),
              t.commands.add("mergeTableCells", new rp(t)),
              t.commands.add(
                "mergeTableCellRight",
                new Jf(t, { direction: "right" })
              ),
              t.commands.add(
                "mergeTableCellLeft",
                new Jf(t, { direction: "left" })
              ),
              t.commands.add(
                "mergeTableCellDown",
                new Jf(t, { direction: "down" })
              ),
              t.commands.add(
                "mergeTableCellUp",
                new Jf(t, { direction: "up" })
              ),
              t.commands.add("setTableColumnHeader", new tp(t)),
              t.commands.add("setTableRowHeader", new Kf(t)),
              t.commands.add("selectTableRow", new hp(t)),
              t.commands.add("selectTableColumn", new up(t)),
              mp(e),
              yp(e),
              bp(e);
          }
          static get requires() {
            return [ep];
          }
        }
        i(87);
        class Cp extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate;
            this.set("icon"),
              this.set("isEnabled", !0),
              this.set("isOn", !1),
              this.set("isToggleable", !1),
              this.set("isVisible", !0),
              this.set("keystroke"),
              this.set("label"),
              this.set("tabindex", -1),
              this.set("tooltip"),
              this.set("tooltipPosition", "s"),
              this.set("type", "button"),
              this.set("withText", !1),
              (this.children = this.createCollection()),
              (this.actionView = this._createActionView()),
              (this.arrowView = this._createArrowView()),
              (this.keystrokes = new Al()),
              (this.focusTracker = new Nl()),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-splitbutton",
                    e.if("isVisible", "ck-hidden", (t) => !t),
                    this.arrowView.bindTemplate.if(
                      "isOn",
                      "ck-splitbutton_open"
                    ),
                  ],
                },
                children: this.children,
              });
          }
          render() {
            super.render(),
              this.children.add(this.actionView),
              this.children.add(this.arrowView),
              this.focusTracker.add(this.actionView.element),
              this.focusTracker.add(this.arrowView.element),
              this.keystrokes.listenTo(this.element),
              this.keystrokes.set("arrowright", (t, e) => {
                this.focusTracker.focusedElement === this.actionView.element &&
                  (this.arrowView.focus(), e());
              }),
              this.keystrokes.set("arrowleft", (t, e) => {
                this.focusTracker.focusedElement === this.arrowView.element &&
                  (this.actionView.focus(), e());
              });
          }
          focus() {
            this.actionView.focus();
          }
          _createActionView() {
            const t = new Oc();
            return (
              t
                .bind(
                  "icon",
                  "isEnabled",
                  "isOn",
                  "isToggleable",
                  "keystroke",
                  "label",
                  "tabindex",
                  "tooltip",
                  "tooltipPosition",
                  "type",
                  "withText"
                )
                .to(this),
              t.extendTemplate({
                attributes: { class: "ck-splitbutton__action" },
              }),
              t.delegate("execute").to(this),
              t
            );
          }
          _createArrowView() {
            const t = new Oc(),
              e = t.bindTemplate;
            return (
              (t.icon = Nc),
              t.extendTemplate({
                attributes: {
                  class: "ck-splitbutton__arrow",
                  "aria-haspopup": !0,
                  "aria-expanded": e.to("isOn", (t) => String(t)),
                },
              }),
              t.bind("isEnabled").to(this),
              t.delegate("execute").to(this, "open"),
              t
            );
          }
        }
        i(89);
        class Tp extends lc {
          constructor(t) {
            super(t);
            const e = this.bindTemplate;
            (this.items = this._createGridCollection()),
              this.set("rows", 0),
              this.set("columns", 0),
              this.bind("label").to(
                this,
                "columns",
                this,
                "rows",
                (t, e) => `${e} × ${t}`
              ),
              this.setTemplate({
                tag: "div",
                attributes: { class: ["ck"] },
                children: [
                  {
                    tag: "div",
                    attributes: { class: ["ck-insert-table-dropdown__grid"] },
                    on: {
                      "mouseover@.ck-insert-table-dropdown-grid-box":
                        e.to("boxover"),
                    },
                    children: this.items,
                  },
                  {
                    tag: "div",
                    attributes: { class: ["ck-insert-table-dropdown__label"] },
                    children: [{ text: e.to("label") }],
                  },
                ],
                on: {
                  mousedown: e.to((t) => {
                    t.preventDefault();
                  }),
                  click: e.to(() => {
                    this.fire("execute");
                  }),
                },
              }),
              this.on("boxover", (t, e) => {
                const { row: i, column: n } = e.target.dataset;
                this.set({ rows: parseInt(i), columns: parseInt(n) });
              }),
              this.on("change:columns", () => {
                this._highlightGridBoxes();
              }),
              this.on("change:rows", () => {
                this._highlightGridBoxes();
              });
          }
          focus() {}
          focusLast() {}
          _highlightGridBoxes() {
            const t = this.rows,
              e = this.columns;
            this.items.map((i, n) => {
              const o = Math.floor(n / 10) < t && n % 10 < e;
              i.set("isOn", o);
            });
          }
          _createGridCollection() {
            const t = [];
            for (let e = 0; e < 100; e++) {
              const i = Math.floor(e / 10),
                n = e % 10;
              t.push(new Mp(this.locale, i + 1, n + 1));
            }
            return this.createCollection(t);
          }
        }
        class Mp extends lc {
          constructor(t, e, i) {
            super(t);
            const n = this.bindTemplate;
            this.set("isOn", !1),
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck-insert-table-dropdown-grid-box",
                    n.if("isOn", "ck-on"),
                  ],
                  "data-row": e,
                  "data-column": i,
                },
              });
          }
        }
        class Ep extends Gc {
          init() {
            const t = this.editor,
              e = this.editor.t,
              i = "ltr" === t.locale.contentLanguageDirection;
            t.ui.componentFactory.add("insertTable", (i) => {
              const n = t.commands.get("insertTable"),
                o = Vc(i);
              let r;
              return (
                o.bind("isEnabled").to(n),
                o.buttonView.set({
                  icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
                  label: e("Insert table"),
                  tooltip: !0,
                }),
                o.on("change:isOpen", () => {
                  r ||
                    ((r = new Tp(i)),
                    o.panelView.children.add(r),
                    r.delegate("execute").to(o),
                    o.buttonView.on("open", () => {
                      (r.rows = 0), (r.columns = 0);
                    }),
                    o.on("execute", () => {
                      t.execute("insertTable", {
                        rows: r.rows,
                        columns: r.columns,
                      }),
                        t.editing.view.focus();
                    }));
                }),
                o
              );
            }),
              t.ui.componentFactory.add("tableColumn", (t) => {
                const n = [
                  {
                    type: "switchbutton",
                    model: {
                      commandName: "setTableColumnHeader",
                      label: e("Header column"),
                      bindIsOn: !0,
                    },
                  },
                  { type: "separator" },
                  {
                    type: "button",
                    model: {
                      commandName: i
                        ? "insertTableColumnLeft"
                        : "insertTableColumnRight",
                      label: e("Insert column left"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: i
                        ? "insertTableColumnRight"
                        : "insertTableColumnLeft",
                      label: e("Insert column right"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "removeTableColumn",
                      label: e("Delete column"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "selectTableColumn",
                      label: e("Select column"),
                    },
                  },
                ];
                return this._prepareDropdown(
                  e("Column"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',
                  n,
                  t
                );
              }),
              t.ui.componentFactory.add("tableRow", (t) => {
                const i = [
                  {
                    type: "switchbutton",
                    model: {
                      commandName: "setTableRowHeader",
                      label: e("Header row"),
                      bindIsOn: !0,
                    },
                  },
                  { type: "separator" },
                  {
                    type: "button",
                    model: {
                      commandName: "insertTableRowBelow",
                      label: e("Insert row below"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "insertTableRowAbove",
                      label: e("Insert row above"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "removeTableRow",
                      label: e("Delete row"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "selectTableRow",
                      label: e("Select row"),
                    },
                  },
                ];
                return this._prepareDropdown(
                  e("Row"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',
                  i,
                  t
                );
              }),
              t.ui.componentFactory.add("mergeTableCells", (t) => {
                const n = [
                  {
                    type: "button",
                    model: {
                      commandName: "mergeTableCellUp",
                      label: e("Merge cell up"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: i
                        ? "mergeTableCellRight"
                        : "mergeTableCellLeft",
                      label: e("Merge cell right"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "mergeTableCellDown",
                      label: e("Merge cell down"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: i
                        ? "mergeTableCellLeft"
                        : "mergeTableCellRight",
                      label: e("Merge cell left"),
                    },
                  },
                  { type: "separator" },
                  {
                    type: "button",
                    model: {
                      commandName: "splitTableCellVertically",
                      label: e("Split cell vertically"),
                    },
                  },
                  {
                    type: "button",
                    model: {
                      commandName: "splitTableCellHorizontally",
                      label: e("Split cell horizontally"),
                    },
                  },
                ];
                return this._prepareMergeSplitButtonDropdown(
                  e("Merge cells"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>',
                  n,
                  t
                );
              });
          }
          _prepareDropdown(t, e, i, n) {
            const o = this.editor,
              r = Vc(n),
              s = this._fillDropdownWithListOptions(r, i);
            return (
              r.buttonView.set({ label: t, icon: e, tooltip: !0 }),
              r
                .bind("isEnabled")
                .toMany(s, "isEnabled", (...t) => t.some((t) => t)),
              this.listenTo(r, "execute", (t) => {
                o.execute(t.source.commandName), o.editing.view.focus();
              }),
              r
            );
          }
          _prepareMergeSplitButtonDropdown(t, e, i, n) {
            const o = this.editor,
              r = Vc(n, Cp);
            return (
              this._fillDropdownWithListOptions(r, i),
              r.buttonView.set({
                label: t,
                icon: e,
                tooltip: !0,
                isEnabled: !0,
              }),
              this.listenTo(r.buttonView, "execute", () => {
                o.execute("mergeTableCells"), o.editing.view.focus();
              }),
              this.listenTo(r, "execute", (t) => {
                o.execute(t.source.commandName), o.editing.view.focus();
              }),
              r
            );
          }
          _fillDropdownWithListOptions(t, e) {
            const i = this.editor,
              n = [],
              o = new xi();
            for (const t of e) Pp(t, i, n, o);
            return Hc(t, o, i.ui.componentFactory), n;
          }
        }
        function Pp(t, e, i, n) {
          const o = (t.model = new Om(t.model)),
            { commandName: r, bindIsOn: s } = t.model;
          if ("button" === t.type || "switchbutton" === t.type) {
            const t = e.commands.get(r);
            i.push(t),
              o.set({ commandName: r }),
              o.bind("isEnabled").to(t),
              s && o.bind("isOn").to(t, "value");
          }
          o.set({ withText: !0 }), n.add(t);
        }
        class Sp extends Or {
          constructor(t) {
            super(t),
              (this.domEventType = ["mousemove", "mouseup", "mouseleave"]);
          }
          onDomEvent(t) {
            this.fire(t.type, t);
          }
        }
        function Ip(t, e, i) {
          const n = Array.from(t),
            o = n[0],
            r = n[n.length - 1],
            { row: s, column: a } = e.getCellLocation(o),
            l = (function (t, e, i, n) {
              const o = i.createElement("table"),
                r = new Map(),
                s = new Map();
              for (const e of t) {
                const t = df("tableRow", e);
                if (!r.has(t)) {
                  const e = t._clone();
                  i.append(e, o), r.set(t, e);
                }
                const a = e._clone(!0),
                  { column: l } = n.getCellLocation(e);
                s.set(a, l), i.append(a, r.get(t));
              }
              return (
                (function (t, e, i, n, o) {
                  for (const r of t.getChildren())
                    for (const t of Array.from(r.getChildren())) {
                      const { column: r } = o.getCellLocation(t),
                        s = i.get(t) - e;
                      if (r !== s)
                        for (let e = 0; e < s - r; e++) {
                          const e = n.createElement("tableCell");
                          n.insert(e, n.createPositionBefore(t));
                          const i = n.createElement("paragraph");
                          n.insert(i, e, 0), n.insertText("", i, 0);
                        }
                    }
                })(o, e, s, i, n),
                o
              );
            })(n, a, i, e),
            { row: c, column: d } = e.getCellLocation(r);
          return (
            (function (t, e, i, n, o) {
              for (const r of t.getChildren())
                for (const t of r.getChildren()) {
                  const r = parseInt(t.getAttribute("colspan") || 1),
                    s = parseInt(t.getAttribute("rowspan") || 1),
                    { row: a, column: l } = o.getCellLocation(t);
                  if (l + r > e) {
                    const i = e - l;
                    i > 1
                      ? n.setAttribute("colspan", i, t)
                      : n.removeAttribute("colspan", t);
                  }
                  if (a + s > i) {
                    const e = i - a;
                    e > 1
                      ? n.setAttribute("rowspan", e, t)
                      : n.removeAttribute("rowspan", t);
                  }
                }
            })(l, d - a + 1, c - s + 1, i, e),
            (function (t, e, i, n, o) {
              const r = parseInt(e.getAttribute("headingRows") || 0);
              if (r > 0) {
                const e = r - i;
                o.setAttribute("headingRows", e, t);
              }
              const s = parseInt(e.getAttribute("headingColumns") || 0);
              if (s > 0) {
                const e = s - n;
                o.setAttribute("headingColumns", e, t);
              }
            })(l, df("table", o), s, a, i),
            l
          );
        }
        i(91);
        class Op extends Gc {
          static get pluginName() {
            return "TableSelection";
          }
          static get requires() {
            return [ep];
          }
          init() {
            const t = this.editor,
              e = t.model;
            this.listenTo(
              e,
              "deleteContent",
              (t, e) => this._handleDeleteContent(t, e),
              { priority: "high" }
            ),
              t.editing.view.addObserver(Sp),
              this._defineSelectionConverter(),
              this._enableShiftClickSelection(),
              this._enableMouseDragSelection(),
              this._enablePluginDisabling();
          }
          getSelectedTableCells() {
            const t = vf(this.editor.model.document.selection);
            return 0 == t.length ? null : t;
          }
          getSelectionAsFragment() {
            const t = this.getSelectedTableCells();
            return t
              ? this.editor.model.change((e) => {
                  const i = e.createDocumentFragment(),
                    n = Ip(t, this.editor.plugins.get("TableUtils"), e);
                  return e.insert(n, i, 0), i;
                })
              : null;
          }
          _defineSelectionConverter() {
            const t = this.editor,
              e = new Set();
            t.conversion.for("editingDowncast").add((t) =>
              t.on(
                "selection",
                (t, i, n) => {
                  const o = n.writer;
                  !(function (t) {
                    for (const i of e)
                      t.removeClass("ck-editor__editable_selected", i);
                    e.clear();
                  })(o);
                  const r = this.getSelectedTableCells();
                  if (!r) return;
                  for (const t of r) {
                    const i = n.mapper.toViewElement(t);
                    o.addClass("ck-editor__editable_selected", i), e.add(i);
                  }
                  const s = n.mapper.toViewElement(r[r.length - 1]);
                  o.setSelection(s, 0);
                },
                { priority: "lowest" }
              )
            );
          }
          _enableShiftClickSelection() {
            const t = this.editor;
            let e = !1;
            this.listenTo(t.editing.view.document, "mousedown", (i, n) => {
              if (!this.isEnabled) return;
              if (!n.domEvent.shiftKey) return;
              const o = yf(t.model.document.selection)[0];
              if (!o) return;
              const r = this._getModelTableCellFromDomEvent(n);
              r &&
                Np(o, r) &&
                ((e = !0), this._setCellSelection(o, r), n.preventDefault());
            }),
              this.listenTo(t.editing.view.document, "mouseup", () => {
                e = !1;
              }),
              this.listenTo(
                t.editing.view.document,
                "selectionChange",
                (t) => {
                  e && t.stop();
                },
                { priority: "highest" }
              );
          }
          _enableMouseDragSelection() {
            const t = this.editor;
            let e,
              i,
              n = !1,
              o = !1;
            this.listenTo(t.editing.view.document, "mousedown", (t, i) => {
              this.isEnabled &&
                (i.domEvent.shiftKey ||
                  i.domEvent.ctrlKey ||
                  i.domEvent.altKey ||
                  (e = this._getModelTableCellFromDomEvent(i)));
            }),
              this.listenTo(t.editing.view.document, "mousemove", (t, r) => {
                if (!r.domEvent.buttons) return;
                if (!e) return;
                const s = this._getModelTableCellFromDomEvent(r);
                s && Np(e, s) && ((i = s), n || i == e || (n = !0)),
                  n &&
                    ((o = !0),
                    this._setCellSelection(e, i),
                    r.preventDefault());
              }),
              this.listenTo(t.editing.view.document, "mouseup", () => {
                (n = !1), (o = !1), (e = null), (i = null);
              }),
              this.listenTo(
                t.editing.view.document,
                "selectionChange",
                (t) => {
                  o && t.stop();
                },
                { priority: "highest" }
              );
          }
          _enablePluginDisabling() {
            const t = this.editor;
            this.on("change:isEnabled", () => {
              if (!this.isEnabled) {
                const e = this.getSelectedTableCells();
                if (!e) return;
                t.model.change((i) => {
                  const n = i.createPositionAt(e[0], 0),
                    o = t.model.schema.getNearestSelectionRange(n);
                  i.setSelection(o);
                });
              }
            });
          }
          _handleDeleteContent(t, e) {
            const [i, n] = e,
              o = this.editor.model,
              r = !n || "backward" == n.direction,
              s = vf(i);
            s.length &&
              (t.stop(),
              o.change((t) => {
                const e = s[r ? s.length - 1 : 0];
                o.change((t) => {
                  for (const e of s)
                    o.deleteContent(t.createSelection(e, "in"));
                });
                const n = o.schema.getNearestSelectionRange(
                  t.createPositionAt(e, 0)
                );
                i.is("documentSelection") ? t.setSelection(n) : i.setTo(n);
              }));
          }
          _setCellSelection(t, e) {
            const i = this._getCellsToSelect(t, e);
            this.editor.model.change((t) => {
              t.setSelection(
                i.cells.map((e) => t.createRangeOn(e)),
                { backward: i.backward }
              );
            });
          }
          _getModelTableCellFromDomEvent(t) {
            const e = t.target,
              i = this.editor.editing.view.createPositionAt(e, 0),
              n = this.editor.editing.mapper.toModelPosition(i).parent;
            return n.is("tableCell") ? n : df("tableCell", n);
          }
          _getCellsToSelect(t, e) {
            const i = this.editor.plugins.get("TableUtils"),
              n = i.getCellLocation(t),
              o = i.getCellLocation(e),
              r = Math.min(n.row, o.row),
              s = Math.max(n.row, o.row),
              a = Math.min(n.column, o.column),
              l = Math.max(n.column, o.column),
              c = [];
            for (const e of new bf(df("table", t), { startRow: r, endRow: s }))
              e.column >= a && e.column <= l && c.push(e.cell);
            return (function (t, e) {
              if (t.row > e.row) return !0;
              if (t.row == e.row && t.column > e.column) return !0;
              return !1;
            })(n, o)
              ? { cells: c.reverse(), backward: !0 }
              : { cells: c, backward: !1 };
          }
        }
        function Np(t, e) {
          return t.parent.parent == e.parent.parent;
        }
        class Rp extends Gc {
          static get pluginName() {
            return "TableClipboard";
          }
          static get requires() {
            return [Op];
          }
          init() {
            const t = this.editor.editing.view.document;
            this.listenTo(t, "copy", (t, e) => this._onCopyCut(t, e)),
              this.listenTo(t, "cut", (t, e) => this._onCopyCut(t, e));
          }
          _onCopyCut(t, e) {
            const i = this.editor.plugins.get("TableSelection");
            if (!i.getSelectedTableCells()) return;
            if ("cut" == t.name && this.editor.isReadOnly) return;
            e.preventDefault(), t.stop();
            const n = this.editor.data,
              o = this.editor.editing.view.document,
              r = n.toView(i.getSelectionAsFragment());
            o.fire("clipboardOutput", {
              dataTransfer: e.dataTransfer,
              content: r,
              method: t.name,
            });
          }
        }
        class Lp extends Gc {
          static get pluginName() {
            return "TableNavigation";
          }
          init() {
            const t = this.editor.editing.view.document;
            this.editor.keystrokes.set(
              "Tab",
              (...t) => this._handleTabOnSelectedTable(...t),
              { priority: "low" }
            ),
              this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
                priority: "low",
              }),
              this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
                priority: "low",
              }),
              this.listenTo(t, "keydown", (...t) => this._onKeydown(...t), {
                priority: di.get("high") + 1,
              });
          }
          _handleTabOnSelectedTable(t, e) {
            const i = this.editor,
              n = i.model.document.selection;
            if (
              !n.isCollapsed &&
              1 === n.rangeCount &&
              n.getFirstRange().isFlat
            ) {
              const t = n.getSelectedElement();
              if (!t || !t.is("table")) return;
              e(),
                i.model.change((e) => {
                  e.setSelection(e.createRangeIn(t.getChild(0).getChild(0)));
                });
            }
          }
          _getTabHandler(t) {
            const e = this.editor;
            return (i, n) => {
              const o = yf(e.model.document.selection)[0];
              if (!o) return;
              n();
              const r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                l = r.getChildIndex(o),
                c = 0 === l;
              if (!t && c && 0 === a) return;
              const d = l === r.childCount - 1,
                h = a === s.childCount - 1;
              if (
                t &&
                h &&
                d &&
                (e.execute("insertTableRowBelow"), a === s.childCount - 1)
              )
                return;
              let u;
              if (t && d) {
                const t = s.getChild(a + 1);
                u = t.getChild(0);
              } else if (!t && c) {
                const t = s.getChild(a - 1);
                u = t.getChild(t.childCount - 1);
              } else u = r.getChild(l + (t ? 1 : -1));
              e.model.change((t) => {
                t.setSelection(t.createRangeIn(u));
              });
            };
          }
          _onKeydown(t, e) {
            const i = e.keyCode;
            (function (t) {
              return (
                t == fo.arrowright ||
                t == fo.arrowleft ||
                t == fo.arrowup ||
                t == fo.arrowdown
              );
            })(i) &&
              this._handleArrowKeys(
                (function (t, e) {
                  const i = "ltr" === e;
                  switch (t) {
                    case fo.arrowleft:
                      return i ? "left" : "right";
                    case fo.arrowright:
                      return i ? "right" : "left";
                    case fo.arrowup:
                      return "up";
                    case fo.arrowdown:
                      return "down";
                  }
                })(i, this.editor.locale.contentLanguageDirection)
              ) &&
              (e.preventDefault(), e.stopPropagation(), t.stop());
          }
          _handleArrowKeys(t) {
            const e = this.editor.model,
              i = e.document.selection,
              n = ["right", "down"].includes(t),
              o = vf(i);
            if (o.length) {
              const e = n ? o[o.length - 1] : o[0];
              return this._navigateFromCellInDirection(e, t), !0;
            }
            const r = df("tableCell", i.focus);
            if (!r) return !1;
            const s = e.createRangeIn(r);
            if (this._isSelectionAtCellEdge(i, n))
              return this._navigateFromCellInDirection(r, t), !0;
            const a = i.getSelectedElement();
            if (a && e.schema.isObject(a)) return !1;
            if (this._isObjectElementNextToSelection(i, n)) return !1;
            const l = this._findTextRangeFromSelection(s, i, n);
            return l
              ? !["left", "right"].includes(t) &&
                  (this._isSingleLineRange(l, n)
                    ? (e.change((t) => {
                        t.setSelection(n ? s.end : s.start);
                      }),
                      !0)
                    : void 0)
              : (this._navigateFromCellInDirection(r, t), !0);
          }
          _isSelectionAtCellEdge(t, e) {
            const i = this.editor.model,
              n = this.editor.model.schema,
              o = e ? t.getLastPosition() : t.getFirstPosition();
            if (!n.getLimitElement(o).is("tableCell")) return !1;
            const r = i.createSelection(o);
            return (
              i.modifySelection(r, { direction: e ? "forward" : "backward" }),
              o.isEqual(r.focus)
            );
          }
          _isObjectElementNextToSelection(t, e) {
            const i = this.editor.model,
              n = i.schema,
              o = i.createSelection(t);
            i.modifySelection(o, { direction: e ? "forward" : "backward" });
            const r = e ? o.focus.nodeBefore : o.focus.nodeAfter;
            return r && n.isObject(r);
          }
          _findTextRangeFromSelection(t, e, i) {
            const n = this.editor.model;
            if (i) {
              const i = e.getLastPosition(),
                o = this._getNearestVisibleTextPosition(t, "backward");
              return o && i.isBefore(o) ? n.createRange(i, o) : null;
            }
            {
              const i = e.getFirstPosition(),
                o = this._getNearestVisibleTextPosition(t, "forward");
              return o && i.isAfter(o) ? n.createRange(o, i) : null;
            }
          }
          _getNearestVisibleTextPosition(t, e) {
            const i = this.editor.model.schema,
              n = this.editor.editing.mapper;
            for (const { nextPosition: o, item: r } of t.getWalker({
              direction: e,
            }))
              if (i.checkChild(o, "$text")) {
                const t = n.toViewElement(r);
                if (t && !t.hasClass("ck-hidden")) return o;
              }
          }
          _isSingleLineRange(t, e) {
            const i = this.editor.model,
              n = this.editor.editing,
              o = n.view.domConverter;
            if (e) {
              const e = i.createSelection(t.start);
              i.modifySelection(e),
                e.focus.isAtEnd ||
                  t.start.isEqual(e.focus) ||
                  (t = i.createRange(e.focus, t.end));
            }
            const r = n.mapper.toViewRange(t),
              s = o.viewRangeToDom(r),
              a = Kr.getDomRangeRects(s);
            let l;
            for (const t of a)
              if (void 0 !== l) {
                if (Math.round(t.top) >= l) return !1;
                l = Math.max(l, Math.round(t.bottom));
              } else l = Math.round(t.bottom);
            return !0;
          }
          _navigateFromCellInDirection(t, e) {
            const i = this.editor.model,
              n = df("table", t),
              o = [...new bf(n, { includeSpanned: !0 })],
              { row: r, column: s } = o[o.length - 1],
              a = o.find(({ cell: e }) => e == t);
            let { row: l, column: c } = a;
            switch (e) {
              case "left":
                c--;
                break;
              case "up":
                l--;
                break;
              case "right":
                c += a.colspan;
                break;
              case "down":
                l += a.rowspan;
            }
            if (l < 0 || l > r || (c < 0 && l <= 0) || (c > s && l >= r))
              return void i.change((t) => {
                t.setSelection(t.createRangeOn(n));
              });
            c < 0 ? ((c = s), l--) : c > s && ((c = 0), l++);
            const d = o.find((t) => t.row == l && t.column == c).cell,
              h = ["right", "down"].includes(e),
              u = i.createPositionAt(d, h ? 0 : "end");
            i.change((t) => {
              t.setSelection(u);
            });
          }
        }
        i(93);
        class jp {
          constructor(t, e) {
            (this.model = t),
              (this.testCallback = e),
              (this.hasMatch = !1),
              this.set("isEnabled", !0),
              this.on("change:isEnabled", () => {
                this.isEnabled
                  ? this._startListening()
                  : (this.stopListening(t.document.selection),
                    this.stopListening(t.document));
              }),
              this._startListening();
          }
          _startListening() {
            const t = this.model.document;
            this.listenTo(
              t.selection,
              "change:range",
              (e, { directChange: i }) => {
                i &&
                  (t.selection.isCollapsed
                    ? this._evaluateTextBeforeSelection("selection")
                    : this.hasMatch &&
                      (this.fire("unmatched"), (this.hasMatch = !1)));
              }
            ),
              this.listenTo(t, "change:data", (t, e) => {
                "transparent" != e.type &&
                  this._evaluateTextBeforeSelection("data", { batch: e });
              });
          }
          _evaluateTextBeforeSelection(t, e = {}) {
            const i = this.model,
              n = i.document.selection,
              o = i.createRange(i.createPositionAt(n.focus.parent, 0), n.focus),
              { text: r, range: s } = sh(o, i),
              a = this.testCallback(r);
            if (
              (!a && this.hasMatch && this.fire("unmatched"),
              (this.hasMatch = !!a),
              a)
            ) {
              const i = Object.assign(e, { text: r, range: s });
              "object" == typeof a && Object.assign(i, a),
                this.fire("matched:" + t, i);
            }
          }
        }
        yi(jp, Hn);
        var Dp = /[\\^$.*+?()[\]{}|]/g,
          zp = RegExp(Dp.source);
        var Bp = function (t) {
          return (t = Xi(t)) && zp.test(t) ? t.replace(Dp, "\\$&") : t;
        };
        const Vp = {
            copyright: { from: "(c)", to: "©" },
            registeredTrademark: { from: "(r)", to: "®" },
            trademark: { from: "(tm)", to: "™" },
            oneHalf: { from: "1/2", to: "½" },
            oneThird: { from: "1/3", to: "⅓" },
            twoThirds: { from: "2/3", to: "⅔" },
            oneForth: { from: "1/4", to: "¼" },
            threeQuarters: { from: "3/4", to: "¾" },
            lessThanOrEqual: { from: "<=", to: "≤" },
            greaterThanOrEqual: { from: ">=", to: "≥" },
            notEqual: { from: "!=", to: "≠" },
            arrowLeft: { from: "<-", to: "←" },
            arrowRight: { from: "->", to: "→" },
            horizontalEllipsis: { from: "...", to: "…" },
            enDash: { from: /(^| )(--)( )$/, to: [null, "–", null] },
            emDash: { from: /(^| )(---)( )$/, to: [null, "—", null] },
            quotesPrimary: { from: Yp('"'), to: [null, "“", null, "”"] },
            quotesSecondary: { from: Yp("'"), to: [null, "‘", null, "’"] },
            quotesPrimaryEnGb: { from: Yp("'"), to: [null, "‘", null, "’"] },
            quotesSecondaryEnGb: { from: Yp('"'), to: [null, "“", null, "”"] },
            quotesPrimaryPl: { from: Yp('"'), to: [null, "„", null, "”"] },
            quotesSecondaryPl: { from: Yp("'"), to: [null, "‚", null, "’"] },
          },
          Fp = {
            symbols: ["copyright", "registeredTrademark", "trademark"],
            mathematical: [
              "oneHalf",
              "oneThird",
              "twoThirds",
              "oneForth",
              "threeQuarters",
              "lessThanOrEqual",
              "greaterThanOrEqual",
              "notEqual",
              "arrowLeft",
              "arrowRight",
            ],
            typography: ["horizontalEllipsis", "enDash", "emDash"],
            quotes: ["quotesPrimary", "quotesSecondary"],
          },
          Hp = ["symbols", "mathematical", "typography", "quotes"];
        function Up(t) {
          return "string" == typeof t ? new RegExp(`(${Bp(t)})$`) : t;
        }
        function Wp(t) {
          return "string" == typeof t
            ? () => [t]
            : t instanceof Array
            ? () => t
            : t;
        }
        function qp(t) {
          return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
        }
        function Yp(t) {
          return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`);
        }
        class $p {
          constructor(t, e = {}) {
            (this.namespaces = e.namespaces || []),
              (this._domParser = new DOMParser()),
              (this._domConverter = new nr(t, { blockFillerMode: "nbsp" })),
              (this._htmlWriter = new Pl());
          }
          toData(t) {
            const e = this._domConverter.viewToDom(t, document);
            return this._htmlWriter.getHtml(e);
          }
          toView(t) {
            const e = this._toDom(t);
            return this._domConverter.domToView(e, { keepOriginalCase: !0 });
          }
          _toDom(t) {
            t = `<xml ${this.namespaces
              .map((t) => `xmlns:${t}="nsp"`)
              .join(" ")}>${t}</xml>`;
            const e = this._domParser.parseFromString(t, "text/xml"),
              i = e.querySelector("parsererror");
            if (i) throw new Error("Parse error - " + i.textContent);
            const n = e.createDocumentFragment(),
              o = e.documentElement.childNodes;
            for (; o.length > 0; ) n.appendChild(o[0]);
            return n;
          }
        }
        class Jp {
          static get safeXmlCharactersEntities() {
            return {
              tagOpener: "&laquo;",
              tagCloser: "&raquo;",
              doubleQuote: "&uml;",
              realDoubleQuote: "&quot;",
            };
          }
          static get safeBadBlackboardCharacters() {
            return {
              ltElement: "«mo»<«/mo»",
              gtElement: "«mo»>«/mo»",
              ampElement: "«mo»&«/mo»",
            };
          }
          static get safeGoodBlackboardCharacters() {
            return {
              ltElement: "«mo»§lt;«/mo»",
              gtElement: "«mo»§gt;«/mo»",
              ampElement: "«mo»§amp;«/mo»",
            };
          }
          static get xmlCharacters() {
            return {
              id: "xmlCharacters",
              tagOpener: "<",
              tagCloser: ">",
              doubleQuote: '"',
              ampersand: "&",
              quote: "'",
            };
          }
          static get safeXmlCharacters() {
            return {
              id: "safeXmlCharacters",
              tagOpener: "«",
              tagCloser: "»",
              doubleQuote: "¨",
              ampersand: "§",
              quote: "`",
              realDoubleQuote: "¨",
            };
          }
        }
        class Gp {
          static isMathmlInAttribute(t, e) {
            const i = new RegExp(
                "^['\"][\\s]*=[\\s]*[\\w-]+('[\\s]*(\"[^\"]*\"|'[^']*')[\\s]*=[\\s]*[\\w-]+[\\s]*')*[\\s]+gmi<"
              ),
              n = t.substring(0, e).split("").reverse().join("");
            return i.test(n);
          }
          static safeXmlDecode(t) {
            let { tagOpener: e } = Jp.safeXmlCharactersEntities,
              { tagCloser: i } = Jp.safeXmlCharactersEntities,
              { doubleQuote: n } = Jp.safeXmlCharactersEntities,
              { realDoubleQuote: o } = Jp.safeXmlCharactersEntities;
            t = (t = (t = (t = t.split(e).join(Jp.safeXmlCharacters.tagOpener))
              .split(i)
              .join(Jp.safeXmlCharacters.tagCloser))
              .split(n)
              .join(Jp.safeXmlCharacters.doubleQuote))
              .split(o)
              .join(Jp.safeXmlCharacters.realDoubleQuote);
            const { ltElement: r } = Jp.safeBadBlackboardCharacters,
              { gtElement: s } = Jp.safeBadBlackboardCharacters,
              { ampElement: a } = Jp.safeBadBlackboardCharacters;
            "_wrs_blackboard" in window &&
              window._wrs_blackboard &&
              (t = (t = (t = t
                .split(r)
                .join(Jp.safeGoodBlackboardCharacters.ltElement))
                .split(s)
                .join(Jp.safeGoodBlackboardCharacters.gtElement))
                .split(a)
                .join(Jp.safeGoodBlackboardCharacters.ampElement)),
              ({ tagOpener: e } = Jp.safeXmlCharacters),
              ({ tagCloser: i } = Jp.safeXmlCharacters),
              ({ doubleQuote: n } = Jp.safeXmlCharacters),
              ({ realDoubleQuote: o } = Jp.safeXmlCharacters);
            const { ampersand: l } = Jp.safeXmlCharacters,
              { quote: c } = Jp.safeXmlCharacters;
            t = (t = (t = (t = (t = t.split(e).join(Jp.xmlCharacters.tagOpener))
              .split(i)
              .join(Jp.xmlCharacters.tagCloser))
              .split(n)
              .join(Jp.xmlCharacters.doubleQuote))
              .split(l)
              .join(Jp.xmlCharacters.ampersand))
              .split(c)
              .join(Jp.xmlCharacters.quote);
            let d = "",
              h = null;
            for (let e = 0; e < t.length; e += 1) {
              const i = t.charAt(e);
              null == h
                ? "$" === i
                  ? (h = "")
                  : (d += i)
                : ";" === i
                ? ((d += "&" + h), (h = null))
                : i.match(/([a-zA-Z0-9#._-] | '-')/)
                ? (h += i)
                : ((d += "$" + h), (h = null), (e -= 1));
            }
            return d;
          }
          static safeXmlEncode(t) {
            const { tagOpener: e } = Jp.xmlCharacters,
              { tagCloser: i } = Jp.xmlCharacters,
              { doubleQuote: n } = Jp.xmlCharacters,
              { ampersand: o } = Jp.xmlCharacters,
              { quote: r } = Jp.xmlCharacters;
            return (t = (t = (t = (t = (t = t
              .split(e)
              .join(Jp.safeXmlCharacters.tagOpener))
              .split(i)
              .join(Jp.safeXmlCharacters.tagCloser))
              .split(n)
              .join(Jp.safeXmlCharacters.doubleQuote))
              .split(o)
              .join(Jp.safeXmlCharacters.ampersand))
              .split(r)
              .join(Jp.safeXmlCharacters.quote));
          }
          static mathMLEntities(t) {
            let e = "";
            for (let i = 0; i < t.length; i += 1) {
              const n = t.charAt(i);
              if (t.codePointAt(i) > 128)
                (e += `&#${t.codePointAt(i)};`),
                  t.codePointAt(i) > 65535 && (i += 1);
              else if ("&" === n) {
                const o = t.indexOf(";", i + 1);
                if (o >= 0) {
                  const n = document.createElement("span");
                  (n.innerHTML = t.substring(i, o + 1)),
                    (e += `&#${nb.fixedCharCodeAt(
                      n.textContent || n.innerText,
                      0
                    )};`),
                    (i = o);
                } else e += n;
              } else e += n;
            }
            return e;
          }
          static addCustomEditorClassAttribute(t, e) {
            let i = "";
            const n = t.indexOf("<math");
            if (0 === n) {
              const o = t.indexOf(">");
              if (-1 === t.indexOf("class"))
                return (
                  (i = `${t.substr(n, o)} class="wrs_${e}">`),
                  (i += t.substr(o + 1, t.length)),
                  i
                );
            }
            return t;
          }
          static removeCustomEditorClassAttribute(t, e) {
            return -1 === t.indexOf("class") || -1 === t.indexOf("wrs_" + e)
              ? t
              : -1 !== t.indexOf(`class="wrs_${e}"`)
              ? t.replace(`class="wrs_${e}"`, "")
              : t.replace("wrs_" + e, "");
          }
          static addAnnotation(t, e, i) {
            let n = "";
            if (-1 !== t.indexOf("<annotation")) {
              const o = t.indexOf("</semantics>");
              n = `${t.substring(
                0,
                o
              )}<annotation encoding="${i}">${e}</annotation>${t.substring(o)}`;
            } else if (Gp.isEmpty(t)) {
              const o = t.indexOf("/>"),
                r = t.indexOf(">"),
                s = r === o ? o : r;
              n = `${t.substring(
                0,
                s
              )}><semantics><annotation encoding="${i}">${e}</annotation></semantics></math>`;
            } else {
              const o = t.indexOf(">") + 1,
                r = t.lastIndexOf("</math>"),
                s = t.substring(o, r);
              n = `${t.substring(
                0,
                o
              )}<semantics>${s}<annotation encoding="${i}">${e}</annotation></semantics></math>`;
            }
            return n;
          }
          static removeAnnotation(t, e) {
            let i = t;
            const n = `<annotation encoding="${e}">`,
              o = t.indexOf(n);
            if (-1 !== o) {
              let e = !1,
                n = t.indexOf("<annotation");
              for (; -1 !== n; )
                n !== o && (e = !0), (n = t.indexOf("<annotation", n + 1));
              if (e) {
                const e =
                  t.indexOf("</annotation>", o) + "</annotation>".length;
                i = t.substring(0, o) + t.substring(e);
              } else i = Gp.removeSemantics(t);
            }
            return i;
          }
          static removeSemantics(t) {
            let e = t;
            const i = t.indexOf("<semantics>");
            if (-1 !== i) {
              const n = t.indexOf("<annotation", i + "<semantics>".length);
              -1 !== n &&
                (e =
                  t.substring(0, i) +
                  t.substring(i + "<semantics>".length, n) +
                  "</math>");
            }
            return e;
          }
          static removeSemanticsOcurrences(t, e = Jp.xmlCharacters) {
            const i = e.tagOpener + "math",
              n = `${e.tagOpener}/math${e.tagCloser}`,
              o = "/" + e.tagCloser,
              { tagCloser: r } = e,
              s = `${e.tagOpener}semantics${e.tagCloser}`,
              a = e.tagOpener + "annotation encoding=";
            let l = "",
              c = t.indexOf(i),
              d = 0;
            for (; -1 !== c; ) {
              l += t.substring(d, c);
              const e = t.indexOf(n, c),
                h = t.indexOf(o, c),
                u = t.indexOf(r, c);
              -1 !== e ? (d = e) : h === u - 1 && (d = h);
              const m = t.indexOf(s, c);
              if (-1 !== m) {
                const e = t.substring(c, m),
                  o = t.indexOf(a, c);
                if (-1 !== o) {
                  const r = m + s.length;
                  (l += e + t.substring(r, o) + n),
                    (c = t.indexOf(i, c + i.length)),
                    (d += n.length);
                } else (d = c), (c = t.indexOf(i, c + i.length));
              } else (d = c), (c = t.indexOf(i, c + i.length));
            }
            return (l += t.substring(d, t.length)), l;
          }
          static containClass(t, e) {
            const i = t.indexOf("class");
            if (-1 === i) return !1;
            const n = t.indexOf(">", i);
            return -1 !== t.substring(i, n).indexOf(e);
          }
          static isEmpty(t) {
            const e = t.indexOf(">"),
              i = t.indexOf("/>");
            let n = !1;
            if ((-1 !== i && i === e - 1 && (n = !0), !n)) {
              const i = new RegExp("</(.+:)?math>").exec(t);
              i && (n = e + 1 === i.index);
            }
            return n;
          }
          static encodeProperties(t) {
            return t.replace(/\w+=".*?"/g, (t) => {
              const e = t.indexOf('"'),
                i = t.substring(e + 1, t.length - 1),
                n = nb.htmlEntities(i);
              return `${t.substring(0, e + 1)}${n}"`;
            });
          }
        }
        class Qp {
          static addConfiguration(t) {
            Object.assign(Qp.properties, t);
          }
          static get properties() {
            return Qp._properties;
          }
          static set properties(t) {
            Qp._properties = t;
          }
          static get(t) {
            return Object.prototype.hasOwnProperty.call(Qp.properties, t)
              ? Qp.properties[t]
              : !!Object.prototype.hasOwnProperty.call(
                  Qp.properties,
                  "_wrs_conf_"
                ) && Qp.properties["_wrs_conf_" + t];
          }
          static set(t, e) {
            Qp.properties[t] = e;
          }
          static update(t, e) {
            if (Qp.get(t)) {
              const i = Object.assign(Qp.get(t), e);
              Qp.set(t, i);
            } else Qp.set(t, e);
          }
        }
        Qp._properties = {};
        class Xp {
          constructor() {
            this.cache = [];
          }
          populate(t, e) {
            this.cache[t] = e;
          }
          get(t) {
            return (
              !!Object.prototype.hasOwnProperty.call(this.cache, t) &&
              this.cache[t]
            );
          }
        }
        class Kp {
          constructor() {
            this.listeners = [];
          }
          add(t) {
            this.listeners.push(t);
          }
          fire(t, e) {
            for (let i = 0; i < this.listeners.length && !e.cancelled; i += 1)
              this.listeners[i].eventName === t &&
                this.listeners[i].callback(e);
            return e.defaultPrevented;
          }
          static newListener(t, e) {
            const i = {};
            return (i.eventName = t), (i.callback = e), i;
          }
        }
        class Zp {
          static get listeners() {
            return Zp._listeners;
          }
          static addListener(t) {
            Zp.listeners.add(t);
          }
          static fireEvent(t, e) {
            Zp.listeners.fire(t, e);
          }
          static get parameters() {
            return Zp._parameters;
          }
          static set parameters(t) {
            Zp._parameters = t;
          }
          static get servicePaths() {
            return Zp._servicePaths;
          }
          static set servicePaths(t) {
            Zp._servicePaths = t;
          }
          static setServicePath(t, e) {
            Zp.servicePaths[t] = e;
          }
          static getServicePath(t) {
            return Zp.servicePaths[t];
          }
          static get integrationPath() {
            return Zp._integrationPath;
          }
          static set integrationPath(t) {
            Zp._integrationPath = t;
          }
          static getServerURL() {
            const t = window.location.href.split("/");
            return `${t[0]}//${t[2]}`;
          }
          static init(t) {
            Zp.parameters = t;
            let e = Zp.createServiceURI("configurationjs"),
              i = Zp.createServiceURI("createimage"),
              n = Zp.createServiceURI("showimage"),
              o = Zp.createServiceURI("getmathml"),
              r = Zp.createServiceURI("service");
            if (0 === Zp.parameters.URI.indexOf("/")) {
              const t = Zp.getServerURL();
              (e = t + e), (n = t + n), (i = t + i), (o = t + o), (r = t + r);
            }
            Zp.setServicePath("configurationjs", e),
              Zp.setServicePath("showimage", n),
              Zp.setServicePath("createimage", i),
              Zp.setServicePath("service", r),
              Zp.setServicePath("getmathml", o),
              Zp.setServicePath("configurationjs", e),
              Zp.listeners.fire("onInit", {});
          }
          static getUrl(t, e) {
            const i = window.location
                .toString()
                .substr(0, window.location.toString().lastIndexOf("/") + 1),
              n = nb.createHttpRequest();
            return n
              ? (void 0 === e || void 0 === e
                  ? n.open("GET", t, !1)
                  : "/" === t.substr(0, 1) ||
                    "http://" === t.substr(0, 7) ||
                    "https://" === t.substr(0, 8)
                  ? n.open("POST", t, !1)
                  : n.open("POST", i + t, !1),
                void 0 !== e && e
                  ? (n.setRequestHeader(
                      "Content-type",
                      "application/x-www-form-urlencoded; charset=UTF-8"
                    ),
                    n.send(nb.httpBuildQuery(e)))
                  : n.send(null),
                n.responseText)
              : "";
          }
          static getService(t, e, i) {
            let n;
            if (!0 === i) {
              const i = `${Zp.getServicePath(t)}?${e}`;
              n = Zp.getUrl(i);
            } else {
              const i = Zp.getServicePath(t);
              n = Zp.getUrl(i, e);
            }
            return n;
          }
          static getServerLanguageFromService(t) {
            return -1 !== t.indexOf(".php")
              ? "php"
              : -1 !== t.indexOf(".aspx")
              ? "aspx"
              : -1 !== t.indexOf("wirispluginengine")
              ? "ruby"
              : "java";
          }
          static createServiceURI(t) {
            const e = Zp.serverExtension();
            return nb.concatenateUrl(Zp.parameters.URI, t) + e;
          }
          static serverExtension() {
            return -1 !== Zp.parameters.server.indexOf("php")
              ? ".php"
              : -1 !== Zp.parameters.server.indexOf("aspx")
              ? ".aspx"
              : "";
          }
        }
        (Zp._servicePaths = {}),
          (Zp._integrationPath = ""),
          (Zp._listeners = new Kp()),
          (Zp._parameters = {});
        class tb {
          static get cache() {
            return tb._cache;
          }
          static set cache(t) {
            tb._cache = t;
          }
          static getLatexFromMathML(t) {
            const e = Gp.removeSemantics(t),
              { cache: i } = tb,
              n = { service: "mathml2latex", mml: e },
              o = JSON.parse(Zp.getService("service", n));
            let r = "";
            if ("ok" === o.status) {
              r = o.result.text;
              const e = nb.htmlEntities(r),
                n = Gp.addAnnotation(t, e, "LaTeX");
              i.populate(r, n);
            }
            return r;
          }
          static getMathMLFromLatex(t, e) {
            const i = tb.cache;
            if (tb.cache.get(t)) return tb.cache.get(t);
            const n = { service: "latex2mathml", latex: t };
            e && (n.saveLatex = "");
            const o = JSON.parse(Zp.getService("service", n));
            let r;
            if ("ok" === o.status) {
              let e = o.result.text;
              (e = e.split("\r").join("").split("\n").join(" ")),
                -1 === e.indexOf("semantics") && -1 === e.indexOf("annotation")
                  ? ((e = Gp.addAnnotation(e, t, "LaTeX")), (r = e))
                  : (r = e),
                i.get(t) || i.populate(t, e);
            } else r = `$$${t}$$`;
            return r;
          }
          static parseMathmlToLatex(t, e) {
            let i = "";
            const n = e.tagOpener + "math",
              o = `${e.tagOpener}/math${e.tagCloser}`,
              r = `${e.tagOpener}annotation encoding=${e.doubleQuote}LaTeX${e.doubleQuote}${e.tagCloser}`,
              s = `${e.tagOpener}/annotation${e.tagCloser}`;
            let a,
              l,
              c,
              d = t.indexOf(n),
              h = 0;
            for (; -1 !== d; ) {
              if (
                ((i += t.substring(h, d)),
                (h = t.indexOf(o, d)),
                -1 === h ? (h = t.length - 1) : (h += o.length),
                (a = t.substring(d, h)),
                (l = a.indexOf(r)),
                -1 !== l)
              ) {
                (l += r.length), (c = a.indexOf(s));
                let t = a.substring(l, c);
                e === Jp.safeXmlCharacters && (t = Gp.safeXmlDecode(t)),
                  (i += `$$${t}$$`),
                  tb.cache.populate(t, a);
              } else i += a;
              d = t.indexOf(n, h);
            }
            return (i += t.substring(h, t.length)), i;
          }
          static getLatexFromTextNode(t, e, i) {
            (void 0 !== i && null != i) || (i = { open: "$$", close: "$$" });
            let n,
              o = t;
            for (; o.previousSibling && 3 === o.previousSibling.nodeType; )
              o = o.previousSibling;
            function r(t, e, n) {
              let o = t.nodeValue.indexOf(n, e);
              for (; -1 === o; ) {
                if (!(t = t.nextSibling)) return null;
                o = t.nodeValue ? t.nodeValue.indexOf(i.close) : -1;
              }
              return { node: t, position: o };
            }
            function s(t, e, i, n) {
              if (t === i) return e <= n;
              for (; t && t !== i; ) t = t.nextSibling;
              return t === i;
            }
            let a = { node: o, position: 0 };
            const l = i.open.length;
            do {
              if (
                ((n = r(a.node, a.position, i.open)),
                null == n || s(t, e, n.node, n.position))
              )
                return null;
              if (((a = r(n.node, n.position + l, i.close)), null == a))
                return null;
              a.position += l;
            } while (s(a.node, a.position, t, e));
            let c;
            if (n.node === a.node)
              c = n.node.nodeValue.substring(n.position + l, a.position - l);
            else {
              const t = n.position + l;
              c = n.node.nodeValue.substring(t, n.node.nodeValue.length);
              let e = n.node;
              do {
                (e = e.nextSibling),
                  e === a.node
                    ? (c += a.node.nodeValue.substring(0, a.position - l))
                    : (c += e.nodeValue ? e.nodeValue : "");
              } while (e !== a.node);
            }
            return {
              latex: c,
              startNode: n.node,
              startPosition: n.position,
              endNode: a.node,
              endPosition: a.position,
            };
          }
        }
        tb._cache = new Xp();
        var eb = i(13);
        class ib {
          constructor() {
            throw new Error(
              "Static class StringManager can not be instantiated."
            );
          }
          static get(t) {
            let { language: e } = this;
            return (
              e in this.strings ||
                (console.warn(`Unknown language ${e} set in StringManager.`),
                (e = "en")),
              t in this.strings[e]
                ? this.strings[e][t]
                : (console.warn(`Unknown key ${t} in StringManager.`), t)
            );
          }
        }
        (ib.strings = eb), (ib.language = "en");
        class nb {
          static fireEvent(t, e) {
            if (document.createEvent) {
              const i = document.createEvent("HTMLEvents");
              return i.initEvent(e, !0, !0), !t.dispatchEvent(i);
            }
            const i = document.createEventObject();
            return t.fireEvent("on" + e, i);
          }
          static addEvent(t, e, i) {
            t.addEventListener
              ? t.addEventListener(e, i, !0)
              : t.attachEvent && t.attachEvent("on" + e, i);
          }
          static removeEvent(t, e, i) {
            t.removeEventListener
              ? t.removeEventListener(e, i, !0)
              : t.detachEvent && t.detachEvent("on" + e, i);
          }
          static addElementEvents(t, e, i, n) {
            e &&
              nb.addEvent(t, "dblclick", (t) => {
                const i = t || window.event,
                  n = i.srcElement ? i.srcElement : i.target;
                e(n, i);
              }),
              i &&
                nb.addEvent(t, "mousedown", (t) => {
                  const e = t || window.event,
                    n = e.srcElement ? e.srcElement : e.target;
                  i(n, e);
                }),
              n &&
                nb.addEvent(t, "mouseup", (t) => {
                  const e = t || window.event,
                    i = e.srcElement ? e.srcElement : e.target;
                  n(i, e);
                });
          }
          static addClass(t, e) {
            nb.containsClass(t, e) || (t.className += " " + e);
          }
          static containsClass(t, e) {
            if (null == t || !("className" in t)) return !1;
            const i = t.className.split(" ");
            for (let t = i.length - 1; t >= 0; t -= 1)
              if (i[t] === e) return !0;
            return !1;
          }
          static removeClass(t, e) {
            let i = "";
            const n = t.className.split(" ");
            for (let t = 0; t < n.length; t += 1)
              n[t] !== e && (i += n[t] + " ");
            t.className = i.trim();
          }
          static convertOldXmlinitialtextAttribute(t) {
            const e = "value=",
              i = t.indexOf("xmlinitialtext"),
              n = t.indexOf(e, i),
              o = t.charAt(n + e.length),
              r = n + e.length + 1,
              s = t.indexOf(o, r),
              a = t.substring(r, s);
            let l = a.split("«").join("§lt;");
            return (
              (l = l.split("»").join("§gt;")),
              (l = l.split("&").join("§")),
              (l = l.split("¨").join("§quot;")),
              (t = t.split(a).join(l))
            );
          }
          static createElement(t, e, i) {
            let n;
            void 0 === e && (e = {}), void 0 === i && (i = document);
            try {
              let o = "<" + t;
              Object.keys(e).forEach((t) => {
                o += ` ${t}="${nb.htmlEntities(e[t])}"`;
              }),
                (o += ">"),
                (n = i.createElement(o));
            } catch (o) {
              (n = i.createElement(t)),
                Object.keys(e).forEach((t) => {
                  n.setAttribute(t, e[t]);
                });
            }
            return n;
          }
          static createObject(t, e) {
            void 0 === e && (e = document),
              (t = (t = (t = (t = t
                .split("<applet ")
                .join('<span wirisObject="WirisApplet" ')
                .split("<APPLET ")
                .join('<span wirisObject="WirisApplet" '))
                .split("</applet>")
                .join("</span>")
                .split("</APPLET>")
                .join("</span>"))
                .split("<param ")
                .join('<br wirisObject="WirisParam" ')
                .split("<PARAM ")
                .join('<br wirisObject="WirisParam" '))
                .split("</param>")
                .join("</br>")
                .split("</PARAM>")
                .join("</br>"));
            const i = nb.createElement("div", {}, e);
            return (
              (i.innerHTML = t),
              (function t(i) {
                if (
                  i.getAttribute &&
                  "WirisParam" === i.getAttribute("wirisObject")
                ) {
                  const t = {};
                  for (let e = 0; e < i.attributes.length; e += 1)
                    null !== i.attributes[e].nodeValue &&
                      (t[i.attributes[e].nodeName] = i.attributes[e].nodeValue);
                  const n = nb.createElement("param", t, e);
                  n.NAME && ((n.name = n.NAME), (n.value = n.VALUE)),
                    n.removeAttribute("wirisObject"),
                    i.parentNode.replaceChild(n, i);
                } else if (
                  i.getAttribute &&
                  "WirisApplet" === i.getAttribute("wirisObject")
                ) {
                  const n = {};
                  for (let t = 0; t < i.attributes.length; t += 1)
                    null !== i.attributes[t].nodeValue &&
                      (n[i.attributes[t].nodeName] = i.attributes[t].nodeValue);
                  const o = nb.createElement("applet", n, e);
                  o.removeAttribute("wirisObject");
                  for (let e = 0; e < i.childNodes.length; e += 1)
                    t(i.childNodes[e]),
                      "param" === i.childNodes[e].nodeName.toLowerCase() &&
                        (o.appendChild(i.childNodes[e]), (e -= 1));
                  i.parentNode.replaceChild(o, i);
                } else
                  for (let e = 0; e < i.childNodes.length; e += 1)
                    t(i.childNodes[e]);
              })(i),
              i.firstChild
            );
          }
          static createObjectCode(t) {
            if (null == t) return null;
            if (1 === t.nodeType) {
              let e = "<" + t.tagName;
              for (let i = 0; i < t.attributes.length; i += 1)
                t.attributes[i].specified &&
                  (e += ` ${t.attributes[i].name}="${nb.htmlEntities(
                    t.attributes[i].value
                  )}"`);
              if (t.childNodes.length > 0) {
                e += ">";
                for (let i = 0; i < t.childNodes.length; i += 1)
                  e += nb.createObject(t.childNodes[i]);
                e += `</${t.tagName}>`;
              } else
                "DIV" === t.nodeName || "SCRIPT" === t.nodeName
                  ? (e += `></${t.tagName}>`)
                  : (e += "/>");
              return e;
            }
            return 3 === t.nodeType ? nb.htmlEntities(t.nodeValue) : "";
          }
          static concatenateUrl(t, e) {
            let i = "";
            return (
              t.indexOf("/") !== t.length && 0 !== e.indexOf("/") && (i = "/"),
              (t + i + e).replace(/([^:]\/)\/+/g, "$1")
            );
          }
          static htmlEntities(t) {
            return t
              .split("&")
              .join("&amp;")
              .split("<")
              .join("&lt;")
              .split(">")
              .join("&gt;")
              .split('"')
              .join("&quot;");
          }
          static htmlEntitiesDecode(t) {
            const e = document.createElement("textarea");
            return (e.innerHTML = t), e.value;
          }
          static createHttpRequest() {
            if (
              "file://" ===
              window.location
                .toString()
                .substr(0, window.location.toString().lastIndexOf("/") + 1)
                .substr(0, 7)
            )
              throw ib.get("exception_cross_site");
            if ("undefined" != typeof XMLHttpRequest)
              return new XMLHttpRequest();
            try {
              return new ActiveXObject("Msxml2.XMLHTTP");
            } catch (t) {
              try {
                return new ActiveXObject("Microsoft.XMLHTTP");
              } catch (t) {
                return null;
              }
            }
          }
          static httpBuildQuery(t) {
            let e = "";
            return (
              Object.keys(t).forEach((i) => {
                null != t[i] &&
                  (e += `${nb.urlEncode(i)}=${nb.urlEncode(t[i])}&`);
              }),
              "&" === e.substring(e.length - 1) &&
                (e = e.substring(0, e.length - 1)),
              e
            );
          }
          static propertiesToString(t) {
            const e = [];
            Object.keys(t).forEach((i) => {
              Object.prototype.hasOwnProperty.call(t, i) && e.push(i);
            });
            const i = e.length;
            for (let t = 0; t < i; t += 1)
              for (let n = t + 1; n < i; n += 1) {
                const i = e[t],
                  o = e[n];
                nb.compareStrings(i, o) > 0 && ((e[t] = o), (e[n] = i));
              }
            let n = "";
            for (let o = 0; o < i; o += 1) {
              const i = e[o];
              (n += i), (n += "=");
              let r = t[i];
              (r = r.replace("\\", "\\\\")),
                (r = r.replace("\n", "\\n")),
                (r = r.replace("\r", "\\r")),
                (r = r.replace("\t", "\\t")),
                (n += r),
                (n += "\n");
            }
            return n;
          }
          static compareStrings(t, e) {
            let i;
            const n = t.length,
              o = e.length,
              r = n > o ? o : n;
            for (i = 0; i < r; i += 1) {
              const n = nb.fixedCharCodeAt(t, i) - nb.fixedCharCodeAt(e, i);
              if (0 !== n) return n;
            }
            return t.length - e.length;
          }
          static fixedCharCodeAt(t, e) {
            e = e || 0;
            const i = t.charCodeAt(e);
            let n, o;
            if (i >= 55296 && i <= 56319) {
              if (((n = i), (o = t.charCodeAt(e + 1)), Number.isNaN(o)))
                throw ib.get("exception_high_surrogate");
              return 1024 * (n - 55296) + (o - 56320) + 65536;
            }
            return !(i >= 56320 && i <= 57343) && i;
          }
          static urlToAssArray(t) {
            let e;
            if (((e = t.indexOf("?")), e > 0)) {
              const i = t.substring(e + 1).split("&"),
                n = {};
              for (e = 0; e < i.length; e += 1) {
                const t = i[e].split("=");
                t.length > 1 &&
                  (n[t[0]] = decodeURIComponent(t[1].replace(/\+/g, " ")));
              }
              return n;
            }
            return {};
          }
          static urlEncode(t) {
            let e = "";
            return (e = encodeURIComponent(t)), e;
          }
          static getWIRISImageOutput(t, e, i) {
            const n = nb.createObject(t);
            if (
              n &&
              (n.className === Qp.get("imageClassName") ||
                n.getAttribute(Qp.get("imageMathmlAttribute")))
            ) {
              if (!e) return t;
              const o = n.getAttribute(Qp.get("imageMathmlAttribute"));
              let r = Gp.safeXmlDecode(o);
              if (
                (Qp.get("saveHandTraces") ||
                  (r = Gp.removeAnnotation(r, "application/json")),
                null == r && (r = n.getAttribute("alt")),
                i)
              ) {
                return Gp.safeXmlEncode(r);
              }
              return r;
            }
            return t;
          }
          static getNodeLength(t) {
            const e = { IMG: 1, BR: 1 };
            if (3 === t.nodeType) return t.nodeValue.length;
            if (1 === t.nodeType) {
              let i = e[t.nodeName.toUpperCase()];
              void 0 === i && (i = 0);
              for (let e = 0; e < t.childNodes.length; e += 1)
                i += nb.getNodeLength(t.childNodes[e]);
              return i;
            }
            return 0;
          }
          static getSelectedItem(t, e, i) {
            let n;
            if (
              (e
                ? ((n = t.contentWindow), n.focus())
                : ((n = window), t.focus()),
              document.selection && !i)
            ) {
              const i = n.document.selection.createRange();
              if (i.parentElement) {
                if (i.htmlText.length > 0)
                  return 0 === i.text.length
                    ? nb.getSelectedItem(t, e, !0)
                    : null;
                n.document.execCommand("InsertImage", !1, "#");
                let o,
                  r,
                  s = i.parentElement();
                return (
                  "IMG" !== s.nodeName.toUpperCase() &&
                    (i.pasteHTML(
                      '<span id="wrs_openEditorWindow_temporalObject"></span>'
                    ),
                    (s = n.document.getElementById(
                      "wrs_openEditorWindow_temporalObject"
                    ))),
                  s.nextSibling && 3 === s.nextSibling.nodeType
                    ? ((o = s.nextSibling), (r = 0))
                    : s.previousSibling && 3 === s.previousSibling.nodeType
                    ? ((o = s.previousSibling), (r = o.nodeValue.length))
                    : ((o = n.document.createTextNode("")),
                      s.parentNode.insertBefore(o, s),
                      (r = 0)),
                  s.parentNode.removeChild(s),
                  { node: o, caretPosition: r }
                );
              }
              return i.length > 1 ? null : { node: i.item(0) };
            }
            if (n.getSelection) {
              let t;
              const e = n.getSelection();
              try {
                t = e.getRangeAt(0);
              } catch (e) {
                t = n.document.createRange();
              }
              const i = t.startContainer;
              if (3 === i.nodeType)
                return { node: i, caretPosition: t.startOffset };
              if (i !== t.endContainer) return null;
              if (1 === i.nodeType) {
                const e = t.startOffset;
                if (i.childNodes[e]) return { node: i.childNodes[e] };
              }
            }
            return null;
          }
          static getSelectedItemOnTextarea(t) {
            const e = document.createTextNode(t.value),
              i = tb.getLatexFromTextNode(e, t.selectionStart);
            return null === i
              ? null
              : {
                  node: e,
                  caretPosition: t.selectionStart,
                  startPosition: i.startPosition,
                  endPosition: i.endPosition,
                };
          }
          static getElementsByNameFromString(t, e, i) {
            const n = [];
            (t = t.toLowerCase()), (e = e.toLowerCase());
            let o = t.indexOf(`<${e} `);
            for (; -1 !== o; ) {
              let r;
              r = i ? ">" : `</${e}>`;
              let s = t.indexOf(r, o);
              -1 !== s
                ? ((s += r.length), n.push({ start: o, end: s }))
                : (s = o + 1),
                (o = t.indexOf(`<${e} `, s));
            }
            return n;
          }
          static decode64(t) {
            const e = "+".charCodeAt(0),
              i = "/".charCodeAt(0),
              n = "0".charCodeAt(0),
              o = "a".charCodeAt(0),
              r = "A".charCodeAt(0),
              s = "-".charCodeAt(0),
              a = "_".charCodeAt(0),
              l = t.charCodeAt(0);
            return l === e || l === s
              ? 62
              : l === i || l === a
              ? 63
              : l < n
              ? -1
              : l < n + 10
              ? l - n + 26 + 26
              : l < r + 26
              ? l - r
              : l < o + 26
              ? l - o + 26
              : null;
          }
          static b64ToByteArray(t, e) {
            let i;
            if (t.length % 4 > 0)
              throw new Error("Invalid string. Length must be a multiple of 4");
            const n = [];
            let o, r, s;
            for (
              e
                ? (o = e)
                : ((r =
                    "=" === t.charAt(t.length - 2)
                      ? 2
                      : "=" === t.charAt(t.length - 1)
                      ? 1
                      : 0),
                  (o = r > 0 ? t.length - 4 : t.length)),
                s = 0;
              s < o;
              s += 4
            )
              (i =
                (nb.decode64(t.charAt(s)) << 18) |
                (nb.decode64(t.charAt(s + 1)) << 12) |
                (nb.decode64(t.charAt(s + 2)) << 6) |
                nb.decode64(t.charAt(s + 3))),
                n.push((i >> 16) & 255),
                n.push((i >> 8) & 255),
                n.push(255 & i);
            return (
              r &&
                (2 === r
                  ? ((i =
                      (nb.decode64(t.charAt(s)) << 2) |
                      (nb.decode64(t.charAt(s + 1)) >> 4)),
                    n.push(255 & i))
                  : 1 === r &&
                    ((i =
                      (nb.decode64(t.charAt(s)) << 10) |
                      (nb.decode64(t.charAt(s + 1)) << 4) |
                      (nb.decode64(t.charAt(s + 2)) >> 2)),
                    n.push((i >> 8) & 255),
                    n.push(255 & i))),
              n
            );
          }
          static readInt32(t) {
            if (t.length < 4) return !1;
            const e = t.splice(0, 4);
            return (e[0] << 24) | (e[1] << 16) | (e[2] << 8) | (e[3] << 0);
          }
          static readByte(t) {
            return t.shift() << 0;
          }
          static readBytes(t, e, i) {
            return t.splice(e, i);
          }
          static updateTextArea(t, e) {
            if (t && e)
              if ((t.focus(), null != t.selectionStart)) {
                const { selectionEnd: i } = t,
                  n = t.value.substring(0, t.selectionStart),
                  o = t.value.substring(i, t.value.length);
                (t.value = n + e + o), (t.selectionEnd = i + e.length);
              } else {
                document.selection.createRange().text = e;
              }
          }
          static updateExistingTextOnTextarea(t, e, i, n) {
            t.focus();
            const o = t.value.substring(0, i);
            (t.value = o + e + t.value.substring(n, t.value.length)),
              (t.selectionEnd = i + e.length);
          }
          static addArgument(t, e, i) {
            let n;
            return (n = t.indexOf("?") > 0 ? "&" : "?"), `${t + n + e}=${i}`;
          }
        }
        class ob {
          static removeImgDataAttributes(t) {
            const e = [],
              { attributes: i } = t;
            Object.keys(i).forEach((t) => {
              const n = i[t];
              0 === n.name.indexOf("data-") && e.push(n.name);
            }),
              e.forEach((e) => {
                t.removeAttribute(e);
              });
          }
          static clone(t, e) {
            const i = Qp.get("imageCustomEditorName");
            t.hasAttribute(i) || e.removeAttribute(i),
              [
                Qp.get("imageMathmlAttribute"),
                i,
                "alt",
                "height",
                "width",
                "style",
                "src",
                "role",
              ].forEach((i) => {
                const n = t.getAttribute(i);
                n && e.setAttribute(i, n);
              });
          }
          static setImgSize(t, e, i) {
            let n, o, r, s;
            if (i)
              if ("svg" === Qp.get("imageFormat"))
                if ("base64" !== Qp.get("saveMode"))
                  n = ob.getMetricsFromSvgString(e);
                else {
                  (o = t.src.substr(
                    t.src.indexOf("base64,") + 7,
                    t.src.length
                  )),
                    (s = ""),
                    (r = nb.b64ToByteArray(o, o.length));
                  for (let t = 0; t < r.length; t += 1)
                    s += String.fromCharCode(r[t]);
                  n = ob.getMetricsFromSvgString(s);
                }
              else
                (o = t.src.substr(t.src.indexOf("base64,") + 7, t.src.length)),
                  (r = nb.b64ToByteArray(o, 88)),
                  (n = ob.getMetricsFromBytes(r));
            else n = nb.urlToAssArray(e);
            let a = n.cw;
            if (!a) return;
            let l = n.ch,
              c = n.cb;
            const { dpi: d } = n;
            d && ((a = (96 * a) / d), (l = (96 * l) / d), (c = (96 * c) / d)),
              (t.width = a),
              (t.height = l),
              (t.style.verticalAlign = `-${l - c}px`);
          }
          static fixAfterResize(t) {
            if (
              (t.removeAttribute("style"),
              t.removeAttribute("width"),
              t.removeAttribute("height"),
              (t.style.maxWidth = "none"),
              -1 !== t.src.indexOf("data:image"))
            )
              if ("svg" === Qp.get("imageFormat")) {
                const e = decodeURIComponent(t.src.substring(32, t.src.length));
                ob.setImgSize(t, e, !0);
              } else {
                const e = t.src.substring(22, t.src.length);
                ob.setImgSize(t, e, !0);
              }
            else ob.setImgSize(t, t.src);
          }
          static getMetricsFromSvgString(t) {
            let e = t.indexOf('height="'),
              i = t.indexOf('"', e + 8, t.length);
            const n = t.substring(e + 8, i);
            (e = t.indexOf('width="')), (i = t.indexOf('"', e + 7, t.length));
            const o = t.substring(e + 7, i);
            (e = t.indexOf('wrs:baseline="')),
              (i = t.indexOf('"', e + 14, t.length));
            const r = t.substring(e + 14, i);
            if (void 0 !== o) {
              const t = [];
              return (t.cw = o), (t.ch = n), void 0 !== r && (t.cb = r), t;
            }
            return [];
          }
          static getMetricsFromBytes(t) {
            let e, i, n, o, r;
            for (nb.readBytes(t, 0, 8); t.length >= 4; )
              (n = nb.readInt32(t)),
                1229472850 === n
                  ? ((e = nb.readInt32(t)),
                    (i = nb.readInt32(t)),
                    nb.readInt32(t),
                    nb.readByte(t))
                  : 1650545477 === n
                  ? (o = nb.readInt32(t))
                  : 1883789683 === n &&
                    ((r = nb.readInt32(t)),
                    (r = Math.round(r / 39.37)),
                    nb.readInt32(t),
                    nb.readByte(t)),
                nb.readInt32(t);
            if (void 0 !== e) {
              const t = [];
              return (t.cw = e), (t.ch = i), (t.dpi = r), o && (t.cb = o), t;
            }
            return [];
          }
        }
        class rb {
          static get cache() {
            return rb._cache;
          }
          static set cache(t) {
            rb._cache = t;
          }
          static mathMLToAccessible(t, e, i) {
            void 0 === e && (e = "en"),
              Gp.containClass(t, "wrs_chemistry") && (i.mode = "chemistry");
            let n = "";
            if (rb.cache.get(t)) n = rb.cache.get(t);
            else {
              (i.service = "mathml2accessible"), (i.lang = e);
              const o = JSON.parse(Zp.getService("service", i));
              "error" !== o.status
                ? ((n = o.result.text), rb.cache.populate(t, n))
                : (n = ib.get("error_convert_accessibility"));
            }
            return n;
          }
        }
        rb._cache = new Xp();
        i(95);
        class sb {
          static mathmlToImgObject(t, e, i, n) {
            const o = t.createElement("img");
            (o.align = "middle"), (o.style.maxWidth = "none");
            const r = i || {};
            if (
              ((r.mml = e),
              (r.lang = n),
              (r.metrics = "true"),
              (r.centerbaseline = "false"),
              "base64" === Qp.get("saveMode") &&
                "default" === Qp.get("base64savemode") &&
                (r.base64 = !0),
              (o.className = Qp.get("imageClassName")),
              -1 !== e.indexOf('class="'))
            ) {
              let t = e.substring(
                e.indexOf('class="') + 'class="'.length,
                e.length
              );
              (t = t.substring(0, t.indexOf('"'))),
                (t = t.substring(4, t.length)),
                o.setAttribute(Qp.get("imageCustomEditorName"), t);
            }
            if (
              !Qp.get("wirisPluginPerformance") ||
              ("xml" !== Qp.get("saveMode") && "safeXml" !== Qp.get("saveMode"))
            ) {
              const t = sb.createImageSrc(e, r);
              o.setAttribute(
                Qp.get("imageMathmlAttribute"),
                Gp.safeXmlEncode(e)
              ),
                (o.src = t),
                ob.setImgSize(
                  o,
                  t,
                  "base64" === Qp.get("saveMode") &&
                    "default" === Qp.get("base64savemode")
                ),
                Qp.get("enableAccessibility") &&
                  (o.alt = rb.mathMLToAccessible(e, n, r));
            } else {
              let t = JSON.parse(sb.createShowImageSrc(r, n));
              if ("warning" === t.status)
                try {
                  t = JSON.parse(Zp.getService("showimage", r));
                } catch (t) {
                  return null;
                }
              ({ result: t } = t),
                "png" === t.format
                  ? (o.src = "data:image/png;base64," + t.content)
                  : (o.src =
                      "data:image/svg+xml;charset=utf8," +
                      nb.urlEncode(t.content)),
                o.setAttribute(
                  Qp.get("imageMathmlAttribute"),
                  Gp.safeXmlEncode(e)
                ),
                ob.setImgSize(o, t.content, !0),
                Qp.get("enableAccessibility") &&
                  (void 0 === t.alt
                    ? (o.alt = rb.mathMLToAccessible(e, n, r))
                    : (o.alt = t.alt));
            }
            return (
              void 0 !== sb.observer && sb.observer.observe(o),
              o.setAttribute("role", "math"),
              o
            );
          }
          static createImageSrc(t, e) {
            "base64" === Qp.get("saveMode") &&
              "default" === Qp.get("base64savemode") &&
              (e.base64 = !0);
            let i = Zp.getService("createimage", e);
            if (-1 !== i.indexOf("@BASE@")) {
              const t = Zp.getServicePath("createimage").split("/");
              t.pop(), (i = i.split("@BASE@").join(t.join("/")));
            }
            return i;
          }
          static initParse(t, e) {
            return (t = sb.initParseSaveMode(t, e)), sb.initParseEditMode(t);
          }
          static initParseSaveMode(t, e) {
            return (
              Qp.get("saveMode") &&
                ((t = tb.parseMathmlToLatex(t, Jp.safeXmlCharacters)),
                (t = tb.parseMathmlToLatex(t, Jp.xmlCharacters)),
                (t = sb.parseMathmlToImg(t, Jp.safeXmlCharacters, e)),
                (t = sb.parseMathmlToImg(t, Jp.xmlCharacters, e)),
                "base64" === Qp.get("saveMode") &&
                  "image" === Qp.get("base64savemode") &&
                  (t = sb.codeImgTransform(t, "base642showimage"))),
              t
            );
          }
          static initParseEditMode(t) {
            if (-1 !== Qp.get("parseModes").indexOf("latex")) {
              const e = nb.getElementsByNameFromString(t, "img", !0),
                i = 'encoding="LaTeX">';
              let n = 0;
              for (let o = 0; o < e.length; o += 1) {
                const r = t.substring(e[o].start + n, e[o].end + n);
                if (-1 !== r.indexOf(` class="${Qp.get("imageClassName")}"`)) {
                  let s = ` ${Qp.get("imageMathmlAttribute")}="`,
                    a = r.indexOf(s);
                  if (
                    (-1 === a && ((s = ' alt="'), (a = r.indexOf(s))), -1 !== a)
                  ) {
                    a += s.length;
                    const l = r.indexOf('"', a),
                      c = Gp.safeXmlDecode(r.substring(a, l));
                    let d = c.indexOf(i);
                    if (-1 !== d) {
                      d += i.length;
                      const r = c.indexOf("</annotation>", d),
                        s = c.substring(d, r),
                        a = `$$${nb.htmlEntitiesDecode(s)}$$`,
                        l = t.substring(0, e[o].start + n),
                        h = t.substring(e[o].end + n);
                      (t = l + a + h),
                        (n += a.length - (e[o].end - e[o].start));
                    }
                  }
                }
              }
            }
            return t;
          }
          static endParse(t) {
            const e = sb.endParseEditMode(t);
            return sb.endParseSaveMode(e);
          }
          static endParseEditMode(t) {
            if (-1 !== Qp.get("parseModes").indexOf("latex")) {
              let e = "",
                i = 0,
                n = t.indexOf("$$");
              for (; -1 !== n; ) {
                if (
                  ((e += t.substring(i, n)),
                  (i = t.indexOf("$$", n + 2)),
                  -1 !== i)
                ) {
                  const o = t.substring(n + 2, i),
                    r = nb.htmlEntitiesDecode(o);
                  let s = tb.getMathMLFromLatex(r, !0);
                  Qp.get("saveHandTraces") ||
                    (s = Gp.removeAnnotation(s, "application/json")),
                    (e += s),
                    (i += 2);
                } else (e += "$$"), (i = n + 2);
                n = t.indexOf("$$", i);
              }
              (e += t.substring(i, t.length)), (t = e);
            }
            return t;
          }
          static endParseSaveMode(t) {
            return (
              Qp.get("saveMode") &&
                ("safeXml" === Qp.get("saveMode") ||
                "xml" === Qp.get("saveMode")
                  ? (t = sb.codeImgTransform(t, "img2mathml"))
                  : "base64" === Qp.get("saveMode") &&
                    "image" === Qp.get("base64savemode") &&
                    (t = sb.codeImgTransform(t, "img264"))),
              t
            );
          }
          static createShowImageSrc(t, e) {
            const i = [],
              n = [
                "mml",
                "color",
                "centerbaseline",
                "zoom",
                "dpi",
                "fontSize",
                "fontFamily",
                "defaultStretchy",
                "backgroundColor",
                "format",
              ];
            n.forEach((e) => {
              const o = n[e];
              void 0 !== t[o] && (i[o] = t[o]);
            });
            const o = {};
            return (
              Object.keys(t).forEach((e) => {
                "mml" !== e && (o[e] = t[e]);
              }),
              (o.formula = com.wiris.js.JsPluginTools.md5encode(
                nb.propertiesToString(i)
              )),
              (o.lang = void 0 === e ? "en" : e),
              (o.version = Qp.get("version")),
              Zp.getService("showimage", nb.httpBuildQuery(o), !0)
            );
          }
          static codeImgTransform(t, e) {
            let i = "",
              n = 0;
            const o = /<img/gi,
              r = o.source.length;
            for (; o.test(t); ) {
              const s = o.lastIndex - r;
              i += t.substring(n, s);
              let a = s + 1;
              for (; a < t.length && n <= s; ) {
                const e = t.charAt(a);
                if ('"' === e || "'" === e) {
                  const i = t.indexOf(e, a + 1);
                  a = -1 === i ? t.length : i;
                } else ">" === e && (n = a + 1);
                a += 1;
              }
              if (n < s) return (i += t.substring(s, t.length)), i;
              let l = t.substring(s, n);
              const c = nb.createObject(l);
              let d,
                h,
                u = c.getAttribute(Qp.get("imageMathmlAttribute"));
              if ("base642showimage" === e)
                null == u && (u = c.getAttribute("alt")),
                  (u = Gp.safeXmlDecode(u)),
                  (l = sb.mathmlToImgObject(document, u, null, null)),
                  (i += nb.createObjectCode(l));
              else if ("img2mathml" === e)
                Qp.get("saveMode") &&
                  ("safeXml" === Qp.get("saveMode")
                    ? ((d = !0), (h = !0))
                    : "xml" === Qp.get("saveMode") && ((d = !0), (h = !1))),
                  (i += nb.getWIRISImageOutput(l, d, h));
              else if ("img264" === e) {
                null === u && (u = c.getAttribute("alt")),
                  (u = Gp.safeXmlDecode(u));
                const t = { base64: "true" };
                (l = sb.mathmlToImgObject(document, u, t, null)),
                  ob.setImgSize(l, l.src, !0),
                  (i += nb.createObjectCode(l));
              }
            }
            return (i += t.substring(n, t.length)), i;
          }
          static parseMathmlToImg(t, e, i) {
            let n = "";
            const o = e.tagOpener + "math",
              r = `${e.tagOpener}/math${e.tagCloser}`;
            let s = t.indexOf(o),
              a = 0;
            for (; -1 !== s; ) {
              n += t.substring(a, s);
              const l = t.indexOf(Qp.get("imageMathmlAttribute"));
              if (
                ((a = t.indexOf(r, s)),
                -1 === a
                  ? (a = t.length - 1)
                  : (a += -1 !== l ? t.indexOf("/>", s) : r.length),
                Gp.isMathmlInAttribute(t, s) || -1 !== l)
              )
                n += t.substring(s, a);
              else {
                let o = t.substring(s, a);
                (o =
                  e.id === Jp.safeXmlCharacters.id
                    ? Gp.safeXmlDecode(o)
                    : Gp.mathMLEntities(o)),
                  (n += nb.createObjectCode(
                    sb.mathmlToImgObject(document, o, null, i)
                  ));
              }
              s = t.indexOf(o, a);
            }
            return (n += t.substring(a, t.length)), n;
          }
        }
        if ("undefined" != typeof MutationObserver) {
          const t = new MutationObserver((t) => {
            t.forEach((t) => {
              t.oldValue === Qp.get("imageClassName") &&
                "class" === t.attributeName &&
                -1 === t.target.className.indexOf(Qp.get("imageClassName")) &&
                (t.target.className = Qp.get("imageClassName"));
            });
          });
          (sb.observer = Object.create(t)),
            (sb.observer.Config = { attributes: !0, attributeOldValue: !0 }),
            (sb.observer.observe = function (t) {
              Object.getPrototypeOf(this).observe(t, this.Config);
            });
        }
        class ab {
          constructor() {
            (this.isContentChanged = !1), (this.waitingForChanges = !1);
          }
          setIsContentChanged(t) {
            this.isContentChanged = t;
          }
          getIsContentChanged() {
            return this.isContentChanged;
          }
          setWaitingForChanges(t) {
            this.waitingForChanges = t;
          }
          caretPositionChanged(t) {}
          clipboardChanged(t) {}
          contentChanged(t) {
            !0 === this.waitingForChanges &&
              !1 === this.isContentChanged &&
              (this.isContentChanged = !0);
          }
          styleChanged(t) {}
          transformationReceived(t) {}
        }
        class lb {
          constructor(t) {
            if (((this.editorAttributes = {}), !("editorAttributes" in t)))
              throw new Error(
                "ContentManager constructor error: editorAttributes property missed."
              );
            if (
              ((this.editorAttributes = t.editorAttributes),
              (this.customEditors = null),
              "customEditors" in t && (this.customEditors = t.customEditors),
              (this.environment = {}),
              !("environment" in t))
            )
              throw new Error(
                "ContentManager constructor error: environment property missed"
              );
            if (
              ((this.environment = t.environment),
              (this.language = ""),
              !("language" in t))
            )
              throw new Error(
                "ContentManager constructor error: language property missed"
              );
            (this.language = t.language),
              (this.editorListener = new ab()),
              (this.editor = null),
              (this.ua = navigator.userAgent.toLowerCase()),
              (this.deviceProperties = {}),
              (this.deviceProperties.isAndroid =
                this.ua.indexOf("android") > -1),
              (this.deviceProperties.isIOS =
                this.ua.indexOf("ipad") > -1 || this.ua.indexOf("iphone") > -1),
              (this.toolbar = null),
              (this.modalDialogInstance = null),
              (this.listeners = new Kp()),
              (this.mathML = null),
              (this.isNewElement = !0),
              (this.integrationModel = null);
          }
          addListener(t) {
            this.listeners.add(t);
          }
          setIntegrationModel(t) {
            this.integrationModel = t;
          }
          setModalDialogInstance(t) {
            this.modalDialogInstance = t;
          }
          insert() {
            this.updateTitle(this.modalDialogInstance),
              this.insertEditor(this.modalDialogInstance);
          }
          insertEditor() {
            if (lb.isEditorLoaded()) {
              if (
                ((this.editor = window.com.wiris.jsEditor.JsEditor.newInstance(
                  this.editorAttributes
                )),
                this.editor.insertInto(
                  this.modalDialogInstance.contentContainer
                ),
                this.editor.focus(),
                this.modalDialogInstance.rtl && this.editor.action("rtl"),
                this.editor.getEditorModel().isRTL() &&
                  (this.editor.element.style.direction = "rtl"),
                this.editor
                  .getEditorModel()
                  .addEditorListener(this.editorListener),
                this.modalDialogInstance.deviceProperties.isIOS)
              ) {
                setTimeout(function () {
                  this.modalDialogInstance.hideKeyboard();
                }, 400);
                const t =
                  document.getElementsByClassName("wrs_formulaDisplay")[0];
                nb.addEvent(
                  t,
                  "focus",
                  this.modalDialogInstance.handleOpenedIosSoftkeyboard
                ),
                  nb.addEvent(
                    t,
                    "blur",
                    this.modalDialogInstance.handleClosedIosSoftkeyboard
                  );
              }
              this.listeners.fire("onLoad", {});
            } else setTimeout(lb.prototype.insertEditor.bind(this), 100);
          }
          init() {
            lb.isEditorLoaded() || this.addEditorAsExternalDependency();
          }
          addEditorAsExternalDependency() {
            const t = document.createElement("script");
            t.type = "text/javascript";
            let e = Qp.get("editorUrl");
            const i = document.createElement("a");
            lb.setHrefToAnchorElement(i, e),
              lb.setProtocolToAnchorElement(i),
              (e = lb.getURLFromAnchorElement(i));
            const n = this.getEditorStats();
            (t.src = `${e}?lang=${this.language}&stats-editor=${n.editor}&stats-mode=${n.mode}&stats-version=${n.version}`),
              document.getElementsByTagName("head")[0].appendChild(t);
          }
          static setHrefToAnchorElement(t, e) {
            t.href = e;
          }
          static setProtocolToAnchorElement(t) {
            0 === window.location.href.indexOf("https://") &&
              "http:" === t.protocol &&
              (t.protocol = "https:");
          }
          static getURLFromAnchorElement(t) {
            if ("80" === t.port || "443" === t.port || "" === t.port)
              return `${t.protocol}//${t.hostname}/${t.pathname}`;
          }
          getEditorStats() {
            const t = {};
            return (
              "editor" in this.environment
                ? (t.editor = this.environment.editor)
                : (t.editor = "unknown"),
              "mode" in this.environment
                ? (t.mode = this.environment.mode)
                : (t.mode = Qp.get("saveMode")),
              "version" in this.environment
                ? (t.version = this.environment.version)
                : (t.version = Qp.get("version")),
              t
            );
          }
          static isEditorLoaded() {
            return (
              window.com &&
              window.com.wiris &&
              window.com.wiris.jsEditor &&
              window.com.wiris.jsEditor.JsEditor &&
              window.com.wiris.jsEditor.JsEditor.newInstance
            );
          }
          setInitialContent() {
            this.isNewElement || this.setMathML(this.mathML);
          }
          setMathML(t, e) {
            void 0 === e && (e = !1),
              this.editor.setMathMLWithCallback(t, () => {
                this.editorListener.setWaitingForChanges(!0);
              }),
              setTimeout(() => {
                this.editorListener.setIsContentChanged(!1);
              }, 500),
              e || this.onFocus();
          }
          onFocus() {
            void 0 !== this.editor &&
              null != this.editor &&
              this.editor.focus();
          }
          submitAction() {
            if (this.editor.isFormulaEmpty())
              this.integrationModel.updateFormula(null);
            else {
              let t = this.editor.getMathMLWithSemantics();
              if (null !== this.customEditors.getActiveEditor()) {
                const { toolbar: e } = this.customEditors.getActiveEditor();
                t = Gp.addCustomEditorClassAttribute(t, e);
              } else
                Object.keys(this.customEditors.editors).forEach((e) => {
                  t = Gp.removeCustomEditorClassAttribute(t, e);
                });
              const e = Gp.mathMLEntities(t);
              this.integrationModel.updateFormula(e);
            }
            this.customEditors.disable(),
              this.integrationModel.notifyWindowClosed(),
              this.setEmptyMathML(),
              this.customEditors.disable();
          }
          setEmptyMathML() {
            this.deviceProperties.isAndroid || this.deviceProperties.isIOS
              ? this.editor.getEditorModel().isRTL()
                ? this.setMathML(
                    '<math dir="rtl"><semantics><annotation encoding="application/json">[]</annotation></semantics></math>',
                    !0
                  )
                : this.setMathML(
                    '<math><semantics><annotation encoding="application/json">[]</annotation></semantics></math>',
                    !0
                  )
              : this.editor.getEditorModel().isRTL()
              ? this.setMathML('<math dir="rtl"/>', !0)
              : this.setMathML("<math/>", !0);
          }
          onOpen() {
            this.isNewElement
              ? this.setEmptyMathML()
              : this.setMathML(this.mathML),
              this.updateToolbar(),
              this.onFocus();
          }
          updateToolbar() {
            this.updateTitle(this.modalDialogInstance);
            const t = this.customEditors.getActiveEditor();
            if (t) {
              const e = t.toolbar
                ? t.toolbar
                : _wrs_int_wirisProperties.toolbar;
              (null != this.toolbar && this.toolbar === e) ||
                this.setToolbar(e);
            } else {
              const t = this.getToolbar();
              (null != this.toolbar && this.toolbar === t) ||
                (this.setToolbar(t), this.customEditors.disable());
            }
          }
          updateTitle() {
            const t = this.customEditors.getActiveEditor();
            t
              ? this.modalDialogInstance.setTitle(t.title)
              : this.modalDialogInstance.setTitle("MathType");
          }
          getToolbar() {
            let t = "general";
            return (
              "toolbar" in this.editorAttributes &&
                ({ toolbar: t } = this.editorAttributes),
              "general" === t &&
                (t =
                  "undefined" == typeof _wrs_int_wirisProperties ||
                  void 0 === _wrs_int_wirisProperties.toolbar
                    ? "general"
                    : _wrs_int_wirisProperties.toolbar),
              t
            );
          }
          setToolbar(t) {
            (this.toolbar = t),
              this.editor.setParams({ toolbar: this.toolbar });
          }
          hasChanges() {
            return (
              !this.editor.isFormulaEmpty() &&
              this.editorListener.getIsContentChanged()
            );
          }
          onKeyDown(t) {
            if (void 0 !== t.key && !1 === t.repeat)
              if ("Escape" === t.key || "Esc" === t.key) {
                let e = document.getElementsByClassName(
                  "wrs_expandButton wrs_expandButtonFor3RowsLayout wrs_pressed"
                );
                0 === e.length &&
                  ((e = document.getElementsByClassName(
                    "wrs_expandButton wrs_expandButtonFor2RowsLayout wrs_pressed"
                  )),
                  0 === e.length &&
                    ((e = document.getElementsByClassName(
                      "wrs_select wrs_pressed"
                    )),
                    0 === e.length &&
                      (this.modalDialogInstance.cancelAction(),
                      t.stopPropagation(),
                      t.preventDefault())));
              } else if (t.shiftKey && "Tab" === t.key)
                if (
                  document.activeElement ===
                  this.modalDialogInstance.submitButton
                )
                  this.editor.focus(), t.stopPropagation(), t.preventDefault();
                else {
                  const e = document.querySelector('[title="Manual"]');
                  document.activeElement === e &&
                    (this.modalDialogInstance.cancelButton.focus(),
                    t.stopPropagation(),
                    t.preventDefault());
                }
              else if ("Tab" === t.key)
                if (
                  document.activeElement ===
                  this.modalDialogInstance.cancelButton
                ) {
                  document.querySelector('[title="Manual"]').focus(),
                    t.stopPropagation(),
                    t.preventDefault();
                } else {
                  "wrs_formulaDisplay wrs_focused" ===
                    document
                      .getElementsByClassName("wrs_formulaDisplay")[0]
                      .getAttribute("class") &&
                    (this.modalDialogInstance.submitButton.focus(),
                    t.stopPropagation(),
                    t.preventDefault());
                }
          }
        }
        class cb {
          constructor() {
            (this.editors = []), (this.activeEditor = "default");
          }
          addEditor(t, e) {
            const i = {};
            (i.name = e.name),
              (i.toolbar = e.toolbar),
              (i.icon = e.icon),
              (i.confVariable = e.confVariable),
              (i.title = e.title),
              (i.tooltip = e.tooltip),
              (this.editors[t] = i);
          }
          enable(t) {
            this.activeEditor = t;
          }
          disable() {
            this.activeEditor = "default";
          }
          getActiveEditor() {
            return "default" !== this.activeEditor
              ? this.editors[this.activeEditor]
              : null;
          }
        }
        var db = {
          imageCustomEditorName: "data-custom-editor",
          imageClassName: "Wirisformula",
          CASClassName: "Wiriscas",
        };
        class hb {
          constructor() {
            (this.cancelled = !1), (this.defaultPrevented = !1);
          }
          cancel() {
            this.cancelled = !0;
          }
          preventDefault() {
            this.defaultPrevented = !0;
          }
        }
        class ub {
          constructor(t) {
            (this.overlayElement = t.overlayElement),
              (this.callbacks = t.callbacks),
              (this.overlayWrapper = this.overlayElement.appendChild(
                document.createElement("div")
              )),
              this.overlayWrapper.setAttribute(
                "class",
                "wrs_popupmessage_overlay_envolture"
              ),
              (this.message = this.overlayWrapper.appendChild(
                document.createElement("div")
              )),
              (this.message.id = "wrs_popupmessage"),
              this.message.setAttribute("class", "wrs_popupmessage_panel"),
              this.message.setAttribute("role", "dialog"),
              this.message.setAttribute("aria-describedby", "description_txt");
            const e = document.createElement("p"),
              i = document.createTextNode(t.strings.message);
            e.appendChild(i),
              (e.id = "description_txt"),
              this.message.appendChild(e);
            const n = this.overlayWrapper.appendChild(
              document.createElement("div")
            );
            n.setAttribute("class", "wrs_popupmessage_overlay"),
              n.addEventListener("click", this.cancelAction.bind(this)),
              (this.buttonArea = this.message.appendChild(
                document.createElement("div")
              )),
              this.buttonArea.setAttribute(
                "class",
                "wrs_popupmessage_button_area"
              ),
              (this.buttonArea.id = "wrs_popup_button_area");
            const o = {
              class: "wrs_button_accept",
              innerHTML: t.strings.submitString,
              id: "wrs_popup_accept_button",
            };
            (this.closeButton = this.createButton(
              o,
              this.closeAction.bind(this)
            )),
              this.buttonArea.appendChild(this.closeButton);
            const r = {
              class: "wrs_button_cancel",
              innerHTML: t.strings.cancelString,
              id: "wrs_popup_cancel_button",
            };
            (this.cancelButton = this.createButton(
              r,
              this.cancelAction.bind(this)
            )),
              this.buttonArea.appendChild(this.cancelButton);
          }
          createButton(t, e) {
            let i = {};
            return (
              (i = document.createElement("button")),
              i.setAttribute("id", t.id),
              i.setAttribute("class", t.class),
              (i.innerHTML = t.innerHTML),
              i.addEventListener("click", e),
              i
            );
          }
          show() {
            "block" !== this.overlayWrapper.style.display
              ? (document.activeElement.blur(),
                (this.overlayWrapper.style.display = "block"),
                this.closeButton.focus())
              : ((this.overlayWrapper.style.display = "none"),
                _wrs_modalWindow.focus());
          }
          cancelAction() {
            (this.overlayWrapper.style.display = "none"),
              void 0 !== this.callbacks.cancelCallback &&
                this.callbacks.cancelCallback();
          }
          closeAction() {
            this.cancelAction(),
              void 0 !== this.callbacks.closeCallback &&
                this.callbacks.closeCallback();
          }
          onKeyDown(t) {
            void 0 !== t.key &&
              ("Escape" === t.key || "Esc" === t.key
                ? (this.cancelAction(), t.stopPropagation(), t.preventDefault())
                : "Tab" === t.key &&
                  (document.activeElement === this.closeButton
                    ? this.cancelButton.focus()
                    : this.closeButton.focus(),
                  t.stopPropagation(),
                  t.preventDefault()));
          }
        }
        var mb =
            '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3813"\n   version="1.1">\n  <metadata\n     id="metadata3819">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3817" />\n  <image\n     y="0"\n     x="0"\n     id="image3821"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nnUlEQVRYw+3Z0QnCMBSF4T/FATqCG1g3cISO0NE6iiPoCE5gneD40ohPvgkJ/AcC9/EjHELgliT0\nkoGOIlasWLFixYoVK1asWLFixYoVK1bsjxy+5hlYgLEx47ofSEKSJW1nTUJJMgLPDlpwHoCpk8rO\nvgZixf4Zu3Vi3cq+WroBp4ahL+BYa3AB7o1CH7vvc7M1U4N/g2sdSk8bxjfDaMNdr+hmAQAAAABJ\nRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n',
          gb =
            '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg32"\n   version="1.1">\n  <metadata\n     id="metadata38">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs36" />\n  <image\n     y="0"\n     x="0"\n     id="image40"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\npklEQVRYw+3ZLQ4CMRCG4bcbFOvXg99T7FG4BafAw1VALx7dWyy2mIoGgSOZJu/n6p70ZybppFIK\nvWSgo4gVK1asWLFixYoVK1asWLFixYoV+yO7r/UMHIAxiO8FZGBrsUfgDEwBN/QNXIA11S/PW1Bo\nCz4N9ein4Nd1Dyw9PbDR0iVW7J+xudax6HkOtZVdg0MfQE7N0G4GlmANYgNW4A6QepowfgDMXB26\nb1V6LAAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n';
        class fb {
          constructor(t) {
            this.attributes = t;
            const e = navigator.userAgent.toLowerCase(),
              i = e.indexOf("android") > -1,
              n = e.indexOf("ipad") > -1 || e.indexOf("iphone") > -1;
            (this.iosSoftkeyboardOpened = !1),
              (this.iosMeasureUnit = -1 === e.indexOf("crios") ? "%" : "vh"),
              (this.iosDivHeight = "100%" + this.iosMeasureUnit);
            const o = window.outerWidth,
              r = window.outerHeight,
              s = o > r,
              a = o < r,
              l = s && this.attributes.height > r,
              c = a && this.attributes.width > o,
              d = l || c;
            (this.instanceId = document.getElementsByClassName(
              "wrs_modal_dialogContainer"
            ).length),
              (this.deviceProperties = {
                orientation: s ? "landscape" : "portait",
                isAndroid: i,
                isIOS: n,
                isMobile: d,
                isDesktop: !d && !n && !i,
              }),
              (this.properties = {
                created: !1,
                state: "",
                previousState: "",
                position: { bottom: 0, right: 10 },
                size: { height: 338, width: 580 },
              }),
              (this.websiteBeforeLockParameters = null);
            let h = { class: "wrs_modal_overlay" };
            (h.id = this.getElementId(h.class)),
              (this.overlay = nb.createElement("div", h)),
              (h = {}),
              (h.class = "wrs_modal_title_bar"),
              (h.id = this.getElementId(h.class)),
              (this.titleBar = nb.createElement("div", h)),
              (h = {}),
              (h.class = "wrs_modal_title"),
              (h.id = this.getElementId(h.class)),
              (this.title = nb.createElement("div", h)),
              (this.title.innerHTML = ""),
              (h = {}),
              (h.class = "wrs_modal_close_button"),
              (h.id = this.getElementId(h.class)),
              (h.title = ib.get("close")),
              (h.style = {}),
              (this.closeDiv = nb.createElement("a", h)),
              this.closeDiv.setAttribute("role", "button");
            let u = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3783"\n   version="1.1">\n  <metadata\n     id="metadata3789">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3787" />\n  <image\n     y="0"\n     x="0"\n     id="image3791"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB\nvklEQVRYw83Z23GDMBAF0AsNhBIowSVQgjuISnAJKSEdZNOBS6CDOBUkqSC4gs2PyGhAQg92se4M\n4w8bccYW2hVumBmRdAB6ADfopQcw2SOYNoIkAL8APgB8AzgLI0/2S/iy1xkt3B9m9h0dM9/YHxM4\nJ/c4MfPkGX+y763OyYVKgUPQTXAJdC84Bg2CS6Gl4FSoF7wHmgvOhbrgzsW+8L4YJegccrEj749R\ngs7ZXGdz8wbAeNbREcDTzrHvblEgBbAUFACuy6JALJeL0E/P9sbvmBnNojcgAM+oJ58AhrlnWM5Z\nA+C9RmiokakBvIJuNTLSc7hojqY0Mo8EB6Ep2CPBm9BU7BHgKDQHqwlOguZiNcDJ0JLe4FV4iaLY\nJjF16dLqnoob+EdDs8A1QJPBtUCTwDVBo+DaoJvgNvBIR6rDl9wirbA1QIPgVgl6VwHb+dAr7Jkk\nS/Pg3mCkVOslxxV9yBFqSqTA/3N2Utkzye3pftw5OxzQ5tHeddcdzGj3o4VgClUwowgtAVOs3BpF\naA6YUnsDowhNAVNu12UUoVtgCn2+ifxp1wO42Ner4KPR5dJ2tsse2ZLvTQxbVf4AmC2z7WnSvpIA\nAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`,
              m = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg2"\n   version="1.1">\n  <metadata\n     id="metadata8">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs6" />\n  <image\n     y="0"\n     x="0"\n     id="image10"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB\n2ElEQVRYw9XZoXPCMBTH8S+5KfDzQ29606CH3/SmQTO96aGHHn/F0Himh8eDZSblQknSJH2F0DtE\nQw8+12vyfulr7XY7LuW4qvj+DugD18AC+AE2woa+/mz07y9cF7Y8d7YPDEtjK2AsCB4BvdLYHPi0\nXawioAA3wAfQaQiKHhuFYl1QSbAL6gWrSKgEuArqBKsEaB1wKNQKVsasHybcpRhwLNQED0zsoMbz\nFwJOhWL6Cmzd2e0D14Wi1/k9di2wFNnAEtBifd9jv4GtIPgaeBOCAkzLFayr/6idWSSY6DJ8sHT9\n6VK6zRFqKwo5gQ+grnKbA/gI6gsy5wRboT7sucBOaBX21GAvNAR7KnAlNBTbNDgIGoMtwO/C0Gko\nNBZbN525tk+dJrAj4F4YGxXgVQS019DkCgarM0OjwCoDaDBYZQINAquMoJVglRnUC1YZQp1g1RB0\nJryn65jYJ0HoRGPHguDX8hsZ6VAiGX4eUrJBbHqSArdN7LLBmCcBnpvYWfHWo6E8Wge8Ar7Kj8E4\nARwcnBPBB20BE7uJBMdAU8BH/YvyBAsFp0BjwNZGi201qALXgYaAnR0hX2upAzwDj/p8raFL5I4u\n8ALc6vNfvc+ztq5al9Rh/AfwZZ/LmlMllAAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`;
            this.closeDiv.setAttribute("style", u),
              this.closeDiv.setAttribute("onmouseover", `this.style = "${m}";`),
              this.closeDiv.setAttribute("onmouseout", `this.style = "${u}";`),
              (h = {}),
              (h.class = "wrs_modal_stack_button"),
              (h.id = this.getElementId(h.class)),
              (h.title = ib.get("exit_fullscreen")),
              (this.stackDiv = nb.createElement("a", h)),
              this.stackDiv.setAttribute("role", "button"),
              (u = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3823"\n   version="1.1">\n  <metadata\n     id="metadata3829">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3827" />\n  <image\n     y="0"\n     x="0"\n     id="image3831"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAHOSURBVFhH1ZiLUcMwEEQNDcQl0AEuISVABZhO\nUkroICVAB6ECoINQgdmVfR5FlmQrkZzjzezEzsc8NPqcdNd1XfVfuB9ec3NAmv4yiRo5ImzBlm+c\nwZYtEHJCGsT3eSgHxKZFxs/tL+aMkCK8R3yMwu4PcsVmiXBIVDDCvh/miEtMeE5UaEsNMJcN8o64\ng26PvPSXs9S+/zRHQtgtvLRFCb9blZpnYw/9Rb6RR3M3zxtiprFbyKYwipK1+uwlnIkSrbITUaJR\n1itKtMkGRYk2WRZAQbTNBpzWtggrrwnaWja00hk0DrCgsEZZ4hXWKksmwjLAHobkgOv+V3+ZhXHQ\niWxKqXYLKNyILDdqbPKlldASPhA+Mxc7uwatkSOSix1iP//q2APshLBvfJo7hbizgQj/mDtl+KYu\nCj8h7NSqCM2zXJvZwqqEY4uCOuGYLKEwJ3kVzMlyscg5915FTFbdqhaSVbn8+mTV1gmurOqCxpZN\nEeUu9BlZd1obioTkQ7IhPGTjYZuPIoUMK/GUFrX39asuHJTlH3w1d3FCBxCrCUufZX+NCUdPSsAq\nwu4A8wnPiQrFhW1Z4govFRWKCoeOjzjoZF92CdwpZy6AquoPvJRHJxB8bJ8AAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`),
              (m = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg42"\n   version="1.1">\n  <metadata\n     id="metadata48">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs46" />\n  <image\n     y="0"\n     x="0"\n     id="image50"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAG/SURBVFhH1ZgxUsMwEEUNJRyAGmp6qKGn5xRQ\nQ08NNfRQQw11DpAaanIAWrMv8WaELSlexhLLm/mRnImiF48jr7zVtm3zX9ju2ik5llxLdpdHNg4k\nT5I7yWB8Cdl9yZHkRmIRRpQxOxK+YzC+hKwSnTBBKKoMxpeUBSbkksgRE1V+CJeWhUPJ5ao7ICeq\nrIVryMKJpC88RlTZk1SThVDYIvoluZIsSqyz511SfEg4UxbRdw5qnlmFa9AsCn8hO4aBKHiUjYqC\nN9mkKHiSzYqCJ9lPSVIUPMmySqTudEu8XbOxO90ab7KQFPYoC1Fhr7IwENbagMLCUtXnoCTM1QZW\n3iS3dFT2mRfHvEjuVfZUckFnQh67dgqo1GYqC1MLn3XtZIR/sFcJW2C39FcD18KxpcutcGqddSmc\nuykg/LDq+iAnC/OudUFOVrfLbkjJWvb11YjJuhSFvqxbUQhlXYuCylpE2YXy2SkLlVEgaxVluzyT\nIEutWQ1kKZYtouF2maK4mjCyFN6bJsw9gKgmrNdsbsKNT0qEKsIqC7EJx4gqxYVDWQgntIgqRYXD\nbY3CLpcVgmdPC974BYy3/MgRNM03hR9ubFTHT48AAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`),
              this.stackDiv.setAttribute("style", u),
              this.stackDiv.setAttribute("onmouseover", `this.style = "${m}";`),
              this.stackDiv.setAttribute("onmouseout", `this.style = "${u}";`),
              (h = {}),
              (h.class = "wrs_modal_maximize_button"),
              (h.id = this.getElementId(h.class)),
              (h.title = ib.get("fullscreen")),
              (this.maximizeDiv = nb.createElement("a", h)),
              this.maximizeDiv.setAttribute("role", "button"),
              (u = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3793"\n   version="1.1">\n  <metadata\n     id="metadata3799">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3797" />\n  <image\n     y="0"\n     x="0"\n     id="image3801"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAG4SURBVFhHvZnhUYNAEEbRBkwH2oGUkA40FWgJ\nKSEdaAmxA0vQDmIHKSFWgPuAHZkEAnd8y5v5kuNHMm+WY1mSm6qqCiGlZdUspXzxopY9Wu6bpZQf\nSxlRWapwVx9p2dy2CxUHy9ryWx9pKdWyECYcIQshwlGyIBeOlAWpcLQsyISXkAWEX5tlPkvJwnP7\nns1SsnvLS7PMZwlZiShEy8pEIVJWKgpRsnJRiJBNFf2wbCzjfZgRUZi9JYWDxT9bWk6WIXbKym4t\nKRVloObO5oze6ZClWX9a5jyOcOrfmuUkXPRUH/1zVRhZpvsnCxN+jnDqHh0SdQaFu9vg0ZIqrBZ1\neoXP92yKcJSocyHcd4FNEY4WdbrCR1rGrukMF9BWVhZvLZ7U9rS2nH9HVvoq63iFu+RUlOpIuCYL\nCCPIqVjq1A9j5R3aBnMY2kKzMlbZHPQVbVHLhomCUjZUFFSy35ZQUVDIMo+Gi4JCltFwERSy75Y5\n4+VkFLLcKHLHyyRUF1jOeJmMShbChZWy0Df8yFDLgg8/cpCN6I9cdHJhZHmy7X2anAnCtDUZ/j/Y\ng2X2j709MHhTDAFF8QdK9SRpUl2yFgAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`),
              (m = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg12"\n   version="1.1">\n  <metadata\n     id="metadata18">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs16" />\n  <image\n     y="0"\n     x="0"\n     id="image20"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAGMSURBVFhHvdk7TsNAFIVhQ0l6elLDJqCGngXQ\nU7MA6rALahZATQ81C6APrXP/jEaKHD/i8TnzS1eaICF/2I4f4qxt20bYOmaVlrK2Mb8s1Nj3mIu0\nlPYZszlPa1kvMf9pKe02Zq3Gcrhc4JUaSzawA0sWsAtLcrATS1KwG0sycA0sAd6kZXm1sNzVHtOy\nvBpYoK8xV/tPC3JjZVByYqVQcmHlUHJgLVBSY0ugPP7xO5PXYSW2FMr19ytm8sahxD7ElEBzk3c6\nsFysn/afymKPvsXMueh3oblRMNibmPuYZ34wsyWHfqhB8OFpwKvDHLADmusFd8/ZU8FOaO4I3PcF\nmwLXgOYOwVtexdnwdUy3vg2UQPnD2eji+vZsrruHS/eoBEpjWMpgrhi1Dv1gY6fBkuRQmtqzJVmg\npMbaoKTEWqGkwtqhpMBWgZICWwVKCuwpzxKSFNi5T2vFqb5gVcAqLNnBSixZwWos2cBg/9JSmgUM\n9iMt5QFe8tZ8VP6n3WXMHQtxPzHfabm0ptkBwWhpthzMp7YAAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
              )})`),
              this.maximizeDiv.setAttribute("style", u),
              this.maximizeDiv.setAttribute(
                "onmouseover",
                `this.style = "${m}";`
              ),
              this.maximizeDiv.setAttribute(
                "onmouseout",
                `this.style = "${u}";`
              ),
              (h = {}),
              (h.class = "wrs_modal_minimize_button"),
              (h.id = this.getElementId(h.class)),
              (h.title = ib.get("minimize")),
              (this.minimizeDiv = nb.createElement("a", h)),
              this.minimizeDiv.setAttribute("role", "button"),
              (u = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                mb
              )})`),
              (m = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                gb
              )})`),
              this.minimizeDiv.setAttribute("style", u),
              this.minimizeDiv.setAttribute(
                "onmouseover",
                `this.style = "${m}";`
              ),
              this.minimizeDiv.setAttribute(
                "onmouseout",
                `this.style = "${u}";`
              ),
              (h = {}),
              (h.class = "wrs_modal_dialogContainer"),
              (h.id = this.getElementId(h.class)),
              (h.role = "dialog"),
              (this.container = nb.createElement("div", h)),
              this.container.setAttribute(
                "aria-labeledby",
                "wrs_modal_title[0]"
              ),
              (h = {}),
              (h.class = "wrs_modal_wrapper"),
              (h.id = this.getElementId(h.class)),
              (this.wrapper = nb.createElement("div", h)),
              (h = {}),
              (h.class = "wrs_content_container"),
              (h.id = this.getElementId(h.class)),
              (this.contentContainer = nb.createElement("div", h)),
              (h = {}),
              (h.class = "wrs_modal_controls"),
              (h.id = this.getElementId(h.class)),
              (this.controls = nb.createElement("div", h)),
              (h = {}),
              (h.class = "wrs_modal_buttons_container"),
              (h.id = this.getElementId(h.class)),
              (this.buttonContainer = nb.createElement("div", h)),
              (this.submitButton = this.createSubmitButton(
                {
                  id: this.getElementId("wrs_modal_button_accept"),
                  class: "wrs_modal_button_accept",
                  innerHTML: ib.get("accept"),
                },
                this.submitAction.bind(this)
              )),
              (this.cancelButton = this.createSubmitButton(
                {
                  id: this.getElementId("wrs_modal_button_cancel"),
                  class: "wrs_modal_button_cancel",
                  innerHTML: ib.get("cancel"),
                },
                this.cancelAction.bind(this)
              )),
              (this.contentManager = null);
            const g = {
                cancelString: ib.get("cancel"),
                submitString: ib.get("close"),
                message: ib.get("close_modal_warning"),
              },
              f = {
                closeCallback: () => {
                  this.close();
                },
                cancelCallback: () => {
                  this.focus();
                },
              },
              p = { overlayElement: this.container, callbacks: f, strings: g };
            (this.popup = new ub(p)),
              (this.rtl = !1),
              "rtl" in this.attributes && (this.rtl = this.attributes.rtl),
              (this.handleOpenedIosSoftkeyboard =
                this.handleOpenedIosSoftkeyboard.bind(this)),
              (this.handleClosedIosSoftkeyboard =
                this.handleClosedIosSoftkeyboard.bind(this));
          }
          setContentManager(t) {
            this.contentManager = t;
          }
          getContentManager() {
            return this.contentManager;
          }
          submitAction() {
            void 0 !== this.contentManager.submitAction &&
              this.contentManager.submitAction(),
              this.close();
          }
          cancelAction() {
            void 0 === this.contentManager.hasChanges
              ? this.close()
              : this.contentManager.hasChanges()
              ? this.showPopUpMessage()
              : this.close();
          }
          createSubmitButton(t, e) {
            return new (class {
              constructor() {
                (this.element = document.createElement("button")),
                  (this.element.id = t.id),
                  (this.element.className = t.class),
                  (this.element.innerHTML = t.innerHTML),
                  nb.addEvent(this.element, "click", e);
              }
              getElement() {
                return this.element;
              }
            })(t, e).getElement();
          }
          create() {
            this.titleBar.appendChild(this.closeDiv),
              this.titleBar.appendChild(this.stackDiv),
              this.titleBar.appendChild(this.maximizeDiv),
              this.titleBar.appendChild(this.minimizeDiv),
              this.titleBar.appendChild(this.title),
              this.deviceProperties.isDesktop &&
                this.container.appendChild(this.titleBar),
              this.wrapper.appendChild(this.contentContainer),
              this.wrapper.appendChild(this.controls),
              this.controls.appendChild(this.buttonContainer),
              this.buttonContainer.appendChild(this.submitButton),
              this.buttonContainer.appendChild(this.cancelButton),
              this.container.appendChild(this.wrapper),
              this.recalculateScrollBar(),
              document.body.appendChild(this.container),
              document.body.appendChild(this.overlay),
              this.deviceProperties.isDesktop
                ? (this.createModalWindowDesktop(),
                  this.createResizeButtons(),
                  this.addListeners(),
                  Qp.get("modalWindowFullScreen") && this.maximize())
                : this.deviceProperties.isAndroid
                ? this.createModalWindowAndroid()
                : this.deviceProperties.isIOS &&
                  !this.deviceProperties.isMobile &&
                  this.createModalWindowIos(),
              null != this.contentManager && this.contentManager.insert(this),
              (this.properties.open = !0),
              (this.properties.created = !0),
              this.isRTL() &&
                ((this.container.style.right =
                  window.innerWidth -
                  this.scrollbarWidth -
                  this.container.offsetWidth +
                  "px"),
                (this.container.className += " wrs_modal_rtl"));
          }
          createResizeButtons() {
            (this.resizerBR = document.createElement("div")),
              (this.resizerBR.className = "wrs_bottom_right_resizer"),
              (this.resizerBR.innerHTML = "◢"),
              (this.resizerTL = document.createElement("div")),
              (this.resizerTL.className = "wrs_bottom_left_resizer"),
              this.container.appendChild(this.resizerBR),
              this.titleBar.appendChild(this.resizerTL),
              nb.addEvent(
                this.resizerBR,
                "mousedown",
                this.activateResizeStateBR.bind(this)
              ),
              nb.addEvent(
                this.resizerTL,
                "mousedown",
                this.activateResizeStateTL.bind(this)
              );
          }
          activateResizeStateBR(t) {
            this.initializeResizeProperties(t, !1);
          }
          activateResizeStateTL(t) {
            this.initializeResizeProperties(t, !0);
          }
          initializeResizeProperties(t, e) {
            nb.addClass(document.body, "wrs_noselect"),
              nb.addClass(this.overlay, "wrs_overlay_active"),
              (this.resizeDataObject = {
                x: this.eventClient(t).X,
                y: this.eventClient(t).Y,
              }),
              (this.initialWidth = parseInt(this.container.style.width, 10)),
              (this.initialHeight = parseInt(this.container.style.height, 10)),
              e
                ? (this.leftScale = !0)
                : ((this.initialRight = parseInt(
                    this.container.style.right,
                    10
                  )),
                  (this.initialBottom = parseInt(
                    this.container.style.bottom,
                    10
                  ))),
              this.initialRight || (this.initialRight = 0),
              this.initialBottom || (this.initialBottom = 0),
              (document.body.style["user-select"] = "none");
          }
          open() {
            this.removeClass("wrs_closed");
            const { isIOS: t } = this.deviceProperties,
              { isAndroid: e } = this.deviceProperties,
              { isMobile: i } = this.deviceProperties;
            if (
              ((t || e || i) &&
                (this.restoreWebsiteScale(),
                this.lockWebsiteScroll(),
                setTimeout(() => {
                  this.hideKeyboard();
                }, 400)),
              this.properties.created
                ? (this.properties.open ||
                    ((this.properties.open = !0),
                    this.deviceProperties.isAndroid ||
                      this.deviceProperties.isIOS ||
                      this.restoreState()),
                  this.deviceProperties.isDesktop &&
                    Qp.get("modalWindowFullScreen") &&
                    this.maximize(),
                  this.deviceProperties.isIOS &&
                    ((this.iosSoftkeyboardOpened = !1),
                    this.setContainerHeight("" + (100 + this.iosMeasureUnit))))
                : this.create(),
              lb.isEditorLoaded())
            )
              this.contentManager.onOpen(this);
            else {
              const t = Kp.newListener("onLoad", () => {
                this.contentManager.onOpen(this);
              });
              this.contentManager.addListener(t);
            }
          }
          close() {
            this.removeClass("wrs_maximized"),
              this.removeClass("wrs_minimized"),
              this.removeClass("wrs_stack"),
              this.addClass("wrs_closed"),
              this.saveModalProperties(),
              this.unlockWebsiteScroll(),
              (this.properties.open = !1);
          }
          restoreWebsiteScale() {
            let t = document.querySelector("meta[name=viewport]");
            const e = ["initial-scale=", "minimum-scale=", "maximum-scale="],
              i = ["1.0", "1.0", "1.0"],
              n = (t, e) => {
                const n = t.getAttribute("content");
                if (n) {
                  const o = n.split(",");
                  let r = "";
                  const s = [];
                  for (let t = 0; t < o.length; t += 1) {
                    let i = !1,
                      n = 0;
                    for (; !i && n < e.length; )
                      o[t].indexOf(e[n]) && (i = !0), (n += 1);
                    i || s.push(o[t]);
                  }
                  for (let t = 0; t < e.length; t += 1) {
                    const n = e[t] + i[t];
                    r += 0 === t ? n : "," + n;
                  }
                  for (let t = 0; t < s.length; t += 1) r += "," + s[t];
                  t.setAttribute("content", r),
                    t.setAttribute("content", ""),
                    t.setAttribute("content", n);
                } else
                  t.setAttribute(
                    "content",
                    "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0"
                  ),
                    t.removeAttribute("content");
              };
            t
              ? n(t, e)
              : ((t = document.createElement("meta")),
                document.getElementsByTagName("head")[0].appendChild(t),
                n(t, e),
                t.remove());
          }
          lockWebsiteScroll() {
            this.websiteBeforeLockParameters = {
              bodyStylePosition: document.body.style.position
                ? document.body.style.position
                : "",
              bodyStyleOverflow: document.body.style.overflow
                ? document.body.style.overflow
                : "",
              htmlStyleOverflow: document.documentElement.style.overflow
                ? document.documentElement.style.overflow
                : "",
              windowScrollX: window.scrollX,
              windowScrollY: window.scrollY,
            };
          }
          unlockWebsiteScroll() {
            if (this.websiteBeforeLockParameters) {
              (document.body.style.position =
                this.websiteBeforeLockParameters.bodyStylePosition),
                (document.body.style.overflow =
                  this.websiteBeforeLockParameters.bodyStyleOverflow),
                (document.documentElement.style.overflow =
                  this.websiteBeforeLockParameters.htmlStyleOverflow);
              const { windowScrollX: t } = this.websiteBeforeLockParameters,
                { windowScrollY: e } = this.websiteBeforeLockParameters;
              window.scrollTo(t, e), (this.websiteBeforeLockParameters = null);
            }
          }
          isIE11() {
            return (
              navigator.userAgent.search("Msie/") >= 0 ||
              navigator.userAgent.search("Trident/") >= 0 ||
              navigator.userAgent.search("Edge/") >= 0
            );
          }
          isRTL() {
            return (
              "ar" === this.attributes.language ||
              "he" === this.attributes.language ||
              this.rtl
            );
          }
          addClass(t) {
            nb.addClass(this.overlay, t),
              nb.addClass(this.titleBar, t),
              nb.addClass(this.overlay, t),
              nb.addClass(this.container, t),
              nb.addClass(this.contentContainer, t),
              nb.addClass(this.stackDiv, t),
              nb.addClass(this.minimizeDiv, t),
              nb.addClass(this.maximizeDiv, t),
              nb.addClass(this.wrapper, t);
          }
          removeClass(t) {
            nb.removeClass(this.overlay, t),
              nb.removeClass(this.titleBar, t),
              nb.removeClass(this.overlay, t),
              nb.removeClass(this.container, t),
              nb.removeClass(this.contentContainer, t),
              nb.removeClass(this.stackDiv, t),
              nb.removeClass(this.minimizeDiv, t),
              nb.removeClass(this.maximizeDiv, t),
              nb.removeClass(this.wrapper, t);
          }
          createModalWindowDesktop() {
            this.addClass("wrs_modal_desktop"), this.stack();
          }
          createModalWindowAndroid() {
            this.addClass("wrs_modal_android"),
              window.addEventListener(
                "resize",
                this.orientationChangeAndroidSoftkeyboard.bind(this)
              );
          }
          createModalWindowIos() {
            this.addClass("wrs_modal_ios"),
              window.addEventListener(
                "resize",
                this.orientationChangeIosSoftkeyboard.bind(this)
              );
          }
          restoreState() {
            "maximized" === this.properties.state
              ? this.maximize()
              : "minimized" === this.properties.state
              ? ((this.properties.state = this.properties.previousState),
                (this.properties.previousState = ""),
                this.minimize())
              : this.stack();
          }
          stack() {
            (this.properties.previousState = this.properties.state),
              (this.properties.state = "stack"),
              this.removeClass("wrs_maximized"),
              (this.minimizeDiv.title = ib.get("minimize")),
              this.removeClass("wrs_minimized"),
              this.addClass("wrs_stack");
            const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                mb
              )})`,
              e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                gb
              )})`;
            this.minimizeDiv.setAttribute("style", t),
              this.minimizeDiv.setAttribute(
                "onmouseover",
                `this.style = "${e}";`
              ),
              this.minimizeDiv.setAttribute(
                "onmouseout",
                `this.style = "${t}";`
              ),
              this.restoreModalProperties(),
              void 0 !== this.resizerBR &&
                void 0 !== this.resizerTL &&
                this.setResizeButtonsVisibility(),
              this.recalculateScrollBar(),
              this.recalculatePosition(),
              this.recalculateScale(),
              this.focus();
          }
          minimize() {
            if (
              (this.saveModalProperties(),
              (this.title.style.cursor = "pointer"),
              "minimized" === this.properties.state &&
                "stack" === this.properties.previousState)
            )
              this.stack();
            else if (
              "minimized" === this.properties.state &&
              "maximized" === this.properties.previousState
            )
              this.maximize();
            else {
              (this.container.style.height = "30px"),
                (this.container.style.width = "250px"),
                (this.container.style.bottom = "0px"),
                (this.container.style.right = "10px"),
                this.removeListeners(),
                (this.properties.previousState = this.properties.state),
                (this.properties.state = "minimized"),
                this.setResizeButtonsVisibility(),
                (this.minimizeDiv.title = ib.get("maximize")),
                nb.containsClass(this.overlay, "wrs_stack")
                  ? this.removeClass("wrs_stack")
                  : this.removeClass("wrs_maximized"),
                this.addClass("wrs_minimized");
              const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                  '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.44 13.76"\n   height="13.76"\n   width="13.44"\n   id="svg3803"\n   version="1.1">\n  <metadata\n     id="metadata3809">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3807" />\n  <image\n     y="0"\n     x="0"\n     id="image3811"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAYAAAAOnxr+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nvElEQVRYw+3ZSw0CMRSF4b8T9iAFB4wDkDAWcICEkTA4GAeAA3AADurgsCkbAgsSMrmFczZNd1/a\n3vSVJFFDGipJNdBZaRdAB2wC2TIwAgNAkrQEjsA86GBegDZJGoF18JnfJtVR9idXvaGGGmrod/b6\nV9kD14k9LbD6FDqUM8CU2b2Deo0aaqihhhpqqKGGGhr1hH/wiP469FaBMzflEhc9PZKQ1CtmsqRO\nEunpHbeNNN3A+dFJ/mf6V+gduGPIoUgKLbAAAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.44" />\n</svg>\n'
                )})`,
                e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                  '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.44 13.76"\n   height="13.76"\n   width="13.44"\n   id="svg22"\n   version="1.1">\n  <metadata\n     id="metadata28">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs26" />\n  <image\n     y="0"\n     x="0"\n     id="image30"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAYAAAAOnxr+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nvUlEQVRYw+3ZsQ3CMBCF4d8WFekZgBqWIDUDZACmYBQWYIn0pGYAegZIexROERHRIBTdhXeVy08+\nyT4/JzMjQmWCVBjoarSugK0z3/0degKODjeyBy5Am8ysARrnnT8nM7sCa+fQLgdAAlQ6ngQVVFBB\nfzeUTK6t8VAwU328ztV6QQUVVFBBBRVUUEG9Ds41sJvZs/8GelDrlw7tAjhvmZLo9o6RD4bEGUp+\nX1My/I0T4HN4rrcASf9M/wp9ASNzIKYYz2hAAAAAAElFTkSuQmCC\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.44" />\n</svg>\n'
                )})`;
              this.minimizeDiv.setAttribute("style", t),
                this.minimizeDiv.setAttribute(
                  "onmouseover",
                  `this.style = "${e}";`
                ),
                this.minimizeDiv.setAttribute(
                  "onmouseout",
                  `this.style = "${t}";`
                );
            }
          }
          maximize() {
            this.saveModalProperties(),
              "maximized" !== this.properties.state &&
                ((this.properties.previousState = this.properties.state),
                (this.properties.state = "maximized")),
              this.setResizeButtonsVisibility(),
              nb.containsClass(this.overlay, "wrs_minimized")
                ? ((this.minimizeDiv.title = ib.get("minimize")),
                  this.removeClass("wrs_minimized"))
                : nb.containsClass(this.overlay, "wrs_stack") &&
                  ((this.container.style.left = null),
                  (this.container.style.top = null),
                  this.removeClass("wrs_stack")),
              this.addClass("wrs_maximized");
            const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                mb
              )})`,
              e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
                gb
              )})`;
            this.minimizeDiv.setAttribute("style", t),
              this.minimizeDiv.setAttribute(
                "onmouseover",
                `this.style = "${e}";`
              ),
              this.minimizeDiv.setAttribute(
                "onmouseout",
                `this.style = "${t}";`
              ),
              this.setSize(
                parseInt(0.8 * window.innerHeight, 10),
                parseInt(0.8 * window.innerWidth, 10)
              ),
              this.container.clientHeight > 700 &&
                (this.container.style.height = "700px"),
              this.container.clientWidth > 1200 &&
                (this.container.style.width = "1200px");
            const { innerHeight: i } = window,
              { innerWidth: n } = window,
              { offsetHeight: o } = this.container,
              { offsetWidth: r } = this.container,
              s = i / 2 - o / 2,
              a = n / 2 - r / 2;
            this.setPosition(s, a),
              this.recalculateScale(),
              this.recalculatePosition(),
              this.recalculateSize(),
              this.focus();
          }
          reExpand() {
            "minimized" === this.properties.state &&
              ("maximized" === this.properties.previousState
                ? this.maximize()
                : this.stack(),
              (this.title.style.cursor = ""));
          }
          setSize(t, e) {
            (this.container.style.height = t + "px"),
              (this.container.style.width = e + "px"),
              this.recalculateSize();
          }
          setPosition(t, e) {
            (this.container.style.bottom = t + "px"),
              (this.container.style.right = e + "px");
          }
          saveModalProperties() {
            "stack" === this.properties.state &&
              ((this.properties.position.bottom = parseInt(
                this.container.style.bottom,
                10
              )),
              (this.properties.position.right = parseInt(
                this.container.style.right,
                10
              )),
              (this.properties.size.width = parseInt(
                this.container.style.width,
                10
              )),
              (this.properties.size.height = parseInt(
                this.container.style.height,
                10
              )));
          }
          restoreModalProperties() {
            "stack" === this.properties.state &&
              (this.setPosition(
                this.properties.position.bottom,
                this.properties.position.right
              ),
              this.setSize(
                this.properties.size.height,
                this.properties.size.width
              ));
          }
          recalculateSize() {
            (this.wrapper.style.width = this.container.clientWidth - 12 + "px"),
              (this.wrapper.style.height =
                this.container.clientHeight - 38 + "px"),
              (this.contentContainer.style.height =
                parseInt(this.wrapper.offsetHeight - 50, 10) + "px");
          }
          setResizeButtonsVisibility() {
            "stack" === this.properties.state
              ? ((this.resizerTL.style.visibility = "visible"),
                (this.resizerBR.style.visibility = "visible"))
              : ((this.resizerTL.style.visibility = "hidden"),
                (this.resizerBR.style.visibility = "hidden"));
          }
          addListeners() {
            this.maximizeDiv.addEventListener(
              "click",
              this.maximize.bind(this),
              !0
            ),
              this.stackDiv.addEventListener(
                "click",
                this.stack.bind(this),
                !0
              ),
              this.minimizeDiv.addEventListener(
                "click",
                this.minimize.bind(this),
                !0
              ),
              this.closeDiv.addEventListener(
                "click",
                this.cancelAction.bind(this)
              ),
              this.title.addEventListener("click", this.reExpand.bind(this)),
              this.overlay.addEventListener(
                "click",
                this.cancelAction.bind(this)
              ),
              nb.addEvent(window, "mousedown", this.startDrag.bind(this)),
              nb.addEvent(window, "mouseup", this.stopDrag.bind(this)),
              nb.addEvent(window, "mousemove", this.drag.bind(this)),
              nb.addEvent(window, "resize", this.onWindowResize.bind(this)),
              nb.addEvent(this.container, "keydown", this.onKeyDown.bind(this));
          }
          removeListeners() {
            nb.removeEvent(window, "mousedown", this.startDrag),
              nb.removeEvent(window, "mouseup", this.stopDrag),
              nb.removeEvent(window, "mousemove", this.drag),
              nb.removeEvent(window, "resize", this.onWindowResize),
              nb.removeEvent(this.container, "keydown", this.onKeyDown);
          }
          eventClient(t) {
            if (void 0 === t.clientX && t.changedTouches) {
              return {
                X: t.changedTouches[0].clientX,
                Y: t.changedTouches[0].clientY,
              };
            }
            return { X: t.clientX, Y: t.clientY };
          }
          startDrag(t) {
            "minimized" !== this.properties.state &&
              t.target === this.title &&
              ((void 0 !== this.dragDataObject &&
                null !== this.dragDataObject) ||
                ((this.dragDataObject = {
                  x: this.eventClient(t).X,
                  y: this.eventClient(t).Y,
                }),
                (this.lastDrag = { x: "0px", y: "0px" }),
                "" === this.container.style.right &&
                  (this.container.style.right = "0px"),
                "" === this.container.style.bottom &&
                  (this.container.style.bottom = "0px"),
                this.isIE11(),
                nb.addClass(document.body, "wrs_noselect"),
                nb.addClass(this.overlay, "wrs_overlay_active"),
                (this.limitWindow = this.getLimitWindow())));
          }
          drag(t) {
            if (this.dragDataObject) {
              t.preventDefault();
              let e = Math.min(
                this.eventClient(t).Y,
                this.limitWindow.minPointer.y
              );
              e = Math.max(this.limitWindow.maxPointer.y, e);
              let i = Math.min(
                this.eventClient(t).X,
                this.limitWindow.minPointer.x
              );
              i = Math.max(this.limitWindow.maxPointer.x, i);
              const n = i - this.dragDataObject.x + "px",
                o = e - this.dragDataObject.y + "px";
              (this.lastDrag = { x: n, y: o }),
                (this.container.style.transform = `translate3d(${n},${o},0)`);
            }
            if (this.resizeDataObject) {
              const { innerWidth: e } = window,
                { innerHeight: i } = window;
              let n,
                o = Math.min(
                  this.eventClient(t).X,
                  e - this.scrollbarWidth - 7
                ),
                r = Math.min(this.eventClient(t).Y, i - 7);
              o < 0 && (o = 0),
                r < 0 && (r = 0),
                (n = this.leftScale ? -1 : 1),
                (this.container.style.width =
                  this.initialWidth + n * (o - this.resizeDataObject.x) + "px"),
                (this.container.style.height =
                  this.initialHeight +
                  n * (r - this.resizeDataObject.y) +
                  "px"),
                this.leftScale ||
                  (this.resizeDataObject.x - o - this.initialWidth < -580
                    ? (this.container.style.right =
                        this.initialRight -
                        (o - this.resizeDataObject.x) +
                        "px")
                    : ((this.container.style.right =
                        this.initialRight + this.initialWidth - 580 + "px"),
                      (this.container.style.width = "580px")),
                  this.resizeDataObject.y - r < this.initialHeight - 338
                    ? (this.container.style.bottom =
                        this.initialBottom -
                        (r - this.resizeDataObject.y) +
                        "px")
                    : ((this.container.style.bottom =
                        this.initialBottom + this.initialHeight - 338 + "px"),
                      (this.container.style.height = "338px"))),
                this.recalculateScale(),
                this.recalculatePosition();
            }
          }
          getLimitWindow() {
            const t = window.innerWidth,
              e = window.innerHeight,
              { offsetHeight: i } = this.container,
              n = parseInt(this.container.style.bottom, 10),
              o = parseInt(this.container.style.right, 10),
              { pageXOffset: r } = window,
              s = this.dragDataObject.y,
              a = this.dragDataObject.x,
              l = i + n - (e - (s - r)),
              c = t - this.scrollbarWidth - (a - r) - o,
              d = e - this.container.offsetHeight + l,
              h = this.title.offsetHeight - (this.title.offsetHeight - l);
            return {
              minPointer: { x: t - c - this.scrollbarWidth, y: d },
              maxPointer: { x: this.container.offsetWidth - c, y: h },
            };
          }
          getScrollBarWidth() {
            const t = document.createElement("p");
            (t.style.width = "100%"), (t.style.height = "200px");
            const e = document.createElement("div");
            (e.style.position = "absolute"),
              (e.style.top = "0px"),
              (e.style.left = "0px"),
              (e.style.visibility = "hidden"),
              (e.style.width = "200px"),
              (e.style.height = "150px"),
              (e.style.overflow = "hidden"),
              e.appendChild(t),
              document.body.appendChild(e);
            const i = t.offsetWidth;
            e.style.overflow = "scroll";
            let n = t.offsetWidth;
            return (
              i === n && (n = e.clientWidth),
              document.body.removeChild(e),
              i - n
            );
          }
          stopDrag() {
            (this.dragDataObject || this.resizeDataObject) &&
              ((this.container.style.transform = ""),
              this.dragDataObject &&
                ((this.container.style.right =
                  parseInt(this.container.style.right, 10) -
                  parseInt(this.lastDrag.x, 10) +
                  "px"),
                (this.container.style.bottom =
                  parseInt(this.container.style.bottom, 10) -
                  parseInt(this.lastDrag.y, 10) +
                  "px")),
              this.focus(),
              (document.body.style["user-select"] = ""),
              this.isIE11(),
              nb.removeClass(document.body, "wrs_noselect"),
              nb.removeClass(this.overlay, "wrs_overlay_active")),
              (this.dragDataObject = null),
              (this.resizeDataObject = null),
              (this.initialWidth = null),
              (this.leftScale = null);
          }
          onWindowResize() {
            this.recalculateScrollBar(),
              this.recalculatePosition(),
              this.recalculateScale();
          }
          onKeyDown(t) {
            void 0 !== t.key &&
              ("block" !== this.popup.overlayWrapper.style.display
                ? "Escape" === t.key || "Esc" === t.key
                  ? this.properties.open && this.contentManager.onKeyDown(t)
                  : t.shiftKey && "Tab" === t.key
                  ? document.activeElement === this.cancelButton
                    ? (this.submitButton.focus(),
                      t.stopPropagation(),
                      t.preventDefault())
                    : this.contentManager.onKeyDown(t)
                  : "Tab" === t.key &&
                    (document.activeElement === this.submitButton
                      ? (this.cancelButton.focus(),
                        t.stopPropagation(),
                        t.preventDefault())
                      : this.contentManager.onKeyDown(t))
                : this.popup.onKeyDown(t));
          }
          recalculatePosition() {
            (this.container.style.right =
              Math.min(
                parseInt(this.container.style.right, 10),
                window.innerWidth -
                  this.scrollbarWidth -
                  this.container.offsetWidth
              ) + "px"),
              parseInt(this.container.style.right, 10) < 0 &&
                (this.container.style.right = "0px"),
              (this.container.style.bottom =
                Math.min(
                  parseInt(this.container.style.bottom, 10),
                  window.innerHeight - this.container.offsetHeight
                ) + "px"),
              parseInt(this.container.style.bottom, 10) < 0 &&
                (this.container.style.bottom = "0px");
          }
          recalculateScale() {
            let t = !1;
            parseInt(this.container.style.width, 10) > 580
              ? ((this.container.style.width =
                  Math.min(
                    parseInt(this.container.style.width, 10),
                    window.innerWidth - this.scrollbarWidth
                  ) + "px"),
                (t = !0))
              : ((this.container.style.width = "580px"), (t = !0)),
              parseInt(this.container.style.height, 10) > 338
                ? ((this.container.style.height =
                    Math.min(
                      parseInt(this.container.style.height, 10),
                      window.innerHeight
                    ) + "px"),
                  (t = !0))
                : ((this.container.style.height = "338px"), (t = !0)),
              t && this.recalculateSize();
          }
          recalculateScrollBar() {
            (this.hasScrollBar =
              window.innerWidth > document.documentElement.clientWidth),
              this.hasScrollBar
                ? (this.scrollbarWidth = this.getScrollBarWidth())
                : (this.scrollbarWidth = 0);
          }
          hideKeyboard() {
            const t = document.createElement("input");
            this.container.appendChild(t), t.focus(), t.blur(), t.remove();
          }
          focus() {
            null != this.contentManager &&
              void 0 !== this.contentManager.onFocus &&
              this.contentManager.onFocus();
          }
          portraitMode() {
            return window.innerHeight > window.innerWidth;
          }
          handleOpenedIosSoftkeyboard() {
            this.iosSoftkeyboardOpened ||
              null == this.iosDivHeight ||
              this.iosDivHeight !== "100" + this.iosMeasureUnit ||
              (this.portraitMode()
                ? this.setContainerHeight("63" + this.iosMeasureUnit)
                : this.setContainerHeight("40" + this.iosMeasureUnit)),
              (this.iosSoftkeyboardOpened = !0);
          }
          handleClosedIosSoftkeyboard() {
            (this.iosSoftkeyboardOpened = !1),
              this.setContainerHeight("100" + this.iosMeasureUnit);
          }
          orientationChangeIosSoftkeyboard() {
            this.iosSoftkeyboardOpened
              ? this.portraitMode()
                ? this.setContainerHeight("63" + this.iosMeasureUnit)
                : this.setContainerHeight("40" + this.iosMeasureUnit)
              : this.setContainerHeight("100" + this.iosMeasureUnit);
          }
          orientationChangeAndroidSoftkeyboard() {
            this.setContainerHeight("100%");
          }
          setContainerHeight(t) {
            (this.iosDivHeight = t), (this.wrapper.style.height = t);
          }
          showPopUpMessage() {
            "minimized" === this.properties.state && this.stack(),
              this.popup.show();
          }
          setTitle(t) {
            this.title.innerHTML = t;
          }
          getElementId(t) {
            return `${t}[${this.instanceId}]`;
          }
        }
        var pb;
        /*! http://mths.be/codepointat v0.1.0 by @mathias */ String.prototype
          .codePointAt ||
          ((pb = function (t) {
            if (null == this) throw TypeError();
            var e = String(this),
              i = e.length,
              n = t ? Number(t) : 0;
            if ((n != n && (n = 0), !(n < 0 || n >= i))) {
              var o,
                r = e.charCodeAt(n);
              return r >= 55296 &&
                r <= 56319 &&
                i > n + 1 &&
                (o = e.charCodeAt(n + 1)) >= 56320 &&
                o <= 57343
                ? 1024 * (r - 55296) + o - 56320 + 65536
                : r;
            }
          }),
          Object.defineProperty
            ? Object.defineProperty(String.prototype, "codePointAt", {
                value: pb,
                configurable: !0,
                writable: !0,
              })
            : (String.prototype.codePointAt = pb)),
          "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
              value: function (t, e) {
                if (null == t)
                  throw new TypeError(
                    "Cannot convert undefined or null to object"
                  );
                for (var i = Object(t), n = 1; n < arguments.length; n++) {
                  var o = arguments[n];
                  if (null != o)
                    for (var r in o)
                      Object.prototype.hasOwnProperty.call(o, r) &&
                        (i[r] = o[r]);
                }
                return i;
              },
              writable: !0,
              configurable: !0,
            });
        i(96);
        class bb {
          constructor(t) {
            (this.language = "en"),
              (this.editMode = "images"),
              (this.modalDialog = null),
              (this.customEditors = new cb());
            if (
              (this.customEditors.addEditor("chemistry", {
                name: "Chemistry",
                toolbar: "chemistry",
                icon: "chem.png",
                confVariable: "chemEnabled",
                title: "ChemType",
                tooltip: "Insert a chemistry formula - ChemType",
              }),
              (this.environment = {}),
              (this.editionProperties = {}),
              (this.editionProperties.isNewElement = !0),
              (this.editionProperties.temporalImage = null),
              (this.editionProperties.latexRange = null),
              (this.editionProperties.range = null),
              (this.integrationModel = null),
              (this.contentManager = null),
              (this.browser = (() => {
                const t = navigator.userAgent;
                let e = "none";
                return (
                  t.search("Edge/") >= 0
                    ? (e = "EDGE")
                    : t.search("Chrome/") >= 0
                    ? (e = "CHROME")
                    : t.search("Trident/") >= 0
                    ? (e = "IE")
                    : t.search("Firefox/") >= 0
                    ? (e = "FIREFOX")
                    : t.search("Safari/") >= 0 && (e = "SAFARI"),
                  e
                );
              })()),
              (this.listeners = new Kp()),
              (this.serviceProviderProperties = {}),
              !("serviceProviderProperties" in t))
            )
              throw new Error("serviceProviderProperties property missing.");
            this.serviceProviderProperties = t.serviceProviderProperties;
          }
          static get globalListeners() {
            return bb._globalListeners;
          }
          static set globalListeners(t) {
            bb._globalListeners = t;
          }
          static get initialized() {
            return bb._initialized;
          }
          static set initialized(t) {
            bb._initialized = t;
          }
          setIntegrationModel(t) {
            this.integrationModel = t;
          }
          setEnvironment(t) {
            "editor" in t && (this.environment.editor = t.editor),
              "mode" in t && (this.environment.mode = t.mode),
              "version" in t && (this.environment.version = t.version);
          }
          getModalDialog() {
            return this.modalDialog;
          }
          init() {
            if (bb.initialized) this.listeners.fire("onLoad", {});
            else {
              const t = Kp.newListener("onInit", () => {
                const t = Zp.getService("configurationjs", "", "get"),
                  e = JSON.parse(t);
                Qp.addConfiguration(e),
                  Qp.addConfiguration(db),
                  (ib.language = this.language),
                  this.listeners.fire("onLoad", {});
              });
              Zp.addListener(t),
                Zp.init(this.serviceProviderProperties),
                (bb.initialized = !0);
            }
          }
          addListener(t) {
            this.listeners.add(t);
          }
          static addGlobalListener(t) {
            bb.globalListeners.add(t);
          }
          beforeUpdateFormula(t, e) {
            const i = new hb();
            return (
              (i.mathml = t),
              (i.wirisProperties = {}),
              null != e &&
                Object.keys(e).forEach((t) => {
                  i.wirisProperties[t] = e[t];
                }),
              (i.language = this.language),
              (i.editMode = this.editMode),
              this.listeners.fire("onBeforeFormulaInsertion", i) ||
              bb.globalListeners.fire("onBeforeFormulaInsertion", i)
                ? {}
                : { mathml: i.mathml, wirisProperties: i.wirisProperties }
            );
          }
          insertFormula(t, e, i, n) {
            const o = {};
            if (i)
              if ("latex" === this.editMode) {
                if (
                  ((o.latex = tb.getLatexFromMathML(i)),
                  this.integrationModel.fillNonLatexNode && !o.latex)
                ) {
                  const n = new hb();
                  (n.editMode = this.editMode),
                    (n.windowTarget = e),
                    (n.focusElement = t),
                    (n.latex = o.latex),
                    this.integrationModel.fillNonLatexNode(n, e, i);
                } else o.node = e.document.createTextNode(`$$${o.latex}$$`);
                this.insertElementOnSelection(o.node, t, e);
              } else
                (o.node = sb.mathmlToImgObject(
                  e.document,
                  i,
                  n,
                  this.language
                )),
                  this.insertElementOnSelection(o.node, t, e);
            else this.insertElementOnSelection(null, t, e);
            return o;
          }
          afterUpdateFormula(t, e, i, n) {
            const o = new hb();
            return (
              (o.editMode = this.editMode),
              (o.windowTarget = e),
              (o.focusElement = t),
              (o.node = i),
              (o.latex = n),
              this.listeners.fire("onAfterFormulaInsertion", o) ||
                bb.globalListeners.fire("onAfterFormulaInsertion", o),
              {}
            );
          }
          placeCaretAfterNode(t) {
            this.integrationModel.getSelection();
            const e = t.ownerDocument;
            if (void 0 !== e.getSelection && t.parentElement) {
              const i = e.createRange();
              i.setStartAfter(t), i.collapse(!0);
              const n = e.getSelection();
              n.removeAllRanges(), n.addRange(i), e.body.focus();
            }
          }
          insertElementOnSelection(t, e, i) {
            if (this.editionProperties.isNewElement)
              if (t)
                if ("textarea" === e.type) nb.updateTextArea(e, t.textContent);
                else if (document.selection && 0 === document.getSelection) {
                  let e = i.document.selection.createRange();
                  if (
                    (i.document.execCommand("InsertImage", !1, t.src),
                    "parentElement" in e ||
                      (i.document.execCommand("delete", !1),
                      (e = i.document.selection.createRange()),
                      i.document.execCommand("InsertImage", !1, t.src)),
                    "parentElement" in e)
                  ) {
                    const i = e.parentElement();
                    "IMG" === i.nodeName.toUpperCase()
                      ? i.parentNode.replaceChild(t, i)
                      : e.pasteHTML(nb.createObjectCode(t));
                  }
                } else {
                  const e = this.integrationModel.getSelection();
                  let i = null;
                  this.editionProperties.range
                    ? (({ range: i } = this.editionProperties),
                      (this.editionProperties.range = null))
                    : (i = e.getRangeAt(0)),
                    i.deleteContents();
                  let n = i.startContainer;
                  const o = i.startOffset;
                  3 === n.nodeType
                    ? ((n = n.splitText(o)), n.parentNode.insertBefore(t, n))
                    : 1 === n.nodeType && n.insertBefore(t, n.childNodes[o]),
                    this.placeCaretAfterNode(t);
                }
              else if ("textarea" === e.type) e.focus();
              else {
                const t = this.integrationModel.getSelection();
                if ((t.removeAllRanges(), this.editionProperties.range)) {
                  const { range: e } = this.editionProperties;
                  (this.editionProperties.range = null), t.addRange(e);
                }
              }
            else if (this.editionProperties.latexRange)
              document.selection && 0 === document.getSelection
                ? ((this.editionProperties.isNewElement = !0),
                  this.editionProperties.latexRange.select(),
                  this.insertElementOnSelection(t, e, i))
                : (this.editionProperties.latexRange.deleteContents(),
                  this.editionProperties.latexRange.insertNode(t),
                  this.placeCaretAfterNode(t));
            else if ("textarea" === e.type) {
              let i;
              (i =
                void 0 !== this.integrationModel.getSelectedItem
                  ? this.integrationModel.getSelectedItem(e, !1)
                  : nb.getSelectedItemOnTextarea(e)),
                nb.updateExistingTextOnTextarea(
                  e,
                  t.textContent,
                  i.startPosition,
                  i.endPosition
                );
            } else
              t && "img" === t.nodeName.toLowerCase()
                ? (ob.removeImgDataAttributes(
                    this.editionProperties.temporalImage
                  ),
                  ob.clone(t, this.editionProperties.temporalImage))
                : this.editionProperties.temporalImage.remove(),
                this.placeCaretAfterNode(this.editionProperties.temporalImage);
          }
          openModalDialog(t, e) {
            this.editMode = "images";
            try {
              if (e) {
                t.contentWindow.focus();
                const e = t.contentWindow.getSelection();
                this.editionProperties.range = e.getRangeAt(0);
              } else {
                t.focus();
                const e = getSelection();
                this.editionProperties.range = e.getRangeAt(0);
              }
            } catch (t) {
              this.editionProperties.range = null;
            }
            if (
              (void 0 === e && (e = !0),
              (this.editionProperties.latexRange = null),
              t)
            ) {
              let i;
              if (
                ((i =
                  void 0 !== this.integrationModel.getSelectedItem
                    ? this.integrationModel.getSelectedItem(t, e)
                    : nb.getSelectedItem(t, e)),
                i)
              ) {
                if (
                  !i.caretPosition &&
                  nb.containsClass(i.node, Qp.get("imageClassName"))
                )
                  (this.editionProperties.temporalImage = i.node),
                    (this.editionProperties.isNewElement = !1);
                else if (3 === i.node.nodeType)
                  if (this.integrationModel.getMathmlFromTextNode) {
                    const t = this.integrationModel.getMathmlFromTextNode(
                      i.node,
                      i.caretPosition
                    );
                    t &&
                      ((this.editMode = "latex"),
                      (this.editionProperties.isNewElement = !1),
                      (this.editionProperties.temporalImage =
                        document.createElement("img")),
                      this.editionProperties.temporalImage.setAttribute(
                        Qp.get("imageMathmlAttribute"),
                        Gp.safeXmlEncode(t)
                      ));
                  } else {
                    const n = tb.getLatexFromTextNode(i.node, i.caretPosition);
                    if (n) {
                      const i = tb.getMathMLFromLatex(n.latex);
                      (this.editMode = "latex"),
                        (this.editionProperties.isNewElement = !1),
                        (this.editionProperties.temporalImage =
                          document.createElement("img")),
                        this.editionProperties.temporalImage.setAttribute(
                          Qp.get("imageMathmlAttribute"),
                          Gp.safeXmlEncode(i)
                        );
                      const o = e ? t.contentWindow : window;
                      if ("textarea" !== t.tagName.toLowerCase())
                        if (document.selection) {
                          let t = 0,
                            e = n.startNode.previousSibling;
                          for (; e; )
                            (t += nb.getNodeLength(e)), (e = e.previousSibling);
                          (this.editionProperties.latexRange =
                            o.document.selection.createRange()),
                            this.editionProperties.latexRange.moveToElementText(
                              n.startNode.parentNode
                            ),
                            this.editionProperties.latexRange.move(
                              "character",
                              t + n.startPosition
                            ),
                            this.editionProperties.latexRange.moveEnd(
                              "character",
                              n.latex.length + 4
                            );
                        } else
                          (this.editionProperties.latexRange =
                            o.document.createRange()),
                            this.editionProperties.latexRange.setStart(
                              n.startNode,
                              n.startPosition
                            ),
                            this.editionProperties.latexRange.setEnd(
                              n.endNode,
                              n.endPosition
                            );
                    }
                  }
              } else
                "textarea" === t.tagName.toLowerCase() &&
                  (this.editMode = "latex");
            }
            const i = Qp.get("editorAttributes").split(", "),
              n = {};
            for (let t = 0, e = i.length; t < e; t += 1) {
              const e = i[t].split("="),
                o = e[0],
                r = e[1];
              n[o] = r;
            }
            const o = {},
              r = Qp.get("editorParameters"),
              s = this.integrationModel.editorParameters;
            Object.assign(o, n, r),
              Object.assign(o, n, s),
              (o.language = this.language),
              (o.rtl = this.integrationModel.rtl);
            const a = {};
            if (
              ((a.editorAttributes = o),
              (a.language = this.language),
              (a.customEditors = this.customEditors),
              (a.environment = this.environment),
              null == this.modalDialog)
            ) {
              (this.modalDialog = new fb(o)), (this.contentManager = new lb(a));
              const t = Kp.newListener("onLoad", () => {
                if (
                  ((this.contentManager.isNewElement =
                    this.editionProperties.isNewElement),
                  null != this.editionProperties.temporalImage)
                ) {
                  const t = Gp.safeXmlDecode(
                    this.editionProperties.temporalImage.getAttribute(
                      Qp.get("imageMathmlAttribute")
                    )
                  );
                  this.contentManager.mathML = t;
                }
              });
              this.contentManager.addListener(t),
                this.contentManager.init(),
                this.modalDialog.setContentManager(this.contentManager),
                this.contentManager.setModalDialogInstance(this.modalDialog);
            } else if (
              ((this.contentManager.isNewElement =
                this.editionProperties.isNewElement),
              null != this.editionProperties.temporalImage)
            ) {
              const t = Gp.safeXmlDecode(
                this.editionProperties.temporalImage.getAttribute(
                  Qp.get("imageMathmlAttribute")
                )
              );
              this.contentManager.mathML = t;
            }
            this.contentManager.setIntegrationModel(this.integrationModel),
              this.modalDialog.open();
          }
          getCustomEditors() {
            return this.customEditors;
          }
        }
        (bb._globalListeners = new Kp()), (bb._initialized = !1);
        class wb {
          constructor(t) {
            if (
              ((this.language = "en"),
              (this.serviceProviderProperties = {}),
              "serviceProviderProperties" in t &&
                (this.serviceProviderProperties = t.serviceProviderProperties),
              (this.configurationService = ""),
              "configurationService" in t &&
                ((this.serviceProviderProperties.URI = t.configurationService),
                console.warn(
                  "Deprecated property configurationService. Use serviceParameters on instead.",
                  [t.configurationService]
                )),
              (this.version = "version" in t ? t.version : ""),
              (this.target = null),
              !("target" in t))
            )
              throw new Error(
                "IntegrationModel constructor error: target property missed."
              );
            (this.target = t.target),
              "scriptName" in t && (this.scriptName = t.scriptName),
              (this.callbackMethodArguments = {}),
              "callbackMethodArguments" in t &&
                (this.callbackMethodArguments = t.callbackMethodArguments),
              (this.environment = {}),
              "environment" in t && (this.environment = t.environment),
              (this.isIframe = !1),
              null != this.target &&
                (this.isIframe =
                  "IFRAME" === this.target.tagName.toUpperCase()),
              (this.editorObject = null),
              "editorObject" in t && (this.editorObject = t.editorObject),
              (this.rtl = !1),
              "rtl" in t && (this.rtl = t.rtl),
              (this.managesLanguage = !1),
              "managesLanguage" in t &&
                (this.managesLanguage = t.managesLanguage),
              (this.temporalImageResizing = !1),
              (this.core = null),
              (this.listeners = new Kp()),
              "integrationParameters" in t &&
                wb.integrationParameters.forEach((e) => {
                  if (e in t.integrationParameters) {
                    const i = t.integrationParameters[e];
                    0 !== Object.keys(i).length && (this[e] = i);
                  }
                });
          }
          init() {
            this.language = this.getLanguage();
            const t = Kp.newListener("onLoad", () => {
              this.callbackFunction(this.callbackMethodArguments);
            });
            if (
              -1 !== this.serviceProviderProperties.URI.indexOf("configuration")
            ) {
              const t = this.serviceProviderProperties.URI,
                e = Zp.getServerLanguageFromService(t);
              this.serviceProviderProperties.server = e;
              const i =
                  this.serviceProviderProperties.URI.indexOf("configuration"),
                n = this.serviceProviderProperties.URI.substring(0, i);
              this.serviceProviderProperties.URI = n;
            }
            let e = this.serviceProviderProperties.URI;
            (e =
              0 === e.indexOf("/") || 0 === e.indexOf("http")
                ? e
                : nb.concatenateUrl(this.getPath(), e)),
              (this.serviceProviderProperties.URI = e);
            const i = {};
            (i.serviceProviderProperties = this.serviceProviderProperties),
              this.setCore(new bb(i)),
              this.core.addListener(t),
              (this.core.language = this.language),
              this.core.init(),
              this.core.setEnvironment(this.environment);
          }
          getPath() {
            if (void 0 === this.scriptName)
              throw new Error("scriptName property needed for getPath.");
            const t = document.getElementsByTagName("script");
            let e = "";
            for (let i = 0; i < t.length; i += 1) {
              const n = t[i].src.lastIndexOf(this.scriptName);
              n >= 0 && (e = t[i].src.substr(0, n - 1));
            }
            return e;
          }
          getVersion() {
            return this.version;
          }
          setLanguage(t) {
            this.language = t;
          }
          setCore(t) {
            (this.core = t), t.setIntegrationModel(this);
          }
          getCore() {
            return this.core;
          }
          setTarget(t) {
            (this.target = t),
              (this.isIframe = "IFRAME" === this.target.tagName.toUpperCase());
          }
          setEditorObject(t) {
            this.editorObject = t;
          }
          openNewFormulaEditor() {
            (this.core.editionProperties.isNewElement = !0),
              this.core.openModalDialog(this.target, this.isIframe);
          }
          openExistingFormulaEditor() {
            (this.core.editionProperties.isNewElement = !1),
              this.core.openModalDialog(this.target, this.isIframe);
          }
          updateFormula(t) {
            let e, i;
            this.editorParameters &&
              (t = com.wiris.editor.util.EditorUtils.addAnnotation(
                t,
                "application/vnd.wiris.mtweb-params+json",
                JSON.stringify(this.editorParameters)
              ));
            this.isIframe
              ? ((e = this.target.contentWindow),
                (i = this.target.contentWindow))
              : ((e = this.target), (i = window));
            let n = this.core.beforeUpdateFormula(t, null);
            return n
              ? ((n = this.insertFormula(e, i, n.mathml, n.wirisProperties)),
                n
                  ? this.core.afterUpdateFormula(
                      n.focusElement,
                      n.windowTarget,
                      n.node,
                      n.latex
                    )
                  : "")
              : "";
          }
          insertFormula(t, e, i, n) {
            return this.core.insertFormula(t, e, i, n);
          }
          getSelection() {
            return this.isIframe
              ? (this.target.contentWindow.focus(),
                this.target.contentWindow.getSelection())
              : (this.target.focus(), window.getSelection());
          }
          addEvents() {
            const t = this.isIframe
              ? this.target.contentWindow.document
              : this.target;
            nb.addElementEvents(
              t,
              (t, e) => {
                this.doubleClickHandler(t, e);
              },
              (t, e) => {
                this.mousedownHandler(t, e);
              },
              (t, e) => {
                this.mouseupHandler(t, e);
              }
            );
          }
          doubleClickHandler(t) {
            if ("img" === t.nodeName.toLowerCase()) {
              this.core.getCustomEditors().disable();
              const e = Qp.get("imageCustomEditorName");
              if (t.hasAttribute(e)) {
                const i = t.getAttribute(e);
                this.core.getCustomEditors().enable(i);
              }
              nb.containsClass(t, Qp.get("imageClassName")) &&
                ((this.core.editionProperties.temporalImage = t),
                (this.core.editionProperties.isNewElement = !0),
                this.openExistingFormulaEditor());
            }
          }
          mouseupHandler() {
            this.temporalImageResizing &&
              setTimeout(() => {
                ob.fixAfterResize(this.temporalImageResizing);
              }, 10);
          }
          mousedownHandler(t) {
            "img" === t.nodeName.toLowerCase() &&
              nb.containsClass(t, Qp.get("imageClassName")) &&
              (this.temporalImageResizing = t);
          }
          getLanguage() {
            return this.getBrowserLanguage();
          }
          getBrowserLanguage() {
            let t = "en";
            return (
              (t = navigator.userLanguage
                ? navigator.userLanguage.substring(0, 2)
                : navigator.language
                ? navigator.language.substring(0, 2)
                : "en"),
              t
            );
          }
          callbackFunction() {
            const t = Kp.newListener("onTargetReady", () => {
              this.addEvents(this.target);
            });
            this.listeners.add(t);
          }
          notifyWindowClosed() {}
          getMathmlFromTextNode(t, e) {}
          fillNonLatexNode(t, e, i) {}
          getSelectedItem(t, e) {}
        }
        (wb.prototype.getMathmlFromTextNode = void 0),
          (wb.prototype.fillNonLatexNode = void 0),
          (wb.prototype.getSelectedItem = void 0),
          (wb.integrationParameters = [
            "serviceProviderProperties",
            "editorParameters",
          ]);
        class _b extends wb {
          constructor(t) {
            const e = t.editorObject;
            void 0 !== e.config &&
              void 0 !== e.config.get("mathTypeParameters") &&
              (t.integrationParameters = e.config.get("mathTypeParameters")),
              super(t),
              (this.integrationFolderName = "ckeditor_wiris");
          }
          getLanguage() {
            return this.editorObject.config.get("language");
          }
          addEditorListeners() {
            const t = this.editorObject;
            (void 0 !== t.config.wirislistenersdisabled &&
              t.config.wirislistenersdisabled) ||
              this.checkElement();
          }
          checkElement() {
            const t = this.editorObject.sourceElement;
            t.wirisActive ||
              (this.setTarget(t), this.addEvents(), (t.wirisActive = !0));
          }
          doubleClickHandler(t, e) {
            if (
              "img" == t.nodeName.toLowerCase() &&
              nb.containsClass(t, Qp.get("imageClassName"))
            ) {
              void 0 !== e.stopPropagation
                ? e.stopPropagation()
                : (e.returnValue = !1),
                this.core.getCustomEditors().disable();
              const i = t.getAttribute(Qp.get("imageCustomEditorName"));
              i && this.core.getCustomEditors().enable(i),
                (this.core.editionProperties.temporalImage = t),
                this.openExistingFormulaEditor();
            }
          }
          getCorePath() {
            return null;
          }
          callbackFunction() {
            super.callbackFunction(), this.addEditorListeners();
          }
          openNewFormulaEditor() {
            return (
              (this.core.editionProperties.selection =
                this.editorObject.editing.view.document.selection),
              super.openNewFormulaEditor()
            );
          }
          insertMathml(t) {
            return this.editorObject.model.change((e) => {
              const i = this.getCore(),
                n = e.createElement("mathml", { formula: t });
              if (i.editionProperties.isNewElement) {
                if (!t) return;
                let i =
                    this.core.editionProperties.selection ||
                    this.editorObject.editing.view.document.selection,
                  o = this.editorObject.editing.mapper.toModelPosition(
                    i.getLastPosition()
                  );
                if ((e.insert(n, o), !i.isCollapsed))
                  for (const t of i.getRanges())
                    e.remove(this.editorObject.editing.mapper.toModelRange(t));
              } else {
                const o = i.editionProperties.temporalImage,
                  r =
                    this.editorObject.editing.view.domConverter.domToView(
                      o
                    ).parent,
                  s = this.editorObject.editing.mapper.toModelElement(r),
                  a = this.editorObject.model.createPositionBefore(s);
                t && e.insert(n, a), e.remove(s);
              }
              return n;
            });
          }
          findText(t) {
            let e,
              i = t;
            for (; !e; )
              (e = this.editorObject.editing.mapper.toModelElement(
                this.editorObject.editing.view.domConverter.domToView(i)
              )),
                (i = i.parentElement);
            const n = this.editorObject.model.createRangeIn(e),
              o = Array.from(n.getItems());
            for (const e of o)
              if (
                e.is("textProxy") &&
                e.data == t.data.replace(String.fromCharCode(160), " ")
              )
                return e.textNode;
          }
          insertFormula(t, e, i, n) {
            let o = {};
            return (
              i
                ? "latex" == this.core.editMode
                  ? ((o.latex = tb.getLatexFromMathML(i)),
                    (o.node = e.document.createTextNode("$$" + o.latex + "$$")),
                    this.editorObject.model.change((t) => {
                      const e = this.core.editionProperties.latexRange,
                        i = this.findText(e.startContainer),
                        n = this.findText(e.endContainer),
                        r = t.createPositionAt(
                          i.parent,
                          i.startOffset + e.startOffset
                        ),
                        s = t.createPositionAt(
                          n.parent,
                          n.startOffset + e.endOffset
                        ),
                        a = t.createRange(r, s);
                      t.remove(a),
                        t.insertText(
                          "$$" + o.latex + "$$",
                          i.getAttributes(),
                          r
                        );
                    }))
                  : (o.node =
                      this.editorObject.editing.view.domConverter.viewToDom(
                        this.editorObject.editing.mapper.toViewElement(
                          this.insertMathml(i)
                        ),
                        e.document
                      ))
                : this.insertMathml(""),
              o
            );
          }
          notifyWindowClosed() {
            this.editorObject.editing.view.focus();
          }
        }
        class kb extends ed {
          constructor(t) {
            super(t);
          }
          execute(t = {}) {
            if (
              !(t.hasOwnProperty("integration") && t.integration instanceof _b)
            )
              throw 'Must pass a valid CKEditor5Integration instance as attribute "integration" of options';
            (this.integration = t.integration),
              this.setEditor(),
              this.openEditor();
          }
          setEditor() {
            this.integration.core.getCustomEditors().disable();
          }
          openEditor() {
            const t = this._getSelectedImage();
            null != t &&
            t.classList.contains(
              WirisPlugin.Configuration.get("imageClassName")
            )
              ? ((this.integration.core.editionProperties.temporalImage = t),
                this.integration.openExistingFormulaEditor())
              : this.integration.openNewFormulaEditor();
          }
          _getSelectedImage() {
            const t = this.editor.editing.view.document.selection;
            if (t.isCollapsed || 1 !== t.rangeCount) return;
            const e = t.getFirstRange();
            let i;
            for (const t of e) {
              if ("span" !== t.item.name) return;
              i = t.item.getChild(0);
              break;
            }
            return i
              ? this.editor.editing.view.domConverter.mapViewToDom(i)
              : void 0;
          }
        }
        class vb extends kb {
          setEditor() {
            this.integration.core.getCustomEditors().enable("chemistry");
          }
        }
        const yb = ["left", "right", "center", "justify"];
        function xb(t) {
          return yb.includes(t);
        }
        function Ab(t, e) {
          return "rtl" == e.contentLanguageDirection
            ? "right" === t
            : "left" === t;
        }
        class Cb extends ed {
          refresh() {
            const t = this.editor.locale,
              e = fh(this.editor.model.document.selection.getSelectedBlocks());
            (this.isEnabled = !!e && this._canBeAligned(e)),
              this.isEnabled && e.hasAttribute("alignment")
                ? (this.value = e.getAttribute("alignment"))
                : (this.value =
                    "rtl" === t.contentLanguageDirection ? "right" : "left");
          }
          execute(t = {}) {
            const e = this.editor,
              i = e.locale,
              n = e.model,
              o = n.document,
              r = t.value;
            n.change((t) => {
              const e = Array.from(o.selection.getSelectedBlocks()).filter(
                  (t) => this._canBeAligned(t)
                ),
                n = e[0].getAttribute("alignment");
              Ab(r, i) || n === r || !r
                ? (function (t, e) {
                    for (const i of t) e.removeAttribute("alignment", i);
                  })(e, t)
                : (function (t, e, i) {
                    for (const n of t) e.setAttribute("alignment", i, n);
                  })(e, t, r);
            });
          }
          _canBeAligned(t) {
            return this.editor.model.schema.checkAttribute(t, "alignment");
          }
        }
        class Tb extends Gc {
          static get pluginName() {
            return "AlignmentEditing";
          }
          constructor(t) {
            super(t), t.config.define("alignment", { options: [...yb] });
          }
          init() {
            const t = this.editor,
              e = t.locale,
              i = t.model.schema,
              n = t.config.get("alignment.options").filter(xb);
            i.extend("$block", { allowAttributes: "alignment" }),
              t.model.schema.setAttributeProperties("alignment", {
                isFormatting: !0,
              });
            const o = (function (t) {
              const e = {
                model: { key: "alignment", values: t.slice() },
                view: {},
              };
              for (const i of t)
                e.view[i] = { key: "style", value: { "text-align": i } };
              return e;
            })(n.filter((t) => !Ab(t, e)));
            t.conversion.attributeToAttribute(o),
              t.commands.add("alignment", new Cb(t));
          }
        }
        var Mb =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
          Eb =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
        const Pb = new Map([
          ["left", Mb],
          ["right", Eb],
          [
            "center",
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
          ],
          [
            "justify",
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
          ],
        ]);
        class Sb extends Gc {
          get localizedOptionTitles() {
            const t = this.editor.t;
            return {
              left: t("Align left"),
              right: t("Align right"),
              center: t("Align center"),
              justify: t("Justify"),
            };
          }
          static get pluginName() {
            return "AlignmentUI";
          }
          init() {
            const t = this.editor,
              e = t.ui.componentFactory,
              i = t.t,
              n = t.config.get("alignment.options");
            n.filter(xb).forEach((t) => this._addButton(t)),
              e.add("alignment", (t) => {
                const o = Vc(t),
                  r = n.map((t) => e.create("alignment:" + t));
                Fc(o, r),
                  o.buttonView.set({ label: i("Text alignment"), tooltip: !0 }),
                  (o.toolbarView.isVertical = !0),
                  (o.toolbarView.ariaLabel = i("Text alignment toolbar")),
                  o.extendTemplate({
                    attributes: { class: "ck-alignment-dropdown" },
                  });
                const s = "rtl" === t.contentLanguageDirection ? Eb : Mb;
                return (
                  o.buttonView.bind("icon").toMany(r, "isOn", (...t) => {
                    const e = t.findIndex((t) => t);
                    return e < 0 ? s : r[e].icon;
                  }),
                  o
                    .bind("isEnabled")
                    .toMany(r, "isEnabled", (...t) => t.some((t) => t)),
                  o
                );
              });
          }
          _addButton(t) {
            const e = this.editor;
            e.ui.componentFactory.add("alignment:" + t, (i) => {
              const n = e.commands.get("alignment"),
                o = new Oc(i);
              return (
                o.set({
                  label: this.localizedOptionTitles[t],
                  icon: Pb.get(t),
                  tooltip: !0,
                  isToggleable: !0,
                }),
                o.bind("isEnabled").to(n),
                o.bind("isOn").to(n, "value", (e) => e === t),
                this.listenTo(o, "execute", () => {
                  e.execute("alignment", { value: t }), e.editing.view.focus();
                }),
                o
              );
            });
          }
        }
        class Ib extends Jc {}
        (Ib.builtinPlugins = [
          class extends Gc {
            static get requires() {
              return [td, ad, pd, hd, Sd, Qd];
            }
            static get pluginName() {
              return "Essentials";
            }
          },
          nh,
          class extends Gc {
            static get pluginName() {
              return "Autoformat";
            }
            afterInit() {
              this._addListAutoformats(),
                this._addBasicStylesAutoformats(),
                this._addHeadingAutoformats(),
                this._addBlockQuoteAutoformats(),
                this._addCodeBlockAutoformats();
            }
            _addListAutoformats() {
              const t = this.editor.commands;
              t.get("bulletedList") &&
                new rh(this.editor, /^[*-]\s$/, "bulletedList"),
                t.get("numberedList") &&
                  new rh(this.editor, /^1[.|)]\s$/, "numberedList");
            }
            _addBasicStylesAutoformats() {
              const t = this.editor.commands;
              if (t.get("bold")) {
                const t = ch(this.editor, "bold");
                new ah(this.editor, /(\*\*)([^*]+)(\*\*)$/g, t),
                  new ah(this.editor, /(__)([^_]+)(__)$/g, t);
              }
              if (t.get("italic")) {
                const t = ch(this.editor, "italic");
                new ah(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, t),
                  new ah(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, t);
              }
              if (t.get("code")) {
                const t = ch(this.editor, "code");
                new ah(this.editor, /(`)([^`]+)(`)$/g, t);
              }
              if (t.get("strikethrough")) {
                const t = ch(this.editor, "strikethrough");
                new ah(this.editor, /(~~)([^~]+)(~~)$/g, t);
              }
            }
            _addHeadingAutoformats() {
              const t = this.editor.commands.get("heading");
              t &&
                t.modelElements
                  .filter((t) => t.match(/^heading[1-6]$/))
                  .forEach((e) => {
                    const i = e[7],
                      n = new RegExp(`^(#{${i}})\\s$`);
                    new rh(this.editor, n, () => {
                      if (!t.isEnabled) return !1;
                      this.editor.execute("heading", { value: e });
                    });
                  });
            }
            _addBlockQuoteAutoformats() {
              this.editor.commands.get("blockQuote") &&
                new rh(this.editor, /^>\s$/, "blockQuote");
            }
            _addCodeBlockAutoformats() {
              this.editor.commands.get("codeBlock") &&
                new rh(this.editor, /^```$/, "codeBlock");
            }
          },
          class extends Gc {
            static get requires() {
              return [hh, uh];
            }
            static get pluginName() {
              return "Bold";
            }
          },
          class extends Gc {
            static get requires() {
              return [mh, gh];
            }
            static get pluginName() {
              return "Italic";
            }
          },
          class extends Gc {
            static get requires() {
              return [kh, vh];
            }
            static get pluginName() {
              return "BlockQuote";
            }
          },
          class extends Gc {
            static get pluginName() {
              return "CKFinder";
            }
            static get requires() {
              return [Mu, yh, nh];
            }
          },
          class extends Gc {
            static get requires() {
              return [Ru, am, xm];
            }
            static get pluginName() {
              return "EasyImage";
            }
          },
          class extends Gc {
            static get requires() {
              return [Im, Nm];
            }
            static get pluginName() {
              return "Heading";
            }
          },
          am,
          class extends Gc {
            static get requires() {
              return [jm];
            }
            static get pluginName() {
              return "ImageCaption";
            }
          },
          class extends Gc {
            static get requires() {
              return [Xm, Km];
            }
            static get pluginName() {
              return "ImageStyle";
            }
          },
          class extends Gc {
            static get requires() {
              return [Zm];
            }
            static get pluginName() {
              return "ImageToolbar";
            }
            afterInit() {
              const t = this.editor,
                e = t.t;
              t.plugins
                .get(Zm)
                .register("image", {
                  ariaLabel: e("Image toolbar"),
                  items: t.config.get("image.toolbar") || [],
                  getRelatedElement: Rh,
                });
            }
          },
          xm,
          class extends Gc {
            static get pluginName() {
              return "Indent";
            }
            static get requires() {
              return [ng, sg];
            }
          },
          class extends Gc {
            static get requires() {
              return [xu, dg];
            }
            static get pluginName() {
              return "Link";
            }
          },
          class extends Gc {
            static get requires() {
              return [jg, zg];
            }
            static get pluginName() {
              return "List";
            }
          },
          class extends Gc {
            static get requires() {
              return [$g, Xg, Gg, Du];
            }
            static get pluginName() {
              return "MediaEmbed";
            }
          },
          Tm,
          class extends Gc {
            static get pluginName() {
              return "PasteFromOffice";
            }
            static get requires() {
              return [td];
            }
            init() {
              const t = this.editor,
                e = [];
              e.push(new cf()),
                e.push(new nf(t.editing.view.document)),
                t.plugins.get("Clipboard").on(
                  "inputTransformation",
                  (t, i) => {
                    if (i.isTransformedWithPasteFromOffice) return;
                    const n = i.dataTransfer.getData("text/html"),
                      o = e.find((t) => t.isActive(n));
                    o &&
                      (o.execute(i), (i.isTransformedWithPasteFromOffice = !0));
                  },
                  { priority: "high" }
                );
            }
          },
          class extends Gc {
            static get requires() {
              return [Ap, Ep, Op, Rp, Lp, Du];
            }
            static get pluginName() {
              return "Table";
            }
          },
          class extends Gc {
            static get requires() {
              return [Zm];
            }
            static get pluginName() {
              return "TableToolbar";
            }
            afterInit() {
              const t = this.editor,
                e = t.t,
                i = t.plugins.get(Zm),
                n = t.config.get("table.contentToolbar"),
                o = t.config.get("table.tableToolbar");
              n &&
                i.register("tableContent", {
                  ariaLabel: e("Table toolbar"),
                  items: n,
                  getRelatedElement: kf,
                }),
                o &&
                  i.register("table", {
                    ariaLabel: e("Table toolbar"),
                    items: o,
                    getRelatedElement: _f,
                  });
            }
          },
          class extends Gc {
            static get pluginName() {
              return "TextTransformation";
            }
            constructor(t) {
              super(t),
                t.config.define("typing", { transformations: { include: Hp } });
            }
            init() {
              const t = this.editor.model.document.selection;
              t.on("change:range", () => {
                this.isEnabled = !t.anchor.parent.is("codeBlock");
              }),
                this._enableTransformationWatchers();
            }
            _enableTransformationWatchers() {
              const t = this.editor,
                e = t.model,
                i = t.plugins.get("Input"),
                n = (function (t) {
                  const e = t.extra || [],
                    i = t.remove || [],
                    n = (t) => !i.includes(t);
                  return (function (t) {
                    const e = new Set();
                    for (const i of t)
                      if (Fp[i]) for (const t of Fp[i]) e.add(t);
                      else e.add(i);
                    return Array.from(e);
                  })(t.include.concat(e).filter(n))
                    .filter(n)
                    .map((t) => Vp[t] || t)
                    .map((t) => ({ from: Up(t.from), to: Wp(t.to) }));
                })(t.config.get("typing.transformations")),
                o = new jp(t.model, (t) => {
                  for (const e of n) {
                    if (e.from.test(t)) return { normalizedTransformation: e };
                  }
                });
              o.on("matched:data", (t, n) => {
                if (!i.isInput(n.batch)) return;
                const { from: o, to: r } = n.normalizedTransformation,
                  s = o.exec(n.text),
                  a = r(s.slice(1)),
                  l = n.range;
                let c = s.index;
                e.enqueueChange((t) => {
                  for (let i = 1; i < s.length; i++) {
                    const n = s[i],
                      o = a[i - 1];
                    if (null == o) {
                      c += n.length;
                      continue;
                    }
                    const r = l.start.getShiftedBy(c),
                      d = e.createRange(r, r.getShiftedBy(n.length)),
                      h = qp(r);
                    e.insertContent(t.createText(o, h), d), (c += o.length);
                  }
                });
              }),
                o.bind("isEnabled").to(this);
            }
          },
          class extends Gc {
            static get requires() {
              return [Du];
            }
            static get pluginName() {
              return "MathType";
            }
            init() {
              const t = this._addIntegration();
              this._addCommands(),
                this._addViews(t),
                this._addSchema(),
                this._addConverters(),
                this._exposeWiris();
            }
            _addIntegration() {
              const t = this.editor,
                e = {};
              let i;
              return (
                (e.environment = {}),
                (e.environment.editor = "CKEditor5"),
                (e.editorObject = t),
                (e.serviceProviderProperties = {}),
                (e.serviceProviderProperties.URI =
                  "https://www.wiris.net/demo/plugins/app"),
                (e.serviceProviderProperties.server = "java"),
                (e.target = t.sourceElement),
                (e.scriptName = "bundle.js"),
                (e.managesLanguage = !0),
                e.target &&
                  ((i = new _b(e)),
                  i.init(),
                  i.listeners.fire("onTargetReady", {}),
                  i.checkElement(),
                  this.listenTo(
                    t.editing.view.document,
                    "click",
                    (t, e) => {
                      2 == e.domEvent.detail &&
                        (i.doubleClickHandler(e.domTarget, e.domEvent),
                        t.stop());
                    },
                    { priority: "highest" }
                  )),
                i
              );
            }
            _addCommands() {
              const t = this.editor;
              t.commands.add("MathType", new kb(t)),
                t.commands.add("ChemType", new vb(t));
            }
            _addViews(t) {
              const e = this.editor;
              e.ui.componentFactory.add("MathType", (i) => {
                const n = new Oc(i);
                return (
                  n
                    .bind("isEnabled")
                    .to(e.commands.get("MathType"), "isEnabled"),
                  n.set({
                    label: "Insert a math equation - MathType",
                    icon: '<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 300 261.7" style="enable-background:new 0 0 300 261.7;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#EF4A5F;}\n\t.st2{fill:#C8202F;}\n</style>\n<path class="st0" d="M300,32.8c0-16.4-13.4-29.7-29.9-29.7c-2.9,0-7.2,0.8-7.2,0.8c-37.9,9.1-71.3,14-112,14c-0.3,0-0.6,0-1,0\n\tc-16.5,0-29.9,13.3-29.9,29.7c0,16.4,13.4,29.7,29.9,29.7l0,0c45.3,0,83.1-5.3,125.3-15.3h0C289.3,59.5,300,47.4,300,32.8"/>\n<path class="st0" d="M90.2,257.7c-11.4,0-21.9-6.4-27-16.7l-60-119.9c-7.5-14.9-1.4-33.1,13.5-40.5c14.9-7.5,33.1-1.4,40.5,13.5\n\tl27.3,54.7L121.1,39c5.3-15.8,22.4-24.4,38.2-19.1c15.8,5.3,24.4,22.4,19.1,38.2l-59.6,179c-3.9,11.6-14.3,19.7-26.5,20.6\n\tC91.6,257.7,90.9,257.7,90.2,257.7"/>\n<g>\n\t<g>\n\t\t<path class="st1" d="M90.2,257.7c-11.4,0-21.9-6.4-27-16.7l-60-119.9c-7.5-14.9-1.4-33.1,13.5-40.5c14.9-7.5,33.1-1.4,40.5,13.5\n\t\t\tl27.3,54.7L121.1,39c5.3-15.8,22.4-24.4,38.2-19.1c15.8,5.3,24.4,22.4,19.1,38.2l-59.6,179c-3.9,11.6-14.3,19.7-26.5,20.6\n\t\t\tC91.6,257.7,90.9,257.7,90.2,257.7"/>\n\t</g>\n</g>\n<g>\n\t<g>\n\t\t<path class="st2" d="M300,32.8c0-16.4-13.4-29.7-29.9-29.7c-2.9,0-7.2,0.8-7.2,0.8c-37.9,9.1-71.3,14-112,14c-0.3,0-0.6,0-1,0\n\t\t\tc-16.5,0-29.9,13.3-29.9,29.7c0,16.4,13.4,29.7,29.9,29.7l0,0c45.3,0,83.1-5.3,125.3-15.3h0C289.3,59.5,300,47.4,300,32.8"/>\n\t</g>\n</g>\n</svg>\n',
                    tooltip: !0,
                  }),
                  n.on("execute", () => {
                    e.execute("MathType", { integration: t });
                  }),
                  n
                );
              }),
                e.ui.componentFactory.add("ChemType", (i) => {
                  const n = new Oc(i);
                  return (
                    n
                      .bind("isEnabled")
                      .to(e.commands.get("ChemType"), "isEnabled"),
                    n.set({
                      label: "Insert a chemistry formula - ChemType",
                      icon: '<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 40.3 49.5" style="enable-background:new 0 0 40.3 49.5;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#A4CF61;}\n</style>\n<path class="st0" d="M39.2,12.1c0-1.9-1.1-3.6-2.7-4.4L24.5,0.9l0,0c-0.7-0.4-1.5-0.6-2.4-0.6c-0.9,0-1.7,0.2-2.4,0.6l0,0L2.3,10.8\n\tl0,0C0.9,11.7,0,13.2,0,14.9h0v19.6h0c0,1.7,0.9,3.3,2.3,4.1l0,0l17.4,9.9l0,0c0.7,0.4,1.5,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6l0,0\n\tl12.2-6.9h0c1.5-0.8,2.6-2.5,2.6-4.3c0-2.7-2.2-4.9-4.9-4.9c-0.9,0-1.8,0.3-2.5,0.7l0,0l-9.7,5.6l-12.3-7V17.8l12.3-7l9.9,5.7l0,0\n\tc0.7,0.4,1.5,0.6,2.4,0.6C37,17,39.2,14.8,39.2,12.1"/>\n</svg>\n',
                      tooltip: !0,
                    }),
                    n.on("execute", () => {
                      e.execute("ChemType", { integration: t });
                    }),
                    n
                  );
                }),
                e.editing.view.addObserver(ag);
            }
            _addSchema() {
              this.editor.model.schema.register("mathml", {
                allowWhere: "$text",
                isObject: !0,
                isInline: !0,
                allowAttributes: ["formula"],
              });
            }
            _addConverters() {
              const t = this.editor;
              t.conversion.for("upcast").elementToElement({
                view: { name: "span", classes: "ck-math-widget" },
                model: (t, e) => {
                  const i = Gp.safeXmlDecode(
                    t.getChild(0).getAttribute("data-mathml")
                  );
                  return e.createElement("mathml", { formula: i });
                },
              }),
                t.data.upcastDispatcher.on("element:math", (e, i, n) => {
                  const { consumable: o, writer: r } = n,
                    s = i.viewItem;
                  if (!o.test(s, { name: !0 })) return;
                  let a = (function (t) {
                    const e = t.getChild(0);
                    if (!e || "semantics" !== e.name) return !1;
                    for (const t of e.getChildren())
                      if (
                        "annotation" === t.name &&
                        "LaTeX" === t.getAttribute("encoding")
                      )
                        return !0;
                    return !1;
                  })(s);
                  const l = new $p(t.editing.view.document),
                    c = new wm(t.editing.view.document).createDocumentFragment(
                      s.getChildren()
                    ),
                    d = [...s.getAttributes()]
                      .map(([t, e]) => ` ${t}="${e}"`)
                      .join("");
                  let h = l.toData(c) || "";
                  h = `<math${d}>${h}</math>`;
                  const u = a
                      ? r.createText(sb.initParse(h, t.config.get("language")))
                      : r.createElement("mathml", { formula: h }),
                    m = n.splitToAllowedParent(u, i.modelCursor);
                  if (!m) return;
                  n.writer.insert(u, m.position), o.consume(s, { name: !0 });
                  const g = n.getSplitParts(u);
                  (i.modelRange = r.createRange(
                    n.writer.createPositionBefore(u),
                    n.writer.createPositionAfter(g[g.length - 1])
                  )),
                    m.cursorParent
                      ? (i.modelCursor = n.writer.createPositionAt(
                          m.cursorParent,
                          0
                        ))
                      : (i.modelCursor = i.modelRange.end);
                }),
                t.conversion.for("editingDowncast").elementToElement({
                  model: "mathml",
                  view: function (e, i) {
                    const n = i.createContainerElement("span", {
                        class: "ck-math-widget",
                      }),
                      o = (function (e, i) {
                        const n = new Sl(i.document),
                          o = e.getAttribute("formula"),
                          r = sb.initParse(o, t.config.get("language")),
                          s = n.toView(r).getChild(0);
                        return i.createEmptyElement("img", s.getAttributes());
                      })(e, i);
                    return i.insert(i.createPositionAt(n, 0), o), Ph(n, i);
                  },
                }),
                t.conversion.for("dataDowncast").elementToElement({
                  model: "mathml",
                  view: function (t, e) {
                    const i = new Sl(e.document);
                    let n = sb.endParseSaveMode(t.getAttribute("formula"));
                    Qp.get("saveHandTraces") ||
                      (n = Gp.removeAnnotation(n, "application/json"));
                    const o = i.toView(n).getChild(0);
                    return (function t(e, i) {
                      if (i.is("text")) return e.createText(i.data);
                      if (i.is("element")) {
                        if (i.is("emptyElement"))
                          return e.createEmptyElement(
                            i.name,
                            i.getAttributes()
                          );
                        {
                          const n = e.createContainerElement(
                            i.name,
                            i.getAttributes()
                          );
                          for (const o of i.getChildren())
                            e.insert(e.createPositionAt(n, "end"), t(e, o));
                          return n;
                        }
                      }
                      throw new Exception("Given node has unsupported type.");
                    })(e, o);
                  },
                });
            }
            _exposeWiris() {
              window.WirisPlugin = {
                Core: bb,
                Parser: sb,
                Image: ob,
                MathML: Gp,
                Util: nb,
                Configuration: Qp,
                Listeners: Kp,
                IntegrationModel: wb,
                Latex: tb,
              };
            }
          },
          class extends Gc {
            static get requires() {
              return [Tb, Sb];
            }
            static get pluginName() {
              return "Alignment";
            }
          },
        ]),
          (Ib.defaultConfig = {
            toolbar: {
              items: [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "|",
                "indent",
                "outdent",
                "|",
                "imageUpload",
                "blockQuote",
                "insertTable",
                "mediaEmbed",
                "undo",
                "redo",
              ],
            },
            image: {
              toolbar: [
                "imageStyle:full",
                "imageStyle:side",
                "|",
                "imageTextAlternative",
              ],
            },
            table: {
              contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
            },
            language: "en",
          });
      },
    ]).default;
  });
//# sourceMappingURL=ckeditor.js.map
